require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/components/button-location-select-hbs", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<label id=\"location-select-label\" for=\"core-wizard-location-select\" class=\"col\">\n	<span class=\"label\">Nearby</span>\n	<button id=\"core-wizard-location-select\" type=\"button\"><span class=\"visuallyhidden\">Detect my location</span></button>\n</label>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/components/input-calendar-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return ((stack1 = ((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"number","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-";
},"3":function(depth0,helpers,partials,data) {
    return "invalid";
},"5":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0['companion-attr'] : depth0),{"name":"if","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"6":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function";

  return "          "
    + this.escapeExpression(((helper = (helper = helpers['companion-attr'] || (depth0 != null ? depth0['companion-attr'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"companion-attr","hash":{},"data":data}) : helper)))
    + "=\"&#35;"
    + ((stack1 = ((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-"
    + ((stack1 = ((helper = (helper = helpers.companion || (depth0 != null ? depth0.companion : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"companion","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-wrapper\"\n";
},"8":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda;

  return "        "
    + ((stack1 = alias1((depth0 != null ? depth0.name : depth0), depth0)) != null ? stack1 : "")
    + "=\""
    + ((stack1 = alias1((depth0 != null ? depth0.value : depth0), depth0)) != null ? stack1 : "")
    + "\"\n";
},"10":function(depth0,helpers,partials,data) {
    var helper;

  return "      data-blackout-dates='"
    + this.escapeExpression(((helper = (helper = helpers.black_out_json || (depth0 != null ? depth0.black_out_json : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"black_out_json","hash":{},"data":data}) : helper)))
    + "'\n";
},"12":function(depth0,helpers,partials,data) {
    return "show";
},"14":function(depth0,helpers,partials,data) {
    return "disabled";
},"16":function(depth0,helpers,partials,data) {
    return "error";
},"18":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return ((stack1 = ((helper = (helper = helpers['label-text'] || (depth0 != null ? depth0['label-text'] : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"label-text","hash":{},"data":data}) : helper))) != null ? stack1 : "");
},"20":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return ((stack1 = ((helper = (helper = helpers.dateFormat || (depth0 != null ? depth0.dateFormat : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"dateFormat","hash":{},"data":data}) : helper))) != null ? stack1 : "");
},"22":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "data-number=\""
    + ((stack1 = ((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"number","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"";
},"24":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "aria-describedby=\""
    + ((stack1 = ((helper = (helper = helpers['aria-describedby'] || (depth0 != null ? depth0['aria-describedby'] : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"aria-describedby","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"";
},"26":function(depth0,helpers,partials,data) {
    return "aria-invalid=\"true\"";
},"28":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda;

  return "            "
    + ((stack1 = alias1((depth0 != null ? depth0.name : depth0), depth0)) != null ? stack1 : "")
    + "=\""
    + ((stack1 = alias1((depth0 != null ? depth0.value : depth0), depth0)) != null ? stack1 : "")
    + "\"\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function";

  return "<div id=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.number : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-wrapper\"\n    data-control=\"datepicker\"\n    data-close=\"true\"\n    class=\"col text datepicker theme-standard pin-left "
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + " "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasError : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\"\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.isMultiDest : depth0),{"name":"unless","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.ia : depth0),{"name":"each","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    data-auto-pos=\"true\"\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.is_blackout : depth0),{"name":"if","hash":{},"fn":this.program(10, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    >\n  <label class=\"datepicker-label datepicker-arrow text icon-before\" for=\""
    + ((stack1 = ((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.number : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\">\n    <span class=\"label "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0['label-show'] : depth0),{"name":"if","hash":{},"fn":this.program(12, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\">"
    + ((stack1 = ((helper = (helper = helpers['label-text'] || (depth0 != null ? depth0['label-text'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"label-text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "<span class=\"datepicker-expand-collapse visuallyhidden\"> expanded. Enter a date or choose one from the table below.</span></span>\n    <input\n        "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isDisabled : depth0),{"name":"if","hash":{},"fn":this.program(14, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n        id=\""
    + ((stack1 = ((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.number : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"\n        data-wizard-action='"
    + ((stack1 = ((helper = (helper = helpers.wizard_action || (depth0 != null ? depth0.wizard_action : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"wizard_action","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "'\n        class=\""
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasError : depth0),{"name":"if","hash":{},"fn":this.program(16, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " "
    + ((stack1 = ((helper = (helper = helpers['class'] || (depth0 != null ? depth0['class'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"class","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + " datepicker-trigger-input\"\n        type=\"text\"\n        placeholder=\""
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.ab11873_1 : depth0),{"name":"if","hash":{},"fn":this.program(18, data, 0),"inverse":this.program(20, data, 0),"data":data})) != null ? stack1 : "")
    + "\"\n        data-cal-version=\"touch-keyboard\"\n        "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.number : depth0),{"name":"if","hash":{},"fn":this.program(22, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n        "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0['aria-describedby'] : depth0),{"name":"if","hash":{},"fn":this.program(24, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n        "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasError : depth0),{"name":"if","hash":{},"fn":this.program(26, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.inputAttributes : depth0),{"name":"each","hash":{},"fn":this.program(28, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    />\n    <span class=\"icon icon-calendar\" aria-hidden=\"true\"></span>\n  </label>\n  <div class=\"datepicker-dropdown\" aria-hidden=\"true\"></div>\n</div>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/components/input-checkbox-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return " disabled";
},"3":function(depth0,helpers,partials,data) {
    return " checked";
},"5":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda;

  return "            "
    + this.escapeExpression(alias1((depth0 != null ? depth0.name : depth0), depth0))
    + "=\""
    + ((stack1 = alias1((depth0 != null ? depth0.value : depth0), depth0)) != null ? stack1 : "")
    + "\"\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function";

  return "\n    <label class=\"check"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.disabled : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\""
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-label\">\n        <input \n          type=\"checkbox\" \n          id=\""
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\" \n          data-wizard-action='"
    + ((stack1 = ((helper = (helper = helpers.wizard_action || (depth0 != null ? depth0.wizard_action : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"wizard_action","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "'\n          "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isChecked : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " \n          "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.disabled : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.ia : depth0),{"name":"each","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "          />\n        <span class=\"inline-label\">"
    + ((stack1 = ((helper = (helper = helpers['label-text'] || (depth0 != null ? depth0['label-text'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"label-text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n    </label>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/components/input-radio-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "disabled";
},"3":function(depth0,helpers,partials,data) {
    return "checked";
},"5":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda;

  return "            "
    + this.escapeExpression(alias1((depth0 != null ? depth0.name : depth0), depth0))
    + "=\""
    + ((stack1 = alias1((depth0 != null ? depth0.value : depth0), depth0)) != null ? stack1 : "")
    + "\"\n";
},"7":function(depth0,helpers,partials,data) {
    return "class=\"checked\"";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function";

  return "\n    <label name=\""
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\" id=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-"
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-label\" class=\"check "
    + ((stack1 = ((helper = (helper = helpers['class'] || (depth0 != null ? depth0['class'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"class","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\" for=\""
    + ((stack1 = ((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-"
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\">\n        <input \n          type=\"radio\" \n          id=\""
    + ((stack1 = ((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-"
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"\n          data-wizard-action='"
    + ((stack1 = ((helper = (helper = helpers.wizard_action || (depth0 != null ? depth0.wizard_action : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"wizard_action","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "'\n          "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isDisabled : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n          "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isChecked : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.ia : depth0),{"name":"each","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "          "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isChecked : depth0),{"name":"if","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n          />\n        <span class=\"inline-label\">"
    + ((stack1 = ((helper = (helper = helpers['label-text'] || (depth0 != null ? depth0['label-text'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"label-text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n    </label>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/components/input-ta-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "invalid";
},"3":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return ((stack1 = ((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"number","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-";
},"5":function(depth0,helpers,partials,data) {
    return "show";
},"7":function(depth0,helpers,partials,data) {
    var stack1;

  return "aria-invalid=\"true\" class=\"error"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isMultiDest : depth0),{"name":"if","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\"";
},"8":function(depth0,helpers,partials,data) {
    return " multi-dest-error";
},"10":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function";

  return ((stack1 = (helpers.if_experiment || (depth0 && depth0.if_experiment) || alias1).call(depth0,"uTA_HOTELS",{"name":"if_experiment","hash":{},"fn":this.program(11, data, 0),"inverse":this.program(13, data, 0),"data":data})) != null ? stack1 : "")
    + "\n          aria-autocomplete=\"list\"\n          autocomplete=\"off\"\n          spellcheck=\"false\"\n          data-ta-key="
    + ((stack1 = ((helper = (helper = helpers.ta_key || (depth0 != null ? depth0.ta_key : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"ta_key","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\n          data-tooltip-id=\"typeahead-list\"\n          aria-owns=\"typeahead-list\"\n          aria-labelledby=\"flight-"
    + ((stack1 = ((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"number","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"\n";
},"11":function(depth0,helpers,partials,data) {
    var helper;

  return "                data-locale=\""
    + this.escapeExpression(((helper = (helper = helpers.locale || (depth0 != null ? depth0.locale : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"locale","hash":{},"data":data}) : helper)))
    + "\"\n                data-js-theme=\"autocomplete\"\n                data-provide=\"utypeahead\"\n                data-template=\"hbs/templates/destinationCustom\"\n                data-mask=\"1759\"\n                data-minchar=\"1\"\n";
},"13":function(depth0,helpers,partials,data) {
    return "                data-js-theme=\"typeahead\"\n                data-provide=\"typeahead\"\n";
},"15":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda;

  return "          "
    + ((stack1 = alias1((depth0 != null ? depth0.name : depth0), depth0)) != null ? stack1 : "")
    + "=\""
    + ((stack1 = alias1((depth0 != null ? depth0.value : depth0), depth0)) != null ? stack1 : "")
    + "\"\n";
},"17":function(depth0,helpers,partials,data) {
    return "        <span class=\"icon icon-search\" aria-hidden=\"true\"></span>\n";
},"19":function(depth0,helpers,partials,data) {
    return "        <span class=\"icon icon-location\" aria-hidden=\"true\"></span>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function";

  return "<div class=\"container-ta-"
    + ((stack1 = ((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + " theme-standard autocomplete pin-left col\" data-control=\"autocomplete\" data-auto-pos=\"true\">\n    <label class=\"text icon-before "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasError : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " autocomplete-arrow\" id=\""
    + ((stack1 = ((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.number : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-label\" >\n      <span class=\"visuallyhidden\" aria-hidden=\"true\" id=\"anchor-"
    + ((stack1 = ((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.number : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"></span>\n      <span class=\"label "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0['label-show'] : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\">"
    + ((stack1 = ((helper = (helper = helpers['label-text'] || (depth0 != null ? depth0['label-text'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"label-text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n      <input\n        type=\"text\"\n        class=\"autocomplete-trigger-input\"\n        id=\""
    + ((stack1 = ((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.number : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"\n        "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasError : depth0),{"name":"if","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.TAoff : depth0),{"name":"unless","hash":{},"fn":this.program(10, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "        data-wizard-action='"
    + ((stack1 = ((helper = (helper = helpers.wizard_action || (depth0 != null ? depth0.wizard_action : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"wizard_action","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "'\n        data-autoselect=\"touch\"\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.ia : depth0),{"name":"each","hash":{},"fn":this.program(15, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "      />\n\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.openSearch : depth0),{"name":"if","hash":{},"fn":this.program(17, data, 0),"inverse":this.program(19, data, 0),"data":data})) != null ? stack1 : "")
    + "    </label>\n    <span class=\"icon icon-close visuallyhidden clear-search\" aria-hidden=\"true\"></span>\n    <div class=\"autocomplete-dropdown\" id=\"typeahead-"
    + ((stack1 = ((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"></div>\n</div>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/components/select-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return " invalid";
},"3":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "<span class=\"label\">"
    + ((stack1 = ((helper = (helper = helpers['label-text'] || (depth0 != null ? depth0['label-text'] : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"label-text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>";
},"5":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "class=\""
    + ((stack1 = ((helper = (helper = helpers['class'] || (depth0 != null ? depth0['class'] : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"class","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasError : depth0),{"name":"if","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\"";
},"6":function(depth0,helpers,partials,data) {
    return " error";
},"8":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda;

  return "      "
    + ((stack1 = alias1((depth0 != null ? depth0.name : depth0), depth0)) != null ? stack1 : "")
    + "=\""
    + ((stack1 = alias1((depth0 != null ? depth0.value : depth0), depth0)) != null ? stack1 : "")
    + "\"\n";
},"10":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.options : depth0),{"name":"if","hash":{},"fn":this.program(11, data, 0),"inverse":this.program(15, data, 0),"data":data})) != null ? stack1 : "");
},"11":function(depth0,helpers,partials,data) {
    var stack1;

  return "      <optgroup label=\""
    + ((stack1 = this.lambda((depth0 != null ? depth0.name : depth0), depth0)) != null ? stack1 : "")
    + "\">\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.options : depth0),{"name":"each","hash":{},"fn":this.program(12, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "      </optgroup>\n";
},"12":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda;

  return "          <option value=\""
    + ((stack1 = alias1((depth0 != null ? depth0.value : depth0), depth0)) != null ? stack1 : "")
    + "\""
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.selected : depth0),{"name":"if","hash":{},"fn":this.program(13, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ">\n              "
    + ((stack1 = alias1((depth0 != null ? depth0.name : depth0), depth0)) != null ? stack1 : "")
    + "\n          </option>\n";
},"13":function(depth0,helpers,partials,data) {
    return " selected=\"selected\"";
},"15":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda;

  return "      <option\n        "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.selected : depth0),{"name":"if","hash":{},"fn":this.program(16, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n        value=\""
    + ((stack1 = alias1((depth0 != null ? depth0.value : depth0), depth0)) != null ? stack1 : "")
    + "\">\n          "
    + ((stack1 = alias1((depth0 != null ? depth0.name : depth0), depth0)) != null ? stack1 : "")
    + "\n      </option>\n";
},"16":function(depth0,helpers,partials,data) {
    return "selected=\"selected\"";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function";

  return "<label\n  id=\""
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-label\"\n  class=\"select icon col icon-toggle180"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasError : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " "
    + ((stack1 = ((helper = (helper = helpers['label-class'] || (depth0 != null ? depth0['label-class'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"label-class","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\">\n  "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0['label-text'] : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n  <select\n    id=\""
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"\n    data-wizard-action='"
    + ((stack1 = ((helper = (helper = helpers.wizard_action || (depth0 != null ? depth0.wizard_action : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"wizard_action","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "'\n    "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0['class'] : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.ia : depth0),{"name":"each","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "  >\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.options : depth0),{"name":"each","hash":{},"fn":this.program(10, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "  </select>\n</label>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/components/icon-lobIcon", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "  <div class=\"multiPkgIcon\">\n";
},"3":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(data && data.first),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.program(6, data, 0),"data":data})) != null ? stack1 : "");
},"4":function(depth0,helpers,partials,data) {
    return "    <span class=\"icon icon-"
    + this.escapeExpression(this.lambda(depth0, depth0))
    + "\" aria-hidden=\"true\"></span>\n";
},"6":function(depth0,helpers,partials,data) {
    return "    &nbsp;\n    <span class=\"icon icon-"
    + this.escapeExpression(this.lambda(depth0, depth0))
    + "\" aria-hidden=\"true\"></span>\n";
},"8":function(depth0,helpers,partials,data) {
    return "  </div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.icon : depth0)) != null ? stack1['1'] : stack1),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.icon : depth0),{"name":"each","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.icon : depth0)) != null ? stack1['1'] : stack1),{"name":"if","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/components/soft-package-checkbox-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return " checked";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "\n<label class=\"col link\">\n  <input type=\"checkbox\"\n  	id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-add-"
    + alias3(((helper = (helper = helpers.lob || (depth0 != null ? depth0.lob : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"lob","hash":{},"data":data}) : helper)))
    + "-checkbox\"\n  	data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\"\n  	data-wizard-action=\""
    + alias3(((helper = (helper = helpers.action || (depth0 != null ? depth0.action : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"action","hash":{},"data":data}) : helper)))
    + "\"\n    data-package-wrapper=\""
    + alias3(((helper = (helper = helpers.lob || (depth0 != null ? depth0.lob : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"lob","hash":{},"data":data}) : helper)))
    + "-package-wrapper\"\n    data-tracking=\"softPackageCheckbox\"\n  	"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.checked : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ">\n  <span class=\"inline-label\"><span class=\"icon icon-"
    + alias3(((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"icon","hash":{},"data":data}) : helper)))
    + "\" aria-hidden=\"true\"></span>"
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n</label>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/includes/next-trip-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda, alias2=this.escapeExpression;

  return "	<section class=\"itin-next-trip\" id=\"next-trip\">\n		<h4 class=\"trip-title\">\n"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.isFlight : stack1),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.program(4, data, 0),"data":data})) != null ? stack1 : "")
    + "		</h4>\n\n		<span class=\"trip-name-icon\">\n			<span class=\"icon icon-"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.lob : stack1), depth0))
    + "\"></span>\n			"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.name : stack1), depth0))
    + "\n		</span>\n\n		<span class=\"trip-date\">\n"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.isHotel : stack1),{"name":"if","hash":{},"fn":this.program(18, data, 0),"inverse":this.program(20, data, 0),"data":data})) != null ? stack1 : "")
    + "		</span>\n\n		<a class=\"trip-link\" href="
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.link : stack1), depth0))
    + ">"
    + ((stack1 = alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.seeMyTripLinkText : stack1), depth0)) != null ? stack1 : "")
    + "</a>\n	</section>\n";
},"2":function(depth0,helpers,partials,data) {
    var stack1;

  return "				"
    + this.escapeExpression(this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.yourUpcomingFlight : stack1), depth0))
    + "\n";
},"4":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.isHotel : stack1),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.program(7, data, 0),"data":data})) != null ? stack1 : "");
},"5":function(depth0,helpers,partials,data) {
    var stack1;

  return "					"
    + this.escapeExpression(this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.yourUpcomingHotel : stack1), depth0))
    + "\n";
},"7":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.isCar : stack1),{"name":"if","hash":{},"fn":this.program(8, data, 0),"inverse":this.program(10, data, 0),"data":data})) != null ? stack1 : "");
},"8":function(depth0,helpers,partials,data) {
    var stack1;

  return "						"
    + this.escapeExpression(this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.yourUpcomingCar : stack1), depth0))
    + "\n";
},"10":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.isCruise : stack1),{"name":"if","hash":{},"fn":this.program(11, data, 0),"inverse":this.program(13, data, 0),"data":data})) != null ? stack1 : "");
},"11":function(depth0,helpers,partials,data) {
    var stack1;

  return "							"
    + this.escapeExpression(this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.yourUpcomingCruise : stack1), depth0))
    + "\n";
},"13":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.isActivity : stack1),{"name":"if","hash":{},"fn":this.program(14, data, 0),"inverse":this.program(16, data, 0),"data":data})) != null ? stack1 : "");
},"14":function(depth0,helpers,partials,data) {
    var stack1;

  return "								"
    + this.escapeExpression(this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.yourUpcomingActivity : stack1), depth0))
    + "\n";
},"16":function(depth0,helpers,partials,data) {
    var stack1;

  return "								"
    + this.escapeExpression(this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.yourUpcomingTrip : stack1), depth0))
    + "\n";
},"18":function(depth0,helpers,partials,data) {
    var stack1;

  return "			"
    + ((stack1 = this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.checkInTextOnUpcomingTrip : stack1), depth0)) != null ? stack1 : "")
    + "\n";
},"20":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.isCar : stack1),{"name":"if","hash":{},"fn":this.program(21, data, 0),"inverse":this.program(23, data, 0),"data":data})) != null ? stack1 : "");
},"21":function(depth0,helpers,partials,data) {
    var stack1;

  return "				"
    + ((stack1 = this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.pickUpTextOnUpcomingTrip : stack1), depth0)) != null ? stack1 : "")
    + "\n";
},"23":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.isActivity : stack1),{"name":"if","hash":{},"fn":this.program(24, data, 0),"inverse":this.program(26, data, 0),"data":data})) != null ? stack1 : "");
},"24":function(depth0,helpers,partials,data) {
    var stack1;

  return "					"
    + ((stack1 = this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.activityStartsTextOnUpcomingTrip : stack1), depth0)) != null ? stack1 : "")
    + "\n";
},"26":function(depth0,helpers,partials,data) {
    var stack1;

  return "					"
    + ((stack1 = this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.departureTextForUpcomingTrip : stack1), depth0)) != null ? stack1 : "")
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.name : stack1),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/activity-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "  <section class=\"tab-pane geolocation-enabled on\" id=\"tab-activity\">\n";
},"3":function(depth0,helpers,partials,data) {
    return "  <section class=\"tab-pane on\" id=\"tab-activity\">\n";
},"5":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "\n    <div id=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isMultipleActivitiesOrder : depth0),{"name":"if","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showLXThingsTodo : depth0),{"name":"if","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showLXAirportRides : depth0),{"name":"if","hash":{},"fn":this.program(10, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n    </div>\n\n";
},"6":function(depth0,helpers,partials,data) {
    var stack1;

  return "\n"
    + ((stack1 = this.invokePartial(partials['corewizard/fields/sub-tabs'],depth0,{"name":"corewizard/fields/sub-tabs","data":data,"indent":"      ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n";
},"8":function(depth0,helpers,partials,data) {
    return "          <div>Content FROM showLXThingsTodo</div>\n";
},"10":function(depth0,helpers,partials,data) {
    return "          <div>Content FROM showLXAirportRides</div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, alias1=helpers.helperMissing, alias2=this.escapeExpression;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/title-hbs'],depth0,{"name":"corewizard/fields/title-hbs","data":data,"helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isLocationSelectEnabled : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/error-messages-hbs'],depth0,{"name":"corewizard/field-groups/error-messages-hbs","data":data,"helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isLXActivityABTest : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n  <fieldset class=\"cols-nested destination-only\">\n    "
    + alias2((helpers['input-TA'] || (depth0 && depth0['input-TA']) || alias1).call(depth0,depth0,"destination",{"name":"input-TA","hash":{"label-show":(depth0 != null ? depth0.isDestinationValueEmpty : depth0),"ia-aria-required":"true","ia-data-wizard-owner":(depth0 != null ? depth0.id : depth0),"wizard-action":"{\"destination\" : \"$value1\"}","ia-value":(depth0 != null ? depth0.destination : depth0),"ia-placeholder":(depth0 != null ? depth0.activityDestinationPlaceholderText : depth0),"ia-data-lob":"ACTIVITIES","has-error":(depth0 != null ? depth0.destinationError : depth0),"label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.activityDestinationLabel : stack1),"ta-key":"activity"},"data":data}))
    + "\n  </fieldset>\n\n  <fieldset class=\"cols-nested\">\n    "
    + alias2((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || alias1).call(depth0,depth0,"start",{"name":"input-calendar","hash":{"label-show":(depth0 != null ? depth0.isStartDateValueEmpty : depth0),"ia-aria-required":"true","ia-data-default-range-length":1,"ia-data-end-date":"&#35;activity-end-wrapper","ia-data-min-range-length":(depth0 != null ? depth0.minTripLength : depth0),"ia-data-last-valid-date":(depth0 != null ? depth0.lastValidDate : depth0),"ia-data-max-range-length":(depth0 != null ? depth0.maxTripLength : depth0),"wizard-action":"{\"startDate\" : \"$value1\"}","ia-data-wizard-owner":(depth0 != null ? depth0.id : depth0),"ia-value":(depth0 != null ? depth0.startDate : depth0),"has-error":(depth0 != null ? depth0.startDateError : depth0),"class":"check-in-out","label-text":(depth0 != null ? depth0.startDateLabel : depth0)},"data":data}))
    + "\n    "
    + alias2((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || alias1).call(depth0,depth0,"end",{"name":"input-calendar","hash":{"label-show":(depth0 != null ? depth0.isEndDateValueEmpty : depth0),"ia-aria-required":"true","ia-data-start-date":"&#35;activity-start-wrapper","wizard-action":"{\"endDate\" : \"$value1\"}","ia-data-wizard-owner":(depth0 != null ? depth0.id : depth0),"ia-value":(depth0 != null ? depth0.endDate : depth0),"has-error":(depth0 != null ? depth0.endDateError : depth0),"class":"check-in-out","label-text":(depth0 != null ? depth0.endDateLabel : depth0)},"data":data}))
    + "\n\n  </fieldset>\n\n</section>\n";
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/direct-flight-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return "    "
    + this.escapeExpression((helpers.input || (depth0 && depth0.input) || helpers.helperMissing).call(depth0,depth0,"checkbox","directFlight",(depth0 != null ? depth0.isDirectFlight : depth0),{"name":"input","hash":{"wizard-action":"{\"isDirectFlight\" : $value1}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.directFlightLabel : stack1)},"data":data}))
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showDirectFlightCheckbox : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/flights-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-type-hbs'],depth0,{"name":"corewizard/field-groups/flights-type-hbs","data":data,"helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"3":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-dates-hbs'],depth0,{"name":"corewizard/field-groups/flights-dates-hbs","data":data,"indent":"      ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"5":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.unless.call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.hotel : stack1),{"name":"unless","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isMultiDest : depth0),{"name":"if","hash":{},"fn":this.program(13, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"6":function(depth0,helpers,partials,data) {
    var stack1;

  return "\n"
    + ((stack1 = helpers.unless.call(depth0,((stack1 = (depth0 != null ? depth0.ages : depth0)) != null ? stack1['1'] : stack1),{"name":"unless","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n        <div class=\"flight-passenger-container col "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.ab11873 : depth0),{"name":"if","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\">\n          <fieldset class=\"cols-nested\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-passengers-hbs'],depth0,{"name":"corewizard/field-groups/flights-passengers-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "          </fieldset>\n        </div>\n\n"
    + ((stack1 = helpers.unless.call(depth0,((stack1 = (depth0 != null ? depth0.ages : depth0)) != null ? stack1['1'] : stack1),{"name":"unless","hash":{},"fn":this.program(11, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n";
},"7":function(depth0,helpers,partials,data) {
    var stack1;

  return "          <div class=\"flight-passenger-wrapper "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.ab11873 : depth0),{"name":"if","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\">\n";
},"8":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasChildren : depth0),{"name":"if","hash":{},"fn":this.program(9, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"9":function(depth0,helpers,partials,data) {
    return "cols-row";
},"11":function(depth0,helpers,partials,data) {
    return "          </div>\n";
},"13":function(depth0,helpers,partials,data) {
    var stack1;

  return "        <div class=\"col\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-multi-destination-hbs'],depth0,{"name":"corewizard/field-groups/flights-multi-destination-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "        </div>\n";
},"15":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-children-help-and-options-hbs'],depth0,{"name":"corewizard/field-groups/flights-children-help-and-options-hbs","data":data,"indent":"      ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"17":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.enableAdvancedOptions : depth0),{"name":"if","hash":{},"fn":this.program(18, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"18":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/advanced-options-hbs'],depth0,{"name":"corewizard/field-groups/advanced-options-hbs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "<div id=\""
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n\n  "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isFlightTab : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-origin-destination-hbs'],depth0,{"name":"corewizard/field-groups/flights-origin-destination-hbs","data":data,"indent":"  ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n  <fieldset class=\"cols-nested flight-date-fieldset total-children-"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.ages : depth0)) != null ? stack1.length : stack1), depth0))
    + "\">\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.isHotelTabWithMaxThreeRooms : depth0),{"name":"unless","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.isHotelTab : depth0),{"name":"unless","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasChildren : depth0),{"name":"if","hash":{},"fn":this.program(15, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "  </fieldset>\n\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.isHotelTab : depth0),{"name":"unless","hash":{},"fn":this.program(17, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n";
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/advanced-options-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return "  <section class=\"advanced-options\">\n    <a\n      href=\"#advanced-options-fields\"\n      role=\"button\"\n      id=\"advanced-options\"\n      aria-controls=\"advanced-options-fields\"\n      aria-expanded=\""
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hideFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\"\n      aria-pressed=\""
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hideFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\"\n      class=\"toggle-trigger "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hideFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\"\n      data-wizard-action='{\"showFlightOptions\" : "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hideFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " }'>\n        "
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.advancedOptionsLabel : stack1), depth0))
    + "<span class=\"icon icon-expand\"></span>\n    </a>\n\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(10, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "  </section>\n";
},"2":function(depth0,helpers,partials,data) {
    return "false";
},"4":function(depth0,helpers,partials,data) {
    return "true";
},"6":function(depth0,helpers,partials,data) {
    return "viewed";
},"8":function(depth0,helpers,partials,data) {
    return "open";
},"10":function(depth0,helpers,partials,data) {
    var stack1;

  return "      <div id=\"advanced-options-fields\">\n        <fieldset class=\"advanced-checkboxes\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/fields/nonstop-flight-hbs'],depth0,{"name":"corewizard/fields/nonstop-flight-hbs","data":data,"indent":"           ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/fields/refundable-flight-hbs'],depth0,{"name":"corewizard/fields/refundable-flight-hbs","data":data,"indent":"           ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "        </fieldset>\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showPreferredAirline : depth0),{"name":"if","hash":{},"fn":this.program(11, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "      </div>\n";
},"11":function(depth0,helpers,partials,data) {
    var stack1;

  return "            <fieldset class=\"cols-nested\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],(depth0 != null ? depth0.preferredAirlinesOptions : depth0),{"name":"corewizard/components/select-hbs","data":data,"indent":"                ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],(depth0 != null ? depth0.preferredFlightCabinClassOptions : depth0),{"name":"corewizard/components/select-hbs","data":data,"indent":"                ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "            </fieldset>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isFlightOnly : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/error-messages-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "<div id=\""
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-errors\" class=\"alert-container alert alert-error validation-alert\">\n  <span class=\"icon icon-warn\" aria-hidden=\"true\"></span>\n  <h5 class=\"alert-title\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.errorMessageTitle : stack1), depth0))
    + "</h5>\n    <div class=\"alert-message\">\n      <ul>\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.originErrorMessage : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.originAndDestinationSameMessage : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.destinationErrorMessage : depth0),{"name":"if","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.dateBlankMessage : depth0),{"name":"if","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.dateFormatInvalidMessage : depth0),{"name":"if","hash":{},"fn":this.program(10, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.dateOutOfRangeMessage : depth0),{"name":"if","hash":{},"fn":this.program(12, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.dateCarOutOfRangeMessage : depth0),{"name":"if","hash":{},"fn":this.program(14, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.dateBeforeCurrentDateMessage : depth0),{"name":"if","hash":{},"fn":this.program(16, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.dateTimeRangeMessage : depth0),{"name":"if","hash":{},"fn":this.program(18, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.railDateTimeRangeMessage : depth0),{"name":"if","hash":{},"fn":this.program(20, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.multiDestDateErrorMessage : depth0),{"name":"if","hash":{},"fn":this.program(22, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.dateRangeTooLongErrorMessage : depth0),{"name":"if","hash":{},"fn":this.program(24, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showDriverAgeBlankMessage : depth0),{"name":"if","hash":{},"fn":this.program(26, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showDriverAgeInvalidMessage : depth0),{"name":"if","hash":{},"fn":this.program(28, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.partialStayDatesOutOfRange : depth0),{"name":"if","hash":{},"fn":this.program(30, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.numberOfTravellersMessage : depth0),{"name":"if","hash":{},"fn":this.program(32, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.numberOfRailTravellersMessage : depth0),{"name":"if","hash":{},"fn":this.program(34, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.childAgeMessage : depth0),{"name":"if","hash":{},"fn":this.program(36, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.railYouthAgeMessage : depth0),{"name":"if","hash":{},"fn":this.program(38, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.railSeniorAgeMessage : depth0),{"name":"if","hash":{},"fn":this.program(40, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.railChildAgeMessage : depth0),{"name":"if","hash":{},"fn":this.program(42, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.railChildTravelingWithChildMessage : depth0),{"name":"if","hash":{},"fn":this.program(44, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.railCardExceedAmt : depth0),{"name":"if","hash":{},"fn":this.program(46, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.railCardTypeMissingMessage : depth0),{"name":"if","hash":{},"fn":this.program(48, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.numberOfRailTravellersZeroMessage : depth0),{"name":"if","hash":{},"fn":this.program(50, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.railOriginNotFromTAMessage : depth0),{"name":"if","hash":{},"fn":this.program(52, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.railDestinationNotFromTAMessage : depth0),{"name":"if","hash":{},"fn":this.program(54, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.openSearchErrorMessage : depth0),{"name":"if","hash":{},"fn":this.program(56, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.originErrorMessage2 : depth0),{"name":"if","hash":{},"fn":this.program(58, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.originAndDestinationSameMessage2 : depth0),{"name":"if","hash":{},"fn":this.program(60, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.destinationErrorMessage2 : depth0),{"name":"if","hash":{},"fn":this.program(62, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.dateBlankMessage2 : depth0),{"name":"if","hash":{},"fn":this.program(64, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.dateFormatInvalidMessage2 : depth0),{"name":"if","hash":{},"fn":this.program(66, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.multiDestDateErrorMessage2 : depth0),{"name":"if","hash":{},"fn":this.program(68, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.originErrorMessage3 : depth0),{"name":"if","hash":{},"fn":this.program(70, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.originAndDestinationSameMessage3 : depth0),{"name":"if","hash":{},"fn":this.program(72, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.destinationErrorMessage3 : depth0),{"name":"if","hash":{},"fn":this.program(74, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.dateBlankMessage3 : depth0),{"name":"if","hash":{},"fn":this.program(76, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.dateFormatInvalidMessage3 : depth0),{"name":"if","hash":{},"fn":this.program(78, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.multiDestDateErrorMessage3 : depth0),{"name":"if","hash":{},"fn":this.program(80, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.originErrorMessage4 : depth0),{"name":"if","hash":{},"fn":this.program(82, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.originAndDestinationSameMessage4 : depth0),{"name":"if","hash":{},"fn":this.program(84, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.destinationErrorMessage4 : depth0),{"name":"if","hash":{},"fn":this.program(86, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.dateBlankMessage4 : depth0),{"name":"if","hash":{},"fn":this.program(88, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.dateFormatInvalidMessage4 : depth0),{"name":"if","hash":{},"fn":this.program(90, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.multiDestDateErrorMessage4 : depth0),{"name":"if","hash":{},"fn":this.program(92, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.originErrorMessage5 : depth0),{"name":"if","hash":{},"fn":this.program(94, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.originAndDestinationSameMessage5 : depth0),{"name":"if","hash":{},"fn":this.program(96, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.destinationErrorMessage5 : depth0),{"name":"if","hash":{},"fn":this.program(98, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.dateBlankMessage5 : depth0),{"name":"if","hash":{},"fn":this.program(100, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.dateFormatInvalidMessage5 : depth0),{"name":"if","hash":{},"fn":this.program(102, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.multiDestDateErrorMessage5 : depth0),{"name":"if","hash":{},"fn":this.program(104, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "      </ul>\n    </div>\n  </div>\n";
},"2":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"originError\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-origin\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.originErrorMessageText : stack1), depth0))
    + "</a></li>\n";
},"4":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-origin\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.originAndDestinationSameMessageText : stack1), depth0))
    + "</a></li>\n";
},"6":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"destinationError\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-destination\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.destinationErrorMessageText : stack1), depth0))
    + "</a></li>\n";
},"8":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"dateBlankMessage\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-departing\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.dateBlankMessageText : stack1), depth0))
    + "</a></li>\n";
},"10":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-departing\">"
    + alias3(((helper = (helper = helpers.dateFormatInvalidMessageText || (depth0 != null ? depth0.dateFormatInvalidMessageText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"dateFormatInvalidMessageText","hash":{},"data":data}) : helper)))
    + "</a></li>\n";
},"12":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-departing\">"
    + alias3(((helper = (helper = helpers.dateOutOfRangeMessageText || (depth0 != null ? depth0.dateOutOfRangeMessageText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"dateOutOfRangeMessageText","hash":{},"data":data}) : helper)))
    + "</a></li>\n";
},"14":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-departing\">"
    + alias3(((helper = (helper = helpers.dateCarOutOfRangeMessageText || (depth0 != null ? depth0.dateCarOutOfRangeMessageText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"dateCarOutOfRangeMessageText","hash":{},"data":data}) : helper)))
    + "</a></li>\n";
},"16":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-departing\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.dateBeforeCurrentDateMessageText : stack1), depth0))
    + "</a></li>\n";
},"18":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-departing\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.dateTimeRangeMessageText : stack1), depth0))
    + "</a></li>\n";
},"20":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "          <li><a href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-departing\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.railDateTimeRangeMessageText : stack1), depth0))
    + "</a></li>\n";
},"22":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"multiDestDateErrorMessage\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-departing\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.multiDestDateErrorText : stack1), depth0))
    + "</a></li>\n";
},"24":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-returning\">"
    + alias3(((helper = (helper = helpers.dateRangeTooLongErrorMessageText || (depth0 != null ? depth0.dateRangeTooLongErrorMessageText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"dateRangeTooLongErrorMessageText","hash":{},"data":data}) : helper)))
    + "</a></li>\n";
},"26":function(depth0,helpers,partials,data) {
    var stack1;

  return "        <li><a href=\"&#35;car-driverAge\">"
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.driverAgeBlankMessageText : stack1), depth0))
    + "</a></li>\n";
},"28":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda, alias2=this.escapeExpression;

  return "        <li>\n            <a href=\"&#35;car-driverAge\">\n              <span class='visuallyhidden'>"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.driverAgeInvalidAccessibilityMessageText : stack1), depth0))
    + "</span>\n              <span aria-hidden='true'>"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.driverAgeInvalidMessageText : stack1), depth0))
    + "</span>\n            </a>\n        </li>\n";
},"30":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"partialStayDatesOutOfRange\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-checkin\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.partialStayDatesOutOfRangeText : stack1), depth0))
    + "</a></li>\n";
},"32":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"numberOfTravellersMessage\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-adults\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.numberOfTravellersMessageText : stack1), depth0))
    + "</a></li>\n";
},"34":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"numberOfRailTravellersMessage\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-adults\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.maxRailTravellersExceededText : stack1), depth0))
    + "</a></li>\n";
},"36":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"childAgeMessage\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-children\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.childAgeMessageText : stack1), depth0))
    + "</a></li>\n";
},"38":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"railYouthAgeMessage\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-youth\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.railYouthAgeMessageText : stack1), depth0))
    + "</a></li>\n";
},"40":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"railSeniorAgeMessage\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-senior\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.railSeniorAgeMessageText : stack1), depth0))
    + "</a></li>\n";
},"42":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"railChildAgeMessage\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-children\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.railChildAloneBelowMin : stack1), depth0))
    + "</a></li>\n";
},"44":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"railChildTravelingWithChildMessage\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-children\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.railChildCantTravelWithChild : stack1), depth0))
    + "</a></li>\n";
},"46":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"railCardExceedAmt\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-children\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.railCardExceededTravellers : stack1), depth0))
    + "</a></li>\n";
},"48":function(depth0,helpers,partials,data) {
    var stack1;

  return "        <li><a class=\"railCardTypeMissingMessage\" href=\"&#35;railcards-list-fieldset-0\">"
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.railCardTypeMissingMessageText : stack1), depth0))
    + "</a></li>\n";
},"50":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"numberOfTravellersZeroError\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-adults\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.maxRailTravellersExceededText : stack1), depth0))
    + "</a></li>\n";
},"52":function(depth0,helpers,partials,data) {
    var stack1;

  return "        <li><a class=\"originError\" href=\"&#35;rail-origin\">"
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.railOriginNotFromTAMessage : stack1), depth0))
    + "</a></li>\n";
},"54":function(depth0,helpers,partials,data) {
    var stack1;

  return "        <li><a class=\"destinationError\" href=\"&#35;rail-destination\">"
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.railDestinationNotFromTAMessage : stack1), depth0))
    + "</a></li>\n";
},"56":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-searchQuery\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.openSearchErrorMessageText : stack1), depth0))
    + "</a></li>\n";
},"58":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-2-origin\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.originErrorMessageText : stack1), depth0))
    + "</a></li>\n";
},"60":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-2-origin\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.originAndDestinationSameMessageText : stack1), depth0))
    + "</a></li>\n";
},"62":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"destinationError2\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-2-destination\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.destinationErrorMessageText : stack1), depth0))
    + "</a></li>\n";
},"64":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"dateBlankMessage2\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-2-departing\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.dateBlankMessageText : stack1), depth0))
    + "</a></li>\n";
},"66":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-2-departing\">"
    + alias3(((helper = (helper = helpers.dateFormatInvalidMessageText || (depth0 != null ? depth0.dateFormatInvalidMessageText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"dateFormatInvalidMessageText","hash":{},"data":data}) : helper)))
    + "</a></li>\n";
},"68":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"multiDestDateErrorMessage2\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-2-departing\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.multiDestDateErrorText : stack1), depth0))
    + "</a></li>\n";
},"70":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-3-origin\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.originErrorMessageText : stack1), depth0))
    + "</a></li>\n";
},"72":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-3-origin\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.originAndDestinationSameMessageText : stack1), depth0))
    + "</a></li>\n";
},"74":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"destinationError3\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-3-destination\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.destinationErrorMessageText : stack1), depth0))
    + "</a></li>\n";
},"76":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"dateBlankMessage3\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-3-departing\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.dateBlankMessageText : stack1), depth0))
    + "</a></li>\n";
},"78":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-3-departing\">"
    + alias3(((helper = (helper = helpers.dateFormatInvalidMessageText || (depth0 != null ? depth0.dateFormatInvalidMessageText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"dateFormatInvalidMessageText","hash":{},"data":data}) : helper)))
    + "</a></li>\n";
},"80":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"multiDestDateErrorMessage3\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-3-departing\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.multiDestDateErrorText : stack1), depth0))
    + "</a></li>\n";
},"82":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-4-origin\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.originErrorMessageText : stack1), depth0))
    + "</a></li>\n";
},"84":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-4-origin\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.originAndDestinationSameMessageText : stack1), depth0))
    + "</a></li>\n";
},"86":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"destinationError4\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-4-destination\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.destinationErrorMessageText : stack1), depth0))
    + "</a></li>\n";
},"88":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"dateBlankMessage4\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-4-departing\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.dateBlankMessageText : stack1), depth0))
    + "</a></li>\n";
},"90":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-4-departing\">"
    + alias3(((helper = (helper = helpers.dateFormatInvalidMessageText || (depth0 != null ? depth0.dateFormatInvalidMessageText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"dateFormatInvalidMessageText","hash":{},"data":data}) : helper)))
    + "</a></li>\n";
},"92":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"multiDestDateErrorMessage4\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-4-departing\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.multiDestDateErrorText : stack1), depth0))
    + "</a></li>\n";
},"94":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-5-origin\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.originErrorMessageText : stack1), depth0))
    + "</a></li>\n";
},"96":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-5-origin\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.originAndDestinationSameMessageText : stack1), depth0))
    + "</a></li>\n";
},"98":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"destinationError5\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-5-destination\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.destinationErrorMessageText : stack1), depth0))
    + "</a></li>\n";
},"100":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"dateBlankMessage5\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-5-departing\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.dateBlankMessageText : stack1), depth0))
    + "</a></li>\n";
},"102":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-5-departing\">"
    + alias3(((helper = (helper = helpers.dateFormatInvalidMessageText || (depth0 != null ? depth0.dateFormatInvalidMessageText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"dateFormatInvalidMessageText","hash":{},"data":data}) : helper)))
    + "</a></li>\n";
},"104":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"multiDestDateErrorMessage5\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-5-departing\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.multiDestDateErrorText : stack1), depth0))
    + "</a></li>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showErrors : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/flights-lap-or-seat-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "    "
    + this.escapeExpression((helpers.assign || (depth0 && depth0.assign) || helpers.helperMissing).call(depth0,depth0,"id","=","hotel-flight",{"name":"assign","hash":{},"data":data}))
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.escapeExpression, alias2=helpers.helperMissing;

  return "<div class=\"young-child-note\">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isHotelTab : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n  <fieldset class=\"children-lap-wrapper cf\">\n  <legend>"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightChildNote : stack1), depth0))
    + "</legend>\n    "
    + alias1((helpers.input || (depth0 && depth0.input) || alias2).call(depth0,depth0,"radio","children-in-lap",(depth0 != null ? depth0.isChildInLap : depth0),{"name":"input","hash":{"ia-value":"lap","ia-name":"lap-or-seat","wizard-action":"{\"isChildInLap\" : true}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightChildInLapLabel : stack1)},"data":data}))
    + "\n    "
    + alias1((helpers.assign || (depth0 && depth0.assign) || alias2).call(depth0,depth0,"inSeat","!",(depth0 != null ? depth0.isChildInLap : depth0),{"name":"assign","hash":{},"data":data}))
    + "\n    "
    + alias1((helpers.input || (depth0 && depth0.input) || alias2).call(depth0,depth0,"radio","children-in-seat",(depth0 != null ? depth0.inSeat : depth0),{"name":"input","hash":{"ia-value":"seat","ia-name":"lap-or-seat","wizard-action":"{\"isChildInLap\" : false}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightChildInSeatLabel : stack1)},"data":data}))
    + "\n  </fieldset>\n</div>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/hotels-children-fieldset-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression, alias2=helpers.helperMissing, alias3="function";

  return "  <fieldset class=\"children-fieldset total-children-"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.ages : depth0)) != null ? stack1.length : stack1), depth0))
    + " cols-nested\" id=\""
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-children-ages\" data-children-fieldset=\""
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" data-wizard-owner=\""
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.ages : depth0),{"name":"each","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "  </fieldset>\n";
},"2":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],depth0,{"name":"corewizard/components/select-hbs","data":data,"indent":"      ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.ages : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/hotels-rooms-container-hbs", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.lambda, alias2=this.escapeExpression, alias3=helpers.helperMissing, alias4="function";

  return "<div class=\"rooms-container total-rooms-"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.rooms : depth0)) != null ? stack1.length : stack1), depth0))
    + " total-room-1-children-"
    + alias2(alias1(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? depth0.rooms : depth0)) != null ? stack1['0'] : stack1)) != null ? stack1.ages : stack1)) != null ? stack1.length : stack1), depth0))
    + "\" id=\""
    + alias2(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-rooms\" data-id-prefix=\""
    + alias2(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" data-highest-tnum=\"0\" data-wizard-owner=\""
    + alias2(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-room-hbs'],depth0,{"name":"corewizard/field-groups/hotels-room-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "</div>\n";
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/cars-location-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "<fieldset class=\"cols-nested origin-destination location-select-enabled\">\n";
},"3":function(depth0,helpers,partials,data) {
    return "<fieldset class=\"cols-nested origin-destination\">\n";
},"5":function(depth0,helpers,partials,data) {
    return " invalid";
},"7":function(depth0,helpers,partials,data) {
    return "show";
},"9":function(depth0,helpers,partials,data) {
    return "                class=\"error\"\n";
},"11":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/components/button-location-select-hbs'],depth0,{"name":"corewizard/components/button-location-select-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"13":function(depth0,helpers,partials,data) {
    return "                class=\"error\"\n            ";
},"15":function(depth0,helpers,partials,data) {
    return "                disabled\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression, alias4=this.lambda;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isLocationSelectEnabled : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "<div class=\"container-ta-car theme-standard autocomplete pin-left col\" data-auto-pos=\"true\" data-control=\"autocomplete\">\n  <label class=\"text type-ahead icon-before autocomplete-arrow "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.destinationError : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-pickup-label\">\n      <span class=\"label "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isDestinationValueEmpty : depth0),{"name":"if","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\">"
    + ((stack1 = alias4(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carPickupLabel : stack1), depth0)) != null ? stack1 : "")
    + "</span>\n        <input\n            type=\"text\"\n            class=\"autocomplete-trigger-input\"\n            id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-pickup\"\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.destinationError : depth0),{"name":"if","hash":{},"fn":this.program(9, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "            value=\""
    + alias3(((helper = (helper = helpers.pickup || (depth0 != null ? depth0.pickup : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"pickup","hash":{},"data":data}) : helper)))
    + "\"\n            placeholder=\""
    + alias3(((helper = (helper = helpers.carPickupPlaceholderText || (depth0 != null ? depth0.carPickupPlaceholderText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"carPickupPlaceholderText","hash":{},"data":data}) : helper)))
    + "\"\n            data-js-theme=\"typeahead\"\n            data-ta-key=\"car_origin\"\n            data-provide=\"typeahead\"\n            data-lob=\"CARS\"\n            data-mask=\"31\"\n            data-version=\"v3\"\n            data-wizard-action='{\"destination\" : \"$value1\"}'\n            data-autoselect=\"touch\" aria-autocomplete=\"list\"\n            autocomplete=\"off\"\n            spellcheck=\"false\"\n            data-tooltip-id=\"typeahead-list-category\"\n            aria-owns=\"typeahead-list-category\"\n        />\n      <span class=\"icon icon-location\" aria-hidden=\"true\"></span>\n  </label>\n    <span class=\"icon icon-close visuallyhidden clear-search\" aria-hidden=\"true\"></span>\n    <div class=\"autocomplete-dropdown\"></div>\n</div>\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isLocationSelectEnabled : depth0),{"name":"if","hash":{},"fn":this.program(11, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "<div class=\"container-ta-car theme-standard autocomplete pin-left col\" data-auto-pos=\"true\" data-control=\"autocomplete\">\n  <label class=\"text type-ahead icon-before autocomplete-arrow "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.carReturnError : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-dropoff-label\">\n      <span class=\"label "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isCarReturnValueEmpty : depth0),{"name":"if","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\">"
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carDropoffLabel : stack1), depth0))
    + "</span>\n        <input\n            type=\"text\"\n            class=\"autocomplete-trigger-input\"\n            id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-dropoff\"\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.carReturnError : depth0),{"name":"if","hash":{},"fn":this.program(13, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " value=\""
    + alias3(((helper = (helper = helpers.dropoff || (depth0 != null ? depth0.dropoff : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"dropoff","hash":{},"data":data}) : helper)))
    + "\"\n            placeholder=\""
    + alias3(((helper = (helper = helpers.carDropoffPlaceholderText || (depth0 != null ? depth0.carDropoffPlaceholderText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"carDropoffPlaceholderText","hash":{},"data":data}) : helper)))
    + "\"\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.carShowDropOff : depth0),{"name":"unless","hash":{},"fn":this.program(15, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "            data-js-theme=\"typeahead\"\n            data-ta-key=\"car_dest\"\n            data-provide=\"typeahead\"\n            data-lob=\"CARS\"\n            data-mask=\"1\"\n            data-version=\"v1\"\n            data-forceicon=\"flights\"\n            data-wizard-action='{\"carReturn\" : \"$value1\"}'\n            data-autoselect=\"touch\"\n            aria-autocomplete=\"list\"\n            autocomplete=\"off\"\n            spellcheck=\"false\"\n            data-tooltip-id=\"typeahead-list-category\"\n            aria-owns=\"typeahead-list-category\"\n            aria-labelledby=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-dropoff-label\"\n            title=\""
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carDropoffPlaceholder : stack1), depth0))
    + "\"\n            data-tracking=\"carReturnInput\"\n        />\n      <span class=\"icon icon-location\" aria-hidden=\"true\"></span>\n  </label>\n    <span class=\"icon icon-close visuallyhidden clear-search\" ></span>\n    <div class=\"autocomplete-dropdown\"></div>\n</div>\n</fieldset>\n";
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/cars-driver-age-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "false";
},"3":function(depth0,helpers,partials,data) {
    return "true";
},"5":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "      <section class=\"cols-row\">\n       \n        <fieldset class=\"col driver-age-col\">\n\n            <div class=\"container-ta-car\" data-auto-pos=\"true\" data-control=\"autocomplete\">         \n              <label class=\"driver-age-label text "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.driverAgeErrorOccured : depth0),{"name":"if","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-pickup-label\">\n                  <span class=\"label\">"
    + alias3(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.driverAge : stack1), depth0))
    + "</span>\n                    <input\n                        type=\"number\"\n                        id=\"car-driverAge\"\n                        name=\"car-driverAge\"\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.driverAgeErrorOccured : depth0),{"name":"if","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "                        value=\""
    + alias3(((helper = (helper = helpers.driverAge || (depth0 != null ? depth0.driverAge : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"driverAge","hash":{},"data":data}) : helper)))
    + "\"\n                        placeholder=\"\"\n                        data-wizard-action='{\"driverAge\" : \"$value1\"}'                    \n                    />\n              </label>\n            </div>\n\n        </fieldset>\n\n      </section>\n";
},"6":function(depth0,helpers,partials,data) {
    return " invalid";
},"8":function(depth0,helpers,partials,data) {
    return "                            class=\"error\"\n                            aria-invalid=\"true\"\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.escapeExpression, alias2=this.lambda;

  return "\n<fieldset class=\"cols-nested driver-age\">\n    \n      <!--driver age checkbox (data, type, namespace, bool, options)-->\n      "
    + alias1((helpers.input || (depth0 && depth0.input) || helpers.helperMissing).call(depth0,depth0,"checkbox","driver-age-checkbox",(depth0 != null ? depth0.isCarDriverAgeWithinLimit : depth0),{"name":"input","hash":{"wizard-action":"{\"isCarDriverAgeWithinLimit\" : $value1}","label-text":(depth0 != null ? depth0.driverAgeLabel : depth0)},"data":data}))
    + "\n\n      <!--driver age tooltip-->\n      <a  href=\"#car-driver-age-help-container\" \n          class=\"driver-age-tooltip\"  \n          id=\"driver-age-help-default\" \n          data-control=\"tooltip\" \n          data-width=\"300\" \n          data-arrow=\"true\" \n          aria-describedby=\"car-driver-age-help-container\" \n          data-fade=\"out\" \n          data-manual=\"none\" \n          data-tooltip-classes=\"example\" \n          data-wizard-action='{\"driverAgeTooltipSelected\" : "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.driverAgeTooltipSelected : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + " }'\n          >\n\n          <span class=\"icon icon-info driver-age-info-icon\"><span class=\"visuallyhidden\">"
    + alias1(alias2(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.driverAgeToottipAltMessageText : stack1), depth0))
    + "</span></span>\n      </a>\n\n      <div id=\"car-driver-age-help-container\" role=\"tooltip\" class=\"visuallyhidden\"><p>"
    + alias1(alias2(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.driverAgeToottipMessageText : stack1), depth0))
    + "</p></div>\n\n  </fieldset>\n\n  <!--driver age textbox-->\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.isCarDriverAgeWithinLimit : depth0),{"name":"unless","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/flights-children-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.ages : depth0),{"name":"each","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"2":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],depth0,{"name":"corewizard/components/select-hbs","data":data,"indent":"      ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression, alias2=helpers.helperMissing, alias3="function";

  return "<fieldset class=\"total-children-"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.ages : depth0)) != null ? stack1.length : stack1), depth0))
    + " children-fieldset cols-nested\" id=\""
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-children-ages\" data-wizard-owner=\""
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.hidePassengerInfo : depth0),{"name":"unless","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</fieldset>\n";
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/flights-multi-destination-hbs", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<div id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-flights\" class=\"multi-dest-container\" data-highest-tnum=\"1\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-flight-hbs'],depth0,{"name":"corewizard/field-groups/flights-flight-hbs","data":data,"indent":"  ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "</div>\n";
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/hotels-dates-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "  "
    + this.escapeExpression((helpers.assign || (depth0 && depth0.assign) || helpers.helperMissing).call(depth0,depth0,"id","=","flight-hotel",{"name":"assign","hash":{},"data":data}))
    + "\n";
},"3":function(depth0,helpers,partials,data) {
    var helper;

  return "\n        <div class=\"length-of-stay-counter col\" id=\"length-of-stay-counter\">\n          "
    + this.escapeExpression(((helper = (helper = helpers.hotelLengthOfStayString || (depth0 != null ? depth0.hotelLengthOfStayString : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"hotelLengthOfStayString","hash":{},"data":data}) : helper)))
    + "\n        </div>\n\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, alias1=helpers.helperMissing, alias2=this.escapeExpression;

  return "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isFlightTab : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + alias2((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || alias1).call(depth0,depth0,"checkin",{"name":"input-calendar","hash":{"label-show":(depth0 != null ? depth0.isStartDateValueEmpty : depth0),"ia-value":(depth0 != null ? depth0.checkinValue : depth0),"ia-data-min-range-length":(depth0 != null ? depth0.minTripLength : depth0),"ia-data-default-range-length":1,"ia-data-last-valid-date":(depth0 != null ? depth0.lastValidDate : depth0),"ia-data-max-range-length":(depth0 != null ? depth0.maxTripLength : depth0),"ia-data-max-booking-length":(depth0 != null ? depth0.maxTripLength : depth0),"has-error":(depth0 != null ? depth0.startDateHotelError : depth0),"wizard-action":(depth0 != null ? depth0.checkinAction : depth0),"class":"check-in-out","label-text":(depth0 != null ? depth0.hotelCheckinLabel : depth0)},"data":data}))
    + "\n"
    + alias2((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || alias1).call(depth0,depth0,"checkout",{"name":"input-calendar","hash":{"label-show":(depth0 != null ? depth0.isEndDateValueEmpty : depth0),"aria-describedby":"length-of-stay-counter","ia-value":(depth0 != null ? depth0.checkoutValue : depth0),"has-error":(depth0 != null ? depth0.endDateHotelError : depth0),"wizard-action":(depth0 != null ? depth0.checkoutAction : depth0),"class":"check-in-out","label-text":(depth0 != null ? depth0.hotelCheckoutLabel : depth0)},"data":data}))
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showLengthOfStay : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/partial-stay-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return "    "
    + this.escapeExpression((helpers.input || (depth0 && depth0.input) || helpers.helperMissing).call(depth0,depth0,"checkbox","partialHotelBooking",(depth0 != null ? depth0.isPartialStay : depth0),{"name":"input","hash":{"wizard-action":"{\"isPartialStay\" : $value1}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.partialStayLabel : stack1)},"data":data}))
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showPartialStay : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/cars-package-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "  "
    + this.escapeExpression((helpers.assign || (depth0 && depth0.assign) || helpers.helperMissing).call(depth0,depth0,"id","=","hotel-car",{"name":"assign","hash":{},"data":data}))
    + "\n";
},"3":function(depth0,helpers,partials,data) {
    return "  "
    + this.escapeExpression((helpers.assign || (depth0 && depth0.assign) || helpers.helperMissing).call(depth0,depth0,"id","=","flight-car",{"name":"assign","hash":{},"data":data}))
    + "\n";
},"5":function(depth0,helpers,partials,data) {
    var stack1;

  return "          <div class=\"driver-age-package-wrapper\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/cars-driver-age-hbs'],depth0,{"name":"corewizard/field-groups/cars-driver-age-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "          </div>\n";
},"7":function(depth0,helpers,partials,data) {
    var stack1;

  return "      <p>"
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carWillBeAddedLabel : stack1), depth0))
    + "</p>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isHotelTab : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isFlightTab : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n<div id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" data-remove-type=\"cars-package\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.parent || (depth0 != null ? depth0.parent : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"parent","hash":{},"data":data}) : helper)))
    + "\">\n   	<!--Car Driver Age fieldset-->\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showCarDriverAge : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.showCarDriverAge : depth0),{"name":"unless","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n";
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/flights-children-help-and-options-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.lambda, alias2=this.escapeExpression, alias3=helpers.helperMissing, alias4="function";

  return "<fieldset class=\"three-pp-airline-age-rules cols-nested\">\n  <label class=\"col three-pp-airline-age-rules-label\">\n      <span class=\"label\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.ageHelpMessage : stack1), depth0))
    + "</span>\n  </label>\n  <a href=\"/p/info-main/h_fw_default?rhtx=HTX_FLTSRCH_RT#travs\" class=\"link age-rules\" id=\""
    + alias2(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-children-help\" data-wizard-owner=\""
    + alias2(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" target=\"_blank\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.airlineAgeRules : stack1), depth0))
    + " <span class=\"visuallyhidden\">opens in a new window</span><span aria-hidden=\"true\" class=\"icon icon-popup\"></span></a>\n</fieldset>\n";
},"3":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<a href=\"/p/info-main/h_fw_default?rhtx=HTX_FLTSRCH_RT#travs\" class=\"link age-rules\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-children-help\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" target=\"_blank\">"
    + alias3(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.airlineAgeRules : stack1), depth0))
    + " <span class=\"visuallyhidden\">opens in a new window</span><span aria-hidden=\"true\" class=\"icon icon-popup\"></span></a>\n";
},"5":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<div id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-lap-or-seat-container\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-lap-or-seat-hbs'],depth0,{"name":"corewizard/field-groups/flights-lap-or-seat-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "</div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isThreePP : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.isThreePP : depth0),{"name":"unless","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showLapOrSeat : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/flights-origin-destination-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/flights-destination-hbs'],depth0,{"name":"corewizard/fields/flights-destination-hbs","data":data,"indent":"      ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "  <fieldset class=\"cols-nested origin-destination typeahead-container\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/fields/flights-origin-hbs'],depth0,{"name":"corewizard/fields/flights-origin-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.hideFlightDestination : depth0),{"name":"unless","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "  </fieldset>\n";
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/packages-origin-destination-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/packages-destination-hbs'],depth0,{"name":"corewizard/fields/packages-destination-hbs","data":data,"indent":"      ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "  <fieldset class=\"cols-nested origin-destination typeahead-container\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/fields/packages-origin-hbs'],depth0,{"name":"corewizard/fields/packages-origin-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.hideFlightDestination : depth0),{"name":"unless","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "  </fieldset>\n";
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/hotels-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return "      <fieldset class=\"cols-nested destination-only\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/fields/hotel-destination-hbs'],depth0,{"name":"corewizard/fields/hotel-destination-hbs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "      </fieldset>\n";
},"3":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda, alias2=this.escapeExpression;

  return "            <label id=\"hotel-1-guests-label\" class=\"select icon col icon-toggle180 \">\n                <span class=\"label\">"
    + ((stack1 = alias1(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.guestsLabel : stack1), depth0)) != null ? stack1 : "")
    + "</span>\n                <select id=\"hotel-1-guests\" data-wizard-action=\"{&quot;guestMoreOptionsSelected&quot; : $value1}\">\n                   <option selected=\"selected\" value=\"2\"> "
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.hotelPreFilledOptions2Adults : stack1), depth0))
    + " </option>\n                   <option value=\"1\"> "
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.hotelPreFilledOptions1Adult : stack1), depth0))
    + " </option>\n                   <option value=\"99\"> "
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.hotelPreFilledOptionsMoreOptions : stack1), depth0))
    + " </option>\n                </select>\n            </label>\n";
},"5":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],(depth0 != null ? depth0.hotelRoomCountOptions : depth0),{"name":"corewizard/components/select-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "            <div class=\"rooms-container stacked-rooms total-rooms-"
    + alias1(((helper = (helper = helpers.roomCount || (depth0 != null ? depth0.roomCount : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"roomCount","hash":{},"data":data}) : helper)))
    + " total-room-1-children-"
    + alias1(this.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? depth0.rooms : depth0)) != null ? stack1['0'] : stack1)) != null ? stack1.ages : stack1)) != null ? stack1.length : stack1), depth0))
    + "\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-rooms-container-hbs'],depth0,{"name":"corewizard/field-groups/hotels-rooms-container-hbs","data":data,"indent":"               ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "            </div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "<div class=\"total-rooms-"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.rooms : depth0)) != null ? stack1.length : stack1), depth0))
    + "\" id=\""
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isHotelDestinationVisible : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    <fieldset class=\"cols-nested\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-dates-hbs'],depth0,{"name":"corewizard/field-groups/hotels-dates-hbs","data":data,"indent":"\t      ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.useDetailedGuestDropdown : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.program(5, data, 0),"data":data})) != null ? stack1 : "")
    + "    </fieldset>\n\n</div>\n";
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/vacation-rental-hbs", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda;

  return "<fieldset class=\"cols-nested destination-only\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/fields/hotel-destination-hbs'],depth0,{"name":"corewizard/fields/hotel-destination-hbs","data":data,"indent":"  ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "</fieldset>\n\n  <fieldset class=\"cols-nested\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-dates-hbs'],depth0,{"name":"corewizard/field-groups/hotels-dates-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "    <label id=\"hotel-1-guests-label\" class=\"select icon col icon-toggle180 \">\n        <span class=\"label\">"
    + ((stack1 = alias1(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.guestsLabel : stack1), depth0)) != null ? stack1 : "")
    + "</span>\n     <select id=\"hotel-1-guests\" data-wizard-action=\"{&quot;rooms[0].adults&quot; : $value1}\" data-select-value=\""
    + this.escapeExpression(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.rooms : depth0)) != null ? stack1['0'] : stack1)) != null ? stack1.adults : stack1), depth0))
    + "\">\n         <option selected=\"selected\" value=\"1\"> 1 </option>\n         <option value=\"2\"> 2 </option>\n         <option value=\"3\"> 3 </option>\n         <option value=\"4\"> 4 </option>\n         <option value=\"5\"> 5 </option>\n         <option value=\"6\"> 6 </option>\n         <option value=\"7\"> 7 </option>\n         <option value=\"8\"> 8 </option>\n         <option value=\"9\"> 9 </option>\n         <option value=\"10\"> 10 </option>\n         <option value=\"11\"> 11+ </option>\n         <option value=\"12\"> 12+ </option>\n         <option value=\"13\"> 13+ </option>\n     </select>\n   </label>\n  </fieldset>\n";
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/flights-dates-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/flights-returning-hbs'],depth0,{"name":"corewizard/fields/flights-returning-hbs","data":data,"indent":"  ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/flights-departing-hbs'],depth0,{"name":"corewizard/fields/flights-departing-hbs","data":data,"helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isRoundtrip : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/flights-passengers-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "		<fieldset id=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-children-fieldset\" class=\"cols-nested\">\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.hidePassengerInfo : depth0),{"name":"unless","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "		</fieldset>\n";
},"2":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.ages : depth0),{"name":"each","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"3":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],depth0,{"name":"corewizard/components/select-hbs","data":data,"indent":"\t\t\t\t\t","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"5":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.hidePassengerInfo : depth0),{"name":"unless","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"6":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.ages : depth0),{"name":"each","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"7":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],depth0,{"name":"corewizard/components/select-hbs","data":data,"indent":"\t\t\t\t","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<div id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-passengers\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],(depth0 != null ? depth0.flightAdultCountOptions : depth0),{"name":"corewizard/components/select-hbs","data":data,"indent":"\t","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],(depth0 != null ? depth0.flightChildCountOptions : depth0),{"name":"corewizard/components/select-hbs","data":data,"indent":"\t","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.ab11873 : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(5, data, 0),"data":data})) != null ? stack1 : "")
    + "</div>\n";
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/flights-flight-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "  <hr class=\"default\" />\n  <fieldset data-number=\""
    + alias3(((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"number","hash":{},"data":data}) : helper)))
    + "\" data-container=\""
    + alias3(((helper = (helper = helpers.container || (depth0 != null ? depth0.container : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"container","hash":{},"data":data}) : helper)))
    + "\" class=\"cols-nested origin-destination additional-flight\">\n    <legend id=\"flight-"
    + alias3(((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"number","hash":{},"data":data}) : helper)))
    + "\">"
    + alias3(this.lambda(((stack1 = (depths[1] != null ? depths[1].loc : depths[1])) != null ? stack1.flightLabel : stack1), depth0))
    + " "
    + alias3(((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"number","hash":{},"data":data}) : helper)))
    + "</legend>\n    "
    + alias3((helpers['input-TA'] || (depth0 && depth0['input-TA']) || alias1).call(depth0,depth0,"origin",{"name":"input-TA","hash":{"ia-data-lob":"FLIGHTS","ia-value":(depth0 != null ? depth0.origin : depth0),"ia-placeholder":((stack1 = (depths[1] != null ? depths[1].loc : depths[1])) != null ? stack1.flightPlaceholderText : stack1),"ia-data-number":(depth0 != null ? depth0.number : depth0),"ta-key":"flight_multi","has-error":(depth0 != null ? depth0.originError : depth0),"wizard-action":(depth0 != null ? depth0.originWizardAction : depth0),"label-text":((stack1 = (depths[1] != null ? depths[1].loc : depths[1])) != null ? stack1.flightOriginLabel : stack1)},"data":data}))
    + "\n\n    "
    + alias3((helpers['input-TA'] || (depth0 && depth0['input-TA']) || alias1).call(depth0,depth0,"destination",{"name":"input-TA","hash":{"ia-data-lob":"FLIGHTS","ia-placeholder":((stack1 = (depths[1] != null ? depths[1].loc : depths[1])) != null ? stack1.flightPlaceholderText : stack1),"ia-data-number":(depth0 != null ? depth0.number : depth0),"ia-value":(depth0 != null ? depth0.destination : depth0),"ta-key":"flight_multi","has-error":(depth0 != null ? depth0.destinationError : depth0),"wizard-action":(depth0 != null ? depth0.destinationWizardAction : depth0),"label-text":((stack1 = (depths[1] != null ? depths[1].loc : depths[1])) != null ? stack1.flightDestinationLabel : stack1)},"data":data}))
    + "\n\n    "
    + alias3((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || alias1).call(depth0,depth0,"departing",{"name":"input-calendar","hash":{"ia-value":(depth0 != null ? depth0.departing : depth0),"has-error":(depth0 != null ? depth0.startDateError : depth0),"wizard-action":(depth0 != null ? depth0.dateWizardAction : depth0),"label-text":((stack1 = (depths[1] != null ? depths[1].loc : depths[1])) != null ? stack1.flightDepartingLabel : stack1)},"data":data}))
    + "\n  </fieldset>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.multidest : depth0),{"name":"each","hash":{},"fn":this.program(1, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true,"useDepths":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/flights-type-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return "          "
    + this.escapeExpression((helpers.input || (depth0 && depth0.input) || helpers.helperMissing).call(depth0,depth0,"radio","type-multi-dest",(depth0 != null ? depth0.isMultiDest : depth0),{"name":"input","hash":{"ia-value":"multi","ia-name":"flight-type","wizard-action":"{\"flighttype\" : \"$value1\", \"packages.hotel\":false, \"packages.car\":false, \"packages.flight\": false}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightMultidestLabel : stack1),"class":"col"},"data":data}))
    + "\n";
},"3":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda, alias2=this.escapeExpression;

  return "\n\n      <a href=\"#flight-type-help-container\" id=\"flight-type-help-default\" data-control=\"tooltip\" data-width=\"300\" data-arrow=\"true\" aria-describedby=\"flight-type-help-container\" data-fade=\"out\" data-manual=\"none\" data-tooltip-classes=\"example\"><span class=\"icon icon-help\"><span class=\"visuallyhidden\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightTypeHelpToolTipText : stack1), depth0))
    + "</span></span></a><div id=\"flight-type-help-container\" role=\"tooltip\" class=\"visuallyhidden\"><p>"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightTypeHelpMessage : stack1), depth0))
    + "</p></div>\n\n\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, alias1=helpers.helperMissing, alias2=this.escapeExpression;

  return "<fieldset class=\"flight-type-select\">\n   <legend class=\"visuallyhidden\">Flight type - changes form below</legend>\n      "
    + alias2((helpers.input || (depth0 && depth0.input) || alias1).call(depth0,depth0,"radio","type-roundtrip",(depth0 != null ? depth0.isRoundtrip : depth0),{"name":"input","hash":{"ia-value":"roundtrip","ia-name":"flight-type","wizard-action":"{\"flighttype\" : \"$value1\"}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightRoundtripLabel : stack1),"class":"col"},"data":data}))
    + "\n\n      "
    + alias2((helpers.input || (depth0 && depth0.input) || alias1).call(depth0,depth0,"radio","type-one-way",(depth0 != null ? depth0.isOneWay : depth0),{"name":"input","hash":{"ia-value":"oneway","ia-name":"flight-type","wizard-action":"{\"flighttype\" : \"$value1\", \"packages.hotel\":false, \"packages.car\":false, \"packages.flight\": false}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightOnewayLabel : stack1),"class":"col"},"data":data}))
    + "\n\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasMultiDestFlight : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.isFlightOnly : depth0),{"name":"unless","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n</fieldset>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/hotels-room-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<div class=\"cols-row hotel-room room-count-"
    + alias3(((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"number","hash":{},"data":data}) : helper)))
    + " total-children-"
    + alias3(this.lambda(((stack1 = (depth0 != null ? depth0.ages : depth0)) != null ? stack1.length : stack1), depth0))
    + "\" id="
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + " data-number=\""
    + alias3(((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"number","hash":{},"data":data}) : helper)))
    + "\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.ownerId || (depth0 != null ? depth0.ownerId : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"ownerId","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\">\n    <fieldset class=\"occupants-select\">\n    <legend class=\"room-count-legend\">"
    + alias3(((helper = (helper = helpers.label || (depth0 != null ? depth0.label : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"label","hash":{},"data":data}) : helper)))
    + "</legend>\n"
    + ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],(depth0 != null ? depth0.hotelAdultCountOptions : depth0),{"name":"corewizard/components/select-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],(depth0 != null ? depth0.hotelChildCountOptions : depth0),{"name":"corewizard/components/select-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "  </fieldset>\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-children-fieldset-hbs'],depth0,{"name":"corewizard/field-groups/hotels-children-fieldset-hbs","data":data,"indent":"  ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "</div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.rooms : depth0),{"name":"each","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/package-price-savings", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showFlightHotelPackageUpsell : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.program(5, data, 0),"data":data})) != null ? stack1 : "");
},"2":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "            <p class=\"fh\">\n                <strong>"
    + alias1(((helper = (helper = helpers.fhMessage1Formatted || (depth0 != null ? depth0.fhMessage1Formatted : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"fhMessage1Formatted","hash":{},"data":data}) : helper)))
    + "</strong>\n                <br />\n                "
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.fhMessage2 : stack1), depth0))
    + "\n            </p>\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showPackageSavingsDisclaimer : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"3":function(depth0,helpers,partials,data) {
    var stack1;

  return "                <p class=\"fh package-val-prop-disclaimer\">"
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.disclaimer : stack1), depth0))
    + "</p>\n";
},"5":function(depth0,helpers,partials,data) {
    var stack1;

  return "            <p class=\"nonfh single-line-val-prop\" id=\"single-line-val-prop\">\n                <strong>"
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.nonfhMessage : stack1), depth0))
    + "</strong>\n            </p>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<div id=\"fh-msg-tooltip\" class=\"sub-600 package-val-prop\">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showPackageValueMessage : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/open-search-hbs", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/title-hbs'],depth0,{"name":"corewizard/fields/title-hbs","data":data,"helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + " <section class=\"tab-pane on\" id=\"tab-openSearch\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/error-messages-hbs'],depth0,{"name":"corewizard/field-groups/error-messages-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "    <fieldset class=\"cols-nested destination-only\">\n        "
    + this.escapeExpression((helpers['input-TA'] || (depth0 && depth0['input-TA']) || helpers.helperMissing).call(depth0,depth0,"searchQuery",{"name":"input-TA","hash":{"label-show":(depth0 != null ? depth0.isSearchQueryValueEmpty : depth0),"openSearch":true,"ia-data-lob":"OPENSEARCH","ta-key":"openSearch","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.openSearchLabel : stack1),"ia-value":(depth0 != null ? depth0.searchQuery : depth0),"has-error":(depth0 != null ? depth0.openSearchError : depth0),"wizard-action":"{\"searchQuery\" : \"$value1\"}"},"data":data}))
    + "\n    </fieldset>\n </section>\n";
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/rail-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return "    <fieldset class=\"cols-nested\">\n        "
    + this.escapeExpression((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || helpers.helperMissing).call(depth0,depth0,"returning",{"name":"input-calendar","hash":{"ia-aria-required":"true","ia-value":(depth0 != null ? depth0.endDate : depth0),"has-error":(depth0 != null ? depth0.endDateError : depth0),"wizard-action":"{\"endDate\" : \"$value1\"}","label-text":((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.rail : stack1)) != null ? stack1.returningLabel : stack1)},"data":data}))
    + "\n\n"
    + ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],(depth0 != null ? depth0.returningSearchBy : depth0),{"name":"corewizard/components/select-hbs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],(depth0 != null ? depth0.returningTimeOptions : depth0),{"name":"corewizard/components/select-hbs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n    </fieldset>\n";
},"3":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "            <fieldset id=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-children\" class=\"cols-nested children-fieldset\">\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.railChildAges : depth0),{"name":"each","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "            </fieldset>\n";
},"4":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],depth0,{"name":"corewizard/components/select-hbs","data":data,"indent":"                    ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"6":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "            <fieldset id=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-youth\" class=\"cols-nested youths-fieldset\">\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.railYouthAges : depth0),{"name":"each","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "            </fieldset>\n";
},"8":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "            <fieldset id=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-senior\" class=\"cols-nested seniors-fieldset\">\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.railSeniorAges : depth0),{"name":"each","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "            </fieldset>\n";
},"10":function(depth0,helpers,partials,data) {
    var stack1;

  return " "
    + ((stack1 = this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.rail : stack1)) != null ? stack1.railCard : stack1), depth0)) != null ? stack1 : "");
},"12":function(depth0,helpers,partials,data) {
    var stack1;

  return " "
    + ((stack1 = this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.rail : stack1)) != null ? stack1.railCardPlural : stack1), depth0)) != null ? stack1 : "")
    + " ";
},"14":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper;

  return "            <fieldset id=\"railcards-list-fieldset-"
    + this.escapeExpression(((helper = (helper = helpers.index || (data && data.index)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" class=\"cols-nested\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],(depth0 != null ? depth0.type : depth0),{"name":"corewizard/components/select-hbs","data":data,"indent":"                ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],(depth0 != null ? depth0.count : depth0),{"name":"corewizard/components/select-hbs","data":data,"indent":"                ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depths[1] != null ? depths[1].showRemoveButton : depths[1]),{"name":"if","hash":{},"fn":this.program(15, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "            </fieldset>\n";
},"15":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.lambda;

  return "                    <a  href=\"#railcards-list-fieldset\"\n                        role=\"button\"\n                        id=\"remove-rail-card-"
    + this.escapeExpression(((helper = (helper = helpers.index || (data && data.index)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\"\n                        aria-controls=\"advanced-options-fields\"\n                        data-wizard-action='"
    + ((stack1 = alias1((depth0 != null ? depth0.remove : depth0), depth0)) != null ? stack1 : "")
    + "'\n                    > <span class=\"icon icon-remove-rail\" title=\""
    + ((stack1 = alias1((depth0 != null ? depth0.deleteCardLabel : depth0), depth0)) != null ? stack1 : "")
    + "\"></span><span class=\"alt\">"
    + ((stack1 = alias1((depth0 != null ? depth0.deleteCardLabel : depth0), depth0)) != null ? stack1 : "")
    + "</span></a>\n";
},"17":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.lambda;

  return "          <a  href=\"#railcards-fieldset\"\n              role=\"button\"\n              id=\"add-rail-card\"\n             class=\"link show-options toggle-trigger\"\n              aria-controls=\"advanced-options-fields\"\n              data-wizard-action='"
    + ((stack1 = ((helper = (helper = helpers.addRailCard || (depth0 != null ? depth0.addRailCard : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"addRailCard","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "'\n              data-redraw=\"true\"\n              aria-redraw=\"true\"\n         ><span aria-hidden=\"true\" title=\""
    + ((stack1 = alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.rail : stack1)) != null ? stack1.addCard : stack1), depth0)) != null ? stack1 : "")
    + "\"></span>"
    + ((stack1 = alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.rail : stack1)) != null ? stack1.addCard : stack1), depth0)) != null ? stack1 : "")
    + "</a>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<div id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/rail-type-hbs'],depth0,{"name":"corewizard/field-groups/rail-type-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n    <fieldset class=\"origin-destination typeahead-container cols-nested\">\n\n        "
    + alias3((helpers['input-TA'] || (depth0 && depth0['input-TA']) || alias1).call(depth0,depth0,"origin",{"name":"input-TA","hash":{"ia-aria-required":"true","ia-placeholder":((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.rail : stack1)) != null ? stack1.originPlaceholder : stack1),"ia-data-lob":"RAILS","ia-value":(depth0 != null ? depth0.trainOrigin : depth0),"ta-key":"rail_origin","has-error":(depth0 != null ? depth0.railsOriginErrors : depth0),"wizard-action":"{\"trainOrigin\" : \"$value1\"}","label-text":((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.rail : stack1)) != null ? stack1.originLabel : stack1),"id":(depth0 != null ? depth0.id : depth0)},"data":data}))
    + "\n\n        "
    + alias3((helpers['input-TA'] || (depth0 && depth0['input-TA']) || alias1).call(depth0,depth0,"destination",{"name":"input-TA","hash":{"ia-aria-required":"true","ia-placeholder":((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.rail : stack1)) != null ? stack1.destinationPlaceholder : stack1),"ia-data-lob":"RAILS","ia-value":(depth0 != null ? depth0.trainDestination : depth0),"ta-key":"rail_dest","has-error":(depth0 != null ? depth0.railsDestinationErrors : depth0),"wizard-action":"{\"trainDestination\" : \"$value1\"}","label-text":((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.rail : stack1)) != null ? stack1.destinationLabel : stack1)},"data":data}))
    + "\n\n    </fieldset>\n\n    <fieldset class=\"cols-nested\">\n        "
    + alias3((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || alias1).call(depth0,depth0,"departing",{"name":"input-calendar","hash":{"ia-aria-required":"true","ia-value":(depth0 != null ? depth0.startDate : depth0),"ia-data-tid":"rail-departing","ia-data-default-range-length":1,"ia-data-min-booking-length":(depth0 != null ? depth0.minTripLength : depth0),"ia-data-last-valid-date":(depth0 != null ? depth0.lastValidDate : depth0),"ia-data-max-booking-length":(depth0 != null ? depth0.maxTripLength : depth0),"has-error":(depth0 != null ? depth0.startDateError : depth0),"wizard-action":"{\"startDate\" : \"$value1\"}","label-text":((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.rail : stack1)) != null ? stack1.departureLabel : stack1)},"data":data}))
    + "\n\n"
    + ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],(depth0 != null ? depth0.departingSearchBy : depth0),{"name":"corewizard/components/select-hbs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],(depth0 != null ? depth0.departureTimeOptions : depth0),{"name":"corewizard/components/select-hbs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "    </fieldset>\n\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isRoundtrip : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n    <fieldset class=\"cols-nested\">\n        <div class=\"col\">\n            <fieldset class=\"cols-nested\">\n                <div id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-passengers\" >\n"
    + ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],(depth0 != null ? depth0.railAdults : depth0),{"name":"corewizard/components/select-hbs","data":data,"indent":"                    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],(depth0 != null ? depth0.railChildren : depth0),{"name":"corewizard/components/select-hbs","data":data,"indent":"                    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],(depth0 != null ? depth0.railYouth : depth0),{"name":"corewizard/components/select-hbs","data":data,"indent":"                    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],(depth0 != null ? depth0.railSenior : depth0),{"name":"corewizard/components/select-hbs","data":data,"indent":"                    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "                </div>\n            </fieldset>\n\n"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = ((stack1 = (depth0 != null ? depth0.rooms : depth0)) != null ? stack1['0'] : stack1)) != null ? stack1.childCount : stack1),{"name":"if","hash":{},"fn":this.program(3, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = ((stack1 = (depth0 != null ? depth0.rooms : depth0)) != null ? stack1['0'] : stack1)) != null ? stack1.youthCount : stack1),{"name":"if","hash":{},"fn":this.program(6, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = ((stack1 = (depth0 != null ? depth0.rooms : depth0)) != null ? stack1['0'] : stack1)) != null ? stack1.seniorCount : stack1),{"name":"if","hash":{},"fn":this.program(8, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n        </div>\n    </fieldset>\n\n    <fieldset id=\"addrailcards-fieldset\" class=\"cols-nested\">\n        <div class=\"col\">\n        <span id=\"railcards-label\" class=\"label\">\n            "
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.railCardsOptions : depth0),{"name":"unless","hash":{},"fn":this.program(10, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n            "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.railCardsOptions : depth0),{"name":"if","hash":{},"fn":this.program(12, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n        </span>\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.railCardsOptions : depth0),{"name":"each","hash":{},"fn":this.program(14, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showAddRailCardLink : depth0),{"name":"if","hash":{},"fn":this.program(17, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n        </div>\n    </fieldset>\n</div>\n";
},"usePartial":true,"useData":true,"useDepths":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/rail-type-hbs", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, alias1=helpers.helperMissing, alias2=this.escapeExpression;

  return "<fieldset class=\"radio-set\">\n   <legend class=\"visuallyhidden\">Train type - changes form below</legend>\n      "
    + alias2((helpers.input || (depth0 && depth0.input) || alias1).call(depth0,depth0,"radio","type-one-way",(depth0 != null ? depth0.isOneWay : depth0),{"name":"input","hash":{"ia-value":"oneway","ia-name":"rail-type","wizard-action":"{\"rail.type\" : \"$value1\"}","label-text":((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.rail : stack1)) != null ? stack1.oneWayLabel : stack1),"class":"col"},"data":data}))
    + "\n\n      "
    + alias2((helpers.input || (depth0 && depth0.input) || alias1).call(depth0,depth0,"radio","type-roundtrip",(depth0 != null ? depth0.isRoundtrip : depth0),{"name":"input","hash":{"ia-value":"roundtrip","ia-name":"rail-type","wizard-action":"{\"rail.type\" : \"$value1\"}","label-text":((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.rail : stack1)) != null ? stack1.roundTripLabel : stack1),"class":"col"},"data":data}))
    + "\n</fieldset>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/cars-hotels-hbs", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda, alias2=this.escapeExpression;

  return ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],(depth0 != null ? depth0.hotelRoomCountOptions : depth0),{"name":"corewizard/components/select-hbs","data":data,"helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "<div class=\"rooms-container stacked-rooms total-rooms-"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.rooms : depth0)) != null ? stack1.length : stack1), depth0))
    + " total-room-1-children-"
    + alias2(alias1(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? depth0.rooms : depth0)) != null ? stack1['0'] : stack1)) != null ? stack1.ages : stack1)) != null ? stack1.length : stack1), depth0))
    + "\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-rooms-container-hbs'],depth0,{"name":"corewizard/field-groups/hotels-rooms-container-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "</div>";
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/cars-hotels-package-hbs", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"package-container-text\">\n    <p>"
    + this.escapeExpression(this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carOptionsLoc : stack1)) != null ? stack1.carAddMessage : stack1), depth0))
    + "</p>\n</div>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/fields/cars-rental-company", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "	<option value=\"\">No Preference</option>\n	<option value=\"AC\">ACE Rent A Car</option>\n	<option value=\"AD\">Advantage Rent-A-Car</option>\n	<option value=\"AL\">Alamo Rent A Car</option>\n	<option value=\"ZI\">Avis</option>\n	<option value=\"ZD\">Budget</option>\n	<option value=\"ZR\">Dollar Rent A Car</option>\n	<option value=\"EY\">Economy Rent a Car</option>\n	<option value=\"ET\">Enterprise</option>\n	<option value=\"EP\">Europcar</option>\n	<option value=\"FX\">Fox Rental Cars</option>\n	<option value=\"ZE\">Hertz</option>\n	<option value=\"MW\">Midway Car Rental</option>\n	<option value=\"ZL\">National Car Rental</option>\n	<option value=\"NU\">N&#252; Car</option>\n	<option value=\"ZA\">Payless</option>\n	<option value=\"SX\">Sixt</option>\n	<option value=\"ZT\">Thrifty Car Rental</option>\n	<option value=\"SV\">U-Save</option>\n";
},"3":function(depth0,helpers,partials,data) {
    return "	<option value=\"\">-- Select from the list --</option>\n	<option value=\"ZI\">Avis</option>\n	<option value=\"ZD\">Budget</option>\n	<option value=\"ZR\">Dollar Rent A Car</option>\n	<option value=\"ET\">Enterprise</option>\n	<option value=\"EP\">Europcar</option>\n	<option value=\"ZE\">Hertz</option>\n	<option value=\"ZA\">Payless</option>\n	<option value=\"ZT\">Thrifty Car Rental</option>\n	<option value=\"AC\">ACE Rent A Car</option>\n	<option value=\"AD\">Advantage Rent-A-Car</option>\n	<option value=\"AL\">Alamo Rent A Car</option>\n	<option value=\"EY\">Economy Rent a Car</option>\n	<option value=\"ZL\">National Car Rental</option>\n	<option value=\"NU\">N&#252; Car</option>\n	<option value=\"SX\">Sixt</option>\n";
},"5":function(depth0,helpers,partials,data) {
    return "	<option value=\"\">-- Select from the list --</option>\n	<option value=\"ZI\">Avis</option>\n	<option value=\"ZD\">Budget</option>\n	<option value=\"ZR\">Dollar Rent A Car</option>\n	<option value=\"ET\">Enterprise</option>\n	<option value=\"EP\">Europcar</option>\n	<option value=\"ZE\">Hertz</option>\n	<option value=\"ZA\">Payless</option>\n	<option value=\"ZT\">Thrifty Car Rental</option>\n	<option value=\"AC\">ACE Rent A Car</option>\n	<option value=\"AD\">Advantage Rent-A-Car</option>\n	<option value=\"AL\">Alamo Rent A Car</option>\n	<option value=\"EY\">Economy Rent a Car</option>\n	<option value=\"FX\">Fox Rental Cars</option>\n	<option value=\"ZL\">National Car Rental</option>\n	<option value=\"NU\">N&#252; Car</option>\n	<option value=\"SX\">Sixt</option>\n	<option value=\"SV\">U-Save</option>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.allVendors : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.corporateVendors : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.specialVendors : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/fields/flights-departing-hbs", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return this.escapeExpression((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || helpers.helperMissing).call(depth0,depth0,"departing",{"name":"input-calendar","hash":{"label-show":(depth0 != null ? depth0.isStartDateValueEmpty : depth0),"ia-aria-required":"true","ia-value":(depth0 != null ? depth0.startDate : depth0),"ia-data-tid":"flight-departing","ia-data-default-range-length":1,"ia-data-min-range-length":(depth0 != null ? depth0.minTripLength : depth0),"ia-data-min-booking-length":(depth0 != null ? depth0.minTripLength : depth0),"ia-data-last-valid-date":(depth0 != null ? depth0.lastValidDate : depth0),"ia-data-max-range-length":(depth0 != null ? depth0.maxTripLength : depth0),"ia-data-max-booking-length":(depth0 != null ? depth0.maxTripLength : depth0),"has-error":(depth0 != null ? depth0.startDateError : depth0),"wizard-action":"{\"startDate\" : \"$value1\"}","label-text":(depth0 != null ? depth0.flightDepartingLabel : depth0)},"data":data}))
    + "\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/fields/flights-returning-hbs", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return this.escapeExpression((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || helpers.helperMissing).call(depth0,depth0,"returning",{"name":"input-calendar","hash":{"label-show":(depth0 != null ? depth0.isEndDateValueEmpty : depth0),"ia-aria-required":"true","ia-value":(depth0 != null ? depth0.endDate : depth0),"has-error":(depth0 != null ? depth0.endDateError : depth0),"wizard-action":"{\"endDate\" : \"$value1\"}","label-text":(depth0 != null ? depth0.flightReturningLabel : depth0)},"data":data}))
    + "\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/fields/title-hbs", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var helper;

  return "<h2 class=\"sub-600\">"
    + this.escapeExpression(((helper = (helper = helpers.getTitle || (depth0 != null ? depth0.getTitle : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"getTitle","hash":{},"data":data}) : helper)))
    + "</h2>";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/fields/flights-destination-hbs", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return this.escapeExpression((helpers['input-TA'] || (depth0 && depth0['input-TA']) || helpers.helperMissing).call(depth0,depth0,"destination",{"name":"input-TA","hash":{"label-show":(depth0 != null ? depth0.isDestinationValueEmpty : depth0),"ia-aria-required":"true","ia-placeholder":(depth0 != null ? depth0.flightDestinationPlaceholderText : depth0),"ia-data-lob":"FLIGHTS","ia-value":(depth0 != null ? depth0.destination : depth0),"ta-key":"flight_dest","has-error":(depth0 != null ? depth0.destinationError : depth0),"wizard-action":"{\"destination\" : \"$value1\"}","label-text":(depth0 != null ? depth0.flightDestinationLabel : depth0)},"data":data}))
    + "\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/fields/packages-destination-hbs", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return this.escapeExpression((helpers['input-TA'] || (depth0 && depth0['input-TA']) || helpers.helperMissing).call(depth0,depth0,"destination",{"name":"input-TA","hash":{"label-show":(depth0 != null ? depth0.isDestinationValueEmpty : depth0),"ia-aria-required":"true","ia-placeholder":(depth0 != null ? depth0.flightDestinationPlaceholderText : depth0),"ia-data-lob":"PACKAGES","ia-value":(depth0 != null ? depth0.destination : depth0),"ta-key":(depth0 != null ? depth0.taDataKeyDest : depth0),"has-error":(depth0 != null ? depth0.destinationError : depth0),"wizard-action":"{\"destination\" : \"$value1\"}","label-text":(depth0 != null ? depth0.flightDestinationLabel : depth0)},"data":data}))
    + "\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/fields/hotel-car-destination-hbs", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return this.escapeExpression((helpers['input-TA'] || (depth0 && depth0['input-TA']) || helpers.helperMissing).call(depth0,depth0,"destination",{"name":"input-TA","hash":{"ia-aria-required":"true","ia-value":(depth0 != null ? depth0.destination : depth0),"ia-placeholder":((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.hotelDestination : stack1)) != null ? stack1.placeholderText : stack1),"ia-data-lob":"HOTELS","label-text":((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.hotelDestination : stack1)) != null ? stack1.label : stack1),"ta-key":"package_hotel_car","has-error":(depth0 != null ? depth0.destinationError : depth0),"wizard-action":"{\"destination\":\"$value1\"}"},"data":data}));
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/fields/nonstop-flight-hbs", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return this.escapeExpression((helpers.input || (depth0 && depth0.input) || helpers.helperMissing).call(depth0,depth0,"checkbox","advanced-flight-nonstop",(depth0 != null ? depth0.nonStop : depth0),{"name":"input","hash":{"wizard-action":"{\"nonStop\" : $value1}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightNonStopLabel : stack1),"id":"advanced-flight-nonstop"},"data":data}))
    + "\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/fields/flights-origin-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "  "
    + this.escapeExpression((helpers.assign || (depth0 && depth0.assign) || helpers.helperMissing).call(depth0,depth0,"id","=","hotel-flight",{"name":"assign","hash":{},"data":data}))
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isHotelTab : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + this.escapeExpression((helpers['input-TA'] || (depth0 && depth0['input-TA']) || helpers.helperMissing).call(depth0,depth0,"origin",{"name":"input-TA","hash":{"label-show":(depth0 != null ? depth0.isOriginValueEmpty : depth0),"ia-aria-required":"true","ia-placeholder":(depth0 != null ? depth0.flightOriginPlaceholderText : depth0),"ia-data-lob":"FLIGHTS","ia-value":(depth0 != null ? depth0.origin : depth0),"ta-key":"flight_origin","has-error":(depth0 != null ? depth0.originError : depth0),"wizard-action":"{\"origin\" : \"$value1\"}","label-text":(depth0 != null ? depth0.flightOriginLabel : depth0),"id":(depth0 != null ? depth0.id : depth0)},"data":data}))
    + "\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/fields/packages-origin-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "  "
    + this.escapeExpression((helpers.assign || (depth0 && depth0.assign) || helpers.helperMissing).call(depth0,depth0,"id","=","hotel-flight",{"name":"assign","hash":{},"data":data}))
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isHotelTab : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + this.escapeExpression((helpers['input-TA'] || (depth0 && depth0['input-TA']) || helpers.helperMissing).call(depth0,depth0,"origin",{"name":"input-TA","hash":{"label-show":(depth0 != null ? depth0.isOriginValueEmpty : depth0),"ia-aria-required":"true","ia-placeholder":(depth0 != null ? depth0.flightOriginPlaceholderText : depth0),"ia-data-lob":"PACKAGES","ia-value":(depth0 != null ? depth0.origin : depth0),"ta-key":(depth0 != null ? depth0.taDataKeyOrig : depth0),"has-error":(depth0 != null ? depth0.originError : depth0),"wizard-action":"{\"origin\" : \"$value1\"}","label-text":(depth0 != null ? depth0.flightOriginLabel : depth0),"id":(depth0 != null ? depth0.id : depth0)},"data":data}))
    + "\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/fields/hotel-destination-hbs", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return this.escapeExpression((helpers['input-TA'] || (depth0 && depth0['input-TA']) || helpers.helperMissing).call(depth0,depth0,"destination",{"name":"input-TA","hash":{"label-show":(depth0 != null ? depth0.isDestinationValueEmpty : depth0),"ia-aria-required":"true","ia-value":(depth0 != null ? depth0.destination : depth0),"ia-placeholder":(depth0 != null ? depth0.hotelDestinationPlaceholderText : depth0),"ia-data-lob":"HOTELS","label-text":(depth0 != null ? depth0.hotelDestinationLabel : depth0),"ta-key":"hotel","has-error":(depth0 != null ? depth0.destinationError : depth0),"wizard-action":"{\"destination\":\"$value1\"}"},"data":data}))
    + "\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/fields/package-radio-buttons-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "\n    "
    + this.escapeExpression((helpers.input || (depth0 && depth0.input) || helpers.helperMissing).call(depth0,depth0,"radio","package",(depth0 != null ? depth0.isCurrentPackageType : depth0),{"name":"input","hash":{"ia-data-tracking":"packageLob","ia-value":(depth0 != null ? depth0.value : depth0),"ia-name":"package-lob","label-text":(depth0 != null ? depth0.label : depth0),"class":"col","wizard-action":"{\"packages.flight\" : $value1, \"packages.hotel\" : $value2, \"packages.car\" : $value3, \"packages.train\" : $value4}"},"data":data}))
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<fieldset class=\"radio-set tablet-only\">"
    + ((stack1 = helpers.each.call(depth0,((stack1 = (depth0 != null ? depth0.packageData : depth0)) != null ? stack1.lobs : stack1),{"name":"each","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</fieldset>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/fields/refundable-flight-hbs", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return this.escapeExpression((helpers.input || (depth0 && depth0.input) || helpers.helperMissing).call(depth0,depth0,"checkbox","advanced-flight-refundable",(depth0 != null ? depth0.noPenalty : depth0),{"name":"input","hash":{"wizard-action":"{\"noPenalty\" : $value1}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightRefundableLabel : stack1),"id":"advanced-flight"},"data":data}))
    + "\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/fields/sub-tabs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "\n  "
    + this.escapeExpression((helpers.input || (depth0 && depth0.input) || helpers.helperMissing).call(depth0,depth0,"radio",(depth0 != null ? depth0.id : depth0),(depth0 != null ? depth0.selected : depth0),{"name":"input","hash":{"ia-data-tracking":(depth0 != null ? depth0.tracking : depth0),"ia-value":(depth0 != null ? depth0.value : depth0),"ia-name":(depth0 != null ? depth0.name : depth0),"label-text":(depth0 != null ? depth0.label : depth0),"class":"col","wizard-action":(depth0 != null ? depth0.action : depth0)},"data":data}))
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<fieldset class=\"radio-set tablet-only\">"
    + ((stack1 = helpers.each.call(depth0,((stack1 = (depth0 != null ? depth0.subTab : depth0)) != null ? stack1.lobs : stack1),{"name":"each","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</fieldset>";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/fields/cruise-dates-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var alias1=helpers.helperMissing, alias2=this.escapeExpression;

  return "\n"
    + alias2((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || alias1).call(depth0,depth0,"checkin",{"name":"input-calendar","hash":{"black-out-json":(depth0 != null ? depth0.backOutJson : depth0),"ia-value":"","ia-data-default-range-length":1,"has-error":false,"wizard-action":"{\"startDate\":\"$value1\"}","class":"check-in-out","label-text":"Start Date"},"data":data}))
    + "\n\n"
    + alias2((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || alias1).call(depth0,depth0,"checkout",{"name":"input-calendar","hash":{"black-out-json":(depth0 != null ? depth0.backOutJson : depth0),"ia-value":"","has-error":false,"wizard-action":"{\"endDate\":\"$value1\"}","class":"check-in-out","label-text":"End Date"},"data":data}))
    + "\n\n\n";
},"3":function(depth0,helpers,partials,data) {
    var alias1=helpers.helperMissing, alias2=this.escapeExpression;

  return "\n"
    + alias2((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || alias1).call(depth0,depth0,"checkin",{"name":"input-calendar","hash":{"ia-data-default-range-length":1,"ia-value":"","has-error":false,"wizard-action":"{\"startDate\":\"$value1\"}","class":"check-in-out","label-text":"Start Date"},"data":data}))
    + "\n\n"
    + alias2((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || alias1).call(depth0,depth0,"checkout",{"name":"input-calendar","hash":{"ia-value":"","has-error":false,"wizard-action":"{\"endDate\":\"$value1\"}","class":"check-in-out","label-text":"End Date"},"data":data}))
    + "\n\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.datePickerEnabled : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(3, data, 0),"data":data})) != null ? stack1 : "");
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/fields/cruise-month-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.cruiseDepartureMonthOptions : depth0),{"name":"each","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"2":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "                <option value=\""
    + alias3(((helper = (helper = helpers.value || (depth0 != null ? depth0.value : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"value","hash":{},"data":data}) : helper)))
    + "\">"
    + alias3(((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"name","hash":{},"data":data}) : helper)))
    + "</option>\n";
},"4":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.months : depth0),{"name":"each","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"5":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "                <option value=\""
    + alias3(((helper = (helper = helpers.value || (depth0 != null ? depth0.value : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"value","hash":{},"data":data}) : helper)))
    + "\">"
    + alias3(((helper = (helper = helpers.display || (depth0 != null ? depth0.display : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"display","hash":{},"data":data}) : helper)))
    + "</option>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "<label class=\"search-type select col icon icon-toggle180\" id=\"cruise-departure-month-label\">\n    <span class=\"label\">"
    + alias1(this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.cruise : stack1)) != null ? stack1.departureMonthLabel : stack1), depth0))
    + "</span>\n    <select id=\"cruise-departure-month\" data-wizard-action='{\"cruiseMonth\" : \"$value1\"}' name=\"select\" data-select-value=\""
    + alias1(((helper = (helper = helpers.cruiseMonth || (depth0 != null ? depth0.cruiseMonth : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"cruiseMonth","hash":{},"data":data}) : helper)))
    + "\" data-wizard-owner=\"departure-month\">\n"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.cruiseDepartureMonthOptions : depth0)) != null ? stack1['1'] : stack1),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(4, data, 0),"data":data})) != null ? stack1 : "")
    + "    </select>\n</label>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/layouts/flight-passenger", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-passengers-hbs'],depth0,{"name":"corewizard/field-groups/flights-passengers-hbs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<fieldset class=\"cols-nested\">\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.hidePassengerInfo : depth0),{"name":"unless","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</fieldset>\n";
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/layouts/wizard-hbs-cars", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "<section class=\"tab-car geolocation-enabled tab-pane on\" id=\"tab-car\">\n";
},"3":function(depth0,helpers,partials,data) {
    return "<section class=\"tab-car tab-pane on\" id=\"tab-car\">\n";
},"5":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "  <div id=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isMultipleCarOrder : depth0),{"name":"if","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showRentalCars : depth0),{"name":"if","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showAirportRides : depth0),{"name":"if","hash":{},"fn":this.program(10, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    </div>\n";
},"6":function(depth0,helpers,partials,data) {
    var stack1;

  return "\n"
    + ((stack1 = this.invokePartial(partials['corewizard/fields/sub-tabs'],depth0,{"name":"corewizard/fields/sub-tabs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n";
},"8":function(depth0,helpers,partials,data) {
    return "        <div>Content FROM showRentalCars</div>\n";
},"10":function(depth0,helpers,partials,data) {
    return "          <div>Content FROM airportRides</div>\n";
},"12":function(depth0,helpers,partials,data) {
    return " invalid";
},"14":function(depth0,helpers,partials,data) {
    return " class=\"error\"";
},"16":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "  	            <option value=\""
    + alias3(((helper = (helper = helpers.value || (depth0 != null ? depth0.value : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"value","hash":{},"data":data}) : helper)))
    + "\">"
    + alias3(((helper = (helper = helpers.key || (depth0 != null ? depth0.key : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"key","hash":{},"data":data}) : helper)))
    + "</option>\n";
},"18":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/cars-driver-age-hbs'],depth0,{"name":"corewizard/field-groups/cars-driver-age-hbs","data":data,"indent":"      ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"20":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return "      <a\n        id=\"car-options-toggle\"\n        data-wizard-action='{\"showCarOptions\" : "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showCarOptions : depth0),{"name":"if","hash":{},"fn":this.program(21, data, 0, blockParams, depths),"inverse":this.program(23, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + " }'\n        class=\"link show-options toggle-trigger "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showCarOptions : depth0),{"name":"if","hash":{},"fn":this.program(25, data, 0, blockParams, depths),"inverse":this.program(27, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "\"\n        href=\"#car-options\"\n        role=\"button\"\n        aria-controls=\"advanced-options-fields\"\n        aria-expanded=\""
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showCarOptions : depth0),{"name":"if","hash":{},"fn":this.program(23, data, 0, blockParams, depths),"inverse":this.program(21, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "\"\n        aria-pressed=\""
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showCarOptions : depth0),{"name":"if","hash":{},"fn":this.program(23, data, 0, blockParams, depths),"inverse":this.program(21, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "\"\n      >\n        "
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carShowOptionsLabel : stack1), depth0))
    + "<span class=\"icon icon-expand\"></span>\n      </a>\n\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showCarOptions : depth0),{"name":"if","hash":{},"fn":this.program(29, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"21":function(depth0,helpers,partials,data) {
    return "false";
},"23":function(depth0,helpers,partials,data) {
    return "true";
},"25":function(depth0,helpers,partials,data) {
    return "open";
},"27":function(depth0,helpers,partials,data) {
    return "viewed";
},"29":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return "        <div id=\"car-options\">\n            <fieldset class=\"cols-nested from-to\">\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.carOptions : depth0),{"name":"each","hash":{},"fn":this.program(30, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "            </fieldset>\n\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showDiscountCodeFields : depth0),{"name":"if","hash":{},"fn":this.program(32, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n            <fieldset class=\"cols-nested equipment-options cf\">\n                <legend>"
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carSpecialEquipment : stack1), depth0))
    + "</legend>\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.specialEquipmentOptions : depth0),{"name":"each","hash":{},"fn":this.program(36, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "            </fieldset>\n        </div>\n";
},"30":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],depth0,{"name":"corewizard/components/select-hbs","data":data,"indent":"                    ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"32":function(depth0,helpers,partials,data) {
    var stack1;

  return "            <fieldset class=\"cols-nested origin-destination\">\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.carDiscountCodeOptions : depth0),{"name":"each","hash":{},"fn":this.program(33, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "            </fieldset>\n";
},"33":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0['show-car-discount-options'] : depth0),{"name":"if","hash":{},"fn":this.program(34, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"34":function(depth0,helpers,partials,data) {
    var alias1=this.lambda, alias2=this.escapeExpression;

  return "                <label class=\"text col\" id=\""
    + alias2(alias1((depth0 != null ? depth0.namespace : depth0), depth0))
    + "-label\">\n                    <span class=\"label\">"
    + alias2(alias1((depth0 != null ? depth0['label-text'] : depth0), depth0))
    + "</span>\n                    <input type=\"text\" id=\""
    + alias2(alias1((depth0 != null ? depth0.namespace : depth0), depth0))
    + "\" placeholder=\""
    + alias2(alias1((depth0 != null ? depth0.placeholder : depth0), depth0))
    + "\" data-wizard-action=\""
    + alias2(alias1((depth0 != null ? depth0.wizard_action : depth0), depth0))
    + "\" value=\""
    + alias2(alias1((depth0 != null ? depth0.value : depth0), depth0))
    + "\"/>\n                </label>\n";
},"36":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return "                <ul class=\"cols-nested col\" role=\"presentation\">\n"
    + ((stack1 = helpers.each.call(depth0,depth0,{"name":"each","hash":{},"fn":this.program(37, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "                </ul>\n";
},"37":function(depth0,helpers,partials,data,blockParams,depths) {
    return "                    <li role=\"presentation\">\n                        "
    + this.escapeExpression((helpers.input || (depth0 && depth0.input) || helpers.helperMissing).call(depth0,depths[2],"checkbox",(depth0 != null ? depth0.namespace : depth0),(depth0 != null ? depth0.isChecked : depth0),{"name":"input","hash":{"disabled":(depth0 != null ? depth0.disabled : depth0),"ia-data-tid":(depth0 != null ? depth0.namespace : depth0),"wizard_action":(depth0 != null ? depth0.wizard_action : depth0),"label-text":(depth0 != null ? depth0['label-text'] : depth0)},"data":data}))
    + "\n                    </li>\n";
},"39":function(depth0,helpers,partials,data) {
    return "hide-element";
},"41":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "            <fieldset>\n                <div class=\"package-container cf\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-added-hotel\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\"  tabindex=\"-1\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/cars-hotels-hbs'],depth0,{"name":"corewizard/field-groups/cars-hotels-hbs","data":data,"indent":"                    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "                </div>\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/cars-hotels-package-hbs'],depth0,{"name":"corewizard/field-groups/cars-hotels-package-hbs","data":data,"indent":"                ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "            </fieldset>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, options, alias1=helpers.helperMissing, alias2=this.escapeExpression, alias3="function", alias4=this.lambda, alias5=helpers.blockHelperMissing, buffer = 
  ((stack1 = this.invokePartial(partials['corewizard/fields/title-hbs'],depth0,{"name":"corewizard/fields/title-hbs","data":data,"helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isLocationSelectEnabled : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0, blockParams, depths),"inverse":this.program(3, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/error-messages-hbs'],depth0,{"name":"corewizard/field-groups/error-messages-hbs","data":data,"indent":"  ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isLXCarABTest : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/cars-location-hbs'],depth0,{"name":"corewizard/field-groups/cars-location-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n  <fieldset class=\"cols-nested pickup-dropoff\">\n\n              "
    + alias2((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || alias1).call(depth0,depth0,"pickup-date",{"name":"input-calendar","hash":{"label-show":(depth0 != null ? depth0.isStartDateValueEmpty : depth0),"ia-data-end-date":"&#35;car-dropoff-date-wrapper","ia-aria-required":"true","ia-value":(depth0 != null ? depth0.startDate : depth0),"ia-data-tid":"pickup-date-label","ia-data-default-range-length":1,"ia-data-min-range-length":(depth0 != null ? depth0.minTripLength : depth0),"ia-data-last-valid-date":(depth0 != null ? depth0.lastValidDate : depth0),"ia-data-max-range-length":(depth0 != null ? depth0.maxTripLength : depth0),"has-error":(depth0 != null ? depth0.startDateError : depth0),"wizard-action":"{\"startDate\" : \"$value1\"}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carPickupDateLabel : stack1)},"data":data}))
    + "\n\n  	<label class=\"search-type select col icon icon-toggle180"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.startTimeError : depth0),{"name":"if","hash":{},"fn":this.program(12, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\""
    + alias2(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias3 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-pickup-time-label\" >\n  	    <span class=\"label visuallyhidden\">"
    + alias2(alias4(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carPickupTimeLabel : stack1), depth0))
    + "</span>\n  	    <select name=\"select\" id=\""
    + alias2(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias3 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-pickup-time\""
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.startTimeError : depth0),{"name":"if","hash":{},"fn":this.program(14, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " data-wizard-action='{\"startTime\" : \"$value1\"}' data-select-value=\""
    + alias2(((helper = (helper = helpers.startTime || (depth0 != null ? depth0.startTime : depth0)) != null ? helper : alias1),(typeof helper === alias3 ? helper.call(depth0,{"name":"startTime","hash":{},"data":data}) : helper)))
    + "\">\n";
  stack1 = ((helper = (helper = helpers.timeValues || (depth0 != null ? depth0.timeValues : depth0)) != null ? helper : alias1),(options={"name":"timeValues","hash":{},"fn":this.program(16, data, 0, blockParams, depths),"inverse":this.noop,"data":data}),(typeof helper === alias3 ? helper.call(depth0,options) : helper));
  if (!helpers.timeValues) { stack1 = alias5.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  buffer += "  	    </select>\n  	</label>\n\n                "
    + alias2((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || alias1).call(depth0,depth0,"dropoff-date",{"name":"input-calendar","hash":{"label-show":(depth0 != null ? depth0.isEndDateValueEmpty : depth0),"ia-data-start-date":"&#35;car-pickup-date-wrapper","ia-aria-required":"true","ia-value":(depth0 != null ? depth0.endDate : depth0),"ia-data-tid":"dropoff-date-label","ia-data-min-range-length":(depth0 != null ? depth0.minTripLength : depth0),"ia-data-last-valid-date":(depth0 != null ? depth0.lastValidDate : depth0),"ia-data-max-range-length":(depth0 != null ? depth0.maxTripLength : depth0),"has-error":(depth0 != null ? depth0.endDateError : depth0),"wizard-action":"{\"endDate\" : \"$value1\"}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carDropoffDateLabel : stack1)},"data":data}))
    + "\n\n  	<label class=\"search-type select col icon icon-toggle180"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.endTimeError : depth0),{"name":"if","hash":{},"fn":this.program(12, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\""
    + alias2(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias3 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-dropoff-time-label\">\n  	    <span class=\"label visuallyhidden\">"
    + alias2(alias4(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carDropOffTimeLabel : stack1), depth0))
    + "</span>\n  	    <select name=\"select\" id=\""
    + alias2(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias3 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-dropoff-time\""
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.endTimeError : depth0),{"name":"if","hash":{},"fn":this.program(14, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " data-wizard-action='{\"endTime\" : \"$value1\"}' data-select-value=\""
    + alias2(((helper = (helper = helpers.endTime || (depth0 != null ? depth0.endTime : depth0)) != null ? helper : alias1),(typeof helper === alias3 ? helper.call(depth0,{"name":"endTime","hash":{},"data":data}) : helper)))
    + "\">\n";
  stack1 = ((helper = (helper = helpers.timeValues || (depth0 != null ? depth0.timeValues : depth0)) != null ? helper : alias1),(options={"name":"timeValues","hash":{},"fn":this.program(16, data, 0, blockParams, depths),"inverse":this.noop,"data":data}),(typeof helper === alias3 ? helper.call(depth0,options) : helper));
  if (!helpers.timeValues) { stack1 = alias5.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer + "  	    </select>\n  	</label>\n  </fieldset>\n\n    <!--Car Driver Age fieldset-->\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isCarDriverAgeEnabled : depth0),{"name":"if","hash":{},"fn":this.program(18, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.unless.call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.hotel : stack1),{"name":"unless","hash":{},"fn":this.program(20, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n    <div class=\""
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.addHotelsWithCar : depth0),{"name":"unless","hash":{},"fn":this.program(39, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " organic-package-checkboxes add-links cols-nested\">\n        "
    + ((stack1 = (helpers['soft-package'] || (depth0 && depth0['soft-package']) || alias1).call(depth0,{"name":"soft-package","hash":{"icon":"hotels","text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.addHotelLinkText : stack1),"checked":((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.hotel : stack1),"action":(depth0 != null ? depth0.addHotelAction : depth0),"lob":"hotel","type":"checkbox","id":(depth0 != null ? depth0.id : depth0)},"data":data})) != null ? stack1 : "")
    + "\n    </div>\n\n    <div class=\"package-wrapper\" id=\"hotel-package-wrapper\" tabindex=\"-1\">\n"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.hotel : stack1),{"name":"if","hash":{},"fn":this.program(41, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    </div>\n</section>\n";
},"usePartial":true,"useData":true,"useDepths":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/layouts/wizard-hbs-flights", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "soft-package-hotel";
},"3":function(depth0,helpers,partials,data) {
    return " soft-package-car";
},"5":function(depth0,helpers,partials,data) {
    var stack1;

  return "        <div class=\"organic-package-checkboxes add-links cols-nested\">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.allowFlightTabAddHotelOption : depth0),{"name":"if","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.allowFlightTabAddCarOption : depth0),{"name":"if","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "        </div>\n";
},"6":function(depth0,helpers,partials,data) {
    var stack1;

  return "            "
    + ((stack1 = (helpers['soft-package'] || (depth0 && depth0['soft-package']) || helpers.helperMissing).call(depth0,{"name":"soft-package","hash":{"icon":"hotels","text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.addHotelLinkText : stack1),"checked":((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.hotel : stack1),"action":(depth0 != null ? depth0.addHotelAction : depth0),"lob":"hotel","id":(depth0 != null ? depth0.id : depth0)},"data":data})) != null ? stack1 : "")
    + "\n";
},"8":function(depth0,helpers,partials,data) {
    var stack1;

  return "            "
    + ((stack1 = (helpers['soft-package'] || (depth0 && depth0['soft-package']) || helpers.helperMissing).call(depth0,{"name":"soft-package","hash":{"icon":"cars","text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.addCarLinkText : stack1),"checked":((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.car : stack1),"action":(depth0 != null ? depth0.addCarAction : depth0),"lob":"car","id":(depth0 != null ? depth0.id : depth0)},"data":data})) != null ? stack1 : "")
    + "\n";
},"10":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.hotel : stack1),{"name":"if","hash":{},"fn":this.program(11, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"11":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "      <div class=\"package-wrapper\" id=\"hotel-package-wrapper\" tabindex=\"-1\">\n        <div class=\"package-container cf\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-added-hotel\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\"  tabindex=\"-1\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-hbs'],depth0,{"name":"corewizard/field-groups/hotels-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "        </div>\n      </div>\n";
},"13":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.car : stack1),{"name":"if","hash":{},"fn":this.program(14, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"14":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "      <div class=\"package-wrapper\" id=\"car-package-wrapper\" tabindex=\"-1\">\n        <div class=\"package-container cf\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-added-car\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/cars-package-hbs'],depth0,{"name":"corewizard/field-groups/cars-package-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "        </div>\n      </div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/title-hbs'],depth0,{"name":"corewizard/fields/title-hbs","data":data,"helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n<section class=\"tab-pane on\" id=\"tab-flight\">\n<div id=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-tab\" class=\""
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.hotel : stack1),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.car : stack1),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\">\n\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/error-messages-hbs'],depth0,{"name":"corewizard/field-groups/error-messages-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-hbs'],depth0,{"name":"corewizard/field-groups/flights-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isRoundtrip : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.allowFlightTabAddHotelOption : depth0),{"name":"if","hash":{},"fn":this.program(10, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.allowFlightTabAddCarOption : depth0),{"name":"if","hash":{},"fn":this.program(13, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n</div>\n</section>\n";
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/layouts/wizard-hbs-misc", Handlebars.template({"1":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper;

  return "    <li role=\"presentation\" class=\"display-group-name\">"
    + this.escapeExpression(((helper = (helper = helpers.displayGroupName || (depth0 != null ? depth0.displayGroupName : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"displayGroupName","hash":{},"data":data}) : helper)))
    + "</li>\n    <div class=\"display-group-results\">\n"
    + ((stack1 = helpers.each.call(depth0,depth0,{"name":"each","hash":{},"fn":this.program(2, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    </div>\n";
},"2":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.index : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0, blockParams, depths),"inverse":this.program(8, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "");
},"3":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression, alias4=this.lambda;

  return "        <li role=\"presentation\" tabindex=\"-1\" data-tid=\"typeahead-item"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" class=\"results-item\">\n            <a role=\"option\" id=\"aria-option-"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\" data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\"\n                href=\"#\" class=\"details\" data-value=\""
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.lastSearchName : stack1), depth0))
    + "\"\n                data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\" data-multiFlightInputId='"
    + alias3(alias4((depths[3] != null ? depths[3].multiFlightInputId : depths[3]), depth0))
    + "'>\n                "
    + ((stack1 = (helpers.getShowAsHierarchyFlag || (depth0 && depth0.getShowAsHierarchyFlag) || alias1).call(depth0,depth0,((stack1 = (depth0 != null ? depth0.hierarchyInfo : depth0)) != null ? stack1.relation : stack1),{"name":"getShowAsHierarchyFlag","hash":{},"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showAsHierarchy : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0, blockParams, depths),"inverse":this.program(6, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "            </a>\n        </li>\n";
},"4":function(depth0,helpers,partials,data) {
    var stack1, alias1=helpers.helperMissing;

  return "                <div class=\"child-suggestion\">\n                    "
    + ((stack1 = (helpers.getChildSuggestionIcon || (depth0 && depth0.getChildSuggestionIcon) || alias1).call(depth0,(depth0 != null ? depth0.index : depth0),{"name":"getChildSuggestionIcon","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                    "
    + ((stack1 = this.lambda(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.displayName : stack1), depth0)) != null ? stack1 : "")
    + "\n                    "
    + ((stack1 = (helpers.showDistanceFromNearbyAirport || (depth0 && depth0.showDistanceFromNearbyAirport) || alias1).call(depth0,((stack1 = ((stack1 = (depth0 != null ? depth0.hierarchyInfo : depth0)) != null ? stack1.nearby : stack1)) != null ? stack1.distInMI : stack1),{"name":"showDistanceFromNearbyAirport","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                </div>\n";
},"6":function(depth0,helpers,partials,data) {
    var stack1;

  return "                    "
    + ((stack1 = (helpers.makeOption || (depth0 && depth0.makeOption) || helpers.helperMissing).call(depth0,(depth0 != null ? depth0.index : depth0),(depth0 != null ? depth0.icon : depth0),((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.displayName : stack1),(depth0 != null ? depth0.rightFloatingTextHtml : depth0),{"name":"makeOption","hash":{},"data":data})) != null ? stack1 : "")
    + "\n";
},"8":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "        <li role=\"presentation\" tabindex=\"-1\" data-tid=\"typeahead-item"
    + ((stack1 = (helpers.getItemCount || (depth0 && depth0.getItemCount) || alias1).call(depth0,(depth0 != null ? depth0.i : depth0),{"name":"getItemCount","hash":{},"data":data})) != null ? stack1 : "")
    + "\"\n            class=\"results-item\">\n            <a role=\"option\" id=\"aria-option-"
    + ((stack1 = (helpers.getItemCount || (depth0 && depth0.getItemCount) || alias1).call(depth0,(depth0 != null ? depth0.i : depth0),{"name":"getItemCount","hash":{},"data":data})) != null ? stack1 : "")
    + "\"\n                tabindex=\"-1\" data-tid=\"typeahead-link"
    + ((stack1 = (helpers.getItemCount || (depth0 && depth0.getItemCount) || alias1).call(depth0,(depth0 != null ? depth0.i : depth0),{"name":"getItemCount","hash":{},"data":data})) != null ? stack1 : "")
    + "\"\n                href=\"#\" class=\"details\" data-value=\""
    + alias3(((helper = (helper = helpers.l || (depth0 != null ? depth0.l : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"l","hash":{},"data":data}) : helper)))
    + "\" data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\"\n                data-multiFlightInputId='"
    + alias3(this.lambda((depths[3] != null ? depths[3].multiFlightInputId : depths[3]), depth0))
    + "'>\n                "
    + ((stack1 = (helpers.getShowAsHierarchyFlag || (depth0 && depth0.getShowAsHierarchyFlag) || alias1).call(depth0,depth0,(depth0 != null ? depth0.relation : depth0),{"name":"getShowAsHierarchyFlag","hash":{},"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showAsHierarchy : depth0),{"name":"if","hash":{},"fn":this.program(9, data, 0, blockParams, depths),"inverse":this.program(11, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "            </a>\n        </li>\n";
},"9":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing;

  return "                <div class=\"child-suggestion\">\n                    "
    + ((stack1 = (helpers.getChildSuggestionIcon || (depth0 && depth0.getChildSuggestionIcon) || alias1).call(depth0,(depth0 != null ? depth0.i : depth0),{"name":"getChildSuggestionIcon","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                    "
    + ((stack1 = ((helper = (helper = helpers.d || (depth0 != null ? depth0.d : depth0)) != null ? helper : alias1),(typeof helper === "function" ? helper.call(depth0,{"name":"d","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\n                    "
    + ((stack1 = (helpers.showDistanceFromNearbyAirport || (depth0 && depth0.showDistanceFromNearbyAirport) || alias1).call(depth0,(depth0 != null ? depth0.distInMI : depth0),{"name":"showDistanceFromNearbyAirport","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                </div>\n";
},"11":function(depth0,helpers,partials,data) {
    var stack1;

  return "                    "
    + ((stack1 = (helpers.makeOption || (depth0 && depth0.makeOption) || helpers.helperMissing).call(depth0,(depth0 != null ? depth0.i : depth0),(depth0 != null ? depth0.icon : depth0),(depth0 != null ? depth0.d : depth0),{"name":"makeOption","hash":{},"data":data})) != null ? stack1 : "")
    + "\n";
},"13":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "    <dt role=\"presentation\" data-tid=\"typeahead-category-"
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "\"\n        id=\"typeahead-category-"
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "\" class=\"category-name\">"
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "</dt>\n    <dd role=\"presentation\" class=\"category-results\">\n        <ul role=\"presentation\" class=\"results\">\n"
    + ((stack1 = helpers.each.call(depth0,depth0,{"name":"each","hash":{},"fn":this.program(14, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "        </ul>\n    </dd>\n";
},"14":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression, alias4=this.lambda;

  return "            <li role=\"presentation\" tabindex=\"-1\" data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" class=\"results-item\">\n                <a role=\"option\" aria-describedby=\"typeahead-category-"
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "\"\n                    id=\"aria-option-"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" href=\"#\"\n                    data-value=\""
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.fullName : stack1), depth0))
    + "\" data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\">\n                    <span data-tid=\"typeahead-icon"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" class=\"details\">"
    + ((stack1 = alias4(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.displayName : stack1), depth0)) != null ? stack1 : "")
    + "</span>\n                </a>\n            </li>\n";
},"16":function(depth0,helpers,partials,data) {
    var stack1;

  return "    <dd role=\"presentation\" class=\"category-results\">\n        <ul role=\"presentation\" class=\"results\">\n"
    + ((stack1 = helpers.each.call(depth0,depth0,{"name":"each","hash":{},"fn":this.program(17, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "        </ul>\n    </dd>\n";
},"17":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.index : depth0),{"name":"if","hash":{},"fn":this.program(18, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"18":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "            <li role=\"presentation\" tabindex=\"-1\" data-tid=\"typeahead-item"
    + this.escapeExpression(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" class=\"results-item\">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.gemma : depth0),{"name":"if","hash":{},"fn":this.program(19, data, 0),"inverse":this.program(21, data, 0),"data":data})) != null ? stack1 : "")
    + "            </li>\n";
},"19":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "                <a role=\"option\" id=\"aria-option-"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\"\n                    data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" href=\"#\" class=\"details\"\n                    data-value=\""
    + alias3(this.lambda(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.fullName : stack1), depth0))
    + "\" data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\">\n                    "
    + ((stack1 = (helpers.makeOptionGemmaSearch || (depth0 && depth0.makeOptionGemmaSearch) || alias1).call(depth0,(depth0 != null ? depth0.index : depth0),(depth0 != null ? depth0.icon : depth0),((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.fullName : stack1),{"name":"makeOptionGemmaSearch","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                </a>\n";
},"21":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.categoryName : depth0),{"name":"if","hash":{},"fn":this.program(22, data, 0),"inverse":this.program(24, data, 0),"data":data})) != null ? stack1 : "");
},"22":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "                <a role=\"option\" id=\"aria-option-"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\"\n                    data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" href=\"#\" class=\"details\"\n                    data-value=\""
    + alias3(this.lambda(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.lastSearchName : stack1), depth0))
    + " - "
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "\" data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\">\n                    "
    + ((stack1 = (helpers.makeOptionOpenSearch || (depth0 && depth0.makeOptionOpenSearch) || alias1).call(depth0,(depth0 != null ? depth0.index : depth0),(depth0 != null ? depth0.icon : depth0),((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.displayName : stack1),(depth0 != null ? depth0.categoryName : depth0),{"name":"makeOptionOpenSearch","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                </a>\n";
},"24":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "                <a role=\"option\" id=\"aria-option-"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\"\n                    data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" href=\"#\" class=\"details\"\n                    data-value=\""
    + alias3(this.lambda(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.lastSearchName : stack1), depth0))
    + "\" data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\">\n                    "
    + ((stack1 = (helpers.makeOption || (depth0 && depth0.makeOption) || alias1).call(depth0,(depth0 != null ? depth0.index : depth0),(depth0 != null ? depth0.icon : depth0),((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.displayName : stack1),{"name":"makeOption","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                </a>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<ul role=\"listbox\" data-tid=\"typeahead-list\" class=\"results\">\n\n"
    + ((stack1 = (helpers.each_with_key || (depth0 && depth0.each_with_key) || alias1).call(depth0,(depth0 != null ? depth0.resultsByDisplayGroup : depth0),{"name":"each_with_key","hash":{"key":"displayGroupName"},"fn":this.program(1, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n</ul>\n<footer data-tid=\"typeahead-footer\" class=\"footer\" role=\"application\">\n    <a id=\"typeahead-close\" data-tid=\"typeahead-close\" class=\"close\" href=\"#\">\n        "
    + alias3(((helper = (helper = helpers.closeText || (depth0 != null ? depth0.closeText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"closeText","hash":{},"data":data}) : helper)))
    + "<span class=\"icon icon-close\"></span>\n    </a>\n</footer>\n\n<dl role=\"presentation\" data-tid=\"typeahead-list-category\">\n\n"
    + ((stack1 = (helpers.each_with_key || (depth0 && depth0.each_with_key) || alias1).call(depth0,(depth0 != null ? depth0.resultsByCategory : depth0),{"name":"each_with_key","hash":{"key":"categoryName"},"fn":this.program(13, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n</dl>\n<footer data-tid=\"typeahead-footer\" class=\"footer\" role=\"application\">\n    <a class=\"close\" href=\"#\">\n        "
    + alias3(((helper = (helper = helpers.closeText || (depth0 != null ? depth0.closeText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"closeText","hash":{},"data":data}) : helper)))
    + "<span class=\"icon icon-close\"></span>\n    </a>\n</footer>\n\n<dl role=\"presentation\" data-tid=\"typeahead-list-category\">\n"
    + ((stack1 = (helpers.each_with_key || (depth0 && depth0.each_with_key) || alias1).call(depth0,(depth0 != null ? depth0.resultsByCategory : depth0),{"name":"each_with_key","hash":{"key":"categoryName"},"fn":this.program(16, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</dl>\n<footer data-tid=\"typeahead-footer\" class=\"footer\">\n    <a class=\"close\" href=\"#\">\n        "
    + alias3(((helper = (helper = helpers.closeText || (depth0 != null ? depth0.closeText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"closeText","hash":{},"data":data}) : helper)))
    + "<span class=\"icon icon-close\"></span>\n    </a>\n</footer>";
},"useData":true,"useDepths":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/layouts/rail-hbs", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/title-hbs'],depth0,{"name":"corewizard/fields/title-hbs","data":data,"helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n<section class=\"tab-pane on\" id=\"tab-rail\">\n    <div>\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/error-messages-hbs'],depth0,{"name":"corewizard/field-groups/error-messages-hbs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/rail-hbs'],depth0,{"name":"corewizard/field-groups/rail-hbs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "    </div>\n</section>";
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/layouts/wizard-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "ab11841_1";
},"3":function(depth0,helpers,partials,data) {
    return "ab11842_1";
},"5":function(depth0,helpers,partials,data) {
    return "ab11872_1";
},"7":function(depth0,helpers,partials,data) {
    return "ab11873_1";
},"9":function(depth0,helpers,partials,data) {
    return "ab11873_2";
},"11":function(depth0,helpers,partials,data) {
    return "ab6555_1";
},"13":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "        <h1 class=\"col wizard-title\">"
    + ((stack1 = ((helper = (helper = helpers.wizardTitle || (depth0 != null ? depth0.wizardTitle : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"wizardTitle","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</h1>\n";
},"15":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/includes/next-trip-hbs'],depth0,{"name":"corewizard/includes/next-trip-hbs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"17":function(depth0,helpers,partials,data) {
    var stack1;

  return "    <ul class=\"tabs cf col"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isTravelocity : depth0),{"name":"if","hash":{},"fn":this.program(18, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" role=\"tablist\" data-tid=\"wizard-tablist\">\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.lobs : depth0),{"name":"each","hash":{},"fn":this.program(20, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    </ul>\n";
},"18":function(depth0,helpers,partials,data) {
    return " tvly-wizard";
},"20":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/layouts/tab-hbs'],depth0,{"name":"corewizard/layouts/tab-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"22":function(depth0,helpers,partials,data) {
    var helper;

  return "        <span class='hotel-value-prop-tablet' id='hotel-tab-value-prop'>\n            <span>"
    + this.escapeExpression(((helper = (helper = helpers.hotelTabletValueProp || (depth0 != null ? depth0.hotelTabletValueProp : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"hotelTabletValueProp","hash":{},"data":data}) : helper)))
    + "</span>\n        </span>\n";
},"24":function(depth0,helpers,partials,data) {
    return " no-tabs";
},"26":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.switches : depth0)) != null ? stack1.packagePriceSavingsDollarValue : stack1),{"name":"if","hash":{},"fn":this.program(27, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"27":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/package-price-savings'],depth0,{"name":"corewizard/field-groups/package-price-savings","data":data,"indent":"                        ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"29":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['handlebars/wizard/promo-message'],depth0,{"name":"handlebars/wizard/promo-message","data":data,"indent":"                    ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"31":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/includes/bpg'],depth0,{"name":"corewizard/includes/bpg","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "<div id=\"wizard-container\" class=\""
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.ab11841 : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.ab11842 : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.ab11872 : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.ab11873_1 : depth0),{"name":"if","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.ab11873_2 : depth0),{"name":"if","hash":{},"fn":this.program(9, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\">\n    <div  class=\"cols-row search theme-inverse-pills "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.ab6555 : depth0),{"name":"if","hash":{},"fn":this.program(11, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\"wizard-theme-wrapper\" data-tid=\"region\">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.wizardTitle : depth0),{"name":"if","hash":{},"fn":this.program(13, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.displayNextTrip : stack1),{"name":"if","hash":{},"fn":this.program(15, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    <!-- tabs - pills -->\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showTabs : depth0),{"name":"if","hash":{},"fn":this.program(17, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    <!-- tabs -->\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showValueProp : depth0),{"name":"if","hash":{},"fn":this.program(22, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    <div class=\"col forms"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.showTabs : depth0),{"name":"unless","hash":{},"fn":this.program(24, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " tabs-container\" data-tid=\"tab-container\">\n        <form autocomplete=\"off\">\n            <div data-wizard-action=\"form-wrapper\">\n"
    + ((stack1 = this.invokePartial(helpers.lookup.call(depth0,depth0,"wizardTemplate",{"name":"lookup","hash":{},"data":data}),depth0,{"data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "            </div>\n            <fieldset class=\"cols submit-and-mixin-fieldset\">\n                <label class=\"col search-btn-col\">\n                    <button type=\"submit\" data-wizard-action=\"{submit:true}\" class=\"btn-action btn-primary\" id=\"search-button\" data-tid=\"search-button\">\n                        <span class=\"btn-label\">"
    + this.escapeExpression(((helper = (helper = helpers.searchText || (depth0 != null ? depth0.searchText : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"searchText","hash":{},"data":data}) : helper)))
    + "</span>\n                    </button>\n                </label>\n\n"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.switches : depth0)) != null ? stack1.usePackageValuePropMessage : stack1),{"name":"if","hash":{},"fn":this.program(26, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.switches : depth0)) != null ? stack1.usePromoMessage : stack1),{"name":"if","hash":{},"fn":this.program(29, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "            </fieldset>\n        </form>\n    </div><!-- .tab-content -->\n"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.switches : depth0)) != null ? stack1.useBestPriceGuaranteeLogo : stack1),{"name":"if","hash":{},"fn":this.program(31, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</div><!-- .search -->\n</div>\n";
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/layouts/tab-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "            data-wizard-action='{\"tab\" : \""
    + alias3(((helper = (helper = helpers.tab || (depth0 != null ? depth0.tab : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"tab","hash":{},"data":data}) : helper)))
    + "\", \"packages.flight\" : "
    + alias3(((helper = (helper = helpers.flightsPackage || (depth0 != null ? depth0.flightsPackage : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"flightsPackage","hash":{},"data":data}) : helper)))
    + ", \"packages.hotel\" : "
    + alias3(((helper = (helper = helpers.hotelsPackage || (depth0 != null ? depth0.hotelsPackage : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"hotelsPackage","hash":{},"data":data}) : helper)))
    + ", \"packages.car\" : "
    + alias3(((helper = (helper = helpers.carsPackage || (depth0 != null ? depth0.carsPackage : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"carsPackage","hash":{},"data":data}) : helper)))
    + ", \"packages.train\" : "
    + alias3(((helper = (helper = helpers.trainsPackage || (depth0 != null ? depth0.trainsPackage : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"trainsPackage","hash":{},"data":data}) : helper)))
    + " }'\n";
},"3":function(depth0,helpers,partials,data) {
    return "            data-wizard-action='{}'\n";
},"5":function(depth0,helpers,partials,data) {
    return "            class=\"on\" aria-selected=\"true\"\n";
},"7":function(depth0,helpers,partials,data) {
    return "            class=\"\" aria-selected=\"false\"\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<li  class=\"tab\" role=\"presentation\" data-lobtab=\""
    + alias3(((helper = (helper = helpers.tab || (depth0 != null ? depth0.tab : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"tab","hash":{},"data":data}) : helper)))
    + "\">\n    <a role=\"tab\" href=\""
    + alias3(((helper = (helper = helpers.link || (depth0 != null ? depth0.link : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"link","hash":{},"data":data}) : helper)))
    + "\"\n        data-tab=\""
    + alias3(((helper = (helper = helpers.tab || (depth0 != null ? depth0.tab : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"tab","hash":{},"data":data}) : helper)))
    + "\"\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.isPackageTab : depth0),{"name":"unless","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "            id=\"tab-"
    + alias3(((helper = (helper = helpers['tab-id'] || (depth0 != null ? depth0['tab-id'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"tab-id","hash":{},"data":data}) : helper)))
    + "-tab\"\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isCurrentTab : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.program(7, data, 0),"data":data})) != null ? stack1 : "")
    + "        data-tracking=\"tab\"\n    >\n\n"
    + ((stack1 = this.invokePartial(partials['corewizard/components/icon-lobIcon'],depth0,{"name":"corewizard/components/icon-lobIcon","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "        <span class=\"visuallyhidden\">Search for </span><span class=\"tab-label\">"
    + ((stack1 = ((helper = (helper = helpers.label || (depth0 != null ? depth0.label : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"label","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n    </a>\n</li>\n";
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/layouts/wizard-hbs-hotels", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "  <section class=\"tab-pane on geolocation-enabled\" id=\"tab-hotel\">\n";
},"3":function(depth0,helpers,partials,data) {
    return "  <section class=\"tab-pane on\" id=\"tab-hotel\">\n";
},"5":function(depth0,helpers,partials,data) {
    return "soft-package-flight";
},"7":function(depth0,helpers,partials,data) {
    return " soft-package-car";
},"9":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isHotelTabWithMaxThreeRooms : depth0),{"name":"if","hash":{},"fn":this.program(10, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.allowHotelTabAddFlightOption : depth0),{"name":"if","hash":{},"fn":this.program(15, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.allowHotelTabAddCarOption : depth0),{"name":"if","hash":{},"fn":this.program(23, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"10":function(depth0,helpers,partials,data) {
    var stack1;

  return "    <div class=\"organic-package-checkboxes add-links cols-nested\">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.allowHotelTabAddFlightOption : depth0),{"name":"if","hash":{},"fn":this.program(11, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.allowHotelTabAddCarOption : depth0),{"name":"if","hash":{},"fn":this.program(13, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    </div>\n";
},"11":function(depth0,helpers,partials,data) {
    var stack1;

  return "      "
    + ((stack1 = (helpers['soft-package'] || (depth0 && depth0['soft-package']) || helpers.helperMissing).call(depth0,{"name":"soft-package","hash":{"icon":"flights","text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.addFlightLinkText : stack1),"checked":((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.flight : stack1),"action":(depth0 != null ? depth0.addFlightAction : depth0),"lob":"flight","id":(depth0 != null ? depth0.id : depth0)},"data":data})) != null ? stack1 : "")
    + "\n";
},"13":function(depth0,helpers,partials,data) {
    var stack1;

  return "      "
    + ((stack1 = (helpers['soft-package'] || (depth0 && depth0['soft-package']) || helpers.helperMissing).call(depth0,{"name":"soft-package","hash":{"icon":"cars","text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.addCarLinkText : stack1),"checked":((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.car : stack1),"action":(depth0 != null ? depth0.addCarAction : depth0),"lob":"car","id":(depth0 != null ? depth0.id : depth0)},"data":data})) != null ? stack1 : "")
    + "\n";
},"15":function(depth0,helpers,partials,data) {
    var stack1;

  return "  <div class=\"package-wrapper"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isHotelTabWithMaxThreeRooms : depth0),{"name":"if","hash":{},"fn":this.program(16, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\"flight-package-wrapper\" tabindex=\"-1\">\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.isHotelTabWithMaxThreeRooms : depth0),{"name":"unless","hash":{},"fn":this.program(19, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.flight : stack1),{"name":"if","hash":{},"fn":this.program(21, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "  </div>\n";
},"16":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.unless.call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.flight : stack1),{"name":"unless","hash":{},"fn":this.program(17, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"17":function(depth0,helpers,partials,data) {
    return " visuallyhidden";
},"19":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression, alias4=this.lambda;

  return "    <div class=\"add-links cols-nested cf\">\n      <a class=\"col link disabled\" href=\"#flight-package-wrapper\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-add-flight\" data-help-container=\"&#35;"
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-add-flight-help-container\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" role=\"button\">\n      <span class=\"icon icon-flights\"></span>"
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.addFlightLinkText : stack1), depth0))
    + "</a>\n      <div id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-add-flight-help-container\"  class=\"help-container\">\n        <span id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-add-flight-help-default\" class=\"col icon icon-help\" aria-hidden=\"true\" data-help-type=\"default\" data-control=\"tooltip\" data-content=\""
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightHotelMessage : stack1), depth0))
    + "\"></span><span class=\"alt\">?</span>\n      </div>\n    </div>\n";
},"21":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "      <div class=\"package-container cf\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-added-flight\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-hbs'],depth0,{"name":"corewizard/field-groups/flights-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "      </div>\n";
},"23":function(depth0,helpers,partials,data) {
    var stack1;

  return "  <div class=\"package-wrapper"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isHotelTabWithMaxThreeRooms : depth0),{"name":"if","hash":{},"fn":this.program(24, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\"car-package-wrapper\">\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.isHotelTabWithMaxThreeRooms : depth0),{"name":"unless","hash":{},"fn":this.program(26, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasCar : depth0),{"name":"if","hash":{},"fn":this.program(28, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "  </div>\n";
},"24":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.unless.call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.car : stack1),{"name":"unless","hash":{},"fn":this.program(17, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"26":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression, alias4=this.lambda;

  return "    <div class=\"add-links cols-nested cf\">\n      <a class=\"col link disabled\" href=\"#add-car\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-add-car\" data-help-container=\"&#35;"
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-add-car-help-container\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" role=\"button\">\n      <span class=\"icon icon-cars\"></span>"
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.addCarLinkText : stack1), depth0))
    + "</a>\n      <div id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-add-car-help-container\" class=\"help-container\">\n        <span id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-add-car-help-default\" class=\"col icon icon-help\" aria-hidden=\"true\" data-help-type=\"default\" data-control=\"tooltip\" data-content=\""
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.hotelCarMessage : stack1), depth0))
    + "\"></span><span class=\"alt\">?</span>\n      </div>\n    </div>\n";
},"28":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "      <div class=\"package-container cf\" id=\"hotel-added-car\" data-wizard-owner=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/cars-package-hbs'],depth0,{"name":"corewizard/field-groups/cars-package-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "      </div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/title-hbs'],depth0,{"name":"corewizard/fields/title-hbs","data":data,"helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isLocationSelectEnabled : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "\n<div id=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-tab\" class=\""
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.flight : stack1),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.car : stack1),{"name":"if","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/error-messages-hbs'],depth0,{"name":"corewizard/field-groups/error-messages-hbs","data":data,"helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-hbs'],depth0,{"name":"corewizard/field-groups/hotels-hbs","data":data,"indent":"  ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.destinationNotCuba : depth0),{"name":"if","hash":{},"fn":this.program(9, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n\n</section>\n";
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/layouts/wizard-hbs-vacationRental", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "    <section class=\"tab-pane on geolocation-enabled\" id=\"tab-vacation-rental\">\n";
},"3":function(depth0,helpers,partials,data) {
    return "    <section class=\"tab-pane on\" id=\"tab-vacation-rental\">\n";
},"5":function(depth0,helpers,partials,data) {
    return "soft-package-flight";
},"7":function(depth0,helpers,partials,data) {
    return " soft-package-car";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isLocationSelectEnabled : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "\n    <div id=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" class=\""
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.flight : stack1),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.car : stack1),{"name":"if","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/error-messages-hbs'],depth0,{"name":"corewizard/field-groups/error-messages-hbs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/vacation-rental-hbs'],depth0,{"name":"corewizard/field-groups/vacation-rental-hbs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "    </div>\n\n    </section>\n";
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/layouts/wizard-hbs-packages", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return "<section class=\"tab-pane on"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.pkg : depth0)) != null ? stack1.showCarMessage : stack1),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hotel : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.flight : depth0),{"name":"if","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " geolocation-enabled\" id=\"tab-package\">\n";
},"2":function(depth0,helpers,partials,data) {
    return " car-message car";
},"4":function(depth0,helpers,partials,data) {
    return " hotel";
},"6":function(depth0,helpers,partials,data) {
    return " flight";
},"8":function(depth0,helpers,partials,data) {
    var stack1;

  return "<section class=\"tab-pane on"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.pkg : depth0)) != null ? stack1.showCarMessage : stack1),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hotel : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.flight : depth0),{"name":"if","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\"tab-package\">\n";
},"10":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/sub-tabs'],depth0,{"name":"corewizard/fields/sub-tabs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"12":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/packages-origin-destination-hbs'],depth0,{"name":"corewizard/field-groups/packages-origin-destination-hbs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"14":function(depth0,helpers,partials,data) {
    var stack1;

  return "        <fieldset class=\"cols-nested destination-only\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/fields/hotel-car-destination-hbs'],depth0,{"name":"corewizard/fields/hotel-car-destination-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "        </fieldset>\n";
},"16":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-dates-hbs'],depth0,{"name":"corewizard/field-groups/hotels-dates-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"18":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-dates-hbs'],depth0,{"name":"corewizard/field-groups/flights-dates-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showLengthOfStay : depth0),{"name":"if","hash":{},"fn":this.program(19, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"19":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.hotel : stack1),{"name":"if","hash":{},"fn":this.program(20, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"20":function(depth0,helpers,partials,data) {
    var helper;

  return "                  <div class=\"length-of-stay-counter col\" id=\"length-of-stay-counter\">\n                    "
    + this.escapeExpression(((helper = (helper = helpers.hotelLengthOfStayString || (depth0 != null ? depth0.hotelLengthOfStayString : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"hotelLengthOfStayString","hash":{},"data":data}) : helper)))
    + "\n                  </div>\n";
},"22":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.rooms : depth0)) != null ? stack1['1'] : stack1),{"name":"if","hash":{},"fn":this.program(23, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.unless.call(depth0,((stack1 = (depth0 != null ? depth0.rooms : depth0)) != null ? stack1['1'] : stack1),{"name":"unless","hash":{},"fn":this.program(25, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n        <fieldset class=\"cols-nested partial-stay\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/direct-flight-hbs'],depth0,{"name":"corewizard/field-groups/direct-flight-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/partial-stay-hbs'],depth0,{"name":"corewizard/field-groups/partial-stay-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "        </fieldset>\n\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isPartialStay : depth0),{"name":"if","hash":{},"fn":this.program(27, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.rooms : depth0)) != null ? stack1['1'] : stack1),{"name":"if","hash":{},"fn":this.program(29, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n      ";
},"23":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],(depth0 != null ? depth0.hotelRoomCountOptions : depth0),{"name":"corewizard/components/select-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"25":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],(depth0 != null ? depth0.hotelRoomCountOptions : depth0),{"name":"corewizard/components/select-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-rooms-container-hbs'],depth0,{"name":"corewizard/field-groups/hotels-rooms-container-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"27":function(depth0,helpers,partials,data) {
    var stack1;

  return "            <fieldset class=\"cols-nested is-partial-stay\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-dates-hbs'],depth0,{"name":"corewizard/field-groups/hotels-dates-hbs","data":data,"indent":"                ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "            </fieldset>\n";
},"29":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-rooms-container-hbs'],depth0,{"name":"corewizard/field-groups/hotels-rooms-container-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"31":function(depth0,helpers,partials,data) {
    var stack1;

  return "          <div class=\"driver-age-package-wrapper\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/cars-driver-age-hbs'],depth0,{"name":"corewizard/field-groups/cars-driver-age-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "          </div>\n";
},"33":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['default/templates/advanced-options-package-hbs'],depth0,{"name":"default/templates/advanced-options-package-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"35":function(depth0,helpers,partials,data) {
    var stack1;

  return "        <div class=\"package-rooms-travellers-container "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.ab11873 : depth0),{"name":"if","hash":{},"fn":this.program(36, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" >\n          <fieldset class=\"cols-nested flights-passengers\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-passengers-hbs'],depth0,{"name":"corewizard/field-groups/flights-passengers-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "          </fieldset>\n        </div>\n      ";
},"36":function(depth0,helpers,partials,data) {
    var stack1;

  return "col"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasChildren : depth0),{"name":"if","hash":{},"fn":this.program(37, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"37":function(depth0,helpers,partials,data) {
    return " cols-row";
},"39":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasChildren : depth0),{"name":"if","hash":{},"fn":this.program(40, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"40":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-children-help-and-options-hbs'],depth0,{"name":"corewizard/field-groups/flights-children-help-and-options-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"42":function(depth0,helpers,partials,data) {
    return "    </section>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/title-hbs'],depth0,{"name":"corewizard/fields/title-hbs","data":data,"helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isLocationSelectEnabled : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(8, data, 0),"data":data})) != null ? stack1 : "")
    + "\n  <div id=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/error-messages-hbs'],depth0,{"name":"corewizard/field-groups/error-messages-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isMultiplePackageOrder : depth0),{"name":"if","hash":{},"fn":this.program(10, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showFlightOandD : depth0),{"name":"if","hash":{},"fn":this.program(12, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showHotelDest : depth0),{"name":"if","hash":{},"fn":this.program(14, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    <fieldset class=\"cols-nested\">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showHotelDest : depth0),{"name":"if","hash":{},"fn":this.program(16, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showFlightOandD : depth0),{"name":"if","hash":{},"fn":this.program(18, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showRooms : depth0),{"name":"if","hash":{},"fn":this.program(22, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showCarDriverAge : depth0),{"name":"if","hash":{},"fn":this.program(31, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.enableAdvancedOptions : depth0),{"name":"if","hash":{},"fn":this.program(33, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.noRooms : depth0),{"name":"if","hash":{},"fn":this.program(35, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.hideChildrenFlightFields : depth0),{"name":"unless","hash":{},"fn":this.program(39, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    </fieldset>\n  </div>\n  \n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isLocationSelectEnabled : depth0),{"name":"if","hash":{},"fn":this.program(42, data, 0),"inverse":this.program(42, data, 0),"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("default/typeahead/category", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "    <dt role=\"presentation\" data-tid=\"typeahead-category-"
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "\"\n        id=\"typeahead-category-"
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "\" class=\"category-name\">"
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "</dt>\n    <dd role=\"presentation\" class=\"category-results\">\n        <ul role=\"presentation\" class=\"results\">\n"
    + ((stack1 = helpers.each.call(depth0,depth0,{"name":"each","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "        </ul>\n    </dd>\n";
},"2":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression, alias4=this.lambda;

  return "            <li role=\"presentation\" tabindex=\"-1\" data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" class=\"results-item\">\n                <a role=\"option\" aria-describedby=\"typeahead-category-"
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "\"\n                    id=\"aria-option-"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" href=\"#\"\n                    data-value=\""
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.fullName : stack1), depth0))
    + "\" data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\">\n                    <span data-tid=\"typeahead-icon"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" class=\"details\">"
    + ((stack1 = alias4(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.displayName : stack1), depth0)) != null ? stack1 : "")
    + "</span>\n                </a>\n            </li>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing;

  return "<dl role=\"presentation\" data-tid=\"typeahead-list-category\">\n\n"
    + ((stack1 = (helpers.each_with_key || (depth0 && depth0.each_with_key) || alias1).call(depth0,(depth0 != null ? depth0.resultsByCategory : depth0),{"name":"each_with_key","hash":{"key":"categoryName"},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n</dl>\n<footer data-tid=\"typeahead-footer\" class=\"footer\" role=\"application\">\n    <a class=\"close\" href=\"#\">\n        "
    + this.escapeExpression(((helper = (helper = helpers.closeText || (depth0 != null ? depth0.closeText : depth0)) != null ? helper : alias1),(typeof helper === "function" ? helper.call(depth0,{"name":"closeText","hash":{},"data":data}) : helper)))
    + "<span class=\"icon icon-close\"></span>\n    </a>\n</footer>\n";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("default/typeahead/open-search-ta", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return "    <dd role=\"presentation\" class=\"category-results\">\n        <ul role=\"presentation\" class=\"results\">\n"
    + ((stack1 = helpers.each.call(depth0,depth0,{"name":"each","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "        </ul>\n    </dd>\n";
},"2":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.index : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"3":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "            <li role=\"presentation\" tabindex=\"-1\" data-tid=\"typeahead-item"
    + this.escapeExpression(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" class=\"results-item\">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.gemma : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.program(6, data, 0),"data":data})) != null ? stack1 : "")
    + "            </li>\n";
},"4":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "                <a role=\"option\" id=\"aria-option-"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\"\n                    data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" href=\"#\" class=\"details\"\n                    data-value=\""
    + alias3(this.lambda(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.fullName : stack1), depth0))
    + "\" data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\">\n                    "
    + ((stack1 = (helpers.makeOptionGemmaSearch || (depth0 && depth0.makeOptionGemmaSearch) || alias1).call(depth0,(depth0 != null ? depth0.index : depth0),(depth0 != null ? depth0.icon : depth0),((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.fullName : stack1),{"name":"makeOptionGemmaSearch","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                </a>\n";
},"6":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.categoryName : depth0),{"name":"if","hash":{},"fn":this.program(7, data, 0),"inverse":this.program(9, data, 0),"data":data})) != null ? stack1 : "");
},"7":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "                <a role=\"option\" id=\"aria-option-"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\"\n                    data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" href=\"#\" class=\"details\"\n                    data-value=\""
    + alias3(this.lambda(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.lastSearchName : stack1), depth0))
    + " - "
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "\" data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\">\n                    "
    + ((stack1 = (helpers.makeOptionOpenSearch || (depth0 && depth0.makeOptionOpenSearch) || alias1).call(depth0,(depth0 != null ? depth0.index : depth0),(depth0 != null ? depth0.icon : depth0),((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.displayName : stack1),(depth0 != null ? depth0.categoryName : depth0),{"name":"makeOptionOpenSearch","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                </a>\n";
},"9":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "               <a role=\"option\" id=\"aria-option-"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\"\n                    data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" href=\"#\" class=\"details\"\n                    data-value=\""
    + alias3(this.lambda(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.fullName : stack1), depth0))
    + "\" data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\">\n                    "
    + ((stack1 = (helpers.makeOptionGemmaSearch || (depth0 && depth0.makeOptionGemmaSearch) || alias1).call(depth0,(depth0 != null ? depth0.index : depth0),(depth0 != null ? depth0.icon : depth0),((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.fullName : stack1),{"name":"makeOptionGemmaSearch","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                </a>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing;

  return "<dl role=\"presentation\" data-tid=\"typeahead-list-category\">\n"
    + ((stack1 = (helpers.each_with_key || (depth0 && depth0.each_with_key) || alias1).call(depth0,(depth0 != null ? depth0.resultsByCategory : depth0),{"name":"each_with_key","hash":{"key":"categoryName"},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</dl>\n<footer data-tid=\"typeahead-footer\" class=\"footer\">\n    <a class=\"close\" href=\"#\">\n        "
    + this.escapeExpression(((helper = (helper = helpers.closeText || (depth0 != null ? depth0.closeText : depth0)) != null ? helper : alias1),(typeof helper === "function" ? helper.call(depth0,{"name":"closeText","hash":{},"data":data}) : helper)))
    + "<span class=\"icon icon-close\"></span>\n    </a>\n</footer>";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("default/typeahead/default", Handlebars.template({"1":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper;

  return "    <li role=\"presentation\" class=\"display-group-name\">"
    + this.escapeExpression(((helper = (helper = helpers.displayGroupName || (depth0 != null ? depth0.displayGroupName : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"displayGroupName","hash":{},"data":data}) : helper)))
    + "</li>\n    <div class=\"display-group-results\">\n"
    + ((stack1 = helpers.each.call(depth0,depth0,{"name":"each","hash":{},"fn":this.program(2, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    </div>\n";
},"2":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.index : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0, blockParams, depths),"inverse":this.program(8, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "");
},"3":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression, alias4=this.lambda;

  return "        <li role=\"presentation\" data-tid=\"typeahead-item"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" class=\"results-item\">\n            <a role=\"option\" id=\"aria-option-"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\" data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\"\n                href=\"#\" class=\"details\" data-value=\""
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.lastSearchName : stack1), depth0))
    + "\"\n                data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\" data-multiFlightInputId='"
    + alias3(alias4((depths[3] != null ? depths[3].multiFlightInputId : depths[3]), depth0))
    + "'>\n                "
    + ((stack1 = (helpers.getShowAsHierarchyFlag || (depth0 && depth0.getShowAsHierarchyFlag) || alias1).call(depth0,depth0,((stack1 = (depth0 != null ? depth0.hierarchyInfo : depth0)) != null ? stack1.relation : stack1),{"name":"getShowAsHierarchyFlag","hash":{},"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showAsHierarchy : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0, blockParams, depths),"inverse":this.program(6, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "            </a>\n        </li>\n";
},"4":function(depth0,helpers,partials,data) {
    var stack1, alias1=helpers.helperMissing;

  return "                <div class=\"child-suggestion\">\n                    "
    + ((stack1 = (helpers.getChildSuggestionIcon || (depth0 && depth0.getChildSuggestionIcon) || alias1).call(depth0,(depth0 != null ? depth0.index : depth0),{"name":"getChildSuggestionIcon","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                    "
    + ((stack1 = this.lambda(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.displayName : stack1), depth0)) != null ? stack1 : "")
    + "\n                    "
    + ((stack1 = (helpers.showDistanceFromNearbyAirport || (depth0 && depth0.showDistanceFromNearbyAirport) || alias1).call(depth0,((stack1 = ((stack1 = (depth0 != null ? depth0.hierarchyInfo : depth0)) != null ? stack1.nearby : stack1)) != null ? stack1.distInMI : stack1),{"name":"showDistanceFromNearbyAirport","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                </div>\n";
},"6":function(depth0,helpers,partials,data) {
    var stack1;

  return "                    "
    + ((stack1 = (helpers.makeOption || (depth0 && depth0.makeOption) || helpers.helperMissing).call(depth0,(depth0 != null ? depth0.index : depth0),(depth0 != null ? depth0.icon : depth0),((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.displayName : stack1),(depth0 != null ? depth0.rightFloatingTextHtml : depth0),{"name":"makeOption","hash":{},"data":data})) != null ? stack1 : "")
    + "\n";
},"8":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "        <li role=\"presentation\" data-tid=\"typeahead-item"
    + ((stack1 = (helpers.getItemCount || (depth0 && depth0.getItemCount) || alias1).call(depth0,(depth0 != null ? depth0.i : depth0),{"name":"getItemCount","hash":{},"data":data})) != null ? stack1 : "")
    + "\"\n            class=\"results-item\">\n            <a role=\"option\" id=\"aria-option-"
    + ((stack1 = (helpers.getItemCount || (depth0 && depth0.getItemCount) || alias1).call(depth0,(depth0 != null ? depth0.i : depth0),{"name":"getItemCount","hash":{},"data":data})) != null ? stack1 : "")
    + "\"\n                tabindex=\"-1\" data-tid=\"typeahead-link"
    + ((stack1 = (helpers.getItemCount || (depth0 && depth0.getItemCount) || alias1).call(depth0,(depth0 != null ? depth0.i : depth0),{"name":"getItemCount","hash":{},"data":data})) != null ? stack1 : "")
    + "\"\n                href=\"#\" class=\"details\" data-value=\""
    + alias3(((helper = (helper = helpers.l || (depth0 != null ? depth0.l : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"l","hash":{},"data":data}) : helper)))
    + "\" data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\"\n                data-multiFlightInputId='"
    + alias3(this.lambda((depths[3] != null ? depths[3].multiFlightInputId : depths[3]), depth0))
    + "'>\n                "
    + ((stack1 = (helpers.getShowAsHierarchyFlag || (depth0 && depth0.getShowAsHierarchyFlag) || alias1).call(depth0,depth0,(depth0 != null ? depth0.relation : depth0),{"name":"getShowAsHierarchyFlag","hash":{},"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showAsHierarchy : depth0),{"name":"if","hash":{},"fn":this.program(9, data, 0, blockParams, depths),"inverse":this.program(11, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "            </a>\n        </li>\n";
},"9":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing;

  return "                <div class=\"child-suggestion\">\n                    "
    + ((stack1 = (helpers.getChildSuggestionIcon || (depth0 && depth0.getChildSuggestionIcon) || alias1).call(depth0,(depth0 != null ? depth0.i : depth0),{"name":"getChildSuggestionIcon","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                    "
    + ((stack1 = ((helper = (helper = helpers.d || (depth0 != null ? depth0.d : depth0)) != null ? helper : alias1),(typeof helper === "function" ? helper.call(depth0,{"name":"d","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\n                    "
    + ((stack1 = (helpers.showDistanceFromNearbyAirport || (depth0 && depth0.showDistanceFromNearbyAirport) || alias1).call(depth0,(depth0 != null ? depth0.distInMI : depth0),{"name":"showDistanceFromNearbyAirport","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                </div>\n";
},"11":function(depth0,helpers,partials,data) {
    var stack1;

  return "                    "
    + ((stack1 = (helpers.makeOption || (depth0 && depth0.makeOption) || helpers.helperMissing).call(depth0,(depth0 != null ? depth0.i : depth0),(depth0 != null ? depth0.icon : depth0),(depth0 != null ? depth0.d : depth0),{"name":"makeOption","hash":{},"data":data})) != null ? stack1 : "")
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=helpers.helperMissing;

  return "<ul role=\"listbox\" data-tid=\"typeahead-list\" class=\"results\">\n\n"
    + ((stack1 = (helpers.each_with_key || (depth0 && depth0.each_with_key) || alias1).call(depth0,(depth0 != null ? depth0.resultsByDisplayGroup : depth0),{"name":"each_with_key","hash":{"key":"displayGroupName"},"fn":this.program(1, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n</ul>\n<footer data-tid=\"typeahead-footer\" class=\"footer\" role=\"application\">\n    <a id=\"typeahead-close\" data-tid=\"typeahead-close\" class=\"close\" href=\"#\">\n        "
    + this.escapeExpression(((helper = (helper = helpers.closeText || (depth0 != null ? depth0.closeText : depth0)) != null ? helper : alias1),(typeof helper === "function" ? helper.call(depth0,{"name":"closeText","hash":{},"data":data}) : helper)))
    + "<span class=\"icon icon-close\"></span>\n    </a>\n</footer>\n";
},"useData":true,"useDepths":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("default/templates/advanced-options-package-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "false";
},"3":function(depth0,helpers,partials,data) {
    return "true";
},"5":function(depth0,helpers,partials,data) {
    return "viewed";
},"7":function(depth0,helpers,partials,data) {
    return "open";
},"9":function(depth0,helpers,partials,data) {
    var stack1;

  return "        <div id=\"advanced-options-fields\">\n            <fieldset class=\"cols-nested\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],(depth0 != null ? depth0.preferredFlightCabinClassOptions : depth0),{"name":"corewizard/components/select-hbs","data":data,"indent":"                ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "            </fieldset>\n        </div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"advanced-options col\">\n    <a\n            href=\"#advanced-options-fields\"\n            role=\"button\"\n            id=\"advanced-options\"\n            aria-controls=\"advanced-options-fields\"\n            aria-expanded=\""
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.hideFlightOptions : depth0),{"name":"unless","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.showFlightOptions : depth0),{"name":"unless","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\"\n            aria-pressed=\""
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.hideFlightOptions : depth0),{"name":"unless","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.showFlightOptions : depth0),{"name":"unless","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\"\n            class=\"toggle-trigger "
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.hideFlightOptions : depth0),{"name":"unless","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.showFlightOptions : depth0),{"name":"unless","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\"\n            data-wizard-action='{\"showFlightOptions\" : "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hideFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " }'\n            >\n        "
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.advancedOptionsLabel : stack1), depth0))
    + "<span class=\"icon icon-expand\"></span>\n    </a>\n\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.showFlightOptions : depth0),{"name":"unless","hash":{},"fn":this.program(9, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n";
},"usePartial":true,"useData":true}));});
this["Handlebars"] = this["Handlebars"] || {};
this["Handlebars"]["templates"] = this["Handlebars"]["templates"] || {};
this["Handlebars"]["templates"]["button-location-select-hbs"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<label id=\"location-select-label\" for=\"core-wizard-location-select\" class=\"col\">\n	<span class=\"label\">Nearby</span>\n	<button id=\"core-wizard-location-select\" type=\"button\"><span class=\"visuallyhidden\">Detect my location</span></button>\n</label>\n";
},"useData":true};
this["Handlebars"]["templates"]["input-calendar-hbs"] = {"1":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return ((stack1 = ((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"number","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-";
},"3":function(depth0,helpers,partials,data) {
    return "invalid";
},"5":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0['companion-attr'] : depth0),{"name":"if","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"6":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function";

  return "          "
    + this.escapeExpression(((helper = (helper = helpers['companion-attr'] || (depth0 != null ? depth0['companion-attr'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"companion-attr","hash":{},"data":data}) : helper)))
    + "=\"&#35;"
    + ((stack1 = ((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-"
    + ((stack1 = ((helper = (helper = helpers.companion || (depth0 != null ? depth0.companion : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"companion","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-wrapper\"\n";
},"8":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda;

  return "        "
    + ((stack1 = alias1((depth0 != null ? depth0.name : depth0), depth0)) != null ? stack1 : "")
    + "=\""
    + ((stack1 = alias1((depth0 != null ? depth0.value : depth0), depth0)) != null ? stack1 : "")
    + "\"\n";
},"10":function(depth0,helpers,partials,data) {
    var helper;

  return "      data-blackout-dates='"
    + this.escapeExpression(((helper = (helper = helpers.black_out_json || (depth0 != null ? depth0.black_out_json : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"black_out_json","hash":{},"data":data}) : helper)))
    + "'\n";
},"12":function(depth0,helpers,partials,data) {
    return "show";
},"14":function(depth0,helpers,partials,data) {
    return "disabled";
},"16":function(depth0,helpers,partials,data) {
    return "error";
},"18":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return ((stack1 = ((helper = (helper = helpers['label-text'] || (depth0 != null ? depth0['label-text'] : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"label-text","hash":{},"data":data}) : helper))) != null ? stack1 : "");
},"20":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return ((stack1 = ((helper = (helper = helpers.dateFormat || (depth0 != null ? depth0.dateFormat : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"dateFormat","hash":{},"data":data}) : helper))) != null ? stack1 : "");
},"22":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "data-number=\""
    + ((stack1 = ((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"number","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"";
},"24":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "aria-describedby=\""
    + ((stack1 = ((helper = (helper = helpers['aria-describedby'] || (depth0 != null ? depth0['aria-describedby'] : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"aria-describedby","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"";
},"26":function(depth0,helpers,partials,data) {
    return "aria-invalid=\"true\"";
},"28":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda;

  return "            "
    + ((stack1 = alias1((depth0 != null ? depth0.name : depth0), depth0)) != null ? stack1 : "")
    + "=\""
    + ((stack1 = alias1((depth0 != null ? depth0.value : depth0), depth0)) != null ? stack1 : "")
    + "\"\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function";

  return "<div id=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.number : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-wrapper\"\n    data-control=\"datepicker\"\n    data-close=\"true\"\n    class=\"col text datepicker theme-standard pin-left "
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + " "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasError : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\"\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.isMultiDest : depth0),{"name":"unless","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.ia : depth0),{"name":"each","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    data-auto-pos=\"true\"\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.is_blackout : depth0),{"name":"if","hash":{},"fn":this.program(10, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    >\n  <label class=\"datepicker-label datepicker-arrow text icon-before\" for=\""
    + ((stack1 = ((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.number : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\">\n    <span class=\"label "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0['label-show'] : depth0),{"name":"if","hash":{},"fn":this.program(12, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\">"
    + ((stack1 = ((helper = (helper = helpers['label-text'] || (depth0 != null ? depth0['label-text'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"label-text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "<span class=\"datepicker-expand-collapse visuallyhidden\"> expanded. Enter a date or choose one from the table below.</span></span>\n    <input\n        "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isDisabled : depth0),{"name":"if","hash":{},"fn":this.program(14, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n        id=\""
    + ((stack1 = ((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.number : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"\n        data-wizard-action='"
    + ((stack1 = ((helper = (helper = helpers.wizard_action || (depth0 != null ? depth0.wizard_action : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"wizard_action","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "'\n        class=\""
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasError : depth0),{"name":"if","hash":{},"fn":this.program(16, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " "
    + ((stack1 = ((helper = (helper = helpers['class'] || (depth0 != null ? depth0['class'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"class","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + " datepicker-trigger-input\"\n        type=\"text\"\n        placeholder=\""
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.ab11873_1 : depth0),{"name":"if","hash":{},"fn":this.program(18, data, 0),"inverse":this.program(20, data, 0),"data":data})) != null ? stack1 : "")
    + "\"\n        data-cal-version=\"touch-keyboard\"\n        "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.number : depth0),{"name":"if","hash":{},"fn":this.program(22, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n        "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0['aria-describedby'] : depth0),{"name":"if","hash":{},"fn":this.program(24, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n        "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasError : depth0),{"name":"if","hash":{},"fn":this.program(26, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.inputAttributes : depth0),{"name":"each","hash":{},"fn":this.program(28, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    />\n    <span class=\"icon icon-calendar\" aria-hidden=\"true\"></span>\n  </label>\n  <div class=\"datepicker-dropdown\" aria-hidden=\"true\"></div>\n</div>\n";
},"useData":true};
this["Handlebars"]["templates"]["input-checkbox-hbs"] = {"1":function(depth0,helpers,partials,data) {
    return " disabled";
},"3":function(depth0,helpers,partials,data) {
    return " checked";
},"5":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda;

  return "            "
    + this.escapeExpression(alias1((depth0 != null ? depth0.name : depth0), depth0))
    + "=\""
    + ((stack1 = alias1((depth0 != null ? depth0.value : depth0), depth0)) != null ? stack1 : "")
    + "\"\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function";

  return "\n    <label class=\"check"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.disabled : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\""
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-label\">\n        <input \n          type=\"checkbox\" \n          id=\""
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\" \n          data-wizard-action='"
    + ((stack1 = ((helper = (helper = helpers.wizard_action || (depth0 != null ? depth0.wizard_action : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"wizard_action","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "'\n          "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isChecked : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " \n          "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.disabled : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.ia : depth0),{"name":"each","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "          />\n        <span class=\"inline-label\">"
    + ((stack1 = ((helper = (helper = helpers['label-text'] || (depth0 != null ? depth0['label-text'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"label-text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n    </label>\n";
},"useData":true};
this["Handlebars"]["templates"]["input-radio-hbs"] = {"1":function(depth0,helpers,partials,data) {
    return "disabled";
},"3":function(depth0,helpers,partials,data) {
    return "checked";
},"5":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda;

  return "            "
    + this.escapeExpression(alias1((depth0 != null ? depth0.name : depth0), depth0))
    + "=\""
    + ((stack1 = alias1((depth0 != null ? depth0.value : depth0), depth0)) != null ? stack1 : "")
    + "\"\n";
},"7":function(depth0,helpers,partials,data) {
    return "class=\"checked\"";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function";

  return "\n    <label name=\""
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\" id=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-"
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-label\" class=\"check "
    + ((stack1 = ((helper = (helper = helpers['class'] || (depth0 != null ? depth0['class'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"class","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\" for=\""
    + ((stack1 = ((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-"
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\">\n        <input \n          type=\"radio\" \n          id=\""
    + ((stack1 = ((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-"
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"\n          data-wizard-action='"
    + ((stack1 = ((helper = (helper = helpers.wizard_action || (depth0 != null ? depth0.wizard_action : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"wizard_action","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "'\n          "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isDisabled : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n          "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isChecked : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.ia : depth0),{"name":"each","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "          "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isChecked : depth0),{"name":"if","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n          />\n        <span class=\"inline-label\">"
    + ((stack1 = ((helper = (helper = helpers['label-text'] || (depth0 != null ? depth0['label-text'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"label-text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n    </label>\n";
},"useData":true};
this["Handlebars"]["templates"]["input-ta-hbs"] = {"1":function(depth0,helpers,partials,data) {
    return "invalid";
},"3":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return ((stack1 = ((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"number","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-";
},"5":function(depth0,helpers,partials,data) {
    return "show";
},"7":function(depth0,helpers,partials,data) {
    var stack1;

  return "aria-invalid=\"true\" class=\"error"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isMultiDest : depth0),{"name":"if","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\"";
},"8":function(depth0,helpers,partials,data) {
    return " multi-dest-error";
},"10":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function";

  return ((stack1 = (helpers.if_experiment || (depth0 && depth0.if_experiment) || alias1).call(depth0,"uTA_HOTELS",{"name":"if_experiment","hash":{},"fn":this.program(11, data, 0),"inverse":this.program(13, data, 0),"data":data})) != null ? stack1 : "")
    + "\n          aria-autocomplete=\"list\"\n          autocomplete=\"off\"\n          spellcheck=\"false\"\n          data-ta-key="
    + ((stack1 = ((helper = (helper = helpers.ta_key || (depth0 != null ? depth0.ta_key : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"ta_key","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\n          data-tooltip-id=\"typeahead-list\"\n          aria-owns=\"typeahead-list\"\n          aria-labelledby=\"flight-"
    + ((stack1 = ((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"number","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"\n";
},"11":function(depth0,helpers,partials,data) {
    var helper;

  return "                data-locale=\""
    + this.escapeExpression(((helper = (helper = helpers.locale || (depth0 != null ? depth0.locale : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"locale","hash":{},"data":data}) : helper)))
    + "\"\n                data-js-theme=\"autocomplete\"\n                data-provide=\"utypeahead\"\n                data-template=\"hbs/templates/destinationCustom\"\n                data-mask=\"1759\"\n                data-minchar=\"1\"\n";
},"13":function(depth0,helpers,partials,data) {
    return "                data-js-theme=\"typeahead\"\n                data-provide=\"typeahead\"\n";
},"15":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda;

  return "          "
    + ((stack1 = alias1((depth0 != null ? depth0.name : depth0), depth0)) != null ? stack1 : "")
    + "=\""
    + ((stack1 = alias1((depth0 != null ? depth0.value : depth0), depth0)) != null ? stack1 : "")
    + "\"\n";
},"17":function(depth0,helpers,partials,data) {
    return "        <span class=\"icon icon-search\" aria-hidden=\"true\"></span>\n";
},"19":function(depth0,helpers,partials,data) {
    return "        <span class=\"icon icon-location\" aria-hidden=\"true\"></span>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function";

  return "<div class=\"container-ta-"
    + ((stack1 = ((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + " theme-standard autocomplete pin-left col\" data-control=\"autocomplete\" data-auto-pos=\"true\">\n    <label class=\"text icon-before "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasError : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " autocomplete-arrow\" id=\""
    + ((stack1 = ((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.number : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-label\" >\n      <span class=\"visuallyhidden\" aria-hidden=\"true\" id=\"anchor-"
    + ((stack1 = ((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.number : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"></span>\n      <span class=\"label "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0['label-show'] : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\">"
    + ((stack1 = ((helper = (helper = helpers['label-text'] || (depth0 != null ? depth0['label-text'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"label-text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n      <input\n        type=\"text\"\n        class=\"autocomplete-trigger-input\"\n        id=\""
    + ((stack1 = ((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.number : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"\n        "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasError : depth0),{"name":"if","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.TAoff : depth0),{"name":"unless","hash":{},"fn":this.program(10, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "        data-wizard-action='"
    + ((stack1 = ((helper = (helper = helpers.wizard_action || (depth0 != null ? depth0.wizard_action : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"wizard_action","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "'\n        data-autoselect=\"touch\"\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.ia : depth0),{"name":"each","hash":{},"fn":this.program(15, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "      />\n\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.openSearch : depth0),{"name":"if","hash":{},"fn":this.program(17, data, 0),"inverse":this.program(19, data, 0),"data":data})) != null ? stack1 : "")
    + "    </label>\n    <span class=\"icon icon-close visuallyhidden clear-search\" aria-hidden=\"true\"></span>\n    <div class=\"autocomplete-dropdown\" id=\"typeahead-"
    + ((stack1 = ((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"></div>\n</div>\n";
},"useData":true};
this["Handlebars"]["templates"]["select-hbs"] = {"1":function(depth0,helpers,partials,data) {
    return " invalid";
},"3":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "<span class=\"label\">"
    + ((stack1 = ((helper = (helper = helpers['label-text'] || (depth0 != null ? depth0['label-text'] : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"label-text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>";
},"5":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "class=\""
    + ((stack1 = ((helper = (helper = helpers['class'] || (depth0 != null ? depth0['class'] : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"class","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasError : depth0),{"name":"if","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\"";
},"6":function(depth0,helpers,partials,data) {
    return " error";
},"8":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda;

  return "      "
    + ((stack1 = alias1((depth0 != null ? depth0.name : depth0), depth0)) != null ? stack1 : "")
    + "=\""
    + ((stack1 = alias1((depth0 != null ? depth0.value : depth0), depth0)) != null ? stack1 : "")
    + "\"\n";
},"10":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.options : depth0),{"name":"if","hash":{},"fn":this.program(11, data, 0),"inverse":this.program(15, data, 0),"data":data})) != null ? stack1 : "");
},"11":function(depth0,helpers,partials,data) {
    var stack1;

  return "      <optgroup label=\""
    + ((stack1 = this.lambda((depth0 != null ? depth0.name : depth0), depth0)) != null ? stack1 : "")
    + "\">\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.options : depth0),{"name":"each","hash":{},"fn":this.program(12, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "      </optgroup>\n";
},"12":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda;

  return "          <option value=\""
    + ((stack1 = alias1((depth0 != null ? depth0.value : depth0), depth0)) != null ? stack1 : "")
    + "\""
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.selected : depth0),{"name":"if","hash":{},"fn":this.program(13, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ">\n              "
    + ((stack1 = alias1((depth0 != null ? depth0.name : depth0), depth0)) != null ? stack1 : "")
    + "\n          </option>\n";
},"13":function(depth0,helpers,partials,data) {
    return " selected=\"selected\"";
},"15":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda;

  return "      <option\n        "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.selected : depth0),{"name":"if","hash":{},"fn":this.program(16, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n        value=\""
    + ((stack1 = alias1((depth0 != null ? depth0.value : depth0), depth0)) != null ? stack1 : "")
    + "\">\n          "
    + ((stack1 = alias1((depth0 != null ? depth0.name : depth0), depth0)) != null ? stack1 : "")
    + "\n      </option>\n";
},"16":function(depth0,helpers,partials,data) {
    return "selected=\"selected\"";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function";

  return "<label\n  id=\""
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-label\"\n  class=\"select icon col icon-toggle180"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasError : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " "
    + ((stack1 = ((helper = (helper = helpers['label-class'] || (depth0 != null ? depth0['label-class'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"label-class","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\">\n  "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0['label-text'] : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n  <select\n    id=\""
    + ((stack1 = ((helper = (helper = helpers.namespace || (depth0 != null ? depth0.namespace : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"namespace","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"\n    data-wizard-action='"
    + ((stack1 = ((helper = (helper = helpers.wizard_action || (depth0 != null ? depth0.wizard_action : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"wizard_action","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "'\n    "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0['class'] : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.ia : depth0),{"name":"each","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "  >\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.options : depth0),{"name":"each","hash":{},"fn":this.program(10, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "  </select>\n</label>\n";
},"useData":true};
this["Handlebars"]["templates"]["icon-lobIcon"] = {"1":function(depth0,helpers,partials,data) {
    return "  <div class=\"multiPkgIcon\">\n";
},"3":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(data && data.first),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.program(6, data, 0),"data":data})) != null ? stack1 : "");
},"4":function(depth0,helpers,partials,data) {
    return "    <span class=\"icon icon-"
    + this.escapeExpression(this.lambda(depth0, depth0))
    + "\" aria-hidden=\"true\"></span>\n";
},"6":function(depth0,helpers,partials,data) {
    return "    &nbsp;\n    <span class=\"icon icon-"
    + this.escapeExpression(this.lambda(depth0, depth0))
    + "\" aria-hidden=\"true\"></span>\n";
},"8":function(depth0,helpers,partials,data) {
    return "  </div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.icon : depth0)) != null ? stack1['1'] : stack1),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.icon : depth0),{"name":"each","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.icon : depth0)) != null ? stack1['1'] : stack1),{"name":"if","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true};
this["Handlebars"]["templates"]["soft-package-checkbox-hbs"] = {"1":function(depth0,helpers,partials,data) {
    return " checked";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "\n<label class=\"col link\">\n  <input type=\"checkbox\"\n  	id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-add-"
    + alias3(((helper = (helper = helpers.lob || (depth0 != null ? depth0.lob : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"lob","hash":{},"data":data}) : helper)))
    + "-checkbox\"\n  	data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\"\n  	data-wizard-action=\""
    + alias3(((helper = (helper = helpers.action || (depth0 != null ? depth0.action : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"action","hash":{},"data":data}) : helper)))
    + "\"\n    data-package-wrapper=\""
    + alias3(((helper = (helper = helpers.lob || (depth0 != null ? depth0.lob : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"lob","hash":{},"data":data}) : helper)))
    + "-package-wrapper\"\n    data-tracking=\"softPackageCheckbox\"\n  	"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.checked : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ">\n  <span class=\"inline-label\"><span class=\"icon icon-"
    + alias3(((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"icon","hash":{},"data":data}) : helper)))
    + "\" aria-hidden=\"true\"></span>"
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n</label>\n";
},"useData":true};
this["Handlebars"]["templates"]["next-trip-hbs"] = {"1":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda, alias2=this.escapeExpression;

  return "	<section class=\"itin-next-trip\" id=\"next-trip\">\n		<h4 class=\"trip-title\">\n"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.isFlight : stack1),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.program(4, data, 0),"data":data})) != null ? stack1 : "")
    + "		</h4>\n\n		<span class=\"trip-name-icon\">\n			<span class=\"icon icon-"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.lob : stack1), depth0))
    + "\"></span>\n			"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.name : stack1), depth0))
    + "\n		</span>\n\n		<span class=\"trip-date\">\n"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.isHotel : stack1),{"name":"if","hash":{},"fn":this.program(18, data, 0),"inverse":this.program(20, data, 0),"data":data})) != null ? stack1 : "")
    + "		</span>\n\n		<a class=\"trip-link\" href="
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.link : stack1), depth0))
    + ">"
    + ((stack1 = alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.seeMyTripLinkText : stack1), depth0)) != null ? stack1 : "")
    + "</a>\n	</section>\n";
},"2":function(depth0,helpers,partials,data) {
    var stack1;

  return "				"
    + this.escapeExpression(this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.yourUpcomingFlight : stack1), depth0))
    + "\n";
},"4":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.isHotel : stack1),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.program(7, data, 0),"data":data})) != null ? stack1 : "");
},"5":function(depth0,helpers,partials,data) {
    var stack1;

  return "					"
    + this.escapeExpression(this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.yourUpcomingHotel : stack1), depth0))
    + "\n";
},"7":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.isCar : stack1),{"name":"if","hash":{},"fn":this.program(8, data, 0),"inverse":this.program(10, data, 0),"data":data})) != null ? stack1 : "");
},"8":function(depth0,helpers,partials,data) {
    var stack1;

  return "						"
    + this.escapeExpression(this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.yourUpcomingCar : stack1), depth0))
    + "\n";
},"10":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.isCruise : stack1),{"name":"if","hash":{},"fn":this.program(11, data, 0),"inverse":this.program(13, data, 0),"data":data})) != null ? stack1 : "");
},"11":function(depth0,helpers,partials,data) {
    var stack1;

  return "							"
    + this.escapeExpression(this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.yourUpcomingCruise : stack1), depth0))
    + "\n";
},"13":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.isActivity : stack1),{"name":"if","hash":{},"fn":this.program(14, data, 0),"inverse":this.program(16, data, 0),"data":data})) != null ? stack1 : "");
},"14":function(depth0,helpers,partials,data) {
    var stack1;

  return "								"
    + this.escapeExpression(this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.yourUpcomingActivity : stack1), depth0))
    + "\n";
},"16":function(depth0,helpers,partials,data) {
    var stack1;

  return "								"
    + this.escapeExpression(this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.yourUpcomingTrip : stack1), depth0))
    + "\n";
},"18":function(depth0,helpers,partials,data) {
    var stack1;

  return "			"
    + ((stack1 = this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.checkInTextOnUpcomingTrip : stack1), depth0)) != null ? stack1 : "")
    + "\n";
},"20":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.isCar : stack1),{"name":"if","hash":{},"fn":this.program(21, data, 0),"inverse":this.program(23, data, 0),"data":data})) != null ? stack1 : "");
},"21":function(depth0,helpers,partials,data) {
    var stack1;

  return "				"
    + ((stack1 = this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.pickUpTextOnUpcomingTrip : stack1), depth0)) != null ? stack1 : "")
    + "\n";
},"23":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.isActivity : stack1),{"name":"if","hash":{},"fn":this.program(24, data, 0),"inverse":this.program(26, data, 0),"data":data})) != null ? stack1 : "");
},"24":function(depth0,helpers,partials,data) {
    var stack1;

  return "					"
    + ((stack1 = this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.activityStartsTextOnUpcomingTrip : stack1), depth0)) != null ? stack1 : "")
    + "\n";
},"26":function(depth0,helpers,partials,data) {
    var stack1;

  return "					"
    + ((stack1 = this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.loc : stack1)) != null ? stack1.departureTextForUpcomingTrip : stack1), depth0)) != null ? stack1 : "")
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.name : stack1),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true};
this["Handlebars"]["templates"]["activity-hbs"] = {"1":function(depth0,helpers,partials,data) {
    return "  <section class=\"tab-pane geolocation-enabled on\" id=\"tab-activity\">\n";
},"3":function(depth0,helpers,partials,data) {
    return "  <section class=\"tab-pane on\" id=\"tab-activity\">\n";
},"5":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "\n    <div id=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isMultipleActivitiesOrder : depth0),{"name":"if","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showLXThingsTodo : depth0),{"name":"if","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showLXAirportRides : depth0),{"name":"if","hash":{},"fn":this.program(10, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n    </div>\n\n";
},"6":function(depth0,helpers,partials,data) {
    var stack1;

  return "\n"
    + ((stack1 = this.invokePartial(partials['corewizard/fields/sub-tabs'],depth0,{"name":"corewizard/fields/sub-tabs","data":data,"indent":"      ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n";
},"8":function(depth0,helpers,partials,data) {
    return "          <div>Content FROM showLXThingsTodo</div>\n";
},"10":function(depth0,helpers,partials,data) {
    return "          <div>Content FROM showLXAirportRides</div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, alias1=helpers.helperMissing, alias2=this.escapeExpression;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/title-hbs'],depth0,{"name":"corewizard/fields/title-hbs","data":data,"helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isLocationSelectEnabled : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/error-messages-hbs'],depth0,{"name":"corewizard/field-groups/error-messages-hbs","data":data,"helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isLXActivityABTest : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n  <fieldset class=\"cols-nested destination-only\">\n    "
    + alias2((helpers['input-TA'] || (depth0 && depth0['input-TA']) || alias1).call(depth0,depth0,"destination",{"name":"input-TA","hash":{"label-show":(depth0 != null ? depth0.isDestinationValueEmpty : depth0),"ia-aria-required":"true","ia-data-wizard-owner":(depth0 != null ? depth0.id : depth0),"wizard-action":"{\"destination\" : \"$value1\"}","ia-value":(depth0 != null ? depth0.destination : depth0),"ia-placeholder":(depth0 != null ? depth0.activityDestinationPlaceholderText : depth0),"ia-data-lob":"ACTIVITIES","has-error":(depth0 != null ? depth0.destinationError : depth0),"label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.activityDestinationLabel : stack1),"ta-key":"activity"},"data":data}))
    + "\n  </fieldset>\n\n  <fieldset class=\"cols-nested\">\n    "
    + alias2((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || alias1).call(depth0,depth0,"start",{"name":"input-calendar","hash":{"label-show":(depth0 != null ? depth0.isStartDateValueEmpty : depth0),"ia-aria-required":"true","ia-data-default-range-length":1,"ia-data-end-date":"&#35;activity-end-wrapper","ia-data-min-range-length":(depth0 != null ? depth0.minTripLength : depth0),"ia-data-last-valid-date":(depth0 != null ? depth0.lastValidDate : depth0),"ia-data-max-range-length":(depth0 != null ? depth0.maxTripLength : depth0),"wizard-action":"{\"startDate\" : \"$value1\"}","ia-data-wizard-owner":(depth0 != null ? depth0.id : depth0),"ia-value":(depth0 != null ? depth0.startDate : depth0),"has-error":(depth0 != null ? depth0.startDateError : depth0),"class":"check-in-out","label-text":(depth0 != null ? depth0.startDateLabel : depth0)},"data":data}))
    + "\n    "
    + alias2((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || alias1).call(depth0,depth0,"end",{"name":"input-calendar","hash":{"label-show":(depth0 != null ? depth0.isEndDateValueEmpty : depth0),"ia-aria-required":"true","ia-data-start-date":"&#35;activity-start-wrapper","wizard-action":"{\"endDate\" : \"$value1\"}","ia-data-wizard-owner":(depth0 != null ? depth0.id : depth0),"ia-value":(depth0 != null ? depth0.endDate : depth0),"has-error":(depth0 != null ? depth0.endDateError : depth0),"class":"check-in-out","label-text":(depth0 != null ? depth0.endDateLabel : depth0)},"data":data}))
    + "\n\n  </fieldset>\n\n</section>\n";
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["direct-flight-hbs"] = {"1":function(depth0,helpers,partials,data) {
    var stack1;

  return "    "
    + this.escapeExpression((helpers.input || (depth0 && depth0.input) || helpers.helperMissing).call(depth0,depth0,"checkbox","directFlight",(depth0 != null ? depth0.isDirectFlight : depth0),{"name":"input","hash":{"wizard-action":"{\"isDirectFlight\" : $value1}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.directFlightLabel : stack1)},"data":data}))
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showDirectFlightCheckbox : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true};
this["Handlebars"]["templates"]["flights-hbs"] = {"1":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-type-hbs'],depth0,{"name":"corewizard/field-groups/flights-type-hbs","data":data,"helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"3":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-dates-hbs'],depth0,{"name":"corewizard/field-groups/flights-dates-hbs","data":data,"indent":"      ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"5":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.unless.call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.hotel : stack1),{"name":"unless","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isMultiDest : depth0),{"name":"if","hash":{},"fn":this.program(13, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"6":function(depth0,helpers,partials,data) {
    var stack1;

  return "\n"
    + ((stack1 = helpers.unless.call(depth0,((stack1 = (depth0 != null ? depth0.ages : depth0)) != null ? stack1['1'] : stack1),{"name":"unless","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n        <div class=\"flight-passenger-container col "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.ab11873 : depth0),{"name":"if","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\">\n          <fieldset class=\"cols-nested\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-passengers-hbs'],depth0,{"name":"corewizard/field-groups/flights-passengers-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "          </fieldset>\n        </div>\n\n"
    + ((stack1 = helpers.unless.call(depth0,((stack1 = (depth0 != null ? depth0.ages : depth0)) != null ? stack1['1'] : stack1),{"name":"unless","hash":{},"fn":this.program(11, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n";
},"7":function(depth0,helpers,partials,data) {
    var stack1;

  return "          <div class=\"flight-passenger-wrapper "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.ab11873 : depth0),{"name":"if","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\">\n";
},"8":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasChildren : depth0),{"name":"if","hash":{},"fn":this.program(9, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"9":function(depth0,helpers,partials,data) {
    return "cols-row";
},"11":function(depth0,helpers,partials,data) {
    return "          </div>\n";
},"13":function(depth0,helpers,partials,data) {
    var stack1;

  return "        <div class=\"col\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-multi-destination-hbs'],depth0,{"name":"corewizard/field-groups/flights-multi-destination-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "        </div>\n";
},"15":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-children-help-and-options-hbs'],depth0,{"name":"corewizard/field-groups/flights-children-help-and-options-hbs","data":data,"indent":"      ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"17":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.enableAdvancedOptions : depth0),{"name":"if","hash":{},"fn":this.program(18, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"18":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/advanced-options-hbs'],depth0,{"name":"corewizard/field-groups/advanced-options-hbs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "<div id=\""
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n\n  "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isFlightTab : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-origin-destination-hbs'],depth0,{"name":"corewizard/field-groups/flights-origin-destination-hbs","data":data,"indent":"  ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n  <fieldset class=\"cols-nested flight-date-fieldset total-children-"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.ages : depth0)) != null ? stack1.length : stack1), depth0))
    + "\">\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.isHotelTabWithMaxThreeRooms : depth0),{"name":"unless","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.isHotelTab : depth0),{"name":"unless","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasChildren : depth0),{"name":"if","hash":{},"fn":this.program(15, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "  </fieldset>\n\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.isHotelTab : depth0),{"name":"unless","hash":{},"fn":this.program(17, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n";
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["advanced-options-hbs"] = {"1":function(depth0,helpers,partials,data) {
    var stack1;

  return "  <section class=\"advanced-options\">\n    <a\n      href=\"#advanced-options-fields\"\n      role=\"button\"\n      id=\"advanced-options\"\n      aria-controls=\"advanced-options-fields\"\n      aria-expanded=\""
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hideFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\"\n      aria-pressed=\""
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hideFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\"\n      class=\"toggle-trigger "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hideFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\"\n      data-wizard-action='{\"showFlightOptions\" : "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hideFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " }'>\n        "
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.advancedOptionsLabel : stack1), depth0))
    + "<span class=\"icon icon-expand\"></span>\n    </a>\n\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(10, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "  </section>\n";
},"2":function(depth0,helpers,partials,data) {
    return "false";
},"4":function(depth0,helpers,partials,data) {
    return "true";
},"6":function(depth0,helpers,partials,data) {
    return "viewed";
},"8":function(depth0,helpers,partials,data) {
    return "open";
},"10":function(depth0,helpers,partials,data) {
    var stack1;

  return "      <div id=\"advanced-options-fields\">\n        <fieldset class=\"advanced-checkboxes\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/fields/nonstop-flight-hbs'],depth0,{"name":"corewizard/fields/nonstop-flight-hbs","data":data,"indent":"           ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/fields/refundable-flight-hbs'],depth0,{"name":"corewizard/fields/refundable-flight-hbs","data":data,"indent":"           ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "        </fieldset>\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showPreferredAirline : depth0),{"name":"if","hash":{},"fn":this.program(11, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "      </div>\n";
},"11":function(depth0,helpers,partials,data) {
    var stack1;

  return "            <fieldset class=\"cols-nested\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],(depth0 != null ? depth0.preferredAirlinesOptions : depth0),{"name":"corewizard/components/select-hbs","data":data,"indent":"                ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],(depth0 != null ? depth0.preferredFlightCabinClassOptions : depth0),{"name":"corewizard/components/select-hbs","data":data,"indent":"                ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "            </fieldset>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isFlightOnly : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["error-messages-hbs"] = {"1":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "<div id=\""
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-errors\" class=\"alert-container alert alert-error validation-alert\">\n  <span class=\"icon icon-warn\" aria-hidden=\"true\"></span>\n  <h5 class=\"alert-title\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.errorMessageTitle : stack1), depth0))
    + "</h5>\n    <div class=\"alert-message\">\n      <ul>\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.originErrorMessage : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.originAndDestinationSameMessage : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.destinationErrorMessage : depth0),{"name":"if","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.dateBlankMessage : depth0),{"name":"if","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.dateFormatInvalidMessage : depth0),{"name":"if","hash":{},"fn":this.program(10, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.dateOutOfRangeMessage : depth0),{"name":"if","hash":{},"fn":this.program(12, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.dateCarOutOfRangeMessage : depth0),{"name":"if","hash":{},"fn":this.program(14, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.dateBeforeCurrentDateMessage : depth0),{"name":"if","hash":{},"fn":this.program(16, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.dateTimeRangeMessage : depth0),{"name":"if","hash":{},"fn":this.program(18, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.railDateTimeRangeMessage : depth0),{"name":"if","hash":{},"fn":this.program(20, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.multiDestDateErrorMessage : depth0),{"name":"if","hash":{},"fn":this.program(22, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.dateRangeTooLongErrorMessage : depth0),{"name":"if","hash":{},"fn":this.program(24, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showDriverAgeBlankMessage : depth0),{"name":"if","hash":{},"fn":this.program(26, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showDriverAgeInvalidMessage : depth0),{"name":"if","hash":{},"fn":this.program(28, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.partialStayDatesOutOfRange : depth0),{"name":"if","hash":{},"fn":this.program(30, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.numberOfTravellersMessage : depth0),{"name":"if","hash":{},"fn":this.program(32, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.numberOfRailTravellersMessage : depth0),{"name":"if","hash":{},"fn":this.program(34, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.childAgeMessage : depth0),{"name":"if","hash":{},"fn":this.program(36, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.railYouthAgeMessage : depth0),{"name":"if","hash":{},"fn":this.program(38, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.railSeniorAgeMessage : depth0),{"name":"if","hash":{},"fn":this.program(40, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.railChildAgeMessage : depth0),{"name":"if","hash":{},"fn":this.program(42, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.railChildTravelingWithChildMessage : depth0),{"name":"if","hash":{},"fn":this.program(44, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.railCardExceedAmt : depth0),{"name":"if","hash":{},"fn":this.program(46, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.railCardTypeMissingMessage : depth0),{"name":"if","hash":{},"fn":this.program(48, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.numberOfRailTravellersZeroMessage : depth0),{"name":"if","hash":{},"fn":this.program(50, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.railOriginNotFromTAMessage : depth0),{"name":"if","hash":{},"fn":this.program(52, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.railDestinationNotFromTAMessage : depth0),{"name":"if","hash":{},"fn":this.program(54, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.openSearchErrorMessage : depth0),{"name":"if","hash":{},"fn":this.program(56, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.originErrorMessage2 : depth0),{"name":"if","hash":{},"fn":this.program(58, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.originAndDestinationSameMessage2 : depth0),{"name":"if","hash":{},"fn":this.program(60, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.destinationErrorMessage2 : depth0),{"name":"if","hash":{},"fn":this.program(62, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.dateBlankMessage2 : depth0),{"name":"if","hash":{},"fn":this.program(64, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.dateFormatInvalidMessage2 : depth0),{"name":"if","hash":{},"fn":this.program(66, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.multiDestDateErrorMessage2 : depth0),{"name":"if","hash":{},"fn":this.program(68, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.originErrorMessage3 : depth0),{"name":"if","hash":{},"fn":this.program(70, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.originAndDestinationSameMessage3 : depth0),{"name":"if","hash":{},"fn":this.program(72, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.destinationErrorMessage3 : depth0),{"name":"if","hash":{},"fn":this.program(74, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.dateBlankMessage3 : depth0),{"name":"if","hash":{},"fn":this.program(76, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.dateFormatInvalidMessage3 : depth0),{"name":"if","hash":{},"fn":this.program(78, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.multiDestDateErrorMessage3 : depth0),{"name":"if","hash":{},"fn":this.program(80, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.originErrorMessage4 : depth0),{"name":"if","hash":{},"fn":this.program(82, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.originAndDestinationSameMessage4 : depth0),{"name":"if","hash":{},"fn":this.program(84, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.destinationErrorMessage4 : depth0),{"name":"if","hash":{},"fn":this.program(86, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.dateBlankMessage4 : depth0),{"name":"if","hash":{},"fn":this.program(88, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.dateFormatInvalidMessage4 : depth0),{"name":"if","hash":{},"fn":this.program(90, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.multiDestDateErrorMessage4 : depth0),{"name":"if","hash":{},"fn":this.program(92, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.originErrorMessage5 : depth0),{"name":"if","hash":{},"fn":this.program(94, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.originAndDestinationSameMessage5 : depth0),{"name":"if","hash":{},"fn":this.program(96, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.destinationErrorMessage5 : depth0),{"name":"if","hash":{},"fn":this.program(98, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.dateBlankMessage5 : depth0),{"name":"if","hash":{},"fn":this.program(100, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.dateFormatInvalidMessage5 : depth0),{"name":"if","hash":{},"fn":this.program(102, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.multiDestDateErrorMessage5 : depth0),{"name":"if","hash":{},"fn":this.program(104, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "      </ul>\n    </div>\n  </div>\n";
},"2":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"originError\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-origin\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.originErrorMessageText : stack1), depth0))
    + "</a></li>\n";
},"4":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-origin\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.originAndDestinationSameMessageText : stack1), depth0))
    + "</a></li>\n";
},"6":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"destinationError\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-destination\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.destinationErrorMessageText : stack1), depth0))
    + "</a></li>\n";
},"8":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"dateBlankMessage\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-departing\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.dateBlankMessageText : stack1), depth0))
    + "</a></li>\n";
},"10":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-departing\">"
    + alias3(((helper = (helper = helpers.dateFormatInvalidMessageText || (depth0 != null ? depth0.dateFormatInvalidMessageText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"dateFormatInvalidMessageText","hash":{},"data":data}) : helper)))
    + "</a></li>\n";
},"12":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-departing\">"
    + alias3(((helper = (helper = helpers.dateOutOfRangeMessageText || (depth0 != null ? depth0.dateOutOfRangeMessageText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"dateOutOfRangeMessageText","hash":{},"data":data}) : helper)))
    + "</a></li>\n";
},"14":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-departing\">"
    + alias3(((helper = (helper = helpers.dateCarOutOfRangeMessageText || (depth0 != null ? depth0.dateCarOutOfRangeMessageText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"dateCarOutOfRangeMessageText","hash":{},"data":data}) : helper)))
    + "</a></li>\n";
},"16":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-departing\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.dateBeforeCurrentDateMessageText : stack1), depth0))
    + "</a></li>\n";
},"18":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-departing\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.dateTimeRangeMessageText : stack1), depth0))
    + "</a></li>\n";
},"20":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "          <li><a href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-departing\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.railDateTimeRangeMessageText : stack1), depth0))
    + "</a></li>\n";
},"22":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"multiDestDateErrorMessage\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-departing\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.multiDestDateErrorText : stack1), depth0))
    + "</a></li>\n";
},"24":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-returning\">"
    + alias3(((helper = (helper = helpers.dateRangeTooLongErrorMessageText || (depth0 != null ? depth0.dateRangeTooLongErrorMessageText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"dateRangeTooLongErrorMessageText","hash":{},"data":data}) : helper)))
    + "</a></li>\n";
},"26":function(depth0,helpers,partials,data) {
    var stack1;

  return "        <li><a href=\"&#35;car-driverAge\">"
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.driverAgeBlankMessageText : stack1), depth0))
    + "</a></li>\n";
},"28":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda, alias2=this.escapeExpression;

  return "        <li>\n            <a href=\"&#35;car-driverAge\">\n              <span class='visuallyhidden'>"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.driverAgeInvalidAccessibilityMessageText : stack1), depth0))
    + "</span>\n              <span aria-hidden='true'>"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.driverAgeInvalidMessageText : stack1), depth0))
    + "</span>\n            </a>\n        </li>\n";
},"30":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"partialStayDatesOutOfRange\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-checkin\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.partialStayDatesOutOfRangeText : stack1), depth0))
    + "</a></li>\n";
},"32":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"numberOfTravellersMessage\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-adults\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.numberOfTravellersMessageText : stack1), depth0))
    + "</a></li>\n";
},"34":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"numberOfRailTravellersMessage\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-adults\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.maxRailTravellersExceededText : stack1), depth0))
    + "</a></li>\n";
},"36":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"childAgeMessage\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-children\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.childAgeMessageText : stack1), depth0))
    + "</a></li>\n";
},"38":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"railYouthAgeMessage\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-youth\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.railYouthAgeMessageText : stack1), depth0))
    + "</a></li>\n";
},"40":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"railSeniorAgeMessage\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-senior\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.railSeniorAgeMessageText : stack1), depth0))
    + "</a></li>\n";
},"42":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"railChildAgeMessage\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-children\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.railChildAloneBelowMin : stack1), depth0))
    + "</a></li>\n";
},"44":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"railChildTravelingWithChildMessage\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-children\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.railChildCantTravelWithChild : stack1), depth0))
    + "</a></li>\n";
},"46":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"railCardExceedAmt\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-children\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.railCardExceededTravellers : stack1), depth0))
    + "</a></li>\n";
},"48":function(depth0,helpers,partials,data) {
    var stack1;

  return "        <li><a class=\"railCardTypeMissingMessage\" href=\"&#35;railcards-list-fieldset-0\">"
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.railCardTypeMissingMessageText : stack1), depth0))
    + "</a></li>\n";
},"50":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"numberOfTravellersZeroError\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-adults\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.maxRailTravellersExceededText : stack1), depth0))
    + "</a></li>\n";
},"52":function(depth0,helpers,partials,data) {
    var stack1;

  return "        <li><a class=\"originError\" href=\"&#35;rail-origin\">"
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.railOriginNotFromTAMessage : stack1), depth0))
    + "</a></li>\n";
},"54":function(depth0,helpers,partials,data) {
    var stack1;

  return "        <li><a class=\"destinationError\" href=\"&#35;rail-destination\">"
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.railDestinationNotFromTAMessage : stack1), depth0))
    + "</a></li>\n";
},"56":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-searchQuery\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.openSearchErrorMessageText : stack1), depth0))
    + "</a></li>\n";
},"58":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-2-origin\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.originErrorMessageText : stack1), depth0))
    + "</a></li>\n";
},"60":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-2-origin\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.originAndDestinationSameMessageText : stack1), depth0))
    + "</a></li>\n";
},"62":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"destinationError2\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-2-destination\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.destinationErrorMessageText : stack1), depth0))
    + "</a></li>\n";
},"64":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"dateBlankMessage2\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-2-departing\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.dateBlankMessageText : stack1), depth0))
    + "</a></li>\n";
},"66":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-2-departing\">"
    + alias3(((helper = (helper = helpers.dateFormatInvalidMessageText || (depth0 != null ? depth0.dateFormatInvalidMessageText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"dateFormatInvalidMessageText","hash":{},"data":data}) : helper)))
    + "</a></li>\n";
},"68":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"multiDestDateErrorMessage2\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-2-departing\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.multiDestDateErrorText : stack1), depth0))
    + "</a></li>\n";
},"70":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-3-origin\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.originErrorMessageText : stack1), depth0))
    + "</a></li>\n";
},"72":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-3-origin\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.originAndDestinationSameMessageText : stack1), depth0))
    + "</a></li>\n";
},"74":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"destinationError3\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-3-destination\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.destinationErrorMessageText : stack1), depth0))
    + "</a></li>\n";
},"76":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"dateBlankMessage3\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-3-departing\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.dateBlankMessageText : stack1), depth0))
    + "</a></li>\n";
},"78":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-3-departing\">"
    + alias3(((helper = (helper = helpers.dateFormatInvalidMessageText || (depth0 != null ? depth0.dateFormatInvalidMessageText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"dateFormatInvalidMessageText","hash":{},"data":data}) : helper)))
    + "</a></li>\n";
},"80":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"multiDestDateErrorMessage3\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-3-departing\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.multiDestDateErrorText : stack1), depth0))
    + "</a></li>\n";
},"82":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-4-origin\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.originErrorMessageText : stack1), depth0))
    + "</a></li>\n";
},"84":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-4-origin\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.originAndDestinationSameMessageText : stack1), depth0))
    + "</a></li>\n";
},"86":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"destinationError4\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-4-destination\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.destinationErrorMessageText : stack1), depth0))
    + "</a></li>\n";
},"88":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"dateBlankMessage4\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-4-departing\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.dateBlankMessageText : stack1), depth0))
    + "</a></li>\n";
},"90":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-4-departing\">"
    + alias3(((helper = (helper = helpers.dateFormatInvalidMessageText || (depth0 != null ? depth0.dateFormatInvalidMessageText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"dateFormatInvalidMessageText","hash":{},"data":data}) : helper)))
    + "</a></li>\n";
},"92":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"multiDestDateErrorMessage4\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-4-departing\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.multiDestDateErrorText : stack1), depth0))
    + "</a></li>\n";
},"94":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-5-origin\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.originErrorMessageText : stack1), depth0))
    + "</a></li>\n";
},"96":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-5-origin\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.originAndDestinationSameMessageText : stack1), depth0))
    + "</a></li>\n";
},"98":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"destinationError5\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-5-destination\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.destinationErrorMessageText : stack1), depth0))
    + "</a></li>\n";
},"100":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"dateBlankMessage5\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-5-departing\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.dateBlankMessageText : stack1), depth0))
    + "</a></li>\n";
},"102":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "        <li><a href=\"&#35;"
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-5-departing\">"
    + alias3(((helper = (helper = helpers.dateFormatInvalidMessageText || (depth0 != null ? depth0.dateFormatInvalidMessageText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"dateFormatInvalidMessageText","hash":{},"data":data}) : helper)))
    + "</a></li>\n";
},"104":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "        <li><a class=\"multiDestDateErrorMessage5\" href=\"&#35;"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-5-departing\">"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.multiDestDateErrorText : stack1), depth0))
    + "</a></li>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showErrors : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true};
this["Handlebars"]["templates"]["flights-lap-or-seat-hbs"] = {"1":function(depth0,helpers,partials,data) {
    return "    "
    + this.escapeExpression((helpers.assign || (depth0 && depth0.assign) || helpers.helperMissing).call(depth0,depth0,"id","=","hotel-flight",{"name":"assign","hash":{},"data":data}))
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.escapeExpression, alias2=helpers.helperMissing;

  return "<div class=\"young-child-note\">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isHotelTab : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n  <fieldset class=\"children-lap-wrapper cf\">\n  <legend>"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightChildNote : stack1), depth0))
    + "</legend>\n    "
    + alias1((helpers.input || (depth0 && depth0.input) || alias2).call(depth0,depth0,"radio","children-in-lap",(depth0 != null ? depth0.isChildInLap : depth0),{"name":"input","hash":{"ia-value":"lap","ia-name":"lap-or-seat","wizard-action":"{\"isChildInLap\" : true}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightChildInLapLabel : stack1)},"data":data}))
    + "\n    "
    + alias1((helpers.assign || (depth0 && depth0.assign) || alias2).call(depth0,depth0,"inSeat","!",(depth0 != null ? depth0.isChildInLap : depth0),{"name":"assign","hash":{},"data":data}))
    + "\n    "
    + alias1((helpers.input || (depth0 && depth0.input) || alias2).call(depth0,depth0,"radio","children-in-seat",(depth0 != null ? depth0.inSeat : depth0),{"name":"input","hash":{"ia-value":"seat","ia-name":"lap-or-seat","wizard-action":"{\"isChildInLap\" : false}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightChildInSeatLabel : stack1)},"data":data}))
    + "\n  </fieldset>\n</div>\n";
},"useData":true};
this["Handlebars"]["templates"]["hotels-children-fieldset-hbs"] = {"1":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression, alias2=helpers.helperMissing, alias3="function";

  return "  <fieldset class=\"children-fieldset total-children-"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.ages : depth0)) != null ? stack1.length : stack1), depth0))
    + " cols-nested\" id=\""
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-children-ages\" data-children-fieldset=\""
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" data-wizard-owner=\""
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.ages : depth0),{"name":"each","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "  </fieldset>\n";
},"2":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],depth0,{"name":"corewizard/components/select-hbs","data":data,"indent":"      ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.ages : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["hotels-rooms-container-hbs"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.lambda, alias2=this.escapeExpression, alias3=helpers.helperMissing, alias4="function";

  return "<div class=\"rooms-container total-rooms-"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.rooms : depth0)) != null ? stack1.length : stack1), depth0))
    + " total-room-1-children-"
    + alias2(alias1(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? depth0.rooms : depth0)) != null ? stack1['0'] : stack1)) != null ? stack1.ages : stack1)) != null ? stack1.length : stack1), depth0))
    + "\" id=\""
    + alias2(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-rooms\" data-id-prefix=\""
    + alias2(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" data-highest-tnum=\"0\" data-wizard-owner=\""
    + alias2(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-room-hbs'],depth0,{"name":"corewizard/field-groups/hotels-room-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "</div>\n";
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["cars-location-hbs"] = {"1":function(depth0,helpers,partials,data) {
    return "<fieldset class=\"cols-nested origin-destination location-select-enabled\">\n";
},"3":function(depth0,helpers,partials,data) {
    return "<fieldset class=\"cols-nested origin-destination\">\n";
},"5":function(depth0,helpers,partials,data) {
    return " invalid";
},"7":function(depth0,helpers,partials,data) {
    return "show";
},"9":function(depth0,helpers,partials,data) {
    return "                class=\"error\"\n";
},"11":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/components/button-location-select-hbs'],depth0,{"name":"corewizard/components/button-location-select-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"13":function(depth0,helpers,partials,data) {
    return "                class=\"error\"\n            ";
},"15":function(depth0,helpers,partials,data) {
    return "                disabled\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression, alias4=this.lambda;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isLocationSelectEnabled : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "<div class=\"container-ta-car theme-standard autocomplete pin-left col\" data-auto-pos=\"true\" data-control=\"autocomplete\">\n  <label class=\"text type-ahead icon-before autocomplete-arrow "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.destinationError : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-pickup-label\">\n      <span class=\"label "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isDestinationValueEmpty : depth0),{"name":"if","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\">"
    + ((stack1 = alias4(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carPickupLabel : stack1), depth0)) != null ? stack1 : "")
    + "</span>\n        <input\n            type=\"text\"\n            class=\"autocomplete-trigger-input\"\n            id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-pickup\"\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.destinationError : depth0),{"name":"if","hash":{},"fn":this.program(9, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "            value=\""
    + alias3(((helper = (helper = helpers.pickup || (depth0 != null ? depth0.pickup : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"pickup","hash":{},"data":data}) : helper)))
    + "\"\n            placeholder=\""
    + alias3(((helper = (helper = helpers.carPickupPlaceholderText || (depth0 != null ? depth0.carPickupPlaceholderText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"carPickupPlaceholderText","hash":{},"data":data}) : helper)))
    + "\"\n            data-js-theme=\"typeahead\"\n            data-ta-key=\"car_origin\"\n            data-provide=\"typeahead\"\n            data-lob=\"CARS\"\n            data-mask=\"31\"\n            data-version=\"v3\"\n            data-wizard-action='{\"destination\" : \"$value1\"}'\n            data-autoselect=\"touch\" aria-autocomplete=\"list\"\n            autocomplete=\"off\"\n            spellcheck=\"false\"\n            data-tooltip-id=\"typeahead-list-category\"\n            aria-owns=\"typeahead-list-category\"\n        />\n      <span class=\"icon icon-location\" aria-hidden=\"true\"></span>\n  </label>\n    <span class=\"icon icon-close visuallyhidden clear-search\" aria-hidden=\"true\"></span>\n    <div class=\"autocomplete-dropdown\"></div>\n</div>\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isLocationSelectEnabled : depth0),{"name":"if","hash":{},"fn":this.program(11, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "<div class=\"container-ta-car theme-standard autocomplete pin-left col\" data-auto-pos=\"true\" data-control=\"autocomplete\">\n  <label class=\"text type-ahead icon-before autocomplete-arrow "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.carReturnError : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-dropoff-label\">\n      <span class=\"label "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isCarReturnValueEmpty : depth0),{"name":"if","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\">"
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carDropoffLabel : stack1), depth0))
    + "</span>\n        <input\n            type=\"text\"\n            class=\"autocomplete-trigger-input\"\n            id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-dropoff\"\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.carReturnError : depth0),{"name":"if","hash":{},"fn":this.program(13, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " value=\""
    + alias3(((helper = (helper = helpers.dropoff || (depth0 != null ? depth0.dropoff : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"dropoff","hash":{},"data":data}) : helper)))
    + "\"\n            placeholder=\""
    + alias3(((helper = (helper = helpers.carDropoffPlaceholderText || (depth0 != null ? depth0.carDropoffPlaceholderText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"carDropoffPlaceholderText","hash":{},"data":data}) : helper)))
    + "\"\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.carShowDropOff : depth0),{"name":"unless","hash":{},"fn":this.program(15, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "            data-js-theme=\"typeahead\"\n            data-ta-key=\"car_dest\"\n            data-provide=\"typeahead\"\n            data-lob=\"CARS\"\n            data-mask=\"1\"\n            data-version=\"v1\"\n            data-forceicon=\"flights\"\n            data-wizard-action='{\"carReturn\" : \"$value1\"}'\n            data-autoselect=\"touch\"\n            aria-autocomplete=\"list\"\n            autocomplete=\"off\"\n            spellcheck=\"false\"\n            data-tooltip-id=\"typeahead-list-category\"\n            aria-owns=\"typeahead-list-category\"\n            aria-labelledby=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-dropoff-label\"\n            title=\""
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carDropoffPlaceholder : stack1), depth0))
    + "\"\n            data-tracking=\"carReturnInput\"\n        />\n      <span class=\"icon icon-location\" aria-hidden=\"true\"></span>\n  </label>\n    <span class=\"icon icon-close visuallyhidden clear-search\" ></span>\n    <div class=\"autocomplete-dropdown\"></div>\n</div>\n</fieldset>\n";
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["cars-driver-age-hbs"] = {"1":function(depth0,helpers,partials,data) {
    return "false";
},"3":function(depth0,helpers,partials,data) {
    return "true";
},"5":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "      <section class=\"cols-row\">\n       \n        <fieldset class=\"col driver-age-col\">\n\n            <div class=\"container-ta-car\" data-auto-pos=\"true\" data-control=\"autocomplete\">         \n              <label class=\"driver-age-label text "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.driverAgeErrorOccured : depth0),{"name":"if","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-pickup-label\">\n                  <span class=\"label\">"
    + alias3(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.driverAge : stack1), depth0))
    + "</span>\n                    <input\n                        type=\"number\"\n                        id=\"car-driverAge\"\n                        name=\"car-driverAge\"\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.driverAgeErrorOccured : depth0),{"name":"if","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "                        value=\""
    + alias3(((helper = (helper = helpers.driverAge || (depth0 != null ? depth0.driverAge : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"driverAge","hash":{},"data":data}) : helper)))
    + "\"\n                        placeholder=\"\"\n                        data-wizard-action='{\"driverAge\" : \"$value1\"}'                    \n                    />\n              </label>\n            </div>\n\n        </fieldset>\n\n      </section>\n";
},"6":function(depth0,helpers,partials,data) {
    return " invalid";
},"8":function(depth0,helpers,partials,data) {
    return "                            class=\"error\"\n                            aria-invalid=\"true\"\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.escapeExpression, alias2=this.lambda;

  return "\n<fieldset class=\"cols-nested driver-age\">\n    \n      <!--driver age checkbox (data, type, namespace, bool, options)-->\n      "
    + alias1((helpers.input || (depth0 && depth0.input) || helpers.helperMissing).call(depth0,depth0,"checkbox","driver-age-checkbox",(depth0 != null ? depth0.isCarDriverAgeWithinLimit : depth0),{"name":"input","hash":{"wizard-action":"{\"isCarDriverAgeWithinLimit\" : $value1}","label-text":(depth0 != null ? depth0.driverAgeLabel : depth0)},"data":data}))
    + "\n\n      <!--driver age tooltip-->\n      <a  href=\"#car-driver-age-help-container\" \n          class=\"driver-age-tooltip\"  \n          id=\"driver-age-help-default\" \n          data-control=\"tooltip\" \n          data-width=\"300\" \n          data-arrow=\"true\" \n          aria-describedby=\"car-driver-age-help-container\" \n          data-fade=\"out\" \n          data-manual=\"none\" \n          data-tooltip-classes=\"example\" \n          data-wizard-action='{\"driverAgeTooltipSelected\" : "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.driverAgeTooltipSelected : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + " }'\n          >\n\n          <span class=\"icon icon-info driver-age-info-icon\"><span class=\"visuallyhidden\">"
    + alias1(alias2(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.driverAgeToottipAltMessageText : stack1), depth0))
    + "</span></span>\n      </a>\n\n      <div id=\"car-driver-age-help-container\" role=\"tooltip\" class=\"visuallyhidden\"><p>"
    + alias1(alias2(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.driverAgeToottipMessageText : stack1), depth0))
    + "</p></div>\n\n  </fieldset>\n\n  <!--driver age textbox-->\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.isCarDriverAgeWithinLimit : depth0),{"name":"unless","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true};
this["Handlebars"]["templates"]["flights-children-hbs"] = {"1":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.ages : depth0),{"name":"each","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"2":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],depth0,{"name":"corewizard/components/select-hbs","data":data,"indent":"      ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression, alias2=helpers.helperMissing, alias3="function";

  return "<fieldset class=\"total-children-"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.ages : depth0)) != null ? stack1.length : stack1), depth0))
    + " children-fieldset cols-nested\" id=\""
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-children-ages\" data-wizard-owner=\""
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.hidePassengerInfo : depth0),{"name":"unless","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</fieldset>\n";
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["flights-multi-destination-hbs"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<div id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-flights\" class=\"multi-dest-container\" data-highest-tnum=\"1\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-flight-hbs'],depth0,{"name":"corewizard/field-groups/flights-flight-hbs","data":data,"indent":"  ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "</div>\n";
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["hotels-dates-hbs"] = {"1":function(depth0,helpers,partials,data) {
    return "  "
    + this.escapeExpression((helpers.assign || (depth0 && depth0.assign) || helpers.helperMissing).call(depth0,depth0,"id","=","flight-hotel",{"name":"assign","hash":{},"data":data}))
    + "\n";
},"3":function(depth0,helpers,partials,data) {
    var helper;

  return "\n        <div class=\"length-of-stay-counter col\" id=\"length-of-stay-counter\">\n          "
    + this.escapeExpression(((helper = (helper = helpers.hotelLengthOfStayString || (depth0 != null ? depth0.hotelLengthOfStayString : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"hotelLengthOfStayString","hash":{},"data":data}) : helper)))
    + "\n        </div>\n\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, alias1=helpers.helperMissing, alias2=this.escapeExpression;

  return "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isFlightTab : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + alias2((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || alias1).call(depth0,depth0,"checkin",{"name":"input-calendar","hash":{"label-show":(depth0 != null ? depth0.isStartDateValueEmpty : depth0),"ia-value":(depth0 != null ? depth0.checkinValue : depth0),"ia-data-min-range-length":(depth0 != null ? depth0.minTripLength : depth0),"ia-data-default-range-length":1,"ia-data-last-valid-date":(depth0 != null ? depth0.lastValidDate : depth0),"ia-data-max-range-length":(depth0 != null ? depth0.maxTripLength : depth0),"ia-data-max-booking-length":(depth0 != null ? depth0.maxTripLength : depth0),"has-error":(depth0 != null ? depth0.startDateHotelError : depth0),"wizard-action":(depth0 != null ? depth0.checkinAction : depth0),"class":"check-in-out","label-text":(depth0 != null ? depth0.hotelCheckinLabel : depth0)},"data":data}))
    + "\n"
    + alias2((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || alias1).call(depth0,depth0,"checkout",{"name":"input-calendar","hash":{"label-show":(depth0 != null ? depth0.isEndDateValueEmpty : depth0),"aria-describedby":"length-of-stay-counter","ia-value":(depth0 != null ? depth0.checkoutValue : depth0),"has-error":(depth0 != null ? depth0.endDateHotelError : depth0),"wizard-action":(depth0 != null ? depth0.checkoutAction : depth0),"class":"check-in-out","label-text":(depth0 != null ? depth0.hotelCheckoutLabel : depth0)},"data":data}))
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showLengthOfStay : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true};
this["Handlebars"]["templates"]["partial-stay-hbs"] = {"1":function(depth0,helpers,partials,data) {
    var stack1;

  return "    "
    + this.escapeExpression((helpers.input || (depth0 && depth0.input) || helpers.helperMissing).call(depth0,depth0,"checkbox","partialHotelBooking",(depth0 != null ? depth0.isPartialStay : depth0),{"name":"input","hash":{"wizard-action":"{\"isPartialStay\" : $value1}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.partialStayLabel : stack1)},"data":data}))
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showPartialStay : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true};
this["Handlebars"]["templates"]["cars-package-hbs"] = {"1":function(depth0,helpers,partials,data) {
    return "  "
    + this.escapeExpression((helpers.assign || (depth0 && depth0.assign) || helpers.helperMissing).call(depth0,depth0,"id","=","hotel-car",{"name":"assign","hash":{},"data":data}))
    + "\n";
},"3":function(depth0,helpers,partials,data) {
    return "  "
    + this.escapeExpression((helpers.assign || (depth0 && depth0.assign) || helpers.helperMissing).call(depth0,depth0,"id","=","flight-car",{"name":"assign","hash":{},"data":data}))
    + "\n";
},"5":function(depth0,helpers,partials,data) {
    var stack1;

  return "          <div class=\"driver-age-package-wrapper\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/cars-driver-age-hbs'],depth0,{"name":"corewizard/field-groups/cars-driver-age-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "          </div>\n";
},"7":function(depth0,helpers,partials,data) {
    var stack1;

  return "      <p>"
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carWillBeAddedLabel : stack1), depth0))
    + "</p>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isHotelTab : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isFlightTab : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n<div id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" data-remove-type=\"cars-package\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.parent || (depth0 != null ? depth0.parent : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"parent","hash":{},"data":data}) : helper)))
    + "\">\n   	<!--Car Driver Age fieldset-->\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showCarDriverAge : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.showCarDriverAge : depth0),{"name":"unless","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n";
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["flights-children-help-and-options-hbs"] = {"1":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.lambda, alias2=this.escapeExpression, alias3=helpers.helperMissing, alias4="function";

  return "<fieldset class=\"three-pp-airline-age-rules cols-nested\">\n  <label class=\"col three-pp-airline-age-rules-label\">\n      <span class=\"label\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.ageHelpMessage : stack1), depth0))
    + "</span>\n  </label>\n  <a href=\"/p/info-main/h_fw_default?rhtx=HTX_FLTSRCH_RT#travs\" class=\"link age-rules\" id=\""
    + alias2(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-children-help\" data-wizard-owner=\""
    + alias2(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" target=\"_blank\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.airlineAgeRules : stack1), depth0))
    + " <span class=\"visuallyhidden\">opens in a new window</span><span aria-hidden=\"true\" class=\"icon icon-popup\"></span></a>\n</fieldset>\n";
},"3":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<a href=\"/p/info-main/h_fw_default?rhtx=HTX_FLTSRCH_RT#travs\" class=\"link age-rules\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-children-help\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" target=\"_blank\">"
    + alias3(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.airlineAgeRules : stack1), depth0))
    + " <span class=\"visuallyhidden\">opens in a new window</span><span aria-hidden=\"true\" class=\"icon icon-popup\"></span></a>\n";
},"5":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<div id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-lap-or-seat-container\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-lap-or-seat-hbs'],depth0,{"name":"corewizard/field-groups/flights-lap-or-seat-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "</div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isThreePP : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.isThreePP : depth0),{"name":"unless","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showLapOrSeat : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["flights-origin-destination-hbs"] = {"1":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/flights-destination-hbs'],depth0,{"name":"corewizard/fields/flights-destination-hbs","data":data,"indent":"      ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "  <fieldset class=\"cols-nested origin-destination typeahead-container\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/fields/flights-origin-hbs'],depth0,{"name":"corewizard/fields/flights-origin-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.hideFlightDestination : depth0),{"name":"unless","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "  </fieldset>\n";
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["packages-origin-destination-hbs"] = {"1":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/packages-destination-hbs'],depth0,{"name":"corewizard/fields/packages-destination-hbs","data":data,"indent":"      ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "  <fieldset class=\"cols-nested origin-destination typeahead-container\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/fields/packages-origin-hbs'],depth0,{"name":"corewizard/fields/packages-origin-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.hideFlightDestination : depth0),{"name":"unless","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "  </fieldset>\n";
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["hotels-hbs"] = {"1":function(depth0,helpers,partials,data) {
    var stack1;

  return "      <fieldset class=\"cols-nested destination-only\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/fields/hotel-destination-hbs'],depth0,{"name":"corewizard/fields/hotel-destination-hbs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "      </fieldset>\n";
},"3":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda, alias2=this.escapeExpression;

  return "            <label id=\"hotel-1-guests-label\" class=\"select icon col icon-toggle180 \">\n                <span class=\"label\">"
    + ((stack1 = alias1(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.guestsLabel : stack1), depth0)) != null ? stack1 : "")
    + "</span>\n                <select id=\"hotel-1-guests\" data-wizard-action=\"{&quot;guestMoreOptionsSelected&quot; : $value1}\">\n                   <option selected=\"selected\" value=\"2\"> "
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.hotelPreFilledOptions2Adults : stack1), depth0))
    + " </option>\n                   <option value=\"1\"> "
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.hotelPreFilledOptions1Adult : stack1), depth0))
    + " </option>\n                   <option value=\"99\"> "
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.hotelPreFilledOptionsMoreOptions : stack1), depth0))
    + " </option>\n                </select>\n            </label>\n";
},"5":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],(depth0 != null ? depth0.hotelRoomCountOptions : depth0),{"name":"corewizard/components/select-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "            <div class=\"rooms-container stacked-rooms total-rooms-"
    + alias1(((helper = (helper = helpers.roomCount || (depth0 != null ? depth0.roomCount : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"roomCount","hash":{},"data":data}) : helper)))
    + " total-room-1-children-"
    + alias1(this.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? depth0.rooms : depth0)) != null ? stack1['0'] : stack1)) != null ? stack1.ages : stack1)) != null ? stack1.length : stack1), depth0))
    + "\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-rooms-container-hbs'],depth0,{"name":"corewizard/field-groups/hotels-rooms-container-hbs","data":data,"indent":"               ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "            </div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "<div class=\"total-rooms-"
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.rooms : depth0)) != null ? stack1.length : stack1), depth0))
    + "\" id=\""
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isHotelDestinationVisible : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    <fieldset class=\"cols-nested\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-dates-hbs'],depth0,{"name":"corewizard/field-groups/hotels-dates-hbs","data":data,"indent":"\t      ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.useDetailedGuestDropdown : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.program(5, data, 0),"data":data})) != null ? stack1 : "")
    + "    </fieldset>\n\n</div>\n";
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["vacation-rental-hbs"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda;

  return "<fieldset class=\"cols-nested destination-only\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/fields/hotel-destination-hbs'],depth0,{"name":"corewizard/fields/hotel-destination-hbs","data":data,"indent":"  ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "</fieldset>\n\n  <fieldset class=\"cols-nested\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-dates-hbs'],depth0,{"name":"corewizard/field-groups/hotels-dates-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "    <label id=\"hotel-1-guests-label\" class=\"select icon col icon-toggle180 \">\n        <span class=\"label\">"
    + ((stack1 = alias1(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.guestsLabel : stack1), depth0)) != null ? stack1 : "")
    + "</span>\n     <select id=\"hotel-1-guests\" data-wizard-action=\"{&quot;rooms[0].adults&quot; : $value1}\" data-select-value=\""
    + this.escapeExpression(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.rooms : depth0)) != null ? stack1['0'] : stack1)) != null ? stack1.adults : stack1), depth0))
    + "\">\n         <option selected=\"selected\" value=\"1\"> 1 </option>\n         <option value=\"2\"> 2 </option>\n         <option value=\"3\"> 3 </option>\n         <option value=\"4\"> 4 </option>\n         <option value=\"5\"> 5 </option>\n         <option value=\"6\"> 6 </option>\n         <option value=\"7\"> 7 </option>\n         <option value=\"8\"> 8 </option>\n         <option value=\"9\"> 9 </option>\n         <option value=\"10\"> 10 </option>\n         <option value=\"11\"> 11+ </option>\n         <option value=\"12\"> 12+ </option>\n         <option value=\"13\"> 13+ </option>\n     </select>\n   </label>\n  </fieldset>\n";
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["flights-dates-hbs"] = {"1":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/flights-returning-hbs'],depth0,{"name":"corewizard/fields/flights-returning-hbs","data":data,"indent":"  ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/flights-departing-hbs'],depth0,{"name":"corewizard/fields/flights-departing-hbs","data":data,"helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isRoundtrip : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["flights-passengers-hbs"] = {"1":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "		<fieldset id=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-children-fieldset\" class=\"cols-nested\">\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.hidePassengerInfo : depth0),{"name":"unless","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "		</fieldset>\n";
},"2":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.ages : depth0),{"name":"each","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"3":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],depth0,{"name":"corewizard/components/select-hbs","data":data,"indent":"\t\t\t\t\t","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"5":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.hidePassengerInfo : depth0),{"name":"unless","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"6":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.ages : depth0),{"name":"each","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"7":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],depth0,{"name":"corewizard/components/select-hbs","data":data,"indent":"\t\t\t\t","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<div id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-passengers\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],(depth0 != null ? depth0.flightAdultCountOptions : depth0),{"name":"corewizard/components/select-hbs","data":data,"indent":"\t","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],(depth0 != null ? depth0.flightChildCountOptions : depth0),{"name":"corewizard/components/select-hbs","data":data,"indent":"\t","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.ab11873 : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(5, data, 0),"data":data})) != null ? stack1 : "")
    + "</div>\n";
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["flights-flight-hbs"] = {"1":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "  <hr class=\"default\" />\n  <fieldset data-number=\""
    + alias3(((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"number","hash":{},"data":data}) : helper)))
    + "\" data-container=\""
    + alias3(((helper = (helper = helpers.container || (depth0 != null ? depth0.container : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"container","hash":{},"data":data}) : helper)))
    + "\" class=\"cols-nested origin-destination additional-flight\">\n    <legend id=\"flight-"
    + alias3(((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"number","hash":{},"data":data}) : helper)))
    + "\">"
    + alias3(this.lambda(((stack1 = (depths[1] != null ? depths[1].loc : depths[1])) != null ? stack1.flightLabel : stack1), depth0))
    + " "
    + alias3(((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"number","hash":{},"data":data}) : helper)))
    + "</legend>\n    "
    + alias3((helpers['input-TA'] || (depth0 && depth0['input-TA']) || alias1).call(depth0,depth0,"origin",{"name":"input-TA","hash":{"ia-data-lob":"FLIGHTS","ia-value":(depth0 != null ? depth0.origin : depth0),"ia-placeholder":((stack1 = (depths[1] != null ? depths[1].loc : depths[1])) != null ? stack1.flightPlaceholderText : stack1),"ia-data-number":(depth0 != null ? depth0.number : depth0),"ta-key":"flight_multi","has-error":(depth0 != null ? depth0.originError : depth0),"wizard-action":(depth0 != null ? depth0.originWizardAction : depth0),"label-text":((stack1 = (depths[1] != null ? depths[1].loc : depths[1])) != null ? stack1.flightOriginLabel : stack1)},"data":data}))
    + "\n\n    "
    + alias3((helpers['input-TA'] || (depth0 && depth0['input-TA']) || alias1).call(depth0,depth0,"destination",{"name":"input-TA","hash":{"ia-data-lob":"FLIGHTS","ia-placeholder":((stack1 = (depths[1] != null ? depths[1].loc : depths[1])) != null ? stack1.flightPlaceholderText : stack1),"ia-data-number":(depth0 != null ? depth0.number : depth0),"ia-value":(depth0 != null ? depth0.destination : depth0),"ta-key":"flight_multi","has-error":(depth0 != null ? depth0.destinationError : depth0),"wizard-action":(depth0 != null ? depth0.destinationWizardAction : depth0),"label-text":((stack1 = (depths[1] != null ? depths[1].loc : depths[1])) != null ? stack1.flightDestinationLabel : stack1)},"data":data}))
    + "\n\n    "
    + alias3((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || alias1).call(depth0,depth0,"departing",{"name":"input-calendar","hash":{"ia-value":(depth0 != null ? depth0.departing : depth0),"has-error":(depth0 != null ? depth0.startDateError : depth0),"wizard-action":(depth0 != null ? depth0.dateWizardAction : depth0),"label-text":((stack1 = (depths[1] != null ? depths[1].loc : depths[1])) != null ? stack1.flightDepartingLabel : stack1)},"data":data}))
    + "\n  </fieldset>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.multidest : depth0),{"name":"each","hash":{},"fn":this.program(1, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true,"useDepths":true};
this["Handlebars"]["templates"]["flights-type-hbs"] = {"1":function(depth0,helpers,partials,data) {
    var stack1;

  return "          "
    + this.escapeExpression((helpers.input || (depth0 && depth0.input) || helpers.helperMissing).call(depth0,depth0,"radio","type-multi-dest",(depth0 != null ? depth0.isMultiDest : depth0),{"name":"input","hash":{"ia-value":"multi","ia-name":"flight-type","wizard-action":"{\"flighttype\" : \"$value1\", \"packages.hotel\":false, \"packages.car\":false, \"packages.flight\": false}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightMultidestLabel : stack1),"class":"col"},"data":data}))
    + "\n";
},"3":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda, alias2=this.escapeExpression;

  return "\n\n      <a href=\"#flight-type-help-container\" id=\"flight-type-help-default\" data-control=\"tooltip\" data-width=\"300\" data-arrow=\"true\" aria-describedby=\"flight-type-help-container\" data-fade=\"out\" data-manual=\"none\" data-tooltip-classes=\"example\"><span class=\"icon icon-help\"><span class=\"visuallyhidden\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightTypeHelpToolTipText : stack1), depth0))
    + "</span></span></a><div id=\"flight-type-help-container\" role=\"tooltip\" class=\"visuallyhidden\"><p>"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightTypeHelpMessage : stack1), depth0))
    + "</p></div>\n\n\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, alias1=helpers.helperMissing, alias2=this.escapeExpression;

  return "<fieldset class=\"flight-type-select\">\n   <legend class=\"visuallyhidden\">Flight type - changes form below</legend>\n      "
    + alias2((helpers.input || (depth0 && depth0.input) || alias1).call(depth0,depth0,"radio","type-roundtrip",(depth0 != null ? depth0.isRoundtrip : depth0),{"name":"input","hash":{"ia-value":"roundtrip","ia-name":"flight-type","wizard-action":"{\"flighttype\" : \"$value1\"}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightRoundtripLabel : stack1),"class":"col"},"data":data}))
    + "\n\n      "
    + alias2((helpers.input || (depth0 && depth0.input) || alias1).call(depth0,depth0,"radio","type-one-way",(depth0 != null ? depth0.isOneWay : depth0),{"name":"input","hash":{"ia-value":"oneway","ia-name":"flight-type","wizard-action":"{\"flighttype\" : \"$value1\", \"packages.hotel\":false, \"packages.car\":false, \"packages.flight\": false}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightOnewayLabel : stack1),"class":"col"},"data":data}))
    + "\n\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasMultiDestFlight : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.isFlightOnly : depth0),{"name":"unless","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n</fieldset>\n";
},"useData":true};
this["Handlebars"]["templates"]["hotels-room-hbs"] = {"1":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<div class=\"cols-row hotel-room room-count-"
    + alias3(((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"number","hash":{},"data":data}) : helper)))
    + " total-children-"
    + alias3(this.lambda(((stack1 = (depth0 != null ? depth0.ages : depth0)) != null ? stack1.length : stack1), depth0))
    + "\" id="
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + " data-number=\""
    + alias3(((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"number","hash":{},"data":data}) : helper)))
    + "\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.ownerId || (depth0 != null ? depth0.ownerId : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"ownerId","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\">\n    <fieldset class=\"occupants-select\">\n    <legend class=\"room-count-legend\">"
    + alias3(((helper = (helper = helpers.label || (depth0 != null ? depth0.label : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"label","hash":{},"data":data}) : helper)))
    + "</legend>\n"
    + ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],(depth0 != null ? depth0.hotelAdultCountOptions : depth0),{"name":"corewizard/components/select-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],(depth0 != null ? depth0.hotelChildCountOptions : depth0),{"name":"corewizard/components/select-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "  </fieldset>\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-children-fieldset-hbs'],depth0,{"name":"corewizard/field-groups/hotels-children-fieldset-hbs","data":data,"indent":"  ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "</div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.rooms : depth0),{"name":"each","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["package-price-savings"] = {"1":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showFlightHotelPackageUpsell : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.program(5, data, 0),"data":data})) != null ? stack1 : "");
},"2":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "            <p class=\"fh\">\n                <strong>"
    + alias1(((helper = (helper = helpers.fhMessage1Formatted || (depth0 != null ? depth0.fhMessage1Formatted : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"fhMessage1Formatted","hash":{},"data":data}) : helper)))
    + "</strong>\n                <br />\n                "
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.fhMessage2 : stack1), depth0))
    + "\n            </p>\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showPackageSavingsDisclaimer : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"3":function(depth0,helpers,partials,data) {
    var stack1;

  return "                <p class=\"fh package-val-prop-disclaimer\">"
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.disclaimer : stack1), depth0))
    + "</p>\n";
},"5":function(depth0,helpers,partials,data) {
    var stack1;

  return "            <p class=\"nonfh single-line-val-prop\" id=\"single-line-val-prop\">\n                <strong>"
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.nonfhMessage : stack1), depth0))
    + "</strong>\n            </p>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<div id=\"fh-msg-tooltip\" class=\"sub-600 package-val-prop\">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showPackageValueMessage : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n";
},"useData":true};
this["Handlebars"]["templates"]["open-search-hbs"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/title-hbs'],depth0,{"name":"corewizard/fields/title-hbs","data":data,"helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + " <section class=\"tab-pane on\" id=\"tab-openSearch\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/error-messages-hbs'],depth0,{"name":"corewizard/field-groups/error-messages-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "    <fieldset class=\"cols-nested destination-only\">\n        "
    + this.escapeExpression((helpers['input-TA'] || (depth0 && depth0['input-TA']) || helpers.helperMissing).call(depth0,depth0,"searchQuery",{"name":"input-TA","hash":{"label-show":(depth0 != null ? depth0.isSearchQueryValueEmpty : depth0),"openSearch":true,"ia-data-lob":"OPENSEARCH","ta-key":"openSearch","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.openSearchLabel : stack1),"ia-value":(depth0 != null ? depth0.searchQuery : depth0),"has-error":(depth0 != null ? depth0.openSearchError : depth0),"wizard-action":"{\"searchQuery\" : \"$value1\"}"},"data":data}))
    + "\n    </fieldset>\n </section>\n";
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["rail-hbs"] = {"1":function(depth0,helpers,partials,data) {
    var stack1;

  return "    <fieldset class=\"cols-nested\">\n        "
    + this.escapeExpression((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || helpers.helperMissing).call(depth0,depth0,"returning",{"name":"input-calendar","hash":{"ia-aria-required":"true","ia-value":(depth0 != null ? depth0.endDate : depth0),"has-error":(depth0 != null ? depth0.endDateError : depth0),"wizard-action":"{\"endDate\" : \"$value1\"}","label-text":((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.rail : stack1)) != null ? stack1.returningLabel : stack1)},"data":data}))
    + "\n\n"
    + ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],(depth0 != null ? depth0.returningSearchBy : depth0),{"name":"corewizard/components/select-hbs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],(depth0 != null ? depth0.returningTimeOptions : depth0),{"name":"corewizard/components/select-hbs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n    </fieldset>\n";
},"3":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "            <fieldset id=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-children\" class=\"cols-nested children-fieldset\">\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.railChildAges : depth0),{"name":"each","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "            </fieldset>\n";
},"4":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],depth0,{"name":"corewizard/components/select-hbs","data":data,"indent":"                    ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"6":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "            <fieldset id=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-youth\" class=\"cols-nested youths-fieldset\">\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.railYouthAges : depth0),{"name":"each","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "            </fieldset>\n";
},"8":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "            <fieldset id=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-senior\" class=\"cols-nested seniors-fieldset\">\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.railSeniorAges : depth0),{"name":"each","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "            </fieldset>\n";
},"10":function(depth0,helpers,partials,data) {
    var stack1;

  return " "
    + ((stack1 = this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.rail : stack1)) != null ? stack1.railCard : stack1), depth0)) != null ? stack1 : "");
},"12":function(depth0,helpers,partials,data) {
    var stack1;

  return " "
    + ((stack1 = this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.rail : stack1)) != null ? stack1.railCardPlural : stack1), depth0)) != null ? stack1 : "")
    + " ";
},"14":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper;

  return "            <fieldset id=\"railcards-list-fieldset-"
    + this.escapeExpression(((helper = (helper = helpers.index || (data && data.index)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" class=\"cols-nested\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],(depth0 != null ? depth0.type : depth0),{"name":"corewizard/components/select-hbs","data":data,"indent":"                ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],(depth0 != null ? depth0.count : depth0),{"name":"corewizard/components/select-hbs","data":data,"indent":"                ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depths[1] != null ? depths[1].showRemoveButton : depths[1]),{"name":"if","hash":{},"fn":this.program(15, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "            </fieldset>\n";
},"15":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.lambda;

  return "                    <a  href=\"#railcards-list-fieldset\"\n                        role=\"button\"\n                        id=\"remove-rail-card-"
    + this.escapeExpression(((helper = (helper = helpers.index || (data && data.index)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\"\n                        aria-controls=\"advanced-options-fields\"\n                        data-wizard-action='"
    + ((stack1 = alias1((depth0 != null ? depth0.remove : depth0), depth0)) != null ? stack1 : "")
    + "'\n                    > <span class=\"icon icon-remove-rail\" title=\""
    + ((stack1 = alias1((depth0 != null ? depth0.deleteCardLabel : depth0), depth0)) != null ? stack1 : "")
    + "\"></span><span class=\"alt\">"
    + ((stack1 = alias1((depth0 != null ? depth0.deleteCardLabel : depth0), depth0)) != null ? stack1 : "")
    + "</span></a>\n";
},"17":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.lambda;

  return "          <a  href=\"#railcards-fieldset\"\n              role=\"button\"\n              id=\"add-rail-card\"\n             class=\"link show-options toggle-trigger\"\n              aria-controls=\"advanced-options-fields\"\n              data-wizard-action='"
    + ((stack1 = ((helper = (helper = helpers.addRailCard || (depth0 != null ? depth0.addRailCard : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"addRailCard","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "'\n              data-redraw=\"true\"\n              aria-redraw=\"true\"\n         ><span aria-hidden=\"true\" title=\""
    + ((stack1 = alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.rail : stack1)) != null ? stack1.addCard : stack1), depth0)) != null ? stack1 : "")
    + "\"></span>"
    + ((stack1 = alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.rail : stack1)) != null ? stack1.addCard : stack1), depth0)) != null ? stack1 : "")
    + "</a>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<div id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/rail-type-hbs'],depth0,{"name":"corewizard/field-groups/rail-type-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n    <fieldset class=\"origin-destination typeahead-container cols-nested\">\n\n        "
    + alias3((helpers['input-TA'] || (depth0 && depth0['input-TA']) || alias1).call(depth0,depth0,"origin",{"name":"input-TA","hash":{"ia-aria-required":"true","ia-placeholder":((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.rail : stack1)) != null ? stack1.originPlaceholder : stack1),"ia-data-lob":"RAILS","ia-value":(depth0 != null ? depth0.trainOrigin : depth0),"ta-key":"rail_origin","has-error":(depth0 != null ? depth0.railsOriginErrors : depth0),"wizard-action":"{\"trainOrigin\" : \"$value1\"}","label-text":((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.rail : stack1)) != null ? stack1.originLabel : stack1),"id":(depth0 != null ? depth0.id : depth0)},"data":data}))
    + "\n\n        "
    + alias3((helpers['input-TA'] || (depth0 && depth0['input-TA']) || alias1).call(depth0,depth0,"destination",{"name":"input-TA","hash":{"ia-aria-required":"true","ia-placeholder":((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.rail : stack1)) != null ? stack1.destinationPlaceholder : stack1),"ia-data-lob":"RAILS","ia-value":(depth0 != null ? depth0.trainDestination : depth0),"ta-key":"rail_dest","has-error":(depth0 != null ? depth0.railsDestinationErrors : depth0),"wizard-action":"{\"trainDestination\" : \"$value1\"}","label-text":((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.rail : stack1)) != null ? stack1.destinationLabel : stack1)},"data":data}))
    + "\n\n    </fieldset>\n\n    <fieldset class=\"cols-nested\">\n        "
    + alias3((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || alias1).call(depth0,depth0,"departing",{"name":"input-calendar","hash":{"ia-aria-required":"true","ia-value":(depth0 != null ? depth0.startDate : depth0),"ia-data-tid":"rail-departing","ia-data-default-range-length":1,"ia-data-min-booking-length":(depth0 != null ? depth0.minTripLength : depth0),"ia-data-last-valid-date":(depth0 != null ? depth0.lastValidDate : depth0),"ia-data-max-booking-length":(depth0 != null ? depth0.maxTripLength : depth0),"has-error":(depth0 != null ? depth0.startDateError : depth0),"wizard-action":"{\"startDate\" : \"$value1\"}","label-text":((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.rail : stack1)) != null ? stack1.departureLabel : stack1)},"data":data}))
    + "\n\n"
    + ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],(depth0 != null ? depth0.departingSearchBy : depth0),{"name":"corewizard/components/select-hbs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],(depth0 != null ? depth0.departureTimeOptions : depth0),{"name":"corewizard/components/select-hbs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "    </fieldset>\n\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isRoundtrip : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n    <fieldset class=\"cols-nested\">\n        <div class=\"col\">\n            <fieldset class=\"cols-nested\">\n                <div id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-passengers\" >\n"
    + ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],(depth0 != null ? depth0.railAdults : depth0),{"name":"corewizard/components/select-hbs","data":data,"indent":"                    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],(depth0 != null ? depth0.railChildren : depth0),{"name":"corewizard/components/select-hbs","data":data,"indent":"                    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],(depth0 != null ? depth0.railYouth : depth0),{"name":"corewizard/components/select-hbs","data":data,"indent":"                    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],(depth0 != null ? depth0.railSenior : depth0),{"name":"corewizard/components/select-hbs","data":data,"indent":"                    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "                </div>\n            </fieldset>\n\n"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = ((stack1 = (depth0 != null ? depth0.rooms : depth0)) != null ? stack1['0'] : stack1)) != null ? stack1.childCount : stack1),{"name":"if","hash":{},"fn":this.program(3, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = ((stack1 = (depth0 != null ? depth0.rooms : depth0)) != null ? stack1['0'] : stack1)) != null ? stack1.youthCount : stack1),{"name":"if","hash":{},"fn":this.program(6, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = ((stack1 = (depth0 != null ? depth0.rooms : depth0)) != null ? stack1['0'] : stack1)) != null ? stack1.seniorCount : stack1),{"name":"if","hash":{},"fn":this.program(8, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n        </div>\n    </fieldset>\n\n    <fieldset id=\"addrailcards-fieldset\" class=\"cols-nested\">\n        <div class=\"col\">\n        <span id=\"railcards-label\" class=\"label\">\n            "
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.railCardsOptions : depth0),{"name":"unless","hash":{},"fn":this.program(10, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n            "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.railCardsOptions : depth0),{"name":"if","hash":{},"fn":this.program(12, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n        </span>\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.railCardsOptions : depth0),{"name":"each","hash":{},"fn":this.program(14, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showAddRailCardLink : depth0),{"name":"if","hash":{},"fn":this.program(17, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n        </div>\n    </fieldset>\n</div>\n";
},"usePartial":true,"useData":true,"useDepths":true};
this["Handlebars"]["templates"]["rail-type-hbs"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, alias1=helpers.helperMissing, alias2=this.escapeExpression;

  return "<fieldset class=\"radio-set\">\n   <legend class=\"visuallyhidden\">Train type - changes form below</legend>\n      "
    + alias2((helpers.input || (depth0 && depth0.input) || alias1).call(depth0,depth0,"radio","type-one-way",(depth0 != null ? depth0.isOneWay : depth0),{"name":"input","hash":{"ia-value":"oneway","ia-name":"rail-type","wizard-action":"{\"rail.type\" : \"$value1\"}","label-text":((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.rail : stack1)) != null ? stack1.oneWayLabel : stack1),"class":"col"},"data":data}))
    + "\n\n      "
    + alias2((helpers.input || (depth0 && depth0.input) || alias1).call(depth0,depth0,"radio","type-roundtrip",(depth0 != null ? depth0.isRoundtrip : depth0),{"name":"input","hash":{"ia-value":"roundtrip","ia-name":"rail-type","wizard-action":"{\"rail.type\" : \"$value1\"}","label-text":((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.rail : stack1)) != null ? stack1.roundTripLabel : stack1),"class":"col"},"data":data}))
    + "\n</fieldset>\n";
},"useData":true};
this["Handlebars"]["templates"]["cars-hotels-hbs"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda, alias2=this.escapeExpression;

  return ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],(depth0 != null ? depth0.hotelRoomCountOptions : depth0),{"name":"corewizard/components/select-hbs","data":data,"helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "<div class=\"rooms-container stacked-rooms total-rooms-"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.rooms : depth0)) != null ? stack1.length : stack1), depth0))
    + " total-room-1-children-"
    + alias2(alias1(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? depth0.rooms : depth0)) != null ? stack1['0'] : stack1)) != null ? stack1.ages : stack1)) != null ? stack1.length : stack1), depth0))
    + "\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-rooms-container-hbs'],depth0,{"name":"corewizard/field-groups/hotels-rooms-container-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "</div>";
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["cars-hotels-package-hbs"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"package-container-text\">\n    <p>"
    + this.escapeExpression(this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carOptionsLoc : stack1)) != null ? stack1.carAddMessage : stack1), depth0))
    + "</p>\n</div>\n";
},"useData":true};
this["Handlebars"]["templates"]["cars-rental-company"] = {"1":function(depth0,helpers,partials,data) {
    return "	<option value=\"\">No Preference</option>\n	<option value=\"AC\">ACE Rent A Car</option>\n	<option value=\"AD\">Advantage Rent-A-Car</option>\n	<option value=\"AL\">Alamo Rent A Car</option>\n	<option value=\"ZI\">Avis</option>\n	<option value=\"ZD\">Budget</option>\n	<option value=\"ZR\">Dollar Rent A Car</option>\n	<option value=\"EY\">Economy Rent a Car</option>\n	<option value=\"ET\">Enterprise</option>\n	<option value=\"EP\">Europcar</option>\n	<option value=\"FX\">Fox Rental Cars</option>\n	<option value=\"ZE\">Hertz</option>\n	<option value=\"MW\">Midway Car Rental</option>\n	<option value=\"ZL\">National Car Rental</option>\n	<option value=\"NU\">N&#252; Car</option>\n	<option value=\"ZA\">Payless</option>\n	<option value=\"SX\">Sixt</option>\n	<option value=\"ZT\">Thrifty Car Rental</option>\n	<option value=\"SV\">U-Save</option>\n";
},"3":function(depth0,helpers,partials,data) {
    return "	<option value=\"\">-- Select from the list --</option>\n	<option value=\"ZI\">Avis</option>\n	<option value=\"ZD\">Budget</option>\n	<option value=\"ZR\">Dollar Rent A Car</option>\n	<option value=\"ET\">Enterprise</option>\n	<option value=\"EP\">Europcar</option>\n	<option value=\"ZE\">Hertz</option>\n	<option value=\"ZA\">Payless</option>\n	<option value=\"ZT\">Thrifty Car Rental</option>\n	<option value=\"AC\">ACE Rent A Car</option>\n	<option value=\"AD\">Advantage Rent-A-Car</option>\n	<option value=\"AL\">Alamo Rent A Car</option>\n	<option value=\"EY\">Economy Rent a Car</option>\n	<option value=\"ZL\">National Car Rental</option>\n	<option value=\"NU\">N&#252; Car</option>\n	<option value=\"SX\">Sixt</option>\n";
},"5":function(depth0,helpers,partials,data) {
    return "	<option value=\"\">-- Select from the list --</option>\n	<option value=\"ZI\">Avis</option>\n	<option value=\"ZD\">Budget</option>\n	<option value=\"ZR\">Dollar Rent A Car</option>\n	<option value=\"ET\">Enterprise</option>\n	<option value=\"EP\">Europcar</option>\n	<option value=\"ZE\">Hertz</option>\n	<option value=\"ZA\">Payless</option>\n	<option value=\"ZT\">Thrifty Car Rental</option>\n	<option value=\"AC\">ACE Rent A Car</option>\n	<option value=\"AD\">Advantage Rent-A-Car</option>\n	<option value=\"AL\">Alamo Rent A Car</option>\n	<option value=\"EY\">Economy Rent a Car</option>\n	<option value=\"FX\">Fox Rental Cars</option>\n	<option value=\"ZL\">National Car Rental</option>\n	<option value=\"NU\">N&#252; Car</option>\n	<option value=\"SX\">Sixt</option>\n	<option value=\"SV\">U-Save</option>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.allVendors : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.corporateVendors : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.specialVendors : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true};
this["Handlebars"]["templates"]["flights-departing-hbs"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return this.escapeExpression((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || helpers.helperMissing).call(depth0,depth0,"departing",{"name":"input-calendar","hash":{"label-show":(depth0 != null ? depth0.isStartDateValueEmpty : depth0),"ia-aria-required":"true","ia-value":(depth0 != null ? depth0.startDate : depth0),"ia-data-tid":"flight-departing","ia-data-default-range-length":1,"ia-data-min-range-length":(depth0 != null ? depth0.minTripLength : depth0),"ia-data-min-booking-length":(depth0 != null ? depth0.minTripLength : depth0),"ia-data-last-valid-date":(depth0 != null ? depth0.lastValidDate : depth0),"ia-data-max-range-length":(depth0 != null ? depth0.maxTripLength : depth0),"ia-data-max-booking-length":(depth0 != null ? depth0.maxTripLength : depth0),"has-error":(depth0 != null ? depth0.startDateError : depth0),"wizard-action":"{\"startDate\" : \"$value1\"}","label-text":(depth0 != null ? depth0.flightDepartingLabel : depth0)},"data":data}))
    + "\n";
},"useData":true};
this["Handlebars"]["templates"]["flights-returning-hbs"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return this.escapeExpression((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || helpers.helperMissing).call(depth0,depth0,"returning",{"name":"input-calendar","hash":{"label-show":(depth0 != null ? depth0.isEndDateValueEmpty : depth0),"ia-aria-required":"true","ia-value":(depth0 != null ? depth0.endDate : depth0),"has-error":(depth0 != null ? depth0.endDateError : depth0),"wizard-action":"{\"endDate\" : \"$value1\"}","label-text":(depth0 != null ? depth0.flightReturningLabel : depth0)},"data":data}))
    + "\n";
},"useData":true};
this["Handlebars"]["templates"]["title-hbs"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var helper;

  return "<h2 class=\"sub-600\">"
    + this.escapeExpression(((helper = (helper = helpers.getTitle || (depth0 != null ? depth0.getTitle : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"getTitle","hash":{},"data":data}) : helper)))
    + "</h2>";
},"useData":true};
this["Handlebars"]["templates"]["flights-destination-hbs"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return this.escapeExpression((helpers['input-TA'] || (depth0 && depth0['input-TA']) || helpers.helperMissing).call(depth0,depth0,"destination",{"name":"input-TA","hash":{"label-show":(depth0 != null ? depth0.isDestinationValueEmpty : depth0),"ia-aria-required":"true","ia-placeholder":(depth0 != null ? depth0.flightDestinationPlaceholderText : depth0),"ia-data-lob":"FLIGHTS","ia-value":(depth0 != null ? depth0.destination : depth0),"ta-key":"flight_dest","has-error":(depth0 != null ? depth0.destinationError : depth0),"wizard-action":"{\"destination\" : \"$value1\"}","label-text":(depth0 != null ? depth0.flightDestinationLabel : depth0)},"data":data}))
    + "\n";
},"useData":true};
this["Handlebars"]["templates"]["packages-destination-hbs"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return this.escapeExpression((helpers['input-TA'] || (depth0 && depth0['input-TA']) || helpers.helperMissing).call(depth0,depth0,"destination",{"name":"input-TA","hash":{"label-show":(depth0 != null ? depth0.isDestinationValueEmpty : depth0),"ia-aria-required":"true","ia-placeholder":(depth0 != null ? depth0.flightDestinationPlaceholderText : depth0),"ia-data-lob":"PACKAGES","ia-value":(depth0 != null ? depth0.destination : depth0),"ta-key":(depth0 != null ? depth0.taDataKeyDest : depth0),"has-error":(depth0 != null ? depth0.destinationError : depth0),"wizard-action":"{\"destination\" : \"$value1\"}","label-text":(depth0 != null ? depth0.flightDestinationLabel : depth0)},"data":data}))
    + "\n";
},"useData":true};
this["Handlebars"]["templates"]["hotel-car-destination-hbs"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return this.escapeExpression((helpers['input-TA'] || (depth0 && depth0['input-TA']) || helpers.helperMissing).call(depth0,depth0,"destination",{"name":"input-TA","hash":{"ia-aria-required":"true","ia-value":(depth0 != null ? depth0.destination : depth0),"ia-placeholder":((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.hotelDestination : stack1)) != null ? stack1.placeholderText : stack1),"ia-data-lob":"HOTELS","label-text":((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.hotelDestination : stack1)) != null ? stack1.label : stack1),"ta-key":"package_hotel_car","has-error":(depth0 != null ? depth0.destinationError : depth0),"wizard-action":"{\"destination\":\"$value1\"}"},"data":data}));
},"useData":true};
this["Handlebars"]["templates"]["nonstop-flight-hbs"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return this.escapeExpression((helpers.input || (depth0 && depth0.input) || helpers.helperMissing).call(depth0,depth0,"checkbox","advanced-flight-nonstop",(depth0 != null ? depth0.nonStop : depth0),{"name":"input","hash":{"wizard-action":"{\"nonStop\" : $value1}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightNonStopLabel : stack1),"id":"advanced-flight-nonstop"},"data":data}))
    + "\n";
},"useData":true};
this["Handlebars"]["templates"]["flights-origin-hbs"] = {"1":function(depth0,helpers,partials,data) {
    return "  "
    + this.escapeExpression((helpers.assign || (depth0 && depth0.assign) || helpers.helperMissing).call(depth0,depth0,"id","=","hotel-flight",{"name":"assign","hash":{},"data":data}))
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isHotelTab : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + this.escapeExpression((helpers['input-TA'] || (depth0 && depth0['input-TA']) || helpers.helperMissing).call(depth0,depth0,"origin",{"name":"input-TA","hash":{"label-show":(depth0 != null ? depth0.isOriginValueEmpty : depth0),"ia-aria-required":"true","ia-placeholder":(depth0 != null ? depth0.flightOriginPlaceholderText : depth0),"ia-data-lob":"FLIGHTS","ia-value":(depth0 != null ? depth0.origin : depth0),"ta-key":"flight_origin","has-error":(depth0 != null ? depth0.originError : depth0),"wizard-action":"{\"origin\" : \"$value1\"}","label-text":(depth0 != null ? depth0.flightOriginLabel : depth0),"id":(depth0 != null ? depth0.id : depth0)},"data":data}))
    + "\n";
},"useData":true};
this["Handlebars"]["templates"]["packages-origin-hbs"] = {"1":function(depth0,helpers,partials,data) {
    return "  "
    + this.escapeExpression((helpers.assign || (depth0 && depth0.assign) || helpers.helperMissing).call(depth0,depth0,"id","=","hotel-flight",{"name":"assign","hash":{},"data":data}))
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isHotelTab : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + this.escapeExpression((helpers['input-TA'] || (depth0 && depth0['input-TA']) || helpers.helperMissing).call(depth0,depth0,"origin",{"name":"input-TA","hash":{"label-show":(depth0 != null ? depth0.isOriginValueEmpty : depth0),"ia-aria-required":"true","ia-placeholder":(depth0 != null ? depth0.flightOriginPlaceholderText : depth0),"ia-data-lob":"PACKAGES","ia-value":(depth0 != null ? depth0.origin : depth0),"ta-key":(depth0 != null ? depth0.taDataKeyOrig : depth0),"has-error":(depth0 != null ? depth0.originError : depth0),"wizard-action":"{\"origin\" : \"$value1\"}","label-text":(depth0 != null ? depth0.flightOriginLabel : depth0),"id":(depth0 != null ? depth0.id : depth0)},"data":data}))
    + "\n";
},"useData":true};
this["Handlebars"]["templates"]["hotel-destination-hbs"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return this.escapeExpression((helpers['input-TA'] || (depth0 && depth0['input-TA']) || helpers.helperMissing).call(depth0,depth0,"destination",{"name":"input-TA","hash":{"label-show":(depth0 != null ? depth0.isDestinationValueEmpty : depth0),"ia-aria-required":"true","ia-value":(depth0 != null ? depth0.destination : depth0),"ia-placeholder":(depth0 != null ? depth0.hotelDestinationPlaceholderText : depth0),"ia-data-lob":"HOTELS","label-text":(depth0 != null ? depth0.hotelDestinationLabel : depth0),"ta-key":"hotel","has-error":(depth0 != null ? depth0.destinationError : depth0),"wizard-action":"{\"destination\":\"$value1\"}"},"data":data}))
    + "\n";
},"useData":true};
this["Handlebars"]["templates"]["package-radio-buttons-hbs"] = {"1":function(depth0,helpers,partials,data) {
    return "\n    "
    + this.escapeExpression((helpers.input || (depth0 && depth0.input) || helpers.helperMissing).call(depth0,depth0,"radio","package",(depth0 != null ? depth0.isCurrentPackageType : depth0),{"name":"input","hash":{"ia-data-tracking":"packageLob","ia-value":(depth0 != null ? depth0.value : depth0),"ia-name":"package-lob","label-text":(depth0 != null ? depth0.label : depth0),"class":"col","wizard-action":"{\"packages.flight\" : $value1, \"packages.hotel\" : $value2, \"packages.car\" : $value3, \"packages.train\" : $value4}"},"data":data}))
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<fieldset class=\"radio-set tablet-only\">"
    + ((stack1 = helpers.each.call(depth0,((stack1 = (depth0 != null ? depth0.packageData : depth0)) != null ? stack1.lobs : stack1),{"name":"each","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</fieldset>\n";
},"useData":true};
this["Handlebars"]["templates"]["refundable-flight-hbs"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return this.escapeExpression((helpers.input || (depth0 && depth0.input) || helpers.helperMissing).call(depth0,depth0,"checkbox","advanced-flight-refundable",(depth0 != null ? depth0.noPenalty : depth0),{"name":"input","hash":{"wizard-action":"{\"noPenalty\" : $value1}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightRefundableLabel : stack1),"id":"advanced-flight"},"data":data}))
    + "\n";
},"useData":true};
this["Handlebars"]["templates"]["sub-tabs"] = {"1":function(depth0,helpers,partials,data) {
    return "\n  "
    + this.escapeExpression((helpers.input || (depth0 && depth0.input) || helpers.helperMissing).call(depth0,depth0,"radio",(depth0 != null ? depth0.id : depth0),(depth0 != null ? depth0.selected : depth0),{"name":"input","hash":{"ia-data-tracking":(depth0 != null ? depth0.tracking : depth0),"ia-value":(depth0 != null ? depth0.value : depth0),"ia-name":(depth0 != null ? depth0.name : depth0),"label-text":(depth0 != null ? depth0.label : depth0),"class":"col","wizard-action":(depth0 != null ? depth0.action : depth0)},"data":data}))
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<fieldset class=\"radio-set tablet-only\">"
    + ((stack1 = helpers.each.call(depth0,((stack1 = (depth0 != null ? depth0.subTab : depth0)) != null ? stack1.lobs : stack1),{"name":"each","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</fieldset>";
},"useData":true};
this["Handlebars"]["templates"]["cruise-dates-hbs"] = {"1":function(depth0,helpers,partials,data) {
    var alias1=helpers.helperMissing, alias2=this.escapeExpression;

  return "\n"
    + alias2((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || alias1).call(depth0,depth0,"checkin",{"name":"input-calendar","hash":{"black-out-json":(depth0 != null ? depth0.backOutJson : depth0),"ia-value":"","ia-data-default-range-length":1,"has-error":false,"wizard-action":"{\"startDate\":\"$value1\"}","class":"check-in-out","label-text":"Start Date"},"data":data}))
    + "\n\n"
    + alias2((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || alias1).call(depth0,depth0,"checkout",{"name":"input-calendar","hash":{"black-out-json":(depth0 != null ? depth0.backOutJson : depth0),"ia-value":"","has-error":false,"wizard-action":"{\"endDate\":\"$value1\"}","class":"check-in-out","label-text":"End Date"},"data":data}))
    + "\n\n\n";
},"3":function(depth0,helpers,partials,data) {
    var alias1=helpers.helperMissing, alias2=this.escapeExpression;

  return "\n"
    + alias2((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || alias1).call(depth0,depth0,"checkin",{"name":"input-calendar","hash":{"ia-data-default-range-length":1,"ia-value":"","has-error":false,"wizard-action":"{\"startDate\":\"$value1\"}","class":"check-in-out","label-text":"Start Date"},"data":data}))
    + "\n\n"
    + alias2((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || alias1).call(depth0,depth0,"checkout",{"name":"input-calendar","hash":{"ia-value":"","has-error":false,"wizard-action":"{\"endDate\":\"$value1\"}","class":"check-in-out","label-text":"End Date"},"data":data}))
    + "\n\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.datePickerEnabled : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(3, data, 0),"data":data})) != null ? stack1 : "");
},"useData":true};
this["Handlebars"]["templates"]["cruise-month-hbs"] = {"1":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.cruiseDepartureMonthOptions : depth0),{"name":"each","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"2":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "                <option value=\""
    + alias3(((helper = (helper = helpers.value || (depth0 != null ? depth0.value : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"value","hash":{},"data":data}) : helper)))
    + "\">"
    + alias3(((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"name","hash":{},"data":data}) : helper)))
    + "</option>\n";
},"4":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.months : depth0),{"name":"each","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"5":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "                <option value=\""
    + alias3(((helper = (helper = helpers.value || (depth0 != null ? depth0.value : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"value","hash":{},"data":data}) : helper)))
    + "\">"
    + alias3(((helper = (helper = helpers.display || (depth0 != null ? depth0.display : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"display","hash":{},"data":data}) : helper)))
    + "</option>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression;

  return "<label class=\"search-type select col icon icon-toggle180\" id=\"cruise-departure-month-label\">\n    <span class=\"label\">"
    + alias1(this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.cruise : stack1)) != null ? stack1.departureMonthLabel : stack1), depth0))
    + "</span>\n    <select id=\"cruise-departure-month\" data-wizard-action='{\"cruiseMonth\" : \"$value1\"}' name=\"select\" data-select-value=\""
    + alias1(((helper = (helper = helpers.cruiseMonth || (depth0 != null ? depth0.cruiseMonth : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"cruiseMonth","hash":{},"data":data}) : helper)))
    + "\" data-wizard-owner=\"departure-month\">\n"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.cruiseDepartureMonthOptions : depth0)) != null ? stack1['1'] : stack1),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(4, data, 0),"data":data})) != null ? stack1 : "")
    + "    </select>\n</label>\n";
},"useData":true};
this["Handlebars"]["templates"]["flight-passenger"] = {"1":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-passengers-hbs'],depth0,{"name":"corewizard/field-groups/flights-passengers-hbs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<fieldset class=\"cols-nested\">\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.hidePassengerInfo : depth0),{"name":"unless","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</fieldset>\n";
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["wizard-hbs-cars"] = {"1":function(depth0,helpers,partials,data) {
    return "<section class=\"tab-car geolocation-enabled tab-pane on\" id=\"tab-car\">\n";
},"3":function(depth0,helpers,partials,data) {
    return "<section class=\"tab-car tab-pane on\" id=\"tab-car\">\n";
},"5":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "  <div id=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isMultipleCarOrder : depth0),{"name":"if","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showRentalCars : depth0),{"name":"if","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showAirportRides : depth0),{"name":"if","hash":{},"fn":this.program(10, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    </div>\n";
},"6":function(depth0,helpers,partials,data) {
    var stack1;

  return "\n"
    + ((stack1 = this.invokePartial(partials['corewizard/fields/sub-tabs'],depth0,{"name":"corewizard/fields/sub-tabs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n";
},"8":function(depth0,helpers,partials,data) {
    return "        <div>Content FROM showRentalCars</div>\n";
},"10":function(depth0,helpers,partials,data) {
    return "          <div>Content FROM airportRides</div>\n";
},"12":function(depth0,helpers,partials,data) {
    return " invalid";
},"14":function(depth0,helpers,partials,data) {
    return " class=\"error\"";
},"16":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "  	            <option value=\""
    + alias3(((helper = (helper = helpers.value || (depth0 != null ? depth0.value : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"value","hash":{},"data":data}) : helper)))
    + "\">"
    + alias3(((helper = (helper = helpers.key || (depth0 != null ? depth0.key : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"key","hash":{},"data":data}) : helper)))
    + "</option>\n";
},"18":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/cars-driver-age-hbs'],depth0,{"name":"corewizard/field-groups/cars-driver-age-hbs","data":data,"indent":"      ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"20":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return "      <a\n        id=\"car-options-toggle\"\n        data-wizard-action='{\"showCarOptions\" : "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showCarOptions : depth0),{"name":"if","hash":{},"fn":this.program(21, data, 0, blockParams, depths),"inverse":this.program(23, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + " }'\n        class=\"link show-options toggle-trigger "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showCarOptions : depth0),{"name":"if","hash":{},"fn":this.program(25, data, 0, blockParams, depths),"inverse":this.program(27, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "\"\n        href=\"#car-options\"\n        role=\"button\"\n        aria-controls=\"advanced-options-fields\"\n        aria-expanded=\""
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showCarOptions : depth0),{"name":"if","hash":{},"fn":this.program(23, data, 0, blockParams, depths),"inverse":this.program(21, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "\"\n        aria-pressed=\""
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showCarOptions : depth0),{"name":"if","hash":{},"fn":this.program(23, data, 0, blockParams, depths),"inverse":this.program(21, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "\"\n      >\n        "
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carShowOptionsLabel : stack1), depth0))
    + "<span class=\"icon icon-expand\"></span>\n      </a>\n\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showCarOptions : depth0),{"name":"if","hash":{},"fn":this.program(29, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"21":function(depth0,helpers,partials,data) {
    return "false";
},"23":function(depth0,helpers,partials,data) {
    return "true";
},"25":function(depth0,helpers,partials,data) {
    return "open";
},"27":function(depth0,helpers,partials,data) {
    return "viewed";
},"29":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return "        <div id=\"car-options\">\n            <fieldset class=\"cols-nested from-to\">\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.carOptions : depth0),{"name":"each","hash":{},"fn":this.program(30, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "            </fieldset>\n\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showDiscountCodeFields : depth0),{"name":"if","hash":{},"fn":this.program(32, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n            <fieldset class=\"cols-nested equipment-options cf\">\n                <legend>"
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carSpecialEquipment : stack1), depth0))
    + "</legend>\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.specialEquipmentOptions : depth0),{"name":"each","hash":{},"fn":this.program(36, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "            </fieldset>\n        </div>\n";
},"30":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],depth0,{"name":"corewizard/components/select-hbs","data":data,"indent":"                    ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"32":function(depth0,helpers,partials,data) {
    var stack1;

  return "            <fieldset class=\"cols-nested origin-destination\">\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.carDiscountCodeOptions : depth0),{"name":"each","hash":{},"fn":this.program(33, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "            </fieldset>\n";
},"33":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0['show-car-discount-options'] : depth0),{"name":"if","hash":{},"fn":this.program(34, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"34":function(depth0,helpers,partials,data) {
    var alias1=this.lambda, alias2=this.escapeExpression;

  return "                <label class=\"text col\" id=\""
    + alias2(alias1((depth0 != null ? depth0.namespace : depth0), depth0))
    + "-label\">\n                    <span class=\"label\">"
    + alias2(alias1((depth0 != null ? depth0['label-text'] : depth0), depth0))
    + "</span>\n                    <input type=\"text\" id=\""
    + alias2(alias1((depth0 != null ? depth0.namespace : depth0), depth0))
    + "\" placeholder=\""
    + alias2(alias1((depth0 != null ? depth0.placeholder : depth0), depth0))
    + "\" data-wizard-action=\""
    + alias2(alias1((depth0 != null ? depth0.wizard_action : depth0), depth0))
    + "\" value=\""
    + alias2(alias1((depth0 != null ? depth0.value : depth0), depth0))
    + "\"/>\n                </label>\n";
},"36":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return "                <ul class=\"cols-nested col\" role=\"presentation\">\n"
    + ((stack1 = helpers.each.call(depth0,depth0,{"name":"each","hash":{},"fn":this.program(37, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "                </ul>\n";
},"37":function(depth0,helpers,partials,data,blockParams,depths) {
    return "                    <li role=\"presentation\">\n                        "
    + this.escapeExpression((helpers.input || (depth0 && depth0.input) || helpers.helperMissing).call(depth0,depths[2],"checkbox",(depth0 != null ? depth0.namespace : depth0),(depth0 != null ? depth0.isChecked : depth0),{"name":"input","hash":{"disabled":(depth0 != null ? depth0.disabled : depth0),"ia-data-tid":(depth0 != null ? depth0.namespace : depth0),"wizard_action":(depth0 != null ? depth0.wizard_action : depth0),"label-text":(depth0 != null ? depth0['label-text'] : depth0)},"data":data}))
    + "\n                    </li>\n";
},"39":function(depth0,helpers,partials,data) {
    return "hide-element";
},"41":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "            <fieldset>\n                <div class=\"package-container cf\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-added-hotel\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\"  tabindex=\"-1\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/cars-hotels-hbs'],depth0,{"name":"corewizard/field-groups/cars-hotels-hbs","data":data,"indent":"                    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "                </div>\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/cars-hotels-package-hbs'],depth0,{"name":"corewizard/field-groups/cars-hotels-package-hbs","data":data,"indent":"                ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "            </fieldset>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, options, alias1=helpers.helperMissing, alias2=this.escapeExpression, alias3="function", alias4=this.lambda, alias5=helpers.blockHelperMissing, buffer = 
  ((stack1 = this.invokePartial(partials['corewizard/fields/title-hbs'],depth0,{"name":"corewizard/fields/title-hbs","data":data,"helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isLocationSelectEnabled : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0, blockParams, depths),"inverse":this.program(3, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/error-messages-hbs'],depth0,{"name":"corewizard/field-groups/error-messages-hbs","data":data,"indent":"  ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isLXCarABTest : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/cars-location-hbs'],depth0,{"name":"corewizard/field-groups/cars-location-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n  <fieldset class=\"cols-nested pickup-dropoff\">\n\n              "
    + alias2((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || alias1).call(depth0,depth0,"pickup-date",{"name":"input-calendar","hash":{"label-show":(depth0 != null ? depth0.isStartDateValueEmpty : depth0),"ia-data-end-date":"&#35;car-dropoff-date-wrapper","ia-aria-required":"true","ia-value":(depth0 != null ? depth0.startDate : depth0),"ia-data-tid":"pickup-date-label","ia-data-default-range-length":1,"ia-data-min-range-length":(depth0 != null ? depth0.minTripLength : depth0),"ia-data-last-valid-date":(depth0 != null ? depth0.lastValidDate : depth0),"ia-data-max-range-length":(depth0 != null ? depth0.maxTripLength : depth0),"has-error":(depth0 != null ? depth0.startDateError : depth0),"wizard-action":"{\"startDate\" : \"$value1\"}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carPickupDateLabel : stack1)},"data":data}))
    + "\n\n  	<label class=\"search-type select col icon icon-toggle180"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.startTimeError : depth0),{"name":"if","hash":{},"fn":this.program(12, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\""
    + alias2(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias3 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-pickup-time-label\" >\n  	    <span class=\"label visuallyhidden\">"
    + alias2(alias4(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carPickupTimeLabel : stack1), depth0))
    + "</span>\n  	    <select name=\"select\" id=\""
    + alias2(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias3 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-pickup-time\""
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.startTimeError : depth0),{"name":"if","hash":{},"fn":this.program(14, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " data-wizard-action='{\"startTime\" : \"$value1\"}' data-select-value=\""
    + alias2(((helper = (helper = helpers.startTime || (depth0 != null ? depth0.startTime : depth0)) != null ? helper : alias1),(typeof helper === alias3 ? helper.call(depth0,{"name":"startTime","hash":{},"data":data}) : helper)))
    + "\">\n";
  stack1 = ((helper = (helper = helpers.timeValues || (depth0 != null ? depth0.timeValues : depth0)) != null ? helper : alias1),(options={"name":"timeValues","hash":{},"fn":this.program(16, data, 0, blockParams, depths),"inverse":this.noop,"data":data}),(typeof helper === alias3 ? helper.call(depth0,options) : helper));
  if (!helpers.timeValues) { stack1 = alias5.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  buffer += "  	    </select>\n  	</label>\n\n                "
    + alias2((helpers['input-calendar'] || (depth0 && depth0['input-calendar']) || alias1).call(depth0,depth0,"dropoff-date",{"name":"input-calendar","hash":{"label-show":(depth0 != null ? depth0.isEndDateValueEmpty : depth0),"ia-data-start-date":"&#35;car-pickup-date-wrapper","ia-aria-required":"true","ia-value":(depth0 != null ? depth0.endDate : depth0),"ia-data-tid":"dropoff-date-label","ia-data-min-range-length":(depth0 != null ? depth0.minTripLength : depth0),"ia-data-last-valid-date":(depth0 != null ? depth0.lastValidDate : depth0),"ia-data-max-range-length":(depth0 != null ? depth0.maxTripLength : depth0),"has-error":(depth0 != null ? depth0.endDateError : depth0),"wizard-action":"{\"endDate\" : \"$value1\"}","label-text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carDropoffDateLabel : stack1)},"data":data}))
    + "\n\n  	<label class=\"search-type select col icon icon-toggle180"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.endTimeError : depth0),{"name":"if","hash":{},"fn":this.program(12, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\""
    + alias2(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias3 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-dropoff-time-label\">\n  	    <span class=\"label visuallyhidden\">"
    + alias2(alias4(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.carDropOffTimeLabel : stack1), depth0))
    + "</span>\n  	    <select name=\"select\" id=\""
    + alias2(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias3 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-dropoff-time\""
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.endTimeError : depth0),{"name":"if","hash":{},"fn":this.program(14, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " data-wizard-action='{\"endTime\" : \"$value1\"}' data-select-value=\""
    + alias2(((helper = (helper = helpers.endTime || (depth0 != null ? depth0.endTime : depth0)) != null ? helper : alias1),(typeof helper === alias3 ? helper.call(depth0,{"name":"endTime","hash":{},"data":data}) : helper)))
    + "\">\n";
  stack1 = ((helper = (helper = helpers.timeValues || (depth0 != null ? depth0.timeValues : depth0)) != null ? helper : alias1),(options={"name":"timeValues","hash":{},"fn":this.program(16, data, 0, blockParams, depths),"inverse":this.noop,"data":data}),(typeof helper === alias3 ? helper.call(depth0,options) : helper));
  if (!helpers.timeValues) { stack1 = alias5.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer + "  	    </select>\n  	</label>\n  </fieldset>\n\n    <!--Car Driver Age fieldset-->\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isCarDriverAgeEnabled : depth0),{"name":"if","hash":{},"fn":this.program(18, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.unless.call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.hotel : stack1),{"name":"unless","hash":{},"fn":this.program(20, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n    <div class=\""
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.addHotelsWithCar : depth0),{"name":"unless","hash":{},"fn":this.program(39, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " organic-package-checkboxes add-links cols-nested\">\n        "
    + ((stack1 = (helpers['soft-package'] || (depth0 && depth0['soft-package']) || alias1).call(depth0,{"name":"soft-package","hash":{"icon":"hotels","text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.addHotelLinkText : stack1),"checked":((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.hotel : stack1),"action":(depth0 != null ? depth0.addHotelAction : depth0),"lob":"hotel","type":"checkbox","id":(depth0 != null ? depth0.id : depth0)},"data":data})) != null ? stack1 : "")
    + "\n    </div>\n\n    <div class=\"package-wrapper\" id=\"hotel-package-wrapper\" tabindex=\"-1\">\n"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.hotel : stack1),{"name":"if","hash":{},"fn":this.program(41, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    </div>\n</section>\n";
},"usePartial":true,"useData":true,"useDepths":true};
this["Handlebars"]["templates"]["wizard-hbs-flights"] = {"1":function(depth0,helpers,partials,data) {
    return "soft-package-hotel";
},"3":function(depth0,helpers,partials,data) {
    return " soft-package-car";
},"5":function(depth0,helpers,partials,data) {
    var stack1;

  return "        <div class=\"organic-package-checkboxes add-links cols-nested\">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.allowFlightTabAddHotelOption : depth0),{"name":"if","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.allowFlightTabAddCarOption : depth0),{"name":"if","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "        </div>\n";
},"6":function(depth0,helpers,partials,data) {
    var stack1;

  return "            "
    + ((stack1 = (helpers['soft-package'] || (depth0 && depth0['soft-package']) || helpers.helperMissing).call(depth0,{"name":"soft-package","hash":{"icon":"hotels","text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.addHotelLinkText : stack1),"checked":((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.hotel : stack1),"action":(depth0 != null ? depth0.addHotelAction : depth0),"lob":"hotel","id":(depth0 != null ? depth0.id : depth0)},"data":data})) != null ? stack1 : "")
    + "\n";
},"8":function(depth0,helpers,partials,data) {
    var stack1;

  return "            "
    + ((stack1 = (helpers['soft-package'] || (depth0 && depth0['soft-package']) || helpers.helperMissing).call(depth0,{"name":"soft-package","hash":{"icon":"cars","text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.addCarLinkText : stack1),"checked":((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.car : stack1),"action":(depth0 != null ? depth0.addCarAction : depth0),"lob":"car","id":(depth0 != null ? depth0.id : depth0)},"data":data})) != null ? stack1 : "")
    + "\n";
},"10":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.hotel : stack1),{"name":"if","hash":{},"fn":this.program(11, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"11":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "      <div class=\"package-wrapper\" id=\"hotel-package-wrapper\" tabindex=\"-1\">\n        <div class=\"package-container cf\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-added-hotel\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\"  tabindex=\"-1\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-hbs'],depth0,{"name":"corewizard/field-groups/hotels-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "        </div>\n      </div>\n";
},"13":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.car : stack1),{"name":"if","hash":{},"fn":this.program(14, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"14":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "      <div class=\"package-wrapper\" id=\"car-package-wrapper\" tabindex=\"-1\">\n        <div class=\"package-container cf\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-added-car\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/cars-package-hbs'],depth0,{"name":"corewizard/field-groups/cars-package-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "        </div>\n      </div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/title-hbs'],depth0,{"name":"corewizard/fields/title-hbs","data":data,"helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n<section class=\"tab-pane on\" id=\"tab-flight\">\n<div id=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-tab\" class=\""
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.hotel : stack1),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.car : stack1),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\">\n\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/error-messages-hbs'],depth0,{"name":"corewizard/field-groups/error-messages-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-hbs'],depth0,{"name":"corewizard/field-groups/flights-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isRoundtrip : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.allowFlightTabAddHotelOption : depth0),{"name":"if","hash":{},"fn":this.program(10, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.allowFlightTabAddCarOption : depth0),{"name":"if","hash":{},"fn":this.program(13, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n</div>\n</section>\n";
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["wizard-hbs-misc"] = {"1":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper;

  return "    <li role=\"presentation\" class=\"display-group-name\">"
    + this.escapeExpression(((helper = (helper = helpers.displayGroupName || (depth0 != null ? depth0.displayGroupName : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"displayGroupName","hash":{},"data":data}) : helper)))
    + "</li>\n    <div class=\"display-group-results\">\n"
    + ((stack1 = helpers.each.call(depth0,depth0,{"name":"each","hash":{},"fn":this.program(2, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    </div>\n";
},"2":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.index : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0, blockParams, depths),"inverse":this.program(8, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "");
},"3":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression, alias4=this.lambda;

  return "        <li role=\"presentation\" tabindex=\"-1\" data-tid=\"typeahead-item"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" class=\"results-item\">\n            <a role=\"option\" id=\"aria-option-"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\" data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\"\n                href=\"#\" class=\"details\" data-value=\""
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.lastSearchName : stack1), depth0))
    + "\"\n                data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\" data-multiFlightInputId='"
    + alias3(alias4((depths[3] != null ? depths[3].multiFlightInputId : depths[3]), depth0))
    + "'>\n                "
    + ((stack1 = (helpers.getShowAsHierarchyFlag || (depth0 && depth0.getShowAsHierarchyFlag) || alias1).call(depth0,depth0,((stack1 = (depth0 != null ? depth0.hierarchyInfo : depth0)) != null ? stack1.relation : stack1),{"name":"getShowAsHierarchyFlag","hash":{},"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showAsHierarchy : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0, blockParams, depths),"inverse":this.program(6, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "            </a>\n        </li>\n";
},"4":function(depth0,helpers,partials,data) {
    var stack1, alias1=helpers.helperMissing;

  return "                <div class=\"child-suggestion\">\n                    "
    + ((stack1 = (helpers.getChildSuggestionIcon || (depth0 && depth0.getChildSuggestionIcon) || alias1).call(depth0,(depth0 != null ? depth0.index : depth0),{"name":"getChildSuggestionIcon","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                    "
    + ((stack1 = this.lambda(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.displayName : stack1), depth0)) != null ? stack1 : "")
    + "\n                    "
    + ((stack1 = (helpers.showDistanceFromNearbyAirport || (depth0 && depth0.showDistanceFromNearbyAirport) || alias1).call(depth0,((stack1 = ((stack1 = (depth0 != null ? depth0.hierarchyInfo : depth0)) != null ? stack1.nearby : stack1)) != null ? stack1.distInMI : stack1),{"name":"showDistanceFromNearbyAirport","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                </div>\n";
},"6":function(depth0,helpers,partials,data) {
    var stack1;

  return "                    "
    + ((stack1 = (helpers.makeOption || (depth0 && depth0.makeOption) || helpers.helperMissing).call(depth0,(depth0 != null ? depth0.index : depth0),(depth0 != null ? depth0.icon : depth0),((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.displayName : stack1),(depth0 != null ? depth0.rightFloatingTextHtml : depth0),{"name":"makeOption","hash":{},"data":data})) != null ? stack1 : "")
    + "\n";
},"8":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "        <li role=\"presentation\" tabindex=\"-1\" data-tid=\"typeahead-item"
    + ((stack1 = (helpers.getItemCount || (depth0 && depth0.getItemCount) || alias1).call(depth0,(depth0 != null ? depth0.i : depth0),{"name":"getItemCount","hash":{},"data":data})) != null ? stack1 : "")
    + "\"\n            class=\"results-item\">\n            <a role=\"option\" id=\"aria-option-"
    + ((stack1 = (helpers.getItemCount || (depth0 && depth0.getItemCount) || alias1).call(depth0,(depth0 != null ? depth0.i : depth0),{"name":"getItemCount","hash":{},"data":data})) != null ? stack1 : "")
    + "\"\n                tabindex=\"-1\" data-tid=\"typeahead-link"
    + ((stack1 = (helpers.getItemCount || (depth0 && depth0.getItemCount) || alias1).call(depth0,(depth0 != null ? depth0.i : depth0),{"name":"getItemCount","hash":{},"data":data})) != null ? stack1 : "")
    + "\"\n                href=\"#\" class=\"details\" data-value=\""
    + alias3(((helper = (helper = helpers.l || (depth0 != null ? depth0.l : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"l","hash":{},"data":data}) : helper)))
    + "\" data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\"\n                data-multiFlightInputId='"
    + alias3(this.lambda((depths[3] != null ? depths[3].multiFlightInputId : depths[3]), depth0))
    + "'>\n                "
    + ((stack1 = (helpers.getShowAsHierarchyFlag || (depth0 && depth0.getShowAsHierarchyFlag) || alias1).call(depth0,depth0,(depth0 != null ? depth0.relation : depth0),{"name":"getShowAsHierarchyFlag","hash":{},"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showAsHierarchy : depth0),{"name":"if","hash":{},"fn":this.program(9, data, 0, blockParams, depths),"inverse":this.program(11, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "            </a>\n        </li>\n";
},"9":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing;

  return "                <div class=\"child-suggestion\">\n                    "
    + ((stack1 = (helpers.getChildSuggestionIcon || (depth0 && depth0.getChildSuggestionIcon) || alias1).call(depth0,(depth0 != null ? depth0.i : depth0),{"name":"getChildSuggestionIcon","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                    "
    + ((stack1 = ((helper = (helper = helpers.d || (depth0 != null ? depth0.d : depth0)) != null ? helper : alias1),(typeof helper === "function" ? helper.call(depth0,{"name":"d","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\n                    "
    + ((stack1 = (helpers.showDistanceFromNearbyAirport || (depth0 && depth0.showDistanceFromNearbyAirport) || alias1).call(depth0,(depth0 != null ? depth0.distInMI : depth0),{"name":"showDistanceFromNearbyAirport","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                </div>\n";
},"11":function(depth0,helpers,partials,data) {
    var stack1;

  return "                    "
    + ((stack1 = (helpers.makeOption || (depth0 && depth0.makeOption) || helpers.helperMissing).call(depth0,(depth0 != null ? depth0.i : depth0),(depth0 != null ? depth0.icon : depth0),(depth0 != null ? depth0.d : depth0),{"name":"makeOption","hash":{},"data":data})) != null ? stack1 : "")
    + "\n";
},"13":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "    <dt role=\"presentation\" data-tid=\"typeahead-category-"
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "\"\n        id=\"typeahead-category-"
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "\" class=\"category-name\">"
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "</dt>\n    <dd role=\"presentation\" class=\"category-results\">\n        <ul role=\"presentation\" class=\"results\">\n"
    + ((stack1 = helpers.each.call(depth0,depth0,{"name":"each","hash":{},"fn":this.program(14, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "        </ul>\n    </dd>\n";
},"14":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression, alias4=this.lambda;

  return "            <li role=\"presentation\" tabindex=\"-1\" data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" class=\"results-item\">\n                <a role=\"option\" aria-describedby=\"typeahead-category-"
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "\"\n                    id=\"aria-option-"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" href=\"#\"\n                    data-value=\""
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.fullName : stack1), depth0))
    + "\" data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\">\n                    <span data-tid=\"typeahead-icon"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" class=\"details\">"
    + ((stack1 = alias4(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.displayName : stack1), depth0)) != null ? stack1 : "")
    + "</span>\n                </a>\n            </li>\n";
},"16":function(depth0,helpers,partials,data) {
    var stack1;

  return "    <dd role=\"presentation\" class=\"category-results\">\n        <ul role=\"presentation\" class=\"results\">\n"
    + ((stack1 = helpers.each.call(depth0,depth0,{"name":"each","hash":{},"fn":this.program(17, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "        </ul>\n    </dd>\n";
},"17":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.index : depth0),{"name":"if","hash":{},"fn":this.program(18, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"18":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "            <li role=\"presentation\" tabindex=\"-1\" data-tid=\"typeahead-item"
    + this.escapeExpression(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" class=\"results-item\">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.gemma : depth0),{"name":"if","hash":{},"fn":this.program(19, data, 0),"inverse":this.program(21, data, 0),"data":data})) != null ? stack1 : "")
    + "            </li>\n";
},"19":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "                <a role=\"option\" id=\"aria-option-"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\"\n                    data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" href=\"#\" class=\"details\"\n                    data-value=\""
    + alias3(this.lambda(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.fullName : stack1), depth0))
    + "\" data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\">\n                    "
    + ((stack1 = (helpers.makeOptionGemmaSearch || (depth0 && depth0.makeOptionGemmaSearch) || alias1).call(depth0,(depth0 != null ? depth0.index : depth0),(depth0 != null ? depth0.icon : depth0),((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.fullName : stack1),{"name":"makeOptionGemmaSearch","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                </a>\n";
},"21":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.categoryName : depth0),{"name":"if","hash":{},"fn":this.program(22, data, 0),"inverse":this.program(24, data, 0),"data":data})) != null ? stack1 : "");
},"22":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "                <a role=\"option\" id=\"aria-option-"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\"\n                    data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" href=\"#\" class=\"details\"\n                    data-value=\""
    + alias3(this.lambda(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.lastSearchName : stack1), depth0))
    + " - "
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "\" data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\">\n                    "
    + ((stack1 = (helpers.makeOptionOpenSearch || (depth0 && depth0.makeOptionOpenSearch) || alias1).call(depth0,(depth0 != null ? depth0.index : depth0),(depth0 != null ? depth0.icon : depth0),((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.displayName : stack1),(depth0 != null ? depth0.categoryName : depth0),{"name":"makeOptionOpenSearch","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                </a>\n";
},"24":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "                <a role=\"option\" id=\"aria-option-"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\"\n                    data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" href=\"#\" class=\"details\"\n                    data-value=\""
    + alias3(this.lambda(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.lastSearchName : stack1), depth0))
    + "\" data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\">\n                    "
    + ((stack1 = (helpers.makeOption || (depth0 && depth0.makeOption) || alias1).call(depth0,(depth0 != null ? depth0.index : depth0),(depth0 != null ? depth0.icon : depth0),((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.displayName : stack1),{"name":"makeOption","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                </a>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<ul role=\"listbox\" data-tid=\"typeahead-list\" class=\"results\">\n\n"
    + ((stack1 = (helpers.each_with_key || (depth0 && depth0.each_with_key) || alias1).call(depth0,(depth0 != null ? depth0.resultsByDisplayGroup : depth0),{"name":"each_with_key","hash":{"key":"displayGroupName"},"fn":this.program(1, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n</ul>\n<footer data-tid=\"typeahead-footer\" class=\"footer\" role=\"application\">\n    <a id=\"typeahead-close\" data-tid=\"typeahead-close\" class=\"close\" href=\"#\">\n        "
    + alias3(((helper = (helper = helpers.closeText || (depth0 != null ? depth0.closeText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"closeText","hash":{},"data":data}) : helper)))
    + "<span class=\"icon icon-close\"></span>\n    </a>\n</footer>\n\n<dl role=\"presentation\" data-tid=\"typeahead-list-category\">\n\n"
    + ((stack1 = (helpers.each_with_key || (depth0 && depth0.each_with_key) || alias1).call(depth0,(depth0 != null ? depth0.resultsByCategory : depth0),{"name":"each_with_key","hash":{"key":"categoryName"},"fn":this.program(13, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n</dl>\n<footer data-tid=\"typeahead-footer\" class=\"footer\" role=\"application\">\n    <a class=\"close\" href=\"#\">\n        "
    + alias3(((helper = (helper = helpers.closeText || (depth0 != null ? depth0.closeText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"closeText","hash":{},"data":data}) : helper)))
    + "<span class=\"icon icon-close\"></span>\n    </a>\n</footer>\n\n<dl role=\"presentation\" data-tid=\"typeahead-list-category\">\n"
    + ((stack1 = (helpers.each_with_key || (depth0 && depth0.each_with_key) || alias1).call(depth0,(depth0 != null ? depth0.resultsByCategory : depth0),{"name":"each_with_key","hash":{"key":"categoryName"},"fn":this.program(16, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</dl>\n<footer data-tid=\"typeahead-footer\" class=\"footer\">\n    <a class=\"close\" href=\"#\">\n        "
    + alias3(((helper = (helper = helpers.closeText || (depth0 != null ? depth0.closeText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"closeText","hash":{},"data":data}) : helper)))
    + "<span class=\"icon icon-close\"></span>\n    </a>\n</footer>";
},"useData":true,"useDepths":true};
this["Handlebars"]["templates"]["rail-hbs"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/title-hbs'],depth0,{"name":"corewizard/fields/title-hbs","data":data,"helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n<section class=\"tab-pane on\" id=\"tab-rail\">\n    <div>\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/error-messages-hbs'],depth0,{"name":"corewizard/field-groups/error-messages-hbs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/rail-hbs'],depth0,{"name":"corewizard/field-groups/rail-hbs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "    </div>\n</section>";
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["wizard-hbs"] = {"1":function(depth0,helpers,partials,data) {
    return "ab11841_1";
},"3":function(depth0,helpers,partials,data) {
    return "ab11842_1";
},"5":function(depth0,helpers,partials,data) {
    return "ab11872_1";
},"7":function(depth0,helpers,partials,data) {
    return "ab11873_1";
},"9":function(depth0,helpers,partials,data) {
    return "ab11873_2";
},"11":function(depth0,helpers,partials,data) {
    return "ab6555_1";
},"13":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "        <h1 class=\"col wizard-title\">"
    + ((stack1 = ((helper = (helper = helpers.wizardTitle || (depth0 != null ? depth0.wizardTitle : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"wizardTitle","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</h1>\n";
},"15":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/includes/next-trip-hbs'],depth0,{"name":"corewizard/includes/next-trip-hbs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"17":function(depth0,helpers,partials,data) {
    var stack1;

  return "    <ul class=\"tabs cf col"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isTravelocity : depth0),{"name":"if","hash":{},"fn":this.program(18, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" role=\"tablist\" data-tid=\"wizard-tablist\">\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.lobs : depth0),{"name":"each","hash":{},"fn":this.program(20, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    </ul>\n";
},"18":function(depth0,helpers,partials,data) {
    return " tvly-wizard";
},"20":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/layouts/tab-hbs'],depth0,{"name":"corewizard/layouts/tab-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"22":function(depth0,helpers,partials,data) {
    var helper;

  return "        <span class='hotel-value-prop-tablet' id='hotel-tab-value-prop'>\n            <span>"
    + this.escapeExpression(((helper = (helper = helpers.hotelTabletValueProp || (depth0 != null ? depth0.hotelTabletValueProp : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"hotelTabletValueProp","hash":{},"data":data}) : helper)))
    + "</span>\n        </span>\n";
},"24":function(depth0,helpers,partials,data) {
    return " no-tabs";
},"26":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.switches : depth0)) != null ? stack1.packagePriceSavingsDollarValue : stack1),{"name":"if","hash":{},"fn":this.program(27, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"27":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/package-price-savings'],depth0,{"name":"corewizard/field-groups/package-price-savings","data":data,"indent":"                        ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"29":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['handlebars/wizard/promo-message'],depth0,{"name":"handlebars/wizard/promo-message","data":data,"indent":"                    ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"31":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/includes/bpg'],depth0,{"name":"corewizard/includes/bpg","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "<div id=\"wizard-container\" class=\""
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.ab11841 : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.ab11842 : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.ab11872 : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.ab11873_1 : depth0),{"name":"if","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.ab11873_2 : depth0),{"name":"if","hash":{},"fn":this.program(9, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\">\n    <div  class=\"cols-row search theme-inverse-pills "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.ab6555 : depth0),{"name":"if","hash":{},"fn":this.program(11, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\"wizard-theme-wrapper\" data-tid=\"region\">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.wizardTitle : depth0),{"name":"if","hash":{},"fn":this.program(13, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.nextTrip : depth0)) != null ? stack1.displayNextTrip : stack1),{"name":"if","hash":{},"fn":this.program(15, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    <!-- tabs - pills -->\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showTabs : depth0),{"name":"if","hash":{},"fn":this.program(17, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    <!-- tabs -->\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showValueProp : depth0),{"name":"if","hash":{},"fn":this.program(22, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    <div class=\"col forms"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.showTabs : depth0),{"name":"unless","hash":{},"fn":this.program(24, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " tabs-container\" data-tid=\"tab-container\">\n        <form autocomplete=\"off\">\n            <div data-wizard-action=\"form-wrapper\">\n"
    + ((stack1 = this.invokePartial(helpers.lookup.call(depth0,depth0,"wizardTemplate",{"name":"lookup","hash":{},"data":data}),depth0,{"data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "            </div>\n            <fieldset class=\"cols submit-and-mixin-fieldset\">\n                <label class=\"col search-btn-col\">\n                    <button type=\"submit\" data-wizard-action=\"{submit:true}\" class=\"btn-action btn-primary\" id=\"search-button\" data-tid=\"search-button\">\n                        <span class=\"btn-label\">"
    + this.escapeExpression(((helper = (helper = helpers.searchText || (depth0 != null ? depth0.searchText : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"searchText","hash":{},"data":data}) : helper)))
    + "</span>\n                    </button>\n                </label>\n\n"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.switches : depth0)) != null ? stack1.usePackageValuePropMessage : stack1),{"name":"if","hash":{},"fn":this.program(26, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.switches : depth0)) != null ? stack1.usePromoMessage : stack1),{"name":"if","hash":{},"fn":this.program(29, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "            </fieldset>\n        </form>\n    </div><!-- .tab-content -->\n"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.switches : depth0)) != null ? stack1.useBestPriceGuaranteeLogo : stack1),{"name":"if","hash":{},"fn":this.program(31, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</div><!-- .search -->\n</div>\n";
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["tab-hbs"] = {"1":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "            data-wizard-action='{\"tab\" : \""
    + alias3(((helper = (helper = helpers.tab || (depth0 != null ? depth0.tab : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"tab","hash":{},"data":data}) : helper)))
    + "\", \"packages.flight\" : "
    + alias3(((helper = (helper = helpers.flightsPackage || (depth0 != null ? depth0.flightsPackage : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"flightsPackage","hash":{},"data":data}) : helper)))
    + ", \"packages.hotel\" : "
    + alias3(((helper = (helper = helpers.hotelsPackage || (depth0 != null ? depth0.hotelsPackage : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"hotelsPackage","hash":{},"data":data}) : helper)))
    + ", \"packages.car\" : "
    + alias3(((helper = (helper = helpers.carsPackage || (depth0 != null ? depth0.carsPackage : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"carsPackage","hash":{},"data":data}) : helper)))
    + ", \"packages.train\" : "
    + alias3(((helper = (helper = helpers.trainsPackage || (depth0 != null ? depth0.trainsPackage : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"trainsPackage","hash":{},"data":data}) : helper)))
    + " }'\n";
},"3":function(depth0,helpers,partials,data) {
    return "            data-wizard-action='{}'\n";
},"5":function(depth0,helpers,partials,data) {
    return "            class=\"on\" aria-selected=\"true\"\n";
},"7":function(depth0,helpers,partials,data) {
    return "            class=\"\" aria-selected=\"false\"\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<li  class=\"tab\" role=\"presentation\" data-lobtab=\""
    + alias3(((helper = (helper = helpers.tab || (depth0 != null ? depth0.tab : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"tab","hash":{},"data":data}) : helper)))
    + "\">\n    <a role=\"tab\" href=\""
    + alias3(((helper = (helper = helpers.link || (depth0 != null ? depth0.link : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"link","hash":{},"data":data}) : helper)))
    + "\"\n        data-tab=\""
    + alias3(((helper = (helper = helpers.tab || (depth0 != null ? depth0.tab : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"tab","hash":{},"data":data}) : helper)))
    + "\"\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.isPackageTab : depth0),{"name":"unless","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "            id=\"tab-"
    + alias3(((helper = (helper = helpers['tab-id'] || (depth0 != null ? depth0['tab-id'] : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"tab-id","hash":{},"data":data}) : helper)))
    + "-tab\"\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isCurrentTab : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.program(7, data, 0),"data":data})) != null ? stack1 : "")
    + "        data-tracking=\"tab\"\n    >\n\n"
    + ((stack1 = this.invokePartial(partials['corewizard/components/icon-lobIcon'],depth0,{"name":"corewizard/components/icon-lobIcon","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "        <span class=\"visuallyhidden\">Search for </span><span class=\"tab-label\">"
    + ((stack1 = ((helper = (helper = helpers.label || (depth0 != null ? depth0.label : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"label","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n    </a>\n</li>\n";
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["wizard-hbs-hotels"] = {"1":function(depth0,helpers,partials,data) {
    return "  <section class=\"tab-pane on geolocation-enabled\" id=\"tab-hotel\">\n";
},"3":function(depth0,helpers,partials,data) {
    return "  <section class=\"tab-pane on\" id=\"tab-hotel\">\n";
},"5":function(depth0,helpers,partials,data) {
    return "soft-package-flight";
},"7":function(depth0,helpers,partials,data) {
    return " soft-package-car";
},"9":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isHotelTabWithMaxThreeRooms : depth0),{"name":"if","hash":{},"fn":this.program(10, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.allowHotelTabAddFlightOption : depth0),{"name":"if","hash":{},"fn":this.program(15, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.allowHotelTabAddCarOption : depth0),{"name":"if","hash":{},"fn":this.program(23, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"10":function(depth0,helpers,partials,data) {
    var stack1;

  return "    <div class=\"organic-package-checkboxes add-links cols-nested\">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.allowHotelTabAddFlightOption : depth0),{"name":"if","hash":{},"fn":this.program(11, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.allowHotelTabAddCarOption : depth0),{"name":"if","hash":{},"fn":this.program(13, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    </div>\n";
},"11":function(depth0,helpers,partials,data) {
    var stack1;

  return "      "
    + ((stack1 = (helpers['soft-package'] || (depth0 && depth0['soft-package']) || helpers.helperMissing).call(depth0,{"name":"soft-package","hash":{"icon":"flights","text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.addFlightLinkText : stack1),"checked":((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.flight : stack1),"action":(depth0 != null ? depth0.addFlightAction : depth0),"lob":"flight","id":(depth0 != null ? depth0.id : depth0)},"data":data})) != null ? stack1 : "")
    + "\n";
},"13":function(depth0,helpers,partials,data) {
    var stack1;

  return "      "
    + ((stack1 = (helpers['soft-package'] || (depth0 && depth0['soft-package']) || helpers.helperMissing).call(depth0,{"name":"soft-package","hash":{"icon":"cars","text":((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.addCarLinkText : stack1),"checked":((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.car : stack1),"action":(depth0 != null ? depth0.addCarAction : depth0),"lob":"car","id":(depth0 != null ? depth0.id : depth0)},"data":data})) != null ? stack1 : "")
    + "\n";
},"15":function(depth0,helpers,partials,data) {
    var stack1;

  return "  <div class=\"package-wrapper"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isHotelTabWithMaxThreeRooms : depth0),{"name":"if","hash":{},"fn":this.program(16, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\"flight-package-wrapper\" tabindex=\"-1\">\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.isHotelTabWithMaxThreeRooms : depth0),{"name":"unless","hash":{},"fn":this.program(19, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.flight : stack1),{"name":"if","hash":{},"fn":this.program(21, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "  </div>\n";
},"16":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.unless.call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.flight : stack1),{"name":"unless","hash":{},"fn":this.program(17, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"17":function(depth0,helpers,partials,data) {
    return " visuallyhidden";
},"19":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression, alias4=this.lambda;

  return "    <div class=\"add-links cols-nested cf\">\n      <a class=\"col link disabled\" href=\"#flight-package-wrapper\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-add-flight\" data-help-container=\"&#35;"
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-add-flight-help-container\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" role=\"button\">\n      <span class=\"icon icon-flights\"></span>"
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.addFlightLinkText : stack1), depth0))
    + "</a>\n      <div id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-add-flight-help-container\"  class=\"help-container\">\n        <span id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-add-flight-help-default\" class=\"col icon icon-help\" aria-hidden=\"true\" data-help-type=\"default\" data-control=\"tooltip\" data-content=\""
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.flightHotelMessage : stack1), depth0))
    + "\"></span><span class=\"alt\">?</span>\n      </div>\n    </div>\n";
},"21":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "      <div class=\"package-container cf\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-added-flight\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-hbs'],depth0,{"name":"corewizard/field-groups/flights-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "      </div>\n";
},"23":function(depth0,helpers,partials,data) {
    var stack1;

  return "  <div class=\"package-wrapper"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isHotelTabWithMaxThreeRooms : depth0),{"name":"if","hash":{},"fn":this.program(24, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\"car-package-wrapper\">\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.isHotelTabWithMaxThreeRooms : depth0),{"name":"unless","hash":{},"fn":this.program(26, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasCar : depth0),{"name":"if","hash":{},"fn":this.program(28, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "  </div>\n";
},"24":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.unless.call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.car : stack1),{"name":"unless","hash":{},"fn":this.program(17, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"26":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression, alias4=this.lambda;

  return "    <div class=\"add-links cols-nested cf\">\n      <a class=\"col link disabled\" href=\"#add-car\" id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-add-car\" data-help-container=\"&#35;"
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-add-car-help-container\" data-wizard-owner=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" role=\"button\">\n      <span class=\"icon icon-cars\"></span>"
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.addCarLinkText : stack1), depth0))
    + "</a>\n      <div id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-add-car-help-container\" class=\"help-container\">\n        <span id=\""
    + alias3(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-add-car-help-default\" class=\"col icon icon-help\" aria-hidden=\"true\" data-help-type=\"default\" data-control=\"tooltip\" data-content=\""
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.hotelCarMessage : stack1), depth0))
    + "\"></span><span class=\"alt\">?</span>\n      </div>\n    </div>\n";
},"28":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "      <div class=\"package-container cf\" id=\"hotel-added-car\" data-wizard-owner=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/cars-package-hbs'],depth0,{"name":"corewizard/field-groups/cars-package-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "      </div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/title-hbs'],depth0,{"name":"corewizard/fields/title-hbs","data":data,"helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isLocationSelectEnabled : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "\n<div id=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "-tab\" class=\""
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.flight : stack1),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.car : stack1),{"name":"if","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/error-messages-hbs'],depth0,{"name":"corewizard/field-groups/error-messages-hbs","data":data,"helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-hbs'],depth0,{"name":"corewizard/field-groups/hotels-hbs","data":data,"indent":"  ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.destinationNotCuba : depth0),{"name":"if","hash":{},"fn":this.program(9, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n\n</section>\n";
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["wizard-hbs-vacationRental"] = {"1":function(depth0,helpers,partials,data) {
    return "    <section class=\"tab-pane on geolocation-enabled\" id=\"tab-vacation-rental\">\n";
},"3":function(depth0,helpers,partials,data) {
    return "    <section class=\"tab-pane on\" id=\"tab-vacation-rental\">\n";
},"5":function(depth0,helpers,partials,data) {
    return "soft-package-flight";
},"7":function(depth0,helpers,partials,data) {
    return " soft-package-car";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isLocationSelectEnabled : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "\n    <div id=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" class=\""
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.flight : stack1),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.car : stack1),{"name":"if","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/error-messages-hbs'],depth0,{"name":"corewizard/field-groups/error-messages-hbs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/vacation-rental-hbs'],depth0,{"name":"corewizard/field-groups/vacation-rental-hbs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "    </div>\n\n    </section>\n";
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["wizard-hbs-packages"] = {"1":function(depth0,helpers,partials,data) {
    var stack1;

  return "<section class=\"tab-pane on"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.pkg : depth0)) != null ? stack1.showCarMessage : stack1),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hotel : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.flight : depth0),{"name":"if","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " geolocation-enabled\" id=\"tab-package\">\n";
},"2":function(depth0,helpers,partials,data) {
    return " car-message car";
},"4":function(depth0,helpers,partials,data) {
    return " hotel";
},"6":function(depth0,helpers,partials,data) {
    return " flight";
},"8":function(depth0,helpers,partials,data) {
    var stack1;

  return "<section class=\"tab-pane on"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.pkg : depth0)) != null ? stack1.showCarMessage : stack1),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hotel : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.flight : depth0),{"name":"if","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\"tab-package\">\n";
},"10":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/sub-tabs'],depth0,{"name":"corewizard/fields/sub-tabs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"12":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/packages-origin-destination-hbs'],depth0,{"name":"corewizard/field-groups/packages-origin-destination-hbs","data":data,"indent":"        ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"14":function(depth0,helpers,partials,data) {
    var stack1;

  return "        <fieldset class=\"cols-nested destination-only\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/fields/hotel-car-destination-hbs'],depth0,{"name":"corewizard/fields/hotel-car-destination-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "        </fieldset>\n";
},"16":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-dates-hbs'],depth0,{"name":"corewizard/field-groups/hotels-dates-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"18":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-dates-hbs'],depth0,{"name":"corewizard/field-groups/flights-dates-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showLengthOfStay : depth0),{"name":"if","hash":{},"fn":this.program(19, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"19":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.packages : depth0)) != null ? stack1.hotel : stack1),{"name":"if","hash":{},"fn":this.program(20, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"20":function(depth0,helpers,partials,data) {
    var helper;

  return "                  <div class=\"length-of-stay-counter col\" id=\"length-of-stay-counter\">\n                    "
    + this.escapeExpression(((helper = (helper = helpers.hotelLengthOfStayString || (depth0 != null ? depth0.hotelLengthOfStayString : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"hotelLengthOfStayString","hash":{},"data":data}) : helper)))
    + "\n                  </div>\n";
},"22":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.rooms : depth0)) != null ? stack1['1'] : stack1),{"name":"if","hash":{},"fn":this.program(23, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.unless.call(depth0,((stack1 = (depth0 != null ? depth0.rooms : depth0)) != null ? stack1['1'] : stack1),{"name":"unless","hash":{},"fn":this.program(25, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n        <fieldset class=\"cols-nested partial-stay\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/direct-flight-hbs'],depth0,{"name":"corewizard/field-groups/direct-flight-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/partial-stay-hbs'],depth0,{"name":"corewizard/field-groups/partial-stay-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "        </fieldset>\n\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isPartialStay : depth0),{"name":"if","hash":{},"fn":this.program(27, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.rooms : depth0)) != null ? stack1['1'] : stack1),{"name":"if","hash":{},"fn":this.program(29, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n      ";
},"23":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],(depth0 != null ? depth0.hotelRoomCountOptions : depth0),{"name":"corewizard/components/select-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"25":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],(depth0 != null ? depth0.hotelRoomCountOptions : depth0),{"name":"corewizard/components/select-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-rooms-container-hbs'],depth0,{"name":"corewizard/field-groups/hotels-rooms-container-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"27":function(depth0,helpers,partials,data) {
    var stack1;

  return "            <fieldset class=\"cols-nested is-partial-stay\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-dates-hbs'],depth0,{"name":"corewizard/field-groups/hotels-dates-hbs","data":data,"indent":"                ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "            </fieldset>\n";
},"29":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/hotels-rooms-container-hbs'],depth0,{"name":"corewizard/field-groups/hotels-rooms-container-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"31":function(depth0,helpers,partials,data) {
    var stack1;

  return "          <div class=\"driver-age-package-wrapper\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/cars-driver-age-hbs'],depth0,{"name":"corewizard/field-groups/cars-driver-age-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "          </div>\n";
},"33":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['default/templates/advanced-options-package-hbs'],depth0,{"name":"default/templates/advanced-options-package-hbs","data":data,"indent":"          ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"35":function(depth0,helpers,partials,data) {
    var stack1;

  return "        <div class=\"package-rooms-travellers-container "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.ab11873 : depth0),{"name":"if","hash":{},"fn":this.program(36, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" >\n          <fieldset class=\"cols-nested flights-passengers\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-passengers-hbs'],depth0,{"name":"corewizard/field-groups/flights-passengers-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "          </fieldset>\n        </div>\n      ";
},"36":function(depth0,helpers,partials,data) {
    var stack1;

  return "col"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasChildren : depth0),{"name":"if","hash":{},"fn":this.program(37, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"37":function(depth0,helpers,partials,data) {
    return " cols-row";
},"39":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasChildren : depth0),{"name":"if","hash":{},"fn":this.program(40, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"40":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['corewizard/field-groups/flights-children-help-and-options-hbs'],depth0,{"name":"corewizard/field-groups/flights-children-help-and-options-hbs","data":data,"indent":"            ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"42":function(depth0,helpers,partials,data) {
    return "    </section>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return ((stack1 = this.invokePartial(partials['corewizard/fields/title-hbs'],depth0,{"name":"corewizard/fields/title-hbs","data":data,"helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isLocationSelectEnabled : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(8, data, 0),"data":data})) != null ? stack1 : "")
    + "\n  <div id=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/field-groups/error-messages-hbs'],depth0,{"name":"corewizard/field-groups/error-messages-hbs","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isMultiplePackageOrder : depth0),{"name":"if","hash":{},"fn":this.program(10, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showFlightOandD : depth0),{"name":"if","hash":{},"fn":this.program(12, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showHotelDest : depth0),{"name":"if","hash":{},"fn":this.program(14, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    <fieldset class=\"cols-nested\">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showHotelDest : depth0),{"name":"if","hash":{},"fn":this.program(16, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showFlightOandD : depth0),{"name":"if","hash":{},"fn":this.program(18, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showRooms : depth0),{"name":"if","hash":{},"fn":this.program(22, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showCarDriverAge : depth0),{"name":"if","hash":{},"fn":this.program(31, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.enableAdvancedOptions : depth0),{"name":"if","hash":{},"fn":this.program(33, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.noRooms : depth0),{"name":"if","hash":{},"fn":this.program(35, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.hideChildrenFlightFields : depth0),{"name":"unless","hash":{},"fn":this.program(39, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    </fieldset>\n  </div>\n  \n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isLocationSelectEnabled : depth0),{"name":"if","hash":{},"fn":this.program(42, data, 0),"inverse":this.program(42, data, 0),"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true};
this["Handlebars"]["templates"]["category"] = {"1":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "    <dt role=\"presentation\" data-tid=\"typeahead-category-"
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "\"\n        id=\"typeahead-category-"
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "\" class=\"category-name\">"
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "</dt>\n    <dd role=\"presentation\" class=\"category-results\">\n        <ul role=\"presentation\" class=\"results\">\n"
    + ((stack1 = helpers.each.call(depth0,depth0,{"name":"each","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "        </ul>\n    </dd>\n";
},"2":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression, alias4=this.lambda;

  return "            <li role=\"presentation\" tabindex=\"-1\" data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" class=\"results-item\">\n                <a role=\"option\" aria-describedby=\"typeahead-category-"
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "\"\n                    id=\"aria-option-"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" href=\"#\"\n                    data-value=\""
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.fullName : stack1), depth0))
    + "\" data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\">\n                    <span data-tid=\"typeahead-icon"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" class=\"details\">"
    + ((stack1 = alias4(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.displayName : stack1), depth0)) != null ? stack1 : "")
    + "</span>\n                </a>\n            </li>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing;

  return "<dl role=\"presentation\" data-tid=\"typeahead-list-category\">\n\n"
    + ((stack1 = (helpers.each_with_key || (depth0 && depth0.each_with_key) || alias1).call(depth0,(depth0 != null ? depth0.resultsByCategory : depth0),{"name":"each_with_key","hash":{"key":"categoryName"},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n</dl>\n<footer data-tid=\"typeahead-footer\" class=\"footer\" role=\"application\">\n    <a class=\"close\" href=\"#\">\n        "
    + this.escapeExpression(((helper = (helper = helpers.closeText || (depth0 != null ? depth0.closeText : depth0)) != null ? helper : alias1),(typeof helper === "function" ? helper.call(depth0,{"name":"closeText","hash":{},"data":data}) : helper)))
    + "<span class=\"icon icon-close\"></span>\n    </a>\n</footer>\n";
},"useData":true};
this["Handlebars"]["templates"]["open-search-ta"] = {"1":function(depth0,helpers,partials,data) {
    var stack1;

  return "    <dd role=\"presentation\" class=\"category-results\">\n        <ul role=\"presentation\" class=\"results\">\n"
    + ((stack1 = helpers.each.call(depth0,depth0,{"name":"each","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "        </ul>\n    </dd>\n";
},"2":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.index : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"3":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "            <li role=\"presentation\" tabindex=\"-1\" data-tid=\"typeahead-item"
    + this.escapeExpression(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" class=\"results-item\">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.gemma : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.program(6, data, 0),"data":data})) != null ? stack1 : "")
    + "            </li>\n";
},"4":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "                <a role=\"option\" id=\"aria-option-"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\"\n                    data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" href=\"#\" class=\"details\"\n                    data-value=\""
    + alias3(this.lambda(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.fullName : stack1), depth0))
    + "\" data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\">\n                    "
    + ((stack1 = (helpers.makeOptionGemmaSearch || (depth0 && depth0.makeOptionGemmaSearch) || alias1).call(depth0,(depth0 != null ? depth0.index : depth0),(depth0 != null ? depth0.icon : depth0),((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.fullName : stack1),{"name":"makeOptionGemmaSearch","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                </a>\n";
},"6":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.categoryName : depth0),{"name":"if","hash":{},"fn":this.program(7, data, 0),"inverse":this.program(9, data, 0),"data":data})) != null ? stack1 : "");
},"7":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "                <a role=\"option\" id=\"aria-option-"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\"\n                    data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" href=\"#\" class=\"details\"\n                    data-value=\""
    + alias3(this.lambda(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.lastSearchName : stack1), depth0))
    + " - "
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "\" data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\">\n                    "
    + ((stack1 = (helpers.makeOptionOpenSearch || (depth0 && depth0.makeOptionOpenSearch) || alias1).call(depth0,(depth0 != null ? depth0.index : depth0),(depth0 != null ? depth0.icon : depth0),((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.displayName : stack1),(depth0 != null ? depth0.categoryName : depth0),{"name":"makeOptionOpenSearch","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                </a>\n";
},"9":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "               <a role=\"option\" id=\"aria-option-"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\"\n                    data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" href=\"#\" class=\"details\"\n                    data-value=\""
    + alias3(this.lambda(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.fullName : stack1), depth0))
    + "\" data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\">\n                    "
    + ((stack1 = (helpers.makeOptionGemmaSearch || (depth0 && depth0.makeOptionGemmaSearch) || alias1).call(depth0,(depth0 != null ? depth0.index : depth0),(depth0 != null ? depth0.icon : depth0),((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.fullName : stack1),{"name":"makeOptionGemmaSearch","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                </a>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing;

  return "<dl role=\"presentation\" data-tid=\"typeahead-list-category\">\n"
    + ((stack1 = (helpers.each_with_key || (depth0 && depth0.each_with_key) || alias1).call(depth0,(depth0 != null ? depth0.resultsByCategory : depth0),{"name":"each_with_key","hash":{"key":"categoryName"},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</dl>\n<footer data-tid=\"typeahead-footer\" class=\"footer\">\n    <a class=\"close\" href=\"#\">\n        "
    + this.escapeExpression(((helper = (helper = helpers.closeText || (depth0 != null ? depth0.closeText : depth0)) != null ? helper : alias1),(typeof helper === "function" ? helper.call(depth0,{"name":"closeText","hash":{},"data":data}) : helper)))
    + "<span class=\"icon icon-close\"></span>\n    </a>\n</footer>";
},"useData":true};
this["Handlebars"]["templates"]["default"] = {"1":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper;

  return "    <li role=\"presentation\" class=\"display-group-name\">"
    + this.escapeExpression(((helper = (helper = helpers.displayGroupName || (depth0 != null ? depth0.displayGroupName : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"displayGroupName","hash":{},"data":data}) : helper)))
    + "</li>\n    <div class=\"display-group-results\">\n"
    + ((stack1 = helpers.each.call(depth0,depth0,{"name":"each","hash":{},"fn":this.program(2, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    </div>\n";
},"2":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.index : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0, blockParams, depths),"inverse":this.program(8, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "");
},"3":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression, alias4=this.lambda;

  return "        <li role=\"presentation\" data-tid=\"typeahead-item"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" class=\"results-item\">\n            <a role=\"option\" id=\"aria-option-"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\" data-tid=\"typeahead-link"
    + alias3(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\"\n                href=\"#\" class=\"details\" data-value=\""
    + alias3(alias4(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.lastSearchName : stack1), depth0))
    + "\"\n                data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\" data-multiFlightInputId='"
    + alias3(alias4((depths[3] != null ? depths[3].multiFlightInputId : depths[3]), depth0))
    + "'>\n                "
    + ((stack1 = (helpers.getShowAsHierarchyFlag || (depth0 && depth0.getShowAsHierarchyFlag) || alias1).call(depth0,depth0,((stack1 = (depth0 != null ? depth0.hierarchyInfo : depth0)) != null ? stack1.relation : stack1),{"name":"getShowAsHierarchyFlag","hash":{},"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showAsHierarchy : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0, blockParams, depths),"inverse":this.program(6, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "            </a>\n        </li>\n";
},"4":function(depth0,helpers,partials,data) {
    var stack1, alias1=helpers.helperMissing;

  return "                <div class=\"child-suggestion\">\n                    "
    + ((stack1 = (helpers.getChildSuggestionIcon || (depth0 && depth0.getChildSuggestionIcon) || alias1).call(depth0,(depth0 != null ? depth0.index : depth0),{"name":"getChildSuggestionIcon","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                    "
    + ((stack1 = this.lambda(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.displayName : stack1), depth0)) != null ? stack1 : "")
    + "\n                    "
    + ((stack1 = (helpers.showDistanceFromNearbyAirport || (depth0 && depth0.showDistanceFromNearbyAirport) || alias1).call(depth0,((stack1 = ((stack1 = (depth0 != null ? depth0.hierarchyInfo : depth0)) != null ? stack1.nearby : stack1)) != null ? stack1.distInMI : stack1),{"name":"showDistanceFromNearbyAirport","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                </div>\n";
},"6":function(depth0,helpers,partials,data) {
    var stack1;

  return "                    "
    + ((stack1 = (helpers.makeOption || (depth0 && depth0.makeOption) || helpers.helperMissing).call(depth0,(depth0 != null ? depth0.index : depth0),(depth0 != null ? depth0.icon : depth0),((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.displayName : stack1),(depth0 != null ? depth0.rightFloatingTextHtml : depth0),{"name":"makeOption","hash":{},"data":data})) != null ? stack1 : "")
    + "\n";
},"8":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "        <li role=\"presentation\" data-tid=\"typeahead-item"
    + ((stack1 = (helpers.getItemCount || (depth0 && depth0.getItemCount) || alias1).call(depth0,(depth0 != null ? depth0.i : depth0),{"name":"getItemCount","hash":{},"data":data})) != null ? stack1 : "")
    + "\"\n            class=\"results-item\">\n            <a role=\"option\" id=\"aria-option-"
    + ((stack1 = (helpers.getItemCount || (depth0 && depth0.getItemCount) || alias1).call(depth0,(depth0 != null ? depth0.i : depth0),{"name":"getItemCount","hash":{},"data":data})) != null ? stack1 : "")
    + "\"\n                tabindex=\"-1\" data-tid=\"typeahead-link"
    + ((stack1 = (helpers.getItemCount || (depth0 && depth0.getItemCount) || alias1).call(depth0,(depth0 != null ? depth0.i : depth0),{"name":"getItemCount","hash":{},"data":data})) != null ? stack1 : "")
    + "\"\n                href=\"#\" class=\"details\" data-value=\""
    + alias3(((helper = (helper = helpers.l || (depth0 != null ? depth0.l : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"l","hash":{},"data":data}) : helper)))
    + "\" data-data=\""
    + alias3(((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"data","hash":{},"data":data}) : helper)))
    + "\"\n                data-multiFlightInputId='"
    + alias3(this.lambda((depths[3] != null ? depths[3].multiFlightInputId : depths[3]), depth0))
    + "'>\n                "
    + ((stack1 = (helpers.getShowAsHierarchyFlag || (depth0 && depth0.getShowAsHierarchyFlag) || alias1).call(depth0,depth0,(depth0 != null ? depth0.relation : depth0),{"name":"getShowAsHierarchyFlag","hash":{},"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showAsHierarchy : depth0),{"name":"if","hash":{},"fn":this.program(9, data, 0, blockParams, depths),"inverse":this.program(11, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "            </a>\n        </li>\n";
},"9":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing;

  return "                <div class=\"child-suggestion\">\n                    "
    + ((stack1 = (helpers.getChildSuggestionIcon || (depth0 && depth0.getChildSuggestionIcon) || alias1).call(depth0,(depth0 != null ? depth0.i : depth0),{"name":"getChildSuggestionIcon","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                    "
    + ((stack1 = ((helper = (helper = helpers.d || (depth0 != null ? depth0.d : depth0)) != null ? helper : alias1),(typeof helper === "function" ? helper.call(depth0,{"name":"d","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\n                    "
    + ((stack1 = (helpers.showDistanceFromNearbyAirport || (depth0 && depth0.showDistanceFromNearbyAirport) || alias1).call(depth0,(depth0 != null ? depth0.distInMI : depth0),{"name":"showDistanceFromNearbyAirport","hash":{},"data":data})) != null ? stack1 : "")
    + "\n                </div>\n";
},"11":function(depth0,helpers,partials,data) {
    var stack1;

  return "                    "
    + ((stack1 = (helpers.makeOption || (depth0 && depth0.makeOption) || helpers.helperMissing).call(depth0,(depth0 != null ? depth0.i : depth0),(depth0 != null ? depth0.icon : depth0),(depth0 != null ? depth0.d : depth0),{"name":"makeOption","hash":{},"data":data})) != null ? stack1 : "")
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=helpers.helperMissing;

  return "<ul role=\"listbox\" data-tid=\"typeahead-list\" class=\"results\">\n\n"
    + ((stack1 = (helpers.each_with_key || (depth0 && depth0.each_with_key) || alias1).call(depth0,(depth0 != null ? depth0.resultsByDisplayGroup : depth0),{"name":"each_with_key","hash":{"key":"displayGroupName"},"fn":this.program(1, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n</ul>\n<footer data-tid=\"typeahead-footer\" class=\"footer\" role=\"application\">\n    <a id=\"typeahead-close\" data-tid=\"typeahead-close\" class=\"close\" href=\"#\">\n        "
    + this.escapeExpression(((helper = (helper = helpers.closeText || (depth0 != null ? depth0.closeText : depth0)) != null ? helper : alias1),(typeof helper === "function" ? helper.call(depth0,{"name":"closeText","hash":{},"data":data}) : helper)))
    + "<span class=\"icon icon-close\"></span>\n    </a>\n</footer>\n";
},"useData":true,"useDepths":true};
this["Handlebars"]["templates"]["advanced-options-package-hbs"] = {"1":function(depth0,helpers,partials,data) {
    return "false";
},"3":function(depth0,helpers,partials,data) {
    return "true";
},"5":function(depth0,helpers,partials,data) {
    return "viewed";
},"7":function(depth0,helpers,partials,data) {
    return "open";
},"9":function(depth0,helpers,partials,data) {
    var stack1;

  return "        <div id=\"advanced-options-fields\">\n            <fieldset class=\"cols-nested\">\n"
    + ((stack1 = this.invokePartial(partials['corewizard/components/select-hbs'],(depth0 != null ? depth0.preferredFlightCabinClassOptions : depth0),{"name":"corewizard/components/select-hbs","data":data,"indent":"                ","helpers":helpers,"partials":partials})) != null ? stack1 : "")
    + "            </fieldset>\n        </div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"advanced-options col\">\n    <a\n            href=\"#advanced-options-fields\"\n            role=\"button\"\n            id=\"advanced-options\"\n            aria-controls=\"advanced-options-fields\"\n            aria-expanded=\""
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.hideFlightOptions : depth0),{"name":"unless","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.showFlightOptions : depth0),{"name":"unless","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\"\n            aria-pressed=\""
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.hideFlightOptions : depth0),{"name":"unless","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.showFlightOptions : depth0),{"name":"unless","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\"\n            class=\"toggle-trigger "
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.hideFlightOptions : depth0),{"name":"unless","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.showFlightOptions : depth0),{"name":"unless","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\"\n            data-wizard-action='{\"showFlightOptions\" : "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hideFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showFlightOptions : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " }'\n            >\n        "
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.advancedOptionsLabel : stack1), depth0))
    + "<span class=\"icon icon-expand\"></span>\n    </a>\n\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.showFlightOptions : depth0),{"name":"unless","hash":{},"fn":this.program(9, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n";
},"usePartial":true,"useData":true};
//https://gist.github.com/dhm116/1790197

if (!('forEach' in Array.prototype)) {
  Array.prototype.forEach= function(action, that /*opt*/) {
    for (var i= 0, n= this.length; i<n; i++)
      if (i in this)
        action.call(that, this[i], i, this);
  };
}

if (!('bind' in Function.prototype)) {
  Function.prototype.bind= function(owner) {
    var that= this;
    if (arguments.length<=1) {
      return function() {
        return that.apply(owner, arguments);
      };
    } else {
      var args= Array.prototype.slice.call(arguments, 1);
      return function() {
        return that.apply(owner, arguments.length===0? args : args.concat(Array.prototype.slice.call(arguments)));
      };
    }
  };
}
/*!

 handlebars v3.0.3

Copyright (C) 2011-2014 by Yehuda Katz

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

@license
*/
define("handlebars/utils", ["exports"], function(a) {
  modulizr.amd.handlebarsv3 = true;

  function b(a) {
    return i[a]
  }

  function c(a) {
    for (var b = 1; b < arguments.length; b++)
      for (var c in arguments[b]) Object.prototype.hasOwnProperty.call(arguments[b], c) && (a[c] = arguments[b][c]);
    return a
  }

  function d(a, b) {
    for (var c = 0, d = a.length; d > c; c++)
      if (a[c] === b) return c;
    return -1
  }

  function e(a) {
    if ("string" != typeof a) {
      if (a && a.toHTML) return a.toHTML();
      if (null == a) return "";
      if (!a) return a + "";
      a = "" + a
    }
    return k.test(a) ? a.replace(j, b) : a
  }

  function f(a) {
    return a || 0 === a ? n(a) && 0 === a.length ? !0 : !1 : !0
  }

  function g(a, b) {
    return a.path = b, a
  }

  function h(a, b) {
    return (a ? a + "." : "") + b
  }
  a.__esModule = !0, a.extend = c, a.indexOf = d, a.escapeExpression = e, a.isEmpty = f, a.blockParams = g, a.appendContextPath = h;
  var i = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#x27;",
      "`": "&#x60;"
    },
    j = /[&<>"'`]/g,
    k = /[&<>"'`]/,
    l = Object.prototype.toString;
  a.toString = l;
  var m = function(a) {
    return "function" == typeof a
  };
  m(/x/) && (a.isFunction = m = function(a) {
    return "function" == typeof a && "[object Function]" === l.call(a)
  });
  var m;
  a.isFunction = m;
  var n = Array.isArray || function(a) {
    return a && "object" == typeof a ? "[object Array]" === l.call(a) : !1
  };
  a.isArray = n;
  return a;
}), define("handlebars/exception", ["exports", "module"], function(a, b) {
  function c(a, b) {
    var e = b && b.loc,
      f = void 0,
      g = void 0;
    e && (f = e.start.line, g = e.start.column, a += " - " + f + ":" + g);
    for (var h = Error.prototype.constructor.call(this, a), i = 0; i < d.length; i++) this[d[i]] = h[d[i]];
    Error.captureStackTrace && Error.captureStackTrace(this, c), e && (this.lineNumber = f, this.column = g)
  }
  var d = ["description", "fileName", "lineNumber", "message", "name", "number", "stack"];
  c.prototype = new Error, b.exports = c;
  return b.exports;
}), define("handlebars/base", ["exports", "./utils", "./exception"], function(a, b, c) {
  function d(a, b) {
    this.helpers = a || {}, this.partials = b || {}, e(this)
  }

  function e(a) {
    a.registerHelper("helperMissing", function() {
      if (1 === arguments.length) return void 0;
      throw new h('Missing helper: "' + arguments[arguments.length - 1].name + '"')
    }), a.registerHelper("blockHelperMissing", function(c, d) {
      var e = d.inverse,
        g = d.fn;
      if (c === !0) return g(this);
      if (c === !1 || null == c) return e(this);
      if (l(c)) return c.length > 0 ? (d.ids && (d.ids = [d.name]), a.helpers.each(c, d)) : e(this);
      if (d.data && d.ids) {
        var h = f(d.data);
        h.contextPath = b.appendContextPath(d.data.contextPath, d.name), d = {
          data: h
        }
      }
      return g(c, d)
    }), a.registerHelper("each", function(a, c) {
      function d(c, d, f) {
        k && (k.key = c, k.index = d, k.first = 0 === d, k.last = !!f, n && (k.contextPath = n + c)), j += e(a[c], {
          data: k,
          blockParams: b.blockParams([a[c], c], [n + c, null])
        })
      }
      if (!c) throw new h("Must pass iterator to #each");
      var e = c.fn,
        g = c.inverse,
        i = 0,
        j = "",
        k = void 0,
        n = void 0;
      if (c.data && c.ids && (n = b.appendContextPath(c.data.contextPath, c.ids[0]) + "."), m(a) && (a = a.call(this)), c.data && (k = f(c.data)), a && "object" == typeof a)
        if (l(a))
          for (var o = a.length; o > i; i++) d(i, i, i === a.length - 1);
        else {
          var p = void 0;
          for (var q in a) a.hasOwnProperty(q) && (p && d(p, i - 1), p = q, i++);
          p && d(p, i - 1, !0)
        }
      return 0 === i && (j = g(this)), j
    }), a.registerHelper("if", function(a, c) {
      return m(a) && (a = a.call(this)), !c.hash.includeZero && !a || b.isEmpty(a) ? c.inverse(this) : c.fn(this)
    }), a.registerHelper("unless", function(b, c) {
      return a.helpers["if"].call(this, b, {
        fn: c.inverse,
        inverse: c.fn,
        hash: c.hash
      })
    }), a.registerHelper("with", function(a, c) {
      m(a) && (a = a.call(this));
      var d = c.fn;
      if (b.isEmpty(a)) return c.inverse(this);
      if (c.data && c.ids) {
        var e = f(c.data);
        e.contextPath = b.appendContextPath(c.data.contextPath, c.ids[0]), c = {
          data: e
        }
      }
      return d(a, c)
    }), a.registerHelper("log", function(b, c) {
      var d = c.data && null != c.data.level ? parseInt(c.data.level, 10) : 1;
      a.log(d, b)
    }), a.registerHelper("lookup", function(a, b) {
      return a && a[b]
    })
  }

  function f(a) {
    var c = b.extend({}, a);
    return c._parent = a, c
  }
  var g = function(a) {
    return a && a.__esModule ? a["default"] : a
  };
  a.__esModule = !0, a.HandlebarsEnvironment = d, a.createFrame = f;
  var h = g(c),
    i = "3.0.1";
  a.VERSION = i;
  var j = 6;
  a.COMPILER_REVISION = j;
  var k = {
    1: "<= 1.0.rc.2",
    2: "== 1.0.0-rc.3",
    3: "== 1.0.0-rc.4",
    4: "== 1.x.x",
    5: "== 2.0.0-alpha.x",
    6: ">= 2.0.0-beta.1"
  };
  a.REVISION_CHANGES = k;
  var l = b.isArray,
    m = b.isFunction,
    n = b.toString,
    o = "[object Object]";
  d.prototype = {
    constructor: d,
    logger: p,
    log: q,
    registerHelper: function(a, c) {
      if (n.call(a) === o) {
        if (c) throw new h("Arg not supported with multiple helpers");
        b.extend(this.helpers, a)
      } else this.helpers[a] = c
    },
    unregisterHelper: function(a) {
      delete this.helpers[a]
    },
    registerPartial: function(a, c) {
      if (n.call(a) === o) b.extend(this.partials, a);
      else {
        if ("undefined" == typeof c) throw new h("Attempting to register a partial as undefined");
        this.partials[a] = c
      }
    },
    unregisterPartial: function(a) {
      delete this.partials[a]
    }
  };
  var p = {
    methodMap: {
      0: "debug",
      1: "info",
      2: "warn",
      3: "error"
    },
    DEBUG: 0,
    INFO: 1,
    WARN: 2,
    ERROR: 3,
    level: 1,
    log: function(a, b) {
      if ("undefined" != typeof console && p.level <= a) {
        var c = p.methodMap[a];
        (console[c] || console.log).call(console, b)
      }
    }
  };
  a.logger = p;
  var q = p.log;
  a.log = q;
  return a;
}), define("handlebars/safe-string", ["exports", "module"], function(a, b) {
  function c(a) {
    this.string = a
  }
  c.prototype.toString = c.prototype.toHTML = function() {
    return "" + this.string
  }, b.exports = c;
  return b.exports;
}), define("handlebars/runtime", ["exports", "./utils", "./exception", "./base"], function(a, b, c, d) {
  function e(a) {
    var b = a && a[0] || 1,
      c = d.COMPILER_REVISION;
    if (b !== c) {
      if (c > b) {
        var e = d.REVISION_CHANGES[c],
          f = d.REVISION_CHANGES[b];
        throw new m("Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version (" + e + ") or downgrade your runtime to an older version (" + f + ").")
      }
      throw new m("Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version (" + a[1] + ").")
    }
  }

  function f(a, c) {
    function d(d, e, f) {
      f.hash && (e = b.extend({}, e, f.hash)), d = c.VM.resolvePartial.call(this, d, e, f);
      var g = c.VM.invokePartial.call(this, d, e, f);
      if (null == g && c.compile && (f.partials[f.name] = c.compile(d, a.compilerOptions, c), g = f.partials[f.name](e, f)), null != g) {
        if (f.indent) {
          for (var h = g.split("\n"), i = 0, j = h.length; j > i && (h[i] || i + 1 !== j); i++) h[i] = f.indent + h[i];
          g = h.join("\n")
        }
        return g
      }
      throw new m("The partial " + f.name + " could not be compiled when running in runtime-only mode")
    }

    function e(b) {
      var c = void 0 === arguments[1] ? {} : arguments[1],
        d = c.data;
      e._setup(c), !c.partial && a.useData && (d = k(b, d));
      var g = void 0,
        h = a.useBlockParams ? [] : void 0;
      return a.useDepths && (g = c.depths ? [b].concat(c.depths) : [b]), a.main.call(f, b, f.helpers, f.partials, d, h, g)
    }
    if (!c) throw new m("No environment passed to template");
    if (!a || !a.main) throw new m("Unknown template object: " + typeof a);
    c.VM.checkRevision(a.compiler);
    var f = {
      strict: function(a, b) {
        if (!(b in a)) throw new m('"' + b + '" not defined in ' + a);
        return a[b]
      },
      lookup: function(a, b) {
        for (var c = a.length, d = 0; c > d; d++)
          if (a[d] && null != a[d][b]) return a[d][b]
      },
      lambda: function(a, b) {
        return "function" == typeof a ? a.call(b) : a
      },
      escapeExpression: b.escapeExpression,
      invokePartial: d,
      fn: function(b) {
        return a[b]
      },
      programs: [],
      program: function(a, b, c, d, e) {
        var f = this.programs[a],
          h = this.fn(a);
        return b || e || d || c ? f = g(this, a, h, b, c, d, e) : f || (f = this.programs[a] = g(this, a, h)), f
      },
      data: function(a, b) {
        for (; a && b--;) a = a._parent;
        return a
      },
      merge: function(a, c) {
        var d = a || c;
        return a && c && a !== c && (d = b.extend({}, c, a)), d
      },
      noop: c.VM.noop,
      compilerInfo: a.compiler
    };
    return e.isTop = !0, e._setup = function(b) {
      b.partial ? (f.helpers = b.helpers, f.partials = b.partials) : (f.helpers = f.merge(b.helpers, c.helpers), a.usePartial && (f.partials = f.merge(b.partials, c.partials)))
    }, e._child = function(b, c, d, e) {
      if (a.useBlockParams && !d) throw new m("must pass block params");
      if (a.useDepths && !e) throw new m("must pass parent depths");
      return g(f, b, a[b], c, 0, d, e)
    }, e
  }

  function g(a, b, c, d, e, f, g) {
    function h(b) {
      var e = void 0 === arguments[1] ? {} : arguments[1];
      return c.call(a, b, a.helpers, a.partials, e.data || d, f && [e.blockParams].concat(f), g && [b].concat(g))
    }
    return h.program = b, h.depth = g ? g.length : 0, h.blockParams = e || 0, h
  }

  function h(a, b, c) {
    return a ? a.call || c.name || (c.name = a, a = c.partials[a]) : a = c.partials[c.name], a
  }

  function i(a, b, c) {
    if (c.partial = !0, void 0 === a) throw new m("The partial " + c.name + " could not be found");
    return a instanceof Function ? a(b, c) : void 0
  }

  function j() {
    return ""
  }

  function k(a, b) {
    return b && "root" in b || (b = b ? d.createFrame(b) : {}, b.root = a), b
  }
  var l = function(a) {
    return a && a.__esModule ? a["default"] : a
  };
  a.__esModule = !0, a.checkRevision = e, a.template = f, a.wrapProgram = g, a.resolvePartial = h, a.invokePartial = i, a.noop = j;
  var m = l(c);
  return a;
}), define("handlebars/no-conflict", ["exports", "module"], function(a, b) {
  b.exports = function(a) {
    var b = "undefined" != typeof global ? global : window,
      c = b.Handlebars;
    a.noConflict = function() {
      b.Handlebars === a && (b.Handlebars = c)
    }
  };
  return b.exports;
}), define("handlebars.runtime", ["exports", "module", "./handlebars/base", "./handlebars/safe-string", "./handlebars/exception", "./handlebars/utils", "./handlebars/runtime", "./handlebars/no-conflict"], function(a, b, c, d, e, f, g, h) {
  function i() {
    var a = new c.HandlebarsEnvironment;
    return f.extend(a, c), a.SafeString = k, a.Exception = l, a.Utils = f, a.escapeExpression = f.escapeExpression, a.VM = g, a.template = function(b) {
      return g.template(b, a)
    }, a
  }
  var j = function(a) {
      return a && a.__esModule ? a["default"] : a
    },
    k = j(d),
    l = j(e),
    m = j(h),
    n = i();
  n.create = i, m(n), n["default"] = n, b.exports = n;
  return b.exports;
});
//     Underscore.js 1.8.3
//     http://underscorejs.org
//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` (`self`) in the browser, `global`
  // on the server, or `this` in some virtual machines. We use `self`
  // instead of `window` for `WebWorker` support.
  var root = typeof self == 'object' && self.self === self && self ||
    typeof global == 'object' && global.global === global && global ||
    this;

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype;

  // Create quick reference variables for speed access to core prototypes.
  var
    push = ArrayProto.push,
    slice = ArrayProto.slice,
    toString = ObjProto.toString,
    hasOwnProperty = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var
    nativeIsArray = Array.isArray,
    nativeKeys = Object.keys,
    nativeCreate = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for their old module API. If we're in
  // the browser, add `_` as a global object.
  if (typeof exports != 'undefined') {
    if (typeof module != 'undefined' && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.8.3';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      // The 2-parameter case has been omitted only because no current consumers
      // made use of it.
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  // A mostly-internal function to generate callbacks that can be applied
  // to each element in a collection, returning the desired result — either
  // `identity`, an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value)) return _.matcher(value);
    return _.property(value);
  };

  _.iteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // Similar to ES6's rest param (http://ariya.ofilabs.com/2013/03/es6-and-rest-parameter.html)
  // This accumulates the arguments passed into an array, after a given index.
  var restArgs = function(func, startIndex) {
    startIndex = startIndex == null ? func.length - 1 : +startIndex;
    return function() {
      var length = Math.max(arguments.length - startIndex, 0);
      var rest = Array(length);
      for (var index = 0; index < length; index++) {
        rest[index] = arguments[index + startIndex];
      }
      switch (startIndex) {
        case 0: return func.call(this, rest);
        case 1: return func.call(this, arguments[0], rest);
        case 2: return func.call(this, arguments[0], arguments[1], rest);
      }
      var args = Array(startIndex + 1);
      for (index = 0; index < startIndex; index++) {
        args[index] = arguments[index];
      }
      args[startIndex] = rest;
      return func.apply(this, args);
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  var property = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object.
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = property('length');
  var isArrayLike = function(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
      length = (keys || obj).length,
      results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  var createReduce = function(dir) {
    // Optimized iterator function as using arguments.length
    // in the main function will deoptimize the, see #1991.
    var reducer = function(obj, iteratee, memo, initial) {
      var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        index = dir > 0 ? 0 : length - 1;
      if (!initial) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    };

    return function(obj, iteratee, memo, context) {
      var initial = arguments.length >= 3;
      return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
    };
  };

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var key;
    if (isArrayLike(obj)) {
      key = _.findIndex(obj, predicate, context);
    } else {
      key = _.findKey(obj, predicate, context);
    }
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
      length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
      length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = restArgs(function(obj, method, args) {
    var isFunc = _.isFunction(method);
    return _.map(obj, function(value) {
      var func = isFunc ? method : value[method];
      return func == null ? func : func.apply(value, args);
    });
  });

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
      value, computed;
    if (iteratee == null || (typeof iteratee == 'number' && typeof obj[0] != 'object') && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
      value, computed;
    if (iteratee == null || (typeof iteratee == 'number' && typeof obj[0] != 'object') && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection.
  _.shuffle = function(obj) {
    return _.sample(obj, Infinity);
  };

  // Sample **n** random values from a collection using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    var sample = isArrayLike(obj) ? _.clone(obj) : _.values(obj);
    var length = getLength(sample);
    n = Math.max(Math.min(n, length), 0);
    var last = length - 1;
    for (var index = 0; index < n; index++) {
      var rand = _.random(index, last);
      var temp = sample[index];
      sample[index] = sample[rand];
      sample[rand] = temp;
    }
    return sample.slice(0, n);
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    var index = 0;
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, key, list) {
      return {
        value: value,
        index: index++,
        criteria: iteratee(value, key, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior, partition) {
    return function(obj, iteratee, context) {
      var result = partition ? [[], []] : {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key]++; else result[key] = 1;
  });

  var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (_.isString(obj)) {
      // Keep surrogate pair characters together
      return obj ? obj.match(reStrSymbol) : [];
    }
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = group(function(result, value, pass) {
    result[pass ? 0 : 1].push(value);
  }, true);

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, _.identity);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, output) {
    output = output || [];
    var idx = output.length;
    for (var i = 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        //flatten current level of array or arguments object
        if (shallow) {
          var j = 0, len = value.length;
          while (j < len) output[idx++] = value[j++];
        } else {
          flatten(value, shallow, strict, output);
          idx = output.length;
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = restArgs(function(array, otherArrays) {
    return _.difference(array, otherArrays);
  });

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
        computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = restArgs(function(arrays) {
    return _.uniq(flatten(arrays, true, true));
  });

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      var j;
      for (j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = restArgs(function(array, rest) {
    rest = flatten(rest, true, true);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  });

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices
  _.unzip = function(array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = restArgs(_.unzip);

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions
  var createPredicateIndexFinder = function(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  };

  // Returns the first index on an array-like that passes a predicate test
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions
  var createIndexFinder = function(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
          i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
          length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  };

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    step = step || 1;

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Split an **array** into several arrays containing **count** or less elements
  // of initial array
  _.chunk = function(array, count) {
    if (count == null || count < 1) return [];

    var result = [];
    var i = 0, length = array.length;
    while (i < length) {
      result.push(slice.call(array, i, i += count));
    }
    return result;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = restArgs(function(func, context, args) {
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var bound = restArgs(function(callArgs) {
      return executeBound(func, bound, context, this, args.concat(callArgs));
    });
    return bound;
  });

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder by default, allowing any combination of arguments to be
  // pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
  _.partial = restArgs(function(func, boundArgs) {
    var placeholder = _.partial.placeholder;
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  });

  _.partial.placeholder = _;

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = restArgs(function(obj, keys) {
    keys = flatten(keys, false, false);
    var index = keys.length;
    if (index < 1) throw new Error('bindAll must be passed function names');
    while (index--) {
      var key = keys[index];
      obj[key] = _.bind(obj[key], obj);
    }
  });

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = restArgs(function(func, wait, args) {
    return setTimeout(function(){
      return func.apply(null, args);
    }, wait);
  });

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };
    return function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, args, context, timestamp, result;

    var later = function() {
      var last = _.now() - timestamp;

      if (last < wait && last >= 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = func.apply(context, args);
          if (!timeout) context = args = null;
        }
      }
    };

    return function() {
      context = this;
      args = arguments;
      timestamp = _.now();
      var callNow = immediate && !timeout;
      if (!timeout) timeout = setTimeout(later, wait);
      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }

      return result;
    };
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  _.restArgs = restArgs;

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
    'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  var collectNonEnumProps = function(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = _.isFunction(constructor) && constructor.prototype || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  };

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (_.has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object
  // In contrast to _.map it returns an object
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = _.keys(obj),
      length = keys.length,
      results = {};
    for (var index = 0; index < length; index++) {
      var currentKey = keys[index];
      results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, defaults) {
    return function(obj) {
      var length = arguments.length;
      if (defaults) obj = Object(obj);
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
          keys = keysFunc(source),
          l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!defaults || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s)
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Internal pick helper function to determine if `obj` has key `key`.
  var keyInObj = function(value, key, obj) {
    return key in obj;
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = restArgs(function(obj, keys) {
    var result = {}, iteratee = keys[0];
    if (obj == null) return result;
    if (_.isFunction(iteratee)) {
      if (keys.length > 1) iteratee = optimizeCb(iteratee, keys[1]);
      keys = _.allKeys(obj);
    } else {
      iteratee = keyInObj;
      keys = flatten(keys, false, false);
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  });

  // Return a copy of the object without the blacklisted properties.
  _.omit = restArgs(function(obj, keys) {
    var iteratee = keys[0], context;
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
      if (keys.length > 1) context = keys[1];
    } else {
      keys = _.map(flatten(keys, false, false), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  });

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function(prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq, deepEq;
  eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // A strict comparison is necessary because `null == undefined`.
    if (a == null || b == null) return a === b;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
    return deepEq(a, b, aStack, bStack);
  };

  // Internal recursive comparison function for `isEqual`.
  deepEq = function(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
        _.isFunction(bCtor) && bCtor instanceof bCtor)
        && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
      return toString.call(obj) === '[object Array]';
    };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return _.has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
  var nodelist = root.document && root.document.childNodes;
  if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`?
  _.isNaN = function(obj) {
    return _.isNumber(obj) && isNaN(obj);
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, key) {
    return obj != null && hasOwnProperty.call(obj, key);
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  _.property = property;

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    return obj == null ? function(){} : function(key) {
      return obj[key];
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
      return new Date().getTime();
    };

  // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // If the value of the named `property` is a function then invoke it with the
  // `object` as context; otherwise, return it.
  _.result = function(object, prop, fallback) {
    var value = object == null ? void 0 : object[prop];
    if (value === void 0) {
      value = fallback;
    }
    return _.isFunction(value) ? value.call(object) : value;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: /<%=([\s\S]+?)%>/g,
    escape: /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'": "'",
    '\\': '\\',
    '\r': 'r',
    '\n': 'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
        (settings.escape || noMatch).source,
        (settings.interpolate || noMatch).source,
        (settings.evaluate || noMatch).source
      ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offset.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    var render;
    try {
      render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var chainResult = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return chainResult(this, func.apply(_, args));
      };
    });
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return chainResult(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return chainResult(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return '' + this._wrapped;
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (typeof define == 'function' && define.amd) {
    define('underscore', [], function() {
      return _;
    });
  }
}());
//     Backbone.js 1.1.2

//     (c) 2010-2014 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Backbone may be freely distributed under the MIT license.
//     For all details and documentation:
//     http://backbonejs.org

(function(root, factory) {
  // Set up Backbone appropriately for the environment. Start with AMD.
  //if (typeof define === 'function' && define.amd) {
  //  define('backbone', ['underscore', 'jquery', 'exports'], function(_, $, exports) {
  //    // Export global even in AMD case in case this script is loaded with
  //    // others that may still expect a global Backbone.
  //    root.Backbone = factory(root, exports, _, $);
  //  });
  //
  //// Next for Node.js or CommonJS. jQuery may not be needed as a module.
  //} else if (typeof exports !== 'undefined') {
  //  var _ = require('underscore');
  //  factory(root, exports, _);
  //
  //// Finally, as a browser global.
  //} else {
  root.Backbone = factory(root, {}, root._, (root.jQuery || root.Zepto || root.ender || root.$));
  //}
}(this, function(root, Backbone, _, $) {

  // Initial Setup
  // -------------

  // Save the previous value of the `Backbone` variable, so that it can be
  // restored later on, if `noConflict` is used.
  var previousBackbone = root.Backbone;

  // Create local references to array methods we'll want to use later.
  var array = [];
  var push = array.push;
  var slice = array.slice;
  var splice = array.splice;

  // Current version of the library. Keep in sync with `package.json`.
  Backbone.VERSION = '1.1.2';

  // For Backbone's purposes, jQuery, Zepto, Ender, or My Library (kidding) owns
  // the `$` variable.
  Backbone.$ = function(){};
  require(['jquery'], function($) {
    Backbone.$ = $;
  });

  // Runs Backbone.js in *noConflict* mode, returning the `Backbone` variable
  // to its previous owner. Returns a reference to this Backbone object.
  Backbone.noConflict = function() {
    root.Backbone = previousBackbone;
    return this;
  };

  // Turn on `emulateHTTP` to support legacy HTTP servers. Setting this option
  // will fake `"PATCH"`, `"PUT"` and `"DELETE"` requests via the `_method` parameter and
  // set a `X-Http-Method-Override` header.
  Backbone.emulateHTTP = false;

  // Turn on `emulateJSON` to support legacy servers that can't deal with direct
  // `application/json` requests ... will encode the body as
  // `application/x-www-form-urlencoded` instead and will send the model in a
  // form param named `model`.
  Backbone.emulateJSON = false;

  // Backbone.Events
  // ---------------

  // A module that can be mixed in to *any object* in order to provide it with
  // custom events. You may bind with `on` or remove with `off` callback
  // functions to an event; `trigger`-ing an event fires all callbacks in
  // succession.
  //
  //     var object = {};
  //     _.extend(object, Backbone.Events);
  //     object.on('expand', function(){ alert('expanded'); });
  //     object.trigger('expand');
  //
  var Events = Backbone.Events = {

    // Bind an event to a `callback` function. Passing `"all"` will bind
    // the callback to all events fired.
    on: function(name, callback, context) {
      if (!eventsApi(this, 'on', name, [callback, context]) || !callback) return this;
      this._events || (this._events = {});
      var events = this._events[name] || (this._events[name] = []);
      events.push({callback: callback, context: context, ctx: context || this});
      return this;
    },

    // Bind an event to only be triggered a single time. After the first time
    // the callback is invoked, it will be removed.
    once: function(name, callback, context) {
      if (!eventsApi(this, 'once', name, [callback, context]) || !callback) return this;
      var self = this;
      var once = _.once(function() {
        self.off(name, once);
        callback.apply(this, arguments);
      });
      once._callback = callback;
      return this.on(name, once, context);
    },

    // Remove one or many callbacks. If `context` is null, removes all
    // callbacks with that function. If `callback` is null, removes all
    // callbacks for the event. If `name` is null, removes all bound
    // callbacks for all events.
    off: function(name, callback, context) {
      var retain, ev, events, names, i, l, j, k;
      if (!this._events || !eventsApi(this, 'off', name, [callback, context])) return this;
      if (!name && !callback && !context) {
        this._events = void 0;
        return this;
      }
      names = name ? [name] : _.keys(this._events);
      for (i = 0, l = names.length; i < l; i++) {
        name = names[i];
        if (events = this._events[name]) {
          this._events[name] = retain = [];
          if (callback || context) {
            for (j = 0, k = events.length; j < k; j++) {
              ev = events[j];
              if ((callback && callback !== ev.callback && callback !== ev.callback._callback) ||
                  (context && context !== ev.context)) {
                retain.push(ev);
              }
            }
          }
          if (!retain.length) delete this._events[name];
        }
      }

      return this;
    },

    // Trigger one or many events, firing all bound callbacks. Callbacks are
    // passed the same arguments as `trigger` is, apart from the event name
    // (unless you're listening on `"all"`, which will cause your callback to
    // receive the true name of the event as the first argument).
    trigger: function(name) {
      if (!this._events) return this;
      var args = slice.call(arguments, 1);
      if (!eventsApi(this, 'trigger', name, args)) return this;
      var events = this._events[name];
      var allEvents = this._events.all;
      if (events) triggerEvents(events, args);
      if (allEvents) triggerEvents(allEvents, arguments);
      return this;
    },

    // Tell this object to stop listening to either specific events ... or
    // to every object it's currently listening to.
    stopListening: function(obj, name, callback) {
      var listeningTo = this._listeningTo;
      if (!listeningTo) return this;
      var remove = !name && !callback;
      if (!callback && typeof name === 'object') callback = this;
      if (obj) (listeningTo = {})[obj._listenId] = obj;
      for (var id in listeningTo) {
        obj = listeningTo[id];
        obj.off(name, callback, this);
        if (remove || _.isEmpty(obj._events)) delete this._listeningTo[id];
      }
      return this;
    }

  };

  // Regular expression used to split event strings.
  var eventSplitter = /\s+/;

  // Implement fancy features of the Events API such as multiple event
  // names `"change blur"` and jQuery-style event maps `{change: action}`
  // in terms of the existing API.
  var eventsApi = function(obj, action, name, rest) {
    if (!name) return true;

    // Handle event maps.
    if (typeof name === 'object') {
      for (var key in name) {
        obj[action].apply(obj, [key, name[key]].concat(rest));
      }
      return false;
    }

    // Handle space separated event names.
    if (eventSplitter.test(name)) {
      var names = name.split(eventSplitter);
      for (var i = 0, l = names.length; i < l; i++) {
        obj[action].apply(obj, [names[i]].concat(rest));
      }
      return false;
    }

    return true;
  };

  // A difficult-to-believe, but optimized internal dispatch function for
  // triggering events. Tries to keep the usual cases speedy (most internal
  // Backbone events have 3 arguments).
  var triggerEvents = function(events, args) {
    var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
    switch (args.length) {
      case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
      case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
      case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
      case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
      default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args); return;
    }
  };

  var listenMethods = {listenTo: 'on', listenToOnce: 'once'};

  // Inversion-of-control versions of `on` and `once`. Tell *this* object to
  // listen to an event in another object ... keeping track of what it's
  // listening to.
  _.each(listenMethods, function(implementation, method) {
    Events[method] = function(obj, name, callback) {
      var listeningTo = this._listeningTo || (this._listeningTo = {});
      var id = obj._listenId || (obj._listenId = _.uniqueId('l'));
      listeningTo[id] = obj;
      if (!callback && typeof name === 'object') callback = this;
      obj[implementation](name, callback, this);
      return this;
    };
  });

  // Aliases for backwards compatibility.
  Events.bind   = Events.on;
  Events.unbind = Events.off;

  // Allow the `Backbone` object to serve as a global event bus, for folks who
  // want global "pubsub" in a convenient place.
  _.extend(Backbone, Events);

  // Backbone.Model
  // --------------

  // Backbone **Models** are the basic data object in the framework --
  // frequently representing a row in a table in a database on your server.
  // A discrete chunk of data and a bunch of useful, related methods for
  // performing computations and transformations on that data.

  // Create a new model with the specified attributes. A client id (`cid`)
  // is automatically generated and assigned for you.
  var Model = Backbone.Model = function(attributes, options) {
    var attrs = attributes || {};
    options || (options = {});
    this.cid = _.uniqueId('c');
    this.attributes = {};
    if (options.collection) this.collection = options.collection;
    if (options.parse) attrs = this.parse(attrs, options) || {};
    attrs = _.defaults({}, attrs, _.result(this, 'defaults'));
    this.set(attrs, options);
    this.changed = {};
    this.initialize.apply(this, arguments);
  };

  // Attach all inheritable methods to the Model prototype.
  _.extend(Model.prototype, Events, {

    // A hash of attributes whose current and previous value differ.
    changed: null,

    // The value returned during the last failed validation.
    validationError: null,

    // The default name for the JSON `id` attribute is `"id"`. MongoDB and
    // CouchDB users may want to set this to `"_id"`.
    idAttribute: 'id',

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Return a copy of the model's `attributes` object.
    toJSON: function(options) {
      return _.clone(this.attributes);
    },

    // Proxy `Backbone.sync` by default -- but override this if you need
    // custom syncing semantics for *this* particular model.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Get the value of an attribute.
    get: function(attr) {
      return this.attributes[attr];
    },

    // Get the HTML-escaped value of an attribute.
    escape: function(attr) {
      return _.escape(this.get(attr));
    },

    // Returns `true` if the attribute contains a value that is not null
    // or undefined.
    has: function(attr) {
      return this.get(attr) != null;
    },

    // Set a hash of model attributes on the object, firing `"change"`. This is
    // the core primitive operation of a model, updating the data and notifying
    // anyone who needs to know about the change in state. The heart of the beast.
    set: function(key, val, options) {
      var attr, attrs, unset, changes, silent, changing, prev, current;
      if (key == null) return this;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      if (typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options || (options = {});

      // Run validation.
      if (!this._validate(attrs, options)) return false;

      // Extract attributes and options.
      unset           = options.unset;
      silent          = options.silent;
      changes         = [];
      changing        = this._changing;
      this._changing  = true;

      if (!changing) {
        this._previousAttributes = _.clone(this.attributes);
        this.changed = {};
      }
      current = this.attributes, prev = this._previousAttributes;

      // Check for changes of `id`.
      if (this.idAttribute in attrs) this.id = attrs[this.idAttribute];

      // For each `set` attribute, update or delete the current value.
      for (attr in attrs) {
        val = attrs[attr];
        if (!_.isEqual(current[attr], val)) changes.push(attr);
        if (!_.isEqual(prev[attr], val)) {
          this.changed[attr] = val;
        } else {
          delete this.changed[attr];
        }
        unset ? delete current[attr] : current[attr] = val;
      }

      // Trigger all relevant attribute changes.
      if (!silent) {
        if (changes.length) this._pending = options;
        for (var i = 0, l = changes.length; i < l; i++) {
          this.trigger('change:' + changes[i], this, current[changes[i]], options);
        }
      }

      // You might be wondering why there's a `while` loop here. Changes can
      // be recursively nested within `"change"` events.
      if (changing) return this;
      if (!silent) {
        while (this._pending) {
          options = this._pending;
          this._pending = false;
          this.trigger('change', this, options);
        }
      }
      this._pending = false;
      this._changing = false;
      return this;
    },

    // Remove an attribute from the model, firing `"change"`. `unset` is a noop
    // if the attribute doesn't exist.
    unset: function(attr, options) {
      return this.set(attr, void 0, _.extend({}, options, {unset: true}));
    },

    // Clear all attributes on the model, firing `"change"`.
    clear: function(options) {
      var attrs = {};
      for (var key in this.attributes) attrs[key] = void 0;
      return this.set(attrs, _.extend({}, options, {unset: true}));
    },

    // Determine if the model has changed since the last `"change"` event.
    // If you specify an attribute name, determine if that attribute has changed.
    hasChanged: function(attr) {
      if (attr == null) return !_.isEmpty(this.changed);
      return _.has(this.changed, attr);
    },

    // Return an object containing all the attributes that have changed, or
    // false if there are no changed attributes. Useful for determining what
    // parts of a view need to be updated and/or what attributes need to be
    // persisted to the server. Unset attributes will be set to undefined.
    // You can also pass an attributes object to diff against the model,
    // determining if there *would be* a change.
    changedAttributes: function(diff) {
      if (!diff) return this.hasChanged() ? _.clone(this.changed) : false;
      var val, changed = false;
      var old = this._changing ? this._previousAttributes : this.attributes;
      for (var attr in diff) {
        if (_.isEqual(old[attr], (val = diff[attr]))) continue;
        (changed || (changed = {}))[attr] = val;
      }
      return changed;
    },

    // Get the previous value of an attribute, recorded at the time the last
    // `"change"` event was fired.
    previous: function(attr) {
      if (attr == null || !this._previousAttributes) return null;
      return this._previousAttributes[attr];
    },

    // Get all of the attributes of the model at the time of the previous
    // `"change"` event.
    previousAttributes: function() {
      return _.clone(this._previousAttributes);
    },

    // Fetch the model from the server. If the server's representation of the
    // model differs from its current attributes, they will be overridden,
    // triggering a `"change"` event.
    fetch: function(options) {
      options = options ? _.clone(options) : {};
      if (options.parse === void 0) options.parse = true;
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        if (!model.set(model.parse(resp, options), options)) return false;
        if (success) success(model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Set a hash of model attributes, and sync the model to the server.
    // If the server returns an attributes hash that differs, the model's
    // state will be `set` again.
    save: function(key, val, options) {
      var attrs, method, xhr, attributes = this.attributes;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      if (key == null || typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options = _.extend({validate: true}, options);

      // If we're not waiting and attributes exist, save acts as
      // `set(attr).save(null, opts)` with validation. Otherwise, check if
      // the model will be valid when the attributes, if any, are set.
      if (attrs && !options.wait) {
        if (!this.set(attrs, options)) return false;
      } else {
        if (!this._validate(attrs, options)) return false;
      }

      // Set temporary attributes if `{wait: true}`.
      if (attrs && options.wait) {
        this.attributes = _.extend({}, attributes, attrs);
      }

      // After a successful server-side save, the client is (optionally)
      // updated with the server-side state.
      if (options.parse === void 0) options.parse = true;
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        // Ensure attributes are restored during synchronous saves.
        model.attributes = attributes;
        var serverAttrs = model.parse(resp, options);
        if (options.wait) serverAttrs = _.extend(attrs || {}, serverAttrs);
        if (_.isObject(serverAttrs) && !model.set(serverAttrs, options)) {
          return false;
        }
        if (success) success(model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);

      method = this.isNew() ? 'create' : (options.patch ? 'patch' : 'update');
      if (method === 'patch') options.attrs = attrs;
      xhr = this.sync(method, this, options);

      // Restore attributes.
      if (attrs && options.wait) this.attributes = attributes;

      return xhr;
    },

    // Destroy this model on the server if it was already persisted.
    // Optimistically removes the model from its collection, if it has one.
    // If `wait: true` is passed, waits for the server to respond before removal.
    destroy: function(options) {
      options = options ? _.clone(options) : {};
      var model = this;
      var success = options.success;

      var destroy = function() {
        model.trigger('destroy', model, model.collection, options);
      };

      options.success = function(resp) {
        if (options.wait || model.isNew()) destroy();
        if (success) success(model, resp, options);
        if (!model.isNew()) model.trigger('sync', model, resp, options);
      };

      if (this.isNew()) {
        options.success();
        return false;
      }
      wrapError(this, options);

      var xhr = this.sync('delete', this, options);
      if (!options.wait) destroy();
      return xhr;
    },

    // Default URL for the model's representation on the server -- if you're
    // using Backbone's restful methods, override this to change the endpoint
    // that will be called.
    url: function() {
      var base =
        _.result(this, 'urlRoot') ||
        _.result(this.collection, 'url') ||
        urlError();
      if (this.isNew()) return base;
      return base.replace(/([^\/])$/, '$1/') + encodeURIComponent(this.id);
    },

    // **parse** converts a response into the hash of attributes to be `set` on
    // the model. The default implementation is just to pass the response along.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new model with identical attributes to this one.
    clone: function() {
      return new this.constructor(this.attributes);
    },

    // A model is new if it has never been saved to the server, and lacks an id.
    isNew: function() {
      return !this.has(this.idAttribute);
    },

    // Check if the model is currently in a valid state.
    isValid: function(options) {
      return this._validate({}, _.extend(options || {}, { validate: true }));
    },

    // Run validation against the next complete set of model attributes,
    // returning `true` if all is well. Otherwise, fire an `"invalid"` event.
    _validate: function(attrs, options) {
      if (!options.validate || !this.validate) return true;
      attrs = _.extend({}, this.attributes, attrs);
      var error = this.validationError = this.validate(attrs, options) || null;
      if (!error) return true;
      this.trigger('invalid', this, error, _.extend(options, {validationError: error}));
      return false;
    }

  });

  // Underscore methods that we want to implement on the Model.
  var modelMethods = ['keys', 'values', 'pairs', 'invert', 'pick', 'omit'];

  // Mix in each Underscore method as a proxy to `Model#attributes`.
  _.each(modelMethods, function(method) {
    Model.prototype[method] = function() {
      var args = slice.call(arguments);
      args.unshift(this.attributes);
      return _[method].apply(_, args);
    };
  });

  // Backbone.Collection
  // -------------------

  // If models tend to represent a single row of data, a Backbone Collection is
  // more analagous to a table full of data ... or a small slice or page of that
  // table, or a collection of rows that belong together for a particular reason
  // -- all of the messages in this particular folder, all of the documents
  // belonging to this particular author, and so on. Collections maintain
  // indexes of their models, both in order, and for lookup by `id`.

  // Create a new **Collection**, perhaps to contain a specific type of `model`.
  // If a `comparator` is specified, the Collection will maintain
  // its models in sort order, as they're added and removed.
  var Collection = Backbone.Collection = function(models, options) {
    options || (options = {});
    if (options.model) this.model = options.model;
    if (options.comparator !== void 0) this.comparator = options.comparator;
    this._reset();
    this.initialize.apply(this, arguments);
    if (models) this.reset(models, _.extend({silent: true}, options));
  };

  // Default options for `Collection#set`.
  var setOptions = {add: true, remove: true, merge: true};
  var addOptions = {add: true, remove: false};

  // Define the Collection's inheritable methods.
  _.extend(Collection.prototype, Events, {

    // The default model for a collection is just a **Backbone.Model**.
    // This should be overridden in most cases.
    model: Model,

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // The JSON representation of a Collection is an array of the
    // models' attributes.
    toJSON: function(options) {
      return this.map(function(model){ return model.toJSON(options); });
    },

    // Proxy `Backbone.sync` by default.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Add a model, or list of models to the set.
    add: function(models, options) {
      return this.set(models, _.extend({merge: false}, options, addOptions));
    },

    // Remove a model, or a list of models from the set.
    remove: function(models, options) {
      var singular = !_.isArray(models);
      models = singular ? [models] : _.clone(models);
      options || (options = {});
      var i, l, index, model;
      for (i = 0, l = models.length; i < l; i++) {
        model = models[i] = this.get(models[i]);
        if (!model) continue;
        delete this._byId[model.id];
        delete this._byId[model.cid];
        index = this.indexOf(model);
        this.models.splice(index, 1);
        this.length--;
        if (!options.silent) {
          options.index = index;
          model.trigger('remove', model, this, options);
        }
        this._removeReference(model, options);
      }
      return singular ? models[0] : models;
    },

    // Update a collection by `set`-ing a new list of models, adding new ones,
    // removing models that are no longer present, and merging models that
    // already exist in the collection, as necessary. Similar to **Model#set**,
    // the core operation for updating the data contained by the collection.
    set: function(models, options) {
      options = _.defaults({}, options, setOptions);
      if (options.parse) models = this.parse(models, options);
      var singular = !_.isArray(models);
      models = singular ? (models ? [models] : []) : _.clone(models);
      var i, l, id, model, attrs, existing, sort;
      var at = options.at;
      var targetModel = this.model;
      var sortable = this.comparator && (at == null) && options.sort !== false;
      var sortAttr = _.isString(this.comparator) ? this.comparator : null;
      var toAdd = [], toRemove = [], modelMap = {};
      var add = options.add, merge = options.merge, remove = options.remove;
      var order = !sortable && add && remove ? [] : false;

      // Turn bare objects into model references, and prevent invalid models
      // from being added.
      for (i = 0, l = models.length; i < l; i++) {
        attrs = models[i] || {};
        if (attrs instanceof Model) {
          id = model = attrs;
        } else {
          id = attrs[targetModel.prototype.idAttribute || 'id'];
        }

        // If a duplicate is found, prevent it from being added and
        // optionally merge it into the existing model.
        if (existing = this.get(id)) {
          if (remove) modelMap[existing.cid] = true;
          if (merge) {
            attrs = attrs === model ? model.attributes : attrs;
            if (options.parse) attrs = existing.parse(attrs, options);
            existing.set(attrs, options);
            if (sortable && !sort && existing.hasChanged(sortAttr)) sort = true;
          }
          models[i] = existing;

        // If this is a new, valid model, push it to the `toAdd` list.
        } else if (add) {
          model = models[i] = this._prepareModel(attrs, options);
          if (!model) continue;
          toAdd.push(model);
          this._addReference(model, options);
        }

        // Do not add multiple models with the same `id`.
        model = existing || model;
        if (order && (model.isNew() || !modelMap[model.id])) order.push(model);
        modelMap[model.id] = true;
      }

      // Remove nonexistent models if appropriate.
      if (remove) {
        for (i = 0, l = this.length; i < l; ++i) {
          if (!modelMap[(model = this.models[i]).cid]) toRemove.push(model);
        }
        if (toRemove.length) this.remove(toRemove, options);
      }

      // See if sorting is needed, update `length` and splice in new models.
      if (toAdd.length || (order && order.length)) {
        if (sortable) sort = true;
        this.length += toAdd.length;
        if (at != null) {
          for (i = 0, l = toAdd.length; i < l; i++) {
            this.models.splice(at + i, 0, toAdd[i]);
          }
        } else {
          if (order) this.models.length = 0;
          var orderedModels = order || toAdd;
          for (i = 0, l = orderedModels.length; i < l; i++) {
            this.models.push(orderedModels[i]);
          }
        }
      }

      // Silently sort the collection if appropriate.
      if (sort) this.sort({silent: true});

      // Unless silenced, it's time to fire all appropriate add/sort events.
      if (!options.silent) {
        for (i = 0, l = toAdd.length; i < l; i++) {
          (model = toAdd[i]).trigger('add', model, this, options);
        }
        if (sort || (order && order.length)) this.trigger('sort', this, options);
      }

      // Return the added (or merged) model (or models).
      return singular ? models[0] : models;
    },

    // When you have more items than you want to add or remove individually,
    // you can reset the entire set with a new list of models, without firing
    // any granular `add` or `remove` events. Fires `reset` when finished.
    // Useful for bulk operations and optimizations.
    reset: function(models, options) {
      options || (options = {});
      for (var i = 0, l = this.models.length; i < l; i++) {
        this._removeReference(this.models[i], options);
      }
      options.previousModels = this.models;
      this._reset();
      models = this.add(models, _.extend({silent: true}, options));
      if (!options.silent) this.trigger('reset', this, options);
      return models;
    },

    // Add a model to the end of the collection.
    push: function(model, options) {
      return this.add(model, _.extend({at: this.length}, options));
    },

    // Remove a model from the end of the collection.
    pop: function(options) {
      var model = this.at(this.length - 1);
      this.remove(model, options);
      return model;
    },

    // Add a model to the beginning of the collection.
    unshift: function(model, options) {
      return this.add(model, _.extend({at: 0}, options));
    },

    // Remove a model from the beginning of the collection.
    shift: function(options) {
      var model = this.at(0);
      this.remove(model, options);
      return model;
    },

    // Slice out a sub-array of models from the collection.
    slice: function() {
      return slice.apply(this.models, arguments);
    },

    // Get a model from the set by id.
    get: function(obj) {
      if (obj == null) return void 0;
      return this._byId[obj] || this._byId[obj.id] || this._byId[obj.cid];
    },

    // Get the model at the given index.
    at: function(index) {
      return this.models[index];
    },

    // Return models with matching attributes. Useful for simple cases of
    // `filter`.
    where: function(attrs, first) {
      if (_.isEmpty(attrs)) return first ? void 0 : [];
      return this[first ? 'find' : 'filter'](function(model) {
        for (var key in attrs) {
          if (attrs[key] !== model.get(key)) return false;
        }
        return true;
      });
    },

    // Return the first model with matching attributes. Useful for simple cases
    // of `find`.
    findWhere: function(attrs) {
      return this.where(attrs, true);
    },

    // Force the collection to re-sort itself. You don't need to call this under
    // normal circumstances, as the set will maintain sort order as each item
    // is added.
    sort: function(options) {
      if (!this.comparator) throw new Error('Cannot sort a set without a comparator');
      options || (options = {});

      // Run sort based on type of `comparator`.
      if (_.isString(this.comparator) || this.comparator.length === 1) {
        this.models = this.sortBy(this.comparator, this);
      } else {
        this.models.sort(_.bind(this.comparator, this));
      }

      if (!options.silent) this.trigger('sort', this, options);
      return this;
    },

    // Pluck an attribute from each model in the collection.
    pluck: function(attr) {
      return _.invoke(this.models, 'get', attr);
    },

    // Fetch the default set of models for this collection, resetting the
    // collection when they arrive. If `reset: true` is passed, the response
    // data will be passed through the `reset` method instead of `set`.
    fetch: function(options) {
      options = options ? _.clone(options) : {};
      if (options.parse === void 0) options.parse = true;
      var success = options.success;
      var collection = this;
      options.success = function(resp) {
        var method = options.reset ? 'reset' : 'set';
        collection[method](resp, options);
        if (success) success(collection, resp, options);
        collection.trigger('sync', collection, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Create a new instance of a model in this collection. Add the model to the
    // collection immediately, unless `wait: true` is passed, in which case we
    // wait for the server to agree.
    create: function(model, options) {
      options = options ? _.clone(options) : {};
      if (!(model = this._prepareModel(model, options))) return false;
      if (!options.wait) this.add(model, options);
      var collection = this;
      var success = options.success;
      options.success = function(model, resp) {
        if (options.wait) collection.add(model, options);
        if (success) success(model, resp, options);
      };
      model.save(null, options);
      return model;
    },

    // **parse** converts a response into a list of models to be added to the
    // collection. The default implementation is just to pass it through.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new collection with an identical list of models as this one.
    clone: function() {
      return new this.constructor(this.models);
    },

    // Private method to reset all internal state. Called when the collection
    // is first initialized or reset.
    _reset: function() {
      this.length = 0;
      this.models = [];
      this._byId  = {};
    },

    // Prepare a hash of attributes (or other model) to be added to this
    // collection.
    _prepareModel: function(attrs, options) {
      if (attrs instanceof Model) return attrs;
      options = options ? _.clone(options) : {};
      options.collection = this;
      var model = new this.model(attrs, options);
      if (!model.validationError) return model;
      this.trigger('invalid', this, model.validationError, options);
      return false;
    },

    // Internal method to create a model's ties to a collection.
    _addReference: function(model, options) {
      this._byId[model.cid] = model;
      if (model.id != null) this._byId[model.id] = model;
      if (!model.collection) model.collection = this;
      model.on('all', this._onModelEvent, this);
    },

    // Internal method to sever a model's ties to a collection.
    _removeReference: function(model, options) {
      if (this === model.collection) delete model.collection;
      model.off('all', this._onModelEvent, this);
    },

    // Internal method called every time a model in the set fires an event.
    // Sets need to update their indexes when models change ids. All other
    // events simply proxy through. "add" and "remove" events that originate
    // in other collections are ignored.
    _onModelEvent: function(event, model, collection, options) {
      if ((event === 'add' || event === 'remove') && collection !== this) return;
      if (event === 'destroy') this.remove(model, options);
      if (model && event === 'change:' + model.idAttribute) {
        delete this._byId[model.previous(model.idAttribute)];
        if (model.id != null) this._byId[model.id] = model;
      }
      this.trigger.apply(this, arguments);
    }

  });

  // Underscore methods that we want to implement on the Collection.
  // 90% of the core usefulness of Backbone Collections is actually implemented
  // right here:
  var methods = ['forEach', 'each', 'map', 'collect', 'reduce', 'foldl',
    'inject', 'reduceRight', 'foldr', 'find', 'detect', 'filter', 'select',
    'reject', 'every', 'all', 'some', 'any', 'include', 'contains', 'invoke',
    'max', 'min', 'toArray', 'size', 'first', 'head', 'take', 'initial', 'rest',
    'tail', 'drop', 'last', 'without', 'difference', 'indexOf', 'shuffle',
    'lastIndexOf', 'isEmpty', 'chain', 'sample'];

  // Mix in each Underscore method as a proxy to `Collection#models`.
  _.each(methods, function(method) {
    Collection.prototype[method] = function() {
      var args = slice.call(arguments);
      args.unshift(this.models);
      return _[method].apply(_, args);
    };
  });

  // Underscore methods that take a property name as an argument.
  var attributeMethods = ['groupBy', 'countBy', 'sortBy', 'indexBy'];

  // Use attributes instead of properties.
  _.each(attributeMethods, function(method) {
    Collection.prototype[method] = function(value, context) {
      var iterator = _.isFunction(value) ? value : function(model) {
        return model.get(value);
      };
      return _[method](this.models, iterator, context);
    };
  });

  // Backbone.View
  // -------------

  // Backbone Views are almost more convention than they are actual code. A View
  // is simply a JavaScript object that represents a logical chunk of UI in the
  // DOM. This might be a single item, an entire list, a sidebar or panel, or
  // even the surrounding frame which wraps your whole app. Defining a chunk of
  // UI as a **View** allows you to define your DOM events declaratively, without
  // having to worry about render order ... and makes it easy for the view to
  // react to specific changes in the state of your models.

  // Creating a Backbone.View creates its initial element outside of the DOM,
  // if an existing element is not provided...
  var View = Backbone.View = function(options) {
    this.cid = _.uniqueId('view');
    options || (options = {});
    _.extend(this, _.pick(options, viewOptions));
    this._ensureElement();
    this.initialize.apply(this, arguments);
    this.delegateEvents();
  };

  // Cached regex to split keys for `delegate`.
  var delegateEventSplitter = /^(\S+)\s*(.*)$/;

  // List of view options to be merged as properties.
  var viewOptions = ['model', 'collection', 'el', 'id', 'attributes', 'className', 'tagName', 'events'];

  // Set up all inheritable **Backbone.View** properties and methods.
  _.extend(View.prototype, Events, {

    // The default `tagName` of a View's element is `"div"`.
    tagName: 'div',

    // jQuery delegate for element lookup, scoped to DOM elements within the
    // current view. This should be preferred to global lookups where possible.
    $: function(selector) {
      return this.$el.find(selector);
    },

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // **render** is the core function that your view should override, in order
    // to populate its element (`this.el`), with the appropriate HTML. The
    // convention is for **render** to always return `this`.
    render: function() {
      return this;
    },

    // Remove this view by taking the element out of the DOM, and removing any
    // applicable Backbone.Events listeners.
    remove: function() {
      this.$el.remove();
      this.stopListening();
      return this;
    },

    // Change the view's element (`this.el` property), including event
    // re-delegation.
    setElement: function(element, delegate) {
      if (this.$el) this.undelegateEvents();
      this.$el = element instanceof Backbone.$ ? element : Backbone.$(element);
      this.el = this.$el[0];
      if (delegate !== false) this.delegateEvents();
      return this;
    },

    // Set callbacks, where `this.events` is a hash of
    //
    // *{"event selector": "callback"}*
    //
    //     {
    //       'mousedown .title':  'edit',
    //       'click .button':     'save',
    //       'click .open':       function(e) { ... }
    //     }
    //
    // pairs. Callbacks will be bound to the view, with `this` set properly.
    // Uses event delegation for efficiency.
    // Omitting the selector binds the event to `this.el`.
    // This only works for delegate-able events: not `focus`, `blur`, and
    // not `change`, `submit`, and `reset` in Internet Explorer.
    delegateEvents: function(events) {
      if (!(events || (events = _.result(this, 'events')))) return this;
      this.undelegateEvents();
      for (var key in events) {
        var method = events[key];
        if (!_.isFunction(method)) method = this[events[key]];
        if (!method) continue;

        var match = key.match(delegateEventSplitter);
        var eventName = match[1], selector = match[2];
        method = _.bind(method, this);
        eventName += '.delegateEvents' + this.cid;
        if (selector === '') {
          this.$el.on(eventName, method);
        } else {
          this.$el.on(eventName, selector, method);
        }
      }
      return this;
    },

    // Clears all callbacks previously bound to the view with `delegateEvents`.
    // You usually don't need to use this, but may wish to if you have multiple
    // Backbone views attached to the same DOM element.
    undelegateEvents: function() {
      this.$el.off('.delegateEvents' + this.cid);
      return this;
    },

    // Ensure that the View has a DOM element to render into.
    // If `this.el` is a string, pass it through `$()`, take the first
    // matching element, and re-assign it to `el`. Otherwise, create
    // an element from the `id`, `className` and `tagName` properties.
    _ensureElement: function() {
      if (!this.el) {
        var attrs = _.extend({}, _.result(this, 'attributes'));
        if (this.id) attrs.id = _.result(this, 'id');
        if (this.className) attrs['class'] = _.result(this, 'className');
        var $el = Backbone.$('<' + _.result(this, 'tagName') + '>').attr(attrs);
        this.setElement($el, false);
      } else {
        this.setElement(_.result(this, 'el'), false);
      }
    }

  });

  // Backbone.sync
  // -------------

  // Override this function to change the manner in which Backbone persists
  // models to the server. You will be passed the type of request, and the
  // model in question. By default, makes a RESTful Ajax request
  // to the model's `url()`. Some possible customizations could be:
  //
  // * Use `setTimeout` to batch rapid-fire updates into a single request.
  // * Send up the models as XML instead of JSON.
  // * Persist models via WebSockets instead of Ajax.
  //
  // Turn on `Backbone.emulateHTTP` in order to send `PUT` and `DELETE` requests
  // as `POST`, with a `_method` parameter containing the true HTTP method,
  // as well as all requests with the body as `application/x-www-form-urlencoded`
  // instead of `application/json` with the model in a param named `model`.
  // Useful when interfacing with server-side languages like **PHP** that make
  // it difficult to read the body of `PUT` requests.
  Backbone.sync = function(method, model, options) {
    var type = methodMap[method];

    // Default options, unless specified.
    _.defaults(options || (options = {}), {
      emulateHTTP: Backbone.emulateHTTP,
      emulateJSON: Backbone.emulateJSON
    });

    // Default JSON-request options.
    var params = {type: type, dataType: 'json'};

    // Ensure that we have a URL.
    if (!options.url) {
      params.url = _.result(model, 'url') || urlError();
    }

    // Ensure that we have the appropriate request data.
    if (options.data == null && model && (method === 'create' || method === 'update' || method === 'patch')) {
      params.contentType = 'application/json';
      params.data = JSON.stringify(options.attrs || model.toJSON(options));
    }

    // For older servers, emulate JSON by encoding the request into an HTML-form.
    if (options.emulateJSON) {
      params.contentType = 'application/x-www-form-urlencoded';
      params.data = params.data ? {model: params.data} : {};
    }

    // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
    // And an `X-HTTP-Method-Override` header.
    if (options.emulateHTTP && (type === 'PUT' || type === 'DELETE' || type === 'PATCH')) {
      params.type = 'POST';
      if (options.emulateJSON) params.data._method = type;
      var beforeSend = options.beforeSend;
      options.beforeSend = function(xhr) {
        xhr.setRequestHeader('X-HTTP-Method-Override', type);
        if (beforeSend) return beforeSend.apply(this, arguments);
      };
    }

    // Don't process data on a non-GET request.
    if (params.type !== 'GET' && !options.emulateJSON) {
      params.processData = false;
    }

    // If we're sending a `PATCH` request, and we're in an old Internet Explorer
    // that still has ActiveX enabled by default, override jQuery to use that
    // for XHR instead. Remove this line when jQuery supports `PATCH` on IE8.
    if (params.type === 'PATCH' && noXhrPatch) {
      params.xhr = function() {
        return new ActiveXObject("Microsoft.XMLHTTP");
      };
    }

    // Make the request, allowing the user to override any Ajax options.
    var xhr = options.xhr = Backbone.ajax(_.extend(params, options));
    model.trigger('request', model, xhr, options);
    return xhr;
  };

  var noXhrPatch =
    typeof window !== 'undefined' && !!window.ActiveXObject &&
      !(window.XMLHttpRequest && (new XMLHttpRequest).dispatchEvent);

  // Map from CRUD to HTTP for our default `Backbone.sync` implementation.
  var methodMap = {
    'create': 'POST',
    'update': 'PUT',
    'patch':  'PATCH',
    'delete': 'DELETE',
    'read':   'GET'
  };

  // Set the default implementation of `Backbone.ajax` to proxy through to `$`.
  // Override this if you'd like to use a different library.
  Backbone.ajax = function() {
    return Backbone.$.ajax.apply(Backbone.$, arguments);
  };

  // Backbone.Router
  // ---------------

  // Routers map faux-URLs to actions, and fire events when routes are
  // matched. Creating a new one sets its `routes` hash, if not set statically.
  var Router = Backbone.Router = function(options) {
    options || (options = {});
    if (options.routes) this.routes = options.routes;
    this._bindRoutes();
    this.initialize.apply(this, arguments);
  };

  // Cached regular expressions for matching named param parts and splatted
  // parts of route strings.
  var optionalParam = /\((.*?)\)/g;
  var namedParam    = /(\(\?)?:\w+/g;
  var splatParam    = /\*\w+/g;
  var escapeRegExp  = /[\-{}\[\]+?.,\\\^$|#\s]/g;

  // Set up all inheritable **Backbone.Router** properties and methods.
  _.extend(Router.prototype, Events, {

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Manually bind a single named route to a callback. For example:
    //
    //     this.route('search/:query/p:num', 'search', function(query, num) {
    //       ...
    //     });
    //
    route: function(route, name, callback) {
      if (!_.isRegExp(route)) route = this._routeToRegExp(route);
      if (_.isFunction(name)) {
        callback = name;
        name = '';
      }
      if (!callback) callback = this[name];
      var router = this;
      Backbone.history.route(route, function(fragment) {
        var args = router._extractParameters(route, fragment);
        router.execute(callback, args);
        router.trigger.apply(router, ['route:' + name].concat(args));
        router.trigger('route', name, args);
        Backbone.history.trigger('route', router, name, args);
      });
      return this;
    },

    // Execute a route handler with the provided parameters.  This is an
    // excellent place to do pre-route setup or post-route cleanup.
    execute: function(callback, args) {
      if (callback) callback.apply(this, args);
    },

    // Simple proxy to `Backbone.history` to save a fragment into the history.
    navigate: function(fragment, options) {
      Backbone.history.navigate(fragment, options);
      return this;
    },

    // Bind all defined routes to `Backbone.history`. We have to reverse the
    // order of the routes here to support behavior where the most general
    // routes can be defined at the bottom of the route map.
    _bindRoutes: function() {
      if (!this.routes) return;
      this.routes = _.result(this, 'routes');
      var route, routes = _.keys(this.routes);
      while ((route = routes.pop()) != null) {
        this.route(route, this.routes[route]);
      }
    },

    // Convert a route string into a regular expression, suitable for matching
    // against the current location hash.
    _routeToRegExp: function(route) {
      route = route.replace(escapeRegExp, '\\$&')
                   .replace(optionalParam, '(?:$1)?')
                   .replace(namedParam, function(match, optional) {
                     return optional ? match : '([^/?]+)';
                   })
                   .replace(splatParam, '([^?]*?)');
      return new RegExp('^' + route + '(?:\\?([\\s\\S]*))?$');
    },

    // Given a route, and a URL fragment that it matches, return the array of
    // extracted decoded parameters. Empty or unmatched parameters will be
    // treated as `null` to normalize cross-browser behavior.
    _extractParameters: function(route, fragment) {
      var params = route.exec(fragment).slice(1);
      return _.map(params, function(param, i) {
        // Don't decode the search params.
        if (i === params.length - 1) return param || null;
        return param ? decodeURIComponent(param) : null;
      });
    }

  });

  // Backbone.History
  // ----------------

  // Handles cross-browser history management, based on either
  // [pushState](http://diveintohtml5.info/history.html) and real URLs, or
  // [onhashchange](https://developer.mozilla.org/en-US/docs/DOM/window.onhashchange)
  // and URL fragments. If the browser supports neither (old IE, natch),
  // falls back to polling.
  var History = Backbone.History = function() {
    this.handlers = [];
    _.bindAll(this, 'checkUrl');

    // Ensure that `History` can be used outside of the browser.
    if (typeof window !== 'undefined') {
      this.location = window.location;
      this.history = window.history;
    }
  };

  // Cached regex for stripping a leading hash/slash and trailing space.
  var routeStripper = /^[#\/]|\s+$/g;

  // Cached regex for stripping leading and trailing slashes.
  var rootStripper = /^\/+|\/+$/g;

  // Cached regex for detecting MSIE.
  var isExplorer = /msie [\w.]+/;

  // Cached regex for removing a trailing slash.
  var trailingSlash = /\/$/;

  // Cached regex for stripping urls of hash.
  var pathStripper = /#.*$/;

  // Has the history handling already been started?
  History.started = false;

  // Set up all inheritable **Backbone.History** properties and methods.
  _.extend(History.prototype, Events, {

    // The default interval to poll for hash changes, if necessary, is
    // twenty times a second.
    interval: 50,

    // Are we at the app root?
    atRoot: function() {
      return this.location.pathname.replace(/[^\/]$/, '$&/') === this.root;
    },

    // Gets the true hash value. Cannot use location.hash directly due to bug
    // in Firefox where location.hash will always be decoded.
    getHash: function(window) {
      var match = (window || this).location.href.match(/#(.*)$/);
      return match ? match[1] : '';
    },

    // Get the cross-browser normalized URL fragment, either from the URL,
    // the hash, or the override.
    getFragment: function(fragment, forcePushState) {
      if (fragment == null) {
        if (this._hasPushState || !this._wantsHashChange || forcePushState) {
          fragment = decodeURI(this.location.pathname + this.location.search);
          var root = this.root.replace(trailingSlash, '');
          if (!fragment.indexOf(root)) fragment = fragment.slice(root.length);
        } else {
          fragment = this.getHash();
        }
      }
      return fragment.replace(routeStripper, '');
    },

    // Start the hash change handling, returning `true` if the current URL matches
    // an existing route, and `false` otherwise.
    start: function(options) {
      if (History.started) throw new Error("Backbone.history has already been started");
      History.started = true;

      // Figure out the initial configuration. Do we need an iframe?
      // Is pushState desired ... is it available?
      this.options          = _.extend({root: '/'}, this.options, options);
      this.root             = this.options.root;
      this._wantsHashChange = this.options.hashChange !== false;
      this._wantsPushState  = !!this.options.pushState;
      this._hasPushState    = !!(this.options.pushState && this.history && this.history.pushState);
      var fragment          = this.getFragment();
      var docMode           = document.documentMode;
      var oldIE             = (isExplorer.exec(navigator.userAgent.toLowerCase()) && (!docMode || docMode <= 7));

      // Normalize root to always include a leading and trailing slash.
      this.root = ('/' + this.root + '/').replace(rootStripper, '/');

      if (oldIE && this._wantsHashChange) {
        var frame = Backbone.$('<iframe src="javascript:0" tabindex="-1">');
        this.iframe = frame.hide().appendTo('body')[0].contentWindow;
        this.navigate(fragment);
      }

      // Depending on whether we're using pushState or hashes, and whether
      // 'onhashchange' is supported, determine how we check the URL state.
      if (this._hasPushState) {
        Backbone.$(window).on('popstate', this.checkUrl);
      } else if (this._wantsHashChange && ('onhashchange' in window) && !oldIE) {
        Backbone.$(window).on('hashchange', this.checkUrl);
      } else if (this._wantsHashChange) {
        this._checkUrlInterval = setInterval(this.checkUrl, this.interval);
      }

      // Determine if we need to change the base url, for a pushState link
      // opened by a non-pushState browser.
      this.fragment = fragment;
      var loc = this.location;

      // Transition from hashChange to pushState or vice versa if both are
      // requested.
      if (this._wantsHashChange && this._wantsPushState) {

        // If we've started off with a route from a `pushState`-enabled
        // browser, but we're currently in a browser that doesn't support it...
        if (!this._hasPushState && !this.atRoot()) {
          this.fragment = this.getFragment(null, true);
          this.location.replace(this.root + '#' + this.fragment);
          // Return immediately as browser will do redirect to new url
          return true;

        // Or if we've started out with a hash-based route, but we're currently
        // in a browser where it could be `pushState`-based instead...
        } else if (this._hasPushState && this.atRoot() && loc.hash) {
          this.fragment = this.getHash().replace(routeStripper, '');
          this.history.replaceState({}, document.title, this.root + this.fragment);
        }

      }

      if (!this.options.silent) return this.loadUrl();
    },

    // Disable Backbone.history, perhaps temporarily. Not useful in a real app,
    // but possibly useful for unit testing Routers.
    stop: function() {
      Backbone.$(window).off('popstate', this.checkUrl).off('hashchange', this.checkUrl);
      if (this._checkUrlInterval) clearInterval(this._checkUrlInterval);
      History.started = false;
    },

    // Add a route to be tested when the fragment changes. Routes added later
    // may override previous routes.
    route: function(route, callback) {
      this.handlers.unshift({route: route, callback: callback});
    },

    // Checks the current URL to see if it has changed, and if it has,
    // calls `loadUrl`, normalizing across the hidden iframe.
    checkUrl: function(e) {
      var current = this.getFragment();
      if (current === this.fragment && this.iframe) {
        current = this.getFragment(this.getHash(this.iframe));
      }
      if (current === this.fragment) return false;
      if (this.iframe) this.navigate(current);
      this.loadUrl();
    },

    // Attempt to load the current URL fragment. If a route succeeds with a
    // match, returns `true`. If no defined routes matches the fragment,
    // returns `false`.
    loadUrl: function(fragment) {
      fragment = this.fragment = this.getFragment(fragment);
      return _.any(this.handlers, function(handler) {
        if (handler.route.test(fragment)) {
          handler.callback(fragment);
          return true;
        }
      });
    },

    // Save a fragment into the hash history, or replace the URL state if the
    // 'replace' option is passed. You are responsible for properly URL-encoding
    // the fragment in advance.
    //
    // The options object can contain `trigger: true` if you wish to have the
    // route callback be fired (not usually desirable), or `replace: true`, if
    // you wish to modify the current URL without adding an entry to the history.
    navigate: function(fragment, options) {
      if (!History.started) return false;
      if (!options || options === true) options = {trigger: !!options};

      var url = this.root + (fragment = this.getFragment(fragment || ''));

      // Strip the hash for matching.
      fragment = fragment.replace(pathStripper, '');

      if (this.fragment === fragment) return;
      this.fragment = fragment;

      // Don't include a trailing slash on the root.
      if (fragment === '' && url !== '/') url = url.slice(0, -1);

      // If pushState is available, we use it to set the fragment as a real URL.
      if (this._hasPushState) {
        this.history[options.replace ? 'replaceState' : 'pushState']({}, document.title, url);

      // If hash changes haven't been explicitly disabled, update the hash
      // fragment to store history.
      } else if (this._wantsHashChange) {
        this._updateHash(this.location, fragment, options.replace);
        if (this.iframe && (fragment !== this.getFragment(this.getHash(this.iframe)))) {
          // Opening and closing the iframe tricks IE7 and earlier to push a
          // history entry on hash-tag change.  When replace is true, we don't
          // want this.
          if(!options.replace) this.iframe.document.open().close();
          this._updateHash(this.iframe.location, fragment, options.replace);
        }

      // If you've told us that you explicitly don't want fallback hashchange-
      // based history, then `navigate` becomes a page refresh.
      } else {
        return this.location.assign(url);
      }
      if (options.trigger) return this.loadUrl(fragment);
    },

    // Update the hash location, either replacing the current entry, or adding
    // a new one to the browser history.
    _updateHash: function(location, fragment, replace) {
      if (replace) {
        var href = location.href.replace(/(javascript:|#).*$/, '');
        location.replace(href + '#' + fragment);
      } else {
        // Some browsers require that `hash` contains a leading #.
        location.hash = '#' + fragment;
      }
    }

  });

  // Create the default Backbone.history.
  Backbone.history = new History;

  // Helpers
  // -------

  // Helper function to correctly set up the prototype chain, for subclasses.
  // Similar to `goog.inherits`, but uses a hash of prototype properties and
  // class properties to be extended.
  var extend = function(protoProps, staticProps) {
    var parent = this;
    var child;

    // The constructor function for the new subclass is either defined by you
    // (the "constructor" property in your `extend` definition), or defaulted
    // by us to simply call the parent's constructor.
    if (protoProps && _.has(protoProps, 'constructor')) {
      child = protoProps.constructor;
    } else {
      child = function(){ return parent.apply(this, arguments); };
    }

    // Add static properties to the constructor function, if supplied.
    _.extend(child, parent, staticProps);

    // Set the prototype chain to inherit from `parent`, without calling
    // `parent`'s constructor function.
    var Surrogate = function(){ this.constructor = child; };
    Surrogate.prototype = parent.prototype;
    child.prototype = new Surrogate;

    // Add prototype properties (instance properties) to the subclass,
    // if supplied.
    if (protoProps) _.extend(child.prototype, protoProps);

    // Set a convenience property in case the parent's prototype is needed
    // later.
    child.__super__ = parent.prototype;

    return child;
  };

  // Set up inheritance for the model, collection, router, view and history.
  Model.extend = Collection.extend = Router.extend = View.extend = History.extend = extend;

  // Throw an error when a URL is needed, and none is supplied.
  var urlError = function() {
    throw new Error('A "url" property or function must be specified');
  };

  // Wrap an optional error callback with a fallback error event.
  var wrapError = function(model, options) {
    var error = options.error;
    options.error = function(resp) {
      if (error) error(model, resp, options);
      model.trigger('error', model, resp, options);
    };
  };

  return Backbone;

}));

(function(globalNames) {// Create a range object for efficently rendering strings to elements.
var range;

function toElement(str) {
    if (!range) {
        range = document.createRange();
        range.selectNode(document.body);
    }

    var fragment;
    if (range.createContextualFragment) {
        fragment = range.createContextualFragment(str);
    } else {
        fragment = document.createElement('body');
        fragment.innerHTML = str;
    }
    return fragment.childNodes[0];
}

var specialElHandlers = {
    /**
     * Needed for IE. Apparently IE doesn't think
     * that "selected" is an attribute when reading
     * over the attributes using selectEl.attributes
     */
    OPTION: function(fromEl, toEl) {
        if ((fromEl.selected = toEl.selected)) {
            fromEl.setAttribute('selected', '');
        } else {
            fromEl.removeAttribute('selected', '');
        }
    },
    /**
     * The "value" attribute is special for the <input> element
     * since it sets the initial value. Changing the "value"
     * attribute without changing the "value" property will have
     * no effect since it is only used to the set the initial value.
     * Similar for the "checked" attribute.
     */
    INPUT: function(fromEl, toEl) {
        fromEl.checked = toEl.checked;
        fromEl.value = toEl.value;

        if (!toEl.hasAttribute('checked')) {
            fromEl.removeAttribute('checked');
        }

        if (!toEl.hasAttribute('value')) {
            fromEl.removeAttribute('value');
        }
    }
};

function noop() {}

/**
 * Loop over all of the attributes on the target node and make sure the
 * original DOM node has the same attributes. If an attribute
 * found on the original node is not on the new node then remove it from
 * the original node
 * @param  {HTMLElement} fromNode
 * @param  {HTMLElement} toNode
 */
function morphAttrs(fromNode, toNode) {
    var attrs = toNode.attributes;
    var i;
    var attr;
    var attrName;
    var attrValue;
    var foundAttrs = {};

    for (i=attrs.length-1; i>=0; i--) {
        attr = attrs[i];
        if (attr.specified !== false) {
            attrName = attr.name;
            attrValue = attr.value;
            foundAttrs[attrName] = true;

            if (fromNode.getAttribute(attrName) !== attrValue) {
                fromNode.setAttribute(attrName, attrValue);
            }
        }
    }

    // Delete any extra attributes found on the original DOM element that weren't
    // found on the target element.
    attrs = fromNode.attributes;

    for (i=attrs.length-1; i>=0; i--) {
        attr = attrs[i];
        if (attr.specified !== false) {
            attrName = attr.name;
            if (!foundAttrs.hasOwnProperty(attrName)) {
                fromNode.removeAttribute(attrName);
            }
        }
    }
}

/**
 * Copies the children of one DOM element to another DOM element
 */
function moveChildren(from, to) {
    var curChild = from.firstChild;
    while(curChild) {
        var nextChild = curChild.nextSibling;
        to.appendChild(curChild);
        curChild = nextChild;
    }
    return to;
}

function morphdom(fromNode, toNode, options) {
    if (!options) {
        options = {};
    }

    if (typeof toNode === 'string') {
        toNode = toElement(toNode);
    }

    var savedEls = {}; // Used to save off DOM elements with IDs
    var unmatchedEls = {};
    var onNodeDiscarded = options.onNodeDiscarded || noop;
    var onBeforeMorphEl = options.onBeforeMorphEl || noop;
    var onBeforeMorphElChildren = options.onBeforeMorphElChildren || noop;
    var onBeforeNodeDiscarded = options.onBeforeNodeDiscarded || noop;

    function removeNodeHelper(node, nestedInSavedEl) {
        var id = node.id;
        // If the node has an ID then save it off since we will want
        // to reuse it in case the target DOM tree has a DOM element
        // with the same ID
        if (id) {
            savedEls[id] = node;
        } else if (!nestedInSavedEl) {
            // If we are not nested in a saved element then we know that this node has been
            // completely discarded and will not exist in the final DOM.
            onNodeDiscarded(node);
        }

        if (node.nodeType === 1) {
            var curChild = node.firstChild;
            while(curChild) {
                removeNodeHelper(curChild, nestedInSavedEl || id);
                curChild = curChild.nextSibling;
            }
        }
    }

    function walkDiscardedChildNodes(node) {
        if (node.nodeType === 1) {
            var curChild = node.firstChild;
            while(curChild) {


                if (!curChild.id) {
                    // We only want to handle nodes that don't have an ID to avoid double
                    // walking the same saved element.

                    onNodeDiscarded(curChild);

                    // Walk recursively
                    walkDiscardedChildNodes(curChild);
                }

                curChild = curChild.nextSibling;
            }
        }
    }

    function removeNode(node, parentNode, alreadyVisited) {
        if (onBeforeNodeDiscarded(node) === false) {
            return;
        }

        parentNode.removeChild(node);
        if (alreadyVisited) {
            if (!node.id) {
                onNodeDiscarded(node);
                walkDiscardedChildNodes(node);
            }
        } else {
            removeNodeHelper(node);
        }
    }

    function morphEl(fromNode, toNode, alreadyVisited) {
        if (toNode.id) {
            // If an element with an ID is being morphed then it is will be in the final
            // DOM so clear it out of the saved elements collection
            delete savedEls[toNode.id];
        }

        if (onBeforeMorphEl(fromNode, toNode) === false) {
            return;
        }

        morphAttrs(fromNode, toNode);

        if (onBeforeMorphElChildren(fromNode, toNode) === false) {
            return;
        }

        var curToNodeChild = toNode.firstChild;
        var curFromNodeChild = fromNode.firstChild;
        var curToNodeId;

        var fromNextSibling;
        var toNextSibling;
        var savedEl;
        var unmatchedEl;

        outer: while(curToNodeChild) {
            toNextSibling = curToNodeChild.nextSibling;
            curToNodeId = curToNodeChild.id;

            while(curFromNodeChild) {
                var curFromNodeId = curFromNodeChild.id;
                fromNextSibling = curFromNodeChild.nextSibling;

                if (!alreadyVisited) {
                    if (curFromNodeId && (unmatchedEl = unmatchedEls[curFromNodeId])) {
                        unmatchedEl.parentNode.replaceChild(curFromNodeChild, unmatchedEl);
                        morphEl(curFromNodeChild, unmatchedEl, alreadyVisited);
                        curFromNodeChild = fromNextSibling;
                        continue;
                    }
                }

                var curFromNodeType = curFromNodeChild.nodeType;

                if (curFromNodeType === curToNodeChild.nodeType) {
                    var isCompatible = false;

                    if (curFromNodeType === 1) { // Both nodes being compared are Element nodes
                        if (curFromNodeChild.tagName === curToNodeChild.tagName) {
                            // We have compatible DOM elements
                            if (curFromNodeId || curToNodeId) {
                                // If either DOM element has an ID then we handle
                                // those differently since we want to match up
                                // by ID
                                if (curToNodeId === curFromNodeId) {
                                    isCompatible = true;
                                }
                            } else {
                                isCompatible = true;
                            }
                        }

                        if (isCompatible) {
                            // We found compatible DOM elements so transform the current "from" node
                            // to match the current target DOM node.
                            morphEl(curFromNodeChild, curToNodeChild, alreadyVisited);
                        }
                    } else if (curFromNodeType === 3) { // Both nodes being compared are Text nodes
                        isCompatible = true;
                        // Simply update nodeValue on the original node to change the text value
                        curFromNodeChild.nodeValue = curToNodeChild.nodeValue;
                    }

                    if (isCompatible) {
                        curToNodeChild = toNextSibling;
                        curFromNodeChild = fromNextSibling;
                        continue outer;
                    }
                }

                // No compatible match so remove the old node from the DOM and continue trying
                // to find a match in the original DOM
                removeNode(curFromNodeChild, fromNode, alreadyVisited);
                curFromNodeChild = fromNextSibling;
            }

            if (curToNodeId) {
                if ((savedEl = savedEls[curToNodeId])) {
                    morphEl(savedEl, curToNodeChild, true);
                    curToNodeChild = savedEl; // We want to append the saved element instead
                } else {
                    // The current DOM element in the target tree has an ID
                    // but we did not find a match in any of the corresponding
                    // siblings. We just put the target element in the old DOM tree
                    // but if we later find an element in the old DOM tree that has
                    // a matching ID then we will replace the target element
                    // with the corresponding old element and morph the old element
                    unmatchedEls[curToNodeId] = curToNodeChild;
                }
            }

            // If we got this far then we did not find a candidate match for our "to node"
            // and we exhausted all of the children "from" nodes. Therefore, we will just
            // append the current "to node" to the end
            fromNode.appendChild(curToNodeChild);

            curToNodeChild = toNextSibling;
            curFromNodeChild = fromNextSibling;
        }

        // We have processed all of the "to nodes". If curFromNodeChild is non-null then
        // we still have some from nodes left over that need to be removed
        while(curFromNodeChild) {
            fromNextSibling = curFromNodeChild.nextSibling;
            removeNode(curFromNodeChild, fromNode, alreadyVisited);
            curFromNodeChild = fromNextSibling;
        }

        var specialElHandler = specialElHandlers[fromNode.tagName];
        if (specialElHandler) {
            specialElHandler(fromNode, toNode);
        }
    }

    var morphedNode = fromNode;
    var morphedNodeType = morphedNode.nodeType;
    var toNodeType = toNode.nodeType;

    // Handle the case where we are given two DOM nodes that are not
    // compatible (e.g. <div> --> <span> or <div> --> TEXT)
    if (morphedNodeType === 1) {
        if (toNodeType === 1) {
            if (morphedNode.tagName !== toNode.tagName) {
                onNodeDiscarded(fromNode);
                morphedNode = moveChildren(morphedNode, document.createElement(toNode.tagName));
            }
        } else {
            // Going from an element node to a text node
            return toNode;
        }
    } else if (morphedNodeType === 3) { // Text node
        if (toNodeType === 3) {
            morphedNode.nodeValue = toNode.nodeValue;
            return morphedNode;
        } else {
            onNodeDiscarded(fromNode);
            // Text node to something else
            return toNode;
        }
    }

    morphEl(morphedNode, toNode, false);

    // Fire the "onNodeDiscarded" event for any saved elements
    // that never found a new home in the morphed DOM
    for (var savedElId in savedEls) {
        if (savedEls.hasOwnProperty(savedElId)) {
            var savedEl = savedEls[savedElId];
            onNodeDiscarded(savedEl);
            walkDiscardedChildNodes(savedEl);
        }
    }

    if (morphedNode !== fromNode && fromNode.parentNode) {
        // If we had to swap out the from node with a new node because the old
        // node was not compatible with the target node then we need to
        // replace the old DOM node in the original DOM tree. This is only
        // possible if the original DOM node was part of a DOM tree which
        // we know is the case if it has a parent node.
        fromNode.parentNode.replaceChild(morphedNode, fromNode);
    }

    return morphedNode;
}

globalNames.morphdom = morphdom;
}(this));

define('gc/getLob', function() {
  return function(tab, pkg) {
    var lob = "";
    pkg = normalizeBooleans(pkg);
    if (tab == "flight" || ((tab == "package" || tab == "hotel") && (pkg.flight))) {
      lob = "flight";
    }
    if (pkg.train) {
      lob = "train";
    }
    if (tab == "hotel" || ((tab == "package" || tab == "flight" || tab === "car") && (pkg.hotel))) {
      lob += (lob.length) ? "Hotel" : "hotel";
    }
    if (tab == "car" || ((tab == "package" || tab == "hotel" || tab == "flight") && (pkg.car))) {
      lob += (lob.length) ? "Car" : "car";
    }
    else if (tab == "overseaHotel") {
      lob = (pkg.flight) ? 'flightHotel' : 'overseaHotel';
    }
    if (tab == "rail") {
      lob = "rail";
    }
    return (lob.length) ? lob : tab;
  }//getLob

  function normalizeBooleans(array) {
    _.each(array, function (value, key) {
      if (value === 'false') array[key] = false;
      if (value === 'true') array[key] = true;
    });
    return array;
  }
});

define('gc/perfLogging', [], function() {
  var isLoggingEnabled = function() {
    if (window.dctk && dctk.enabled) {
      return (dctk.logging && dctk.logging.logTrxEvent)
    } else {
      return false;
    }
  }
  return {
    "responseToPaint" : function() {
      if (window.performance && window.performance.timing && window.performance.timing.responseStart && window.performance.timing.requestStart) {
        var now = Date.now();
        var fromResponseStart = (now - window.performance.timing.responseStart);
        var fromRequestStart = (now - window.performance.timing.requestStart);

        if (window.location.search.indexOf('showPerf=true') > -1) console.log("GC.Wizard.Perf: " + fromResponseStart);
        if(fromResponseStart <= 30000 && fromRequestStart <= 30000){
            if (isLoggingEnabled()) {
              dctk.logging.logTrxEvent("GC.Wizard.Perf", ['clEventName01=ResponseStartToPaint', 'clEventTime01='+fromResponseStart, 'clEventName02=RequestStartToPaint', 'clEventTime02='+fromRequestStart]);
            } else {
              // Allow for AMD compliant deferred loading.
              // This may hang on this requirement forever if dctk client logging is never loaded on this page.
              require('dctk/clientLogging', function(cl) {
                cl.logTrxEvent("GC.Wizard.Perf", ['clEventName01=ResponseStartToPaint', 'clEventTime01='+fromResponseStart, 'clEventName02=RequestStartToPaint', 'clEventTime02='+fromRequestStart]);
              })
            }
            if (performance && performance.mark) {
              performance.mark("GC.Wizard.Paint");
            }
          }
      }
    }
  }
});

// object to track when multiple things are done
// object to help detect when a background image is loaded
// object to track when HTML is painted to the UI

// tracks multiple events and fires single event after all of them have tiggered
// uses an array to be better self documenting
function AllAreDone(eventNameArray, callbackAfterLastEvent) {
  var numberOfEvetnsThatHaveHappened = 0;
  var numberOfEventsToExpect = eventNameArray.length;
  this.triggerOneEvent = function(eventName) {
    numberOfEvetnsThatHaveHappened += 1;
    if (numberOfEvetnsThatHaveHappened >= numberOfEventsToExpect) {
      callbackAfterLastEvent();
    }
  };
}

// detect when a background image has loaded
function backgroundImageLoaded(element, successCallback, failCallback, timeout) {
  var url, timeoutId, image;

  url = element.style.backgroundImage.slice(4, -1);
  if (url.indexOf("\"") > -1 || url.indexOf("'") > -1) {
    url = url.slice(1, -1);
  }
  timeoutId = setTimeout(failCallback, timeout);
  image = new Image();

  image.onload = function() {
    clearTimeout(timeoutId);
    successCallback();
  };
  image.onerror = function() {
    clearTimeout(timeoutId);
    failCallback();
  }
  image.src = url;
}

function TimeCalculator(logger) {
  var navigationStart,
      responseStart,
      documentStart,
      primaryContentPainted,
      self = this;

  self.wizardLoadTime;
  self.headerLoadTime;
  self.marqueeLoadTime;
  self.additionalAdLoadTime;

  if (window['performance'] && window.performance['timing']) {
    navigationStart = window.performance.timing.navigationStart;
    responseStart = window.performance.timing.responseStart;
  }
  if (window['start_of_document']) {
    documentStart = start_of_document;
  }

  function returnGreater(a, b) {
    return a > b ? a : b;
  }

  function getPrimaryContentPainted() {
    if (primaryContentPainted) {
      return primaryContentPainted;
    }
    if (self.wizardLoadTime && self.headerLoadTime && self.marqueeLoadTime && self.additionalAdLoadTime) {
      primaryContentPainted = returnGreater(self.wizardLoadTime, self.headerLoadTime);
      primaryContentPainted = returnGreater(primaryContentPainted, self.marqueeLoadTime);
      primaryContentPainted = returnGreater(primaryContentPainted, self.additionalAdLoadTime);
      return primaryContentPainted;
    }
    return null;
  }

  function logMetric(name, start, end) {
    if (start && end) {
      logger.addMetric(name, end - start);
    }
  }

  this.logMetrics = function() {
    logMetric("navigationStartToPrimaryContentPainted", navigationStart, getPrimaryContentPainted());
    logMetric("startOfDocumentToPrimaryContentPainted", documentStart, getPrimaryContentPainted());
    logMetric("startOfDocumentToWizardPainted", documentStart, self.wizardLoadTime);
    logMetric("ResponseToPrimaryContentPainted", responseStart, getPrimaryContentPainted());
    logger.sendMetrics("awsHomepageMetrics")
  }

}

function additionalAdPlacementImageLoaded(elementsArray, noAdCallback, successCallback, failCallback, timeout) {
  var i, element;
  for (i = 0; i < elementsArray.length; i ++) {
    element = elementsArray[i];
    if (element.style.display === "block") {
      backgroundImageLoaded(element, successCallback, failCallback, timeout);
      return;
    }
  }
  noAdCallback();
}

// stores and logs custom metrics
function CustomPerformanceMetricLogger(loggingFunction) {
  var metricsArray = [],
      numberOfEvents = 0;
  this.addMetric = function(name, value) {
    numberOfEvents += 1;
    if (numberOfEvents > 4) {
      console.error("Cannot log performance event " + name + ":" + value +
                    ". Only a max of 4 custom events are supported.");
      return;
    }
    metricsArray.push('clEventName0' + numberOfEvents + '=' + name);
    metricsArray.push('clEventTime0' + numberOfEvents + '=' + value);
  };
  this.sendMetrics = function(loggingMetricsName) {
      if (typeof loggingFunction === "function") {
          loggingFunction(loggingMetricsName, metricsArray);
      }
      else if(window.dctk && dctk.enabled) {
          dctk.onReady(function() {
              dctk.logging.logTrxEvent(loggingMetricsName, metricsArray);
          });
      }
      else{
          require('dctk/clientLogging', function(cl) {
              cl.logTrxEvent(loggingMetricsName, metricsArray);
          })
      }
  };
}

var logger = new CustomPerformanceMetricLogger();
var calc = new TimeCalculator(logger) ;
var tracker = new AllAreDone(["headerPainted", "wizardPainted", "marqueeAdImageLoaded", "additionWizardAdImageLoaded"], calc.logMetrics);

function marqueeImageSuccess() {
  calc.marqueeLoadTime = +new Date();
  tracker.triggerOneEvent("marqueeAdImageLoaded");
}

function marqueeImageFail() {
  tracker.triggerOneEvent("marqueeAdImageLoaded");
}

function additionalAdSuccess() {
  calc.additionalAdLoadTime = +new Date();
  tracker.triggerOneEvent("additionWizardAdImageLoaded");
}

function additionalAdFail() {
  tracker.triggerOneEvent("additionWizardAdImageLoaded");
}

define('gc/primary-content-painted', function() {
    return tracker;
});
define('gc/getDefaultTabAndPackages', ['underscore', 'gc/json-path'], function(_, jsonPath) {
  return function(config) {
    var tab = 'flight';
    var tabObj = _.find(jsonPath("wizardconfig.lobs", config), function(lob) {return lob.defaultLob});
    if (tabObj && tabObj.id) {
      tab = tabObj.id;
    }
    var packages = {};
    if (tab && (tab === "package" || (tabObj && tabObj.isPackage))) {
      var lobConfig = "" ;
      if (tab === 'package') {
        var pack = _.find(tabObj.lobs, function(lob) {return lob.defaultPackage});
        lobConfig = pack.id;
      } else {
        lobConfig = tab;
      }
      var packageSettings = config[lobConfig];
      packages = {
        flight: packageSettings.packageSetting_flight,
        hotel: packageSettings.packageSetting_hotel,
        car: packageSettings.packageSetting_car
      }
    }
    return {
      tab: tab,
      packages: packages
    };
  }
});

/**
 * Module is a function for merging two objects with properties. This module is
 * created for use with our config files. _.extend does not do a deep merge and
 * $.extend has some bugs where it will not correctly work with this example:
 * {foo:{me:true}} and {foo:{me:false, you:true}}
 * @exports gc/merge
 */
define('gc/merge', function() {
  /**
   * Returns true if the value is a plain Object
   * @param {object} value - any value
   * @returns {boolean} - true if the value is a plain Object, otherwise false
   */
  function isObject(value) {
    return value && // test for null since typeof null is 'object'
      (typeof value === 'object') &&
      !(value instanceof Array) && // Array and Date are also typeof 'object'
      !(value instanceof Date);
  }

  /**
   * Returns a copy of an object with the same structure and values. This
   * breaks all reffrences to the original object so changes in one will
   * not effect the other.
   * @param {object} value - any object with parameters
   * @returns {object} - a cloned copy of the object passed in
   */
  function clone(value) {
    var key;
    var output = {};
    if (isObject(value)) {
      for (key in value) {
        if (value.hasOwnProperty(key)) {
          output[key] = clone(value[key]);
        }
      }
      return output;
    } else {
      return value;
    }
  }

  /**
   * Copies the structure of default or override to the destination object
   * @param {object} destination - all properties end up being added here
   * @param {object} defaults - these are the default values to be copied
   * @param {object} overrides - these value override the default if they exsist
   */
  function copyBaseWithDefaultsAndOverrides(destination, defaults, overrides) {
    var key;
    for (key in defaults) {
      if (overrides.hasOwnProperty(key)) {
       if (isObject(defaults[key]) && isObject(overrides[key])) {
         destination[key] = merge(defaults[key], overrides[key])
       } else {
         destination[key] = clone(overrides[key]);
       }
      } else if (defaults.hasOwnProperty(key)) {
        destination[key] = clone(defaults[key]);
      }
    }
  }

  /**
   * Copies all properties from source to destination that don't already
   * exsist on the destination.
   * @param {object} destination - properties are copied to here
   * @param {object} source - properties are copied from here
   */
  function addSourcePropertiesToDestination(destination, source) { 
    var key;
    for (key in source) {
      if (source.hasOwnProperty(key) && !destination[key]) {
        destination[key] = clone(source[key]);
      }
    }
  }

  /**
   * Returns a new object with all properties from default and overrides copied
   * onto it. Properties are taken from default unless they exsist in override.
   * @param {object} defaults - the default properties
   * @param {object} overrides - the override properties
   * @returns {object} - a new object will all the properties
   */
  function merge(defaults, overrides) {
    var output = {};
    copyBaseWithDefaultsAndOverrides(output, defaults, overrides);
    addSourcePropertiesToDestination(output, overrides);
    return output;
  }

  /**
   * Wrapper around merge. Checks that both parameters are objects, otherwise
   * just returns the default.
   * @param {object} default - the default properties
   * @param {object} overrides - the override properties
   * @returns {object} - a new object with all the properties
   */
  return function(defaults, overrides) {
    if (isObject(defaults) && isObject(overrides)) {
      return merge(defaults, overrides);
    } else {
      return defaults;
    }
  }
});

define('gc/json-path', function() {
  return function(path, object) {
    var pathArray = splitPath(path);
    var value = getValue(pathArray, object);
    return value;
  }

  function splitPath(path) {
    return path.split(/\[|]\.|]|\./);
  }

  function getValue(path, object) {
    var key = path.shift();
    object = object[key];
    if (path.length === 0 || typeof object === 'undefined') {
      return object;
    } else {
      return getValue(path, object);
    }
  }

});

/**
 * Backbone-Nested 2.0.0 - An extension of Backbone.js that keeps track of nested attributes
 *
 * http://afeld.github.com/backbone-nested/
 *
 * Copyright (c) 2011-2012 Aidan Feldman
 * MIT Licensed (LICENSE)
 */
/*global $, _, Backbone */
(function(){
  'use strict';

  var _delayedTriggers = [],
    nestedChanges;

  Backbone.NestedModel = Backbone.Model.extend({

    get: function(attrStrOrPath){
      var attrPath = Backbone.NestedModel.attrPath(attrStrOrPath),
        result;

      Backbone.NestedModel.walkPath(this.attributes, attrPath, function(val, path){
        var attr = _.last(path);
        if (path.length === attrPath.length){
          // attribute found
          result = val[attr];
        }
      });

      return result;
    },

    has: function(attr){
      // for some reason this is not how Backbone.Model is implemented - it accesses the attributes object directly
      var result = this.get(attr);
      return !(result === null || _.isUndefined(result));
    },

    set: function(key, value, opts){
      var newAttrs = Backbone.NestedModel.deepClone(this.attributes),
        attrPath,
        unsetObj,
        validated;

      if (_.isString(key)){
        // Backbone 0.9.0+ syntax: `model.set(key, val)` - convert the key to an attribute path
        attrPath = Backbone.NestedModel.attrPath(key);
      } else if (_.isArray(key)){
        // attribute path
        attrPath = key;
      }

      if (attrPath){
        opts = opts || {};
        this._setAttr(newAttrs, attrPath, value, opts);
      } else { // it's an Object
        opts = value || {};
        var attrs = key;
        for (var _attrStr in attrs) {
          if (attrs.hasOwnProperty(_attrStr)) {
            this._setAttr(newAttrs,
                          Backbone.NestedModel.attrPath(_attrStr),
                          opts.unset ? void 0 : attrs[_attrStr],
                          opts);
          }
        }
      }

      nestedChanges = Backbone.NestedModel.__super__.changedAttributes.call(this);

      if (opts.unset && attrPath && attrPath.length === 1){ // assume it is a singular attribute being unset
        // unsetting top-level attribute
        unsetObj = {};
        unsetObj[key] = void 0;
        nestedChanges = _.omit(nestedChanges, _.keys(unsetObj));
        validated = Backbone.NestedModel.__super__.set.call(this, unsetObj, opts);
      } else {
        unsetObj = newAttrs;

        // normal set(), or an unset of nested attribute
        if (opts.unset && attrPath){
          // make sure Backbone.Model won't unset the top-level attribute
          opts = _.extend({}, opts);
          delete opts.unset;
        } else if (opts.unset && _.isObject(key)) {
          unsetObj = key;
        }
        nestedChanges = _.omit(nestedChanges, _.keys(unsetObj));
        validated = Backbone.NestedModel.__super__.set.call(this, unsetObj, opts);
      }


      if (!validated){
        // reset changed attributes
        this.changed = {};
        nestedChanges = {};
        return false;
      }


      this._runDelayedTriggers();
      return this;
    },

    unset: function(attr, options) {
      return this.set(attr, void 0, _.extend({}, options, {unset: true}));
    },

    clear: function(options) {
      nestedChanges = {};

      // Mostly taken from Backbone.Model.set, modified to work for NestedModel.
      options = options || {};
      // clone attributes so validate method can't mutate it from underneath us.
      var attrs = _.clone(this.attributes);
      if (!options.silent && this.validate && !this.validate(attrs, options)) {
        return false; // Should maybe return this instead?
      }

      var changed = this.changed = {};
      var model = this;

      var setChanged = function(obj, prefix, options) {
        // obj will be an Array or an Object
        _.each(obj, function(val, attr){
          var changedPath = prefix;
          if (_.isArray(obj)){
            // assume there is a prefix
            changedPath += '[' + attr + ']';
          } else if (prefix){
            changedPath += '.' + attr;
          } else {
            changedPath = attr;
          }

          val = obj[attr];
          if (_.isObject(val)) { // clear child attrs
            setChanged(val, changedPath, options);
          }
          if (!options.silent) model._delayedChange(changedPath, null, options);
          changed[changedPath] = null;
        });
      };
      setChanged(this.attributes, '', options);

      this.attributes = {};

      // Fire the `"change"` events.
      if (!options.silent) this._delayedTrigger('change');

      this._runDelayedTriggers();
      return this;
    },

    add: function(attrStr, value, opts){
      var current = this.get(attrStr);
      if (!_.isArray(current)) throw new Error('current value is not an array');
      return this.set(attrStr + '[' + current.length + ']', value, opts);
    },

    remove: function(attrStr, opts){
      opts = opts || {};

      var attrPath = Backbone.NestedModel.attrPath(attrStr),
        aryPath = _.initial(attrPath),
        val = this.get(aryPath),
        i = _.last(attrPath);

      if (!_.isArray(val)){
        throw new Error("remove() must be called on a nested array");
      }

      // only trigger if an element is actually being removed
      var trigger = !opts.silent && (val.length >= i + 1),
        oldEl = val[i];

      // remove the element from the array
      val.splice(i, 1);
      opts.silent = true; // Triggers should only be fired in trigger section below
      this.set(aryPath, val, opts);

      if (trigger){
        attrStr = Backbone.NestedModel.createAttrStr(aryPath);
        this.trigger('remove:' + attrStr, this, oldEl);
        for (var aryCount = aryPath.length; aryCount >= 1; aryCount--) {
          attrStr = Backbone.NestedModel.createAttrStr(_.first(aryPath, aryCount));
          this.trigger('change:' + attrStr, this, oldEl);
        }
        this.trigger('change', this, oldEl);
      }

      return this;
    },

    changedAttributes: function(diff) {
      var backboneChanged = Backbone.NestedModel.__super__.changedAttributes.call(this, diff);
      if (_.isObject(backboneChanged)) {
        return _.extend({}, nestedChanges, backboneChanged);
      }
      return false;
    },

    toJSON: function(){
      return Backbone.NestedModel.deepClone(this.attributes);
    },


    // private
    _delayedTrigger: function(/* the trigger args */){
      _delayedTriggers.push(arguments);
    },

    _delayedChange: function(attrStr, newVal, options){
      this._delayedTrigger('change:' + attrStr, this, newVal, options);

      // Check if `change` even *exists*, as it won't when the model is
      // freshly created.
      if (!this.changed) {
        this.changed = {};
      }

      this.changed[attrStr] = newVal;
    },

    _runDelayedTriggers: function(){
      while (_delayedTriggers.length > 0){
        this.trigger.apply(this, _delayedTriggers.shift());
      }
    },

    // note: modifies `newAttrs`
    _setAttr: function(newAttrs, attrPath, newValue, opts){
      opts = opts || {};

      var fullPathLength = attrPath.length;
      var model = this;

      Backbone.NestedModel.walkPath(newAttrs, attrPath, function(val, path){
        var attr = _.last(path);
        var attrStr = Backbone.NestedModel.createAttrStr(path);

        // See if this is a new value being set
        var isNewValue = !_.isEqual(val[attr], newValue);

        if (path.length === fullPathLength){
          // reached the attribute to be set

          if (opts.unset){
            // unset the value
            delete val[attr];

            // Trigger Remove Event if array being set to null
            if (_.isArray(val)){
              var parentPath = Backbone.NestedModel.createAttrStr(_.initial(attrPath));
              model._delayedTrigger('remove:' + parentPath, model, val[attr]);
            }
          } else {
            // Set the new value
            val[attr] = newValue;
          }

          // Trigger Change Event if new values are being set
          if (!opts.silent && _.isObject(newValue) && isNewValue){
            var visited = [];
            var checkChanges = function(obj, prefix) {
              // Don't choke on circular references
              if(_.indexOf(visited, obj) > -1) {
                return;
              } else {
                visited.push(obj);
              }

              var nestedAttr, nestedVal;
              for (var a in obj){
                if (obj.hasOwnProperty(a)) {
                  nestedAttr = prefix + '.' + a;
                  nestedVal = obj[a];
                  if (!_.isEqual(model.get(nestedAttr), nestedVal)) {
                    model._delayedChange(nestedAttr, nestedVal, opts);
                  }
                  if (_.isObject(nestedVal)) {
                    checkChanges(nestedVal, nestedAttr);
                  }
                }
              }
            };
            checkChanges(newValue, attrStr);

          }


        } else if (!val[attr]){
          if (_.isNumber(attr)){
            val[attr] = [];
          } else {
            val[attr] = {};
          }
        }

        if (!opts.silent){
          // let the superclass handle change events for top-level attributes
          if (path.length > 1 && isNewValue){
            model._delayedChange(attrStr, val[attr], opts);
          }

          if (_.isArray(val[attr])){
            model._delayedTrigger('add:' + attrStr, model, val[attr]);
          }
        }
      });
    }

  }, {
    // class methods

    attrPath: function(attrStrOrPath){
      var path;

      if (_.isString(attrStrOrPath)){
        // TODO this parsing can probably be more efficient
        path = (attrStrOrPath === '') ? [''] : attrStrOrPath.match(/[^\.\[\]]+/g);
        path = _.map(path, function(val){
          // convert array accessors to numbers
          return val.match(/^\d+$/) ? parseInt(val, 10) : val;
        });
      } else {
        path = attrStrOrPath;
      }

      return path;
    },

    createAttrStr: function(attrPath){
      var attrStr = attrPath[0];
      _.each(_.rest(attrPath), function(attr){
        attrStr += _.isNumber(attr) ? ('[' + attr + ']') : ('.' + attr);
      });

      return attrStr;
    },

    deepClone: function(obj){
      return $.extend(true, {}, obj);
    },

    walkPath: function(obj, attrPath, callback, scope){
      var val = obj,
        childAttr;

      // walk through the child attributes
      for (var i = 0; i < attrPath.length; i++){
        callback.call(scope || this, val, attrPath.slice(0, i + 1));

        childAttr = attrPath[i];
        val = val[childAttr];
        if (!val) break; // at the leaf
      }
    }

  });

}());

/*
 XDate v0.8
 Docs & Licensing: http://arshaw.com/xdate/
*/

var XDate=function(g,n,A,p){function f(){var a=this instanceof f?this:new f,c=arguments,b=c.length,d;typeof c[b-1]=="boolean"&&(d=c[--b],c=q(c,0,b));if(b)if(b==1)if(b=c[0],b instanceof g||typeof b=="number")a[0]=new g(+b);else if(b instanceof f){var c=a,h=new g(+b[0]);if(l(b))h.toString=v;c[0]=h}else{if(typeof b=="string"){a[0]=new g(0);a:{for(var c=b,b=d||!1,h=f.parsers,w=0,e;w<h.length;w++)if(e=h[w](c,b,a)){a=e;break a}a[0]=new g(c)}}}else a[0]=new g(m.apply(g,c)),d||(a[0]=r(a[0]));else a[0]=new g;
typeof d=="boolean"&&B(a,d);return a}function l(a){return a[0].toString===v}function B(a,c,b){if(c){if(!l(a))b&&(a[0]=new g(m(a[0].getFullYear(),a[0].getMonth(),a[0].getDate(),a[0].getHours(),a[0].getMinutes(),a[0].getSeconds(),a[0].getMilliseconds()))),a[0].toString=v}else l(a)&&(a[0]=b?r(a[0]):new g(+a[0]));return a}function C(a,c,b,d,h){var e=k(j,a[0],h),a=k(D,a[0],h),h=!1;d.length==2&&typeof d[1]=="boolean"&&(h=d[1],d=[b]);b=c==1?(b%12+12)%12:e(1);a(c,d);h&&e(1)!=b&&(a(1,[e(1)-1]),a(2,[E(e(0),
e(1))]))}function F(a,c,b,d){var b=Number(b),h=n.floor(b);a["set"+o[c]](a["get"+o[c]]()+h,d||!1);h!=b&&c<6&&F(a,c+1,(b-h)*G[c],d)}function H(a,c,b){var a=a.clone().setUTCMode(!0,!0),c=f(c).setUTCMode(!0,!0),d=0;if(b==0||b==1){for(var h=6;h>=b;h--)d/=G[h],d+=j(c,!1,h)-j(a,!1,h);b==1&&(d+=(c.getFullYear()-a.getFullYear())*12)}else b==2?(b=a.toDate().setUTCHours(0,0,0,0),d=c.toDate().setUTCHours(0,0,0,0),d=n.round((d-b)/864E5)+(c-d-(a-b))/864E5):d=(c-a)/[36E5,6E4,1E3,1][b-3];return d}function s(a){var c=
a(0),b=a(1),d=a(2),a=new g(m(c,b,d)),c=t(I(c,b,d));return n.floor(n.round((a-c)/864E5)/7)+1}function I(a,c,b){c=new g(m(a,c,b));if(c<t(a))return a-1;else if(c>=t(a+1))return a+1;return a}function t(a){a=new g(m(a,0,4));a.setUTCDate(a.getUTCDate()-(a.getUTCDay()+6)%7);return a}function J(a,c,b,d){var h=k(j,a,d),e=k(D,a,d);b===p&&(b=I(h(0),h(1),h(2)));b=t(b);d||(b=r(b));a.setTime(+b);e(2,[h(2)+(c-1)*7])}function K(a,c,b,d,h){var e=f.locales,g=e[f.defaultLocale]||{},i=k(j,a,h),b=(typeof b=="string"?
e[b]:b)||{};return x(a,c,function(a){if(d)for(var b=(a==7?2:a)-1;b>=0;b--)d.push(i(b));return i(a)},function(a){return b[a]||g[a]},h)}function x(a,c,b,d,e){for(var f,g,i="";f=c.match(N);){i+=c.substr(0,f.index);if(f[1]){g=i;for(var i=a,j=f[1],l=b,m=d,n=e,k=j.length,o=void 0,q="";k>0;)o=O(i,j.substr(0,k),l,m,n),o!==p?(q+=o,j=j.substr(k),k=j.length):k--;i=g+(q+j)}else f[3]?(g=x(a,f[4],b,d,e),parseInt(g.replace(/\D/g,""),10)&&(i+=g)):i+=f[7]||"'";c=c.substr(f.index+f[0].length)}return i+c}function O(a,
c,b,d,e){var g=f.formatters[c];if(typeof g=="string")return x(a,g,b,d,e);else if(typeof g=="function")return g(a,e||!1,d);switch(c){case "fff":return i(b(6),3);case "s":return b(5);case "ss":return i(b(5));case "m":return b(4);case "mm":return i(b(4));case "h":return b(3)%12||12;case "hh":return i(b(3)%12||12);case "H":return b(3);case "HH":return i(b(3));case "d":return b(2);case "dd":return i(b(2));case "ddd":return d("dayNamesShort")[b(7)]||"";case "dddd":return d("dayNames")[b(7)]||"";case "M":return b(1)+
1;case "MM":return i(b(1)+1);case "MMM":return d("monthNamesShort")[b(1)]||"";case "MMMM":return d("monthNames")[b(1)]||"";case "yy":return(b(0)+"").substring(2);case "yyyy":return b(0);case "t":return u(b,d).substr(0,1).toLowerCase();case "tt":return u(b,d).toLowerCase();case "T":return u(b,d).substr(0,1);case "TT":return u(b,d);case "z":case "zz":case "zzz":return e?c="Z":(d=a.getTimezoneOffset(),a=d<0?"+":"-",b=n.floor(n.abs(d)/60),d=n.abs(d)%60,e=b,c=="zz"?e=i(b):c=="zzz"&&(e=i(b)+":"+i(d)),c=
a+e),c;case "w":return s(b);case "ww":return i(s(b));case "S":return c=b(2),c>10&&c<20?"th":["st","nd","rd"][c%10-1]||"th"}}function u(a,c){return a(3)<12?c("amDesignator"):c("pmDesignator")}function y(a){return!isNaN(+a[0])}function j(a,c,b){return a["get"+(c?"UTC":"")+o[b]]()}function D(a,c,b,d){a["set"+(c?"UTC":"")+o[b]].apply(a,d)}function r(a){return new g(a.getUTCFullYear(),a.getUTCMonth(),a.getUTCDate(),a.getUTCHours(),a.getUTCMinutes(),a.getUTCSeconds(),a.getUTCMilliseconds())}function E(a,
c){return 32-(new g(m(a,c,32))).getUTCDate()}function z(a){return function(){return a.apply(p,[this].concat(q(arguments)))}}function k(a){var c=q(arguments,1);return function(){return a.apply(p,c.concat(q(arguments)))}}function q(a,c,b){return A.prototype.slice.call(a,c||0,b===p?a.length:b)}function L(a,c){for(var b=0;b<a.length;b++)c(a[b],b)}function i(a,c){c=c||2;for(a+="";a.length<c;)a="0"+a;return a}var o="FullYear,Month,Date,Hours,Minutes,Seconds,Milliseconds,Day,Year".split(","),M=["Years",
"Months","Days"],G=[12,31,24,60,60,1E3,1],N=/(([a-zA-Z])\2*)|(\((('.*?'|\(.*?\)|.)*?)\))|('(.*?)')/,m=g.UTC,v=g.prototype.toUTCString,e=f.prototype;e.length=1;e.splice=A.prototype.splice;e.getUTCMode=z(l);e.setUTCMode=z(B);e.getTimezoneOffset=function(){return l(this)?0:this[0].getTimezoneOffset()};L(o,function(a,c){e["get"+a]=function(){return j(this[0],l(this),c)};c!=8&&(e["getUTC"+a]=function(){return j(this[0],!0,c)});c!=7&&(e["set"+a]=function(a){C(this,c,a,arguments,l(this));return this},c!=
8&&(e["setUTC"+a]=function(a){C(this,c,a,arguments,!0);return this},e["add"+(M[c]||a)]=function(a,d){F(this,c,a,d);return this},e["diff"+(M[c]||a)]=function(a){return H(this,a,c)}))});e.getWeek=function(){return s(k(j,this,!1))};e.getUTCWeek=function(){return s(k(j,this,!0))};e.setWeek=function(a,c){J(this,a,c,!1);return this};e.setUTCWeek=function(a,c){J(this,a,c,!0);return this};e.addWeeks=function(a){return this.addDays(Number(a)*7)};e.diffWeeks=function(a){return H(this,a,2)/7};f.parsers=[function(a,
c,b){if(a=a.match(/^(\d{4})(-(\d{2})(-(\d{2})([T ](\d{2}):(\d{2})(:(\d{2})(\.(\d+))?)?(Z|(([-+])(\d{2})(:?(\d{2}))?))?)?)?)?$/)){var d=new g(m(a[1],a[3]?a[3]-1:0,a[5]||1,a[7]||0,a[8]||0,a[10]||0,a[12]?Number("0."+a[12])*1E3:0));a[13]?a[14]&&d.setUTCMinutes(d.getUTCMinutes()+(a[15]=="-"?1:-1)*(Number(a[16])*60+(a[18]?Number(a[18]):0))):c||(d=r(d));return b.setTime(+d)}}];f.parse=function(a){return+f(""+a)};e.toString=function(a,c,b){return a===p||!y(this)?this[0].toString():K(this,a,c,b,l(this))};
e.toUTCString=e.toGMTString=function(a,c,b){return a===p||!y(this)?this[0].toUTCString():K(this,a,c,b,!0)};e.toISOString=function(){return this.toUTCString("yyyy-MM-dd'T'HH:mm:ss(.fff)zzz")};f.defaultLocale="";f.locales={"":{monthNames:"January,February,March,April,May,June,July,August,September,October,November,December".split(","),monthNamesShort:"Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec".split(","),dayNames:"Sunday,Monday,Tuesday,Wednesday,Thursday,Friday,Saturday".split(","),dayNamesShort:"Sun,Mon,Tue,Wed,Thu,Fri,Sat".split(","),
amDesignator:"AM",pmDesignator:"PM"}};f.formatters={i:"yyyy-MM-dd'T'HH:mm:ss(.fff)",u:"yyyy-MM-dd'T'HH:mm:ss(.fff)zzz"};L("getTime,valueOf,toDateString,toTimeString,toLocaleString,toLocaleDateString,toLocaleTimeString,toJSON".split(","),function(a){e[a]=function(){return this[0][a]()}});e.setTime=function(a){this[0].setTime(a);return this};e.valid=z(y);e.clone=function(){return new f(this)};e.clearTime=function(){return this.setHours(0,0,0,0)};e.toDate=function(){return new g(+this[0])};f.now=function(){return+new g};
f.today=function(){return(new f).clearTime()};f.UTC=m;f.getDaysInMonth=E;if(typeof module!=="undefined"&&module.exports)module.exports=f;typeof define==="function"&&define.amd&&define([],function(){return f});return f}(Date,Math,Array);
define('xdate', function() {
  return XDate;
});

define('gc/localStorage', ['underscore'], function(_) {
  return {

    init: function() {
      try {
        var storage = window['localStorage'],
            x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        this.availability = true;
        return true;
      }
      catch(e) {
        this.availability = false;
        return false;
      }
      finally {
        this.initialized = true;
      }
    },

    checkIfAvailable: function() {
      if (this.initialized) return this.availability;
      return this.init();
    },

    // Filter the wizard model to save the data we need for the last search
    filterModel: function(model){
      var lastSearchModel = _.pick(model, 'tab', 'isCarDriverAgeWithinLimit', 'driverAge', 'origin', 'originTLA', 'originFromTA', 'destination', 'destinationTLA', 'destinationFromTA', 'regionId', 'rooms', 'roomCount', 'carReturn', 'pickup',
                                  'flighttype', 'startDate', 'endDate', 'checkin', 'checkout', 'startTime', 'regionName', 'searchQuery', 'multiDest', 'cruiseDestination', 'cruiseMonth', 'dropoff',
                                  'endTime', 'packageType', 'packages', 'isChildInLap', 'rail','carChains','carInfantseat','carNavigation','carSkirack', 'carToddlerseat', 'carType', 'showCarOptions',
                                  'showFlightOptions', 'nonStop', 'noPenalty', 'carrier', 'cabinClass', 'isPartialStay','trainOrigin','trainDestination');
      return lastSearchModel;
    },

    /**
     * Store data in local storage
     *
     * @param {Object} data JSON object to be stored in the local storage
     * @param  {String} storageKey Storage key
     * @returns {boolean} true if success, false otherwise
     */
    saveLocalStorage: function(storageKey, data) {
      // check if LocalStorage feature is enabled
      if ( ! this.checkIfAvailable()) {
        return false;
      }

      try {
        if (typeof data !== 'string') {
          data = this._modelFilter(data);
          data = JSON.stringify(data);
        }
        localStorage.setItem(storageKey, data);
      }
      catch (ex) {
        return false;
      }

      return true;
    },

    /**
     * Retrieve data from the local storage
     *
     * @param {String} storageKey Storage key
     * @return {boolean | Object} false if failed, Object if found
     */
    getLocalStorage: function(storageKey) {
      // check if LocalStorage feature is enabled
      if ( ! this.checkIfAvailable()) {
        return false;
      }

      try {
        var item = localStorage.getItem(storageKey);
        item = JSON.parse(item);
      }
      catch(ex) {
        return false;
      }

      return item;
    },
    initialized: false,
    availability: false,
    localStorageKey: '_e3.wizard_',

    _modelFilter: function(data) {
      var keep = {};
      for (var prop in data) {
        //Fix for Main-157435
        if(prop == 'isChildInLap'){
          keep[prop] = data[prop];
        }
        if (data[prop]) {
          keep[prop] = data[prop];
        }

        //this method filters any var with value false. I need an exception for the driver age checkbox (coz its default status=true)
        if (prop == 'isCarDriverAgeWithinLimit') {
          keep[prop] = data[prop];
        }
      }
      delete keep.nextTrip;
      return keep;
    }

  }
});

/*jslint nomen: true */
/*global _, corewizard, XDate , ab6072status*/

define('gc/modelHelpers', [
  'gc/modelHelpersOverride',
  'gc/inputDefaults',
  'gc/dataModels',
  'gc/loc',
  'gc/abTest',
  'underscore',
  'gc/predicates',
  'jquery'
], function(
  modelHelpersOverride,
  inputDefaults,
  dataModels,
  loc,
  abTest,
  _,
  predicates,
  $
) {
  var helpers = {};

  helpers.getChildForHotels = getChildForHotels = function (childAge, childIndex, roomIndex, roomId) {
      'use strict';
      if (typeof childAge === 'undefined') {
          childAge = '';
      }
      //Fix issue  WCAG-2501
      var _childAge = (childAge === null || childAge === undefined || childAge === 'undefined' || childAge === '') ? 'null' : childAge;
      var options =  JSON.parse(JSON.stringify(inputDefaults.childAges.options)); //Clone options
      if( options && options.forEach){
        options.forEach(function(option){
          if( option.value == _childAge ){
            option.selected = 'selected';
          }else{
            delete option.selected;
          }
        });
      }

      return {
          namespace: roomId + '-age-select-' + String(childIndex + 1),
          age: childAge,
          index: childIndex,
          roomIndex: roomIndex,
          parent: roomId,
          'wizard_action': '{"rooms['+roomIndex+'].children['+childIndex+']": $value1}',
          'label-text': function(childNumber){
              'use strict';
              var childAgeCompile = loc.childLabel.replace('{{childIndex}}', childNumber);
              return childAgeCompile;
          }(childIndex+1),
          options: options,
          hasError: _.contains(dataModels.model.get('validation.fields'), roomIndex + ":" + childIndex),
          'ia' : [{'name':'data-select-value', 'value':childAge},
                  {'name':'data-children-fieldset', 'value': roomId},
                  {'name':'data-redraw', 'value':'true'},
                  {'name':'aria-required', 'value':'true'},
                  {'name':'data-wizard-owner', 'value':roomId}]
      };
  };

  helpers.getChildrenForHotels = getChildrenForHotels = function (children, roomIndex, roomId) {
      'use strict';
      return _.map(children, function (age, index) {
          return getChildForHotels(age, index, roomIndex, roomId);
      });
  };
  helpers.getRoomForHotels = getRoomForHotels = function (lob, room, roomIndex, isSingleRoom) {
      'use strict';
      // replace placeholder in loc string for hotelRoomLabel
      var labelLocString = loc.hotelRoomLabel.replace('###number###', roomIndex + 1);
      return {
          adults: room.adults,
          children: room.children,
          childCount: room.children.length,
          id: lob + '-' + String(roomIndex + 1),
          ownerId: lob,
          number: roomIndex + 1,
          index: roomIndex,
          isHotelOnly: true,
          ages: getChildrenForHotels(room.children, roomIndex, lob + '-' + String(roomIndex + 1)),
          isSingleRoom : isSingleRoom,
          label: labelLocString,
          hotelAdultCountOptions: {
              namespace: lob + '-' + String(roomIndex + 1) + '-' + 'adults',
              'wizard_action': '{"rooms['+roomIndex+'].adults" : $value1}',
              'options': (abTest.get(11873).value !== 0) ? inputDefaults.hotelAdults.inlineLabelOptions.slice(0, 6) : inputDefaults.hotelAdults.options.slice(0, 6),
              'ia' : [{'name':'data-select-value', 'value':room.adults},
                      {'name':'wizard-owner', 'value':'adults'}],
              'label-text': inputDefaults.hotelAdults.label,
              'class': 'adult-select number-of-travellers',
              'hasError': _.contains(dataModels.model.get('validation.fields'),  roomIndex + 'a')
          },
          hotelChildCountOptions: {
              namespace: lob + '-' + String(roomIndex + 1) + '-' + 'children',
              'wizard_action': '{"rooms['+roomIndex+'].childCount" : $value1}',
              'options': (abTest.get(11873).value !== 0) ? inputDefaults.hotelChildren.inlineLabelOptions : inputDefaults.hotelChildren.options,
              'ia' : [{'name':'data-select-value', 'value':room.childCount},
                      {'name':'data-children-fieldset', 'value':lob + '-' + String(roomIndex + 1)},
                      {'name':'data-redraw', 'value':'true'},
                      {'name':'wizard-owner', 'value':'children'}],
              'label-text': inputDefaults.hotelChildren.label,
              'class': 'children-select number-of-travellers',
              'hasError': _.contains(dataModels.model.get('validation.fields'),  roomIndex + 'c')
          }
      };
  };
  helpers.getRoomsForHotels = getRoomsForHotels = function (lob, rooms) {
      'use strict';
      return _.map(rooms, function(room, index) {
          return getRoomForHotels(lob, room, index, rooms.length == 1);
      });
  };
  helpers.getRoomsForModel = getRoomsForModel = function (state, config) {
      'use strict';
      var roomsOut = [],
          i,
          j,
          adults,
          childCount,
          children,
          roomCount,
          maxRoomCount,
          stateRoomCount,
          childAge;

      maxRoomCount = config.get('travelers.maxRoomCount');
      if (state.get("tab") == "hotel" &&
              (state.get("roomCount") == 9) &&
              config.get("travelers.ninePlusRoomsAllowed"))
          maxRoomCount = 1;

      stateRoomCount = state.get('roomCount');
      roomCount = stateRoomCount <= maxRoomCount ? stateRoomCount : maxRoomCount;
      for (i = 0; i < roomCount; i += 1) {
          children = [];
          adults = state.get('rooms[' + i + '].adults') || 2;
          childCount = state.get('rooms[' + i + '].childCount') || 0;

          for (j = 0; j < childCount; j += 1) {
              childAge = state.get('rooms[' + i + '].children[' + j + ']');
              if (typeof childAge === 'undefined') {
                  childAge = '';
              }
              children.push(childAge);
          }

          roomsOut.push({'adults': adults, 'childCount': childCount, 'children': children});
      }
      return roomsOut;
  };
  helpers.getRoomsForModelFlights = getRoomsForModelFlights = function (state) {
      'use strict';
      var rooms,
          i,
          childAge,
          children;

      rooms = [];
      if (state.get('rooms') && state.get('rooms').length > 0) {
          rooms[0] = {};
          rooms[0].adults = state.get('rooms[0].adults');
          rooms[0].childCount = state.get('rooms[0].childCount');
      } else {
          rooms[0] = {adults: 1, childCount: 0, children: []};
      }

      children = [];
      for (i = 0; i < rooms[0].childCount; i += 1) {
          childAge = state.get('rooms[0].children[' + i + ']');
          if (typeof childAge === 'undefined') {
              childAge = '';
          }
          children.push(childAge);
      }
      rooms[0].children = children;

      return rooms;
  };
  helpers.getRoomsForModelRails = getRoomsForModelRails = function (state) {
       'use strict';
       var rooms,
           i,
           childAge,
           children,
           youths,
           youthAge,
           seniors,
           seniorAge;

       rooms = [];
       if (state.get('rooms') && state.get('rooms').length > 0) {
           rooms[0] = {};
           rooms[0].adults = state.get('rooms[0].adults');
           rooms[0].childCount = state.get('rooms[0].childCount');
           rooms[0].youthCount = state.get('rooms[0].youthCount');
           rooms[0].seniorCount = state.get('rooms[0].seniorCount');
       } else {
           rooms[0] = {adults: 1, childCount: 0, children: [], youthCount: 0, youths: [], seniorCount: 0, seniors: []};
       }

       children = [];
       youths = [];
       seniors = [];
       for (i = 0; i < rooms[0].childCount; i += 1) {
           childAge = state.get('rooms[0].children[' + i + ']');
           if (typeof childAge === 'undefined') {
               childAge = '';
           }
           children.push(childAge);
       }
       for (i = 0; i < rooms[0].youthCount; i += 1) {
           youthAge = state.get('rooms[0].youths[' + i + ']');
           if (typeof youthAge === 'undefined') {
               youthAge = '';
           }
           youths.push(youthAge);
       }
       for (i = 0; i < rooms[0].seniorCount; i += 1) {
           seniorAge = state.get('rooms[0].seniors[' + i + ']');
           if (typeof seniorAge === 'undefined') {
               seniorAge = '';
           }
           seniors.push(seniorAge);
       }
       rooms[0].children = children;
       rooms[0].youths = youths;
       rooms[0].seniors = seniors;

       return rooms;
   },
  helpers.getRulesForCheckingChildAges = getRulesForCheckingChildAges = function (model) {
      'use strict';
      var i,
          j,
          room,
          rules,
          child,
          roomCount,
          rooms;

      roomCount = model.get("roomCount");
      rooms = model.get("rooms");

      rules = [];

      for (i = 0; i < roomCount; i += 1) {
          room = rooms[i];

          for (j = 0; j < room.childCount; j += 1) {

              rules.push(["isNotDefaultValue", ["rooms[" + i + "].children[" + j + "]"], "child-age-not-provided"]);

          }
      }
      return rules;
  };
  helpers.getRegionNameOrDestination = getRegionNameOrDestination = function (state, config) {
      'use strict';
      var result = state.get("regionName") || state.get("destination");
      if (state.get('tab') === 'flight') {
          result = state.get("destination") || state.get("regionName");
      }
      return result;
  };
  helpers.getEndDate = getEndDate = function (state, config) {
      'use strict';
      var endDateString,
          endDate,
          startDateString,
          startDate,
          minDate,
          maxDate;

      // Bugfix for eph-511
      // Set the endDate in state if we have the startDate but not the endDate
      // Only for the Lob related to the hotel, we need to add one more day to the endDate
      if(!(state.get('endDate')) && state.get('startDate')){
          var currentStartDate = new XDate(state.get("startDate"));
          var currentEndDate = currentStartDate.clone().addDays(config.get("calendar.minTripLength")).toString(config.get("dateFormat"));
          return currentEndDate;
      }

      endDateString = state.get('endDate');
      //https://jira/jira/browse/MAIN-122282 Special case: partial LS data doesn't apply for hotel soft packaging.
      if (state.get('packages.flight') &&
          state.get('tab') === 'hotel' &&
          state.get('isPartialStay')) return state.get('checkout') || state.get('endDate');

      //commented out to fix https://jira/jira/browse/MAIN-123019
      // only run constraints when the LOB changes
      // if (!corewizard.core.state.changed.tab && !corewizard.core.state.changed.packages && typeof corewizard.core.state.changed.isPartialStay == 'undefined') {
      //   return endDateString;
      // }

      if (predicates.isNotBlank(endDateString).isValid &&
              predicates.isValidDate(endDateString).isValid) {
          endDate = new XDate(endDateString);
          if (_.isNaN(endDate)) {
            return '';
          }

          startDateString = state.get("startDate");

          if (predicates.isNotBlank(startDateString).isValid &&
                  predicates.isValidDate(startDateString).isValid) {
              startDate = new XDate(startDateString);

              minDate = startDate.clone().addDays(config.get("calendar.minTripLength"));
              maxDate = startDate.clone().addDays(config.get("calendar.maxTripLength"));
              if (endDate < minDate) {
                  var newEndDate = minDate.toString(config.get("dateFormat"));
                  state.set('endDate', newEndDate);
                  return newEndDate;
              }

              if(endDate > maxDate){
                  return "";
              }

          }
          return endDate.toString(config.get("dateFormat"));

        } else if (predicates.isNotBlank(endDateString).isValid) {
            return endDateString;      }
      return "";
  };
  helpers.getSoftPackageAction = getSoftPackageAction = function (buttonLob, model) {
      'use strict';
      var packages = ['flight', 'hotel', 'car'];
      var isFlightPackage = model.get('packages.flight'),
          isHotelPackage = model.get('packages.hotel'),
          isCarPackage = model.get('packages.car'),
          isTrainPackage = model.get('packages.train');
      var tab = model.get('tab');

      var isHotelTab = tab === 'hotel',
          isCarTab = tab === 'car',
          isFlightTab = tab === 'flight';

      var numberOfPackageTypesAdded = (isFlightPackage ? 1 : 0) +
                                      (isHotelPackage ? 1 : 0) +
                                      (isCarPackage ? 1 : 0) +
                                      (isTrainPackage ? 1 : 0);
      var moreThanTwoPackageTypes = numberOfPackageTypesAdded > 2,
          hasTwoPackageTypes = numberOfPackageTypesAdded === 2;
      var isCheckBoxStyle = isHotelTab;

      var values = _.map(packages, function(lob) {
          var isCurrentPackageType = lob === buttonLob;
          var isCurrentTab = lob === tab;

          if (isCheckBoxStyle) {
              if (isCurrentTab) {
                  if (moreThanTwoPackageTypes) {
                      return 'true';
                  } else {
                      return '$value1';
                  }
              } else if (isCurrentPackageType) {
                  return '$value1';
              } else {
                  return String(model.get('packages.' + lob));
              }
          } else {
              if (isCurrentTab) {
                  //return false if there's only two packages
                  //and this buttonID is one of them.
                  return String(!(
                      hasTwoPackageTypes &&
                      model.get('packages.' + buttonLob) === true)
                  );
              } else if (isCurrentPackageType) {
                  return String(!model.get('packages.' + lob));
              } else {
                  return String(model.get('packages.' + lob));
              }
          }
      });

      return '{"packages.flight" : ' + values[0] +
             ', "packages.hotel" : ' + values[1] +
             ', "packages.car" : '   + values[2] + '}';
  };

    helpers.mobileSuppress = mobileSuppress = function() {
        var isiPad = navigator.userAgent.match(/iPad/i) != null;
        var isMobile = navigator.userAgent.match(/Mobile|Android|BlackBerry/i) != null;
        return ( isMobile && !isiPad);
    };

    helpers.isUseSingleStackLaunchPages = isUseSingleStackLaunchPages = function() {
        return loc.masterconfig.switches.useSingleStackLaunchPages;
    };

    helpers.getHotelTabletValueProp = getHotelTabletValueProp = function () {
        'use strict';
        var hotelTabletValuePropCompile = loc.hotelTabletValueProp.replace('{{package_search_over_hotel_count}}', loc.masterconfig.package_search_over_hotel_count);
        return hotelTabletValuePropCompile;
    };

    $.extend(true, helpers, modelHelpersOverride);

  return helpers;
});


// XDate already knows how to handle MM/DD/YYYY & YYYY/MM/DD
// we need something for DD/MM/YYYY
// XDate allows us to extend the parser, but we're only allowed to pass in 1 string argument total
// also, FF doesnt like . or - as date separators

function parseDate(str) {
    var format = XDate.prototype.format;
    var parts = str.split(/[\s\.,/-]+/);
    var year, month, day
    if (format) {
        var formatParts = format.split(/[\s\.,/-]+/);
        if (formatParts.length == 3) {
            var $1 = formatParts[0][0].toUpperCase();
            var $2 = formatParts[1][0].toUpperCase();
            var $3 = formatParts[2][0].toUpperCase();
            if ($1 == 'D' && $2 == 'M' && $3 == 'Y') {
        	    year = parts[2];
        	    month = parts[1] ? parts[1]-1 : 0;
        	    day = parts[0];
            }
            else if ($1 == 'M' && $2 == 'D' && $3 == 'Y') {
        	    year = parts[2];
        	    month = parts[0] ? parts[0]-1 : 0;
        	    day = parts[1];
            }
            else if ($1 == 'Y' && $2 == 'M' && $3 == 'D') {
        	    year = parts[0];
        	    month = parts[1] ? parts[1]-1 : 0;
        	    day = parts[2];
            }
            if (year > 0 && year < 100) {
                // in case year is passed in as yy instead of yyyy
            	var thisyear = XDate.today().getFullYear();
            	year = Math.floor(thisyear/100) * 100 + parseInt(year);
            }
            return new XDate(year, month, day);
        }
    }
    return;
}

XDate.prototype.setParseDateFormat = function(format) {XDate.prototype.format = format;};
XDate.prototype.setParseDateFormat('mm/dd/yyyy'); // connect this with config
XDate.parsers.push(parseDate);
// jquery specific date util
if ('undefined' == typeof(exp)){var exp = {};}
if ('undefined' == typeof(exp.core)){exp.core = {};}
if ('undefined' == typeof(exp.core.date)){exp.core.date = {};}

exp.core.date.Calendar = function(_config){
    var Calendar = {
        config:_config,
        rM:[31,28,31,30,31,30,31,31,30,31,30,31],
        getDateFormat:function(){
            return this.config.getDateFormat();
        },
        getDateSeparator:function(){
            return this.config.getDateSeparator();
        },
        getStartOfWeek:function(){
            return this.config.getStartOfWeek();
        },
        getDateFromString:function(t){
            if(!t || !t.length) return null;
            t=t.replace(/\s+/g,"");
            if(t.match(/[^-|\d|\.|\/]/)) return null;
            var rgt=t.split(/-|\.|\//);
            for(var i=0;i<rgt.length;i++) rgt[i]=parseInt(rgt[i],10);
            if(!rgt[1]) return null;
            var m,d,y;
            var fmt=this.getDateFormat();
            if(fmt=="yymmdd")
            {
                if(!rgt[2]) return null;
                m=rgt[1];d=rgt[2];y=rgt[0];
            }
            else
            {
                if(fmt=="mmddyy"){m=rgt[0];d=rgt[1];}
                else{m=rgt[1];d=rgt[0];}//fmt=="ddmmyy"
                if(rgt[2])y=rgt[2];
                else y=this.DefYr(m-1,d);
            }
            var yearNow = new Date().getFullYear();
            m-=1;
            if(y.toString().length===2)y+=2000;
            if(y<yearNow)y=yearNow;
            if(y<1601||y>4500||m<0||m>11||d<1||d>this.getMonthCount(m,y))return null;
            return new Date(y,m,d);
        },
        toStringFromComp: function (d,m,y)
        {
            function pad(s) {
                return s < 10 ? '0' + s : s;
            }
            var out="";
            var ds=this.getDateSeparator();
            var fmt=this.getDateFormat();
            d = pad(d);
            m = pad(m);
            if(fmt=="mmddyy")out=m+ds+d+ds+y;
            else if(fmt=="ddmmyy")out=d+ds+m+ds+y;
            else out=y+ds+m+ds+d;
            return out;
        },
        toStringFromDate: function (dt)
        {
            var out="";
            var ds=this.getDateSeparator();
            var fmt=this.getDateFormat();
            var mm = dt.getMonth() + 1;
            var dd = dt.getDate();
            var yy = dt.getFullYear();
            if(fmt=="mmddyy")out=mm+ds+dd+ds+yy;
            else if(fmt=="ddmmyy")out=dd+ds+mm+ds+yy;
            else out=yy+ds+mm+ds+dd;
            return out;
        },
        IsLY: function (y){
            if(0==y%4&&((y%100!=0)||(y%400==0)))
                return true;
            else
                return false;
        },
        DefYr: function (m,d){
            var dt=new Date();
            var yC=(dt.getYear()<1000)?1900+dt.getYear():dt.getYear();
            if(m<dt.getMonth()||(m==dt.getMonth()&&d<dt.getDate()))yC++;
            return yC;
        },
        getMonthCount: function (m,y){
            var c=this.rM[m];
            if((1==m)&&this.IsLY(y))c++;
            return c;
        },
        IsLastDayOfMonth: function(date){
            return this.getMonthCount(date.getMonth(),date.getFullYear()) == date.getDate();
        },
        incrementMonth: function(date){
            if (date.getMonth() == 11)
            {
                date.setMonth(0);
                date.setFullYear(date.getFullYear() + 1);
            }
            else
            {
                date.setMonth(date.getMonth() + 1);
            }
            return date;
        },
        decrementMonth: function(date){
            if (date.getMonth() == 0)
            {
                date.setMonth(11);
                date.setFullYear(date.getFullYear() - 1);
            }
            else
            {
                date.setMonth(date.getMonth() - 1);
            }
            return date;
        }
    }
    return Calendar;
};


exp.core.date.DateUpdater = function(_calendar, _config){
    var me;
    var DateUpdater = {
        config:_config,
        calendar:_calendar,
        /*  Due to the calendar behaviour, the parameter 'c', when set, will act as a lower offset limit to the return date.
         As several pages depend on this behaviour, a non-limiting prefill is carried out via the 'defaultLengthOfStay' parameter    */
        register:function(objFrom,objTo,c,greyOutPreviousDays,greyOutPostDays,defaultLengthOfStay){
            c = c || 0;
            var $objFrom = $(objFrom);
            var dt1 = this.calendar.getDateFromString($objFrom[0].value);
            var $objTo = $(objTo);
            var dt2 = this.calendar.getDateFromString($objTo[0].value);

            var ds=this.calendar.getDateSeparator();
            var fmt=this.calendar.getDateFormat();
            var format = fmt.substring(0,2) + ds + fmt.substring(2,4) + ds + fmt.substring(4,6);

            var currentDateValue = new Date();
            currentDateValue.setHours(0,0,0,0);

            if(dt1 && dt1.valueOf() < currentDateValue.valueOf()){
                $objFrom[0].value = format;
            }
            if (dt2 && dt2.valueOf() < currentDateValue.valueOf()){
                $objTo[0].value = format;
            }

            me = this;
            var fn = function(){me.update("#"+objFrom.id, "#"+objTo.id, c, greyOutPreviousDays, defaultLengthOfStay);};
            var fn2 = function(){me.updateByNights($objFrom[0], $objTo[0], c); me.update($objFrom[0], $objTo[0], c, greyOutPreviousDays);};

            $("body").on("blur",  "#"+objFrom.id, fn);
            $("body").on("focus", "#"+objFrom.id, fn);
            $("body").on("blur",  "#"+objTo.id, fn);
            $("body").on("focus", "#"+objTo.id, fn);

            var $stayNights = $("#"+objFrom.id+"-stay-nights");
            if ($stayNights.length != 0) {
                $stayNights.change(fn2);
                $stayNights.keypress(fn2);
            }

        },
        days_between: function (date1, date2) {

            var ONE_DAY = 1000 * 60 * 60 * 24

            var date1_ms = date1.getTime()
            var date2_ms = date2.getTime()

            var difference_ms = Math.abs(date1_ms - date2_ms)

            return Math.round(difference_ms/ONE_DAY)
        },
        updateNumberOfNights: function (from,to){

            var nightsField = document.getElementById('hot-sear-date-num-nights');
            if(this.config != undefined && nightsField != null)
            {
                var nightText = this.config.getNightTextConfig();
                var days = this.days_between(to, from);
                if(days > 1) nightsField.innerHTML = days + " " + nightText[1];
                else nightsField.innerHTML = nightText[0];
                nightsField.style.display = "inline";
            }
        },
        updateDayName: function (obj, date){
            var $dayField = $("#"+obj.id+"-day");
            if (this.config != undefined && $dayField.length != 0) {
                try {
                    var index = date.getDay();
                    if (index == undefined) {
                        $dayField.html("");
                        return;
                    }
                    var names = this.config.getDayNames();
                    $dayField.html(names[index]);
                } catch(err) {
                    $dayField.html("");
                }
            }
        },
        updateByNights: function (objFrom, objTo, c) {
            var dt1 = this.calendar.getDateFromString($(objFrom).val());
            var $stayNights = $("#"+objFrom.id+"-stay-nights");
            if (dt1) {
                dt1.setDate(dt1.getDate() + parseInt($stayNights.get(0).value));
                $(objTo).val(this.calendar.toStringFromComp(dt1.getDate(),dt1.getMonth()+1,dt1.getFullYear()));
            }
        },
        update: function (objFrom, objTo, c, greyOutPreviousDays, defaultLengthOfStay) {
            var $objFrom = $(objFrom);
            var $objTo = $(objTo);
            var dt1 = this.calendar.getDateFromString($objFrom.val());
            var dt2 = this.calendar.getDateFromString($objTo.val());
            var $stayNights = $("#"+objFrom.id+"-stay-nights");
            c = $objFrom.attr('data-min-booking-length') || $objFrom.closest('[data-control="datepicker"]').attr('data-min-range-length') || 0;

            // No prefill if the return date is already set or no default value given
            if (!defaultLengthOfStay || isNaN(parseInt(defaultLengthOfStay)) || dt2) {
                defaultLengthOfStay = 0;
            }

            this.updateDayName(objFrom,dt1);
            this.updateDayName(objTo,dt2);

            // Update number of nights - AB Test
            if(dt1 && dt2)
            {
                this.updateNumberOfNights(dt1,dt2);
            }

            if (dt1)
            {
                //set the correct number of nights from the drop down
                if (dt2 && $stayNights.length != 0) {
                    var nights = Math.round((dt2-dt1)/1000/60/60/24);
                    if (nights < 1) nights = $stayNights.get(0).value;
                    $stayNights.get(0).value = nights;
                }

                // The return date will be prefilled with the given default offset or the minimum if no default given
                var returnDateOffset = Math.max(c, defaultLengthOfStay);
                dt1 = new Date(dt1.valueOf() + 1000 * 3600 * 24 * returnDateOffset);
                var dt1Value = this.calendar.toStringFromComp(dt1.getDate(),dt1.getMonth()+1,dt1.getFullYear());

                if (dt2 && dt2 <= dt1) dt2 = null;
                //if the return date  is earlier than departure date fill in the inputfield value
                if (null==dt2 && ($objTo.attr('data-optional') != "true" || $objTo.val() != "")){
                    // Update number of nights - AB Test
                    dt2 = this.calendar.getDateFromString($objFrom.val());
                    this.updateNumberOfNights(dt2,dt1);

                    //if the nights dropdown is set to more than 1 then the checkout date will be corrected
                    if ($stayNights.length != 0 && $stayNights.get(0).value != 1) {
                        dt1.setDate(dt1.getDate() + parseInt($stayNights.get(0).value)-1);
                        var dt1Value = this.calendar.toStringFromComp(dt1.getDate(),dt1.getMonth()+1,dt1.getFullYear());
                    }

                    if (dt1Value != $objTo.val()) {
                        $objTo.val(dt1Value);
                        $objTo.blur();
                    }
                    if(exp.core.date.datePicker){
                        exp.core.date.datePicker.entries[$objTo.attr('id')].currentValue = dt1;
                    }

                    this.updateDayName(objTo,dt1);
                }
            }
            if($objFrom.is('.fieldDefaultText')) {
                $objFrom.removeClass('fieldDefaultText');
            }
            if($objTo.is('.fieldDefaultText')) {
                $objTo.removeClass('fieldDefaultText');
            }


            //the following functions check whether the placeholder polyfill is being used if it is it checks if
            //the input is in a placeholder state or not and updates the class on the input accordingly.
            if (typeof uitk !== "undefined") {
                uitk.updatePlaceholderClass($objFrom);
                uitk.updatePlaceholderClass($objTo);
            }
        }
    }
    return DateUpdater;
}


exp.core.date.CalendarControl = function (){
    var date = function ()
    {
        var m_fmt = 'mmddyy';
        var m_sep = '/';
        var m_sow = 0;
        var m_months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
        var m_singleMonths = ['JAN','FEV','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];
        var m_dayNames = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
        var m_dayAbbrs = ['S','M','T','W','T','F','S'];
        var m_closeText = 'Close';
        var m_locale = '';
        var m_nightText = ['night', 'nights'];

        var setNightTextConfig = function (nightText)
        {
            m_nightText = nightText;
        };

        var setFormatConfig = function (fmt, sep)
        {
            m_fmt = fmt;
            m_sep = sep;
        };

        var setUnitConfig = function (sow, months, dayAbbrs, dayNames)
        {
            m_sow = sow;
            m_months = months;
            m_dayAbbrs = dayAbbrs;
            if (dayNames != undefined) {
                m_dayNames = dayNames;
            }
        };

        var setSingleUnitConfig = function (sow, months, dayAbbrs)
        {
            m_sow = sow;
            m_singleMonths = months;
            m_dayAbbrs = dayAbbrs;
        };

        var setTextConfig = function (closeText)
        {
            m_closeText = closeText;
        };

        var setLocaleConfig = function (locale)
        {
            m_locale = locale;
        };

        return {
            setFormatConfig: setFormatConfig,
            setUnitConfig: setUnitConfig,
            setSingleUnitConfig: setSingleUnitConfig,
            setTextConfig: setTextConfig,
            setLocaleConfig: setLocaleConfig,
            setNightTextConfig: setNightTextConfig,
            getDateFormat: function () {return m_fmt;},
            getDateSeparator: function () {return m_sep;},
            getStartOfWeek: function () {return m_sow;},
            getMonths: function () {return m_months;},
            getSingleMonths: function () {return m_singleMonths;},
            getDayAbbrs: function () {return m_dayAbbrs;},
            getDayNames: function () {return m_dayNames;},
            getCloseText: function () {return m_closeText;},
            getLocaleConfig: function () {return m_locale;},
            getNightTextConfig: function () {return m_nightText;}
        };
    }
    return {Config: new date('ddmmyy', '.', 2)};
}();

/* global window, dctk, Modernizr */

define('gc/core', [
    'gc/dataModels',
    'gc/preferredAirlines',
    'gc/Submit',
    'gc/wizardActionBinder',
    'gc/localStorage',
    'gc/importedState',
    'gc/searchExperiments',
    'handlebars.runtime',
    'gc/typeaheadConfig',
    'gc/abTest',
    'gc/getLob',
    'gc/conf',
    'gc/errorLogging',
    'gc/perfLogging',
    'jquery',
    'gc/wizardHelpers',
    'gc/carHelpers'
], function(
    dataModels,
    preferredAirlines,
    Submit,
    wizardActionBinder,
    localStorage,
    importedState,
    searchExperiments,
    Handlebars,
    typeaheadConfig,
    abTest,
    getLob,
    conf,
    errorLogging,
    perfLogging,
    $,
    wizardHelpers,
    carHelpers
){
    function initCal(config) {
        try {
            var datePickerCalConfig = exp.core.date.CalendarControl.Config;
            datePickerCalConfig.setFormatConfig(config.get('calendar.format.date'), config.get('calendar.format.delimiter'));
            datePickerCalConfig.setUnitConfig(config.get('calendar.unit.sow'), config.get('calendar.unit.month'), config.get('calendar.unit.day'), config.get('calendar.unit.dayNames'));
            datePickerCalConfig.getSingleMonths(config.get('calendar.unit.sow'), config.get('calendar.unit.singleMonths'), config.get('calendar.unit.day'));
            datePickerCalConfig.setTextConfig(config.get('calendar.text.close'));
            datePickerCalConfig.setNightTextConfig(config.get('calendar.text.nights'));

            uitk.datePickerCalendarObj  = exp.core.date.Calendar(datePickerCalConfig);
            uitk.dateUpdater = exp.core.date.DateUpdater(uitk.datePickerCalendarObj , datePickerCalConfig);
        } catch (e) {
            errorLogging.logError(e, 'wizard', 'gc/core', 'initCal');
        }
    }

    shiftFocus = function(element, delay) {
        window.setTimeout(
            function() {element.focus();},
            delay || 0
        );
    }//shiftFocus

    focusTextToEnd = function(element) {
        var isIE = !!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g) || !!navigator.userAgent.match(/Edge/g);
        if(isIE) {
            var self = element;
            setTimeout(function() {
                var element = document.getElementById(self.get(0).id);
                var inputElement = element.getElementsByTagName('input')[0];
                element.focus();
                inputElement.focus();
                var elementVal = inputElement.value;
                inputElement.value = '';
                inputElement.value = elementVal;
            }, 10);
        }

        else {
            element.focus();
            element.find('input').focus();
            var $eleVal = element.find('input').val();
            element.find('input').val('').val($eleVal);
            return element;
        }
    }

    return {
        dataModels: dataModels,
        $wizardWrapper: function() {
            return $('div[data-wizard-action=search-wrapper]');
        },
        $wizardFormWrapper: function() {
            return $('div[data-wizard-action=form-wrapper]');
        },
        init : function() {
            try {
                $('#WizardHero').addClass('core-wizard-loaded').attr('role', 'main');
                dataModels.update(conf);

                dataModels.state.set(importedState.importData(), {silent: true});

                this.setSelectValues();
                this.bindStateChangeEvents(dataModels.state);
                dataModels.state.on('reloadWizard', _.bind(this.reloadWizard,this));

                //Reset the state attributes related to Typeahead once the wizard is initialized
                searchExperiments.resetTypeaheadState(dataModels.state);

                this.reloadWizard();

                return this;
            } catch (e) {
                errorLogging.logError(e, 'wizard', 'gc/core', 'init');
            }
        },//init

        setSelectValues : function() { // changes display of select elements to match data-select-value
            $("select[data-select-value]").each(function(){
                if ($(this).find("option[value='" + $(this).attr("data-select-value") + "']").length) { // if the data-select-value set exists as an option...
                    $(this).val($(this).attr("data-select-value")); // set the current value to it
                }
            });
        },//setSelectValues

        hideDropdown : function() { // force hiding of pop-up dropdown
            $(".DropDownCon").hide();
        },

        hideCalendars : function() { // force hiding of pop-up calendars
            $(".uitk-tooltip.theme-calendar").hide();
            if (abTest.get(6655).value == 1) $(".uitk-tooltip.theme-calendar-button").hide();
        },//hideCalendars

        // Wizard renders before UITK loads
        // But we need to wire up events after UITK loads
        // This function is called once the UITK loads
        uitkLoaded : function(uitk, Typeahead) {
            try {
                // set up all wizard events
                this.subscribeEvents.call(this, dataModels.state);
                this.bindEvents.call(this);
                wizardActionBinder.bindActions(this.$wizardWrapper(), dataModels.state, uitk);
                Submit.setUitk(uitk);


                // wire up search button onclick
                $('#new-homepage-search-wizard').on(uitk.clickEvent, 'button[type=submit]', _.bind(function(e) {
                    e.preventDefault();
                    wizardActionBinder.bindOpenSearchSubmitAction(this.$wizardWrapper(), dataModels.state, uitk);
                    this.submit();
                }, this));

                // set up media quierys
                uitk.mediaquery.register('(min-width: 320px) and (max-width: 491px)', 'wizard-not-desktop');
                uitk.mediaquery.register('(min-width: 492px)', 'wizard-min-desktop');

                preferredAirlines.setPreferredAirlines();
                dataModels.state.set('isInitialized', true);
                dataModels.state.set('initConfigDone', true);

                // setup typeahead and calendar
                Typeahead.init(typeaheadConfig);
                initCal(dataModels.config);

                // Hotel Specific wiring
                $("body").on(uitk.clickEvent, ".cal a", function(e) {
                    'use strict';
                    corewizard.helpers.unCheckNoDates();
                });

                $("body").on("keypress", "#hotel .check-in-out", function(e) {
                    'use strict';
                    corewizard.helpers.unCheckNoDates();
                });

                //and trigger change to run the above once on page load in case checkbox is pre-checked
                $('[data-wizard-type="noDate"]').trigger('change');

                uitk.subscribe('calendar.selectDate', function(topic, data){
                    'use strict';
                    if (!(window.isTablet && site_id == 1)) { // MAIN-124644
                        if (corewizard.helpers.elementIsHotelDepartingField(data.element)) {
                            corewizard.helpers.openCalendarField('endDate');
                        }
                    }
                });

                uitk.subscribe('corewizard.state.update.packages.flight:packages.hotel:packages.car', function(topic, data) {
                    uitk.publish("corewizard.state.update.changeTab", {'field':$('#tab-package-tab')});
                });

            } catch (e) {
                errorLogging.logError(e, 'wizard', 'gc/core', 'uitkLoaded');
            }
        },

        writeHtmlToContainer : function(html) {
            var container;
            container = this.$wizardWrapper();

            // make sure the DOM element is created already, otherwise wait a little
            if (container) {
                run();
            } else {
                setTimeout(function() {
                    container = this.$wizardWrapper();
                    run();
                }, 10);
            }

            function run() {
                if ($('html').hasClass('ie8')) {
                    container.html(html);
                } else {
                    if (!this.contentNode) {
                        container.html(html);
                        this.contentNode = container.children()[0];
                        perfLogging.responseToPaint();
                    } else {
                        morphdom(this.contentNode, html);
                    }
                }
            }
        },

        //track events when car driver age checkbox status change
        isDriverAgeCheckboxStatusChanged: function(state, key){
            if(dataModels.model.get('isCarDriverAgeWithinLimit') === true){
                //send omniture event based on the tab where the checkbox status changed
                if(state.get('tab') === 'car'){
                    this.trackDctkEvent('DriverAgeCheckboxChecked', 'HP.CAR.Age.Checked');
                }
                else if(state.get('tab') === 'package' || state.get('tab') === 'flight' || state.get('tab') === 'hotel'){
                    var lob = getLob(state.get('tab'), state.get('packages'));
                    switch(lob) {
                        case 'hotelCar' : this.trackDctkEvent('DriverAgeCheckboxChecked', 'HP.PKG.HC.Age.Checked');break;
                        case 'flightHotelCar' : this.trackDctkEvent('DriverAgeCheckboxChecked', 'HP.PKG.FHC.Age.Checked');break;
                        case 'flightCar' : this.trackDctkEvent('DriverAgeCheckboxChecked', 'HP.PKG.FC.Age.Checked');break;
                    }

                }
            }
            else{
                //send omniture event based on the tab where the checkbox status changed
                if(state.get('tab') === 'car'){
                    this.trackDctkEvent('DriverAgeCheckboxUnchecked', 'HP.CAR.Age.Unchecked');
                }
                else if(state.get('tab') === 'package' || state.get('tab') === 'flight' || state.get('tab') === 'hotel'){
                    var lob = getLob(state.get('tab'), state.get('packages'));
                    switch(lob) {
                        case 'hotelCar' : this.trackDctkEvent('DriverAgeCheckboxUnchecked', 'HP.PKG.HC.Age.Unchecked');break;
                        case 'flightHotelCar' : this.trackDctkEvent('DriverAgeCheckboxUnchecked', 'HP.PKG.FHC.Age.Unchecked');break;
                        case 'flightCar' : this.trackDctkEvent('DriverAgeCheckboxUnchecked', 'HP.PKG.FC.Age.Unchecked');break;
                    }
                }
            }
        },

        //track event when car driver age tooltip clicked
        driverAgeTooltipClicked: function(state, key){
            //send omniture event based on the tab where the checkbox status changed
            if(state.get('tab') === 'car'){
                this.trackDctkEvent('DriverAgeTooltipClicked', 'HP.CAR.Age.Tooltip');
            }
            else if(state.get('tab') === 'package' || state.get('tab') === 'flight' || state.get('tab') === 'hotel'){
                var lob = getLob(state.get('tab'), state.get('packages'));
                switch(lob) {
                    case 'hotelCar' : this.trackDctkEvent('DriverAgeTooltipClicked', 'HP.PKG.HC.Age.Tooltip');break;
                    case 'flightHotelCar' : this.trackDctkEvent('DriverAgeTooltipClicked', 'HP.PKG.FHC.Age.Tooltip');break;
                    case 'flightCar' : this.trackDctkEvent('DriverAgeTooltipClicked', 'HP.PKG.FC.Age.Tooltip');break;
                }
            }


        },

        reloadWizard : function(state, key) {
            try {
                //For instances where packages and tab change, don't double render!
                if (dataModels.state.hasChanged('packages') && dataModels.state.hasChanged('tab') && key === 'tab') {
                    return;
                }
                if (dataModels.state.hasChanged('packages') || dataModels.state.hasChanged('tab')) {
                    dataModels.state.set('validation', {});
                }
                var lobToLoad = dataModels.model.get('config.template');
                if (typeof lobToLoad === 'function') lobToLoad = lobToLoad(dataModels.model);

                if (!lobToLoad) {
                    window.console &&
                    console.warn &&
                    console.warn('LOB template name is not defined. Check config for LOB.');
                    return false;
                } else if (!Handlebars.partials[lobToLoad]) {
                    window.console &&
                    console.error &&
                    console.error('Template named "' + lobToLoad + '" does not exist. Check LOB\'s config.template');
                    return false;
                } else {
                    //render the wizard.
                    var context = dataModels.viewModel.toJSON();
                    this.writeHtmlToContainer(Handlebars.partials['corewizard/layouts/wizard-hbs'](context));
                    if (typeof uitk !== 'undefined') {
                        uitk.publish('corewizard.wizardReloaded');
                    }

                    //Set TA callback
                    var taElement = $("[data-provide='utypeahead']");
                    if (taElement) {
                        taElement.data('onItemSelected',typeaheadConfig.typeahead.hotel.utaSelectionCallback);
                        taElement.data('onInputEdited',typeaheadConfig.typeahead.hotel.inputEditCallback);
                    }
                }

                this.$wizardFormWrapper = $('div[data-wizard-action=form-wrapper]');
                this.handleKeyBoardFocus();
                this.hideCalendars();
                this.hideDropdown();
                this.setSelectValues();
                this.updateErrorLinks(context);
                if (typeof uitk !== 'undefined' && uitk.initCalendarInputs) {
                    uitk.prepFields();
                    this.setNumberOfHotelNights();
                    this.setTabStateOnWizardContainer();
                    //MAIN-123105 AB 5423 Event used by loyalty to show/hide hotel coupon msg
                    uitk.publish("corewizard.tabsReloaded", getLob(dataModels.model.get('tab'), dataModels.model.get('packages')));
                    uitk.mediaquery.register('(min-width: 320px) and (max-width: 491px)', 'wizard-not-desktop');
                    uitk.mediaquery.register('(min-width: 492px)', 'wizard-min-desktop');
                }
            } catch (e) {
                errorLogging.logError(e, 'wizard', 'gc/core', 'reloadWizard');
            }
        },

        updateErrorLinks : function(context) {
            var $elError = $('.alert-error.validation-alert');
            if (! $elError) return;

            function linkDateErrorMessage(errorClass, startId, endId) {
                el = $(errorClass);
                if (el) {
                    if ($(startId).hasClass('error')) el.attr('href', startId);
                    else el.attr('href', endId);
                }
            }
            function linkErrorMessage(errorClass, field, isId) {
                el = $(errorClass);
                if (el) {
                    var id = (isId) ? field : '#' + $(field).attr('id');
                    el.attr('href', id);
                }
            }
            function setErrorMessageClickToFocus($elError) {
                $elError.find('ul > li > a').on('click', function(e) {
                    e.preventDefault();
                    var $target = $($(this).attr('href'));
                    setTimeout(function() {
                        $target.select();
                        uitk.utils.focusElement($target);
                    });
                });
            }

            var tab = context.tab;
            var multiDest = context.multidest && context.multidest[0] && context.multidest[0].isMultiDest ;
            var el;
            if (tab == 'flight') {
                linkDateErrorMessage('.dateBlankMessage', '#flight-departing', '#flight-returning');
                linkDateErrorMessage('.partialStayDatesOutOfRange', '#flight-hotel-checkin','#flight-hotel-checkout');
                linkErrorMessage('.numberOfTravellersMessage', '[data-wizard-owner=adults].error:first');
                linkErrorMessage('.childAgeMessage', '#flight-passengers .invalid select:first');
                linkErrorMessage('.multiDestDateErrorMessage', '.calendar.departing.invalid:first input');

                // fix for WCAG-2025
                if (multiDest){
                    linkErrorMessage('.destinationError', '.multi-dest-error');
                    linkErrorMessage('.originError', '.multi-dest-error');
                    linkErrorMessage('.dateBlank', '.calendar.departing.invalid:first input');
                }
            }
            else if (tab == 'hotel') {
                linkDateErrorMessage('.dateBlankMessage', '#hotel-checkin', '#hotel-checkout');
                linkErrorMessage('.numberOfTravellersMessage', '[data-wizard-owner=adults].error:first');
                linkErrorMessage('.childAgeMessage', '.children-fieldset .invalid select:first');
            }
            else if (tab == 'package') {
                linkDateErrorMessage('.partialStayDatesOutOfRange', '#package-checkin','#package-checkout');
                linkErrorMessage('.numberOfTravellersMessage', '[data-wizard-owner=adults].error:first');
                linkErrorMessage('.childAgeMessage', '.children-fieldset .invalid select:first');
            }
            else if (tab == 'car') {
                linkErrorMessage('.destinationError', '#car-pickup', true);
                linkDateErrorMessage('.dateBlankMessage', '#car-pickup-date', '#car-dropoff-date');
            }
            else if (tab == 'activity') {
                linkDateErrorMessage('.dateBlankMessage', '#activity-start', '#activity-end');
            }else if (tab == 'rail') {
                linkErrorMessage('.childAgeMessage', '.children-fieldset .invalid select:first');
                linkErrorMessage('.railYouthAgeMessage', '.youths-fieldset .invalid select:first');
                linkErrorMessage('.railSeniorAgeMessage', '.seniors-fieldset .invalid select:first');
            }

            // fix accessibility out of focus issue
            setErrorMessageClickToFocus($elError);

            // Adding visually hidden for multi destination error fields to let user know on which field error was thrown.
            $('.multi-dest-error').each(function() {
                $(this).before("<span class='visuallyhidden'>Error on field " + this.id + ". Please correct the error." );
            });
        },

        trackLobClick: function (state) {
            var lob;
            if(carHelpers.isHotelAttachedWithCar(dataModels.model)) {
                lob = "hotelAttachedWithCar";
            }
            else {
                lob = getLob(dataModels.model.get('tab'), dataModels.model.get('packages'));
            }

            var lobOmnitureMap = {
                'flight'          : 'HP.RB.FLIGHT',
                'hotel'           : 'HP.RB.HOTEL',
                'domesticHotel'   : 'HP.RB.DOMESTIC.HOTEL',
                'overseaHotel'    : 'HP.RB.OVERSEA.HOTEL',
                'flightHotel'     : 'HP.RB.FLIGHT:HOTEL',
                'flightHotelCar'  : 'HP.RB.FLIGHT:HOTEL:CAR',
                'flightCar'       : 'HP.RB.FLIGHT:CAR',
                'hotelCar'        : 'HP.RB.HOTEL:CAR',
                'car'             : 'HP.RB.CAR',
                'activity'        : 'HP.RB.LX',
                'cruise'          : 'HP.RB.CRUISE',
                'threePP'         : 'HP.RB.3P.FLIGHT:HOTEL',
                'buses'           : 'HP.RB.RedBus',
                'rentalCars'      : 'HP.RB.RENTAL:CAR',
                'airportRides'    : 'HP.RB.AIRPORT:RIDE ',
                'lxThingsTodo'    : 'HP.RB:LXTHINGSTODO',
                'lxAirportRides':   'HP.RB:LXAIRPORTRIDE',
                'vacationRentals' : 'HP.RB.VACATIONRENTAL',
                'openSearch'      : 'HP.RB.OPENSEARCH',
                'hotelAttachedWithCar' : 'HP.RB.CAR:HOTEL',
                'rail' : 'HP.RB.RAIL'
            };

            this.trackDctkEvent('RFRR Action Link', lobOmnitureMap[lob]);
        },

        trackLobClickDelayed: function() {
            setTimeout(_.bind(this.trackLobClick, this), 0);
        },

        handleKeyBoardFocus: function (model) {
            if (typeof uitk !== 'undefined') {
                var model = dataModels.model,
                    tab = model.get('tab'),
                    currentActiveElementId = dataModels.state.get("activeElement"),
                    $currentActiveElement = $('#' + currentActiveElementId),
                    lastActiveElementId = dataModels.state._previousAttributes.activeElement,
                    $lastActiveElement = $('#' + lastActiveElementId);
                //Fix accessibility bug for WCAG-2019
                if($currentActiveElement.length>0 && $currentActiveElement.is('input[type="radio"]'))
                    $currentActiveElement.focus();

                if ($lastActiveElement.is('a')) {
                    var activeElementHref = $lastActiveElement.attr('href');

                    if (!$lastActiveElement.hasClass('open')) {
                        uitk.utils.focusElement($lastActiveElement);
                    } else {
                        uitk.utils.focusElement($(activeElementHref.substring(activeElementHref.indexOf('#'))));
                    }
                }

                if($('select' + lastActiveElementId)) {
                    uitk.utils.focusElement($lastActiveElement);
                }

                if ( $lastActiveElement.attr('data-package-wrapper') ) {
                    var packageWrapper = $lastActiveElement.attr('data-package-wrapper');
                    uitk.utils.focusElement($lastActiveElement);
                }

            }

        },

        setTabStateOnWizardContainer : function() {
            var activeTab = getLob(dataModels.model.get('tab'), dataModels.model.get('packages')),
                wizardContainer = document.getElementById('new-homepage-search-wizard');
            $(wizardContainer).attr('data-active-tab', activeTab + '-tab-active');
        },//setTabStateOnWizardContainer

        tabOverrideLinksStopPropagation : function() {
            if (typeof corewizard.masterconfig.tabOverrideLinks == 'undefined') return;
            var lobs = _.keys(corewizard.masterconfig.tabOverrideLinks);
            $.each(lobs, function(index, value) {
                $("#tab-"+value+"-tab").click(function(e){
                    e.stopPropagation();
                });
            });
        }, //tabOverrideLinksStopPropagation

        setNumberOfHotelNights: function(model) {
            var model = dataModels.model,
                hotelStartDate = model.get('startDate'),
                hotelEndDate = model.get('endDate')||'',
                dateDifference,
                daysToNights;

            if (hotelStartDate) {
                hotelStartDate = new XDate(hotelStartDate),
                    hotelEndDate = new XDate(hotelEndDate),
                    dateDifference = hotelStartDate.diffDays(hotelEndDate),
                    daysToNights = dateDifference - 1;
                dataModels.state.set('hotelLengthOfStay', daysToNights);
            }
        },

        subscribeEvents : function() {
            $('#tab-package-tab').parent().hover(
                function() {
                    if (!$('#tab-package-tab').hasClass('on')) {
                        $('#pkg-tab-radio-btns').addClass('hover');
                        $('#tab-package-tab').addClass('hover');
                    }
                },
                function() {
                    $('#pkg-tab-radio-btns').removeClass('hover');
                    $('#tab-package-tab').removeClass('hover');
                }
            );
            $('#tab-package-tab').parent().click(
                function() {
                    $('#pkg-tab-radio-btns').removeClass('hover');
                    $('#tab-package-tab').removeClass('hover');
                }
            );
            this.tabOverrideLinksStopPropagation();

            $("body").on("change", "#car-pickup", _.bind(function() {
                dataModels.state.set('carSearchType', 4);
                //If pickup searchTerm changed, then remove searchParameters
                dataModels.state.set('originRegionId', null);
                dataModels.state.set('originLatitude', null);
                dataModels.state.set('originLongitude', null);
            }, this));

            $("body").on("change", "#car-dropoff", _.bind(function() {
                //If dropoff searchTerm changed, then remove searchParameters
                dataModels.state.set('destinationRegionId', null);
                dataModels.state.set('destinationLatitude', null);
                dataModels.state.set('destinationLongitude', null);
            }, this));


            dataModels.state.on('change:origin', function(state) {
                var model = dataModels.model;
                var value = model.get('origin');
                if (model.get('originFromFlightTA') && model.get('originFromFlightTA') != $.trim(value)) {
                    state.set('originTLA', null);
                    state.set('originFromFlightTA', null);
                    state.set('OMOriginTA', false);
                }
                if (model.get('originFromTA') && (model.get('originFromTA') != $.trim(model.get('origin')))) {
                    state.set('originTLA', null);
                    state.set('originFromTA', null);
                    state.set('OMOriginTA', false);
                }
            }, this);

            if(abTest.get(11873).value === 1){
              function addLabel(){
                  var $datepicker = $('.datepicker-trigger-input');
                  if($datepicker.val() !== ""){
                    $datepicker.prev(".label").addClass('show');
                  }
              }

              dataModels.state.on('change:startDate', function(state) {
                  addLabel();
              }, this);

              dataModels.state.on('change:checkin', function(state) {
                  addLabel();
              }, this);

            }


            dataModels.state.on('change:destination', function(state) {

                var model = dataModels.model;
                var value = model.get('destination');

                if (model.get('OMDestinationTACompare') && model.get('OMDestinationTACompare') != $.trim(model.get('destination'))) {
                    //null out TA
                    state.set('OMDestinationTA', false);
                }

                state.set('regionName', null);
                if (!model.get('destinationFromTA') || (model.get('destinationFromTA') && model.get('destinationFromTA') != $.trim(model.get('destination')))) {
                    state.set('destinationTLA', null);
                    state.set('hotelId', null);
                    state.set('multiCityRegion', null);
                    state.set('regionId', null);
                    state.set('latLong', null);
                    state.set('destinationFromTA', null);
                    state.set('OMDestinationTA', false);
                    state.set('TASearchType', null);
                }
                if (model.get('originFromTA') && model.get('originFromTA') != $.trim(model.get('origin'))) {
                    state.set('originTLA', null);
                    state.set('originFromTA', null);
                    state.set('OMOriginTA', false);
                }
            }, this);
        },//subscribeEvents

        bindEvents : function() {

            function clearField(fieldtype, flighttype, target, tab){
                fieldtype = fieldtype.toLowerCase();
                flighttype = flighttype.toLowerCase();
                target = target.toLowerCase();
                tab = tab.toLowerCase();
                function setNormalState(){
                    dataModels.state.set(fieldtype,'');
                    dataModels.state.set(fieldtype + 'FromTA','');
                    dataModels.state.set(fieldtype + 'TLA','');
                    if(flighttype === 'origin') dataModels.state.set('userTypedQuery','');
                }
                function setMultidestState(){
                    var currentMultidest = dataModels.state.get('multiDest'),
                        indexToRemove = parseInt(target.match(/\d/g)) - 2,
                        newMultidestOrigin = [],
                        newMultidestDestination = [];
                    _.each(currentMultidest.origin, function (origin, index) {
                        newMultidestOrigin[index] = origin;
                    });
                    _.each(currentMultidest.destination, function (destination, index) {
                        newMultidestDestination[index] = destination;
                    });
                    if(fieldtype === 'origin'){
                        newMultidestOrigin.splice(indexToRemove,1,'');
                        dataModels.state.set('multiDest.origin' , newMultidestOrigin);
                    }else if(fieldtype === 'destination'){
                        newMultidestDestination.splice(indexToRemove,1,'');
                        dataModels.state.set('multiDest.destination' , newMultidestDestination);
                    }
                }
                if(tab != "flight"){
                    return setNormalState();
                }
                if(flighttype === 'roundtrip' || flighttype === 'oneway') setNormalState();
                else if(flighttype === 'multi'){
                    if(target === 'flight-origin' || target === 'flight-destination') setNormalState();
                    else setMultidestState();
                }
            }

            this.$wizardWrapper().on(uitk.clickEvent, ".icon-close", _.bind(function(e) {
                var target      = $(e.currentTarget).parent().children('label').children('input').attr('id'),
                    flighttype  = dataModels.model.get('flighttype'),
                    tab         = dataModels.model.get('tab');
                if(target.indexOf('origin')>-1){
                    clearField('origin', flighttype, target, tab);
                }else if(target.indexOf('car-pickup')>-1){
                    dataModels.state.set('TASearchType','');
                    dataModels.state.set('tla','');
                    dataModels.state.set('carSearchType','');
                    dataModels.state.set('carPickupValueFromTA','');
                    dataModels.state.set('originRegionId','');
                    dataModels.state.set('originLatitude','');
                    dataModels.state.set('originLongitude','');
                    dataModels.state.set('selectedTASuggestionPosition','');
                    dataModels.state.set('destination','');
                    dataModels.state.set('destinationFromTA','');
                    dataModels.state.set('destinationTLA','');
                }else if(target.indexOf('car-dropoff')>-1){
                    dataModels.state.set('destinationRegionId','');
                    dataModels.state.set('destinationLatitude','');
                    dataModels.state.set('destinationLongitude','');
                    dataModels.state.set('TASearchType','');
                    dataModels.state.set('carDropoffValueFromTA','');
                    dataModels.state.set('selectedTASuggestionPosition','');
                    dataModels.state.set('carReturn','');
                }else{
                    clearField('destination', flighttype, target, tab);
                }
                this.reloadWizard();
            }, this));

            this.$wizardWrapper().on(uitk.clickEvent, '[data-wizard-action]', _.bind(function(e) {
                var target = $(e.target).attr('id');
                dataModels.state.set('activeElement', target);

                if($(e.target).val().length>0){
                    $(e.target).parent().parent().children(".icon-close").removeClass("visuallyhidden");
                }
            }, this));

            //this.$wizardFormWrapper.on("keypress", function(e) {
            //  if (e.which === 13) {
            //    this.$wizardFormWrapper.find('input').each(function(index, element) {
            //      this.applyStateChangeToField($(element));
            //    });
            //    this.reloadTab();
            //    this.submit();
            //  }
            //});

            // re-initialize tooltip trigger event for help icons rendered within handlebars templates.
            this.$wizardWrapper().on(uitk.clickEvent, "[data-control=tooltip]", function(e) {
                $(this).uitk_tooltip('show');
            });

            // placeholder polyfill interferes with styling
            $('html.no-placeholder').find(this.$wizardFormWrapper).on('change', 'input[type=text]', function() {
                if ($(this).val() === "" ) {
                    $(this).val($(this).attr("placeholder"));
                    $(this).addClass("placeholderspolyfill").removeClass('updated');
                }
            });

            // The fix for the Accessibility bug WCAG-956 and WCAG-922 -- IE specific
            if ((window.navigator.userAgent.indexOf('MSIE ') > -1) || (window.navigator.userAgent.indexOf('Trident/') > -1)) {
                this.$wizardWrapper().on("keydown", '.calendar.departing input, .calendar.checkin input', function(e) {
                    if (e.which === 9 && e.shiftKey == false) {
                        e.preventDefault();
                        var next = $(this).attr("data-end-date") || '#flight-adults';
                        $(next).focus().select();
                    }
                });
            }



            $(".site-content-wrap").on("focus", ".hero-form input", function() {
                var $this = $(this);

                //IE needs a timeout to select the text on focus
                if ($('html').hasClass('lt-ie10') || $('html').hasClass('ie10')) {
                    //but it interferes with the uitk calendar widget
                    if ($(this).data('control') !== 'calendar' ) {
                        setTimeout(function() {
                            $this.select();
                        }, 0);
                    }

                } else {
                    $this.select();
                }


                // Fix issue where typeahead is re-triggered on input focus on mobile devices
                if(Modernizr.touch) {
                    $(".uitk-tooltip.theme-typeahead").hide();
                }
                // Work around Chrome's little problem
                $this.mouseup(function() {
                    // Prevent further mouseup intervention
                    $this.unbind("mouseup");
                    return false;
                });
            });
        },//bindEvents

        bindStateChangeEvents: function() {
            var self = this;
            function bindSingleEvent(key, value) {
                if (_.isString(value)) {
                    var fn,
                        scope = self,
                        scopeSplit = value.split('.');
                    //support for strings representing scoped functions.
                    _.each(scopeSplit, function(value, i) {
                        scope = scope[scopeSplit[i]];
                        if (scope == undefined) return;
                    });
                    //if the scoped function exists, use this for binding.
                    if (scope) fn = scope;
                } else if (_.isFunction(value)) {
                    //support for function literals or anonymous functions.
                    fn = value;
                }
                if (_.isFunction(fn)) {
                    if (key === 'tab' || key === 'packages') {
                        //need to add an argument to reloadWizard to check
                        //for double rendering.
                        dataModels.state.on('change:' + key, function (argument) {
                            fn.call(self, argument, key);
                        }, this);
                    } else {
                        dataModels.state.on('change:' + key, fn, this);
                    }
                }
            }

            _.each(dataModels.config.get('events'), function (value, key) {
                //string support so you can define the binding before the function if necessary
                if (_.isArray(value)) {
                    _.each(value, function(v) {
                        bindSingleEvent.call(this, key, v);
                    }, this);
                } else {
                    bindSingleEvent.call(this, key, value);
                }

            }, this);
        },

        submit: function() {
            if(carHelpers.isHotelAttachedWithCar(dataModels.model)){
                this.hideHotelSelectionForCars();
                this.trackDctkEvent('hotel-attach-search', 'HP.RB.CAR:HOTELSEARCH');
            }

            try {
                Submit.submit(dataModels.model);
            } catch (e) {
                errorLogging.logError(e, 'wizard', 'gc/core', 'submit');
            }
        },

        hideHotelSelectionForCars: function(model)
        {
            if((dataModels.model.get('tab') === 'car') && (abTest.get(11100).value == 1))
            {
                //Hide add hotel in case when drop off location is changed
                var dropOffValue = $("#car-dropoff").val();
                var hotelCheckBox = $("#car-add-hotel-checkbox");

                //After checking hotel checkbox when user type in drop off loc
                if(dropOffValue.length > 0 && hotelCheckBox && hotelCheckBox.is(':checked'))
                {
                    hotelCheckBox.trigger('click');
                    $('.organic-package-checkboxes').hide();
                    var currentEle = $("#car-dropoff-label");
                    focusTextToEnd(currentEle);
                    return;
                }

                //User directly type in drop off without selecting checkbox
                if(dropOffValue.length > 0)
                {
                    $('.organic-package-checkboxes').hide();
                    return;
                }

                //User directly type in drop off and clear it
                if(dropOffValue.length == 0)
                {
                    $('.organic-package-checkboxes').show();
                    return;
                }
            }
        },

        trackDctkEvent: function(trackEvent, eventStr) {
            if (window.dctk && dctk.onReady) {
                dctk.onReady(function () {
                    dctk.trackEvent('o', trackEvent, { prop16: eventStr, eVar28: eventStr });
                });
            }
        }

    }
});

define('gc/wizard-api', [
  'gc/confFun',
  'gc/Config',
  'gc/core',
  'gc/dataModels',
  'gc/defaultConfig',
  'gc/errorLogging',
  'gc/wizardConfigFun'
], function(
  confFun,
  Config,
  core,
  dataModels,
  defaultConfig,
  errorLogging,
  wizardConfigFun
){
  /**
   * Defines public APIs that can be called on the wizard.
   * @exports gc/wizard-api
   */
  return {
    /**
     * Updates the page level config on the wizard, clears the state and re-renders it.
     * @param {Object} pageConfig - The new config to initialize the wizard with.
     */
    reInit : function(pageConfig) {
      try {
        var conf = confFun(wizardConfigFun(pageConfig), defaultConfig);

        core.dataModels = core.dataModels.update(conf);

        core.reloadWizard();
      } catch (e) {
        errorLogging.logError(e, 'wizard', 'gc/wizard-api', 'reInit');
      }
    },
    /**
     * Sets the update object on the state.
     * @param {Object} update - An object with properties to update on the state.
     */
    updateState : function(update) {
      try {
        core.dataModels.state.set(update);
      } catch (e) {
        errorLogging.logError(e, 'wizard', 'gc/wizard-api', 'reInit');
      }
    },
    /**
     * Calls the callback and passes the model to it when a property on the state is updated.
     * @param {String} property - The name of the property to listen to.
     * @param {Function} callback - Is called with the model as the parameter.
     */
    onStateChange: function(property, callback) {
      dataModels.state.on('change:' + property, function() {
        try {
          callback(dataModels.model.toJSON());
        } catch (e) {}
      });
    },

    /**
     * Returns the Wizard Model
     */
    getModel: function() {
      return dataModels.model.toJSON();
    }
  }
});

define('gc/predicates', ['xdate'], function(XDate) {
  return {
    isValidDriverAge: function (age) {      
      var age = this.filterInt(age);
      var isValid = (age && age > 17 && age < 100);
      
      return {isValid: isValid};
    },

    filterInt: function (field) {
      if(/^(\-|\+)?([0-9]+|Infinity)$/.test(field))
        return Number(field);
      return NaN;
    },

    isNotBlank: function (field) {
      var isValid = (typeof field == 'string') && (field.length > 0);
      return {isValid: isValid};
    },

    isOriginDiffrentFromDestination: function (origin, destination) {
      var originIsNotBlank = this.isNotBlank(origin);
      var destinationIsNotBlank = this.isNotBlank(destination);
      var isValid = (originIsNotBlank.isValid || destinationIsNotBlank.isValid) ?
        origin !== destination :
        false;
      return {isValid: isValid};
    },

    isValidDate: function (date) {
      var isValid = (date != null && typeof date != "undefined") && (new XDate(date)[0].toString() !== "Invalid Date");
      return {isValid: isValid};
    },

    isValidDateOrBlank: function(date) {
      var isNotBlank = this.isNotBlank(date),
          isValidDate = this.isValidDate(date),
          isValid = (!isNotBlank.isValid || isValidDate.isValid);

      return {isValid: isValid};
    },

    isDateBeforeMaxDate: function (date, maxDate) {
      date = new XDate(date);
      maxDate = new XDate(maxDate);
      var isValid = date.diffDays(maxDate) > 0;
      return {isValid: isValid};
    },

    isPartialDateTest: function (firstDate, secondDate) {
      var firstXDate = new XDate(firstDate);
      var secondXDate = new XDate(secondDate);

      //ensure dates are valid before comparing.
      for (var i = 0; i < arguments.length; i++) {
        var isNotBlank = this.isNotBlank(arguments[i]);
        var isValidDate = this.isValidDate(arguments[i]);
        if (!isNotBlank.isValid) return {isValid: true};
        if (!isValidDate.isValid) return {isValid: true};
      }

      var isValid = firstXDate.diffDays(secondXDate) >= 0;
      return {isValid: isValid};
    },

    isPartialDateWithinRange: function (date, startDate, endDate) {
      var dateX = new XDate(date),
      startXDate = new XDate(startDate),
      endXDate = new XDate(endDate);
      //ensure dates are valid before comparing.
      for (var i = 0; i < arguments.length; i++) {
        var isNotBlank = this.isNotBlank(arguments[i]);
        var isValidDate = this.isValidDate(arguments[i]);
        if (!isNotBlank.isValid) return {isValid: true};
        if (!isValidDate.isValid) return {isValid: true};
      }
      var isValid = (startXDate.diffDays(dateX) >= 0) &&
                  (dateX.diffDays(endXDate) >= 0);

      return {isValid: isValid};
    },

    isDateBeforeMaxDaysOut: function (date, days) {
      var maxDate = new XDate();
      maxDate.addDays(days);
      return this.isDateBeforeMaxDate(date, maxDate);
    },

    isStartDateBeforeEndDate: function (startDate, endDate, minLength) {
      startDate = new XDate(startDate);
      endDate = new XDate(endDate);
      var isValid = (startDate.valid() && endDate.valid()) ?
        (startDate.diffDays(endDate) >= minLength) :
        true;
      return {isValid: isValid};
    },

    isDateAfterCurrentDate: function (date) {
      date = new XDate(date);
      var isValid = (XDate.today().diffDays(date) > 0);
      return {isValid: isValid};
    },

    isDatePriorToCurrentDate: function (date) {
      date = new XDate(date);
      var isValid = (XDate.today().diffDays(date) > -1);
      return {isValid: isValid};
    },

    isDateAfterCurrentDateOrBlank: function (date) {
      var isNotBlank = this.isNotBlank(date),
          isDateAfterCurrentDate = this.isDateAfterCurrentDate(date),
          isValid = (!isNotBlank.isValid || isDateAfterCurrentDate.isValid);

      return {isValid: isValid};
    },

    isTripValidLength: function (startDate, endDate, maxLength) {
      startDate = new XDate(startDate);
      endDate = new XDate(endDate);
      var isValid = (startDate.valid() && endDate.valid()) ?
        (startDate.diffDays(endDate) <= maxLength) :
        true;
      return {isValid: isValid};
    },

    isTripWithTimeValidLongEnough: function (startDate, startTime, endDate, endTime, minHours) {
      'use strict';
      if(startDate!=undefined && endDate!=undefined){
        startDate = new XDate(startDate);
        endDate = new XDate(endDate);
        var days = startDate.diffDays(endDate);
        if (days === 0) {
          startTime = _convertRailsStrTimeToMins(startTime);
          endTime = _convertRailsStrTimeToMins(endTime);
          if ((endTime - startTime) < (minHours * 60)) {
            return {isValid: false};
          }
        }
      }
      else{
        return {isValid: false};
      }
      return {isValid: true};
    },

    isValidPickupTime: function (startDate, startTime) {
      'use strict';
      var minHoursFromCurrentTime = 2;
      startDate = new XDate(startDate);
      startDate.addMinutes(_convertCarStrTimeToMins(startTime));
      var isValid = new XDate().diffHours(startDate) > minHoursFromCurrentTime;
      return {isValid: isValid};
    },

    isTotalTravelersLessThanMax: function (rooms, maxTravelers) {
      var fields = [];
      if (rooms && rooms.length) {
        var count = 0;
        for (var i = 0; i < rooms.length; i++) {
          var room = rooms[i];
          if (room) {
            var adults = parseInt(room.adults, 10);
            if (adults && adults > 0) {
              count += adults;
              fields.push(i + 'a');
            }
            var kids = parseInt(room.childCount, 10);
            if (kids && kids > 0) {
              count += kids;
              fields.push(i + 'c');
            }
          }
        }
        if (count > maxTravelers) {
          return {isValid: false, fields: fields};
        }
      }
      return {isValid: true};
    },

    isRailTotalTravelersLessThanMax: function (rooms, maxTravelers) {
      var fields = [];
      if (rooms && rooms.length) {
        var count = 0;
        for (var i = 0; i < rooms.length; i++) {
          var room = rooms[i];
          if (room) {
            var adults = parseInt(room.adults, 10);
            if (adults && adults > 0) {
              count += adults;
              fields.push(i + 'a');
            }
            var kids = parseInt(room.childCount, 10);
            if (kids && kids > 0) {
              count += kids;
              fields.push(i + 'c');
            }
            var youthSum = parseInt(room.youthCount, 10);
            if (youthSum && youthSum > 0) {
              count += youthSum;
              fields.push(i + 'y');
            }
            var seniorSum = parseInt(room.seniorCount, 10);
            if (seniorSum && seniorSum > 0) {
              count += seniorSum;
              fields.push(i + 's');
            }
          }
        }
        if (count > maxTravelers) {
          return {isValid: false, fields: fields};
        }
      }
      return {isValid: true};
    },

    isRailTotalTravelersZero: function (rooms) {
      var fields = [];
      if (rooms && rooms.length) {
        var adults = parseInt(rooms[0].adults, 10);
        var children = parseInt(rooms[0].childCount, 10);
        var youths = parseInt(rooms[0].youthCount, 10);
        var seniors = parseInt(rooms[0].seniorCount, 10);
        if (adults === 0 && youths === 0 && seniors === 0 && children === 0) {
          fields.push('rail-adults');
          return {isValid: false, fields: fields};
        }
        return {isValid: true};
      }
    },

    isChildAlone: function (rooms) {
      if (rooms && rooms.length) {
        for (var i = 0; i < rooms.length; i++) {
          var room = rooms[i];
          var adults = parseInt(room.adults, 10);
          if (adults && adults > 0) {
            return {isValid: false};
          }
        }
      }
      return {isValid: true};
    },

    isChildAloneAbove13: function (rooms) {
      var fields = [];
      if (rooms && rooms.length) {
          var child = rooms[0].children;
          var result = true;
          if (child && child.length === 1) {
            console.log('single:' + child.length);
          _.each(child, function(value) {
            var adults = parseInt(rooms[0].adults, 10);
            var youths = parseInt(rooms[0].youthCount, 10);
            var seniors = parseInt(rooms[0].seniorCount, 10);
            var childClean = parseInt(value, 10);
            if (adults === 0 && youths === 0 && seniors === 0 && childClean < 13) {
              fields.push('children-age-select-0');
              result = false;
            }
          });
        }
        return {isValid: result, fields: fields};
      }
    },
    isChildTravelingWithChild: function (rooms) {
      var fields = [];
      if (rooms && rooms.length) {
        var child = rooms[0].children;
        var result = true;
        var adults = parseInt(rooms[0].adults, 10);
        var youths = parseInt(rooms[0].youthCount, 10);
        var seniors = parseInt(rooms[0].seniorCount, 10);
          function isOldEnough(element, index, array) {
            return element >= 13;
          }
          if (child && child.length > 1) {
            console.log('multi:'+ child.length);
          var ageCheck = child.every(isOldEnough);
          if (adults === 0 && youths === 0 && seniors === 0 && ageCheck == false) {
            for (var i = 0; i < child.length; i++) {
              fields.push('children-age-select-' + i);
            }
            result = false;
          }
        }
        return {isValid: result, fields: fields};
      }
    },
    railCardCheck: function (rooms, railCards){
      var fields = [];
      var cardTally = _.pluck(railCards, 'count');
      var numClean = _.map(cardTally, function(num){
        return parseInt(num);
      });
      var cardSum = numClean.reduce(add, 0);
      function add(a, b) {
          return a + b;
      }
      for (var r = 0; r < railCards.length; r++) {
        fields.push('railcard-count-select-' + r);
      }
      if (rooms && rooms.length) {
        var count = 0;
        for (var i = 0; i < rooms.length; i++) {
          var room = rooms[i];
          if (room) {
            var adults = parseInt(room.adults, 10);
            if (adults && adults > 0) {
              count += adults;
            }
            var kids = parseInt(room.childCount, 10);
            if (kids && kids > 0) {
              count += kids;
            }
            var youthSum = parseInt(room.youthCount, 10);
            if (youthSum && youthSum > 0) {
              count += youthSum;
            }
            var seniorSum = parseInt(room.seniorCount, 10);
            if (seniorSum && seniorSum > 0) {
              count += seniorSum;
            }
          }
        }
        if (count < cardSum-1) {
          fields.push('railcard-count-select-' + index);
          return {isValid: false, fields: fields};
        }
      }
      return {isValid: true};
    },

    isChildAccompaniedByAdult: function (rooms) {
      var isChildAlone = this.isChildAlone(rooms);
      return {isValid: !isChildAlone.isValid};
    },

    isChildAgesAllProvided: function (rooms) {
      'use strict';
      var fields = [];
      var result = true;
      for (var i = 0; i < rooms.length; i++) {
        var room = rooms[i];
        for (var j = 0; j < room.childCount; j++) {
          if (room.children[j] !== 0 && !room.children[j]) {
            fields.push(i + ':' + j);
            result = false;
          }
        }
      }
      return {isValid: result, fields: fields};
    },

    isRailChildAgesAllProvided: function (rooms) {
      'use strict';
      var fields = [];
      var result = true;
      for (var i = 0; i < rooms.length; i++) {
        var room = rooms[i];
        for (var j = 0; j < room.childCount; j++) {
          if (room.children[j] !== 0 && !room.children[j]) {
            fields.push('children-age-select-' + j);
            result = false;
          }
        }
      }
      return {isValid: result, fields: fields};
    },

    isRailYouthAgesAllProvided: function (rooms) {
      'use strict';
      var fields = [];
      var result = true;
      for (var i = 0; i < rooms.length; i++) {
        var room = rooms[i];
        for (var j = 0; j < room.youthCount; j++) {
          if (room.youths[j] !== 0 && !room.youths[j]) {
            fields.push('youths-age-select-' + j);
            result = false;
          }
        }
      }
      return {isValid: result, fields: fields};
    },

    isRailSeniorAgesAllProvided: function (rooms) {
      'use strict';
      var fields = [];
      var result = true;
      for (var i = 0; i < rooms.length; i++) {
        var room = rooms[i];
        for (var j = 0; j < room.seniorCount; j++) {
          if (room.seniors[j] !== 0 && !room.seniors[j]) {
            fields.push('seniors-age-select-' + j);
            result = false;
          }
        }
      }
      return {isValid: result, fields: fields};
    },

    isRailCardTypeProvided: function (cards) {

      return {isValid: true};
    },

    isRailOriginFromTA: function(originTLA, originFromTA, trainOrigin){
      if((originTLA && (originTLA!=null || originTLA!="")) ||
          (originFromTA && (originFromTA!=null || originFromTA!="")))
      {
        return {isValid: true};
      }
      else if(trainOrigin !== ""){
        return {isValid: false, fields: "rail-origin"};
      }
      else{
        return {isValid: true};
      }
    },

    isRailDestinationFromTA: function(destinationTLA, destinationFromTA, trainDestination){
      if((destinationTLA && (destinationTLA!=null || destinationTLA!="")) ||
          (destinationFromTA && (destinationFromTA!=null || destinationFromTA!="")))
      {
        return {isValid: true};
      }
      else if(trainDestination !== ""){
        return {isValid: false, fields: "rail-destination"};
      }
      else{
        return {isValid: true};
      }
    },

    areAllFlightsComplete: function (multiDest) {
      var result = true;
      var fields = [];
      var errors = [];
      for (var i = 0; i < 4; i++) {
        var allFieldsAreEmpty = this.allFieldsAreEmpty(multiDest.destination[i], multiDest.origin[i], multiDest.startDate[i]);
        if (allFieldsAreEmpty.isValid) {
          //completely empty multiDest, so skip so that result
          //can't be false for this leg.

        } else {
          _.each(multiDest, function (value, key) {
            if (!value[i]) {
              //we're missing one field, this validation now fails.
              fields.push(key + ':' + (i + 2));
              switch (key) {
                case 'origin' :
                  errors.push('origin-blank-' + (i + 2));
                  break;
                case 'destination' :
                  errors.push('destination-blank-' + (i + 2));
                  break;
                case 'startDate' :
                  errors.push('date-blank-' + (i + 2));
                  break;
              }
              result = false;
            }
          });
        }
      }
      return {isValid: result, fields: fields, errors: errors};
    },

    allFieldsAreEmpty: function () {
      var result = true;
      _.each(arguments, function (argument) {
        if (argument) result = false;
      });
      return {isValid: result};
    },

    areAllDatesValid: function (multiDest, startDate) {
      var result = true;
      var fields = [];
      var errors = [];
      for (var i = 0; i < 4; i++) {
        var allFieldsAreEmpty = this.allFieldsAreEmpty(multiDest.destination[i], multiDest.origin[i], multiDest.startDate[i]);
        if (allFieldsAreEmpty.isValid) {
          //completely empty multiDest, so skip so that result
          //can't be false for this leg.
        } else {
          var previousDate;
          if (i < 1) {
            if (startDate === undefined) {
              previousDate = multiDest.startDate[i];
            }
            else {
              previousDate = startDate;
            }
          }
          else {
            previousDate = multiDest.startDate[i - 1];
          }
          var previousXDate = new XDate(previousDate);
          var currentXDate = new XDate(multiDest.startDate[i]);
          var isNotBlank = this.isNotBlank(multiDest.startDate[i]);
          var isValidDate = this.isValidDate(multiDest.startDate[i]);
          if (!isNotBlank.isValid) {
            //check for valid date
            fields.push('startDate:' + (i + 2));
            errors.push('date-blank-' + (i + 2));
            result = false;
          } else if (!isValidDate.isValid) {
            fields.push('startDate:' + (i + 2));
            errors.push('date-format-invalid-' + (i + 2));
            result = false;
          } else if (currentXDate < previousXDate) {
            fields.push('startDate:' + (i + 2));
            errors.push('date-comes-before-previous-' + (i + 2));
            result = false;
          }

        }
      }
      return {isValid: result, fields: fields, errors: errors};
    },

    allOriginsAreDifferentFromDestinations: function (multiDest) {
      var result = true;
      var fields = [];
      var errors = [];
      for (var i = 0; i < 4; i++) {
        if (multiDest.origin[i] && multiDest.origin[i] === multiDest.destination[i]) {
          result = false;
          fields.push('origin:' + (i + 2));
          errors.push('origin-same-' + (i + 2));
        }
      }
      return {isValid: result, fields: fields, errors: errors};
    },

    areAllDatesValidOrBlank: function (startDate, endDate) {
      var isStartDateNotBlank = this.isNotBlank(startDate),
          isEndDateNotBlank = this.isNotBlank(endDate),
          isValidStartDate = this.isValidDate(startDate),
          isValidEndDate = this.isValidDate(endDate),
          isValid = (!isStartDateNotBlank.isValid && !isEndDateNotBlank.isValid) || (isValidStartDate.isValid && isValidEndDate.isValid);

      return {isValid: isValid};
    }
  };

  function _convertCarStrTimeToMins(time) {
    var pm = time.indexOf('PM') > -1;
    var min = parseInt(time.slice(-4, -2));
    var hour = parseInt(time.slice(0, -4));
    hour = (pm && hour != 12) ? hour + 12 : hour;
    return (hour * 60) + min;
  }
  function _convertRailsStrTimeToMins(time) {
    var hour = parseInt(time.slice(0, 2));
    var min = parseInt(time.slice(2, 4));
    return (hour * 60) + min;
  }
});

require(['gc/searchExperiments', 'handlebars.runtime', 'env'], function(searchExperiments, Handlebars, env) {
    var handlebarHelpers = {};
    var imagesPath = getPrefixPath(env) + 'images/';
    var wizardImagesPath = imagesPath + "wizard/";
    
    function getPrefixPath(env){
        var prefixPath = '';
        if (env.version == 'local') {
            prefixPath = "/content/local/";
        } else {
            prefixPath = env.prefix + '/content/' + env.version + '/';
        }
        
        return prefixPath;
    }

    //This returns the adjusted position for each item depending upon where the suggestion is placed in TA
    handlebarHelpers.getItemCount = function (i) {
        return parseInt(i);
    };

    //This function decides the placement of the icon and display text as per experiment variant
    handlebarHelpers.arrangeIconAndText = function (iconHtml, textHtml, rightFloatingTextHtml) {
        var value = iconHtml + textHtml;

        value = '<div class="option-text-primary">' + value + '</div>';
        if (_.isString(rightFloatingTextHtml)) {
            value = '<span class="option-text-secondary">' + rightFloatingTextHtml + '</span>' + value;
        }

        return value;
    };

    //This function defines the span element to be included in the <a> tag of TA suggestions
    handlebarHelpers.makeOption = function (index, icon, d, rightFloatingTextHtml) {
        var iconHtml = '<span data-tid="typeahead-icon'
          + index
          + '"class="icon icon-'
          + icon + ' '
          + '""'
          + '" aria-hidden="true"/>';
        return handlebarHelpers.arrangeIconAndText(iconHtml, d, rightFloatingTextHtml);
    };

    //This Handlebar helper returns corewizard.handlebarHelpers.getItemCount()
    Handlebars.registerHelper('getItemCount', function(i) {
        return handlebarHelpers.getItemCount(i);
    });

    //This Handlebar helper returns corewizard.handlebarHelpers.makeOption()
    Handlebars.registerHelper('makeOption', function(index, icon, d, rightFloatingTextHtml) {
        return handlebarHelpers.makeOption(index, icon, d, rightFloatingTextHtml);
    });

    // FROM https://gist.github.com/3902173
    //
    // HELPER: #each_with_key
    //
    // Usage: {{#each_with_key container key="myKey"}}...{{/each_with_key}}
    //
    // Iterate over an object containing other objects.
    // Each inner object will be used in turn, with an added key ("myKey")
    // set to the value of the inner object's key in the container.
    Handlebars.registerHelper("each_with_key", function (obj, options) {
        var context,
        buffer = "",
        key,
        keyName = options.hash.key;
        for (key in obj) {
            if (obj.hasOwnProperty(key)) {
                context = obj[key];
                if (keyName) {
                    context[keyName] = key;
                }
                buffer += options.fn(context);
            }
        }
        return buffer;
    });

    //This Handlebar helper returns the HTML content for a child suggestion for TA where hierarchy is shown
    Handlebars.registerHelper('getChildSuggestionIcon', function (i) {
        var k = parseInt(i);
        return '<span data-tid="typeahead-icon' + k + '" class="icon icon-return" aria-hidden="true"></span>';
    });

    //This Handlebar helper returns corewizard.handlebarHelpers.arrangeIconAndText() with category in the textHtml for cross product suggestions
    Handlebars.registerHelper('makeOptionOpenSearch', function(index, icon, d, category) {
        var iconHtml = '<span data-tid="typeahead-icon'
            + index
            + '"class="icon icon-'
            + icon
            + '" aria-hidden="true"/>';
        var textHtml = d + '<span style="color:#1f1f1f"> - ' + category + '</span>';
        return handlebarHelpers.arrangeIconAndText(iconHtml, textHtml);
    });

    //This Handlebar helper returns just description for Gemma Autosuggest in the textHtml
    Handlebars.registerHelper('makeOptionGemmaSearch', function(index, icon, d) {
        var iconHtml = '<span data-tid="typeahead-icon'
            + index
            + '"class="icon icon-'
            + icon
            + '" aria-hidden="true"/>';
        var textHtml = '<div class="option-text-primary">' + d + '</div>';
        return textHtml;
    });

    //This Handlebar helper sets the showAsHierarchy flag as true for child or nearby TA suggestions in the context
    Handlebars.registerHelper('getShowAsHierarchyFlag', function (context, obj) {
        if (obj && (obj[0] == 'child' || obj[0] == 'nearby')) {
            //Set the flag to show as hierarchy option
            context.showAsHierarchy = true;
        }
    });

    //This Handlebar helper sets the showAsHierarchy flag as true for child or nearby TA suggestions in the context
    Handlebars.registerHelper('showDistanceFromNearbyAirport', function (obj) {
        if (searchExperiments.getVariant("NEARBY_AIRPORT") === 2 && obj) {
            return ". <b>" + parseInt(obj) + " miles</b> away";
        }
    });

    /**
     * Helper to get Scratchpad module loc strings
     * that are in scratchpad-header.tray.js
     */
    Handlebars.registerHelper('scratchpadLoc', function (context) {
        var loc = '';
        try {
            loc = window.Scratchpad.headerTray.locStrings[context];
        } catch (ex) {
        }
        return loc;
    });

    /**
     * Helper to check if experiment is enabled
     */
    Handlebars.registerHelper('if_experiment', function(expName, options) {
        if(searchExperiments.getVariant(expName) !== 0) {
            return options.fn(this);
        }
        else {
            return options.inverse(this);
        }
    });
});
var corewizard = corewizard || {};

define('gc/importedState', [
  'gc/modelHelpers',
  'gc/localStorage',
  'gc/dataModels',
  'gc/getLob'
], function(
  modelHelpers,
  localStorage,
  dataModels,
  getLob
) {

  function hasPackage(packages) {
      return (
        typeof e == "object" &&
          (packages.flight || packages.hotel || packages.car || packages.train)
      );
  };
  //returns raw data as javascript object
  var rawImportedState = {
    backButtonData: function () {
      var data = $('#back-button-model').val();
      return data ? $.parseJSON(data) : null;
    },

    setBackButtonData: function(model) {
      $('#back-button-model').val(JSON.stringify(model.toJSON()))
    },

    lastSearchData: function () {
      var data = $('#last-search-json-form-values');
      return data.length ? $.parseJSON(data.html()) : null;
    },

    deepLinkData: function () {
      var urlParams = window.location.search.substring(1);
      return deparam(urlParams);
    }
  };

  //takes url params as a string and converts to object
  function deparam(queryString) {
    var match,
      pl = /\+/g,  // Regex for replacing addition symbol with a space
      search = /([^&=]+)=?([^&]*)/g,
      decode = function (s) {
        return decodeURIComponent(s.replace(pl, " "));
      },
      urlParams = {};
    while (match = search.exec(queryString)) {
      var value = decode(match[2]);
      if (value === 'false') {
        value = false;
      } else if (/^\d+$/.test(value) && parseInt(value)) {
        value = parseInt(value)
      }

      urlParams[decode(match[1])] = value;
    }
    return urlParams;
  }

  var importedState = {
    importData: function () {
      var ignoreLastSearch = dataModels.config.get('ignoreLastSearch');
      if (_.isUndefined(ignoreLastSearch)) {
        ignoreLastSearch = false;
      }

      var data = (!ignoreLastSearch && this.localStorageData()) ||
        this.backButtonData() ||
        (!ignoreLastSearch && this.lastSearchData()) ||
        this.deepLinkData();

      if (lobOverride())
        data = _.extend(data, lobOverride());

      delete data.validation; // remove any previous validation issues


      if (!_.isEmpty(data)) {
        data = this.adjustLob(data);
      }
      data.importedData = true;
      return data;
    },

    adjustLob: function(data) {
      if (data.tab && data.packages) {
        var propsedLob = getLob(data.tab, data.packages);
        var hasLob = _.find(dataModels.config.attributes.wizardconfig.lobs, function(lob) {
          var hasMatchingPackage;
          if (lob.lobs) {
            hasMatchingPackage = _.find(lob.lobs, function(pkg) {
              return propsedLob === pkg.id;
            });
          };
          return propsedLob === lob.id || hasMatchingPackage
        });

        //if the LOB from last search doesn't exist on this tab, use the specifed default.
        if (!hasLob) {
          if (hasPackage(dataModels.config.defaultPackages)) {
            data.tab = 'package';
          } else {
            data.packages = {
              flight: false,
              car: false,
              hotel: false,
              train: false
            };
            data.tab = dataModels.config.defaultTab;
          }
          data.packages = dataModels.config.defaultPackages;
        }
      }

      return data;
      //check to see if this wizard configuration contains the LOB defined
      //by last search
    },


    backButtonData: function () {
      var data = rawImportedState.backButtonData();
      if (!data) return null;

      return _.extend(data, savedStateOverride(data));
    },

    setBackButtonData: function(model) {
      rawImportedState.setBackButtonData(model);
    },

    lastSearchData: function () {
      var data = rawImportedState.lastSearchData();
      if (!data) return null;

      data = _.extend(data, savedStateOverride(data));

      if (isMobile() && data.tab === 'hotel')
        data = _.extend(data, lastSearchMobileOverride());

      return data;
    },

    deepLinkData: function () {
      var data = rawImportedState.deepLinkData();

      if (isMobile())
        data = _.extend(data, deepLinkMobileOverride());

      return data;
    },

    localStorageData: function() {
      return localStorage.getLocalStorage &&
        localStorage.localStorageKey &&
        localStorage.getLocalStorage(localStorage.localStorageKey);
    },

    hasImportData: function() {
      return !_.isEmpty(this.importData());
    }
  };

  function savedStateOverride(savedState) {
    var state = dataModels.state;
    var overrides = {};

    overrides.isChildInLap = savedState.lapSeat === 'lap';

    if (savedState.origin === '()')
      overrides.origin = '';

    if (savedState.departing)
      overrides.startDate = savedState.departing;

    if (savedState.returning)
      overrides.endDate = savedState.returning;

    if (state.get('tab') === 'flight' && state.get('flighttype') === 'oneway')
      overrides.endDate = savedState.departing;

    if (!(state.get('packages.flight') || state.get('packages.hotel'))) {
      overrides.checkin = null;
      overrides.checkout = null;
    }

    overrides = _.extend(overrides, roomsOverride(savedState));

    return overrides;
  }

  function roomsOverride(state) {
    var overrides = {
      roomCount: state.rooms && state.rooms.length ?
        state.rooms.length :
        1,
      rooms: state.rooms && state.rooms.length ?
        state.rooms :
        [{adults: 0, childCount: 0, guests: 0, children: [], youthCount: 0, youths: []}]
    };

    _.each(overrides.rooms, function (room) {
      room.childCount = room.children.length;
      room.guests = room.children.length + room.adults;
    });

    return overrides;
  }

  function lastSearchMobileOverride() {
    var checkin = new XDate().toString(dataModels.config.get("dateFormat"));
    var checkout = new XDate().addDays(1).toString(dataModels.config.get("dateFormat"));

    return {
      checkin: checkin,
      checkout: checkout,
      departing: checkin,
      returning: checkout
    };
  }

  function deepLinkMobileOverride() {
    var checkin = new XDate().toString(dataModels.config.get("dateFormat"));
    var checkout = new XDate().addDays(1).toString(dataModels.config.get("dateFormat"));

    return {
      checkin: checkin,
      checkout: checkout,
      startDate: checkin,
      endDate: checkout,
      startDatePrefilled: true,
      endDatePrefilled: true
    };
  }

  function lobOverride() {
    var lobParam = rawImportedState.deepLinkData().lob;
    if (!lobParam) return null;

    var lobOverride = {};

    var packageSettings = dataModels.config.get(lobParam);
    if (packageSettings) {
      lobOverride.packages = {
        flight: packageSettings.packageSetting_flight,
        hotel: packageSettings.packageSetting_hotel,
        car: packageSettings.packageSetting_car
      };
    }

    if (_.contains(_.pluck(dataModels.config.attributes.wizardconfig.lobs, 'id'), lobParam))
      lobOverride.tab = lobParam;

    return lobOverride;
  }

  function isMobile() {
    return window.innerWidth <= 492;
  }

  return importedState;
});

var corewizard = corewizard || {};

define('gc/carHelpers', ['gc/dataModels'], function(dataModels) {
    'use strict';

    return {
            isHotelAttachedWithCar : function(model) {
                model = model || this.model;
                var tab = model.get('tab');
                var pkg = model.get('packages');
                return (tab === 'car') && pkg && (pkg.hotel);
            }
        };
});

// This object contains details about all the search experiments along with the LOBs in which they are to run
// It has the following public API:
//
//     experimentDetails - contains the list of experiments by abacus ID. Meant to be private but exposed for unit tests
//     getAbacusId - helper function to get an abacus ID based on map property such as 'ESS_V4_CARS' or 'TRENDING_NOW'
//     getSearchExperimentVariantIfParticipating - helper method to get the search variant
//     getSearchExperimentVariant - helper method to get the search variant
//     getVariant - gets the variant based on name
//     isOriginField - boolean value true if field is the origin, false if it's the destination aka anything other than origin
//     getFreeSearchTextDetails - function that returns an object with {top:XXX, bottom:YYYY} properties
//     flighttypeChanged - placeholder event handler for flightTypeChanged events
//     parseUrl - converts a string URL into an object with URL info
//     getUserSearchHistory - pulls scratchpad search history data.
//
/*
 * // IMPORTANT : Please let esstech@expedia.com know before making any changes to this file
 */

define('gc/searchExperiments', ['gc/abTest', 'gc/getLob', 'gc/dataModels', 'gc/carHelpers'],  function (abTest, getLob, dataModels, carHelpers) {
    "use strict";

// polyfill for string.prototype.trim (ES5.1) for IE8 and other old javascript implementations.
// See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim
if (!String.prototype.trim) {
    String.prototype.trim = function () {
        return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    };
}

    var searchExperimentNameIdMapping = {
            TRIGGER_WITH_FEWER_CHARACTERS       : '6739', //1-2 char typeahead trigger experiment
            NEARBY_AIRPORT                      : '8075', //Show nearby airport in typeahead suggestions
            TUNE_DISPLAY_TEXT                   : '8071', //Streamline display text in TA for Flights LOB
            BEST_DEALS_OPTION                   : '8445', //Cheap Hotels and/or Best Deals in Hotels LOB
            HIGH_LEVEL_REGION                   : '8664', //Expose High Level region in Hotels LOB
            RECENT_HISTORY_HOTEL                : '11582', //Expose Recent history from Scratchpad in Hotels LOB
            ALWAYS_SEND_GAIA_ID_AND_LAT_LONG    : '9027', // Modify HSR Submitted Search URL to send GAIA and Lat/Long (for All Types)
            TRIGGER_1_2_CHAR                    : '9110',  //1-2 char typeahead trigger for TW, CN, HK in all LOBs
            HOTEL_INPUT_HINT                    : '9109', //Including Hotel name in Hotel LOB
            REMOVING_FLIGHTS_ICON               : '9241', //Removing flights icon in Flights LOB
            CONSUME_ESS_V4_FOR_ACTIVITIES       : '9432', //Consuming ESS v4 for activities LOB
            CONSUME_ESS_V4_FOR_PACKAGES         : '9433', //Consuming ESS v4 for packages LOB
            CURRENT_LOCATION                    : '8160', //Show current location as a suggestion in hotel LOB
            MEMBER_PRICE_HOTEL                  : '9598', //Adding MER signup to the hotel tab
            CWTA_JP_Recommendation              : '10614', //Core Wizard Typeahead Recommendations for Japan
            CWTA_HotelNameInCars                : '10728', //Show hotels in CAR LOB search and sort by popularity
            CWTA_MVBoldingFontIconColor         : '10967', //Follow up of multi Variant experiment for improving scan-ability in hotel LOB
            CWTA_PrePopulateInput               : '10933', //GWC experiment
            uTA_HOTELS                          : '11640',  //TnL Experiment #3397 [rWeb] migrate GC to uTA TA in S/F of responsive web - HOTELS LOB
            CWTA_MaxSuggestionsCars             : '11680', //Change max results for typeahead in cars LOB
            CWTA_RemoveFlightIcon               : '11683', //Remove flight icon from flights LOB and package origins
            CWTA_AnchorTAOnTop                  : '11681'  //Anchor input on focus to show more search results
        },
        experimentDetails = {},
        searchUserHistoryUtil = (function () {
            // utility module that provides a simple interface(API) for extracting
            // data from scratchpad userhistory

            // helper function to extract the search property from a userhistory object
            function getSearchNode(item) {
                return _.isObject(item) &&
                       _.isObject(item.search) &&
                       _.property('search')(item);
            }

            // helper method that checks to see if this userhistory.search node
            // has a 'routetype' property thus indicating that it's a search object
            // result returned from an AIR_SEARCH
            function isFlightSearch(search) {
                return _.isObject(search) && ('routetype' in search);
            }

            // helper function that checks to see if this userhistory.search node
            // has a 'destination' property thus indicating that it's a search object
            // result returned from  an HOTEL_SEARCH
            function isHotelSearch(search) {
                return _.isObject(search) && ('destination' in search);
            }

            // helper function that determines whether or not given
            // a sentence and a searchTxt, the searchText matches the
            // start of any word in the sentence
            function prefixMatch(sentence, searchTxt){

                if(!_.isString(searchTxt)) {
                    searchTxt = '';
                }

                var words = sentence.match(/\S+\s*/g);

                // We want to compare the entire sentence for a match as well
                // any individual words contained with it it. So add it to the list.
                words.push(sentence);

                function startsWithIgnoreCase(str, prefix) {

                    if(_.isString(str) && _.isString(prefix)) {
                        str = str.toLocaleLowerCase();
                        prefix = prefix.toLocaleLowerCase();

                        return str.indexOf(prefix) === 0;
                    }

                    return false;
                }

                return _.any(words, function(word){
                    return startsWithIgnoreCase(word, searchTxt);
                });
            }

            // parseUrl(url)
            // given a URL string, extract out an object with URL properties including
            //    protocol
            //    host
            //    hostname
            //    pathname
            //    search (query string)
            //    searchObject (query string reified into an object)
            //    hash
            function parseUrl(url) {

                if(!_.isString(url)) {
                    throw new Error("Must call the parseUrl API with a string representation of a URL");
                }

                // Let the browser do the work
                var parser = document.createElement('a'),
                    searchObject = {},
                    queryParams = [],
                    split = [];

                parser.href = url;

                // TODO: leverage underscore-contrib - http://documentcloud.github.io/underscore-contrib/#fromquery
                // pull the query string off the URL
                // using the search API in the browser
                queryParams = parser.search
                    .replace(/^\?/, '') // strip the first character '?'
                    .split('&'); // split on the '&' character

                // Transform the decoded query params to an object
                _.each(queryParams, function(query) {
                    split = query.split("=");
                    searchObject[_.first(split)] = decodeURIComponent(_.last(split));
                });

                return {
                    protocol: parser.protocol,
                    host: parser.host,
                    hostname: parser.hostname,
                    pathname: parser.pathname,
                    search: parser.search,
                    searchObject: searchObject,
                    hash: parser.hash
                };
            }

            // given a list of scratchpad API response userhistory objects and a prefix string,
            // returns a list of flight search specific full userhistory objects filtered by the prefix string query.
            // An empty prefix will match all flight searches in the user history list. The list is compacted to
            // weed out any undefined objects.
            function getFlightTLAMatches(userhistory, prefix, inputId) {

                // defaults to looking in the origin field if not set
                inputId = inputId || 'flight-origin';

                var isDepartingFlight = ~inputId.indexOf('flight-origin');

                var matches = _.filter(userhistory, function (item){

                    var searchNode = getSearchNode(item),
                        searchString,
                        routedetails,
                        detail,
                        TLAs,
                        routedetails;

                    if (isFlightSearch(searchNode)) {

                        // pull out the routedetails node from the search object
                        // since that's where our TLAs to search live

                        // _.property(prop) is a nice little utility that will generate
                        // a function that when called will pull out the value of the
                        // named property. Here we create a extractRouteDetailsFrom() function
                        var extractRouteDetailsFrom = _.property('routedetails');

                        // then we pull out the value of search.routedetails
                        // which is an array
                        routedetails = extractRouteDetailsFrom(searchNode);

                        // For now, we're just grabbing the first routes details.
                        detail = _.first(routedetails);

                        if(_.isObject(detail)){

                            // grab out the the 'arrivalairport' and/or 'departureairport' fields as
                            // needed based on on whether or not the search is from the origin or the destination
                            // input in TA. NOTE: dangerous to be sending DOM element ID down as a flag
                            // to determine which field to use to grab a JSON value.
                            TLAs = _.pick(detail, isDepartingFlight ? 'departureairport': 'arrivalairport');

                            // squash the values down into a searchable string
                            searchString = _.values(TLAs).join(', ');

                            if (prefixMatch(searchString, prefix)) {
                                return item;
                            }

                        } else {

                            // If we didn't get any useful route detail be optimistic and add the item to the list
                            // because if we're in here, we should only be looking at flight searches in the userhistory.
                            return item;
                        }
                    }
                });

                return matches;
            }

            // given a list of scratchpad API response userhistory objects and a prefix string,
            // returns a list of hotel search specific full userhistory objects filtered by the prefix string query.
            // An empty prefix will match all hotel searches in the user history list. The list is compacted to
            // weed out any undefined objects.
            function getHotelDestinationMatches(userhistory, prefix) {

                var matches = _.filter(userhistory, function (item){

                    var searchNode = getSearchNode(item),
                        searchString;

                    if(isHotelSearch(searchNode) && _.has(searchNode.destination, 'regionname')){
                        searchString = _.property('regionname')(searchNode.destination);

                        if (prefixMatch(searchString, prefix)) {
                            return item;
                        }
                    }
                });

                return matches;
            }

            // the public API exposed by the searchUserHistoryUtil module
            return {
                getHotelDestinationMatches: getHotelDestinationMatches,
                getFlightTLAMatches: getFlightTLAMatches
            }
        })();

    function getAbacusId(experimentName) {
        return searchExperimentNameIdMapping[experimentName];
    }

    experimentDetails[getAbacusId("TRIGGER_WITH_FEWER_CHARACTERS")]     = ['flight', 'hotel', 'flightHotel', 'flightHotelCar', 'flightCar', 'hotelCar', 'car', 'activity', 'hotelAttachedWithCar'];
    experimentDetails[getAbacusId("NEARBY_AIRPORT")]                    = ['flight'];
    experimentDetails[getAbacusId("TUNE_DISPLAY_TEXT")]                 = ['flight'];
    experimentDetails[getAbacusId("BEST_DEALS_OPTION")]                 = ['hotel'];
    experimentDetails[getAbacusId("HIGH_LEVEL_REGION")]                 = ['hotel'];
    experimentDetails[getAbacusId("RECENT_HISTORY_HOTEL")]              = ['hotel'];
    experimentDetails[getAbacusId("ALWAYS_SEND_GAIA_ID_AND_LAT_LONG")]  = ['hotel'];
    experimentDetails[getAbacusId("TRIGGER_1_2_CHAR")]                  = ['flight', 'hotel', 'flightHotel', 'flightHotelCar', 'flightCar', 'hotelCar', 'car', 'activity', 'hotelAttachedWithCar'];
    experimentDetails[getAbacusId("HOTEL_INPUT_HINT")]                  = ['hotel'];
    experimentDetails[getAbacusId("REMOVING_FLIGHTS_ICON")]             = ['flight'];
    experimentDetails[getAbacusId("CONSUME_ESS_V4_FOR_ACTIVITIES")]     = ['activity'];
    experimentDetails[getAbacusId("CONSUME_ESS_V4_FOR_PACKAGES")]       = ['flightHotel', 'flightHotelCar', 'flightCar', 'hotelCar'];
    experimentDetails[getAbacusId("CURRENT_LOCATION")]                  = ['hotel'];
    experimentDetails[getAbacusId("MEMBER_PRICE_HOTEL")]                = ['hotel', 'flightHotel', 'flightHotelCar', 'flightCar'];
    experimentDetails[getAbacusId("CWTA_JP_Recommendation")]            = ['flight', 'hotel']; // flightHotel is excluded
    experimentDetails[getAbacusId("CWTA_HotelNameInCars")]              = ['car', 'hotelAttachedWithCar'];
    experimentDetails[getAbacusId("CWTA_MVBoldingFontIconColor")]       = ['hotel'];
    experimentDetails[getAbacusId("CWTA_PrePopulateInput")]             = ['flight', 'hotel', 'flightHotel', 'flightHotelCar', 'flightCar', 'hotelCar', 'car', 'activity'];
    experimentDetails[getAbacusId("uTA_HOTELS")]                        = ['hotel'];
    experimentDetails[getAbacusId("CWTA_MaxSuggestionsCars")]           = ['car'];
    experimentDetails[getAbacusId("CWTA_RemoveFlightIcon")]             = ['flight', 'flightHotel', 'flightHotelCar', 'flightCar'];
    experimentDetails[getAbacusId("CWTA_AnchorTAOnTop")]                = ['flight', 'hotel'];

    function getSearchExperimentVariantIfParticipating(abacusID) {
        var assignment, coreLob;
        if (!experimentDetails[abacusID]) {
            throw "The LOBs for experiment " + abacusID + " are undefined";
        }

        // When hotel is attached with cars we have to follow HC flow but
        // Abacus experiments of HC must not apply, we want experiments related to 'Car' to be applied.
        // It means path will be HC but experiments will be of 'Car'
        if(carHelpers.isHotelAttachedWithCar(dataModels.model))
        {
            coreLob = "hotelAttachedWithCar";
        }
        else {
            //AAG sites have null values for corewizard.core attributes
            coreLob = getLob(dataModels.model.get('tab'), dataModels.model.get('packages'));
        }

        if (_.contains(experimentDetails[abacusID], coreLob)) {
            if (typeof callAbtestGetter === "function") {
                assignment = callAbtestGetter(abacusID);
                if (typeof assignment === "number") {
                    assignment = assignment.toString(10);
                }
            }
            return (assignment || "0");
        }
        else {
            return undefined;
        }
    }

    function getSearchExperimentVariant(abacusID) {
        var variant = getSearchExperimentVariantIfParticipating(abacusID);
        return (variant || "0");
    }

    function getVariant(experimentName) {
        var abacusId = getAbacusId(experimentName);
        if (!abacusId) {
            throw "The experiment name \"" + experimentName + "\" is unknown.";
        }
        return parseInt(getSearchExperimentVariant(abacusId), 10);
    };

    function isOriginField(contextId) {
       if (
            contextId === 'flight-origin' ||
            contextId === 'flight-2-origin' ||
            contextId === 'flight-3-origin' ||
            contextId === 'flight-4-origin' ||
            contextId === 'flight-5-origin' ||
            contextId === 'package-origin'
        ) {
            //From/Origin fields
            return true;
        }
        else {
            //To/Destination fields
            return false;
        }
    };

    function flighttypeChanged (state){
        genericTypeaheadStateReset(state);
    };

    function genericTypeaheadStateReset (state) {

        //Reset the typeahead related flags
        corewizard.OMTypeAheadRendered = false;
        //Info pertaining to latest interaction
        state.set('userTypedQuery', '');
        state.set('selectedTASuggestionPosition', null);
        state.set('TASearchType', null);
        state.set('suggestionType', null);//this holds 'child' info
        state.set('taTriggerElemId',null);
        state.set('essItemsTotal',0);
        state.set('activeESSTests',null);
        state.set('taMetadata',null);
        //reset the attributes which are expected to be populated only via Typeahead
        state.set('hotelId', null);
        state.set('multiCityRegion', null);
        state.set('regionId', null);
        state.set('latLong', null);

        //Info persisted irrespective of Typeahead interaction
        state.set('destinationFromTA',null);
        state.set('originFromTA',null);
        state.set('destinationTLA', null);
        state.set('originTLA', null);
        state.set('destinationRegionId', null);
        state.set('originRegionId', null);
        state.set('destinationLatitude', null);
        state.set('destinationLongitude', null);
        state.set('originLatitude', null);
        state.set('originLongitude', null);
        state.set('TADestSearchType', null);
        state.set('TAOrigSearchType', null);
        state.set('destSuggestionTypeId',null);
        state.set('origSuggestionTypeId',null);
        state.set('destinationSourceInfo', null);
        state.set('originSourceInfo', null);
        state.set('destinationRelInfo', null);
        state.set('originRelInfo', null);
        state.set('multiFlightDestination',null);
        state.set('multiFlightOrigin',null);
        state.set('multiFlightDestSuggType',null);
        state.set('multiFlightOrigSuggType',null);
        state.set('multiFlightDestSuggTypeId',null);
        state.set('multiFlightOrigSuggTypeId',null);
        state.set('multiFlightDestSrc',null);
        state.set('multiFlightOrigSrc',null);
        state.set('multiFlightDestRel', null);
        state.set('multiFlightOrigRel', null);

        //When switching between lobs rails origin and destination must be cleared, 
        //as discussed in email thread: Re: Rail MVP Typeahead - related to the bug
        //Rails has a rule to force selection from TA
        if(state.get("tab")==="rail" ){
            state.set("origin",null);
            state.set("destination",null);
        }

        if(getSearchExperimentVariant('11640') !== '0') {
            require("universalTypeahead", function(uTA) {
                uTA.initTracking();
            }, function(error) {});
        }

    }

    /*
     * @params :- state : Corewizard state
     * @params :- key : Corewizard attribute of which key aka tab on wizard is pressed. 
     * key is undefined when we make explicit request to reset TA state.
     * Both the above params are passed implicitly via corewizard event handlers
     */
    function resetTypeaheadState (state, key) {

        if(state.hasChanged('packages') == false && state.hasChanged('tab') == false ) {
            //Page load and key == undefined
            //"No change in packages and no change in tab. Page load reset TA"
            genericTypeaheadStateReset(state);
        }
        else if(state.hasChanged('packages') == true && state.hasChanged('tab') == false ) {
            //Addition of package options in non - package LOB
            //Sub tab change in Package LOB
            //"Packages changed and no change in tab. Package change reset TA"
            //Reset change only if sub tabs change in package tab. Do not reset on soft package change
            if(state.get('tab') === 'package') {
                genericTypeaheadStateReset(state);
            }
        }
        else if(state.hasChanged('packages') == false && state.hasChanged('tab') == true ) {
            //Change of tab between non package LOBs
            //"Tab changed and no change in packages. Tab change reset TA"
            genericTypeaheadStateReset(state);
        }
        else if(state.hasChanged('packages') == true && state.hasChanged('tab') == true ) {
            //"Packages changed and tab changed"
            //Change of tab between non-package LOB and package LOB
            //For instances where packages and tab change, don't double reset! Reset only for packages
            //Reset only for package change in this scenario
            if(key === 'tab') return;
            genericTypeaheadStateReset(state);
        }
        else {
            //"Explicit request to reset Typeahead state"
            genericTypeaheadStateReset(state);
        }

        if (getVariant("BEST_DEALS_OPTION")) {
            state.set('sort', null);
        }

        //User history specific state variables
        if(getSearchExperimentVariant('11582') !== '0') {
            state.set('userHistoryItemsTotal',0);
            state.set('userHistoryItemAge',null);
        }

        //Current location specific state variables
        if(getSearchExperimentVariant('8160') !== '0') {
            state.set('currentLocationShown', 0);
            state.set('currentLocationDetails',null);
        }

        //Trending Search specific state variables
        if(getSearchExperimentVariant('10614') !== '0') {
            state.set('recommenderOptionsRendered',0);
        }

    };

    function updateCurrentLocationInModel (data, model) {
        model.set('currentLocationDetails', data);
    };

    function getCurrentLocation (callback) {
        var options =  {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
        };

        navigator.geolocation.getCurrentPosition(
            function (position) {
                var coordinates = {};
                coordinates.lat = position.coords.latitude;
                coordinates.lng = position.coords.longitude;
                if (typeof callback === "function") { callback(coordinates); }
            },
            function(error) {
                //TODO: Put logging indicating geoLocation Ended
                var errorMessage = "Unknown Error";
                switch (error.code) {
                    case error.PERMISSION_DENIED: errorMessage = "User denied the request for Geolocation.";break;
                    case error.POSITION_UNAVAILABLE: errorMessage = "Location information is unavailable.";break;
                    case error.TIMEOUT: errorMessage = "The request to get user location timed out.";break;
                    case error.UNKNOWN_ERROR: errorMessage = "An unknown error occurred.";break;
                }
                if (typeof callback === "function") { callback(errorMessage); }
            },
            options
        );
    };

    function resetMERSignupState (state) {
        if (getSearchExperimentVariant('9598') > 0) {
            state.set('merSignupSuccess',undefined);
            state.set('merOptin',false);
            state.set('merEmail',undefined);
        }
    }

    // given user entered search data as userTypedText, an id for which field we're on
    // and the fligtType indicating which tab on the flight wizard the user is on (roundtrip,oneway, etc)
    // returns the list of matching search objects extracted
    // out of the scratchpad response userhistory data array
    // NOTE: all params are strings and required
    function getUserSearchHistory(userTypedtext, inputId, flightType) {
        if (arguments.length !== 3) {
            throw new Error("3 arguments required for getUserSearchHistory API");
        }
        if (!_.isString(userTypedtext)) {
            throw new Error("userTypedtext must be a string");
        }
        if (!_.isString(inputId)) {
            throw new Error("inputId must be a string");
        }
        if (!_.isString(flightType)) {
            throw new Error("flightType must be a string");
        }

        var userHistoryData,
            filterLOB,
            filteredSearchHistory = [],
            filterProduct = '',
            experimentLob,
            searches,
            hotels,
            flights,
            scratchpadProductLobMapping = {
                FLIGHT: 'AIR',
                HOTEL: 'HOTEL',
                PACKAGE: 'PACKAGE',
                CAR: 'CAR'
            },
            resultingHistoryData = [],
            filterRouteType = {
                roundtrip: "ROUND_TRIP",
                oneway: "ONE_WAY"
            }[flightType];
        // don't use it unless window.typeaheadUtilScratchpad has been loaded
        if(_.isObject(typeaheadUtilScratchpad)){
            //vmohapatra : Passing a 'type' as param is optional. We want to specifically filter data of type "SEARCH" for our experiment
            userHistoryData = typeaheadUtilScratchpad.getCompleteScratchpadHistoryData('SEARCH');
        }

        // filter down the userhistory data list based on current LOB
        if (_.isObject(userHistoryData.userhistory) && userHistoryData.userhistory.length > 0) {
            filterLOB = getLob(dataModels.model.get('tab'), dataModels.model.get('packages')).toUpperCase();

            if (scratchpadProductLobMapping[filterLOB]) {
                filterProduct = scratchpadProductLobMapping[filterLOB];
            }
            //Filter user history by product type
            if (filterProduct) {
                filteredSearchHistory = _.filter(userHistoryData.userhistory, function (historicalEvent) {
                    if (filterProduct === "AIR") {
                        return historicalEvent.product === filterProduct &&
                            historicalEvent.search.routetype === filterRouteType;
                    } else {
                        return historicalEvent.product === filterProduct;
                    }
                });
            }
        }

        // use that LOB based list to get the matches
        if (filteredSearchHistory && filteredSearchHistory.length > 0) {

            //Processing search history based on LOB and user typed text
            experimentLob = getLob(dataModels.model.get('tab'), dataModels.model.get('packages'));

            if (experimentLob == 'flight') {
                resultingHistoryData = searchUserHistoryUtil.getFlightTLAMatches(filteredSearchHistory, userTypedtext, inputId);
            } else if (experimentLob == 'hotel') {
                resultingHistoryData = searchUserHistoryUtil.getHotelDestinationMatches(filteredSearchHistory, userTypedtext);
            }
        }

        // return the first 5 hits
        return _.take(resultingHistoryData, 5);
    }

    // parseUrl(url)
    // given a URL string, extract out an object with URL properties including
    //    protocol
    //    host
    //    hostname
    //    pathname
    //    search (query string)
    //    searchObject (query string reified into an object)
    //    hash
    function parseUrl(url) {

        if(!_.isString(url)) {
            throw new Error("Must call the parseUrl API with a string representation of a URL");
        }

        // Let the browser do the work
        var parser = document.createElement('a'),
            searchObject = {},
            queryParams = [],
            split = [];

        parser.href = url;

        // TODO: leverage underscore-contrib - http://documentcloud.github.io/underscore-contrib/#fromquery
        // pull the query string off the URL
        // using the search API in the browser
        queryParams = parser.search
                            .replace(/^\?/, '') // strip the first character '?'
                            .split('&'); // split on the '&' character

        // Transform the decoded query params to an object
        _.each(queryParams, function(query) {
            split = query.split("=");
            searchObject[_.first(split)] = decodeURIComponent(_.last(split));
        });

        return {
            protocol: parser.protocol,
            host: parser.host,
            hostname: parser.hostname,
            pathname: parser.pathname,
            search: parser.search,
            searchObject: searchObject,
            hash: parser.hash
        };
    }

    function callAbtestGetter (abacusID) {
        return abTest.get(abacusID).value;
    };

    // This is the public API for the searchExperiments object
    return {
        experimentDetails: experimentDetails, // only public for unit tests
        getAbacusId: getAbacusId,
        getSearchExperimentVariantIfParticipating: getSearchExperimentVariantIfParticipating,
        getSearchExperimentVariant: getSearchExperimentVariant,
        getVariant: getVariant,
        isOriginField: isOriginField,
        flighttypeChanged: flighttypeChanged,
        resetTypeaheadState: resetTypeaheadState,
        updateCurrentLocationInModel: updateCurrentLocationInModel,
        getCurrentLocation: getCurrentLocation,
        resetMERSignupState: resetMERSignupState,
        parseUrl: parseUrl,
        getUserSearchHistory: getUserSearchHistory
    };

});

define('gc/inputDefaults', ['gc/loc'], function(loc) {
  return {
    cruises : {
      label : loc.cruise.destinationLabel,
      options : [
        { name : loc.cruise.showAll, value : ''},
        { name : loc.cruise.mostPopular,
          options : [
            { name : loc.cruise.optionCaribbean, value : 'caribbean' },
            { name : loc.cruise.optionBahamas, value : 'bahamas' },
            { name : loc.cruise.optionMexico, value : 'mexico' },
            { name : loc.cruise.optionAlaska, value : 'alaska' },
            { name : loc.cruise.optionEurope, value : 'europe' },
            { name : loc.cruise.optionBermuda, value : 'bermuda' },
            { name : loc.cruise.optionHawaii, value : 'hawaii' },
            { name : loc.cruise.optionCanadaNE, value : 'canada-new-england' }
          ]
        },//optionGroup,
        { name : loc.cruise.otherDestinationsLabel,
          options : [
            { name : loc.cruise.optionAfrica, value : 'africa'},
            { name : loc.cruise.optionArcticAntarctic, value : 'arctic-antarctic'},
            { name : loc.cruise.optionAsia, value : 'asia'},
            { name : loc.cruise.optionAustraliaNZ, value : 'australia-new-zealand'},
            { name : loc.cruise.optionCentralAmerica, value : 'central-america'},
            { name : loc.cruise.optionNowhere, value : 'cruise-to-nowhere'},
            { name : loc.cruise.optionGalapagos, value : 'galapagos'},
            { name : loc.cruise.optionGreenlandIceland, value : 'greenland-iceland'},
            { name : loc.cruise.optionMiddleEast, value : 'middle-east'},
            { name : loc.cruise.optionPacificCoastal, value : 'pacific-coastal'},
            { name : loc.cruise.optionPanamaCanal, value : 'panama-canal'},
            { name : loc.cruise.optionSouthAmerica, value : 'south-america'},
            { name : loc.cruise.optionSouthPacific, value : 'south-pacific'},
            { name : loc.cruise.optionTahiti, value : 'tahiti'},
            { name : loc.cruise.optionTransatlantic, value : 'transpacific'},
            { name : loc.cruise.optionWorldCruises, value : 'world-cruise'}
          ] //options
        }//optionGroup
      ]//optionGroups
    },
    preferredClass : {
      label : loc.perferredClassLabel,
      options : [
        { name : loc.preferredClassFirst, value : 'first'},
        { name : loc.preferredClassBusiness, value : 'business'},
        { name : loc.preferredClassEconomy, value : '', selected : 'selected'},
        { name : loc.preferredClassPremiumEconomy, value : 'premium'}
      ]
    },//preferredClass
    flightAdults : {
      label : loc.flightAdultsLabel,
      options : [
        { name : '1', value : '1', selected : 'selected' },
        { name : '2', value : '2' },
        { name : '3', value : '3' },
        { name : '4', value : '4' },
        { name : '5', value : '5' },
        { name : '6', value : '6' }
      ],
      inlineLabelOptions : [
        { name : '1 ' + loc.flightAdultsInlineLabel, value : '1', selected : 'selected' },
        { name : '2 ' + loc.flightAdultsInlineLabel, value : '2' },
        { name : '3 ' + loc.flightAdultsInlineLabel, value : '3' },
        { name : '4 ' + loc.flightAdultsInlineLabel, value : '4' },
        { name : '5 ' + loc.flightAdultsInlineLabel, value : '5' },
        { name : '6 ' + loc.flightAdultsInlineLabel, value : '6' }
      ]
    },
    flightChildren : {
      label : loc.flightChildrenLabel,
      options : [
        { name : '0', value : '0', selected : 'selected' },
        { name : '1', value : '1' },
        { name : '2', value : '2' },
        { name : '3', value : '3' },
        { name : '4', value : '4' },
        { name : '5', value : '5' },
        { name : '6', value : '6' }
      ],
      inlineLabelOptions : [
        { name : '0 ' + loc.flightChildrenInlineLabel, value : '0', selected : 'selected' },
        { name : '1 ' + loc.flightChildrenInlineLabel, value : '1' },
        { name : '2 ' + loc.flightChildrenInlineLabel, value : '2' },
        { name : '3 ' + loc.flightChildrenInlineLabel, value : '3' },
        { name : '4 ' + loc.flightChildrenInlineLabel, value : '4' },
        { name : '5 ' + loc.flightChildrenInlineLabel, value : '5' },
        { name : '6 ' + loc.flightChildrenInlineLabel, value : '6' }
      ]
    },
    rooms : {
      label : loc.hotelRoomsCountLabel,
      options : [
        { name : '1', value : '1', selected : 'selected'},
        { name : '2', value : '2' },
        { name : '3', value : '3' },
        { name : '4', value : '4' },
        { name : '5', value : '5' },
        { name : '6', value : '6' },
        { name : '7', value : '7' },
        { name : '8', value : '8' },
        { name : '9+', value : '9' }
      ],
      inlineLabelOptions : [
        { name : '1 ' + loc.hotelRoomsCountLabel, value : '1', selected : 'selected'},
        { name : '2 ' + loc.hotelRoomsCountLabel, value : '2' },
        { name : '3 ' + loc.hotelRoomsCountLabel, value : '3' },
        { name : '4 ' + loc.hotelRoomsCountLabel, value : '4' },
        { name : '5 ' + loc.hotelRoomsCountLabel, value : '5' },
        { name : '6 ' + loc.hotelRoomsCountLabel, value : '6' },
        { name : '7 ' + loc.hotelRoomsCountLabel, value : '7' },
        { name : '8 ' + loc.hotelRoomsCountLabel, value : '8' },
        { name : '9+ ' + loc.hotelRoomsCountLabel, value : '9' }
      ]
    },
    hotelAdults : {
      label : loc.flightAdultsLabel,
      options : [
        { name : '1', value : '1' },
        { name : '2', value : '2', selected : 'selected'},
        { name : '3', value : '3' },
        { name : '4', value : '4' },
        { name : '5', value : '5' },
        { name : '6', value : '6' },
        { name : '7', value : '7' },
        { name : '8', value : '8' },
        { name : '9', value : '9' },
        { name : '10', value : '10' },
        { name : '11', value : '11' },
        { name : '12', value : '12' },
        { name : '13', value : '13' },
        { name : '14', value : '14' }
      ],
      inlineLabelOptions : [
        { name : '1 ' + loc.flightAdultsInlineLabel, value : '1' },
        { name : '2 ' + loc.flightAdultsInlineLabel, value : '2', selected : 'selected'},
        { name : '3 ' + loc.flightAdultsInlineLabel, value : '3' },
        { name : '4 ' + loc.flightAdultsInlineLabel, value : '4' },
        { name : '5 ' + loc.flightAdultsInlineLabel, value : '5' },
        { name : '6 ' + loc.flightAdultsInlineLabel, value : '6' },
        { name : '7 ' + loc.flightAdultsInlineLabel, value : '7' },
        { name : '8 ' + loc.flightAdultsInlineLabel, value : '8' },
        { name : '9 ' + loc.flightAdultsInlineLabel, value : '9' },
        { name : '10 ' + loc.flightAdultsInlineLabel, value : '10' },
        { name : '11 ' + loc.flightAdultsInlineLabel, value : '11' },
        { name : '12 ' + loc.flightAdultsInlineLabel, value : '12' },
        { name : '13 ' + loc.flightAdultsInlineLabel, value : '13' },
        { name : '14 ' + loc.flightAdultsInlineLabel, value : '14' }
      ]
    },
    hotelGuests : {
      label : 'Guests',
      options : [
        { name : '2 adults, 0 children', value : '2', selected : 'selected'},
        { name : '1 adult, 0 children', value : '1' },
        { name : 'More options', value : '99' }
      ]
    },
    hotelChildren : {
      label : loc.flightChildrenLabel,
      options : [
        { name : '0', value : '0', selected : 'selected' },
        { name : '1', value : '1'},
        { name : '2', value : '2'},
        { name : '3', value : '3' },
        { name : '4', value : '4' },
        { name : '5', value : '5' },
        { name : '6', value : '6' }
      ],
      inlineLabelOptions : [
        { name : '0 ' + loc.flightChildrenInlineLabel, value : '0', selected : 'selected' },
        { name : '1 ' + loc.flightChildrenInlineLabel, value : '1'},
        { name : '2 ' + loc.flightChildrenInlineLabel, value : '2'},
        { name : '3 ' + loc.flightChildrenInlineLabel, value : '3' },
        { name : '4 ' + loc.flightChildrenInlineLabel, value : '4' },
        { name : '5 ' + loc.flightChildrenInlineLabel, value : '5' },
        { name : '6 ' + loc.flightChildrenInlineLabel, value : '6' }
      ]
    },
    threePPAdults : {
      label : loc.flightAdultsLabel,
      options : [
        { name : '1', value : '1' },
        { name : '2', value : '2', selected : 'selected'},
        { name : '3', value : '3' },
        { name : '4', value : '4' },
        { name : '5', value : '5' },
        { name : '6', value : '6' },
        { name : '7', value : '7' },
        { name : '8', value : '8' },
        { name : '9', value : '9' },
        { name : '10', value : '10' },
        { name : '11', value : '11' },
        { name : '12', value : '12' },
        { name : '13', value : '13' },
        { name : '14', value : '14' }
      ]
    },
    threePPChildren : {
      label : loc.flightChildrenLabel,
      options : [
        { name : '0', value : '0', selected : 'selected' },
        { name : '1', value : '1'},
        { name : '2', value : '2'},
        { name : '3', value : '3' },
        { name : '4', value : '4' },
        { name : '5', value : '5' },
        { name : '6', value : '6' }
      ]
    },
    childAges : {
      label : loc.childAgesLabel,
      options : [
        { name : loc.childAgesDefault, value : 'null', selected : 'selected' },
        { name : loc.childUnder1, value : '0'},
        { name : '1', value : '1'},
        { name : '2', value : '2'},
        { name : '3', value : '3' },
        { name : '4', value : '4' },
        { name : '5', value : '5' },
        { name : '6', value : '6' },
        { name : '7', value : '7' },
        { name : '8', value : '8' },
        { name : '9', value : '9' },
        { name : '10', value : '10' },
        { name : '11', value : '11' },
        { name : '12', value : '12' },
        { name : '13', value : '13' },
        { name : '14', value : '14' },
        { name : '15', value : '15' },
        { name : '16', value : '16' },
        { name : '17', value : '17' }
      ]
    },
    threePPHotelSelect : {
      options : [
        { name : loc.threePP.hotelSelectLabel, value : '' }
      ]
    },
    threePPHotelQuality : {
      options : [
        { name : loc.threePP.hotelQualityLabel, value : '' }
      ]
    },
    rail: {
      nbChildren: [
        {name: '0', value: '0', selected : 'selected' },
        {name: '1', value: '1'},
        {name: '2', value: '2'},
        {name: '3', value: '3'},
        {name: '4', value: '4'},
        {name: '5', value: '5'},
        {name: '6', value: '6'},
        {name: '7', value: '7'},
        {name: '8', value: '8'}
      ],
      nbYouths: [
        {name: '0', value: '0', selected: 'selected'},
        {name: '1', value: '1'},
        {name: '2', value: '2'},
        {name: '3', value: '3'},
        {name: '4', value: '4'},
        {name: '5', value: '5'},
        {name: '6', value: '6'},
        {name: '7', value: '7'},
        {name: '8', value: '8'}
      ],
      nbSeniors: [
        {name: '0', value: '0', selected: 'selected'},
        {name: '1', value: '1'},
        {name: '2', value: '2'},
        {name: '3', value: '3'},
        {name: '4', value: '4'},
        {name: '5', value: '5'},
        {name: '6', value: '6'},
        {name: '7', value: '7'},
        {name: '8', value: '8'}
      ],
      nbAdults: [
        {name: '0', value: '0'},
        {name: '1', value: '1', selected: 'selected'},
        {name: '2', value: '2'},
        {name: '3', value: '3'},
        {name: '4', value: '4'},
        {name: '5', value: '5'},
        {name: '6', value: '6'},
        {name: '7', value: '7'},
        {name: '8', value: '8'}
      ],
      time: [
        {name: loc.rail.timeName0000, value: '0000', selected: 'selected'},
        {name: loc.rail.timeName0030, value: '0030'},
        {name: loc.rail.timeName0100, value: '0100'},
        {name: loc.rail.timeName0130, value: '0130'},
        {name: loc.rail.timeName0200, value: '0200'},
        {name: loc.rail.timeName0230, value: '0230'},
        {name: loc.rail.timeName0300, value: '0300'},
        {name: loc.rail.timeName0330, value: '0330'},
        {name: loc.rail.timeName0400, value: '0400'},
        {name: loc.rail.timeName0430, value: '0430'},
        {name: loc.rail.timeName0500, value: '0500'},
        {name: loc.rail.timeName0530, value: '0530'},
        {name: loc.rail.timeName0600, value: '0600'},
        {name: loc.rail.timeName0630, value: '0630'},
        {name: loc.rail.timeName0700, value: '0700'},
        {name: loc.rail.timeName0730, value: '0730'},
        {name: loc.rail.timeName0800, value: '0800'},
        {name: loc.rail.timeName0830, value: '0830'},
        {name: loc.rail.timeName0900, value: '0900'},
        {name: loc.rail.timeName0930, value: '0930'},
        {name: loc.rail.timeName1000, value: '1000'},
        {name: loc.rail.timeName1030, value: '1030'},
        {name: loc.rail.timeName1100, value: '1100'},
        {name: loc.rail.timeName1130, value: '1130'},
        {name: loc.rail.timeName1200, value: '1200'},
        {name: loc.rail.timeName1230, value: '1230'},
        {name: loc.rail.timeName1300, value: '1300'},
        {name: loc.rail.timeName1330, value: '1330'},
        {name: loc.rail.timeName1400, value: '1400'},
        {name: loc.rail.timeName1430, value: '1430'},
        {name: loc.rail.timeName1500, value: '1500'},
        {name: loc.rail.timeName1530, value: '1530'},
        {name: loc.rail.timeName1600, value: '1600'},
        {name: loc.rail.timeName1630, value: '1630'},
        {name: loc.rail.timeName1700, value: '1700'},
        {name: loc.rail.timeName1730, value: '1730'},
        {name: loc.rail.timeName1800, value: '1800'},
        {name: loc.rail.timeName1830, value: '1830'},
        {name: loc.rail.timeName1900, value: '1900'},
        {name: loc.rail.timeName1930, value: '1930'},
        {name: loc.rail.timeName2000, value: '2000'},
        {name: loc.rail.timeName2030, value: '2030'},
        {name: loc.rail.timeName2100, value: '2100'},
        {name: loc.rail.timeName2130, value: '2130'},
        {name: loc.rail.timeName2200, value: '2200'},
        {name: loc.rail.timeName2230, value: '2230'},
        {name: loc.rail.timeName2300, value: '2300'},
        {name: loc.rail.timeName2330, value: '2330'}
      ],
      cardCount: [
        {name: '1', value: '1', selected: 'selected'},
        {name: '2', value: '2'},
        {name: '3', value: '3'},
        {name: '4', value: '4'},
        {name: '5', value: '5'},
        {name: '6', value: '6'},
        {name: '7', value: '7'},
        {name: '8', value: '8'}
      ],
      searchBy: [
        {name: loc.rail.departAt, value: "DEPARTURE", selected: 'selected'},
        {name: loc.rail.arriveBy, value: "ARRIVAL"}
      ]
    }
  };
});

define('gc/conf', ['gc/confFun', 'gc/wizardConfig', 'gc/defaultConfig'], function(confFun, wizardConfig, defaultConfig) {
  return confFun(wizardConfig, defaultConfig);
})

define('gc/confFun', [
  'gc/merge',
  'gc/activityConfig',
  'gc/carConfig',
  'gc/cruiseConfig',
  'gc/flightCarConfig',
  'gc/flightConfig',
  'gc/hotelCarConfig',
  'gc/hotelConfig',
  'gc/packageConfig',
  'gc/flightHotelConfig',
  'gc/flightHotelCarConfig',
  'gc/threePPConfig',
  'gc/wizardConfig',
  'gc/confOverride'
], function(
  merge,
  activityConfig,
  carConfig,
  cruiseConfig,
  flightCarConfig,
  flightConfig,
  hotelCarConfig,
  hotelConfig,
  packageConfig,
  flightHotelConfig,
  flightHotelCarConfig,
  threePPConfig,
  wizardConfig,
  confOverride
) {
  return function(wizardConfig, defaultConfig) {
    function extendWithWizardConfig(id, config) {
        return (wizardConfig[id] ? merge(config, wizardConfig[id]) : config);
    }
    var conf = {
        activity: extendWithWizardConfig('activity', activityConfig),
        car: extendWithWizardConfig('car', carConfig),
        cruise: extendWithWizardConfig('cruise', cruiseConfig),
        def: extendWithWizardConfig('def', defaultConfig),
        flightCar: extendWithWizardConfig('flightCar', flightCarConfig),
        flight: extendWithWizardConfig('flight', flightConfig),
        hotelCar: extendWithWizardConfig('hotelCar', hotelCarConfig),
        hotel: extendWithWizardConfig('hotel', hotelConfig),
        'package': extendWithWizardConfig('package', packageConfig),
        flightHotel: extendWithWizardConfig('flightHotel', flightHotelConfig),
        flightHotelCar: extendWithWizardConfig('flightHotelCar', flightHotelCarConfig),
        threePP: extendWithWizardConfig('threePP', threePPConfig),
        wizardconfig: wizardConfig
    };

    return merge(conf, confOverride);
  }
});

define('gc/defaultConstraints', [
  'gc/loc',
  'gc/abTest',
  'underscore',
  'gc/getLob'
], function(
  loc,
  abTest,
  _,
  getLob
) {
  return {
      'switches': loc.masterconfig && loc.masterconfig.switches,
      'tab': function(state, config) {
          if (!state.get('tab')) {
            return config.defaultTab;
          }
          return state.get('tab');
      },
      'showValueProp': function (state, config) {
          'use strict';
          return config.get('showValueProp');
      },
      'id': function (state) {
          'use strict';
          return state.get('tab');
      },
      "isHotelTabWithMaxThreeRooms":function(state, config) {
          'use strict';
          return !(state.get('roomCount') > 3) && state.get('tab') === 'hotel';
      },
      'lastValidDate': function (state, config) {
          'use strict';
          var date = new XDate();
          date.addDays(config.get('calendar.furthestBookingDayOut'));
          return date.toString(config.get('dateFormat'));
      },
      'firstValidDate': function (state, config) {
          'use strict';
          var date = new XDate();
          date.addDays(config.get('calendar.earliestBookingDay'));
          return date.toString(config.get('dateFormat'));
      },
      'minTripLength': function (state, config) {
          'use strict';
          return config.get('calendar.minTripLength');
      },
      'maxTripLength': function (state, config) {
          'use strict';
          return config.get('calendar.maxTripLength');
      },
      'destinationNotCuba': function (state, config) {
          'use strict';
          if(!corewizard.masterconfig.trivagoRedirectionEnabled) {
              return true;
          }
          var regionId = state.get('regionId');
          return !(state.get('tab') === 'hotel' && regionId <= -1000);
      },
      'timeValues': function (state, config) {
          return [
              {key: loc.carOptionsLoc.timeValue0000, value: "1200AM"}, {key: loc.carOptionsLoc.timeValue0030, value: "1230AM"}, {key: loc.carOptionsLoc.timeValue0100, value: "100AM"},  {key: loc.carOptionsLoc.timeValue0130, value: "130AM"},
              {key: loc.carOptionsLoc.timeValue0200, value: "200AM"},  {key: loc.carOptionsLoc.timeValue0230, value: "230AM"},  {key: loc.carOptionsLoc.timeValue0300, value: "300AM"},  {key: loc.carOptionsLoc.timeValue0330, value: "330AM"},
              {key: loc.carOptionsLoc.timeValue0400, value: "400AM"},  {key: loc.carOptionsLoc.timeValue0430, value: "430AM"},  {key: loc.carOptionsLoc.timeValue0500, value: "500AM"},  {key: loc.carOptionsLoc.timeValue0530, value: "530AM"},
              {key: loc.carOptionsLoc.timeValue0600, value: "600AM"},  {key: loc.carOptionsLoc.timeValue0630, value: "630AM"},  {key: loc.carOptionsLoc.timeValue0700, value: "700AM"},  {key: loc.carOptionsLoc.timeValue0730, value: "730AM"},
              {key: loc.carOptionsLoc.timeValue0800, value: "800AM"},  {key: loc.carOptionsLoc.timeValue0830, value: "830AM"},  {key: loc.carOptionsLoc.timeValue0900, value: "900AM"},  {key: loc.carOptionsLoc.timeValue0930, value: "930AM"},
              {key: loc.carOptionsLoc.timeValue1000, value: "1000AM"}, {key: loc.carOptionsLoc.timeValue1030, value: "1030AM"}, {key: loc.carOptionsLoc.timeValue1100, value: "1100AM"}, {key: loc.carOptionsLoc.timeValue1130, value: "1130AM"},
              {key: loc.carOptionsLoc.timeValue1200, value: "1200PM"}, {key: loc.carOptionsLoc.timeValue1230, value: "1230PM"}, {key: loc.carOptionsLoc.timeValue1300, value: "100PM"},  {key: loc.carOptionsLoc.timeValue1330, value: "130PM"},
              {key: loc.carOptionsLoc.timeValue1400, value: "200PM"},  {key: loc.carOptionsLoc.timeValue1430, value: "230PM"},  {key: loc.carOptionsLoc.timeValue1500, value: "300PM"},  {key: loc.carOptionsLoc.timeValue1530, value: "330PM"},
              {key: loc.carOptionsLoc.timeValue1600, value: "400PM"},  {key: loc.carOptionsLoc.timeValue1630, value: "430PM"},  {key: loc.carOptionsLoc.timeValue1700, value: "500PM"},  {key: loc.carOptionsLoc.timeValue1730, value: "530PM"},
              {key: loc.carOptionsLoc.timeValue1800, value: "600PM"},  {key: loc.carOptionsLoc.timeValue1830, value: "630PM"},  {key: loc.carOptionsLoc.timeValue1900, value: "700PM"},  {key: loc.carOptionsLoc.timeValue1930, value: "730PM"},
              {key: loc.carOptionsLoc.timeValue2000, value: "800PM"},  {key: loc.carOptionsLoc.timeValue2030, value: "830PM"},  {key: loc.carOptionsLoc.timeValue2100, value: "900PM"},  {key: loc.carOptionsLoc.timeValue2130, value: "930PM"},
              {key: loc.carOptionsLoc.timeValue2200, value: "1000PM"}, {key: loc.carOptionsLoc.timeValue2230, value: "1030PM"}, {key: loc.carOptionsLoc.timeValue2300, value: "1100PM"}, {key: loc.carOptionsLoc.timeValue2330, value: "1130PM"}
          ];
      },
      'pickup': function (state, config) {
          'use strict';
          return state.get('destination');
      },
      'dropoff': function (state, config) {
          'use strict';
          return loc.masterconfig.switches.enableCarOffairportOnewaySearch ? state.get('carReturn') :
              !state.get('TASearchType') || state.get('TASearchType') === 'AIRPORT' ?
                  state.get('carReturn') : '';
      },
      'lobs': function(state, config) {
          'use strict';
          var conf = config.attributes;
          return _.map(conf.wizardconfig.lobs, function(lob) {
              var packageData = (conf[lob.id].model && conf[lob.id].model.packages) || {};
              var carsData = (conf[lob.id].model && conf[lob.id].model.cars) || {};
              var activitiesData = (conf[lob.id].model && conf[lob.id].model.activities) || {};
              var isCurrentTab;
              // For bugfix eph_414
              if(state.get('tab') === 'package'){
                  // For package, make sure the right lob get highlighted correctly
                  isCurrentTab = (!this.get('isSoftPackage') && lob.id === this.get('lob')) || lob.id === state.get('tab') || lob.id === getLob(state.get('tab'), state.get('packages'));
              } else {
                  // For softPackage only, the tab will stay at the hotels and flights tab, we don't need use the getLob
                  isCurrentTab = (!this.get('isSoftPackage') && lob.id === this.get('lob')) || lob.id === state.get('tab');
              }
              return {
                  tab:            lob.isPackage ? 'package' : lob.id,
                  'tab-id':       lob.id,
                  link:           conf[lob.id].link || 'javascript:void(0)',
                  icon:           lob.icon || conf[lob.id].icon,
                  label:          lob.id == "openSearch" ? ((abTest.get(11394).value === 1) ? 'Explore' : ((abTest.get(11394).value === 2) ? 'Discover' : (lob.label || loc.tabLoc[lob.id]))) : (lob.label || loc.tabLoc[lob.id]),
                  isPackageTab:   lob.id == "package",
                  isCarsTab:      lob.id == "car",
                  isActivityTab:  lob.id == "activity",
                  isCurrentTab:   isCurrentTab,
                  flightsPackage: String(!!packageData.flight),
                  hotelsPackage:  String(!!packageData.hotel),
                  carsPackage:    String(!!packageData.car),
                  trainsPackage:  String(!!packageData.train),
                  rentalCars:     String(!!carsData.rentalCars),
                  airportRides:   String(!!carsData.airportRides),
                  lxThingsTodo:   String(!!activitiesData.lxThingsTodo),
                  lxAirportRides: String(!!activitiesData.lxAirportRides)
              };
          }, this);
      },
      'showTabs': function(state, config) {
          'use strict';
          var wizardconfig = config.attributes.wizardconfig;
          return wizardconfig.lobs.length > 1 || wizardconfig.lobs[0].id === 'package';
      }
  };
});

define('gc/defaultConfig', [
    'gc/defaultConfigOverride',
    'gc/modelHelpers',
    'gc/loc',
    'gc/abTest',
    'gc/searchExperiments',
    'gc/wizardConfig',
    'underscore',
    'gc/defaultConstraints',
    'gc/getLob'
], function(
    defaultConfigOverride,
    modelHelpers,
    loc,
    abTest,
    searchExperiments,
    wizardConfig,
    _,
    defaultConstraints,
    getLob
) {
    var defaultConfig = {
        defaultLob: (function(){
          return _.find(wizardConfig.lobs, function(lob) {
            return lob.defaultLob;
          }).id;
        })(),
        searchUrlGenerator: 'eapAspSearchUrl',
        masterconfig: loc.masterconfig,
        model: {
            tab : (function(){
              return _.find(wizardConfig.lobs, function(lob) {
                return lob.defaultLob;
              }).id;
            })(),
            isInitialized : false,
            isValidated : false,
            initConfigDone : false,
            hasFailedValidation : false,
            hasSuccessfullySubmitted : false,
            origin: "",
            //          region: "", // TODO: do we use this anywhere yet?
            validation:{isValid:true},
            destination: "",
            showFlightOptions: false,
            userDeniedGeoLocation: false,
            cruiseDestination:"",
            cruiseMonth:"",
            cruiseEarliestDepartureDate:"",
            cruiseLatestDepartureDate:"",
            departing: undefined,
            returning: undefined,  // if this is just "return" instead of "returning", the minify script breaks, despite being legal JS
            checkin: undefined, // TODO: is there a point to having these separate from departing/returning?
            checkout: undefined,
            //          pickupTime: "12:00 AM",
            //          dropoffTime: "12:00 AM",
            rooms: [{adults: -1, // -1 adults because flight and hotel have different defaults
                children: [], // age must be wrapped in an object because it will need an id etc. when it's made into context later
                childCount: 0,
                youths: [],
                youthCount: 0,
                seniors: [],
                seniorCount: 0}],
            roomCount: 1,
            isChildInLap: true,
            flighttype: "roundtrip", // if lob is flight this can have: "roundtrip", "oneway", or "multi"
            railtype: "oneway",
            railCardContent:[],
            hotelId: null, // from type ahead we may get the hotel ID
            hotelNameFromTA: "",
            regionId: null, // from type ahead we may get the region
            tla: null, // from type ahead we may get the TLA
            noDate: false, // hotel "i don't know my dates" checkbox
            packages: {
                //allowFlightTabAddHotelOption: true,
                //allowFlightTabAddCarOption: true,
                hotel: false,
                car: false,
                flight: false
            }, // set a package to true if soft package add-on for that lob is being displayed.
            carPickupValueFromTA: "",
            showCarOptions: false,
            startTime: "1030AM",
            endTime: "1030AM",
            carShowDropOff: true,
            carDiscountCode: "0",
            carVendor: "",
            carType: 1,
            carSearchType: 4,
            carSkirack: false,
            carInfantseat: false,
            isCarDriverAgeWithinLimit:true,
            driverAgeTooltipSelected: false,
            driverAge: '25',
            carToddlerseat: false,
            carChains: false,
            carLefthand: false,
            carRighthand: false,
            carNavigation: false,
            carRateCode: "",
            carCouponCode: "",
            carOtherCode: "",
            carCorpCode: "",
            train: {
                departTime: "362",
                returnTime: "362"
            },
            showTabs: true,
            trainOrigin:'',
            trainDestination:'',
            _xpid: '11905|0'
        },
        typeahead : {
            def: {
                minchar: 3,
                maxitems: 10,
                version: 'v1',
                locale: 'en_US',
                mask: 95,
                client: 'HOMEPAGE',
                closetext: 'Close',
                continuetext: 'Continue typing to refine search',
                tooltip: true,
                forceicon: false,
                template: 'default',
                regionid: 1,
                cheapHotelsText: 'Cheap hotels',
                cheapHotelsInText: 'Cheap hotels in',
                bestDealsText: 'Best deals',
                bestDealsInText: 'Best deals in'
            },
            origin : {
                dest: false
            },
            dest : {
                dest: true
            }
        },
        events : {
            'UI:packageLob': 'trackLobClick',
            'UI:tab': 'trackLobClickDelayed',
            'UI:softPackageCheckbox': 'trackLobClick',
            'tab': [searchExperiments.resetTypeaheadState, 'reloadWizard'],
            'flighttype': [searchExperiments.flighttypeChanged,'reloadWizard'],
            'rail.type': 'reloadWizard',
            'rail.nbpax.child': 'reloadWizard',
            'rail.nbpax.youth': 'reloadWizard',
            'rail.cards': 'reloadWizard',
            'packages': [searchExperiments.resetTypeaheadState, 'reloadWizard'],
            'children': 'reloadWizard',
            'youths': 'reloadWizard',
            'showCarOptions': 'reloadWizard',
            'carDiscountCode': 'reloadWizard',
            'carVendor': 'reloadWizard',
            'carType': 'reloadWizard',
            '#rooms.count': 'reloadWizard',
            '#rooms.remove': 'reloadWizard',
            'changeTab': 'reloadWizard',
            'roomCount': 'reloadWizard',
            'rooms[0].childCount': [modelHelpers.childCountChanged, 'reloadWizard'],
            'rooms[1].childCount': [modelHelpers.childCountChanged, 'reloadWizard'],
            'rooms[2].childCount': [modelHelpers.childCountChanged, 'reloadWizard'],
            'rooms[3].childCount': [modelHelpers.childCountChanged, 'reloadWizard'],
            'rooms[4].childCount': [modelHelpers.childCountChanged, 'reloadWizard'],
            'rooms[5].childCount': [modelHelpers.childCountChanged, 'reloadWizard'],
            'rooms[6].childCount': [modelHelpers.childCountChanged, 'reloadWizard'],
            'rooms[7].childCount': [modelHelpers.childCountChanged, 'reloadWizard'],
            'rooms[0].children': 'reloadWizard',
            'rooms[1].children': 'reloadWizard',
            'rooms[2].children': 'reloadWizard',
            'rooms[3].children': 'reloadWizard',
            'rooms[4].children': 'reloadWizard',
            'rooms[5].children': 'reloadWizard',
            'rooms[6].children': 'reloadWizard',
            'rooms[7].children': 'reloadWizard',
            'rooms[0].youths': 'reloadWizard',
            'rooms[0].youthCount': 'reloadWizard',
            'rooms[0].seniors': 'reloadWizard',
            'rooms[0].seniorCount': 'reloadWizard',
            'guestMoreOptionsSelected' : [modelHelpers.guestsChanged, 'reloadWizard'],
            'noDate': 'reloadWizard',
            'isPartialStay': 'reloadWizard',
            'showFlightOptions':'reloadWizard',
            'isChildInLap' : 'reloadWizard',
            'showThreePPOptions' : 'reloadWizard',
            'showCruiseOptions' : 'reloadWizard',
            'userDeniedGeoLocation' : 'reloadWizard',
            'carSkirack' : 'reloadWizard',
            'carInfantseat' : 'reloadWizard',
            'carToddlerseat' : 'reloadWizard',
            'carChains' : 'reloadWizard',
            'carLefthand' : 'reloadWizard',
            'carRighthand' : 'reloadWizard',
            'carNavigation' : 'reloadWizard',
            'isCarDriverAgeWithinLimit' : ['isDriverAgeCheckboxStatusChanged', 'reloadWizard'],
            'driverAgeTooltipSelected': ['driverAgeTooltipClicked'],
            'submit' : 'submit',
            'UI:carReturnInput' :   'hideHotelSelectionForCars'
        },
        calendar: {
            'maxTripLength': 329,
            'minTripLength': 0,
            'earliestBookingDay': 0,
            'furthestBookingDayOut': 329,
            months: (typeof loc.calendar.months === 'string') ? loc.calendar.months.split(",") : loc.calendar.months,
            format : {
                date: loc.calendar.dateFormat || "mmddyy",
                delimiter : loc.calendar.dateSeparator || "/"
            },
            unit : {
                sow: parseInt(loc.calendar.startDayOfTheWeek),
                singleMonths: (typeof loc.calendar.singleMonths === 'string') ? loc.calendar.singleMonths.split(",") : loc.calendar.singleMonths,
                month: (typeof loc.calendar.shortMonths === 'string') ? loc.calendar.shortMonths.split(",") : loc.calendar.shortMonths,
                day: (typeof loc.calendar.daysOfTheWeek === 'string') ? loc.calendar.daysOfTheWeek.split(",") : loc.calendar.daysOfTheWeek,
                dayNames: (typeof loc.calendar.dayNames === 'string') ? loc.calendar.dayNames.split(",") : loc.calendar.dayNames,
                shortDays: (typeof loc.calendar.shortDays === 'string') ? loc.calendar.shortDays.split("#") : loc.calendar.shortDays
            },
            text: {
                close: loc.calendar.closeLink || "close",
                nights: (typeof loc.calendar.nightsTexts === 'string') ? loc.calendar.nightsTexts.split(",") : loc.calendar.nightsTexts
            }
        },
        travelers: {
            infantAge: 1,
            defaultChildAge: "",
            maxTravelers: 6,
            ninePlusRoomsAllowed : true,
            maxChildren : 6,
            defaultNumAdults : 2
        },
        dateFormat: loc.calendar.dateFormatWithSeparator || "MM/dd/yyyy",
        userVisibleDateFormat: loc.calendar.userVisibleDateFormat || "mm/dd/yyyy",
        validation: {},
        showPackageValueMessageLobs: ['flightHotel', 'flightHotelCar', 'flightCar', 'hotelCar'],
        showPackageSavingsDisclaimer: false,
        airlineAgeRulesLink: '/p/info-main/h_fw_default?rhtx=HTX_FLTSRCH_RT#travs',
        brand: 'Expedia',
        constraints : defaultConstraints,
        viewRules: {
            'formTitle' : function(model) {
                'use strict';
                // TODO Fix this, do not read for globals inside the viewRules
                return model.get('config.formTitleOverride') ||
                  ((loc.formTitle[getLob(model.get('tab'), model.get('packages'))]) ?
                    loc.formTitle[getLob(model.get('tab'), model.get('packages'))] :
                    '');
            },
            'wizardTitle': function (model) {
                'use strict';
                return model.get('wizardTitle') ||
                       model.get('config.wizardTitle') ||
                       "";
            },
            'wizardTemplate': function (model) {
                var templateName = model.get('config.template');
                return templateName;
            },
            'getTitle':function(model){
                var lob = getLob(model.get('tab'), model.get('packages'));
                return loc.formTitle[lob];
            },
            'destinationError': function(model) {
                'use strict';
                return _.contains(model.get('validation.fields'), 'destination');
            },
            'openSearchError': function(model) {
                'use strict';
                return _.contains(model.get('validation.fields'), 'searchQuery');
            },
            'originError': function(model) {
                'use strict';
                return _.contains(model.get('validation.fields'), 'origin');
            },
            'startDateError': function(model) {
                'use strict';
                return _.contains(model.get('validation.fields'), 'startDate');
            },
            'startDateHotelError': function(model) {
                'use strict';
                return _.contains(model.get('validation.fields'), 'startDate');
            },
            'endDateError': function(model) {
                'use strict';
                return _.contains(model.get('validation.fields'), 'endDate');
            },
            'endDateHotelError': function(model) {
                'use strict';
                return _.contains(model.get('validation.fields'), 'endDate');
            },
            'startTimeError': function(model) {
                'use strict';
                return _.contains(model.get('validation.fields'), 'startTime');
            },
            'endTimeError': function(model) {
                'use strict';
                return _.contains(model.get('validation.fields'), 'endTime');
            },
            'multiDestDateErrorMessage': function(model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'date-comes-before-previous');
            },
            'multiDestDateErrorMessage2': function(model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'date-comes-before-previous-2');
            },
            'multiDestDateErrorMessage3': function(model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'date-comes-before-previous-3');
            },
            'multiDestDateErrorMessage4': function(model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'date-comes-before-previous-4');
            },
            'multiDestDateErrorMessage5': function(model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'date-comes-before-previous-5');
            },
            'destinationErrorMessage': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'destination-blank');
            },
            'destinationErrorMessage2': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'destination-blank-2');
            },
            'destinationErrorMessage3': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'destination-blank-3');
            },
            'destinationErrorMessage4': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'destination-blank-4');
            },
            'destinationErrorMessage5': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'destination-blank-5');
            },
            'openSearchErrorMessage': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'search-query-blank');
            },
            'originErrorMessage': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'origin-blank');
            },
            'originErrorMessage2': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'origin-blank-2');
            },
            'originErrorMessage3': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'origin-blank-3');
            },
            'originErrorMessage4': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'origin-blank-4');
            },
            'originErrorMessage5': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'origin-blank-5');
            },
            'originAndDestinationSameMessage': function(model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'origin-same');
            },
            'originAndDestinationSameMessage2': function(model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'origin-same-2');
            },
            'originAndDestinationSameMessage3': function(model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'origin-same-3');
            },
            'originAndDestinationSameMessage4': function(model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'origin-same-4');
            },
            'originAndDestinationSameMessage5': function(model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'origin-same-5');
            },
            'dateBlankMessage': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'date-blank');
            },
            'dateBlankMessage2': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'date-blank-2');
            },
            'dateBlankMessage3': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'date-blank-3');
            },
            'dateBlankMessage4': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'date-blank-4');
            },
            'dateBlankMessage5': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'date-blank-5');
            },
            'dateFormatInvalidMessage': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'date-format-invalid');
            },
            'dateFormatInvalidMessage2': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'date-format-invalid-2');
            },
            'dateFormatInvalidMessage3': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'date-format-invalid-3');
            },
            'dateFormatInvalidMessage4': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'date-format-invalid-4');
            },
            'dateFormatInvalidMessage5': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'date-format-invalid-5');
            },
            'dateRangeTooLongErrorMessage': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'trip-length-invalid');
            },
            'dateOutOfRangeMessage' : function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'date-range-long');
            },
            'dateBeforeCurrentDateMessage' : function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'date-before-today');
            },
            'childAgeMessage': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'child-ages-not-all-provided');
            },
            'numberOfTravellersMessage': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'too-many-travelers');
            },
            'numberOfRailTravellersMessage': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'too-many-rail-travelers');
            },
            'numberOfRailTravellersZeroMessage': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'zero-rail-travelers');
            },
            'railYouthAgeMessage': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'youth-ages-not-all-provided');
            },
            'railSeniorAgeMessage': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'senior-ages-not-all-provided');
            },
            'railChildAgeMessage': function (model) {
              'use strict';
              return _.contains(model.get('validation.errors'), 'child-alone-too-young');
            },
            'railChildTravelingWithChildMessage' : function (model) {
              'use strict';
              return _.contains(model.get('validation.errors'),'child-cant-travel-with-child');
            },
            'railCardExceedAmt': function (model) {
              'use strict';
              return _.contains(model.get('validation.errors'), 'too-many-rail-cards');
            },
            'dateTimeRangeMessage': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'time-too-short');
            },
            'railDateTimeRangeMessage': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'rail-time-too-short');
            },
            'pickupDateTimeMessage': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'pickup-time-too-soon');
            },
            'partialStayDatesOutOfRange': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'checkin-checkout-range');
            },
            'isOriginValueEmpty': function (model) {
                'use strict';
                return false;
            },
            'isDestinationValueEmpty': function (model) {
                'use strict';
                return false;
            },
            'isCarReturnValueEmpty': function (model) {
                'use strict';
                return false;
            },
            'isStartDateValueEmpty': function (model) {
                'use strict';
                return false;
            },
            'isEndDateValueEmpty': function (model) {
                'use strict';
                return false;
            },
            'isCheckInValueEmpty': function (model) {
                'use strict';
                return false;
            },
            'isCheckOutValueEmpty': function (model) {
                'use strict';
                return false;
            },
            'isSearchQueryValueEmpty': function (model) {
                'use strict';
                return false;
            },
            'dateCarOutOfRangeMessage' : function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'date-car-range-long');
            },

            'dateCarOutOfRangeMessageText' : function (model) {
                'use strict';
                var dateCarOutOfRangeMessageText = loc.dateCarOutOfRangeMessageText || "";
                var maxTripLength =  model.get('maxTripLength') || 0;
                return dateCarOutOfRangeMessageText.replace('{{maxTripLength}}', maxTripLength + 1);
            },

            'dateOutOfRangeMessageText':function(model){
                'use strict';
                var dateOutOfRangeMessageText = loc.dateOutOfRangeMessageText
                  .replace('{{minCalendarDate}}', model.get('firstValidDate'))
                  .replace;('{{lastValidDate}}', model.get('lastValidDate'));
                return dateOutOfRangeMessageText;
            },
            'dateRangeTooLongErrorMessageText':function(model){
              'use strict';
               var dateRangeCompile = loc.dateRangeTooLongErrorMessageText.replace('{{maxTripLength}}', model.get('maxTripLength'));
               return dateRangeCompile;
            },

            'dateFormatInvalidMessageText':function(model){
                'use strict';
                var dateFormatInvalid = loc.dateFormatInvalidMessageText.replace('{{dateFormat}}', model.get('config.dateFormat'));
                return dateFormatInvalid;
            },

            'showErrors': function (model) {
                'use strict';
                return !model.get('validation.isValid');
            },

            'isFlightTab': function (model) {
                'use strict';
                return model.get('tab') === 'flight';
            },
            'isHotelTab': function (model) {
                'use strict';
                return model.get('tab') === 'hotel';
            },

            'dateFormat': function (model) {
                'use strict';
                return model.get('config.userVisibleDateFormat');
            },
            'maxTripLength': function (model) {
                'use strict';
                return model.get('config.calendar.maxTripLength');
            },
            'maxNumberofTravellers' : function (model) {
                'use strict';
                return model.get('config.travelers.maxTravelers');
            },
            'minCalendarDate' : function (model) {
                'use strict';
                var days = model.get('config.calendar.earliestBookingDay'),
                  date = new XDate();
                date.addDays(days);
                return date.toString(model.get('config.dateFormat'));
            },
            'maxCalendarDate': function (model) {
                'use strict';
                var days = model.get('config.calendar.furthestBookingDayOut'),
                  date = new XDate();
                date.addDays(days);
                return date.toString(model.get('config.dateFormat'));
            },
            'allowHotelTabAddFlightOption': function (model) {
                if (modelHelpers.mobileSuppress()) return;
                return true;
            },
            'allowHotelTabAddCarOption': function (model) {
                'use strict';
                if (modelHelpers.mobileSuppress()) return;
                if (typeof corewizard.masterconfig.validPackages == "undefined") {
                    corewizard.masterconfig.validPackages = {};
                    var tmp = loc.masterconfig.packageOrder.split(',');
                    for (var i = 0; i < tmp.length; i++) {
                        corewizard.masterconfig.validPackages[tmp[i]] = true;
                    }
                }
                return corewizard.masterconfig.validPackages["hc"];
            },
            'addCarAction' : function(model) {
                'use strict';
                return modelHelpers.getSoftPackageAction('car', model);
            },
            'addFlightAction' : function(model) {
                'use strict';
                return modelHelpers.getSoftPackageAction('flight', model);
            },
            'addHotelAction' : function(model) {
                'use strict';
                return modelHelpers.getSoftPackageAction('hotel', model);

            },
            'useBestPriceGuaranteeLogo' : function(model) {
                'use strict';
                return loc.masterconfig.switches.useBestPriceGuaranteeLogo;
            },
            'isLobWithPackageSavingsEnabled': function(model) {
                'use strict';
                var lob = getLob(model.get('tab'), model.get('packages'));
                var bucket = abTest.get(7808).value;
                return (bucket && bucket !== "0" ? lob === 'hotel' || lob === 'overseaHotel' || lob === 'flight' : false);
            },
            'showPackageValueMessage': function(model) {
                'use strict';
                return _.contains(model.get('config.showPackageValueMessageLobs'), getLob(model.get('tab'), model.get('packages')));
            },
            'showPackageSavingsDisclaimer' : function(model) {
                'use strict';
                return model.get('config.showPackageSavingsDisclaimer');
            },
            'airlineAgeRulesLink' : function(model) {
                'use strict';
                return model.get('config.airlineAgeRulesLink');
            },
            'hotelDestinationLabel': function(model) {
                'use strict';
                return loc.hotelDestinationLabel;
            },
            'hotelDestinationPlaceholder': function(model) {
                'use strict';
                return loc.hotelDestinationPlaceholder;
            },
            'flightOriginLabel': function(model) {
                'use strict';
                return loc.flightOriginLabel;
            },
            'flightDestinationLabel': function(model) {
                'use strict';
                return loc.flightDestinationLabel;
            },
            'flightLocationPlaceholder': function(model) {
                //This function can be removed as now there are separate placeholders for flights origin and destination
                'use strict';
                return loc.flightLocationPlaceholder;
            },
            'flightOriginPlaceholder': function(model) {
                'use strict';
                return loc.flightLocationPlaceholder;
            },
            'flightDestinationPlaceholder': function(model) {
                'use strict';
                return loc.flightLocationPlaceholder;
            },
            'flightOriginPlaceholderText': function(model) {
                'use strict';
                return loc.flightPlaceholderText;
            },
            'flightDestinationPlaceholderText': function(model) {
                'use strict';
                return loc.flightPlaceholderText;
            },
            'flightDepartingLabel': function(model) {
                'use strict';
                return loc.flightDepartingLabel;
            },
            'flightReturningLabel': function(model) {
                'use strict';
                return loc.flightReturningLabel;
            },
            'flightMultidestLabel': function(model){
                'use strict';
                return loc.flightMultidestLabel;
            },
            'loc' : function(model) {
                'use strict';
                return loc;
            },
            'hotelDestinationPlaceholderText': function(model) {
                'use strict';
                return loc.hotelDestinationPlaceholderText;
            },
            'hotelCheckinLabel': function(model) {
                'use strict';
                return loc.hotelCheckinLabel;
            },
            'hotelCheckoutLabel': function(model) {
                'use strict';
                return loc.hotelCheckoutLabel;
            },
            'hotelTabletValueProp' : function(model) {
                'use strict';
                return modelHelpers.getHotelTabletValueProp();
            },
            'hotelLengthOfStayString' : function(model) {
                //under AB test 6070
                var hasCheckinCheckout = !!model.get('checkin') && !!model.get('checkout');

                if (model.get('importedData') &&
                  (model.get('tab') !== 'flight') && !model.get('isSoftPackage')) {
                    hasCheckinCheckout = false;
                }

                var hotelStartDate = hasCheckinCheckout ? model.get('checkin') : model.get('startDate'),
                  hotelEndDate = hasCheckinCheckout ? model.get('checkout') : model.get('endDate')||'',
                  dateDifference,
                  daysToNights;

                if (hotelStartDate && isNaN(hotelEndDate)) {
                    hotelStartDate = new XDate(hotelStartDate),
                      hotelEndDate = new XDate(hotelEndDate),
                      dateDifference = hotelStartDate.diffDays(hotelEndDate),
                      daysToNights = dateDifference;
                    if (daysToNights === 1)
                        return String(daysToNights + ' Night')
                    else
                        return String(daysToNights + ' Nights')
                }
            },
            'allowFlightTabAddHotelOption': function (model) {
                if (site_id==1 && modelHelpers.mobileSuppress()) return;
                return true;
            },
            'allowFlightTabAddCarOption': function (model) {
                if (site_id==1 && modelHelpers.mobileSuppress()) return;
                return true;
            },
            'ab6555':function(){
                return abTest.get(6555).value;
            },
            'ab11873':function(model){
                return (abTest.get(11873).value !== 0);
            },
            'twoOrMoreRooms':function(model){
                return model.get('rooms') ? model.get('rooms').length > 1 : false;
            },
            'bpgModel': function(model) {
                return model.get('config.bpgModel');
            },
            'searchText' : loc.searchButtonText.defaultText,
            'fhMessage1Formatted': function(model){
                return loc.fhMessage1.replace(/#.*#/, model.get("config.package_price_savings"));
            },
            "carPickupLabel": function(model) {
                'use strict';
                return loc.carPickupLabel;
            },
            "carPickupPlaceholder": function(model) {
                'use strict';
                return corewizard.locPickupPlaceholder;
            },
            "carDropoffLabel": function(model) {
                'use strict';
                return loc.carDropoffLabel;
            },
            "carPickupPlaceholderText": function(model) {
                'use strict';
                return loc.carPickupPlaceholder;
            },
            "carDropoffPlaceholderText": function(model) {
                'use strict';
                return loc.carDropoffPlaceholder;
            },
            'addHotelsWithCar' : function(model) {
                'use strict';
                var savedDropOffLoc = model.get('carReturn');
                var isDropOffLocPresent = savedDropOffLoc && (savedDropOffLoc.length > 0);

                if(model.get('tab') === 'car') {
                    if(window.dctk && window.dctk.onReady) {
                        dctk.onReady(function () {
                            dctk.evaluateExperimentAndLog({"id": 11100});
                        });
                    }
                    return  (!isDropOffLocPresent && abTest.get(11100).value == 1);
                }
                return false;
            },
            'activityDestinationPlaceholderText': function(model) {
                'use strict';
                return loc.activityDestinationPlaceholder;
            },
            'startDateLabel': function(model) {
                'use strict';
                return loc.startDateLabel;
            },
            'endDateLabel': function(model) {
                'use strict';
                return loc.endDateLabel;
            },
            'railCardTypeMissingMessage': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'rails-card-type-not-provided');
            },
            'railOriginNotFromTAMessage': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'rails-origin-not-from-ta');
            },
            'railDestinationNotFromTAMessage': function (model) {
                'use strict';
                return _.contains(model.get('validation.errors'), 'rails-destination-not-from-ta');
            },
            'railsOriginErrors':function(model) {
                return _.contains(model.get('validation.errors'), 'rails-origin-not-from-ta') ||
                    _.contains(model.get('validation.fields'), 'trainOrigin');
            },
            'railsDestinationErrors':function(model){
                return _.contains(model.get('validation.errors'), 'rails-destination-not-from-ta') ||
                    _.contains(model.get('validation.fields'), 'trainDestination');
            },
            'showDriverAgeInvalidMessage':function(model){
                return _.contains(model.get('validation.errors'), 'driver-age-invalid');
            },
            'showDriverAgeBlankMessage':function(model){
                return _.contains(model.get('validation.errors'), 'driver-age-blank');
            },
            'driverAgeErrorOccured': function(model) {
                'use strict';
                return _.contains(model.get('validation.fields'), 'driverAge');
            },
            'driverAgeLabel': function(model) {
                'use strict';
                return "<span class='visuallyhidden'>" + loc.driverAgeAccessibilityLabel+ "</span><span aria-hidden='true'>" + loc.driverAgeLabel+ "</span>";
            }

        },
        addEvent: function (event, additionalEvent) {
            var defined = this.events[event];
            var eventArray = [];

            if (_.isArray(additionalEvent)) {
                eventArray = _.union(eventArray, additionalEvent);
            } else {
                eventArray.push(additionalEvent);
            }

            if (_.isArray(defined)) {
                eventArray = _.union(eventArray, defined);
            } else if(!_.isUndefined(defined)) {
                eventArray.push(defined);
            }

            this.events[event] = eventArray;

        }
    };

    $.extend(true, defaultConfig, defaultConfigOverride);

    return defaultConfig;
});

define('gc/hotelConstraints', ['gc/modelHelpers', 'gc/loc'], function(modelHelpers, loc) {
  return {
      "main" : true,
      "id" : "hotel",
      "isHotelOnly" :  function (state, config) {
          'use strict';
          return !(state.get("packages.flight") || state.get("packages.car"));
      },
      "destination" : modelHelpers.getRegionNameOrDestination,
      "startDate" : function (state, config) {
          'use strict';
          return state.get("startDate") || state.get("checkin");
      },
      "endDate" : modelHelpers.getEndDate,
      "isDateless" : function (state, config) {
          'use strict';
          return state.get("noDate");
      },
      "useFlightDates" : true,
      "isNinePlusRoomRequest" : function (state, config) {
          'use strict';
          return ((state.get("roomCount") > config.get("travelers.maxRoomCount")) && config.get("travelers.ninePlusRoomsAllowed"));
      },
      "rooms" : function (state, config) {
          'use strict';
          return modelHelpers.getRoomsForModel(state, config);
      }
  }
});

define('gc/hotelValidationRules', [
  'gc/validationHelpers',
  'gc/json-path',
  'gc/getLob'
], function(
  validationHelpers,
  jsonPath,
  getLob
) {
  return {
    "carDriverAge": [
                      function (model) {
                        'use strict';
                        return (validationHelpers.isPackageWithCar(model) && model.isCarDriverAgeWithinLimit === false);
                      },
                      [['isNotBlank', ['driverAge'], 'driver-age-blank'],
                       ['isValidDriverAge', ['driverAge'], 'driver-age-invalid']]],
    "destination" : [true,
                     [
                       ["isNotBlank", ["destination"], "destination-blank"]]],
    "startDate" : [
      function (model) {
        'use strict';
        return !jsonPath('isDateless', model) && !validationHelpers.startAndEndDateAreBlank(model);
      },
      [
        ["isNotBlank", ["startDate"], "date-blank"],
        ["isValidDate", ["startDate"], "date-format-invalid"],
        ["isDateBeforeMaxDaysOut", ["startDate", "config.calendar.furthestBookingDayOut"], "date-range-long"],
        ["isDatePriorToCurrentDate", ["startDate"], "date-before-today"]]],
    "endDate" : [
      function (model) {
        'use strict';
        return !jsonPath('isDateless', model) && !validationHelpers.startAndEndDateAreBlank(model);
      },
      [
        ["isNotBlank", ["endDate"], "date-blank"],
        ["isValidDate", ["endDate"], "date-format-invalid"],
        ["isDateBeforeMaxDaysOut", ["endDate", "config.calendar.furthestBookingDayOut"], "date-range-long"],
        ["isDatePriorToCurrentDate", ["endDate"], "date-before-today"],
        ["isDateAfterCurrentDate", ["endDate"], "date-range-long"]]],
    "bothDates" : [
      function (model, ruleSetResults) {
        'use strict';
        return !jsonPath('isDateless', model) &&
          !validationHelpers.startAndEndDateAreBlank(model) &&
          !_.contains(ruleSetResults.fields, "startDate") &&
          !_.contains(ruleSetResults.fields, 'endDate');
      },
      [
        ["isTripValidLength", ["startDate", "endDate", "config.calendar.maxTripLength"], "trip-length-invalid"],
        ["isStartDateBeforeEndDate", ["startDate", "endDate", 'config.calendar.minTripLength'], "date-order-invalid"]]],
    "childAges" : [function(model) { return jsonPath('rooms[0].childCount', model); },
                   [["isChildAgesAllProvided", ["rooms"], "child-ages-not-all-provided"]]]
  }
});

/*jslint nomen: true */
/*global _, typeaheadItemClickCallback */

define('gc/hotelConfig', [
  'gc/hotelConfigOverride',
  'gc/modelHelpers',
  'gc/inputDefaults',
  'gc/loc',
  'gc/hotelValidationRules',
  'gc/hotelConstraints'
], function(
  hotelConfigOverride,
  modelHelpers,
  inputDefaults,
  loc,
  hotelValidationRules,
  hotelConstraints
) {
    var hotelConfig = {
        icon: ['hotels'],
        template: 'corewizard/layouts/wizard-hbs-hotels',
        searchUrlGenerator: 'hotelSearchUrl',
        calendar : {
            furthestBookingDayOut: 500,
            maxTripLength: 28,
            minTripLength: 1
        },
        travelers: {
            maxRoomCount: 8,
            ninePlusRoomsAllowed: true
        },
        typeahead: {
            def: {
                lob: 'HOTELS',
                selectioncallback: function () {
                    'use strict';
                    typeaheadItemClickCallback();
                },
                mask: 223,
                version: 'v1'
            }
        },
        validation: hotelValidationRules,
        constraints : hotelConstraints,
        viewRules: {
            'hotelDestinationPlaceholderText' : loc.hotelDestinationPlaceholderText,
            "hotelDestinationLabel" : function() {
              return loc.hotelDestinationLabel;
            },
            'hideDestinationField': function (model) {
                'use strict';
                return !!model.get('packages.flight');
            },
            'disableAddFlightLink': function (model) {
                'use strict';
                return model.get('isNinePlusRoomRequest') || (model.get('packages.flight') || model.get('roomCount') > 3);
            },
            'disableAddCarLink': function (model) {
                'use strict';
                return model.get('isNinePlusRoomRequest') || (model.get('packages.car') || model.get('roomCount') > 3);
            },
            'showDisableAddFlightCarTips': function (model) {
                'use strict';
                return model.get('roomCount') > 3;
            },
            'isHotelDestinationVisible': function (model) {
                'use strict';
                return model.get('tab') === 'hotel';
            },
            'searchText' : function (model) {
                var text = loc.searchButtonText.defaultText;
                if (model.get('isHotelOnly') && model.get('isNinePlusRoomRequest')) {
                    text = loc.searchButtonText.hotel9Plus;
                }
                return text;
            },
            'nextRoomCount': function (model) {
                'use strict';
                return model.get('roomCount') + 1;
            },
            'flightAndCar': function (model) {
                'use strict';
                return model.get('packages.flight') && model.get('packages.car');
            },
            'hasFlight': function (model) {
                'use strict';
                return model.get('packages.flight');
            },
            'hasCar': function (model) {
                'use strict';
                return model.get('packages.car') === "true";
            },
            'rooms': function (model) {
                'use strict';
                return modelHelpers.getRoomsForHotels('hotel', model.get('rooms'));
            },
            'hotelRoomCountOptions': function (model) {
                return {
                    namespace: 'hotel-rooms',
                    'wizard_action': '{"roomCount" : "$value1"}',
                    'options': inputDefaults.rooms.options,
                    'ia' : [{'name':'data-select-value', 'value':model.get('roomCount')},
                            {'name':'aria-required', 'value':'true'}],
                    'label-text': inputDefaults.rooms.label
                };
            },
            'checkinAction': function (model) {
                return '{"startDate" : "$value1"}';
            },
            'checkinValue': function (model) {
                return model.get('startDate');
            },
            'checkoutAction': function (model) {
                return '{"endDate" : "$value1"}'
            },
            'checkoutValue': function (model) {
                return model.get('endDate');
            },
            'useHotelPromoMessage': function(model) {
                'use strict';
                return false;
            },
            'useOverseasHotelPromoMessage': function(model) {
                'use strict';
                return false;
            }
        }
    };

    $.extend(true, hotelConfig, hotelConfigOverride);

    return hotelConfig;
});

define('gc/flightConstraints', ['gc/modelHelpers'], function(modelHelpers) {
  return {
      'id': 'flight',
      'main': true,
      'isFlightOnly': true,
      'isRoundtrip': function (state) {
          'use strict';
          return state.get('flighttype') === 'roundtrip';
      },
      'isOneWay': function (state) {
          'use strict';
          return state.get('flighttype') === 'oneway';
      },
      'isMultiDest': function (state) {
          'use strict';
          return state.get('flighttype') === 'multi';
      },
      'multiDest': function (state) {
          'use strict';
          var out = {
                origin:      ['', '', '', ''],
                destination: ['', '', '', ''],
                startDate:   ['', '', '', '']},
            i;
          for (i = 0; i < 4; i ++) {
              out.origin[i] = state.get('multiDest.origin[' + i + ']') || '';
              out.destination[i] = state.get('multiDest.destination[' + i + ']') || '';
              out.startDate[i] = state.get('multiDest.startDate[' + i + ']') || '';
          }
          return out;
      },
      'startDate': function (state) {
          'use strict';
          return state.get('startDate') || state.get('checkin');
      },
      'endDate': modelHelpers.getEndDate,
      'adults': function (state) {
          'use strict';
          return state.get('rooms[0].adults');
      },
      'children': function (state) {
          'use strict';
          return state.get('rooms[0].childCount');
      },
      'ages': function (state, config) {
          'use strict';
          var result = [],
            i,
            childAge;
          for (i = 0; i < state.get('rooms[0].childCount'); i += 1) {
              childAge = state.get('rooms[0].children[' + i + ']');
              if (i === config.get('travelers.maxChildren')) break;
              if (typeof childAge === 'undefined') {
                  result.push(config.get('travelers.defaultChildAge'));
              } else {
                  result.push(childAge);
              }
          }
          return result;
      },
      'hasChildren': function (state) {
          'use strict';
          return state.get('rooms[0].childCount') > 0;
      },
      'rooms': function (state, config) {
        'use strict';
        if (state.get('packages.hotel')) {
            return modelHelpers.getRoomsForModel.call(this, state, config);
        } else {
            return (state.get('rooms') && state.get('rooms').length > 0) ? [state.get('rooms')[0]] : [{adults: 1, childCount: 0, children: []}];
        }
      },
      'lastValidDate': function (state, config) {
          'use strict';
          var date = new XDate();
          date.addDays(config.get('calendar.furthestBookingDayOut'));
          return date.toString(config.get('dateFormat'));
      }
  }
});

define('gc/flightValidationRules', ['underscore', 'gc/validationHelpers', 'gc/json-path'], function(_, validationHelpers, jsonPath) {
  return {
    'origin' : [true,
                [
                  ['isNotBlank', ['origin'], 'origin-blank'],
                  ['isOriginDiffrentFromDestination', ['origin', 'destination'], 'origin-same']]],
    'destination' : [true,
                     [
                       ['isNotBlank', ['destination'], 'destination-blank']]],
    'startDate' : [true,
                   [
                     ['isNotBlank', ['startDate'], 'date-blank'],
                     ['isValidDate', ['startDate'], 'date-format-invalid'],
                     ['isDateBeforeMaxDaysOut', ['startDate', 'config.calendar.furthestBookingDayOut'], 'date-range-long'],
                     ['isDatePriorToCurrentDate', ['startDate'], 'date-before-today']]],
    'endDate' : [
      function (model, ruleSetResults) {
        'use strict';
        return jsonPath('isRoundtrip', model);
      },
      [
        ['isNotBlank', ['endDate'], 'date-blank'],
        ['isValidDate', ['endDate'], 'date-format-invalid'],
        ['isDateBeforeMaxDaysOut', ['endDate', 'config.calendar.furthestBookingDayOut'], 'date-range-long'],
        ['isDatePriorToCurrentDate', ['endDate'], 'date-before-today']]],
    'bothDates' : [
      function (model, ruleSetResults) {
        'use strict';
        return jsonPath('isRoundtrip', model) &&
          !validationHelpers.startAndEndDateAreBlank(model) &&
          !_.contains(ruleSetResults.fields, "startDate") &&
          !_.contains(ruleSetResults.fields, 'endDate');
      },
      [
        ['isStartDateBeforeEndDate', ['startDate', 'endDate', 'config.calendar.minTripLength'], 'date-order-invalid'],
        ['isTripValidLength', ['startDate', 'endDate', 'config.calendar.maxTripLength'], 'trip-length-invalid']]],
    'totalNumberOfTravellers' : [true,
                                 [
                                   ['isTotalTravelersLessThanMax', ['rooms', 'config.travelers.maxTravelers'], 'too-many-travelers']]],
    'childAges' : [
      function (model) {
        'use strict';
        return jsonPath('rooms[0].childCount', model);
      },
      [
        ['isChildAgesAllProvided', ['rooms'], 'child-ages-not-all-provided']]],
    'multiDest' : [
      function (model) {
        'use strict';
        return jsonPath('isMultiDest', model);
      },
      [   ['areAllDatesValid', ['multiDest', 'startDate'], 'some-dates-invalid', ['multiDest']],
          ['areAllFlightsComplete', ['multiDest'], 'multi-dest-not-complete'],
          ['allOriginsAreDifferentFromDestinations', ['multiDest'], 'multi-dest-origin-same']], true]
  }
});

/*jslint nomen: true */
/*global _, ab3227status, corewizard, XDate */

define('gc/flightConfig', [
    'gc/flightConfigOverride',
    'gc/modelHelpers',
    'gc/loc',
    'gc/inputDefaults',
    'gc/flightValidationRules',
    'gc/flightConstraints',
    'gc/defaultConfig'
], function(
    flightConfigOverride,
    modelHelpers,
    loc,
    inputDefaults,
    flightValidationRules,
    flightConstraints,
    defaultConfig
) {
    var flightConfig = {
        icon: ['flights'],
        template: 'corewizard/layouts/wizard-hbs-flights',
        searchUrlGenerator: 'flightSearchUrl',
        maxMultiDestLegs: 4,
        calendar: {
            'maxTripLength': 330,
            'minTripLength': 0,
            'furthestBookingDayOut': 330
        },
        travelers: {
            infantAge: 1,
            defaultChildAge: '',
            maxTravelers: 6,
            maxRoomCount: 3
        },

        model: {
            multiDest: {
                origin:      ["", "", "", ""],
                destination: ["", "", "", ""],
                startDate:   ["", "", "", ""]
            }
        },
        validation : flightValidationRules,
        constraints : flightConstraints,
        viewRules: {
            'showAddHotelLink': function (model) {
                'use strict';
                return model.get('flighttype') === 'roundtrip' &&
                  !model.get('packages.hotel');
            },
            'showAddCarLink': function (model) {
                'use strict';
                return model.get('flighttype') === 'roundtrip' &&
                  !model.get('packages.car');
            },
            "flightOriginLabel" : function() {
              return loc.flightOriginLabel;
            },
            "flightDestinationLabel" : function() {
              return loc.flightDestinationLabel;
            },
            'hidePassengerInfo': function (model) {
                'use strict';
                return typeof ab3227status !== 'undefined' ?
                ab3227status !== 2 && model.get('pacakge.hotel') :
                  model.get('pacakge.hotel');
            },
            'hideFlightOptions': function (model) {
                'use strict';
                return !model.get('showFlightOptions');
            },
            'multidest': function (model) {
                'use strict';
                var multidest = [];
                var legs = model.get('config.maxMultiDestLegs');
                var md = model.get('multiDest');
                for (var i = 0; i < legs; i++) {
                  multidest.push({
                      destination: md.destination[i],
                      origin: md.origin[i],
                      departing: md.startDate[i],
                      number: i + 2,
                      id: 'flight',
                      originError: _.contains(model.get('validation.fields'), 'origin:' + (i + 2)),
                      destinationError: _.contains(model.get('validation.fields'), 'destination:' + (i + 2)),
                      startDateError: _.contains(model.get('validation.fields'), 'startDate:' + (i + 2)),
                      originWizardAction: '{"multiDest.origin[' + i + ']": "$value1"}',
                      destinationWizardAction: '{"multiDest.destination[' + i + ']": "$value1"}',
                      dateWizardAction: '{"multiDest.startDate[' + i + ']": "$value1"}',
                      isRoundtrip: model.get('isRoundtrip'),
                      isOneWay: model.get('isOneWay'),
                      isMultiDest: model.get('isMultiDest'),
                      dateFormat: model.get('config.userVisibleDateFormat')
                  });
                }
                return multidest;
            },
            'hasMultiDestFlight': function (model) {
                'use strict';
                return true;
            },
            'enableAdvancedOptions': function (model) {
                'use strict';
                return true;
            },
            'flightAdultCountOptions': function (model) {
                return {
                    namespace: 'flight-adults',
                    'wizard_action': '{"rooms[0].adults" : $value1}',
                    'options': inputDefaults.flightAdults.options,
                    'ia' : [{'name':'data-select-value', 'value':model.get('adults')},
                            {'name':'wizard-owner', 'value':'adults'},
                            {'name':'aria-required', 'value':'true'}],
                    'label-text': inputDefaults.flightAdults.label,
                    class: 'number-of-travellers'
                };
            },
            'flightChildCountOptions': function (model) {
                //Fix issue  WCAG-2501
                var childCount = model.get('children');
                var options = inputDefaults.flightChildren.options;
                if( options && options.forEach && (childCount || childCount === 0) ){
                  options.forEach(function(option){
                    if( option.value == childCount ){
                      option.selected = 'selected';
                    }else{
                      delete option.selected;
                    }
                 });
                }

                return {
                    namespace: 'flight-children',
                    'wizard_action': '{"rooms[0].childCount" : $value1}',
                    'options': options,
                    'ia' : [{'name':'data-select-value', 'value':model.get('children')},
                            {'name':'wizard-owner', 'value':'children'},
                            {'name':'data-children-fieldset', 'value':'children'},
                            {'name':'aria-redraw', 'value':'true'},
                            {'name':'aria-required', 'value':'true'}],
                    'label-text': inputDefaults.flightChildren.label,
                    class: 'children-select number-of-travellers'
                };
            },
            'hotelRoomCountOptions': function (model) {
                return {
                    namespace: 'flight-hotel-rooms',
                    'wizard_action': '{"roomCount" : "$value1"}',
                    'options': inputDefaults.rooms.options.slice(0,3),
                    'ia' : [{'name':'data-select-value', 'value':model.get('roomCount')},
                            {'name':'aria-required', 'value':'true'}],
                    'label-text': inputDefaults.rooms.label
                };
            },
            'rooms': function (model) {
                'use strict';
                return modelHelpers.getRoomsForHotels('flight-hotel', model.get('rooms'));
            },
            'checkinAction': function (model) {
                return '{"checkin" : "$value1"}';
            },
            'checkinValue': function (model) {
                return model.get('checkin') || model.get('startDate');
            },
            'checkoutAction': function (model) {
                return '{"checkout" : "$value1"}';
            },
            'checkoutValue': function (model) {
                return model.get('checkout') || model.get('endDate');
            },
            'ages': function (model) {
                'use strict';
                return modelHelpers.getChildrenForHotels(model.get('ages'), 0, 'flight');
            },
            'showLapOrSeat': function (model) {
                'use strict';
                return _.some(model.get('ages'), function (age) {
                    return !_.isNull(age) && age !== '' && age <= model.get('config.travelers.infantAge');
                });
            },
            'showPreferredAirline': function (model) {
                'use strict';
                return true;
            },
            'preferredAirlinesOptions': function (model) {
                return {
                    namespace: 'flight-advanced-preferred-airline',
                    'wizard_action': '{"carrier" : "$value1"}',
                    'options': defaultConfig.model.preferredAirlines,
                    'ia' : [{'name':'data-select-value', 'value':model.get('carrier')}],
                    'label-text': loc.perferredAirlineLabel
                };
            },
            'preferredFlightCabinClassOptions': function (model) {
                return {
                    namespace: 'flight-advanced-preferred-class',
                    'wizard_action': '{"cabinClass" : "$value1"}',
                    'options': inputDefaults.preferredClass.options,
                    'ia' : [{'name':'data-select-value', 'value':model.get('cabinClass')}],
                    'label-text': inputDefaults.preferredClass.label
                };
            },
            'useFlightPromoMessage': function(model) {
                'use strict';
                return false;
            },
            'multiFlightPlaceholder': function(model) {
                //This function can be removed as now there are separate placeholder texts for both origin and destination in multi flights
                'use strict';
                return loc.flightMultiPlaceholder;
            },
            'multiflightOriginPlaceholder': function(model) {
                'use strict';
                return loc.flightMultiOriginPlaceholder;
            },
            'multiflightDestinationPlaceholder': function(model) {
                'use strict';
                return loc.flightMultiDestinationPlaceholder;
            },
            'multiFlightOriginLabel': function(model) {
                'use strict';
                return loc.flightMultiOriginLabel;
            },
            'multiFlightDestinationLabel': function(model) {
                'use strict';
                return loc.flightMultiDestinationLabel;
            },
            'isFlightSelectEnabled': function(model) {
                'use strict';
                return false;
            },
            'isSwapOriginDestinationEnabled': function(model) {
                'use strict';
                return false;
            },
            "searchText" : loc.searchButtonText.defaultText
        }
    };

    $.extend(true, flightConfig, flightConfigOverride);

    return flightConfig;
});

define('gc/carValidationRules', [], function() {
  return {

    "carDriverAge": [
                      function (model) {
                        'use strict';
                        return (model.isCarDriverAgeWithinLimit === false && model.tab === 'car');
                      },
                      [['isNotBlank', ['driverAge'], 'driver-age-blank'],
                       ['isValidDriverAge', ['driverAge'], 'driver-age-invalid']]],
    "pickUpLocation": [true,
                       [
                         ['isNotBlank', ['destination'], 'destination-blank']]],
    "pickUpDate": [true,
                   [
                     ["isNotBlank", ["startDate"], "date-blank"],
                     ["isValidDate", ["startDate"], "date-format-invalid"]]],
    "pickUpTime": [],
    "dropOffDate": [true,
                    [
                      ["isNotBlank", ["endDate"], "date-blank"],
                      ["isValidDate", ["endDate"], "date-format-invalid"]]],
    "tripLength": [
      ['startDate', 'endDate'],
      [
        ["isTripWithTimeValidLongEnough", ["startDate", "startTime", "endDate", "endTime", "config.calendar.minTripTime"], "time-too-short"],
        ["isTripValidLength", ["startDate", "endDate", "config.calendar.maxTripLength"], "date-car-range-long"]]]
  }
});

define('gc/carConstraints', ['gc/loc', 'gc/modelHelpers', 'gc/abTest'], function(loc, modelHelpers, abTest) {
  return {
      "id": "car",
      "isCarDriverAgeEnabled": function (state, config) {
          'use strict';
          return (abTest.get(11636).value === 1);
      },
      "carAllVendors": function (state, config) {
          'use strict';
          return state.get('carDiscountCode') === "0";
      },
      "carCorporateVendors": function (state, config) {
          'use strict';
          return state.get('carDiscountCode') === "1";
      },
      "carSpecialVendors": function (state, config) {
          'use strict';
          return state.get('carDiscountCode') === "2";
      },
      "startDate": function (state, config) {
          'use strict';
          return state.get('startDate') || state.get('checkin');
      },
      "endDate": function (state, config) {
          'use strict';
          return state.get('endDate') || state.get('checkout') || state.get('checkin') || modelHelpers.getEndDate(state, config);
      },
      "carTypes": function (state, config) {
          return [
              {key: loc.carOptionsLoc.typeNoPref, value: "1"},
              {key: loc.carOptionsLoc.typeEconomy, value: "2"},
              {key: loc.carOptionsLoc.typeCompact, value: "5"},
              {key: loc.carOptionsLoc.typeMidsize, value: "3"},
              {key: loc.carOptionsLoc.typeStandard, value: "6"},
              {key: loc.carOptionsLoc.typeFullsize, value: "4"},
              {key: loc.carOptionsLoc.typePremium, value: "9"},
              {key: loc.carOptionsLoc.typeLuxury, value: "7"},
              {key: loc.carOptionsLoc.typeConvertible, value: "12"},
              {key: loc.carOptionsLoc.typeMinivan, value: "8"},
              {key: loc.carOptionsLoc.typeSportUtilityVehicle, value: "11"},
              {key: loc.carOptionsLoc.typeSports, value: "15"}
          ];
      },
      "carVendors": function(state, config) {
          'use strict';
          if (state.get('carDiscountCode') === "0") {
              return [
                  {value: "", key: loc.carOptionsLoc.carRentalCompanyNoPreference},
                  {value: "AC", key: loc.carOptionsLoc.vendorAce},
                  {value: "AD", key: loc.carOptionsLoc.vendorAdvantage},
                  {value: "AL", key: loc.carOptionsLoc.vendorAlamo},
                  {value: "ZI", key: loc.carOptionsLoc.vendorAvis},
                  {value: "ZD", key: loc.carOptionsLoc.vendorBudget},
                  {value: "ZR", key: loc.carOptionsLoc.vendorDollar},
                  {value: "EY", key: loc.carOptionsLoc.vendorEconomy},
                  {value: "ET", key: loc.carOptionsLoc.vendorEnterprise},
                  {value: "EP", key: loc.carOptionsLoc.vendorEuropcar},
                  {value: "FX", key: loc.carOptionsLoc.vendorFox},
                  {value: "ZE", key: loc.carOptionsLoc.vendorHertz},
                  {value: "MW", key: loc.carOptionsLoc.vendorMidway},
                  {value: "ZL", key: loc.carOptionsLoc.vendorNational},
                  {value: "NU", key: loc.carOptionsLoc.vendorNu},
                  {value: "ZA", key: loc.carOptionsLoc.vendorPayless},
                  {value: "SX", key: loc.carOptionsLoc.vendorSixt},
                  {value: "ZT", key: loc.carOptionsLoc.vendorThrifty},
                  {value: "SV", key: loc.carOptionsLoc.vendorUSave}
              ];
          } else if (state.get('carDiscountCode') === "1") {
              return [
                  {value: "", key: '-- ' + loc.carOptionsLoc.carRentalCompanySelectFromList + ' --'},
                  {value: "ZI", key: loc.carOptionsLoc.vendorAvis},
                  {value: "ZD", key: loc.carOptionsLoc.vendorBudget},
                  {value: "ZR", key: loc.carOptionsLoc.vendorDollar},
                  {value: "ET", key: loc.carOptionsLoc.vendorEnterprise},
                  {value: "EP", key: loc.carOptionsLoc.vendorEuropcar},
                  {value: "ZE", key: loc.carOptionsLoc.vendorHertz},
                  {value: "ZA", key: loc.carOptionsLoc.vendorPayless},
                  {value: "ZT", key: loc.carOptionsLoc.vendorThrifty},
                  {value: "AC", key: loc.carOptionsLoc.vendorAce},
                  {value: "AD", key: loc.carOptionsLoc.vendorAdvantage},
                  {value: "AL", key: loc.carOptionsLoc.vendorAlamo},
                  {value: "EY", key: loc.carOptionsLoc.vendorEconomy},
                  {value: "ZL", key: loc.carOptionsLoc.vendorNational},
                  {value: "NU", key: loc.carOptionsLoc.vendorNu},
                  {value: "SX", key: loc.carOptionsLoc.vendorSixt}
              ];
          } else if (state.get('carDiscountCode') === "2") {
              return [
                  {value: "", key: '-- ' + loc.carOptionsLoc.carRentalCompanySelectFromList + ' --'},
                  {value: "ZI", key: loc.carOptionsLoc.vendorAvis},
                  {value: "ZD", key: loc.carOptionsLoc.vendorBudget},
                  {value: "ZR", key: loc.carOptionsLoc.vendorDollar},
                  {value: "ET", key: loc.carOptionsLoc.vendorEnterprise},
                  {value: "EP", key: loc.carOptionsLoc.vendorEuropcar},
                  {value: "ZE", key: loc.carOptionsLoc.vendorHertz},
                  {value: "ZA", key: loc.carOptionsLoc.vendorPayless},
                  {value: "ZT", key: loc.carOptionsLoc.vendorThrifty},
                  {value: "AC", key: loc.carOptionsLoc.vendorAce},
                  {value: "AD", key: loc.carOptionsLoc.vendorAdvantage},
                  {value: "AL", key: loc.carOptionsLoc.vendorAlamo},
                  {value: "EY", key: loc.carOptionsLoc.vendorEconomy},
                  {value: "ZL", key: loc.carOptionsLoc.vendorNational},
                  {value: "NU", key: loc.carOptionsLoc.vendorNu},
                  {value: "SX", key: loc.carOptionsLoc.vendorSixt},
                  {value: "SV", key: loc.carOptionsLoc.vendorUSave}
              ];
          }
      },
      "carDiscountCodes": [
          {value: 0, key: loc.carOptionsLoc.carNoCode},
          {value: 1, key: loc.carOptionsLoc.carCorporateContracted},
          {value: 2, key: loc.carOptionsLoc.carSpecialAdvertised}
      ],
      "isCarPackage" : function(state, config) {
          return state.get('tab') === 'car';
      }
  }
});

/*jslint nomen: true */
/*global _ */

define('gc/carConfig', [
  'gc/carConfigOverride',
  'gc/loc',
  'jquery',
  'gc/carValidationRules',
  'gc/carConstraints',
  'gc/abTest'
], function(
  carConfigOverride,
  loc,
  $,
  carValidationRules,
  carConstraints,
  abTest
) {
    var carConfig = {
        icon: ['cars'],
        template: 'corewizard/layouts/wizard-hbs-cars',
        searchUrlGenerator: 'carSearchUrl',
        calendar: {
            minTripTime: 2,
            maxTripLength: (function () {
                if (abTest.get(12234, null, true).value === 1) {
                    return 330;
                }
                return 29;
            })()
        },
        vendorOptions : true,
        carOptions : ['type'],
        carsSpecialEquipment : [
            [ 'infantseat', 'toddlerseat'],
            ['skirack', 'chains'],
            ['navigation']
        ],
        carsSpecialEquipmentLimit : 0,
        specialVendorOptions : ['rateCode', 'couponCode', 'otherCode'],
        corporateVendorOptions: ['corpCode'],
        validation : carValidationRules,
        discountCodeConfig : {
            'AC' : {rateCodeLbl: loc.carOptionsLoc.rateCode, couponCodeLbl: loc.carOptionsLoc.couponCode,                                    corpCodeLbl: "Corporate Discount #"},
            'AD' : {rateCodeLbl: loc.carOptionsLoc.rateCode, couponCodeLbl: loc.carOptionsLoc.couponCode,                                    corpCodeLbl: "FASTSTART Org ID"},
            'AL' : {rateCodeLbl: loc.carOptionsLoc.rateCode, couponCodeLbl: loc.carOptionsLoc.couponCode, otherCodeLbl: "Alamo Insiders #",  corpCodeLbl: loc.carOptionsLoc.corpDiscount},
            'ZI' : {rateCodeLbl: loc.carOptionsLoc.rateCode, couponCodeLbl: loc.carOptionsLoc.couponCode, otherCodeLbl: "Wizard #",          corpCodeLbl: "AWD #"},
            'ZD' : {                                         couponCodeLbl: loc.carOptionsLoc.couponCode, otherCodeLbl: "Fast Break #",      corpCodeLbl: "BCD #"},
            'ZR' : {rateCodeLbl: loc.carOptionsLoc.rateCode, couponCodeLbl: loc.carOptionsLoc.couponCode, otherCodeLbl: "Dollar Express #",  corpCodeLbl: loc.carOptionsLoc.corpDiscount},
            'EY' : {                                         couponCodeLbl: loc.carOptionsLoc.couponCode,                                    corpCodeLbl: loc.carOptionsLoc.corpDiscount},
            'ET' : {                                         couponCodeLbl: loc.carOptionsLoc.couponCode, otherCodeLbl: "Enterprise Plus #", corpCodeLbl: "Customer #"},
            'EP' : {rateCodeLbl: loc.carOptionsLoc.rateCode, couponCodeLbl: loc.carOptionsLoc.couponCode, otherCodeLbl: "Privilege #",       corpCodeLbl: "Contract #"},
            'FX' : {rateCodeLbl: loc.carOptionsLoc.rateCode, couponCodeLbl: loc.carOptionsLoc.couponCode},
            'ZE' : {                                         couponCodeLbl: loc.carOptionsLoc.couponCode, otherCodeLbl: "Hertz #1 Club",     corpCodeLbl: "CDP"},
            'MW' : {                                         couponCodeLbl: loc.carOptionsLoc.couponCode,                                    corpCodeLbl: loc.carOptionsLoc.corpDiscount},
            'ZL' : {                                         couponCodeLbl: loc.carOptionsLoc.couponCode, otherCodeLbl: "Emerald Club ID:",  corpCodeLbl: "National Contract ID"},
            'NU' : {rateCodeLbl: loc.carOptionsLoc.rateCode, couponCodeLbl: loc.carOptionsLoc.couponCode,                                    corpCodeLbl: "Corporate Account"},
            'ZA' : {rateCodeLbl: loc.carOptionsLoc.rateCode, couponCodeLbl: loc.carOptionsLoc.couponCode, otherCodeLbl: "Payless Perks #",   corpCodeLbl: loc.carOptionsLoc.corpDiscount},
            'SX' : {rateCodeLbl: loc.carOptionsLoc.rateCode, couponCodeLbl: loc.carOptionsLoc.couponCode,                                    corpCodeLbl: loc.carOptionsLoc.corpDiscount},
            'ZT' : {rateCodeLbl: loc.carOptionsLoc.rateCode, couponCodeLbl: loc.carOptionsLoc.couponCode, otherCodeLbl: "Blue Chip #",       corpCodeLbl: loc.carOptionsLoc.corpDiscount},
            'SV' : {rateCodeLbl: loc.carOptionsLoc.rateCode, couponCodeLbl: loc.carOptionsLoc.couponCode}
        },
        constraints: carConstraints,
        viewRules: {
            "carShowDropOff": function (model) {
                'use strict';
                return loc.masterconfig.switches.enableCarOffairportOnewaySearch ? true :
                !model.get('TASearchType') || model.get('TASearchType') === "AIRPORT";
            },
            "carHideCarOptions": function (model) {
                'use strict';
                return !model.get('carShowCarOptions');
            },
            "showDiscountCodeFields": function (model) {
                'use strict';
                return model.get('carDiscountCode') !== "0";
            },
            "discountCodeConfig": function (model) {
                'use strict';
                return model.get('config.discountCodeConfig')[model.get('carVendor')];
            },
            "carOptions": function (model) {
                'use strict';
                function titlecase(string) { return string.charAt(0).toUpperCase() + string.slice(1); }
                return _.map(model.get('config.carOptions'), function(option) {
                    var carOption = (option === 'discount' ? 'carDiscountCode' : 'car' + titlecase(option));
                    var optionsList = _.map(model.get(carOption + 's'), function(pair) {
                        return {name: pair.key, value: pair.value};
                    });
                    return {
                        namespace: 'car-options-' + option,
                        'wizard_action': '{"' + carOption + '" : "$value1"}',
                        'options': optionsList,
                        'ia' : [{'name':'data-select-value', 'value':model.get(carOption)}],
                        'label-text': loc.carOptionsLoc[carOption]
                    }
                });
            },
            "carDiscountCodeOptions": function (model) {
                'use strict';
                function titlecase(string) { return string.charAt(0).toUpperCase() + string.slice(1); }
                function getDiscountCodeLbl(codeLbl) {
                    if (model.get('carVendor')) {
                        return model.get('config.discountCodeConfig')[model.get('carVendor')][codeLbl]
                    } else {
                        return null;
                    }
                }
                function optionDetails(optionNames, showCondition) {
                    var namespace;
                    return _.map(optionNames, function (option) {
                        namespace = (option === 'otherCode') ? 'otherCodeLbl' : 'dis' + titlecase(option);
                        return {
                            'placeholder': loc.carDiscountEnterCodeLabel,
                            namespace: namespace,
                            'show-car-discount-options': showCondition && getDiscountCodeLbl(option + 'Lbl'),
                            'label-text': getDiscountCodeLbl(option + 'Lbl'),
                            'wizard_action': '{"car' + titlecase(option) + '" : "$value1"}',
                            'value': model.get('car' + titlecase(option))
                        };
                    });
                }
                return optionDetails(model.get('config.specialVendorOptions'), model.get('carSpecialVendors')).concat(
                  optionDetails(model.get('config.corporateVendorOptions'), model.get('carCorporateVendors'))
                );
            },
            "specialEquipmentOptions": function (model) {
                'use strict';
                function titlecase(string) { return string.charAt(0).toUpperCase() + string.slice(1); }
                function getOption(option) { return (model.get(option) === "false" || model.get(option) === false) ? false:true; }
                var limit = model.get('config.carsSpecialEquipmentLimit'),
                    carEquip = model.get('config.carsSpecialEquipment'),
                    carOption = '',
                    checked = false,
                    optionSelected = 0;
                if (limit) {
                    _.map(carEquip, function (column) {
                        _.map(column, function (option) {
                            carOption = 'car' + titlecase(option);
                            checked = getOption(carOption);
                            if (getOption(carOption)) {
                                optionSelected++;
                            }
                        });
                    });
                }
                return _.map(carEquip, function(column) {
                    return _.map(column, function(option) {
                        carOption = 'car' + titlecase(option);
                        checked = getOption(carOption);
                        return {
                            namespace: 'car-options-equipment-' + option,
                            'wizard_action': '{"' + carOption + '": "$value1"}',
                            isChecked: checked,
                            disabled: (!checked && limit && optionSelected >= limit),
                            'label-text': loc.carOptionsLoc[carOption]
                        }
                    });
                });
            },
            'isCarAgeOptionEnabled': function(model) {
                'use strict';
                return true;
            },
            "searchText" : loc.searchButtonText.defaultText
        }
    };

    $.extend(true, carConfig, carConfigOverride);

    return carConfig;
});

define('gc/activityValidationRules', ['gc/validationHelpers'], function(validationHelpers) {
  return {
    "destination": [true,
                    [
                      ["isNotBlank", ["destination"], "destination-blank"]]],
    "startDate": [function (model) {
      'use strict';
      return !validationHelpers.startAndEndDateAreBlank(model);
    },
                  [
                    ["isNotBlank", ["startDate"], "date-blank"],
                    ["isValidDate", ["startDate"], "date-format-invalid"],
                    ["isDateBeforeMaxDaysOut", ["startDate", "config.calendar.furthestBookingDayOut"], "date-range-long"],
                    ["isDatePriorToCurrentDate", ["startDate"], "date-before-today"],
                    ["isStartDateBeforeEndDate", ["startDate", "endDate", 'config.calendar.minTripLength'], "date-order-invalid"]]],
    "endDate": [function (model) {
      'use strict';
      return !validationHelpers.startAndEndDateAreBlank(model);
    },
                [
                  ["isNotBlank", ["endDate"], "date-blank"],
                  ["isValidDate", ["endDate"], "date-format-invalid"],
                  ["isDateBeforeMaxDaysOut", ["endDate", "config.calendar.furthestBookingDayOut"], "date-range-long"],
                  ["isDatePriorToCurrentDate", ["endDate"], "date-before-today"]]],
    "bothDates": [
      ['startDate', 'endDate'],
      [
        ["isTripValidLength", ["startDate", "endDate", "config.calendar.maxTripLength"], "trip-length-invalid"]]]
  }
});

define('gc/activityConstraints', ['gc/modelHelpers'], function(modelHelpers) {
  return {
    "id": "activity",
    "main": true,
    "destination": modelHelpers.getRegionNameOrDestination,
    "startDate": function (state, config) {
        'use strict';
        var prefilled = state.get("startDatePrefilled") || state.get("endDatePrefilled");
        if (prefilled) return "";
        return state.get("startDate") || state.get("checkin");
    },
    "endDate": function (state, config) {
        'use strict';
        var prefilled = state.get("startDatePrefilled") || state.get("endDatePrefilled");
        if (prefilled) return "";
        return state.get("endDate") || state.get("checkout") || modelHelpers.getEndDate(state, config);
    },
    "isActivityPackage" : function(state, config) {
          return state.get('tab') === 'activity';
      }
  }
});

/*jslint nomen: true */
/*global _ */

define('gc/activityConfig', [
    'gc/activityConfigOverride',
    'gc/loc',
    'gc/activityValidationRules',
    'gc/activityConstraints'
], function(
    activityConfigOverride,
    loc,
    activityValidationRules,
    activityConstraints
) {
    var activityConfig = {
        icon: ['activities'],
        template: 'corewizard/field-groups/activity-hbs',
        searchUrlGenerator: 'activitySearchUrl',
        calendar: {
            furthestBookingDayOut: 328,
            maxTripLength: 14,
            minTripLength: 0
        },
        validation: activityValidationRules,
        constraints: activityConstraints,
        viewRules: {
            'useActivityPromoMessage': function (model) {
                'use strict';
                false;
            },
            'activityDestinationPlaceholder': function (model) {
                'use strict';
                return loc.activityDestinationPlaceholder;
            },
            'activityDestinationLabel': function (model) {
                'use strict';
                return loc.activityDestinationLabel;
            },
            "searchText" : loc.searchButtonText.defaultText
        }
    };

    $.extend(true, activityConfig, activityConfigOverride);

    return activityConfig;
});

define('gc/packageConstraints', ['underscore', 'gc/modelHelpers', 'gc/validate', 'gc/abTest', 'gc/getLob'], function(_, modelHelpers, validate, abTest, getLob) {
  return {
      'isCarDriverAgeEnabledForPackages': function (state, config) {
          'use strict';
          return (abTest.get(11877).value === 1);
      },
      'showCarDriverAge': function (state, config) {
          'use strict';
          var lob = getLob(state.get('tab'), state.get('packages'));         
          return (_.contains(['flightHotelCar', 'flightCar', 'hotelCar'], lob) && this.get('isCarDriverAgeEnabledForPackages'));
      },
      'id': function (state) {
          'use strict';
          return state.get('tab');
      },
      'main': function (state) {
          'use strict';
          return state.get('tab') === 'package';
      },
      'isPackage': true,
      'packageType': function (state) {
          'use strict';
          return (state.get('packages.flight') ? 'F' : '') +
            (state.get('packages.train') ? 'T' : '') +
            (state.get('packages.hotel') ? 'H' : '') +
            (state.get('packages.car') ? 'C' : '');
      },
      'destination': modelHelpers.getRegionNameOrDestination,
      'destID': function (state) {
          'use strict';
          if (state.get('regionId') && state.get('destinationTLA')) {
              return state.get('regionId') + ':' + state.get('destinationTLA');
          } else {
              return null;
          }
      },
      'startDate': function (state) {
          'use strict';
          //https://jira/jira/browse/MAIN-122282 Special case: partial LS data doesn't apply for hotel soft packaging.
          if (state.get('packages.flight') &&
            state.get('tab') === 'hotel' &&
            state.get('isPartialStay')) return state.get('checkin') || state.get('startDate');


          return state.get('startDate');
      },
      'endDate': modelHelpers.getEndDate,
      'startDateHotfix': function(state) {
          return state.get('checkin') || state.get('startDate');
      },
      'endDateHotfix': function(state) {
          return state.get('checkout') || this.get('endDate');
      },
      'checkin': function (state, config) {
          'use strict';
          var validationResults = validate(config.validation, state.toJSON()),
            startDateIsValid;
          if (_.isUndefined(state.get('startDate'))) {
              startDateIsValid = false;
          } else {
              startDateIsValid = validationResults.isValid ? true : _contains(validationResults.fields, 'startDate');
          }
          return _.isUndefined(state.get('checkin')) ?
            startDateIsValid ? state.get('startDate') : ''
            : state.get('checkin');
      },
      'checkout': function (state, config) {
          'use strict';
          var validationResults = validate(config.validation, state.toJSON()),
            endDateIsValid;
          if (_.isUndefined(state.get('endDate'))) {
              endDateIsValid = false;
          } else {
              endDateIsValid = validationResults.isValid ? true : _contains(validationResults.fields, 'endDate');
          }
          return _.isUndefined(state.get('checkout')) ?
            endDateIsValid ? this.get('endDate') : ''
            : state.get('checkout');
      },
      'isPartialStay': function (state) {
          'use strict';
          var checkin = state.get('checkin'),
              checkout = state.get('checkout'),
              startDate = state.get('startDate'),
              endDate = state.get('endDate');
          //https://jira/jira/browse/MAIN-120642 - last search returns checkout/checkin dates for non partial stay searches
          if (state.get('tab') === 'flight' &&
              state.get('packages.hotel') &&
              checkin &&
              checkout) {
              return (checkin !== startDate) || (checkout !== endDate);
          }
          return state.get('isPartialStay');
      },
      'rooms': function (state, config) {
          'use strict';
          if (state.get('packages.hotel')) {
              return modelHelpers.getRoomsForModel.call(this, state, config);
          } else {
              return (state.get('rooms') && state.get('rooms').length > 0) ? [state.get('rooms')[0]] : [{adults: 1, childCount: 0, children: []}];
          }
      },
      'roomCount': function (state) {
          'use strict';
          return state.get('roomCount') > 3 ? 3 : state.get('roomCount');
      },
      'adults': function (state, config) {
          'use strict';
          return state.get('rooms[0].adults') === -1 ?
            config.get('travelers.defaultNumAdults') :
            state.get('rooms[0].adults')
      },
      'children': function (state) {
          'use strict';
          return state.get('rooms[0].childCount');
      },
      'ages': function (state, config) {
          'use strict';
          var result = [],
            i,
            childAge;
          for (i = 0; i < state.get('rooms[0].childCount'); i += 1) {
              childAge = state.get('rooms[0].children[' + i + ']');
              if (typeof childAge === 'undefined') {
                  result.push(config.get('travelers.defaultChildAge'));
              } else {
                  result.push(childAge);
              }
          }
          return result;
      },
      'isNinePlusRoomRequest' : function (state, config) {
          'use strict';
          //remove this from model if coming from another LOB for soft packaging scenarios.
          return false;
      },
      isSoftPackage : function(state, config) {
          return state.get('tab') !== 'package';
      },
      'subTab': function(state, config) {
          'use strict';
          var conf = config.attributes;
          var packageLob = _.find(conf.wizardconfig.lobs, function(lob) {return  lob.id == "package"});
          if (!packageLob) return null;

          var pkgLobs = ['flight', 'hotel', 'car', 'train'];
          var pkgState = _.pick(state.get('packages'), pkgLobs);
          var testIDdict = {
              'flightHotelCar' : 'fhc',
              'flightHotel' : 'fh',
              'flightCar' : 'fc',
              'hotelCar' : 'hc',
              'trainHotel' : 'th'
          };
          return {
              isPackageDefault: state.get('tab') === 'package',
              lobs: _.map(packageLob.lobs, function(lob) {
                  var pkgDefaults = _.pick(conf[lob.id].model.packages, pkgLobs);
                  return {
                      id: testIDdict[lob.id] || lob.id,
                      type: testIDdict[lob.id] || lob.id,
                      label: loc.tabLoc[lob.id],
                      value: _.map(pkgDefaults, String).join(':'),
                      selected: !this.get('isSoftPackage') && _.isEqual(pkgDefaults, pkgState),
                      action: '{"packages.flight" : $value1, "packages.hotel" : $value2, "packages.car" : $value3, "packages.train" : $value4}',
                      name: state.get('tab') + '-lob',
                      tracking:state.get('tab') + 'Lob'
                  }
              }, this)
          };
      }

  }
});

define('gc/packageValidationRules', [
  'underscore',
  'gc/validationHelpers',
  'gc/json-path',
  'gc/getLob'
], function(
  _,
  validationHelpers,
  jsonPath,
  getLob) {
  return {
     "carDriverAge": [
                      function (model) {
                        'use strict';
                        //validate only for tabs where car is involved
                        if(model.tab === 'package'){
                          return (validationHelpers.isPackageWithCar(model) && model.isCarDriverAgeWithinLimit === false);
                        }
                      },
                      [['isNotBlank', ['driverAge'], 'driver-age-blank'],
                       ['isValidDriverAge', ['driverAge'], 'driver-age-invalid']]],
    'origin' : [true,
                [
                  ['isNotBlank', ['origin'], 'origin-blank'],
                  ['isOriginDiffrentFromDestination', ['origin', 'destination'], 'origin-same']]],
    'destination' : [true,
                     [
                       ['isNotBlank', ['destination'], 'destination-blank']]],
    'startDate' : [
      function (model) {
        'use strict';
        return !jsonPath('isDateless', model) &&
          !validationHelpers.startAndEndDateAreBlank(model);
      },
      [
        ['isNotBlank', ['startDate'], 'date-blank'],
        ['isValidDate', ['startDate'], 'date-format-invalid'],
        ['isDateBeforeMaxDaysOut', ['startDate', 'config.calendar.furthestBookingDayOut'], 'date-range-long'],
        ['isDatePriorToCurrentDate', ['startDate'], 'date-before-today']]],
    'endDate' : [
      function (model) {
        'use strict';
        return !jsonPath('isDateless', model) &&
          !validationHelpers.startAndEndDateAreBlank(model);
      },
      [
        ['isNotBlank', ['endDate'], 'date-blank'],
        ['isValidDate', ['endDate'], 'date-format-invalid'],
        ['isDateBeforeMaxDaysOut', ['endDate', 'config.calendar.furthestBookingDayOut'], 'date-range-long'],
        ['isDatePriorToCurrentDate', ['endDate'], 'date-before-today'],
        ['isDateAfterCurrentDate', ['endDate'], 'date-range-long']]],
    'bothDates' : [
      function (model) {
        'use strict';
        return !jsonPath('isDateless', model) &&
          !validationHelpers.startAndEndDateAreBlank(model) &&
          !_.contains(jsonPath('validation.fields', model), 'startDate') &&
          !_.contains(jsonPath('validation.fields', model), 'endDate');
      },
      [
        ['isTripValidLength', ['startDate', 'endDate', 'config.calendar.maxTripLength'], 'trip-length-invalid'],
        ['isStartDateBeforeEndDate', ['startDate', 'endDate', 'config.calendar.minTripLength'], 'date-order-invalid']]],
    'totalNumberOfTravellers' : [true,
                                 [
                                   ['isTotalTravelersLessThanMax', ['rooms', 'config.travelers.maxTravelers'], 'too-many-travelers']]],
    'childAges' : [
      function (model) {
        'use strict';
        return jsonPath('rooms[0].childCount', model);
      },
      [
        ['isChildAgesAllProvided', ['rooms'], 'child-ages-not-all-provided']]],
    'partialStay': [
      function (model) {
        'use strict';
        return jsonPath('isPartialStay', model);
      },
      [
        ['isPartialDateWithinRange', ['checkin', 'startDate', 'endDate'], 'checkin-checkout-range', ['checkin']],
        ['isPartialDateWithinRange', ['checkout', 'startDate', 'endDate'], 'checkin-checkout-range', ['checkout']]], true],
    'checkin' : [
      function(model) {
        'use strict';
        return jsonPath('isPartialStay', model);
      },
      [
        ['isNotBlank', ['checkin'], 'date-blank'],
        ['isValidDate', ['checkin'], 'date-format-invalid'],
        ['isDatePriorToCurrentDate', ['checkin'], 'date-before-today']], false ],
    'checkout' : [
      function(model) {
        'use strict';
        return jsonPath('isPartialStay', model);
      },
      [
        ['isNotBlank', ['checkout'], 'date-blank'],
        ['isValidDate', ['checkout'], 'date-format-invalid'],
        ['isDatePriorToCurrentDate', ['checkout'], 'date-before-today']], false ]


  };
});

/*jslint nomen: true */
/*global _, corewizard, $ */

corewizard = corewizard || {};
corewizard.conf = corewizard.conf || {};
define('gc/packageConfig', [
  'gc/modelHelpers',
  'gc/inputDefaults',
  'gc/loc',
  'gc/packageValidationRules',
  'gc/packageConstraints',
  'gc/getLob'
], function(
  modelHelpers,
  inputDefaults,
  loc,
  packageValidationRules,
  packageConstraints,
  getLob
) {
    return {
        icon: ['flights', 'hotels'],
        searchUrlGenerator: 'eapAspSearchUrl',
        template: 'corewizard/layouts/wizard-hbs-packages',
        travelers : {
            maxTravelers : 6,
            maxRoomCount: 3
        },
        calendar: {
            'maxTripLength': 26,
            'minTripLength': 1
        },
        showDirectFlightCheckbox: false,
        validation : packageValidationRules,
        constraints: packageConstraints,
        viewRules: {
            'wizardTemplate': function (model) {
                var tab = model.get('tab');
                if (tab === 'overseaHotel') tab = 'hotel';
                if (_.contains(['flightHotel', 'flightHotelCar', 'flightCar', 'hotelCar'], tab)) {
                    tab = 'package';
                }
                return 'corewizard/layouts/wizard-hbs-' + tab + 's';
            },
            taDataKeyOrig : function (model) {
                var lob = getLob(model.get('tab'), model.get('packages'));
                switch(lob) {
                    case 'flightHotel' : return 'package_origin';
                    case 'flightHotelCar' : return 'package_origin';
                    case 'flightCar' : return 'package_FC_origin';
                    default : return 'package_origin';
                }
            },
            taDataKeyDest : function (model) {
                var lob = getLob(model.get('tab'), model.get('packages'));
                switch(lob) {
                    case 'flightHotel' : return 'package_dest';
                    case 'flightHotelCar' : return 'package_dest';
                    case 'flightCar' : return 'package_FC_dest';
                    default : return 'package_dest';
                }
            },
            "flightOriginLabel" : function() {
              return loc.flightOriginLabel;
            },
            "flightDestinationLabel" : function() {
              return loc.flightDestinationLabel;
            },
            'endDateHotelError': function(model) {
                'use strict';
                return _.contains(model.get('validation.fields'), 'endDate');
            },
            'showFlightOandD': function (model) {
                'use strict';
                return model.get('packages.flight');
            },
            'hasMultiDestFlight': function (model) {
                // because the flights soft package usecase goes through here
                'use strict';
                return true;
            },
            'showHotelDest': function (model) {
                'use strict';
                return !model.get('packages.flight');
            },
            'showRooms': function (model) {
                'use strict';
                return model.get('packages.hotel');
            },
            'hotelRoomCountOptions': function (model) {
                var namespace = (model.get('tab') === 'flight') ? 'flight-hotel' : 'package';
                return {
                    namespace: namespace + '-rooms',
                    'wizard_action': '{"roomCount" : "$value1"}',
                    'options': inputDefaults.rooms.options.slice(0,3),
                    'ia' : [{'name':'data-select-value', 'value':model.get('roomCount')},
                            {'name':'aria-required', 'value':'true'}],
                    'label-text': inputDefaults.rooms.label
                };
            },
            'preferredFlightCabinClassOptions': function (model) {
                return {
                    namespace: 'package-advanced-preferred-class',
                    'wizard_action': '{"cabinClass" : "$value1"}',
                    'options': inputDefaults.preferredClass.options,
                    'ia' : [{'name':'data-select-value', 'value':model.get('cabinClass')}],
                    'label-text': inputDefaults.preferredClass.label
                };
            },
            'flightAdultCountOptions': function (model) {
                return {
                    namespace: 'adults',
                    'wizard_action': '{"rooms[0].adults" : $value1}',
                    'options': inputDefaults.flightAdults.options,
                    'ia' : [{'name':'data-select-value', 'value':model.get('adults')},
                            {'name':'wizard-owner', 'value':'adults'},
                            {'name':'aria-required', 'value':'true'}],
                    'label-text': inputDefaults.flightAdults.label,
                    class: 'number-of-travellers'
                };
            },
            'flightChildCountOptions': function (model) {
                return {
                    namespace: 'children',
                    'wizard_action': '{"rooms[0].childCount" : $value1}',
                    'options': inputDefaults.flightChildren.options,
                    'ia' : [{'name':'data-select-value', 'value':model.get('children')},
                            {'name':'wizard-owner', 'value':'children'},
                            {'name':'data-children-fieldset', 'value':'children'},
                            {'name':'aria-redraw', 'value':'true'},
                            {'name':'aria-required', 'value':'true'}],
                    'label-text': inputDefaults.flightChildren.label,
                    class: 'children-select number-of-travellers'
                };
            },
            'noRooms': function (model) {
                'use strict';
                return !model.get('packages.hotel');
            },
            'showPartialStay': function (model) {
                'use strict';
                return model.get('packages.flight') && model.get('packages.hotel');
            },
            'showCarMessage': function (model) {
                'use strict';
                return model.get('packages.car');
            },
            'hasFlight': function (model) {
                'use strict';
                return model.get('packages.flight');
            },
            'hasCar': function (model) {
                'use strict';
                return model.get('packages.car') === "true" || model.get('packages.car') === true;
            },
            'rooms': function (model) {
                'use strict';
                var idString = 'package';
                if (model.get('packages.hotel')) {
                    if (model.get('tab') === 'flight') {
                        //automation expects flight-hotel for this suite of inputs.
                        idString = 'flight-hotel';
                    };
                    if (model.get('tab') === 'hotel') {
                        //automation expects hotel for this suite of inputs.
                        idString = 'hotel';
                    }
                    return modelHelpers.getRoomsForHotels(idString, model.get('rooms'));
                }
            },
            'isHotelDestinationVisible': function (model) {
                'use strict';
                var tab = model.get('tab');
                return tab === 'hotel' || tab === 'overseaHotel';
            },
            'hideFlightDestination': function (model) {
                'use strict';
                var tab = model.get('tab');
                return tab === 'hotel' || tab === 'overseaHotel';
            },
            'isRoundtrip': function () {
                'use strict';
                return true;
            },
            'hasChildren': function (model) {
                'use strict';
                return model.get('rooms[0].childCount') > 0 || (
                    getLob(model.get('tab'), model.get('packages')) !== 'flightCar' && (
                      (model.get('roomCount') > 1 && model.get('rooms[1].childCount') > 0) ||
                      (model.get('roomCount') > 2 && model.get('rooms[2].childCount') > 0)
                    )
                  )
            },
            'showAddHotelLink': function (model) {
                'use strict';
                return model.get('tab') === 'flight' &&
                  !model.get('packages.hotel');
            },
            'showAddCarLink': function (model) {
                'use strict';
                return (model.get('tab') === 'flight' || model.get('tab') === 'hotel') &&
                  !model.get('packages.car');
            },
            'hideChildrenFlightFields': function (model) {
                'use strict';
                return (model.get('packages.car') || model.get('packages.hotel')) &&
                  !model.get('packages.flight');
            },
            'ages': function (model) {
                'use strict';
                return modelHelpers.getChildrenForHotels(model.get('ages'), 0, model.get('tab'));
            },
            'showLapOrSeat': function (model) {
                'use strict';
                if (model.get('packages.hotel')) {
                    return _.some(model.get('rooms'), function(room) {
                        return _.some(room.children, function (age) {
                            return !_.isNull(age) && age !== '' && age <= model.get('config.travelers.infantAge');
                        });
                    });
                } else {
                    return _.some(model.get('rooms')[0].children, function (age) {
                        return !_.isNull(age) && age !== '' && age <= model.get('config.travelers.infantAge');
                    });
                }
            },
            'packageOrder': function (model) {
                'use strict';
                var hasFlight = model.get('packages.flight');
                var hasHotel = model.get('packages.hotel');
                var hasCar = model.get('packages.car');
                var hasTrain = model.get('packages.train');

                var isFH  = (hasFlight && hasHotel && !hasCar && !hasTrain) ? true : false; //force cast into boolean
                var isFHC = (hasFlight && hasHotel && hasCar && !hasTrain) ? true : false;
                var isFC  = (hasFlight && !hasHotel && hasCar && !hasTrain) ? true : false;
                var isHC  = (!hasFlight && hasHotel && hasCar && !hasTrain) ? true : false;
                var isTH  = (!hasFlight && hasHotel && !hasCar && hasTrain) ? true : false;

                var label = loc.tabLoc;
                var fh  = {id:'package-fh',  value:'true:true:false:false', checked:isFH,  display:label.flightHotel};
                var fhc = {id:'package-fhc', value:'true:true:true:false',  checked:isFHC, display:label.flightHotelCar};
                var fc  = {id:'package-fc',  value:'true:false:true:false', checked:isFC,  display:label.flightCar};
                var hc  = {id:'package-hc',  value:'false:true:true:false', checked:isHC,  display:label.hotelCar};
                var th  = {id:'package-th',  value:'false:true:false:true', checked:isTH,  display:label.trainHotel};
                var pkglobs = {'fh':fh, 'fhc':fhc, 'fc':fc, 'hc':hc, 'th':th};

                var packageOrder = [];
                $.each(model.get('config.masterconfig.packageOrder').split(','), function(index, value) {
                    packageOrder.push(pkglobs[value]);
                });
                return packageOrder;
            },

            'isMultiplePackageOrder': function(model) {
                return model.get('config.masterconfig.packageOrder').split(',').length > 1;
            },

            'checkinAction': function (model) {
                'use strict';
                if (model.get('isPartialStay') || model.get('tab') === 'flight') {
                    return '{"checkin" : "$value1"}';
                } else {
                    return '{"startDate" : "$value1"}';
                }
            },
            'checkinValue': function (model) {
                'use strict';
                if (model.get('isPartialStay') || model.get('tab') === 'flight') {
                    return model.get('checkin');
                } else {
                    return model.get('startDate') || model.get('checkin');
                }
            },
            'checkoutAction': function (model) {
                'use strict';
                if (model.get('isPartialStay') || model.get('tab') === 'flight') {
                    return '{"checkout" : "$value1"}';
                } else {
                    return '{"endDate" : "$value1"}';
                }
            },
            'checkoutValue': function (model) {
                'use strict';
                if (model.get('isPartialStay') || model.get('tab') === 'flight') {
                    return model.get('checkout');
                } else {
                    return model.get('endDate');
                }
            },
            'isPartialStay' : function(model) {
                //remove isPartialStay for hotel-car
                if (model.get('packages.hotel') && model.get('packages.car') && !model.get('packages.flight')) return false;
                else return model.get('isPartialStay');
            },
            'startDateHotelError' : function(model) {
                'use strict';
                if (model.get('isPartialStay')) return _.contains(model.get('validation.fields'), 'checkin');
                return _.contains(model.get('validation.fields'), 'startDate');

            },
            'showDirectFlightCheckbox' : function(model) {
                'use strict';
                return model.get('config.showDirectFlightCheckbox');
            },
            'showFlightHotelPackageUpsell' : function(model) {
                'use strict';
                var overseaHotelFlight = (model.get('packages.flight') && model.get('tab') === 'overseaHotel');
                return (model.get('packages.flight') &&
                  model.get('packages.hotel') &&
                  !model.get('packages.car') &&
                  !model.get('packages.train')) || overseaHotelFlight;
            },
            "searchText" : function (model) {
                var text = loc.searchButtonText.defaultText;
                var tab = model.get('tab');
                if (tab === 'hotel' || tab === 'overseaHotel') {
                    if (model.get('packages.flight') &&
                      model.get('packages.car')) {
                        text = loc.searchButtonText.hotelFlightCarText;
                    } else if (model.get('packages.flight')) {
                        text = loc.searchButtonText.hotelFlightText;
                    } else if (model.get('packages.car')) {
                        text = loc.searchButtonText.hotelCarText;
                    }
                }
                return text;
            },
            'isFlightSelectEnabled': function(model) {
                'use strict';
                return false;
            },
            'hideFlightOptions': function (model) {
                'use strict';
                return !model.get('showFlightOptions');
            }
        }
    };
});

define('gc/flightCarConstraints', ['gc/modelHelpers'], function(modelHelpers) {
  return {
      'rooms' : function (state, config) {
          return modelHelpers.getRoomsForModel.call(this, state, config).slice(0,1);
      }
  }
});

define('gc/flightCarValidationRules', ['gc/validationHelpers'], function(validationHelpers) {
  return {
    "carDriverAge": [
                      function (model) {
                        'use strict';                        
                        return (validationHelpers.isPackageWithCar(model) && model.isCarDriverAgeWithinLimit === false);
                      },
                      [['isNotBlank', ['driverAge'], 'driver-age-blank'],
                       ['isValidDriverAge', ['driverAge'], 'driver-age-invalid']]],
    'startDate' : [
      true,
      [
        ['isNotBlank', ['startDate'], 'date-blank'],
        ['isValidDate', ['startDate'], 'date-format-invalid'],
        ['isDateBeforeMaxDaysOut', ['startDate', 'config.calendar.furthestBookingDayOut'], 'date-range-long'],
        ['isDatePriorToCurrentDate', ['startDate'], 'date-before-today'],
        ['isStartDateBeforeEndDate', ['startDate', 'endDate', 'config.calendar.minTripLength'], 'date-order-invalid']
      ]
    ],
    'endDate' : [
      true,
      [
        ['isNotBlank', ['endDate'], 'date-blank'],
        ['isValidDate', ['endDate'], 'date-format-invalid'],
        ['isDateBeforeMaxDaysOut', ['endDate', 'config.calendar.furthestBookingDayOut'], 'date-range-long'],
        ['isDatePriorToCurrentDate', ['endDate'], 'date-before-today']
      ]
    ]
  }
});

/*jslint nomen: true */
/*global _, corewizard */

define('gc/flightCarConfig', [
  'gc/flightCarConfigOverride',
  'gc/packageConfig',
  'gc/inputDefaults',
  'gc/flightCarValidationRules',
  'gc/flightCarConstraints'
], function(
  flightCarConfigOverride,
  packageConfig,
  inputDefaults,
  flightCarValidationRules,
  flightCarConstraints
) {
    return $.extend(true, {}, packageConfig, {
        'model' : {
            'packages' : {
                flight: true,
                hotel: false,
                car: true,
                train: false
            }
        },
        viewRules: {
            'flightAdultCountOptions': function (model) {
                return {
                    namespace: 'package-adults',
                    'wizard_action': '{"rooms[0].adults" : $value1}',
                    'options': inputDefaults.flightAdults.options,
                    'ia' : [{'name':'data-select-value', 'value':model.get('adults')},
                            {'name':'wizard-owner', 'value':'adults'},
                            {'name':'aria-required', 'value':'true'}],
                    'label-text': inputDefaults.flightAdults.label,
                    class: 'number-of-travellers'
                };
            },
            'flightChildCountOptions': function (model) {
                return {
                    namespace: 'package-children',
                    'wizard_action': '{"rooms[0].childCount" : $value1}',
                    'options': inputDefaults.flightChildren.options,
                    'ia' : [{'name':'data-select-value', 'value':model.get('children')},
                            {'name':'wizard-owner', 'value':'children'},
                            {'name':'data-children-fieldset', 'value':'children'},
                            {'name':'aria-redraw', 'value':'true'},
                            {'name':'aria-required', 'value':'true'}],
                    'label-text': inputDefaults.flightChildren.label,
                    class: 'children-select number-of-travellers'
                };
            }
        },
        'constraints' : flightCarConstraints,
        'validation' : flightCarValidationRules,
        'calendar' : {
            'minTripLength' : 0
        }
    }, flightCarConfigOverride);
});

define('gc/hotelCarValidationRules', ['gc/hotelValidationRules', 'gc/merge'], function(hotelValidationRules, merge) {
  var rules =  merge(hotelValidationRules, {}); // this will clone hotelValidationRules
  delete rules.origin;
  return rules;
});

/*jslint nomen: true */
/*global _, corewizard */

define('gc/hotelCarConfig', [
  'gc/hotelConfig',
  'gc/packageConfig',
  'gc/loc'
], function (
  hotelConfig,
  packageConfig,
  loc
) {
  var HC = $.extend(true, {}, packageConfig, {
    'validation': $.extend(true, {}, hotelConfig.validation),
    'model': {
      'packages': {
        flight: false,
        hotel: true,
        car: true,
        train: false
      }
    },
    'calendar': {
      'minTripLength': 1
    },
    'viewRules': {
      'hotelCarDestinationLabel': function (model) {
        return loc.hotelCarDestinationLabel;
      },
      'hotelCarDestinationPlaceholder': function (model) {
        return loc.hotelCarDestinationPlaceholder;
      }
    }
  });

  delete HC.validation.origin;
  return HC;
});

/*jslint nomen: true */
/*global _, corewizard */

define('gc/flightHotelConfig', ['gc/packageConfig', 'gc/packageConfigOverride'], function(packageConfig, packageConfigOverride){
    return $.extend(true, packageConfig, packageConfigOverride, {
        'packageSetting_flight' : true,
        'packageSetting_hotel' : true,
        'packageSetting_car' : false,
        'model' : {
            'packages' : {
                flight: true,
                hotel: true,
                car: false,
                train: false
            }
        },
        'calendar': {
            'maxTripLength': 26,
            'minTripLength': 1
        }
    });
});



/*jslint nomen: true */
/*global _, corewizard */

define('gc/flightHotelCarConfig', ['gc/packageConfig'], function(packageConfig){
    return $.extend(true, {}, packageConfig, {
        'packageSetting_flight' : true,
        'packageSetting_hotel' : true,
        'packageSetting_car' : true,
        'model' : {
            'packages' : {
                flight: true,
                hotel: true,
                car: true,
                train: false
            }
        },
        'calendar': {
          'minTripLength': 1
        }
    });
});

define('gc/cruiseValidationRules', [], function() {
    return {
        'cruiseEarliestDepartureDate' : [true,
            [
                ['isValidDateOrBlank', ['cruiseEarliestDepartureDate'], 'date-format-invalid'],
                ['isDateAfterCurrentDateOrBlank', ['cruiseEarliestDepartureDate'], 'date-before-today']]],
        'cruiseLatestDepartureDate' : [true,
            [
                ['isValidDateOrBlank', ['cruiseLatestDepartureDate'], 'date-format-invalid'],
                ['isDateAfterCurrentDateOrBlank', ['cruiseLatestDepartureDate'], 'date-before-today']]],
        'bothDates' : [
            ['cruiseEarliestDepartureDate', 'cruiseLatestDepartureDate'],
            [
                ['areAllDatesValidOrBlank', ['cruiseEarliestDepartureDate', 'cruiseLatestDepartureDate'], 'date-format-invalid']]]
    }
});

define('gc/cruiseConstraints', [], function() {
  return {
      "id": "cruise",
      "main": true,
      "destination": function (state, config) {
          'use strict';
          return state.get("cruiseDestination");
      },
      "cruiseMonth": function (state, config) {
          'use strict';
          return state.get("cruiseMonth");
      },
      "months": function (state, config) {
          'use strict';
          if (typeof this.monthValues === 'undefined') {
              var numberOfMonths,
                months,
                currDate,
                currMonth,
                currYear,
                monthValues,
                i;

              numberOfMonths = config.get("calendar.numberOfCruiseMonths");
              months = config.get("calendar.months");

              currDate = new Date();
              currMonth = currDate.getMonth();
              currYear = currDate.getFullYear();
              monthValues = [{display: "Show All", value: "4501-1-1"}];

              for (i = 0; i < numberOfMonths; i += 1) {
                var monthVal = ((currMonth % 12) + 1);
                  monthValues.push({display: months[currMonth % 12] + currYear,
                      value: currYear + "-" + monthVal + "-" + "01" });
                  currMonth += 1;
                  if (currMonth % 12 === 0) {
                      currYear += 1;
                  }
              }

              this.monthValues = monthValues;
          }
          return this.monthValues;
      },
      "cruiseEarliestDepartureDate": function (state, config) {
          'use strict';
          return state.get("cruiseEarliestDepartureDate");
      },
      "cruiseLatestDepartureDate": function (state, config) {
          'use strict';
          return state.get("cruiseLatestDepartureDate");
      },
      'backOutJson' : function(state, config) {
          var value = state.get('cruiseSailingDates');
          if (value && value.whitelistedDates) {
              return value.whitelistedDates;
          }
          return '';
      }
  }
});

/*jslint nomen: true */
/*global _ */

define('gc/cruiseConfig', [
    'gc/cruiseConfigOverride',
    'gc/loc',
    'jquery',
    'gc/cruiseConstraints',
    'gc/abTest',
    'gc/cruiseValidationRules',
    'gc/defaultConfig',
    'gc/inputDefaults',
    'env',
    'gc/dataModels'
], function(
    cruiseConfigOverride,
    loc,
    $,
    cruiseConstraints,
    abTest,
    cruiseValidationRules,
    defaultConfig,
    inputDefaults,
    env,
    dataModels
) {
    var NEW_DEFAULT_DEST_LABEL = loc.cruise.selectDestinationLabel;
    var NEW_DEFAULT_MONTH_LABEL = loc.cruise.selectDateLabel;
    var NO_FILTER = "---";

    var cruiseConfig = {
        icon: ['cruise'],
        template: 'corewizard/field-groups/cruise-hbs',
        searchUrlGenerator: 'cruiseSearchUrl',
        calendar: {
            numberOfCruiseMonths: 18,
            months: [ "January ", "February ", "March ", "April ", "May ", "June ",
                "July ", "August ", "September ", "October ", "November ", "December " ]
        },
        validation : cruiseValidationRules,
        constraints : cruiseConstraints,
        viewRules : {
            'searchText' : loc.searchButtonText.defaultText,
            'cruiseStorefrontDateBasedSearch': function (model) {
                'use strict';
                return abTest.get(10120).value === 1;
            },
            'cruiseDestinationOptions': function (model) {
                return {
                    namespace: 'cruise-destination',
                    'wizard_action': '{"cruiseDestination" : "$value1"}',
                    'options': inputDefaults.cruises.options,
                    'ia' : [{'name':'data-select-value', 'value':model.get('cruiseDestination')}],
                    'label-text': inputDefaults.cruises.label
                };
            }
        },
        model : {}
    };

    langCheck = function(langid) {
        if (env.locale === 'en_US') {
            inputDefaults.cruises.options[0].name = NEW_DEFAULT_DEST_LABEL;

            cruiseConfig.expLogged = false;
            cruiseConfig.filterControls = {
                destination: {
                    name: 'destination',
                    getQueryParam: function (state, value) {
                        var queryParam = {};
                        if (typeof value !== 'undefined') {
                            if (value) {
                                queryParam = {
                                    "destination": value
                                };
                            }
                        } else {
                            var selectedDest = state.get("cruiseDestination");
                            if (selectedDest) queryParam = {"destination": selectedDest};
                        }
                        return queryParam;
                    },
                    update: function (data, state) {
                        if (data && data.destinations) {
                            var items = {};
                            for (var i in data.destinations) {
                                var dest = data.destinations[i];
                                if (_.isUndefined(items[dest.groupName])) {
                                    items[dest.groupName] = [];
                                }
                                items[dest.groupName].push({
                                    name: dest.optionText,
                                    value: dest.optionValue,
                                    selected: dest.selected,
                                    index: dest.index
                                });
                            }
                            inputDefaults.cruises.options = [{name: NEW_DEFAULT_DEST_LABEL, value: ''}];
                            for (var groupName in items) {
                                inputDefaults.cruises.options.push({name: groupName, options: items[groupName]});
                            }
                        }
                    }
                },
                departureMonth: {
                    name: 'departureMonth',
                    getQueryParam: function (state, value) {
                        var queryParam = {};
                        if (!cruiseConfig.datePickerEnabled(state)) {
                            if (typeof value !== 'undefined') {
                                if (value) {
                                    var earliest = new Date(value);
                                    var latest = new Date(earliest.getFullYear(), earliest.getMonth() + 2, 0);
                                    queryParam = {
                                        "earliest-departure-date": cruiseConfig.getFormattedDate(earliest),
                                        "latest-departure-date": cruiseConfig.getFormattedDate(latest)
                                    };
                                }
                            } else {
                                var selectedMonth = state.get("cruiseMonth");
                                if (selectedMonth) {
                                    var earliest = new Date(selectedMonth);
                                    var latest = new Date(earliest.getFullYear(), earliest.getMonth() + 2, 0);
                                    queryParam = {
                                        "earliest-departure-date": cruiseConfig.getFormattedDate(earliest),
                                        "latest-departure-date": cruiseConfig.getFormattedDate(latest)
                                    };
                                }
                            }
                        }
                        return queryParam;
                    },
                    update: function (data, state) {
                        if (data && data.departureMonths && !cruiseConfig.datePickerEnabled(state)) {
                            var items = [{name: NEW_DEFAULT_MONTH_LABEL, value: ""}];
                            for (var i in data.departureMonths) {
                                var month = data.departureMonths[i];
                                if (month.index === 1) {
                                    items.push({
                                        name: month.optionText,
                                        value: month.optionValue,
                                        selected: month.selected,
                                        index: month.index
                                    });
                                }
                            }
                            state.set('cruiseDepartureMonthOptions', items);
                        }
                    }
                },
                earliestDepartureDate: {
                    name: 'earliestDepartureDate',
                    getQueryParam: function (state, value) {
                        var queryParam = {};
                        if (cruiseConfig.datePickerEnabled(state)) {
                            if (value) {
                                queryParam = {
                                    "earliest-departure-date": cruiseConfig.getFormattedDate(value)
                                };
                            } else {
                                var startDate = state.get("cruiseEarliestDepartureDate");
                                if (startDate) {
                                    var earliest = new Date(startDate);
                                    queryParam = {
                                        "earliest-departure-date": cruiseConfig.getFormattedDate(earliest)
                                    };
                                }
                            }
                        }
                        return queryParam;
                    },
                    update: function (data, state) {
                        var whitelistedDates = '', datePickerEnabled = false, cruiseSailingDates = {};
                        if (data && cruiseConfig.datePickerEnabled(state)) {
                            whitelistedDates = '{"dates":' + data['jsonDepartureDateWhitelist'] + ',"blackoutDatesFlag":false}';
                            datePickerEnabled = true;
                            cruiseSailingDates.whitelistedDates =  whitelistedDates;
                            cruiseSailingDates.earliestDepartureDate =  state.get('cruiseEarliestDepartureDate');
                            cruiseSailingDates.latestDepartureDate =  state.get('cruiseLatestDepartureDate');
                        } else {
                            datePickerEnabled = false;
                        }
                        state.set('datePickerEnabled', datePickerEnabled);
                        state.set('cruiseSailingDates', cruiseSailingDates);
                    }
                },
                latestDepartureDate: {
                    name: 'latestDepartureDate',
                    getQueryParam: function (state, value) {
                        var queryParam = {};
                        if (cruiseConfig.datePickerEnabled(state)) {
                            if (value) {
                                queryParam = {
                                    "latest-departure-date": cruiseConfig.getFormattedDate(value)
                                };
                            } else {
                                var endDate = state.get("cruiseLatestDepartureDate");
                                if (endDate) {
                                    var latest = new Date(endDate);
                                    queryParam = {
                                        "latest-departure-date": cruiseConfig.getFormattedDate(latest)
                                    };
                                }
                            }
                        }
                        return queryParam;
                    },
                    update: function (data, state) {
                        var whitelistedDates = '', datePickerEnabled = false, cruiseSailingDates = {};
                        if (data && cruiseConfig.datePickerEnabled(state)) {
                            whitelistedDates = '{"dates":' + data['jsonDepartureDateWhitelist'] + ',"blackoutDatesFlag":false}';
                            datePickerEnabled = true;
                            cruiseSailingDates.whitelistedDates =  whitelistedDates;
                            cruiseSailingDates.earliestDepartureDate =  state.get('cruiseEarliestDepartureDate');
                            cruiseSailingDates.latestDepartureDate =  state.get('cruiseLatestDepartureDate');
                        } else {
                            datePickerEnabled = false;
                        }
                        state.set('cruiseSailingDates', cruiseSailingDates);
                        state.set('datePickerEnabled', datePickerEnabled);
                    }
                }
                /*
                 ,
                 cruiseLine: {
                 getQueryParam: function(state) {'cruise-line'},
                 update: function(data, state) {}
                 },
                 departurePort: {
                 getQueryParam: function(state) {'cruise-line'},
                 update: function(data, state) {}
                 },
                 cruiseLength:  {
                 getQueryParam: function(state) {'departure-port'},
                 update: function(data, state) {}
                 },
                 */
            };

            cruiseConfig.viewRules.BEXAsiaAdditionalCruiseFilters = true;

            cruiseConfig.model.cruiseDepartureMonthOptions = [{name: NEW_DEFAULT_MONTH_LABEL, value: ""}];
            cruiseConfig.model.cruiseLineOptions = [{name: "", value: ""}];
            cruiseConfig.model.cruisePortOptions = [{name: "", value: ""}];
            cruiseConfig.model.cruiseLengthOptions = [{name: "", value: ""}];

            cruiseConfig.constraints.cruiseFiltersEvar47 = function (model) {
                return [
                    "CRUISE",
                    model.get("cruiseDestination") ? "CDES" : NO_FILTER,
                    model.get("cruiseLine") ? "CLIN" : NO_FILTER,
                    model.get("cruisePort") ? "DPOR" : NO_FILTER,
                    model.get("cruiseMonth") ? "DMON" : NO_FILTER,
                    model.get("cruiseLength") ? "CLEN" : NO_FILTER
                ].join("|");
            };

            cruiseConfig.getSearchOptions = function (searchParameters, doneCallback, alwaysCallback) {
                var cruiseSelectBoxes = $("#tab-cruise").find("select");
                var cruiseInput = $("#tab-cruise").find("input");
                cruiseSelectBoxes.prop('disabled', true);
                cruiseInput.prop('disabled', true);
                $.ajax(
                    {
                        method: 'POST', // jQuery >= 1.9.0
                        type: 'POST', // jQuery < 1.9.0
                        url: env.cruiseEndpoint,
                        data: searchParameters,
                        dataType: 'json',
                        timeout: 10000
                    })
                    .done(doneCallback)
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        console.error("Failed to retrieve wizard data from /cruiseSearchCriteria/getSearchOptionsV2", jqXHR, textStatus, errorThrown);
                    })
                    .always(function (data) {
                        alwaysCallback(data);
                        cruiseSelectBoxes.prop('disabled', false);
                        cruiseInput.prop('disabled', false);
                    });
            };

            cruiseConfig.initialiseFilterOptions = function (state) {
                state.set('cruiseEarliestDepartureDate', '');
                state.set('cruiseLatestDepartureDate', '');

                var searchParameters = {},
                    destination = state.get('cruiseDestination');
                if (destination && destination.length > 0) {
                    searchParameters['destination'] = destination;
                }
                cruiseConfig.getSearchOptions(searchParameters,
                    function (data) {
                        for (var i in cruiseConfig.filterControls) {
                            var ctrl = cruiseConfig.filterControls[i];
                            ctrl.update(data, state);
                        }
                    },
                    function () {
                    }
                );
            };

            cruiseConfig.filterChange = function (filter, state, value) {
                cruiseConfig.getSearchOptions(cruiseConfig.getQueryParams(filter, state, value),
                    function (data) {
                        for (var i in cruiseConfig.filterControls) {
                            var ctrl = cruiseConfig.filterControls[i];
                            ctrl.update(data, state);
                        }
                    },
                    function () {
                        state.trigger('reloadWizard');
                    }
                );
            };

            /*
             {
             'destination': 'caribbean',
             'earliest-departure-date': '2016-1-1',
             'latest-departure-date': '2016-2-28'
             }
             */
            cruiseConfig.getQueryParams = function (filter, state, value) {
                var queryParams = {};
                for (var i in cruiseConfig.filterControls) {
                    var ctrl = cruiseConfig.filterControls[i];
                    if (i === filter.name) {
                        queryParams = $.extend(true, {}, queryParams, ctrl.getQueryParam(state, value));
                    } else {
                        queryParams = $.extend(true, {}, queryParams, ctrl.getQueryParam(state));
                    }
                }

                if (cruiseConfig.datePickerEnabled(state)) {
                    if (queryParams['earliest-departure-date'] && !queryParams['latest-departure-date']) {
                        queryParams['latest-departure-date'] = queryParams['earliest-departure-date'];
                        state.set('latest-departure-date', cruiseConfig.getCalendarFormattedDateFromString(queryParams['latest-departure-date']));
                    } else if (!queryParams['earliest-departure-date'] && queryParams['latest-departure-date']) {
                        queryParams['earliest-departure-date'] = queryParams['latest-departure-date'];
                        state.set('earliest-departure-date', cruiseConfig.getCalendarFormattedDateFromString(queryParams['earliest-departure-date']));
                    }
                }

                return queryParams;
            };

            cruiseConfig.getFormattedDate = function (date) {
                var result = "";
                if (date) {
                    var curr_date = date.getUTCDate(),
                        curr_month = date.getUTCMonth() + 1,
                        curr_year = date.getUTCFullYear();
                    result = curr_year + "-" + curr_month + "-" + curr_date;
                }
                return result;
            };

            cruiseConfig.getCalendarFormattedDateFromString = function (date) {
                if (date) {
                    var datePieces = date.split("-"),
                        year = datePieces[0],
                        month = datePieces[1],
                        day = datePieces[2];

                    return month + "/" + day + "/" + year;
                }

                return "";
            };

            cruiseConfig.track = function (tag) {
                if (window.dctk && dctk.onReady) {
                    dctk.onReady(function () {
                        dctk.trackAction(tag);
                    });
                }
            };

            cruiseConfig.datePickerEnabled = function (state) {
                return cruiseConfig.viewRules.cruiseStorefrontDateBasedSearch();
            };

            defaultConfig.addEvent('cruiseDestination', function (state, value) {
                cruiseConfig.track('CRU.SF.Filter.Destination');
                cruiseConfig.filterChange(cruiseConfig.filterControls.destination, state, value);
            });
            defaultConfig.addEvent('cruiseMonth', function (state, value) {
                cruiseConfig.track('CRU.SF.Filter.Month');
                cruiseConfig.filterChange(cruiseConfig.filterControls.departureMonth, state, value);
            });
            //      defaultConfig.addEvent('cruiseLine', function(state, value) {cruiseConfig.filterChange(cruiseConfig.filterControls.cruiseLine, state, value);});
            //      defaultConfig.addEvent('cruisePort', function(state, value) {cruiseConfig.filterChange(cruiseConfig.filterControls.departurePort, state, value);});
            //      defaultConfig.addEvent('cruiseLength', function(state, value) {cruiseConfig.filterChange(cruiseConfig.filterControls.cruiseLength, state, value);});

            // don't include uitk in the main module dependancies so we don't
            // have to wait on it, but have this block wait for uitk to load
            require('uitk', function(uitk) {
              uitk.subscribe('datepicker.selectDate', function (topic, data) {
                  var id = data.element.context.id;

                  if (id === 'earliestDepartureDateParent') {
                      cruiseConfig.track('CRU.SF.Filter.Start.Date');
                      cruiseConfig.filterChange(cruiseConfig.filterControls.earliestDepartureDate, dataModels.state, data.date);
                  } else if (id === 'latestDepartureDateParent') {
                      cruiseConfig.track('CRU.SF.Filter.End.Date');
                      cruiseConfig.filterChange(cruiseConfig.filterControls.latestDepartureDate, dataModels.state, data.date);
                  }
              });
            });
        }
        else {

        }
    };
    langCheck();
    if (env.locale === 'en_US') {
        cruiseConfig.initialiseFilterOptions(dataModels.state);
    }

    $.extend(true, cruiseConfig, cruiseConfigOverride);

    return cruiseConfig;
});

define('gc/threePPConfig', ['gc/defaultConfig', 'gc/threePPConfigOverride'], function(defaultConfig, threePPConfigOverride) {
    var threePP = {
        enabled: false,
        icon: ['packages'],
        template: 'corewizard/layouts/wizard-hbs-threepp',
        searchUrlGenerator: 'threePPSearchUrl',
        eventsToAdd: {}
    };

    $.extend(true, threePP, threePPConfigOverride);

    if(threePP.enabled && Object.keys(threePP.eventsToAdd).length > 0 ) {
        Object.keys(threePP.eventsToAdd).forEach(function(key) {
            defaultConfig.addEvent(key, threePP.eventsToAdd[key]);
        });
    }

    return threePP;
});

define('gc/vacationRentalsConfig', [
    'jquery',
    'gc/vacationRentalsConfigOverride'
], function(
    $,
    vacationRentalsConfigOverride
) {
    var vacationRentalsConfig = {
        icon: ['vacation-rentals'],
        isEnabled: function() {
            return true;
        }
    };

    $.extend(true, vacationRentalsConfig, vacationRentalsConfigOverride);

    return vacationRentalsConfig;
});

define('gc/vacationRentalConfig', [
    'jquery',
    'gc/vacationRentalConfigOverride',
    'gc/modelHelpers',
    'gc/loc',
    'gc/vacationRentalValidationRules',
    'gc/vacationRentalConstraints'
], function(
    $,
    vacationRentalConfigOverride,
    modelHelpers,
    loc,
    vacationRentalValidationRules,
    vacationRentalConstraints
) {
    var vacationRentalConfig = {
        icon: ['vacation-rentals'],
        template: 'corewizard/layouts/wizard-hbs-vacationRental',
        searchUrlGenerator: 'vacationRentalSearchUrl',
        calendar : {
            furthestBookingDayOut: 500,
            maxTripLength: 28,
            minTripLength: 1
        },
        travelers: {
            maxRoomCount: 8,
            ninePlusRoomsAllowed: true
        },
        typeahead: {
            def: {
                lob: 'HOTELS',
                selectioncallback: function () {
                    'use strict';
                    typeaheadItemClickCallback();
                },
                mask: 223,
                version: 'v1'
            }
        },
        validation: vacationRentalValidationRules,
        constraints : vacationRentalConstraints,
        viewRules: {
            'hotelDestinationPlaceholderText' : loc.hotelDestinationPlaceholderText,
            'isHotelDestinationVisible': function (model) {
                'use strict';
                return model.get('tab') === 'hotel';
            },
            'searchText' : function (model) {
                var text = loc.searchButtonText.defaultText;
                if (model.get('isHotelOnly') && model.get('isNinePlusRoomRequest')) {
                    text = loc.searchButtonText.hotel9Plus;
                }
                return text;
            },
            'checkinAction': function (model) {
                return '{"startDate" : "$value1"}';
            },
            'checkinValue': function (model) {
                return model.get('startDate');
            },
            'checkoutAction': function (model) {
                return '{"endDate" : "$value1"}'
            },
            'checkoutValue': function (model) {
                return model.get('endDate');
            }
        },
        isEnabled: function() {
            return true;
        }
    };

    $.extend(true, vacationRentalConfig, vacationRentalConfigOverride);

    return vacationRentalConfig;
});

define('gc/vacationRentalValidationRules', [
  'gc/validationHelpers',
  'gc/json-path'
], function(
  validationHelpers,
  jsonPath
) {
  return {
    "destination" : [true,
                     [
                       ["isNotBlank", ["destination"], "destination-blank"]]],
    "startDate" : [
      function (model) {
        'use strict';
        return !jsonPath('isDateless', model) && !validationHelpers.startAndEndDateAreBlank(model);
      },
      [
        ["isNotBlank", ["startDate"], "date-blank"],
        ["isValidDate", ["startDate"], "date-format-invalid"],
        ["isDateBeforeMaxDaysOut", ["startDate", "config.calendar.furthestBookingDayOut"], "date-range-long"],
        ["isDatePriorToCurrentDate", ["startDate"], "date-before-today"]]],
    "endDate" : [
      function (model) {
        'use strict';
        return !jsonPath('isDateless', model) && !validationHelpers.startAndEndDateAreBlank(model);
      },
      [
        ["isNotBlank", ["endDate"], "date-blank"],
        ["isValidDate", ["endDate"], "date-format-invalid"],
        ["isDateBeforeMaxDaysOut", ["endDate", "config.calendar.furthestBookingDayOut"], "date-range-long"],
        ["isDatePriorToCurrentDate", ["endDate"], "date-before-today"],
        ["isDateAfterCurrentDate", ["endDate"], "date-range-long"]]],
    "bothDates" : [
      function (model, ruleSetResults) {
        'use strict';
        return !jsonPath('isDateless', model) &&
          !validationHelpers.startAndEndDateAreBlank(model) &&
          !_.contains(ruleSetResults.fields, "startDate") &&
          !_.contains(ruleSetResults.fields, 'endDate');
      },
      [
        ["isTripValidLength", ["startDate", "endDate", "config.calendar.maxTripLength"], "trip-length-invalid"],
        ["isStartDateBeforeEndDate", ["startDate", "endDate", 'config.calendar.minTripLength'], "date-order-invalid"]]]
  }
});

define('gc/vacationRentalConstraints', ['gc/modelHelpers', 'gc/loc'], function(modelHelpers, loc) {
  return {
      "main" : true,
      "id" : "vacationRental",
      "destination" : modelHelpers.getRegionNameOrDestination,
      "startDate" : function (state, config) {
          'use strict';
          return state.get("startDate") || state.get("checkin");
      },
      "endDate" : modelHelpers.getEndDate,
      "isDateless" : function (state, config) {
          'use strict';
          return state.get("noDate");
      }
  }
});

define('gc/openSearchConfig', [
    'jquery',
    'gc/loc',
    'gc/openSearchConfigOverride',
    'gc/openSearchValidationRules'
], function(
    $,
    loc,
    openSearchConfigOverride,
    openSearchValidationRules
) {
    var openSearchConfig = {
        icon: ['search'],
        template: 'corewizard/field-groups/open-search-hbs',
        searchUrlGenerator: 'openSearchUrl',
        validation: openSearchValidationRules,
        isEnabled: function() {
            return false;
        },
        viewRules: {
            'openSearchLabel': function(model){
                'use strict';
                return loc.openSearchLabel;
             },
              "searchText" : loc.searchButtonText.defaultText
        }
    };

    $.extend(true, openSearchConfig, openSearchConfigOverride);

    return openSearchConfig;
});

define('gc/openSearchValidationRules', [], function() {
  return {
  "searchQuery": [true,
                     [
                       ['isNotBlank', ['searchQuery'], 'search-query-blank']]]
  }
});
define('gc/railValidationRules', ['underscore', 'gc/validationHelpers', 'gc/json-path'], function(_, validationHelpers, jsonPath) {
    return {

        'origin' : [true,
            [
                ['isNotBlank', ['trainOrigin'], 'origin-blank'],
                ['isOriginDiffrentFromDestination', ['trainOrigin', 'trainDestination'], 'origin-same']]],

        'destination' : [true,
            [
                ['isNotBlank', ['trainDestination'], 'destination-blank']]],

        'startDate' : [true,
            [
                ['isNotBlank', ['startDate'], 'date-blank'],
                ['isValidDate', ['startDate'], 'date-format-invalid'],
                ['isDateBeforeMaxDaysOut', ['startDate', 'config.calendar.furthestBookingDayOut'], 'date-range-long'],
                ['isDatePriorToCurrentDate', ['startDate'], 'date-before-today']]],

        'endDate' : [
            function (model, ruleSetResults) {
                'use strict';
                return jsonPath('isRoundtrip', model);
            },
            [
                ['isNotBlank', ['endDate'], 'date-blank'],
                ['isValidDate', ['endDate'], 'date-format-invalid'],
                ['isDateBeforeMaxDaysOut', ['endDate', 'config.calendar.furthestBookingDayOut'], 'date-range-long'],
                ['isDatePriorToCurrentDate', ['endDate'], 'date-before-today']]],

        'tripLength': [

            function (model, ruleSetResults) {
                'use strict';
                return jsonPath('isRoundtrip', model);
            },
            [
                ['isTripWithTimeValidLongEnough', ['startDate', 'rail.departureTime', 'endDate', 'rail.returningTime', 'config.calendar.minTripTime'], 'rail-time-too-short']
            ]
        ],

        'bothDates' : [
            function (model, ruleSetResults) {
                'use strict';
                return jsonPath('isRoundtrip', model) &&
                    !validationHelpers.startAndEndDateAreBlank(model) &&
                    !_.contains(ruleSetResults.fields, "startDate") &&
                    !_.contains(ruleSetResults.fields, 'endDate');
            },
            [
                ['isStartDateBeforeEndDate', ['startDate', 'endDate', 'config.calendar.minTripLength'], 'date-order-invalid'],
                ['isTripValidLength', ['startDate', 'endDate', 'config.calendar.maxTripLength'], 'trip-length-invalid']
            ]
        ],

        'totalNumberOfTravellers' : [true, [['isRailTotalTravelersLessThanMax', ['rooms', 'config.travelers.maxTravelers'], 'too-many-rail-travelers']]],

        'numberOfTravellersZero' : [true, [['isRailTotalTravelersZero', ['rooms'], 'zero-rail-travelers']]],

        'childAbove13' : [true, [['isChildAloneAbove13', ['rooms'], 'child-alone-too-young']]],

        'childTravelingWithChild' : [true, [['isChildTravelingWithChild', ['rooms'], 'child-cant-travel-with-child']]],

        'cardCount' : [true, [['railCardCheck', ['rooms', 'rail.cards'], 'too-many-rail-cards']]],

        'childAges' : [true, [['isRailChildAgesAllProvided', ['rooms'], 'child-ages-not-all-provided']]],

        'youthAges' : [true, [['isRailYouthAgesAllProvided', ['rooms'], 'youth-ages-not-all-provided']]],

        'seniorAges' : [true, [['isRailSeniorAgesAllProvided', ['rooms'], 'senior-ages-not-all-provided']]],

        'railsCardType': [true, [['isRailCardTypeProvided', ['rail.cards'], 'rails-card-type-not-provided']]],

        'railsOriginFromTA':[true, [['isRailOriginFromTA', ['originTLA','originFromTA','trainOrigin'], 'rails-origin-not-from-ta']]],

        'railsDestinationFromTA':[true, [['isRailDestinationFromTA', ['destinationTLA','destinationFromTA','trainDestination'], 'rails-destination-not-from-ta']]]


    }
});

define('gc/railConfig', [
    'jquery',
    'gc/loc',
    'gc/inputDefaults',
    'gc/railConfigOverride',
    'gc/railSearchUrl',
    'gc/railValidationRules',
    'gc/modelHelpers'
], function(
    $,
    loc,
    inputDefaults,
    railConfigOverride,
    railSearchUrl,
    railValidationRules,
    modelHelpers
) {
    var getDepartureTime = function() {
        var now = new Date();
        now.setMinutes(Math.ceil((now.getMinutes()+30)/ 30) * 30);
        var hours = now.getHours();
        var minutes = now.getMinutes();
        minutes = minutes < 10 ? '0'+ minutes : minutes.toString();
        hours = hours < 10 ? '0' + hours : hours.toString();

        return hours + minutes;
    };

    var getAgesOptions = function(key, keyCount, model) {
        'use strict';
        var nbPax = model.get('rooms[0].'+keyCount);
        var ages = [];
        for(var i=0; i<nbPax; i++) {
            ages.push({
                namespace: key+'-age-select-' + i + '',
                hasError: function() {
                    var invalidFields = model.get('validation.fields');
                    return invalidFields && invalidFields.length>0 && _.contains(invalidFields, this.namespace);
                },
                'wizard_action': '{"rooms[0].'+key+'['+i+']":"$value1"}',
                'options': model.get('config.ageOptions.'+key),
                'label-text': loc.rail[key+'AgeLabel'].replace('{0}', (i+1)),
                'ia' : [
                    {'name':'data-select-value', 'value':model.get('rooms[0].'+key+'['+i+']')},
                    {'name':'aria-required', 'value':'true'},
                    {'name':'data-redraw', 'value':'true'} // will reformat correctly the model value. Like Array instead of Object.
                ]
            });
        }
        return ages;
    };

    var getCardsOptions = function(key, index, options, model) {
        return {
            namespace: 'railcard-'+key+'-select-' + index + '',
            hasError: function() {
                var invalidFields = model.get('validation.fields');
                return invalidFields && invalidFields.length>0 && _.contains(invalidFields, this.namespace);
            },
            'wizard_action': '{"rail.cards['+index+'].'+key+'":"$value1"}',
            'options': options,
            'label-text': '',
            'class': key=="count" && !model.get('rail.cards['+index+'].type') ? 'hidden': '',
            'ia' : [
                {'name':'data-select-value', 'value':model.get('rail.cards['+index+'].'+key)},
                {'name':'aria-required', 'value':'true'},
                {'name':'data-redraw', 'value':'true'}, // will reformat correctly the model value. Like Array instead of Object.
                key=="count" && !model.get('rail.cards['+index+'].type') ? {'name':'disabled', 'value': true} : {  }
            ]
        };
    };

    var buildAgeRangeOptions = function(ageRange) {
        var ageOptions = [{name: loc.rail.select, value: null, selected: 'selected'}];
        for(var i=ageRange.min; i<=ageRange.max; i++) {
            var iName = (i==0) ? loc.childUnder1 : String(i);
            var iStr = String(i);
            ageOptions.push({name: iName, value: iStr});
        }
        return ageOptions;
    };

    var buildSeniorAgeRangeOptions = function(ageRange) {
        var ageOptions = [{name: loc.rail.select, value: null, selected: 'selected'}];
        for(var i=ageRange.min; i<=ageRange.max; i++) {
            var iName = i === ageRange.max ? String(i +'+') : String(i);
            var iStr = String(i);
            ageOptions.push({name: iName, value: iStr});
        }
        return ageOptions;
    };

    var selectedDepartureTime = getDepartureTime();

    var railConfig = {
        icon: ['train'],
        template: 'corewizard/layouts/rail-hbs',
        calendar: {
            'maxTripLength': 83,
            'minTripLength': 0,
            'furthestBookingDayOut': 83,
            'minTripTime': 0.5
        },
        cardTypes: [
            {name: loc.rail.selectCardLabel, value: '', selected: 'selected'},
            {name: 'UK Annual Gold Card', value: 'UK_ANNUAL_GOLD'},
            {name: 'UK Disability Child Railcard', value: 'UK_CHILD_DISABILITY'},
            {name: 'UK Disability Railcard', value: 'UK_DISABILITY'},
            {name: 'UK Family and Friends Railcard', value: 'UK_FAMILY_FRIENDS'},
            {name: 'UK GroupSave', value: 'UK_GROUPSAVE'},
            {name: 'UK HM Forces Railcard', value: 'UK_HM_ARMED_FORCES'},
            {name: 'UK Jobcentre Plus', value: 'UK_JOBCENTRE_PLUS'},
            {name: 'UK Network Railcard', value: 'UK_NETWORK'},
            {name: 'Scottish Youth Railcard', value: 'UK_SCOTTISH_YOUTH'},
            {name: 'UK Senior Railcard', value: 'UK_SENIOR'},
            {name: 'UK Two Together', value: 'UK_TWO_TOGETHER'},
            {name: 'UK Youth Railcard (16-25)', value: 'UK_YOUTH'}
        ],
        travelers: {
           infantAge: 1,
           defaultChildAge: '',
           maxTravelers: 8,
           maxChildren: 7
       },
       defaultNumAdults: {defaultNum: 2},
        ageRange: {
            child: {
                min: 0,
                max: 15
            },
            youth: {
                min: 16,
                max: 25
            },
            senior: {
                min: 60,
                max: 62
            }
        },
        model: {
            // Default values for select boxes if user doesn't touch them
            rail: {
                type: "oneway",
                nbpax: {
                    adult: 1
                },
                ages: {
                    adult: 40,
                    child: [],
                    youth: [],
                    senior: []
                },
                departureTime: selectedDepartureTime,
                returningTime: selectedDepartureTime,
                departingSearchBy: 'DEPARTURE',
                returningSearchBy: 'DEPARTURE',
                cards: [{type:0,count:1}]
                },
                rooms: [{
                      adults: 1,
                      children: [],
                      childCount: 0,
                      youths: [],
                      youthCount: 0,
                      seniors: [],
                      seniorCount: 0}]
                    },
        constraints: {
            'isRoundtrip': function (state) {
                'use strict';
                return state.get('rail.type') === 'roundtrip';
            },
            'isOneWay': function (state) {
                'use strict';
                return state.get('rail.type') === 'oneway';
            },
            'adults': function (state, config) {
                'use strict';
                return state.get('rooms[0].adults') || config.get('model.rooms[0].adults');
            },
            'rooms': function (state) {
                'use strict';
                return modelHelpers.getRoomsForModelRails(state);
            },
            'startDate': function (state) {
                'use strict';
                return state.get('startDate');
            },
            'endDate': modelHelpers.getEndDate
        },
        isEnabled: function() {
            return true;
        },
        validation : railValidationRules,
        viewRules: {
            'showAddRailCardLink': function(model){
              'use strict';
              var maxTravelers = model.get('config.travelers.maxTravelers') || 0;
              var cards = model.get('rail.cards') || [];
              var cleanCard = cards[cards.length-1];
              if(cards.length == 1){
                  return (cards.length < maxTravelers && cards.length > 0 && cleanCard.type != 0);
              }else{
                  return (cards.length < maxTravelers && cards.length > 0);
              }
            },
            'showRemoveButton': function(model){
              'use strict';
              var maxTravelers = model.get('config.travelers.maxTravelers') || 0;
              var cards = model.get('rail.cards') || [];

              return !(cards.length === 1 ) || cards[0].type;
            },
            departureTimeOptions: function(model) {
                return {
                    namespace: 'departureTime',
                    'wizard_action': '{"rail.departureTime" : "$value1"}',
                    'options': inputDefaults.rail.time,
                    hasError: function() {
                        var invalidFields = model.get('validation.fields');
                        return invalidFields && invalidFields.length>0 && _.contains(invalidFields, 'rail.departureTime');
                    },
                    'ia' : [{'name':'data-select-value', 'value':model.get('rail.departureTime')}],
                    'label-text': loc.rail.time
                };
            },
            returningTimeOptions: function(model) {
                return {
                    namespace: 'returningTime',
                    'wizard_action': '{"rail.returningTime" : "$value1"}',
                    'options': inputDefaults.rail.time,
                    hasError: function() {
                        var invalidFields = model.get('validation.fields');
                        return invalidFields && invalidFields.length>0 && _.contains(invalidFields, 'rail.returningTime');
                    },
                    'ia' : [{'name':'data-select-value', 'value':model.get('rail.returningTime')}],
                    'label-text': loc.rail.time
                };
            },
            railAdults: function(model) {
                return {
                    namespace: 'rail-adults',
                    hasError: function() {
                        var invalidFields = model.get('validation.fields');
                        return invalidFields && invalidFields.length>0 && _.contains(invalidFields, this.namespace);
                    },
                    'wizard_action': '{"rooms[0].adults" : "$value1"}',
                    'options': inputDefaults.rail.nbAdults,
                    'ia' : [{'name':'data-select-value', 'value':model.get('adults')},
                            {'name':'aria-required', 'value':'true'}],
                    'label-text': loc.rail.adultsLabel
                };
            },
            railChildren: function(model) {
                return {
                    namespace: 'childAges',
                    'wizard_action': '{"rooms[0].childCount" : "$value1"}',
                    'options': inputDefaults.rail.nbChildren,
                    'ia' : [{'name':'data-select-value', 'value':model.get('rooms[0].childCount')}],
                    'label-text': loc.rail.childrenLabel
                };
            },
            railYouth: function(model) {
                return {
                    namespace: 'youthAges',
                    'wizard_action': '{"rooms[0].youthCount" : "$value1"}',
                    'options': inputDefaults.rail.nbYouths,
                    'ia' : [{'name':'data-select-value', 'value':model.get('rooms[0].youthCount')}],
                    'label-text': loc.rail.youthLabel
                };
            },
            railSenior: function(model) {
                return {
                    namespace: 'seniorAges',
                    'wizard_action': '{"rooms[0].seniorCount" : "$value1"}',
                    'options': inputDefaults.rail.nbSeniors,
                    'ia' : [{'name':'data-select-value', 'value':model.get('rooms[0].seniorCount')}],
                    'label-text': loc.rail.seniorLabel
                };
            },
            railChildAges: function(model) {
                return getAgesOptions('children', 'childCount', model);
            },
            railYouthAges: function(model) {
                return getAgesOptions('youths', 'youthCount', model);
            },
            railSeniorAges: function(model) {
                return getAgesOptions('seniors', 'seniorCount', model);
            },
            addRailCard: function(model) {
                var maxTravelers = model.get('config.travelers.maxTravelers') || 0;
                var cards = model.get('rail.cards');
                var cardsCopy = cards ? cards.slice() : [];
                if (cardsCopy.length < maxTravelers || cardsCopy.length === 0) {
                  cardsCopy.push({type:0, count:1});
                }
                return '{"rail.cards":'+JSON.stringify(cardsCopy)+' }';
            },
            railCardsOptions: function(model) {
                'use strict';
                var cards = model.get('rail.cards');
                cards = cards ? cards : [];
                var cardOptions = [];
                for(var i=0; i<cards.length; i++) {

                  var cardsCopy = JSON.parse( JSON.stringify(cards) ); //Clone array avoiding object references
                  if( cards.length === 1 && cards[i].type ){ // 0 and empty string coers to false
                    cardsCopy[i].type = 0;
                    cardsCopy[i].count = 1;
                  }else{
                    cardsCopy.splice(i,1);
                  }

                  cardOptions.push({
                      type: getCardsOptions('type', i, model.get('config.cardTypes'), model),
                      count: getCardsOptions('count', i, inputDefaults.rail.cardCount, model),
                      remove: '{"rail.cards":'+JSON.stringify(cardsCopy)+' }',
                      deleteCardLabel: loc.rail.deleteCard
                  });
                }
                return cardOptions;
            },
            departingSearchBy: function(model) {
                return {
                    namespace: 'departingTime',
                    'wizard_action': '{"rail.departingSearchBy" : "$value1"}',
                    'options': inputDefaults.rail.searchBy,
                    'ia' : [{'name':'data-select-value', 'value':model.get('rail.departingSearchBy')}],
                    'label-text': loc.rail.searchBy
                };
            },
            returningSearchBy: function(model) {
                return {
                    namespace: 'arrivingTime',
                    'wizard_action': '{"rail.returningSearchBy" : "$value1"}',
                    'options': inputDefaults.rail.searchBy,
                    'ia' : [{'name':'data-select-value', 'value':model.get('rail.returningSearchBy')}],
                    'label-text': loc.rail.searchBy
                };
            }
        }
    };

    $.extend(true, railConfig, railConfigOverride);

    railConfig.searchUrlGenerator = function (model) {
        return railSearchUrl(model);
    };

    railConfig.ageOptions = {
        children: buildAgeRangeOptions(railConfig.ageRange.child),
        youths: buildAgeRangeOptions(railConfig.ageRange.youth),
        seniors: buildSeniorAgeRangeOptions(railConfig.ageRange.senior)
    };

    return railConfig;
});

define('gc/wizardConfig', ['pageConfigOverride', 'gc/wizardConfigFun'], function(pageConfigOverride, wizardConfigFun) {
    return wizardConfigFun(pageConfigOverride);
});

define('gc/wizardConfigFun', ['jquery', 'gc/wizardConfigOverride', 'gc/merge'],
  function($, wizardConfigOverride,  merge) {
    return function(pageConfigOverride) {
      var wizardConfig = merge(wizardConfigOverride, pageConfigOverride);

      // total replacement of lobs
      if(pageConfigOverride && pageConfigOverride.lobs) {
        wizardConfig.lobs = pageConfigOverride.lobs;
      }

      return wizardConfig;
    }
});

/*jslint nomen: true */
/*global Backbone, corewizard */

define('gc/Config', [
  'gc/merge',
  'gc/getLob',
  'gc/getDefaultTabAndPackages',
  'gc/json-path',
  'underscore'
], function(
  merge,
  getLob,
  getDefaultTabAndPackages,
  jsonPath,
  _
) {
  'use strict';
  return function(config, stateObj) {

    var _config;
    var _state;
    var _defaultTab;
    var _defaultPackages;

    function constructor(config, stateObj) {
      _config = config;
      _state = stateObj;

      this.attributes = _config;

      XDate.prototype.setParseDateFormat(_config.def.dateFormat);

      var defaultTabAndPackages = getDefaultTabAndPackages(arguments[0]);
      _defaultTab = defaultTabAndPackages.tab;
      _defaultPackages = defaultTabAndPackages.packages;

    };

    this.get = function(key) {
      var lobKey = this.getCurrentLob() + '.' + key;
      var defaultKey = 'def.' + key;

      var lobSpecificConfig = jsonPath(lobKey, _config);
      var defaultConfig = jsonPath(defaultKey, _config);

      if (_.isObject(lobSpecificConfig) && _.isObject(defaultConfig)) {
          return merge(defaultConfig, lobSpecificConfig);
      } else {
          return lobSpecificConfig || defaultConfig;
      }
    };

    this.set = function(key, value) {
      var keyParts = key.split('.');
      _config[keyParts[0]][keyParts[1]] = value;
    }

    this.getCurrentLob = function() {
      var tab = _state.get('tab');
      var pkg = _state.get('packages');
      if (!tab) {
        tab = _defaultTab;
      }
      if (!pkg) {
        pkg = _defaultPackages;
      }
      return getLob(tab, pkg);
    };

    this.toJSON = function() {
      'use strict';
      var tab = _state.get('tab');
      var pkg = _state.get('packages');
      return merge(config['def'], config[this.getCurrentLob()]);
    };

    constructor.apply(this, [config, stateObj]);
  };
});

define('gc/validationHelpers', ['underscore', 'gc/predicates', 'gc/json-path', 'gc/getLob'],
       function(_, predicates, jsonPath, getLob) {
  return {
    startAndEndDateAreBlank: function (model) {
      return (!predicates.isNotBlank(jsonPath('startDate', model)).isValid) &&
        (!predicates.isNotBlank(jsonPath('endDate', model)).isValid)
    },

    //check if a package selected and car is included 
    isPackageWithCar: function (model) {    	
        //validate only for tabs where car is involved
        if(model.tab === 'package' || model.tab === 'flight' || model.tab === 'hotel'){
          var lob = getLob(model.tab, model.packages);               
          return  _.contains(['flightHotelCar', 'flightCar', 'hotelCar'], lob);
        }
    }
  }
});

/*
Validator is used mainly in submit.js to validate model data on form submission,
but can also be used in other places. Validation data consists of a:

"ruleSet", which is a javascript object that consists of
  - "ruleGroups", which is an array that contains
    - "rules"
 */

define('gc/validate', ['gc/predicates', 'gc/json-path', 'underscore'], function(predicates, jsonPath, _) {
  var defaults = {
    'isValid' : true,
    'fields' : [],
    'errors' : []
  };

  function validate(ruleSet, model) {
    // return value: {isValid: Boolean, fields: [String], errors: [String]}
    'use strict';
    var validationResults = runRuleSet(ruleSet, model);
    return validationResults;
  }

  function runRuleSet(ruleSet, model) {
    // ruleSet: {ruleGroup1: RuleGroup, ruleGroup2: RuleGroup}
    // return value: {isValid: Boolean, fields: [String], errors: [String]}
    'use strict';
    var ruleSetResult = _.clone(defaults);

    _.each(ruleSet, function(ruleGroup) {
      if (shouldRunRuleGroup(ruleSet, model, ruleGroup, ruleSetResult)) {
        ruleSetResult = mergeResult(ruleSetResult, runRuleGroup(ruleGroup, model));
      }
    });

    return ruleSetResult;
  }

  function runRuleGroup(ruleGroup, model) {
    // ruleGroup: [[String]|Function|Boolean, [Rule], (Boolean)]
    // return value: {isValid: Boolean, fields: [String], errors: [String]}
    'use strict';
    var ruleList = _.isFunction(ruleGroup[1]) ?
        ruleGroup[1].call(this, model) :
        ruleGroup[1];
    // set to true if you want the tests to continue after finding an error
    var failFast = !ruleGroup[2];
    var ruleGroupResult = _.clone(defaults);

    //using find so we can break out of the loop
    _.find(ruleList, function (rule) {
      var ruleResult = runRule(rule, model);
      ruleGroupResult = mergeResult(ruleGroupResult, ruleResult);
      if (failFast && !ruleResult.isValid) {
        return true; //break
      }
    });

    return ruleGroupResult;
  }

  function runRule(rule, model) {
    // rule: [String, [String], String, ([String])]
    // return value: {isValid: Boolean, fields: [String], errors: [String]}
    'use strict';
    var validationFnName = rule[0];
    var propertiesToValidate = rule[1];
    var errorName = rule[2];
    var errorProperties = rule[3];
    var validationFn = predicates[validationFnName];
    var propertyValues = _.map(propertiesToValidate,
                               function(property) {
                                 return jsonPath(property, model);
                               });
    var result = validationFn.apply(predicates, propertyValues);

    if (!result.isValid) {
      result = mergeResult(result, {
        fields:  errorProperties ? errorProperties : propertiesToValidate,
        errors: [errorName]
      });
    }

    return result;
  }

  function mergeResult(result1, result2) {
    // result1, result2, and return value: {isValid: Boolean, fields: [String], errors: [String]}
    'use strict';
    result1 = _.clone(result1);

    if (!result2.isValid) result1.isValid = false;
    result1.fields = _.union(result1.fields, result2.fields);
    result1.errors = _.union(result1.errors, result2.errors);

    return result1;
  }

  function shouldRunRuleGroup(ruleSet, model, ruleGroup, ruleSetResult) {
    'use strict';
    var runCond = ruleGroup[0];
    if (_.isArray(runCond)) {
      // this should be a list of field names which must be valid to run
      var rules = [];
      _.each(runCond, function(rule) {
        var ruleGroup = ruleSet[rule]
        if (ruleGroup) {
          rules.push(ruleGroup);
        }
      });
      var results = runRuleSet(rules, model);
      return _.intersection(results.fields, runCond).length === 0;
    } else if (_.isFunction(runCond)) {
      return runCond.call(this, model, ruleSetResult);
    }else{
      return runCond;
    }
  }

  return validate;
});

define('gc/State', ['jquery'], function($) {

  return Backbone.NestedModel.extend({
    // need to bootstrap the rooms array or it get's turned into an object
    // bug https://jira/jira/browse/MAIN-120543
    defaults: {
      rooms: [{
        adults: 0,
        childCount: 0,
        guests: 0,
        children: [],
        youths: [],
        youthCount: 0,
        seniors: [],
        seniorCount: 0
      }],
      rail: {
        cards: [{type:0, count:1}]
      }
    },
    clear: function(options) {
      Backbone.NestedModel.prototype.clear.call(this, options);
      this.set(this.defaults, options);
    }
  });
});

/*jslint nomen: true */
/*global Backbone, corewizard, $ */

define('gc/DefaultState', ['jquery'], function($) {
    return Backbone.NestedModel.extend({
        constructor : function (attributes, options) {
            'use strict';
            this.state = options.state;
            this.config = options.config;
            Backbone.NestedModel.apply(this, arguments);
        },
        get : function (key) {
            'use strict';
            var result;

            result = this.state.get(key);
            if (typeof result === 'undefined') {
                result = this.config.get('model.' + key);
            }

            return result;
        },
        toJSON: function () {
            'use strict';
            var stateJSON,
              defaultJSON;

            stateJSON = this.state.toJSON();
            defaultJSON = this.config.get('model');

            return $.extend(true, {}, defaultJSON, stateJSON);
        }
    });
});
/*jslint nomen: true */
/*global Backbone, _, corewizard, $ */

define('gc/ConstraintModel', ['jquery'], function($) {
    return Backbone.NestedModel.extend({
        constructor : function (attributes, options) {
            'use strict';
            this.state = options.state;
            this.config = options.config;
            Backbone.NestedModel.apply(this, arguments);
        },
        get : function (key) {
            'use strict';
            var result,
              constraints,
              con;
            if (key.indexOf('config.') === 0) {
                result = this.config.get(key.replace('config.', ''));
            } else {
                constraints = this.config.get('constraints');
                con = constraints[key];

                if (con) {
                    if (typeof con === 'function') {
                        result = con.call(this, this.state, this.config);
                    } else {
                        result = con;
                    }
                } else {
                    result = this.state.get(key);

                    if (typeof result === 'undefined' || result === null) {
                        result = this.config.get('model.' + key);
                    }
                }
            }

            return result;
        },
        toJSON: function () {
            'use strict';
            var tempModel,
              constraints;

            constraints = this.config.get('constraints');
            tempModel = this.state.toJSON();

            _.each(constraints, function (value, key) {
                if (typeof value === 'function') {
                    tempModel[key] = value.call(this, this.state, this.config);
                } else {
                    tempModel[key] = value;
                }
            }, this);

            tempModel.config = this.config.toJSON();

            return tempModel;
        }
    });
});
/*global Backbone, _ */

define('gc/ViewModel', ['jquery'], function($) {
    return Backbone.NestedModel.extend({
        constructor: function (attributes, options) {
            'use strict';

            this.model = options.model;

            Backbone.NestedModel.apply(this, arguments);
        },
        get: function (key) {
            'use strict';

            var viewRules,
              rule,
              value;

            viewRules = this.model.get('config.viewRules');
            rule = viewRules[key];

            if (rule) {
                if (typeof rule === 'function') {
                    value = rule.call(this, this.model, this.model.state);
                } else {
                    value = rule;
                }
            } else {
                value = this.model.get(key);
            }

            return value;
        },
        toJSON: function () {
            'use strict';

            var tempModel,
              viewRules;

            viewRules = this.model.get('config.viewRules');
            tempModel = this.model.toJSON();

            _.each(viewRules, function (value, key) {
                if (typeof value === 'function') {
                    tempModel[key] = value.call(this, this.model);
                } else {
                    tempModel[key] = value;
                }
            }, this);

            return tempModel;
        }
    });
});

define('gc/dataModels', [
  'gc/State',
  'gc/Config',
  'gc/ViewModel',
  'gc/DefaultState',
  'gc/ConstraintModel'
], function(
  State,
  Config,
  ViewModel,
  DefaultState,
  ConstraintModel
) {
  var dm = {
    state: new State()
  };
  dm.update = function(c) {
    dm.state.clear({silent:true});
    dm.config = new Config(c, dm.state);
    dm.defaultState = new DefaultState({}, {state: dm.state, config: dm.config});
    dm.model = new ConstraintModel({}, {state: dm.defaultState, config: dm.config});
    dm.viewModel = new ViewModel({}, {model: dm.model });
    return dm;
  }

  return dm;
});

define('gc/preferredAirlines', ['gc/loc', 'gc/dataModels', 'env', 'gc/defaultConfig','gc/abTest'], function(loc, dataModels, env, defaultConfig, abTest) {
  return {
    setPreferredAirlines: function () {
      var useTravelEntitiesAPI = abTest.get(12299).value;
      if (useTravelEntitiesAPI == 1) {
        var url = ['//',window.location.host,'/travel-entities/airlines?isMajor=true&sort=name'];
        if (typeof env.siteId != "undefined" && env.siteId.length > 0) url.push('&siteid=',env.siteId);
        if (typeof env.locale != "undefined" && env.locale.length > 0) url.push('&locale=',env.locale);
      } else {
        var url = ['//', window.location.host, '/api/flight/getairlines'];
        if (typeof env.langId != "undefined" && env.langId.length > 0) url.push('?langid=',env.langId);
      }
      $.ajax({
        url: url.join(''),
        timeout: env.airlinesTimeout,
        success: getPreferredAirlinesSuccess,
        error: function() {console.warn('failed to get preferred airlines');}
      });
    }
  };

  function getPreferredAirlinesSuccess(airlineData) {
    airlineData = parseAirlineData(airlineData);
    defaultConfig.model.preferredAirlines = airlineData;
    var viewModel = dataModels.viewModel;
    if (viewModel.get('tab') === 'flight' && viewModel.get('showFlightOptions') === true) {
      dataModels.state.trigger('reloadWizard');
    }
  }

  function parseAirlineData(airlineData) {
    if (airlineData.hasOwnProperty('data')) {
      airlineData = airlineData.data;
    }
    airlineData = _.map(airlineData, function(airline) {
      return { name: airline.name, value: airline.code };
    });
    airlineData.unshift({
      name : loc.preferredAirlineDefault,
      value : '',
      selected : 'selected'
    });
    return airlineData;
  }
});

/*
 * Dependencies:
 * jQuery
 * corewizard.logger
 * JSON (needs to be added with trunk/content/static_content/default/default/scripts/external/json/json2.js for older browsers)
 */
define('gc/config', ['gc/Logger'], function(Logger) {
	return function(json) {
		var logger = new Logger('corewizard.model');
		var addJSON = logger.returnLoggingFunction('addJSON', function (json) {
			for (var component in json) {
				if (_data[component]) {
					for (var context in json[component]) {
							if (_data[component][context]) {
								for (var property in json[component][context]) {
									_data[component][context][property] = json[component][context][property];
								}
							} else {
								_data[component][context] = json[component][context];

							}
					}
				} else {
					_data[component] = json[component];
				}
			}
		});
		var getContexts = logger.returnLoggingFunction('getContexts', function (context) {
			if (context instanceof Array) {
				context.push('def');
			} else if (typeof context == 'string') {
				context = [context, 'def'];
			} else {
				context = ['def'];
			}
			return context;
		});
		logger.attacheLoggingFunction(this, 'get', function(component, property, context, field) {
			var result = undefined;
			if (field) {
				if (field.is('[data-wizard-type="' + property + '"]')) {
					result = field.attr('data-' + component);
				} else {
					result = field.attr('data-' + component + '-' + property);
				}
				if (result) {
					if (result == 'true')
						return true;
					if (result == 'false')
						return false;
					return result;
				}
			}
			if (!_data[component])
				return undefined;
			context = getContexts(context);
			var i = 0;
			while (typeof result == 'undefined' && i < context.length) {
				if (!_data[component][context[i]]) {
					i ++;
					continue;
				}
					result = _data[component][context[i]][property];
				i ++;
			}
			return result;
		});
		logger.attacheLoggingFunction(this, 'getAll', function(context) {
			'use strict';
			var component, property, currentContext, data = {};
			for (component in _data) {
				context = getContexts(context);
				for (var i = context.length - 1; i >= 0; i --) {
					currentContext = context[i];
						for (property in _data[component][currentContext]) {
							if (!data[component])
								data[component] = {};
							data[component][property] = _data[component][currentContext][property];
						}
				}
			}
			return data;
		});
		this.add = addJSON;
		var _data = {model:{}};
		addJSON(json);
	}
	
});
/*
 * Dependencies:
 * expClientLogging
 */
define('gc/Logger', function () {
	var doLogging = false;
	return function(filename) {
		var _filename = filename;
		function logError(functionName, e) {
			if (doLogging && window['expClientLogging']) {
				expClientLogging.logMessage(functionName + 'Error',
						['errorName=' + e.name, 'errorMessage=' + e.message, 'stackTrace=' + e.stack,
				          'file=' + _filename, 'module=coreWizard', 'function=' + functionName]);
				}
				throw e;
		}
		this.attacheLoggingFunction = function(obj, name, fun) {
			if (doLogging) {
				obj[name] = logingFunction(name, fun, obj);
			} else {
				obj[name] = fun;
			}
		};
		function logingFunction(name, fun, obj) {
			if (doLogging) {
				obj = obj || null;
				return function() {
					try {
						fun.call(obj, arguments);
					} catch (e) {
						logError(name, e)
					}
				};
			} else {
				return fun;
			}
		}
		this.returnLoggingFunction = logingFunction;
		this.log = logError;
		this.setDoLogging = function(value) {
			doLogging = value;
		};
		this.getDoLogging = function() {
			return doLogging;
		}
	}
});
define('gc/date', ['gc/config'], function (config) {
	var configJSON = {date:{def:{format:'mm/dd/yyyy',
								 seporator:'/',
								 normalizedFormat:'mmddyyyy'}}};
	var _config = new config(configJSON);
	var _millasecondsInADay = (1000 * 60 * 60 * 24);
	var dateFormatAndIndices = {
		"mmddyy":{day:1,month:0, year:2, regex:'^(?:0*[1-9]|1[012])[- /.](?:0*[1-9]|[12][0-9]|3[01])(?:[- /.](?:20)*\\d\\d)*$'},
		"mmddyyyy":{day:1,month:0, year:2, regex:'^(?:0*[1-9]|1[012])[- /.](?:0*[1-9]|[12][0-9]|3[01])(?:[- /.](?:20)*\\d\\d)*$'},
		"ddmmyy":{day:0,month:1, year:2, regex:'^(?:0*[1-9]|[12][0-9]|3[01])[- /.](?:0*[1-9]|1[012])(?:[- /.](?:20)*\\d\\d)*$'},
		"ddmmyyyy":{day:0,month:1, year:2, regex:'^(?:0*[1-9]|[12][0-9]|3[01])[- /.](?:0*[1-9]|1[012])(?:[- /.](?:20)*\\d\\d)*$'},
		"yymmdd":{day:2,month:1, year:0, regex:'^(?:(?:20)*\\d\\d)[- /.](?:0*[1-9]|1[012])[- /.](?:0*[1-9]|[12][0-9]|3[01])*$'},
		"yyyymmdd":{day:2,month:1, year:0, regex:'^(?:(?:20)*\\d\\d)[- /.](?:0*[1-9]|1[012])[- /.](?:0*[1-9]|[12][0-9]|3[01])*$'}
	};
	return {
		isValidDate: function(value) {
			var regex = new RegExp(dateFormatAndIndices[_config.get('date', 'normalizedFormat')].regex);
			return regex.test(value);
		},
		fromString: function(value) {
			if (!value) {
		        return null;
		    }
		    var parsed = this.splitDate(value);
		    var date = new Date(parsed.year, parsed.month - 1, parsed.day); // month goes by index 0
		    if (isNaN(date.getTime())) {
		        return null
		    }
		    return date;
		},
        toString: function(date) {

            function monthAsString() {
                return date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
            }

            function dateAsString() {
                return date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
            }

            function yearAsString() {
                return date.getFullYear();
            }

            function format(format) {
                var result = format.toUpperCase().replace("MM", monthAsString());
                result = result.replace("DD", dateAsString());
                result = result.replace("YYYY", yearAsString());
                result = result.replace("YY", (yearAsString() % 2000));
                return result;
            };
            return format(_config.get('date', 'format'));
        },
		splitDate: function(value) {
			if (!value || value == "") {
		        return null;
		    }
		    var parts =  value.split(_config.get('date', 'seporator'));
		    var indices = dateFormatAndIndices[_config.get('date', 'normalizedFormat')];
		    if (indices == undefined) return [];
		    var parsedDate = {
		        day:parseInt(parts[indices.day], 10),
		        month:parseInt(parts[indices.month], 10),
		        year:parseInt(parts[indices.year], 10)
		    };
		    if (parsedDate.year < 100) parsedDate.year = 2000 + parsedDate.year;
		    return parsedDate;
		},
		compare: function(date1, date2) {
			date1 = this.getDate(date1);
			date2 = this.getDate(date2);
			if (!date1 || !date2) {
				return null;
			}
			if (date1 > date2) {
				return 1;
			} else if (date1 < date2) {
				return -1;
			} else {
				return 0;
			}
		},
		compareWithoutTime: function(date1, date2) {
			date1 = this.dropTimeInDate(this.getDate(date1));
			date2 = this.dropTimeInDate(this.getDate(date2));
			return this.compare(date1, date2);
		},
		addDaysToDate: function(date, days) {
			date = this.getDate(date);
			return new Date(date.getTime() + (_millasecondsInADay * days));
		},
		dropTimeInDate: function(date) {
			return new Date(date.getFullYear(), date.getMonth(), date.getDate());
		},
		getDate: function(date) {
			if (date instanceof Date) {
				return date;
			} else if (typeof date === 'number') {
				return new Date(date);
			} else if (typeof date === 'string') {
				return new Date(this.fromString(date));
			} else {
				return null;
			}
		},
		setConfig: function(config){
			_config = config;
		}
	};
});
define('gc/wizardHelpers', ['handlebars.runtime'], function(Handlebars) {
  var hbr_helpers = {
    extractAttributes : function(hash) {
      var ia = [];
      for (var key in hash) {
        //take all ia- attributes declared and put in an ia array.
        if (key.substr(0, 2) === 'ia') ia.push({
          name: [key.substr(3)],
          value: hash[key]
        });
      }
      return ia;
    },

    commonAttributes : function(data, options) {
      'use strict';
      data.wizard_action = options['wizard-action'];
      data.hasError = options['has-error'];
    },

    extractInputAttributes : function(hash) {
      var inputAttributes = [];
      for (var key in hash) {
        //take just attributes declared needed for the input and put in an inputAttributes array.
        if (key.substr(0, 8) === 'ia-value' || key.substr(0, 16) === 'ia-aria-required') inputAttributes.push({
          name: [key.substr(3)],
          value: hash[key]
        });
      }
      return inputAttributes;
    }
  };

  Handlebars.registerHelper('repeat', function(count, block) {
    var accum = "";
    var data = {};
    for (var i = 0; i < count; i++) {
      data.index = i;
      accum += block.fn(this, {data:data});
    }
    return accum;
  });

  Handlebars.registerHelper('iaDataSelectValue', function(value) {
    return [{'name':'data-select-value', 'value':value}];
  });

  Handlebars.registerHelper('assign', function (scope, key, operand, comparator, options) {
    if (scope && key && operand) {
      switch (operand) {
        case '!' :
          scope[key] = !comparator;
          break;
        default :
          scope[key] = comparator;
      }
    }
  });

  Handlebars.registerHelper('input-calendar', function(data, namespace, options) {
    var attributes = [],
      thisData = data,
      options = arguments[arguments.length - 1],
      companionLookup = {
        departing: 'returning',
        returning: 'departing',
        checkin: 'checkout',
        checkout: 'checkin'
      },
      companionAttrLookup = {
        departing: 'data-end-date',
        returning: 'data-start-date',
        checkin: 'data-end-date',
        checkout: 'data-start-date'
      },
      hotelFlightLookup = {
        checkin : 'departing',
        checkout : 'returning'
      };

    //remove value for dateless.
    if (options.hash['ia-value'] && data.isDateless) delete options.hash['ia-value'];

    thisData = $.extend({}, data, options.hash);

    var extension = {
      ia : hbr_helpers.extractAttributes(options.hash),
      namespace : namespace,
      companion : companionLookup[namespace],
      isDisabled : thisData.isDateless,
      inputAttributes : hbr_helpers.extractInputAttributes(options.hash),
      hasError : function() {
        if (thisData.id === 'hotel') {
          //lookup correct error keys for each situation.
          if (thisData.useFlightDates && typeof thisData.errTypes === 'object' && thisData.errTypes[hotelFlightLookup[namespace]])
            return true;
          if (thisData.useHotelDates && typeof thisData.errTypes === 'object' && thisData.errTypes[namespace])
            return true;
        }
        if (thisData.namespace === 'start') return thisData.errTypes && thisData.errTypes.departing;
        if (thisData.namespace === 'end') return thisData.errTypes && thisData.errTypes.returning;
        var hasError = thisData.errTypes && typeof thisData.errTypes === 'object' && thisData.errTypes[namespace];
        if (!hasError) return false; //no errors.
        return hasError;
      }
    };

    hbr_helpers.commonAttributes(extension, options.hash);

    if (options.hash['black-out-json']) {
      thisData.black_out_json = options.hash['black-out-json'];
      thisData.is_blackout = true;
    } else {
      thisData.is_blackout = false;
    }

    //apply min/max for hotels for 'hotel', 'flight-hotel', and 'hotel-flight'.
    var maxBooking = thisData.isHotelOnly ? 60 : 26;
    extension.ia.push({ name : 'data-max-booking-length', value : maxBooking});
    extension.ia.push({ name : 'data-max-range-length', value : maxBooking});

    if (thisData.id && thisData.id.indexOf('hotel') > -1) {
      extension.ia.push(
        //some default hotel calendar settings.
        { name : 'data-min-booking-length', value : '1' },
        { name : 'data-default-booking-length', value : '1' },
        { name : 'data-min-range-length', value : '1' },
        { name : 'data-default-range-length', value : '1' },
        { name : 'data-wizard-owner', value : thisData.id}
      );
    }

    //if there's an index, we're a multi destination field.
    //if () thisData.isMultiDest = true;
    if (thisData.index || thisData.index === 0) {
      if (!extension.wizard_action)
        extension['wizard_action'] = '{"multiDest.' + namespace + '[' + thisData.index + ']" : "$value1"}';
      thisData.isMultiDest = true;

    } else {
      if (!extension.wizard_action)
        extension['wizard_action'] = '{"' + (thisData.useFlightDates ? hotelFlightLookup[namespace] : namespace) + '" : "$value1"}';
    }
    //workaround for multiDest error states
    // if (_.contains(dataModels.model.get('validation.fields'), 'multiDest')) {
    //   if (_.contains(dataModels.model.get('validation.fields'), 'startDate:' + thisData.number)) {
    //     thisData.hasError = true;
    //   }
    // }

    $.extend(thisData, extension);

    if (!thisData.isMultiDest && !thisData.isOneWay) thisData['companion-attr'] = companionAttrLookup[namespace];
    return new Handlebars.SafeString(Handlebars.partials['corewizard/components/input-calendar-hbs'](thisData));
  });

  Handlebars.registerHelper('input-TA', function(data, namespace, options) {
    var options = arguments[arguments.length - 1],
      thisData = data;
    thisData = $.extend({}, data, options.hash);

    var extension = {
      namespace : namespace,
      ia : hbr_helpers.extractAttributes(options.hash),
      ta_key : options.hash['ta-key']
    };

    hbr_helpers.commonAttributes(extension, options.hash);

    if (thisData.index || thisData.index === 0) {
      thisData.index = '' + thisData.index;
      if (!extension.wizard_action)
        extension['wizard_action'] = '{"multiDest.' + namespace + '.[' + thisData.index + ']" : "$value1"}';
    }

    $.extend(thisData, extension);
    return new Handlebars.SafeString(Handlebars.partials['corewizard/components/input-ta-hbs'](thisData));
  });

  Handlebars.registerHelper('input', function(data, type, namespace, bool, options) {
    function swapIdAndNamespace(data) {
      var id = data.id;
      data.id = data.namespace;
      data.namespace = id;
      return data;
    }
    var options = arguments[arguments.length - 1],
      thisData = data;
    thisData = $.extend({}, data, options.hash);
    var extension = {
      namespace : namespace,
      ia : hbr_helpers.extractAttributes(options.hash),
      hasError : typeof thisData.errTypes === 'object' && thisData.errTypes[namespace],
      isChecked : bool
    };

    hbr_helpers.commonAttributes(extension, options.hash);

    switch (type) {
      case 'radio' :
        if (options.hash['ia-name'] === 'flight-type' && !thisData.isFlightOnly) {
          thisData.isDisabled = true;
          thisData['class'] = 'disabled col';
        }
    }
    $.extend(thisData, extension);

    //Allen Kim: Package radio buttons need to have id in the format "package-{{id}}"
    if (type === 'radio' && namespace === 'package') {
      thisData = swapIdAndNamespace(_.clone(thisData));
    }

    var templateName = Handlebars.partials['corewizard/components/input-' + type + '-hbs'];
    if (templateName)
      return new Handlebars.SafeString(templateName(thisData));
  });


  // Handlebars.registerHelper('select', function(data, namespace, dataKey, options) {
  //   var options = arguments[arguments.length - 1],
  //     thisData = data;
  //   thisData = $.extend({}, data, options.hash);
  //
  //   var optionsList = thisData['options-list'] ||
  //     inputDefaults[dataKey] && inputDefaults[dataKey].options
  //     || [];
  //
  //   var label_text = typeof thisData['label-text'] !== 'undefined' ?
  //     thisData['label-text'] :
  //     inputDefaults[dataKey] ?
  //       inputDefaults[dataKey].label :
  //       '';
  //   if (thisData['no-label'] && thisData['no-label'] == true)
  //   {
  //     label_text = '';
  //   }
  //
  //   var extension = {
  //     namespace : namespace,
  //     ia : hbr_helpers.extractAttributes(options.hash),
  //     hasError : (typeof thisData.errTypes === 'object' && thisData.errTypes[namespace]) || thisData.error,
  //     options : optionsList,
  //     'label-text' : label_text
  //   };
  //
  //   hbr_helpers.commonAttributes(extension, options.hash);
  //
  //   if (!options['ia-data-wizard-owner']) {
  //     extension.ia.push({
  //       name : 'data-wizard-owner',
  //       value : namespace
  //     });
  //   }
  //   extension.namespace = thisData.id + '-' + extension.namespace;
  //   var indexForRoom = thisData.index || 0;
  //   switch (dataKey) {
  //     case 'childAges' :
  //       var childAgeErrorIndex = thisData.roomIndex + ':' + thisData.index;
  //       thisData.hasError = _.contains(dataModels.model.get('validation.fields'), childAgeErrorIndex);
  //       extension['label-text'] = thisData['label-text'];
  //       if (!extension.wizard_action)
  //         extension['wizard_action'] = '{"rooms[' + indexForRoom + '].children[' + thisData.index + ']" : $value1}';
  //       extension.namespace = thisData.id;
  //       thisData['label-class'] = 'child-number-' + thisData.childNumber;
  //       break;
  //     case 'flightChildren' :
  //     case 'hotelChildren' :
  //       var childErrorIndex = indexForRoom + 'c';
  //       thisData.hasError = _.contains(dataModels.model.get('validation.fields'), childErrorIndex);
  //       if (!extension.wizard_action)
  //         extension['wizard_action'] = '{"rooms[' + thisData.index + '].childCount" : $value1}';
  //       break;
  //     case 'hotelAdults' :
  //       var adultErrorIndex = indexForRoom + 'a';
  //       thisData.hasError = _.contains(dataModels.model.get('validation.fields'), adultErrorIndex);
  //       if (!extension.wizard_action) {
  //         extension['wizard_action'] = '{"rooms[' + thisData.index + '].adults" : $value1}';
  //         if (thisData.ownerId === 'package' || 'flight-hotel') {
  //           extension.options = inputDefaults[dataKey].options.slice(0, 6);
  //         }
  //       }
  //       if (dataModels.state.get('oneGuestSelected')) {
  //         extension.ia[0].value = 1;
  //         dataModels.state.unset('oneGuestSelected', {'silent' : true});
  //       }
  //       break;
  //
  //     case 'hotelGuests' :
  //       var guestErrorIndex = indexForRoom + 'g';
  //       thisData.hasError = _.contains(dataModels.model.get('validation.fields'), guestErrorIndex);
  //       if (!extension.wizard_action)
  //       {
  //         extension['wizard_action'] = '{"rooms[' + thisData.index + '].guests" : $value1}';
  //       }
  //       break;
  //
  //     case 'flightAdults' :
  //       var adultErrorIndex = '0a';
  //       thisData.hasError = _.contains(dataModels.model.get('validation.fields'), adultErrorIndex);
  //       break;
  //   }
  //
  //   if (!thisData.isHotelOnly && namespace === 'rooms') {
  //     extension.options = extension.options.slice(0,3);
  //   }
  //   $.extend(thisData, extension);
  //   return new Handlebars.SafeString(Handlebars.partials['corewizard/components/select-hbs'](thisData));
  // });


  Handlebars.registerHelper('soft-package', function(options) {
    return Handlebars.partials['corewizard/components/soft-package-checkbox-hbs'](options.hash);
  });

});

/*
 *  Project: UITKv2 Global Footer
 *  Description: Core wizard responsive JS logic
 *  Author: v-bnordwall@expedia.com
 */

// the semi-colon before function invocation is a safety net against concatenated
// scripts and/or other plugins which may not be closed properly.
require(['uitk'], function(uitk) {

    "use strict";

    var toggleCoreWizardTheme = function( topic, data ) {
      var wizardContainer = $('#wizard-theme-wrapper');

      if (data.key === 'wizard-not-desktop') {
        $(wizardContainer)
          .removeClass('theme-inverse-pills')
          .addClass('theme-pills');
      }

      if (data.key === 'wizard-min-desktop') {
        $(wizardContainer)
          .removeClass('theme-pills')
          .addClass('theme-inverse-pills');
      }
    }

    var collapseMobileFooterMenus = function( topic, data ) {
      var footerToggleMenus = $('#site-footer-wrap').find('.toggle-trigger');

      if ($.fn.uitk_toggle && data.key === 'wizard-not-desktop') {
        $(footerToggleMenus).uitk_toggle('close');
      }
    }

    uitk.subscribe('mediaquery.matched', toggleCoreWizardTheme, collapseMobileFooterMenus);
    uitk.mediaquery.publishAgain();

  });

define('gc/SearchUrl', function() {
    var SearchUrl = function(baseUrl, div, equ) {
        this.baseURL = baseUrl || '';
        this.div = div || '&';
        this.equ = equ || '=';
    };
    SearchUrl.prototype = [];
    SearchUrl.prototype.addParameter = function(name, value, required, def) {
        if (value) {
            this.push(name + this.equ + value);
        } else if (required) {
            var defaultValue = '';
            if (def || def === 0) {
                defaultValue = def;
            }
            this.push(name + this.equ + defaultValue);
        }
    };
    SearchUrl.prototype.toString = function() {
        var url = this.baseURL + this.join(this.div);
        return url.replace('?' + this.div, '?').replace(this.div + '#' + this.div, '#');
    };
    SearchUrl.prototype.beginQuery = function() {
        this.push('?');
    };
    SearchUrl.prototype.beginHash = function() {
        this.push('#');
    };

    return SearchUrl;
});

define('gc/activitySearchUrl', ['gc/SearchUrl'], function(SearchUrl) {
  return function(model) {
    var url;
    var prefilledDates = model.startDatePrefilled || model.endDatePrefilled;

    // Activities wants to use the /go url, see https://jira/jira/browse/MAIN-117523
    // http://www.expedia.com/go?type=lx&LocationName=Rome&StartDate=05/14/2014&EndDate=05/17/2014
    url = new SearchUrl('/things-to-do/');
    url.beginQuery();

    var location = model.destination;

    if (model.hotelId) {
        location = model.city;
    }

    url.addParameter('location', location, true);

    if (!prefilledDates && model.startDate && model.endDate) {
        url.addParameter('startDate', model.startDate, true);
        url.addParameter('endDate', model.endDate, true);
    }

    url.addParameter('_xpid', model._xpid);

    return url.toString();
  };
});

define('gc/carSearchUrl', ['gc/SearchUrl', 'gc/abTest'], function(SearchUrl, abTest) {
    return function (model) {
        var url;

        url = new SearchUrl('/carsearch');

        // abacus#10341 Cars_E3PrimeShoppingPage_GC
        // enabling E3 Prime based car shopping for non IE8 browsers
        if (abTest.get(10341, null, true).value === 1 && !$('html').hasClass('lt-ie9')) {
            url = new SearchUrl('/carsearch/app');
        }

        url.beginQuery();

        url.addParameter('dagv', 1, true);
        url.addParameter('subm', 1, true);
        url.addParameter('fdrp', 0, true);

        url.addParameter('styp', model.carSearchType, true, 4);

        url.addParameter('locn', model.pickup, true);
        url.addParameter('loc2', model.dropoff);

        url.addParameter('date1', model.startDate, true);
        url.addParameter('date2', model.endDate, true);

        url.addParameter('vend', model.carVendor, true);
        url.addParameter('kind', model.carType, true);

        url.addParameter('time1', model.startTime, true);
        url.addParameter('time2', model.endTime, true);

        url.addParameter('sesr', model.carSkirack === 'true' ? 1 : 0);
        url.addParameter('seis', model.carInfantseat === 'true' ? 1 : 0);
        url.addParameter('sets', model.carToddlerseat === 'true' ? 1 : 0);
        url.addParameter('sesc', model.carChains === 'true' ? 1 : 0);
        url.addParameter('selh', model.carLefthand === 'true' ? 1 : 0);
        url.addParameter('serh', model.carRighthand === 'true' ? 1 : 0);
        url.addParameter('sens', model.carNavigation === 'true' ? 1 : 0);

        url.addParameter('rtcd', model.carRateCode);
        url.addParameter('cpcd', model.carCouponCode);
        url.addParameter('odcd', model.carOtherCode);
        url.addParameter('cdnu', model.carCorpCode);

        url.addParameter('ttyp', 2, true);
        url.addParameter('acop', 2, true);
        url.addParameter('rdus', 10, true);
        url.addParameter('rdct', 1, true);

        url.addParameter('dpln', model.originRegionId);
        url.addParameter('drid1', model.destinationRegionId);
        url.addParameter('olat', model.originLatitude);
        url.addParameter('olon', model.originLongitude);
        url.addParameter('dlat', model.destinationLatitude);
        url.addParameter('dlon', model.destinationLongitude);

        //if car tab active, test enabled, custom age entered: Send age parameter
        if(model.tab === 'car' && abTest.get(11636).value===1 && model.isCarDriverAgeWithinLimit === false){
            url.addParameter('age', model.driverAge);
        }

        url.addParameter('_xpid', model._xpid);
        
        return url.toString();
    }
});

define('gc/cruiseSearchUrl', ['jquery', 'gc/SearchUrl', 'gc/cruiseSearchUrlOverride', 'gc/abTest'], function($, SearchUrl, cruiseSearchUrlOverride, abTest) {

    var cruiseSearchUrl = {
        searchUrlGenerator: function(model) {
            var url;

            url = new SearchUrl('/Cruise-Search');
            url.beginQuery();

            url.addParameter('destination', model.cruiseDestination);

            if (abTest.get(10120).value === 1) {
                url.addParameter('earliest-departure-date', cruiseSearchUrl.getFormattedDate(model.cruiseEarliestDepartureDate));
                url.addParameter('latest-departure-date', cruiseSearchUrl.getFormattedDate(model.cruiseLatestDepartureDate));
            } else if (model.cruiseMonth && model.cruiseMonth != "4501-1-1") {
                url.addParameter('earliest-departure-date', model.cruiseMonth);
            }

            url.addParameter('_xpid', model._xpid);

            return url.toString();
        },
        getFormattedDate: function (dateString) {
            var result = "";
            if (dateString) {
                var date = new Date(dateString),
                    curr_date = date.getUTCDate(),
                    curr_month = date.getUTCMonth() + 1,
                    curr_year = date.getUTCFullYear();
                result = curr_year + "-" + curr_month + "-" + curr_date;
            }
            return result;
        }
    };
    $.extend(true, cruiseSearchUrl, cruiseSearchUrlOverride);

    return cruiseSearchUrl.searchUrlGenerator;
});

define('gc/openSearchUrl', ['gc/SearchUrl','gc/abTest'], function(SearchUrl , abTest) {
    return function(model) {

        var urlTemplateConfig = {
            HOTEL:{
                urlTemplate:'/go/hotel/info/[id]'
            },
            GEO:{
                urlTemplate:'/d[id].Destination-Travel-Guides'
            },
            HOTELS:{
                urlTemplate:'/Hotel-Search?#&destination=[id]'
            },
            FLIGHTS:{
                urlTemplate:'/d[id].Travel-Guide-Flights'
            },
            PACKAGES:{
                urlTemplate:'/d[id].Destination-Travel-Guides'
            },
            CARS:{
                urlTemplate:'/d[id].Car-Rental-Guide'
            },
            ACTIVITIES:{
                urlTemplate:'/pubspec/scripts/eap.asp'
            },
            ALL:{
                urlTemplate:'/d[id].Destination-Travel-Guides'
            }
        };
        var regionTypesWithLandingPage = ['CITY', 'MULTICITY', 'NEIGHBORHOOD', 'POI', 'HOTEL'];

        //
        // Helper methods
        //
        function getUrlTemplate(category, id) {
            var template = urlTemplateConfig[category].urlTemplate;
            if (template != null && id != null) {
                return template.replace('[id]', id);
            }

            return template;
        }

        function getVariant() {
            return abTest.get(10406).value;
        }

        function getOpenSearchUrl(query) {
            var url = new SearchUrl('/Search-Results');
            url.beginQuery();
            url.addParameter('q', encodeURIComponent(query), true);
            url.addParameter('ref', 'aws-corewizard-' + getVariant());
            url.addParameter('_xpid', model._xpid);
            return url.toString();
        }

        function getHotelUrl(model) {
            var url = new SearchUrl(getUrlTemplate('HOTEL', model.openSearchQueryData.hotelId));
            url.beginQuery();
            url.addParameter('_xpid', model._xpid);
            return url.toString();
        }

        function getHotelSearchUrl(model) {
            var url = new SearchUrl(getUrlTemplate('HOTELS', model.openSearchQueryData.gaiaId));
            url.beginQuery();
            url.addParameter('_xpid', model._xpid);
            return url.toString();
        }

        function getActivitiesUrl(model) {
            var url = new SearchUrl(getUrlTemplate('ACTIVITIES'));
            url.beginQuery();
            url.addParameter('GOTO','TSHOPSSEARCH');
            url.addParameter('LocationID', model.openSearchQueryData.gaiaId);
            url.addParameter('_xpid', model._xpid);
            return url.toString();
        }

        function getTravelGuidesUrl(model, category) {
            var url = new SearchUrl(getUrlTemplate(category, model.openSearchQueryData.gaiaId));
            url.beginQuery();
            url.addParameter('_xpid', model._xpid);
            return url.toString();
        }

        //
        // Main code
        //
        var data = model.openSearchQueryData;
        if(model.selectedTASuggestionPosition && data && data.lob != 'GEMMA') {

            var category = data.regionType == 'HOTEL' ? data.regionType : data.lob;

            if(category == 'HOTEL') {
                return getHotelUrl(model);
            }
            else if(category == 'ACTIVITIES') {
                return getActivitiesUrl(model);
            }
            else if(category == 'HOTELS') {
                return getHotelSearchUrl(model);
            }
            else if(regionTypesWithLandingPage.indexOf(data.regionType) >= 0) {
                return getTravelGuidesUrl(model, category);
            }
            else {
                return getOpenSearchUrl(data.regionNames.displayName);
            }
        }
        else if(model.searchQuery) {
            return getOpenSearchUrl(model.searchQuery);
        }
};

});

define('gc/flightSearchUrl', ['gc/SearchUrl'], function(SearchUrl) {
    return function(model) {
        // Helper functions
        function getLegUrl(leg) {
            var legUrl = new SearchUrl('', ',', ':');
            legUrl.addParameter('from', leg.origin, true);
            legUrl.addParameter('to', leg.destination, true);
            legUrl.addParameter('departure', leg.start + 'TANYT', true);
            return legUrl.toString();
        }

        function getPassengers(model) {
            var passUrl = new SearchUrl('', ',', ':');
            passUrl.addParameter('children', getChildren(model.ages), true, 0);
            passUrl.addParameter('adults', model.adults, true, 0);
            passUrl.addParameter('seniors', "0", true, 0);
            passUrl.addParameter('infantinlap', (model.isChildInLap ? 'Y' : 'N'), true, 'Y');
            return passUrl.toString();
        }

        function getChildren(children) {
            if (children && children.length) {
                var s = "";
                var i = 0;
                s += children.length + '[';
                for (i = 0; i < children.length; i ++) {
                    s += children[i].age || children[i];
                    if (i !== children.length - 1) {
                        s += ";";
                    }
                }
                s += ']';
                return s;
            }
        }

        var url = new SearchUrl('/Flights-Search');
        url.beginQuery();

        url.addParameter('trip', model.flighttype, true, 'roundtrip');
        url.addParameter('leg1', getLegUrl({origin:model.originTLA || model.origin, destination:model.destinationTLA || model.destination, start:model.startDate}), true);

        if (model.isRoundtrip) {
            url.addParameter('leg2', getLegUrl({origin:model.destinationTLA|| model.destination, destination:model.originTLA || model.origin, start:model.endDate}), true);
        }
        else if (model.isMultiDest) {
            for (var i = 0; i < 4; i++) {
                var leg;
                if (!model.multiDest.destination[i]) {
                    break;
                }
                leg = {
                    origin :      model.multiDest.origin[i],
                    destination : model.multiDest.destination[i],
                    start :       model.multiDest.startDate[i]
                };

                url.addParameter('leg' + (i + 2), getLegUrl(leg), true);

            }
        }

        url.addParameter('passengers', getPassengers(model), true, 0);

        addAdditionalOptions(model, url);

        url.addParameter('mode', 'search');

        url.addParameter('_xpid', model._xpid);

        return url.toString();

        function addAdditionalOptions(model, url) {
            'use strict';
            //cabinclass:business,maxhops:0,nopenalty:Y,carrier:AS
            var additionalOptions = new SearchUrl('', ',', ':');
            additionalOptions.addParameter('cabinclass', model.cabinClass, false);

            if (model.nonStop) {
                additionalOptions.addParameter('maxhops', "0", true);
            }

            if (model.noPenalty) {
                additionalOptions.addParameter('nopenalty', "Y", true);
            }

            additionalOptions.addParameter('carrier', model.carrier, false);

            url.addParameter('options', encodeURIComponent(additionalOptions.toString()), false);
        }
    }

});

define('gc/hotelInfoSiteUrl', ['gc/SearchUrl'], function(SearchUrl) {
    return function(model) {
        var url;
        url = new SearchUrl('/h' + model.hotelId + '.Hotel-Information');
        url.beginQuery();

        if (!model.isDateless) {
            url.addParameter('chkin', model.startDate, true);
            url.addParameter('chkout', model.endDate, true);
        }

        for(var i = 0; i < model.rooms.length; i++) {
            var room = model.rooms[i];
            var travlers = [];
            travlers.push('a' + (room && room.adults ? room.adults : 2));
            var childCount = (room && room.children ? room.children.length : 0);
        for (var j = 0; j < childCount; j++) {
            travlers.push('c' + room.children[j]);
        }
        var roomnum = i+1;
            url.addParameter('rm' + roomnum, travlers.join(':'));
        }

        url.addParameter('_xpid', model._xpid);

        return url.toString();
    };
});

define('gc/hotelSearchUrl', [
    'gc/SearchUrl',
    'gc/searchExperiments',
    'env'
], function(
    SearchUrl,
    searchExperiments,
    env
) {

    function addAdultsAndChildrenParams(model, url){
        var adults = [];
        var children = [];
        for (var i = 0; i < model.rooms.length; i ++) {
            var room = model.rooms[i];
            adults[i] = (room && room.adults ? room.adults : 2);
            var childCount = (room && room.children ? room.children.length : 0);
            for (var j = 0; j < childCount; j++) {
                children.push((i + 1) + '_' + room.children[j]);
            }
        }
        url.addParameter('adults', adults.join(','));
        url.addParameter('children', children.join(','));
    }

    function handlePOIIdsAndGaiaIds(model,url){

        //if TA suggestion type is POI send latLong to hotel search
        if(model.TASearchType == "POI")
        {
            url.addParameter('latLong',model.latLong, true);
        }
        else if(model.isHotelOnly && model.TASearchType == "POSTALCODE")
        {
            url.addParameter('latLong',model.latLong, true);
        }
        else
        {
            handleGaiaIds(model,url);
        }
    }

    function handleGaiaIds(model,url){
        var regionORGaiaId = parseInt(model.regionId);

        //if the gaiaid is greater than 32 bit maxint, do not add regionId parameter to url, instead add latLong

        if(regionORGaiaId <= 4294967295){
            url.addParameter('regionId', model.regionId, true);
        }
        else{
            url.addParameter('latLong',model.latLong, true);
        }
    }

    return function (model) {
      if (searchExperiments.getVariant("HIGH_LEVEL_REGION") === 2 &&
          model.regionId &&
          model.TASearchType == "MULTIREGION") {
          var trvGudUrlStr = '/d'+model.regionId+'.Travel-Guide-Hotels';
          var redirectUrl = new corewizard.search.SearchUrl(trvGudUrlStr);
          return redirectUrl.toString();
      }

      if (model.isHotelOnly && model.isNinePlusRoomRequest) {
          var STANDARD_DATE_FORMAT = "M/dd/yyyy";
          var ninePlusRoomsUrl = "https://" + window.location.host.replace('www', 'groups') + "/GroupForm.cfm?";
          ninePlusRoomsUrl += "ESite=" + env.siteId;
          ninePlusRoomsUrl += "&Loc=" + env.locale;
          ninePlusRoomsUrl += "&City=" + encodeURIComponent(model.destination);

          if (model.startDate) {
              if (uitk.utils.createLocalizedDate) {
                  var start = uitk.utils.createLocalizedDate(model.startDate, env.locale);
                  if (start && start.settings && start.settings.date && start.settings.date.format && (start.date != "Invalid Date")) {
                      var localeDateFormat = start.settings.date.format["short"];
                      start.settings.date.format["short"] = STANDARD_DATE_FORMAT;
                      ninePlusRoomsUrl += "&InDate=" + start.shortDate();
                      start.settings.date.format["short"] = localeDateFormat;
                  }
              }
              else {
                  ninePlusRoomsUrl += "&InDate=" + model.startDate;
              }
          }

          if (model.endDate) {
              if (uitk.utils.createLocalizedDate) {
                  var end = uitk.utils.createLocalizedDate(model.endDate, env.locale);
                  if (end && end.settings && end.settings.date && end.settings.date.format && (end.date != "Invalid Date")) {
                      localeDateFormat = end.settings.date.format["short"];
                      end.settings.date.format["short"] = STANDARD_DATE_FORMAT;
                      ninePlusRoomsUrl += "&OutDate=" + end.shortDate();
                      end.settings.date.format["short"] = localeDateFormat;
                  }
              }
              else {
                  ninePlusRoomsUrl += "&OutDate=" + model.endDate;
              }
          }

          return ninePlusRoomsUrl;
      }

      var url = new SearchUrl('/Hotel-Search'),
          sort = model.sort;

      url.beginQuery();
      if (!model.isHashlessURLneeded) url.beginHash();

      if (model.latLong && model.latLong.indexOf("undefined") < 0 && model.trainOrMetroStationDestination) {
          url.addParameter('destination', model.trainOrMetroStationDestination, true);
      } else {
          if (model.hotelId) {
              url.addParameter('destination', model.city, true);
          }else{
              url.addParameter('destination', model.destination, true);
          }
      }

      if (!model.isDateless) {
          url.addParameter('startDate', model.startDate, true);
          url.addParameter('endDate', model.endDate, true);
      }

      url.addParameter('group', model.group);

      if(searchExperiments.getVariant("ALWAYS_SEND_GAIA_ID_AND_LAT_LONG"))
      {
          // Workaround for the bug https://jira/jira/browse/ECOMSVC-1545
          // Currently (December 2015), hotel search results page do not support any such region ID as an URL parameter
          // that is introduced with experiment 8812. Such a region ID is yet to be integrated into GAIA. As a workaround,
          // the region ID is excluded from the URL.
          // For details on experiment 8812, see the following Mingle card:
          // https://eiwork.mingle.thoughtworks.com/projects/ewe_discovery_services/cards/1518
          // Experiment 8812 has been cleaned up, this condition remains to check for other type of non-GAIA city types.
          if (! _.contains(Typeahead.unintegratedCityTypes, model.TASearchType)) {
              // Checking model.regionId !== "0" is a workaround for the bug https://jira/jira/browse/ECOMSVC-1488, filed on
              // 2015-10-21. Ideally, when there is no GAIA ID for a certain location, model.regionId, which is from ESS,
              // should be undefined, not an invalid value in the correct format.
              url.addParameter('regionId', model.regionId && model.regionId !== "0" ? model.regionId : "", true);
          }
          url.addParameter('latLong', model.latLong ? model.latLong : "");
      }
      else {
          handlePOIIdsAndGaiaIds(model, url);
      }

      addAdultsAndChildrenParams(model, url);

      // if (model.SOME_EXTRA_MODEL_VALUE_FOR_USE_ON_THE_URL_GENERATOR) {
      //     url.addParameter('bar', model.SOME_EXTRA_MODEL_VALUE_FOR_USE_ON_THE_URL_GENERATOR);
      // }

      if (model.hotelId) {
          url.addParameter('selected', model.hotelId);
      }
      if (searchExperiments.getVariant("BEST_DEALS_OPTION") &&
          typeof model.sort === "string")
      {
          url.addParameter('sort', sort);
      }

      if (model.membersOnly) {
          url.addParameter('mctc', model.membersOnly);
      }
      if(model.packageRates){
          url.addParameter('packageRates',model.packageRates);
      }

      url.addParameter('_xpid', model._xpid);

      return url.toString();
  }

});

define('gc/vacationRentalSearchUrl', [
    'gc/SearchUrl',
    'gc/searchExperiments',
    'env'
], function(
    SearchUrl,
    searchExperiments,
    env
) {

  function addAdultsAndChildrenParams(model, url){
      var adults = [];
      var children = [];
      for (var i = 0; i < model.rooms.length; i ++) {
          var room = model.rooms[i];
          adults[i] = (room && room.adults ? room.adults : 2);
          var childCount = (room && room.children ? room.children.length : 0);
          for (var j = 0; j < childCount; j++) {
              children.push((i + 1) + '_' + room.children[j]);
          }
      }
      url.addParameter('adults', adults.join(','));
      url.addParameter('children', children.join(','));
  }

    function handlePOIIdsAndGaiaIds(model,url){

        //if TA suggestion type is POI send latLong to hotel search
        if(model.TASearchType == "POI")
        {
            url.addParameter('latLong',model.latLong, true);
        }
        else if(model.isHotelOnly && model.TASearchType == "POSTALCODE")
        {
            url.addParameter('latLong',model.latLong, true);
        }
        else
        {
            handleGaiaIds(model,url);
        }
    }

    function handleGaiaIds(model,url){
        var regionORGaiaId = parseInt(model.regionId);

        //if the gaiaid is greater than 32 bit maxint, do not add regionId parameter to url, instead add latLong

        if(regionORGaiaId <= 4294967295){
            url.addParameter('regionId', model.regionId, true);
        }
        else{
            url.addParameter('latLong',model.latLong, true);
        }
    }

    function getBrand(siteId){
      var brand = 'Expedia';
      siteId = parseInt(siteId);
      var brands = {
        Hotels        : [1170],
        Wotif         : [70125,70129,70152],
        Travelocity   : [80001, 80004],
        Orbitz        : [70201,70203,70205,70206,70221,70222,70223,70224,70225,
                        702010001,702010002,702010003,702010004,702010005,702010006],
        Venere        : [],
        AARP          : [],
        Hotwire       : [30031,30044],
        Egencia       : [],
        HotelClub     : [],
        CheapTickets  : [70301,703010001,703010003,703010004,703010005],
        LastMinute    : [70150,70151],
        Trivago       : [],
        Travelnow     : [],
        Ebookers      : [70403,70406,70420,70463,70472,70473],
        TAAP          : [],
        Mrjet         : [70465]
      }
      _.mapObject(brands, function(siteIdList, brandName) {
        if(_.contains(siteIdList, siteId)) return brand = brandName;
      });
      return brand;
    }

    return function (model) {
      if (searchExperiments.getVariant("HIGH_LEVEL_REGION") === 2 &&
          model.regionId &&
          model.TASearchType == "MULTIREGION") {
          var trvGudUrlStr = '/d'+model.regionId+'.Travel-Guide-VacationRentals';
          var redirectUrl = new corewizard.search.SearchUrl(trvGudUrlStr);
          return redirectUrl.toString();
      }


      var url = new SearchUrl('/Hotel-Search'),
          sort = model.sort;

      url.beginQuery();
      if (!model.isHashlessURLneeded) url.beginHash();

      if (model.latLong && model.latLong.indexOf("undefined") < 0 && model.trainOrMetroStationDestination) {
          url.addParameter('destination', model.trainOrMetroStationDestination, true);
      } else {
          if (model.hotelId) {
              url.addParameter('destination', model.city, true);
          }else{
              url.addParameter('destination', model.destination, true);
          }
      }

      if (!model.isDateless) {
          url.addParameter('startDate', model.startDate, true);
          url.addParameter('endDate', model.endDate, true);
      }

      url.addParameter('group', model.group);

      if(searchExperiments.getVariant("ALWAYS_SEND_GAIA_ID_AND_LAT_LONG"))
      {
          // Workaround for the bug https://jira/jira/browse/ECOMSVC-1545
          // Currently (December 2015), hotel search results page do not support any such region ID as an URL parameter
          // that is introduced with experiment 8812. Such a region ID is yet to be integrated into GAIA. As a workaround,
          // the region ID is excluded from the URL.
          // For details on experiment 8812, see the following Mingle card:
          // https://eiwork.mingle.thoughtworks.com/projects/ewe_discovery_services/cards/1518
          // Experiment 8812 has been cleaned up, this condition remains to check for other type of non-GAIA city types.
          if (! _.contains(Typeahead.unintegratedCityTypes, model.TASearchType)) {
              // Checking model.regionId !== "0" is a workaround for the bug https://jira/jira/browse/ECOMSVC-1488, filed on
              // 2015-10-21. Ideally, when there is no GAIA ID for a certain location, model.regionId, which is from ESS,
              // should be undefined, not an invalid value in the correct format.
              url.addParameter('regionId', model.regionId && model.regionId !== "0" ? model.regionId : "", true);
          }
          url.addParameter('latLong', model.latLong ? model.latLong : "");
      }
      else {
          handlePOIIdsAndGaiaIds(model, url);
      }

      addAdultsAndChildrenParams(model, url);


      // if (model.SOME_EXTRA_MODEL_VALUE_FOR_USE_ON_THE_URL_GENERATOR) {
      //     url.addParameter('bar', model.SOME_EXTRA_MODEL_VALUE_FOR_USE_ON_THE_URL_GENERATOR);
      // }

      if (model.hotelId) {
          url.addParameter('selected', model.hotelId);
      }
      if (searchExperiments.getVariant("BEST_DEALS_OPTION") &&
          typeof model.sort === "string")
      {
          url.addParameter('sort', sort);
      }

      if (model.membersOnly) {
          url.addParameter('mctc', model.membersOnly);
      }

      var vrTypes = 'apartment,condo,villa,vacationHome,residence,townhouse,cabin,chalet,cottage,servicedApartment,traditionalBuilding,'+
                    'agritourism,caravanPark,castle,countryHouse,houseBoat,longHouse,overWater,palace,pension,ranch,safari,treeHouse';
      url.addParameter('lodging', vrTypes);

      url.addParameter('_xpid', model._xpid);

      return url.toString();
  }

});

define('gc/packageInfoSiteUrl', ['gc/SearchUrl'], function(SearchUrl) {
  return function(model) {
    var url;

          url = new SearchUrl('/h' + model.hotelId + '.Hotel-Information');
          url.beginQuery();


  url.addParameter('packageType', 2);

  url.addParameter('origin', model.origin, true);
  url.addParameter('destination', model.destinationTLA, true);

  url.addParameter('fromDate', encodeURIComponent(model.startDate), true);
  url.addParameter('toDate', encodeURIComponent(model.endDate), true);

  var rooms = model.rooms.length;
  url.addParameter('numberOfRooms', rooms > 3 ? 3 : rooms, true);
  for(var i = 1; i <= rooms && i <= 3; i++) {
      var room = model.rooms[i-1];
      url.addParameter('adultsPerRoom['+i+']', (room && room.adults ? room.adults : 2));
      var childCount = (room && room.children ? room.children.length : 0);
      url.addParameter('childrenPerRoom['+i+']', childCount);
      for (var j = 1; j <= childCount; j++) {
          url.addParameter('childAges['+i+']['+j+']', room.children[j-1]);
      }
  }

  url.addParameter('_xpid', model._xpid);

  return url.toString();
};

});

/*
 *  Documentation for eap.asp package search found here:
 *  https://confluence/display/SEMPPC/Deeplink+Resource+Guide#DeeplinkResourceGuide-PackageSearch
*/

define('gc/eapAspSearchUrl', ['gc/SearchUrl', 'gc/abTest', 'underscore'], function(SearchUrl, abTest, _) {
    return function (model,lob) {
        // convert from url formatted time (HHMMaa) to minutes-from-midnight
// @param timeString time string in "HHmmAA" or "HHmm" format, note the lack of colon
// In case of error return default time
        var convertUrlTime = function(timeString)
        {
            var hours, minutes, phase;
            var rawString = timeString;

            // check for single-digit hours and pad out
            if (rawString.length == 3 || rawString.length == 5)
                rawString = '0' + rawString;

            // try to parse into parts
            switch(rawString.length)
            {
                case 4:
                    hours = parseInt(rawString.substring(0, 2), 10);
                    minutes = parseInt(rawString.substring(2, 4), 10);
                    break;
                case 6:
                    hours = parseInt(rawString.substring(0, 2), 10);
                    minutes = parseInt(rawString.substring(2, 4), 10);
                    phase = rawString.substring(4, 6).toUpperCase();
                    if (phase != "AM" && phase != "PM")
                        return '630';
                    break;
                default:
                    return '630';
            }

            // check hours and minutes for correct integer parse
            if (isNaN(hours) || isNaN(minutes))
                return '630';

            // adjust hours for phase (if there is one)
            if (hours == 12 && phase == "AM")
                hours = 0;
            if (hours != 12 && phase == "PM")
                hours += 12;

            // check to make sure values are within bounds
            if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59)
                return '630';

            var date = new Date(0);
            date.setHours(hours);
            date.setMinutes(minutes);

            return (date.getHours() * 60) + date.getMinutes();
        }

        var url = new SearchUrl('/pubspec/scripts/eap.asp'),
            i,
            roomNum,
            j,
            childNum;

        url.beginQuery();

        if (model.isPackage) {
//        if (model.hotelId) {
//            return corewizard.search.packageInfoSiteUrl(model);
//        }
            url.addParameter('GOTO', 'PACKAGEWIZ');
            if (model.packageType === "FHC") {
                url.addParameter('PackageType', '1');
            }
            else if (model.packageType === "FH" || (model.packageType === "TH")) {
                url.addParameter('PackageType', '2');
            }
            else if (model.packageType === "HC") {
                url.addParameter('PackageType', '3');

                // temporary hack for MAIN-113987: hard-coding times into search params to prevent rental car search from failing
                if(model.tab == "car") {
                    url.addParameter('FromTime', convertUrlTime(model.startTime));
                    url.addParameter('ToTime', convertUrlTime(model.endTime));
                } else {
                    url.addParameter('FromTime', '630');
                    url.addParameter('ToTime', '630');
                }

            }
            else if (model.packageType === "FC") {
                url.addParameter('PackageType', '5');
            }
        }


        if (lob === 'flight') {
            //this is supposed to be deprecated by March 2014
            url.addParameter('GOTO', 'EXPFLTWIZ');

            //url.addParameter('TripType', model.flighttype || 'RoundTrip');
            switch (model.flighttype) {
                case 'multi' :
                    url.addParameter('TripType', 'Multicity');
                    url.addParameter('FrAirport1', model.origin);
                    url.addParameter('ToAirport1', model.destination);
                    url.addParameter('Date1', model.startDate);
                    url.addParameter('Time1', model.startTime);
                    for (var i = 0; i < model.multidest.length; i++) {
                        url.addParameter('FrAirport' + (i + 2), model.multidest[i].origin);
                        url.addParameter('ToAirport' + (i + 2), model.multidest[i].destination);
                        url.addParameter('Date' + (i + 2), model.multidest[i].departing);
                        url.addParameter('Time' + (i + 2), model.multidest[i]['time' + (i + 2)]);
                    };
                    break;
                case 'roundtrip' :
                case 'oneway' :
                    (model.flighttype === 'roundtrip') ? url.addParameter('TripType', 'roundtrip') : url.addParameter('TripType', 'oneway');
                    url.addParameter('ToAirport', model.destinationTLA);
                    url.addParameter('FromDate', model.startDate);
                    url.addParameter('ToDate', model.endDate);
                    url.addParameter('FrAirport', model.originTLA);
                    break;
            }

            url.addParameter('NumAdult', model.adults);
            url.addParameter('NumSenior', model.numSeniors);
            url.addParameter('NumChild', model.children);
            url.addParameter('InfantInSeat', model.lapSeat === "lap" ? 0 : 1);
            url.addParameter('NoChangePen', model.noPenalty ? 1 : 0);
            url.addParameter('Direct', model.nonStop ? 1 : 0);
            url.addParameter('Airline', model.carrier);
            url.addParameter('Class', model.cabinClassLegacy);

            for (var i = 0; i < model.ages.length; i++) {
                url.addParameter('Age' + (i + 1), model.ages[i]);
            };

            return url.toString();
        }

        if (lob === "hotel") {
            //this is supposed to be deprecated by March 2014
            url.addParameter('GOTO', 'HOTSEARCH');
            url.addParameter('CityName', model.destination);
            url.addParameter('InDate', model.startDate);
            url.addParameter('OutDate', model.endDate);
            url.addParameter('Class', model.star);
            url.addParameter('ChainName', model.hotelName);
            url.addParameter('LodgingType', model.lodging);
            url.addParameter('NumRoom', model.rooms.length);
            var adults = [];
            var children = [];

            for (var i = 0; i < model.rooms.length; i ++) {
                var room = model.rooms[i];
                url.addParameter('NumAdult' + (i + 1 === 1 ? '' : (i + 1)), room.adults);
                adults[i] = (room && room.adults ? room.adults : 2);
                var childCount = (room && room.children ? room.children.length : 0);
                for (var j = 0; j < childCount; j++) {
                    url.addParameter((i + 1 === 1 ? '' : 'Rm' + (i + 1)) + 'Child' + (j + 1) + 'Age', '' + room.children[j]);
                }
            }
            //corewizard.search.hotelSearchUrl.addAdultsAndChildrenParams(model, url);
            return url.toString();
        }

        if (model.originTLA) {
            url.addParameter('FrAirport', model.originTLA, true, '');
        } else {
            url.addParameter('FrAirport', model.origin, true, '');
        }
        if (!(model.isPackage && model.hotelId)) {
            url.addParameter('DestName', model.destination, true, '');

        }
        if (model.hotelId) {
            url.addParameter('DestID', model.multiCityRegion + ':' + model.destinationTLA);
        } else {
            url.addParameter('DestID', model.destID);
        }

        url.addParameter('FromDate', model.startDate);
        if (model.packageType === "TH") {
            url.addParameter('FromTime', model.train.departTime);
        }
        url.addParameter('ToDate', model.endDate);
        if (model.packageType === "TH") {
            url.addParameter('ToTime', model.train.returnTime);
        }
        if (model.isPartialStay) {
            url.addParameter('FlexFromDate', model.checkin);
            url.addParameter('FlexToDate', model.checkout);
        }

        if (model.rooms) {
            url.addParameter('NumRoom', model.roomCount);
            for (i = 0; i < model.rooms.length; i ++) {
                roomNum = i + 1;
                var adults = (model.rooms[i] && model.rooms[i].adults && (model.rooms[i].adults>=0)) ? model.rooms[i].adults : 2;
                var children = (model.rooms[i] && model.rooms[i].childCount ? model.rooms[i].childCount : '0');
                url.addParameter('NumAdult' + roomNum, adults, true, '2');
                url.addParameter('NumChild' + roomNum, children, true, '0');
                for (j = 0; j < children; j ++) {
                    childNum = j + 1;
                    url.addParameter('Rm' + roomNum + 'Child' + childNum + 'Age', model.rooms[i].children[j], true, '0');
                }
            }
        }
        url.addParameter('NumSenior', model.numSeniors);
        url.addParameter('InfantInSeat', model.isChildInLap ? "0" : "1");
        if (model.packageType === "TH") {
            url.addParameter('TransportationSearchType', 'TRAIN');
        }
        url.addParameter('needUTF8Decode', 'true');
        // url.addParameter('lang', model.lang, true, '1033'); // set default lang is 1033. Each POS should configure it with its language.
        // lang should be handled already and shouldn't need to be explicitly set.

        var cabinClass = model.cabinClassLegacy || model.cabinClass;
        if(cabinClass) {
            url.addParameter('cabinClass', cabinClass[0]);
        }

        url.addParameter('Direct', model.isDirectFlight ? "1" : "0");

        //if package tab includes car rental is active, test enabled, custom age entered: Send age parameter
        if(_.contains(['flightHotelCar', 'flightCar', 'hotelCar'], lob ) && abTest.get(11877).value===1 && model.isCarDriverAgeWithinLimit === false){
            url.addParameter('DriverAge', model.driverAge);
        }

        url.addParameter('_xpid', model._xpid);

        return url.toString();
    }
});

define('gc/search',[
    'gc/flightSearchUrl',
    'gc/activitySearchUrl',
    'gc/cruiseSearchUrl',
    'gc/openSearchUrl',
    'gc/carSearchUrl',
    'gc/hotelInfoSiteUrl',
    'gc/hotelSearchUrl',
    'gc/packageInfoSiteUrl',
    'gc/eapAspSearchUrl',
    'gc/threePPSearchUrl',
    'gc/vacationRentalSearchUrl',
    'gc/railSearchUrl'
],function(
    flightSearchUrl,
    activitySearchUrl,
    cruiseSearchUrl,
    openSearchUrl,
    carSearchUrl,
    hotelInfoSiteUrl,
    hotelSearchUrl,
    packageInfoSiteUrl,
    eapAspSearchUrl,
    threePPSearchUrl,
    vacationRentalSearchUrl,
    railSearchUrl
){
    return {
      addSearchType : function(id, searchFunction) {
        this[id] = searchFunction;
      },
      flightSearchUrl: flightSearchUrl,
      activitySearchUrl: activitySearchUrl,
      cruiseSearchUrl: cruiseSearchUrl,
      openSearchUrl: openSearchUrl,
      carSearchUrl: carSearchUrl,
      hotelInfoSiteUrl: hotelInfoSiteUrl,
      hotelSearchUrl: hotelSearchUrl,
      packageInfoSiteUrl: packageInfoSiteUrl,
      eapAspSearchUrl: eapAspSearchUrl,
      threePPSearchUrl: threePPSearchUrl,
      vacationRentalSearchUrl: vacationRentalSearchUrl,
      railSearchUrl: railSearchUrl
    }
});

define('gc/threePPSearchUrl', ['jquery', 'gc/SearchUrl', 'gc/threePPSearchUrlOverride'], function($, SearchUrl, threePPSearchUrlOverride) {
    var threePPSearchUrl = {
        searchUrlGenerator: function(model) {
        }
    };

    $.extend(true, threePPSearchUrl, threePPSearchUrlOverride);

    return threePPSearchUrl.searchUrlGenerator;
});
define('gc/railSearchUrl', ['jquery', 'gc/SearchUrl'], function($, SearchUrl) {

    return function(model) {
        var url = new SearchUrl('/rails/search');

        url.beginQuery(); // add the ?

        //Do Lookups if needed on these
        url.addParameter("journeyType", model.rail.type, true);
        if(model.originTLA) url.addParameter("orig", encodeURIComponent(model.originTLA), true);
        url.addParameter("originName", encodeURIComponent(model.trainOrigin), true);
        if(model.destinationTLA) url.addParameter("dest", encodeURIComponent(model.destinationTLA), true);
        url.addParameter("destinationName", encodeURIComponent(model.trainDestination), true);
        url.addParameter("sDate", encodeURIComponent(model.startDate), true);
        url.addParameter("sTime", model.rail.departureTime);
        url.addParameter("SearchBy", model.rail.departingSearchBy);

        var nbPax = {
            adults: 1,
            children: 0,
            youths: 0,
            seniors: 0
        };
        var ages = {
            adults: 40,
            children: [],
            youths: [],
            seniors: []
        };

        for (var i = 0; i < model.rooms.length; i ++) {
            var room = model.rooms[i];

            nbPax.adults = room && room.adults ? room.adults : 1;
            nbPax.children = room && room.childCount ? room.childCount : 0;
            nbPax.youths = room && room.youthCount ? room.youthCount : 0;
            nbPax.seniors = room && room.seniors ? room.seniors : 0;

            ages.children = room && room.children ? room.children : [];
            ages.youths = room && room.youths ? room.youths : [];
            ages.seniors = room && room.seniors ? room.seniors : [];


            if (nbPax && ages) {
                var age_pax = [];
                Object.keys(nbPax).forEach(function (paxType) {
                    var nb = parseInt(nbPax[paxType]);
                    var age = ages[paxType];
                    if ($.isArray(age)) {
                      age_pax = age_pax.concat(age);
                    } else if ($.isPlainObject(age)) {
                      age = $.map(age, function (value) {
                        return [value];
                      });
                      age_pax = age_pax.concat(age);
                    } else if ($.isNumeric(age)) {
                        var ageArray = Array(nb);
                        for(i = 0 ; i < ageArray.length ; i++){
                            ageArray[i] = age;
                        }
                        age_pax = age_pax.concat(ageArray);
                    }
                });
            }
        }

        url.addParameter("age_pax", encodeURIComponent(age_pax.toString()), true);

        if(!model.isOneWay) {
            url.addParameter("eDate", encodeURIComponent(model.endDate));
            url.addParameter("eTime", model.rail.returningTime);
            url.addParameter("retSearchBy", model.rail.returningSearchBy);
        }

        // Cycle through rail cards formatted in an array as [[type, number],[type, number],...]
        var cards = model.rail.cards;
        if(cards) {
            var railCards = [];
            cards.forEach(function(railCard) {
                if (railCard.type !== 0 && railCard.count > 0) {
                    var nbRailCards = parseInt(railCard.count);
                    var cardArray = Array(nbRailCards);
                    for(i = 0 ; i < cardArray.length ; i++){
                        cardArray[i] = railCard.type;
                    }
                    railCards = railCards.concat(cardArray);
                }
            });
            url.addParameter("rail_card", encodeURIComponent(railCards.toString()));
        }

        url.addParameter('_xpid', model._xpid);

        return url.toString();
    };
});


define('gc/TypeaheadMetricsLogger', ['gc/dataModels', 'gc/searchExperiments', 'gc/TypeaheadUtils'], function(dataModels, searchExperiments, TypeaheadUtils) {

var TypeaheadMetricsLogger = function(name, locale, guid) {
    "use strict";
    function getLineOfBusiness() {
        var lob = "-";
        try {
            if (_.isObject(dataModels))
            {
                lob = dataModels.model.get('tab');//@vmohapatra TODO :getLobType
            }
        }
        catch (e) {
            // Do nothing.
        }
        return lob;
    }

    this.name = name;
    this.timestamps = {};
    this.selections = [];
    this.focuses = [];
    this.submission = undefined;
    this.guid = guid || TypeaheadUtils.getGuid();
    this.suggestionEngagement = new TypeaheadMetricsLogger.SuggestionEngagementMetric(name, getLineOfBusiness());
}

TypeaheadMetricsLogger.prototype.TimestampCategories = {
    FOCUS: "FOCUS",
    ESS_REQUEST: "ESS_REQUEST",
    ESS_RESPONSE: "ESS_RESPONSE",
    KEY_UP: "KEY_UP",
    RENDER: "RENDER"
};

TypeaheadMetricsLogger.prototype.MetricCategory = function(name, beginTimestampCategory, endTimestampCategory) {
    "use strict";
    this.name = name;
    this.beginTimestampCategory = beginTimestampCategory;
    this.endTimestampCategory = endTimestampCategory;
};

TypeaheadMetricsLogger.prototype.SelectionMetric = function(index, text, guid, optionalTimestampValue) {
    "use strict";
    this.index = index;
    this.text = text;
    this.length = text.length;
    this.pointOfSale = TypeaheadUtils.getPointOfSale(),
    this.guid = guid;
    this.type = "selection";
    this.timestamp = optionalTimestampValue || new Date().getTime();
};

TypeaheadMetricsLogger.prototype.SubmissionMetric = function(text, guid, isValid, optionalTimestampValue) {
    "use strict";
    this.text = text;
    this.length = text.length;
    this.pointOfSale = TypeaheadUtils.getPointOfSale();
    this.guid = guid;
    this.type = isValid ? "validSearchSubmission" : "invalidSearchSubmission";
    this.timestamp = optionalTimestampValue || new Date().getTime();
}

TypeaheadMetricsLogger.prototype.FocusMetric = function(guid, optionalTimestampValue) {
    "use strict";
    this.pointOfSale = TypeaheadUtils.getPointOfSale();
    this.guid = guid;
    this.type = "focus";
    this.timestamp = optionalTimestampValue || new Date().getTime();
};

TypeaheadMetricsLogger.prototype.MetricCategories = {
    KeyUpToEssRequest: new TypeaheadMetricsLogger.prototype.MetricCategory(
        "KeyUpToEssRequest",
        TypeaheadMetricsLogger.prototype.TimestampCategories.KEY_UP,
        TypeaheadMetricsLogger.prototype.TimestampCategories.ESS_REQUEST),
    EssRequestToResponse: new TypeaheadMetricsLogger.prototype.MetricCategory(
        "EssRequestToResponse",
        TypeaheadMetricsLogger.prototype.TimestampCategories.ESS_REQUEST,
        TypeaheadMetricsLogger.prototype.TimestampCategories.ESS_RESPONSE),
    EssResponseToRender: new TypeaheadMetricsLogger.prototype.MetricCategory(
        "EssResponseToRender",
        TypeaheadMetricsLogger.prototype.TimestampCategories.ESS_RESPONSE,
        TypeaheadMetricsLogger.prototype.TimestampCategories.RENDER),
    KeyUpToRenderNotCallingEss: new TypeaheadMetricsLogger.prototype.MetricCategory(
        "KeyUpToRenderNotCallingEss",
        TypeaheadMetricsLogger.prototype.TimestampCategories.KEY_UP,
        TypeaheadMetricsLogger.prototype.TimestampCategories.RENDER)
};

TypeaheadMetricsLogger.SuggestionEngagementMetric = function(elementId, lineOfBusiness) {
    _.extend(this, TypeaheadUtils.createTypeaheadMetricsLogEntryCore(elementId, lineOfBusiness, undefined, undefined, undefined));
    _.extend(this, {
        type: "SuggestionEngagement",
        suggestionShown: false,
        suggestionSelected: false,
        isAddrAutocomplete: false
    });
};

TypeaheadMetricsLogger.prototype.emitSuggestionEngagementMetric =
    function(isSuggestionSelected, userTypedQuery, text, variants, selectedSuggestionEssid)
{
    "use strict";
    _.extend(this.suggestionEngagement, {
        suggestionSelected: isSuggestionSelected,
        text: text,
        timestamp: Date.now(),
        userTypedQuery: userTypedQuery,
        variants: variants,
        selectedSuggestionEssid: isSuggestionSelected === true ? TypeaheadUtils.formatEssIdSourceInfo(selectedSuggestionEssid) : undefined
    });
    TypeaheadUtils.sendToCollector([this.suggestionEngagement]);
};

TypeaheadMetricsLogger.prototype.timestamp = function (timestampCategory, query, optionalTimestampValue) {
    "use strict";
    this.timestamps[timestampCategory] = this.timestamps[timestampCategory] || {};
    this.timestamps[timestampCategory][query] = this.timestamps[timestampCategory][query] ||[];
    this.timestamps[timestampCategory][query].push(optionalTimestampValue || new Date().getTime());
};

TypeaheadMetricsLogger.prototype.logFocus = function () {
    "use strict";
    this.focuses.push(new this.FocusMetric(this.guid));
};

TypeaheadMetricsLogger.prototype.logSelection = function (index, text) {
    "use strict";
    this.selections.push(new this.SelectionMetric(index, text, this.guid));
};

TypeaheadMetricsLogger.prototype.logSubmission = function (text, isValid) {
    "use strict";
    this.submission = new TypeaheadMetricsLogger.prototype.SubmissionMetric(text, this.guid, isValid);
};

TypeaheadMetricsLogger.prototype.computePerformanceMetrics = function() {
    "use strict";
    var self = this,
        mCat = this.MetricCategories,
        rv = [],
        guid = this.guid;

    function computeMetricsForQuery(query, metricCategories) {
        var metrics = {};
        var finalTimestampCategory;
        _.forEach(metricCategories, function (metricCategory) {
            self._extendWithMetric(metrics, metricCategory, query);
        });
        if ($.isEmptyObject(metrics)) {
            return null;
        } else {
            finalTimestampCategory = metricCategories[metricCategories.length - 1].endTimestampCategory;
            self.timestamps[finalTimestampCategory][query].shift();
            metrics['pointOfSale'] = TypeaheadUtils.getPointOfSale();
            metrics['guid'] = guid;
            metrics['type'] = "latency";
            return metrics;
        }
    }

    function computeMetricsForQueryCallingEss(query) {
        return computeMetricsForQuery(query, [mCat.KeyUpToEssRequest, mCat.EssRequestToResponse, mCat.EssResponseToRender]);
    }

    function computeMetricsForQueryNotCallingEss(query) {
        return computeMetricsForQuery(query, [mCat.KeyUpToRenderNotCallingEss]);
    }

    _.forEach(_.keys(this.timestamps[this.TimestampCategories.RENDER]), function (query) {
        var metrics;
        do {
            metrics = computeMetricsForQueryCallingEss(query) || computeMetricsForQueryNotCallingEss(query);
            if (metrics) {
                rv.push(metrics);
            }
        } while (metrics);
    });
    return rv;
};

TypeaheadMetricsLogger.prototype.emitMetrics = function() {
    "use strict";
    var performanceMetrics = this.computePerformanceMetrics();
    if (performanceMetrics.length > 0) {
        TypeaheadUtils.sendToCollector(performanceMetrics);
    }
    if (this.selections.length > 0) {
        TypeaheadUtils.sendToCollector(this.selections);
        this.selections = [];
    }
    if (this.focuses.length > 0) {
        TypeaheadUtils.sendToCollector(this.focuses);
        this.focuses = [];
    }
    if (this.submission) {
        TypeaheadUtils.sendToCollector([this.submission]);
        this.submission = undefined;
    }
};

TypeaheadMetricsLogger.prototype._hasTimestamp = function(timestampCategory, query) {
    "use strict";
    return this.timestamps[timestampCategory]
        && $.isArray(this.timestamps[timestampCategory][query])
        && this.timestamps[timestampCategory][query].length > 0
};

TypeaheadMetricsLogger.prototype._extendWithMetric = function(object, metricCategory, query) {
    "use strict";
    if (this._hasTimestamp(metricCategory.endTimestampCategory, query)
        && this._hasTimestamp(metricCategory.beginTimestampCategory, query))
    {
        object[metricCategory.name] = this.timestamps[metricCategory.endTimestampCategory][query][0]
            - this.timestamps[metricCategory.beginTimestampCategory][query].shift();
    }
    if (!_.isEmpty(object)) {
        object.text = query;
    }
    return object;
};

return TypeaheadMetricsLogger;
});

/* global _ */
define('gc/TypeaheadMeasurementTopics', [], function() {
    "use strict";
    function createEnum(taNamespace, elements) {
        return _.reduce(
            elements,
            function (memo, element) {
                memo[element] = taNamespace + "." + element;
                return memo;
            },
            {}
        )
    }
    var taNamespace = "TypeaheadMeasurementTopics";
    window[taNamespace] = createEnum(taNamespace, [
        "GeolocationBegin",
        "GeolocationEndError",
        "GeolocationEndSuccess",
        "SuggestionsDisplayed",
        "SuggestionSelected"
    ]);

    return window[taNamespace];
});

/* global _, $, document, window */

define('gc/TypeaheadUtils', ['underscore', 'gc/dataModels', 'env', 'gc/searchExperiments'], function (_, dataModels, env, searchExperiments) {
    "use strict";

    return {
        getCookie : function(name) {
            var value = "; " + document.cookie,
                parts = value.split("; " + name + "=");
            if (parts.length == 2) return parts.pop().split(";").shift();
        },
        getDeviceType : function() {
            return window.utag_data ? window.utag_data.device_type : "Unavailable";
        },
        getGuid : function () {
            var guid = undefined;
            return function () {
                if (guid === undefined) {
                    var mc1Cookie = this.getCookie("MC1"),
                        pair = mc1Cookie && mc1Cookie.split("=");
                    guid = $.isArray(pair) && pair.length === 2 ? pair[1] : "";
                }
                return guid;
            }
        },
        getLocale : function () {
            return env.locale;
        },
        getPageId : function () {
            var pageId = undefined;
            return function () {
                if (pageId === undefined) {
                    pageId = $("#pageId").val();
                    if (! pageId) { pageId = ""; }
                }
                return pageId;
            }
        },
        getSiteId : function () {
            return env.siteId;
        },
        getPointOfSale : function () {
            return window.location.hostname;
        },
        getExperimentTreatmentAssignments : function (serversideVariantAssignments, clientsideVariantAssignments) {
            return _.compact([serversideVariantAssignments, clientsideVariantAssignments]).join("|");
        },
        getTAExperimentTreatmentAssignments : function () {
            var clientsideVariantAssignments = undefined;
            return function (corewizard) {
                function getAssignmentString(abacusId) {
                    var assignment = corewizard.masterconfig.abacus[abacusId];
                    return assignment ? String(abacusId) + "." + assignment : undefined;
                }
                if (clientsideVariantAssignments === undefined) {
                    clientsideVariantAssignments = _.compact(_.map(_.keys(searchExperiments.experimentDetails), getAssignmentString))
                        .join("|");
                }
                var serversideVariantAssignments = dataModels.model.get("activeESSTests");
                return _.compact([serversideVariantAssignments, clientsideVariantAssignments]).join("|");
            }
        },
        createTypeaheadMetricsLogEntryCore : function (documentElementId, lineOfBusiness, treatmentAssignments, timestamp) {
            return {
                contentFlavor: "global-controls",
                deviceType: this.getDeviceType(),
                userAgent: navigator.userAgent,
                guid: this.getGuid(),
                lob: lineOfBusiness,
                locale: this.getLocale(),
                pageId: this.getPageId(),
                pointOfSale: this.getPointOfSale(),
                siteId: this.getSiteId(),
                textInputElementId: documentElementId,
                timestamp: timestamp,
                variants: treatmentAssignments
            };
        },
        generateTracker : function () {
            return Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
        },
        sendToCollector : function (object) {
            var url = "//"
                + window.location.hostname
                + (window.location.port ? ':' + window.location.port : '')
                + "/cl/data"
                + "/typeahead_client_metrics.json?stream=true&persist=true&batch=true";
            $.ajax({
                    contentType: "application/json; charset=UTF-8",
                    url: url,
                    data: JSON.stringify(object),
                    dataType: "json",
                    type: "POST"
                }
            );
        },
        removePropertiesNotToBeSavedForBackButton : function (object) {
            if (_.isObject(object)) {
                if (object.TADestSearchType === "GEOLOCATION" || _.isObject(object.promiseForGeolocation)) {
                    delete object.destination;
                    delete object.promiseForGeolocation;
                    delete object.userDeniedGeoLocation;
                    delete object.TADestSearchType
                }
            }
            return object;
        },
        getDataFromItem : function (item) {
            var data;
            var rawData;
            if (typeof item.attr === 'function') {
                rawData = item.attr('data-data');
                if(rawData) {
                    try {
                        data = JSON.parse(rawData);
                    }
                    catch (e) {
                        // Do nothing.
                    }
                }
            }
            else {
                data = item;
            }
            return data;
        },
        formatEssIdSourceInfo : function (essId) {
            return essId ?
                    (
                        ( essId.sourceName ? essId.sourceName : '-')
                        + ':'
                        + ( essId.sourceId ? essId.sourceId : '-')
                    )
                    : '-:-' ;
        },
        TypeaheadSuggestionsDisplayedMeasurement : function(timestamp) {
            "use strict";
            this.timestamp = timestamp;
        },
        TypeaheadSuggestionSelectedMeasurement : function(timestamp, documentElementId, lineOfBusiness, treatmentAssignments) {
            "use strict";
            this.timestamp = timestamp;
            this.documentElementId = documentElementId;
            this.lineOfBusiness = lineOfBusiness;
            this.treatmentAssignments = treatmentAssignments;
        },
        TypeaheadGeolocationBeginMeasurement : function (timestamp, tracker) {
            "use strict";
            this.timestamp = timestamp;
            this.tracker = tracker;
        },
        TypeaheadGeolocationEndMeasurement : function(timestamp, tracker, documentElementId, lineOfBusiness, treatmentAssignments) {
            "use strict";
            this.timestamp = timestamp;
            this.tracker = tracker;
            this.documentElementId = documentElementId;
            this.lineOfBusiness = lineOfBusiness;
            this.treatmentAssignments = treatmentAssignments;
        },
        TypeaheadGeolocationEndSuccessMeasurement : function(timestamp, tracker, position, documentElementId, lineOfBusiness, treatmentAssignments) {
            "use strict";
            _.extend(this, new this.TypeaheadGeolocationEndMeasurement(
                 timestamp, tracker, documentElementId, lineOfBusiness, treatmentAssignments));
            _.extend(this, {position: position});
        },
        TypeaheadGeolocationEndErrorMeasurement : function(timestamp, tracker, positionError, documentElementId, lineOfBusiness, treatmentAssignments) {
            "use strict";
            _.extend(this, new this.TypeaheadGeolocationEndMeasurement(
                timestamp, tracker, documentElementId, lineOfBusiness, treatmentAssignments));
            _.extend(this, {positionError: positionError});
        },
        currentLocationInfo : {
            // currentCityName: "${currentCityName}",
            // currentStateName: "${currentStateName}",
            // currentRegionName: "${currentRegionName}",
            // currentCountryName: "${currentCountryName}",
            // currentAirportTLA: "${currentAirportTLA}"
        }

    }
});

/* global
    _,
    TypeaheadMeasurementTopics,
    TypeaheadUtils,
    uitk
*/

/*
 * TypeaheadGeolocationMeasurementsLogger is a singleton class that logs the measurements about the usage of W3C
 * geolocation API for the typeahead suggestion "Use your current location".
 */
define('gc/TypeaheadGeolocationMeasurementsLogger', ['underscore', 'uitk', 'gc/TypeaheadMeasurementTopics', 'gc/TypeaheadUtils'], function (_, uitk, TypeaheadMeasurementTopics, TypeaheadUtils) {
    "use strict";

    var instance = null;

    function TypeaheadGeolocationMeasurementsLogger() {
        if(instance !== null){
            throw new Error("Cannot instantiate more than one TypeaheadGeolocationMeasurementsLogger, " +
                "use TypeaheadGeolocationMeasurementsLogger.getInstance()");
        }
        this.initialize();
    }

    TypeaheadGeolocationMeasurementsLogger.prototype = {
        initialize : function() {
            this.begins = {};
            uitk.subscribe(TypeaheadMeasurementTopics.GeolocationBegin, this,
                TypeaheadGeolocationMeasurementsLogger.prototype.logGeolocationBegin);
            uitk.subscribe(TypeaheadMeasurementTopics.GeolocationEndError, this,
                TypeaheadGeolocationMeasurementsLogger.prototype.logGeolocationEndError);
            uitk.subscribe(TypeaheadMeasurementTopics.GeolocationEndSuccess, this,
                TypeaheadGeolocationMeasurementsLogger.prototype.logGeolocationEndSuccess);
        },
        createGeolocationAsSuggestionLogEntry : function(beginTimestamp, endMeasurement) {
            return _.extend(
                TypeaheadUtils.createTypeaheadMetricsLogEntryCore(
                    endMeasurement.documentElementId,
                    endMeasurement.lineOfBusiness,
                    endMeasurement.treatmentAssignments,
                    endMeasurement.timestamp),
                {
                    latency: endMeasurement.timestamp - beginTimestamp,
                    type: "GeolocationAsSuggestion"
                });
        },
        createGeolocationAsSuggestionSuccessLogEntry : function(beginTimestamp, endMeasurement)
        {
            return _.extend(
                createGeolocationAsSuggestionLogEntry(beginTimestamp, endMeasurement),
                {
                    position: clonePosition(endMeasurement.position)
                }
            );
        },
        createGeolocationAsSuggestionErrorLogEntry : function(beginTimestamp, endMeasurement)
        {
            return _.extend(
                createGeolocationAsSuggestionLogEntry(beginTimestamp, endMeasurement),
                {
                    positionError: clonePositionError(endMeasurement.positionError)
                }
            );
        },
        /*
         * A Position in W3C Geolocation may not be a "regular" JavaScript object. For example,
         * position.hasOwnProperty("timestamp") may be false. Therefore we need an ad hoc function to clone it.
         */
        clonePosition : function(position) {
            return {
                coords: {
                    accuracy: position.coords.accuracy,
                    altitude: position.coords.altitude,
                    altitudeAccuracy: position.coords.altitudeAccuracy,
                    heading: position.coords.heading,
                    latitude: position.coords.latitude,
                    longitude:  position.coords.longitude,
                    speed: position.coords.speed
                },
                timestamp: position.timestamp
            }
        },
        /*
         * A PositionError in W3C Geolocation may not be a "regular" JavaScript object. For example,
         * positionError.hasOwnProperty("code") may be false. Therefore we need an ad hoc function to clone it.
         */
        clonePositionError : function (positionError) {
            return {
                code: positionError.code,
                message: positionError.message
            }
        },
        logGeolocationBegin : function (topic, measurement) {
            var tracker = measurement.tracker;
            if (this.begins.hasOwnProperty(tracker)) {
                console.log("tracker was reused. This is a bug.");
            }
            else {
                this.begins[tracker] = measurement;
            }
        },
        logGeolocationEnd : function doLog(payloadFactory, endMeasurement) {
            var tracker = endMeasurement.tracker;
            if (! this.begins.hasOwnProperty(tracker)) {
                console.log("end without a corresponding begin. This is a bug.");
            }
            else {
                TypeaheadUtils.sendToCollector([
                    payloadFactory(this.begins[tracker].timestamp, endMeasurement)
                ]);
                delete this.begins[tracker];
            }
        },
        logGeolocationEndSuccess : function (topic, measurement) {
            this.logGeolocationEnd(this.createGeolocationAsSuggestionSuccessLogEntry, measurement);
        },
        logGeolocationEndError : function (topic, measurement) {
            this.logGeolocationEnd(this.createGeolocationAsSuggestionErrorLogEntry, measurement);
        }
    }

    TypeaheadGeolocationMeasurementsLogger.getInstance = function() {
        // summary:
        // Gets an instance of the singleton. It is better to use
        if(instance === null){
            instance = new TypeaheadGeolocationMeasurementsLogger();
        }
        return instance;

    }

    return { getInstance : TypeaheadGeolocationMeasurementsLogger.getInstance };
});

/* global
 TypeaheadMeasurementTopics,
 TypeaheadUtils,
 uitk
 */

/*
 * TypeaheadHeartMetricsLogger is a singleton class that logs the time
 * between the user see or hear the suggestions and he makes a decision.
 */
define('gc/TypeaheadScannabilityMeasurementsLogger', ['uitk', 'gc/TypeaheadMeasurementTopics', 'gc/TypeaheadUtils'], function (uitk, TypeaheadMeasurementTopics, TypeaheadUtils) {
    "use strict";

    var instance = null;

    function TypeaheadScannabilityMeasurementsLogger(){
        if(instance !== null){
            throw new Error("Cannot instantiate more than one TypeaheadScannabilityMeasurementsLogger, " +
                "use TypeaheadScannabilityMeasurementsLogger.getInstance()");
        }

        this.initialize();
    }

    /*
     * TypeaheadScannabilityMeasurementsLogger is a class hidden inside of the class TypeaheadHeartMetricsLogger 
     * and performs the actual work for it. 
     * It is hidden to remain a singleton.
     */

    TypeaheadScannabilityMeasurementsLogger.prototype = {
        initialize : function() {
            this.begins = {};
            uitk.subscribe(TypeaheadMeasurementTopics.SuggestionsDisplayed, this,
                TypeaheadScannabilityMeasurementsLogger.prototype.logSuggestionsDisplayed);
            uitk.subscribe(TypeaheadMeasurementTopics.SuggestionSelected, this,
                TypeaheadScannabilityMeasurementsLogger.prototype.logSuggestionSelected);
        },
        createScannabilityMeasurementsLogEntry : function(beginTimestamp, endMeasurement) {
            return _.extend(
                TypeaheadUtils.createTypeaheadMetricsLogEntryCore(
                    endMeasurement.documentElementId,
                    endMeasurement.lineOfBusiness,
                    endMeasurement.treatmentAssignments,
                    endMeasurement.timestamp),
                {
                    latency: endMeasurement.timestamp - beginTimestamp,
                    type: "scan"
                });
        },
        logSuggestionsDisplayed : function (topic, measurement) {
            this.timestamp = measurement.timestamp;
        },
        logSuggestionSelected : function (topic, measurement) {
            TypeaheadUtils.sendToCollector([
                this.createScannabilityMeasurementsLogEntry(this.timestamp, measurement)
            ]);
        }
    };

    TypeaheadScannabilityMeasurementsLogger.getInstance = function(){
        // summary:
        // Gets an instance of the singleton. It is better to use
        if(instance === null){
            instance = new TypeaheadScannabilityMeasurementsLogger();
        }
        return instance;
    };

    return TypeaheadScannabilityMeasurementsLogger;

});

/**
 * Created by txiang on 5/10/16.
 */
define('gc/TypeaheadAddressAutocompleteHelper', ['gc/dataModels'], function (dataModels) {
    "use strict";

    function constructEssObject(predictions){

        var idx = 1,
            results = [],
            maximumGoogleAutocompleteResultsToBeShown = 5,
            maxIndex = 0,
            prediction = {},
            essId = {},
            regionNames = {},
            essObject = {};

        if(predictions)
        {
            maxIndex = Math.min(maximumGoogleAutocompleteResultsToBeShown, predictions.length);
            while(idx <= maxIndex)
            {
                prediction = predictions[idx-1];
                essId = {
                    sourceName:"GPA",
                    sourceId: prediction.place_id
                };
                regionNames = {
                    fullName : prediction.description,
                    shortName : prediction.description,
                    displayName : this.boldMatchedSubStringInPrediction(prediction),
                    lastSearchName : prediction.description
                };
                essObject = {
                    type : "ADDRESS",
                    essId : essId,
                    regionNames : regionNames,
                    index : idx
                };
                results.push(essObject);
                idx++;
            }
        }


        return results;
    };

    function boldMatchedSubStringInPrediction(prediction)
    {
        var boldDisplayname = prediction.description;
        var returnStr = "";
        var connectHead = 0;
        var matchedStrs  = prediction.matched_substrings;
        var idx;
        var matchedStr = "";
        for(idx in matchedStrs)
        {
            matchedStr = matchedStrs[idx];
            returnStr += boldDisplayname.slice(connectHead, matchedStr.offset);
            returnStr += "<B>" + boldDisplayname.slice(matchedStr.offset, matchedStr.offset + matchedStr.length)+ "</B>";
            connectHead = matchedStr.offset + matchedStr.length;
        }

        return returnStr + boldDisplayname.slice(connectHead);
    };

    function autocompleteAddress(essAddressAutocompleteJsonResponse, typeaheadInstance, lastFocusedElementId) {

        var request = {
            input : essAddressAutocompleteJsonResponse.q,
            types : ["geocode"]
        };

        function handlePredictions(predictions, status) {
            var constructedEssResults = [];
            var addressAutocompleteQuery = '';  // default search query string
            var isGoogleAddressAutocompleteCall = true;

            if (status === google.maps.places.PlacesServiceStatus.OK){
            //status = ZERO_RESULT is treated as a failure as we only log failures for now.
            //In failure metrics we will get to know how often ZERO_RESULT happens.

                constructedEssResults = TypeaheadAddressAutocompleteHelper.constructEssObject(predictions);
                
                if(this.shouldRender(essAddressAutocompleteJsonResponse, constructedEssResults, lastFocusedElementId))
                {
                    addressAutocompleteQuery = essAddressAutocompleteJsonResponse.q;
                    if(constructedEssResults.length > 0){
                        typeaheadInstance.render(addressAutocompleteQuery, constructedEssResults, isGoogleAddressAutocompleteCall);
                    }
                }
                else {
                    typeaheadInstance.close();
                }
            }
            else{
                TypeaheadUtils.sendToCollector([_.extend(
                    TypeaheadUtils.createTypeaheadMetricsLogEntryCore(
                        typeaheadInstance.$element.attr("id"),
                        dataModels.model.get('tab'),//@vmohapatra TODO :getLobType
                        TypeaheadUtils.getTAExperimentTreatmentAssignments(corewizard),
                        Date.now()),
                    {
                        userTypedQuery: dataModels.model.get("userTypedQuery"),
                        type: "AddressAutocompleteFailure",
                        status: status
                    })]);
            }
        };

        var handlePredictionsResponse;

        if (!handlePredictions) {
            handlePredictionsResponse = $.noop;
        }
        else {
            handlePredictionsResponse = $.proxy(handlePredictions, typeaheadInstance);
        }

        typeaheadInstance.getAddressAutocompleteService().getPlacePredictions(request, handlePredictionsResponse);

    };

    return{
        constructEssObject : constructEssObject,
        boldMatchedSubStringInPrediction : boldMatchedSubStringInPrediction,
        autocompleteAddress : autocompleteAddress
    };

});

/*global ab3291status, corewizard */

define('gc/typeaheadCallbacks', [
    'gc/abTest',
    'gc/dataModels',
    'gc/searchExperiments',
    'gc/loc',
    'gc/getLob',
    'jquery',
    'gc/TypeaheadUtils',
    'gc/TypeaheadMeasurementTopics',
    'gc/TypeaheadGeolocationMeasurementsLogger',
    'gc/RecentHistoryOptionsInjector'
], function(
    abTest,
    dataModels,
    searchExperiments,
    loc,
    getLob,
    $,
    TypeaheadUtils,
    TypeaheadMeasurementTopics,
    TypeaheadGeolocationMeasurementsLogger,
    RecentHistoryOptionsInjector
) {

    var ab3291status = abTest.get(3291).value;

    function typeaheadUpdateModel(data, model, hasChild) {
        //If no hierarchy info present, by default classify it as parent
        model.set('suggestionType', data.hierarchyInfo ?
                                        (
                                            data.hierarchyInfo.relation ?
                                                (data.hierarchyInfo.relation[0] === 'child' ? 'child' : 'parent')
                                                : 'parent'
                                        )
                                        : 'parent'
                );
        model.set('hasChild', hasChild ? true : false);
    }

    // isNotMultiFlight
    // Helper method to verify we're not on a multi-flight scenario
    function isNotMultiFlight() {
        var result = true;
        var currentLob = getLob(dataModels.model.get('tab'), dataModels.model.get('packages'));

        // if we're on the test wizard, add test button
        if (currentLob === 'flight') {
            result = $('input[name="flight-type"]:checked').val() !== 'multi';
        }
        return result;
    }

    // setCoreWizardFields
    // @param {data} - data is the corewizard.core.state object to send to corewizard.core.state.set(data) API.
    // This call sets the corewizard.core.state.attributes object fields
    // @param {currentLob} - what LOB is active
    //
    // NOTE:
    // These are the minimum set of corewizard.core.state properties
    // that affect the visible UI fields that need populating. From
    // there you can add on whatever else is needed by the non-UI parts
    // of the model.
    function setCoreWizardFields(data, currentLob) {
        var viewModel = dataModels.state;

        if (currentLob === 'hotel' || (currentLob === 'flight' && isNotMultiFlight())) {

            // set all the wizard fields with one call
            // passing an object with all the data
            viewModel.set(data);

            // once the typeahead tooltip window closes, then it's safe to
            // reset focus/select to last focused typeahead control.
            require('uitk', function(uitk) {
              uitk.subscribe('typeaheadTooltip.closed', function(topic, lastFocusedElementId){
                  uitk.unsubscribe('typeaheadTooltip.closed');

                  // reset focus and fire the assistive technogies to happen on the next turn of the event loop
                  var lastActiveElement = document.getElementById(lastFocusedElementId);
                  setTimeout(function(){
                      // User has made a selection and the typeahead popup has closed
                      // Set the flag to track that so that when focus is restored to
                      // the input control, we can avoid rendering another typeahead popup
                      Typeahead.taItemChosen = true;
                      lastActiveElement.select();
                      uitk.utils.liveAnnounce("All fields have been updated");
                  }, 0);
              });
            })

            // Trigger an "updateLayout" on the wizard
            // This will trigger a broadcast corewizard.wizardReloaded event
            dataModels.state.trigger('reloadWizard');
        }
    }

    function getAirportCode(data, isEssV4) {
        return isEssV4 ? (data.hierarchyInfo ? (data.hierarchyInfo.airport ? data.hierarchyInfo.airport.airportCode : data.hierarchyInfo.airport) : data.hierarchyInfo) : data.a;
    }

    function getDataType(data, isEssV4) {
        return isEssV4 ? data.type : data.t;
    }

    function getGaiaId(data, isEssV4) {
        //vmohapatra : gaiaId/hotelId is going to be deprecated from ESS response.
        //vmohapatra : return GAIA ID only if source name is GAI in ESS response (BUG : ECOMSVC-1767 )
        return isEssV4
            ? (
                data.essId && data.essId.sourceName === "GAI" && _.isString(data.essId.sourceId)
                    ? data.essId.sourceId
                    :undefined
            )
            : data.id;
    }

    function getHotelId(data) {
        //vmohapatra : return Hotel ID only if source name is PRC in ESS response (BUG : ECOMSVC-1767 )
        return data.essId &&  data.essId.sourceName === "PRC"
            ? data.essId.sourceId
            : undefined;
    }

    function getSuggestionTypeId(data) {
        return data.essId && data.essId.sourceId
            ? data.essId.sourceId
            : '-';
    }

    function getFullName(data, isEssV4) {
        return isEssV4 ? (data.regionNames ? data.regionNames.fullName : '') : data.f;
    }

    function getLastSearchName(data, isEssV4) {
        return isEssV4 ? (data.regionNames ? data.regionNames.lastSearchName : '' ): data.l;
    }

    // Returns the value suitable for calling corewizard.core.state.set("destinationFromTA", value) with.
    function getDestinationFromTAForPackageDestination(data, isEssV4) {
        return isEssV4 ? (data.regionNames ? data.regionNames.lastSearchName : '') : data.f;
    }

    function getIndex(data, isEssV4) {
        return isEssV4 ? data.index : data.i;
    }

    //Util function to get relation info of suggestion
    function getRelationInfo(data) {
        return ( data.hierarchyInfo && data.hierarchyInfo.relation && data.hierarchyInfo.relation.length > 0 ? data.hierarchyInfo.relation[0] : '-' );
    }

    //hotel LOB callback for the typeahead (added extra param to indicate if it has child)
    function typeaheadItemClickCallback(item, hasChild, typeahead) {
        'use strict';

        function publishGeolocationBeginMeasurement(tracker) {
          if (uitk) {
            uitk.publish(TypeaheadMeasurementTopics.GeolocationBegin,
                new TypeaheadGeolocationBeginMeasurement(Date.now(), tracker));
          }
        }

        function publishGeolocationEndSuccessMeasurement(tracker, position) {
          if (uitk) {
            uitk.publish(TypeaheadMeasurementTopics.GeolocationEndSuccess,
                new TypeaheadUtils.TypeaheadGeolocationEndSuccessMeasurement(
                    Date.now(), tracker, position, typeahead.$element.attr("id"), dataModels.model.get('tab'),//@vmohapatra TODO :getLobType
                    TypeaheadUtils.getTAExperimentTreatmentAssignments(corewizard)));
          }
        }

        function publishGeolocationEndErrorMeasurement(tracker, positionError) {
          if (uitk) {
            uitk.publish(TypeaheadMeasurementTopics.GeolocationEndError,
                new TypeaheadUtils.TypeaheadGeolocationEndErrorMeasurement(
                    Date.now(), tracker, positionError, typeahead.$element.attr("id"), dataModels.model.get('tab'),//@vmohapatra TODO :getLobType
                    TypeaheadUtils.getTAExperimentTreatmentAssignments(corewizard)));
          }
        }

        var model = dataModels.state, data={};
        var deferredGeolocation;
        var geolocationMetricsTracker;
        var promiseForGeolocationLiteral = "promiseForGeolocation";
        var currentLob = getLob(dataModels.model.get('tab'), dataModels.model.get('packages'));

        data = TypeaheadUtils.getDataFromItem(item);
        if (! data) { return; }

        //Set the source info for each Typeahead selection. Default is null / undefined
        model.set('destinationSourceInfo', data.essId);

        //Set the relation info if present
        model.set('destinationRelInfo', getRelationInfo(data));

        if (searchExperiments.getVariant("CURRENT_LOCATION")) {

            if (data.type === 'GEOLOCATION') {
                if (_.isObject(navigator.geolocation)) {
                    // Use the jQuery Deferred() mechanism to create a
                    // Promise object to store as a wizard state property.
                    deferredGeolocation = $.Deferred();
                    TypeaheadGeolocationMeasurementsLogger.getInstance();

                    geolocationMetricsTracker = TypeaheadUtils.generateTracker();
                    publishGeolocationBeginMeasurement(geolocationMetricsTracker);
                    // Ask HTML5 API for current location. This API can take quite a while so we
                    // 'store' off a Promise object that represents the eventual results of the call as a property
                    // on in the wizard state store.
                    // NOTE
                    // This call triggers a browser dialog the initial time the call is made and the user is asked if they
                    // want to allow expedia.com to access their geolocation. There's no way to know when that is however.
                    // But when it does happen, the browser window deactivates and loses keyboard focus. After the dialog
                    // is closed, the browser reactivates the window. This reactivation triggers a focus event. If the user
                    // selected
                    navigator.geolocation.getCurrentPosition(
                        function(position) {
                            publishGeolocationEndSuccessMeasurement(geolocationMetricsTracker, position);
                            deferredGeolocation.resolve(position);
                        },
                        function(positionError) {
                            publishGeolocationEndErrorMeasurement(geolocationMetricsTracker, positionError);
                            deferredGeolocation.reject(positionError);
                        },
                        {
                            enableHighAccuracy: true,
                            timeout: 5000,
                            maximumAge: 0
                        });

                    // store the Promise object on the wizard state object
                    model.set(promiseForGeolocationLiteral, deferredGeolocation.promise());
                }
                else {
                    // Browser does not support geolocation. Do nothing.
                }
            }
        }

        if (data.category === "USERHISTORY") {
            setCoreWizardFields(
                RecentHistoryOptionsInjector.extractCoreWizardStateFromHistoryForHotel(data.essId, data.regionNames),
                currentLob
            );
        }
        else {
            if(data.type == 'HOTEL') {
                model.set('hotelId', getHotelId(data));
                model.set('destSuggestionTypeId', getSuggestionTypeId(data));

                model.set('city',data.hotelAddress.city);
                if(data.hierarchyInfo) {
                    model.set('destinationTLA', data.hierarchyInfo.airport ? data.hierarchyInfo.airport.airportCode : data.hierarchyInfo.airport);
                    model.set('multiCityRegion', data.hierarchyInfo.airport ? data.hierarchyInfo.airport.multicity : data.hierarchyInfo.multicity);
                }
            }
            else {
                model.set('hotelId', null);
                model.set('destSuggestionTypeId', getSuggestionTypeId(data));
            }
        }

        if (data.subtype) {
            if (data.type==='ADDRESS' || data.type==='POI') {
                model.set('TASearchType', data.subtype);
                model.set('TADestSearchType', data.subtype);
                model.set('excludeGaiaId','true');
            } // this is especially for BUC HLR, in Omniture logging, we need to log its subType, but in HSRP, we need to both send its GAIAID and lat-long
            else if (data.type==='MULTIREGION') {
                model.set('TASearchType', data.subtype);
                model.set('TADestSearchType', data.subtype);
            } // for Type 4 NBHs (ESS experiment 11374 CWTA_AirportIconForNBHDs)
              // https://eiwork.mingle.thoughtworks.com/projects/ewe_discovery_services/cards/3292
            else if (data.type==='NEIGHBORHOOD' && data.subtype==='AIRNBH') {
                model.set('TASearchType', 'AIRNBH');
                model.set('TADestSearchType', 'AIRNBH');
            }
        }
        else if(currentLob === 'hotel' && data.type=='ADDRESS')
        {
            model.set('TASearchType', data.subtype ? data.subtype : data.type);
            model.set('TADestSearchType', data.subtype ? data.subtype : data.type);
        }
        else if(searchExperiments.getSearchExperimentVariant('11582') !== '0' && data.category=='USERHISTORY')
        {
            model.set('TASearchType', data.category);
            model.set('TADestSearchType', data.category);
        }
        else
        {
            model.set('TASearchType', data.type);
            model.set('TADestSearchType', data.type);
        }

        model.set('OMHotelTA', true);
        if(model.get('hotelId') != undefined) {
            model.set('regionId', undefined);
        }
        else {
            model.set('regionId', getGaiaId(data, true));
        }

        //For Themes since they don't have coordinate information, don't set it in the model
        if(data.coordinates)
        {
            //vmohapatra: HSRP requires latLong param to be sent in lat,long format. Domain can handle both comma and space
            model.set('latLong', data.coordinates.lat + ',' + data.coordinates['long']);
        }
        if(data.regionNames) {
            //model.set('destinationFromTA', data.regionNames.fullName);
            //vmohapatra : Since lastSearchName is used as searchText :
            //in order to keep destination and destinationFromTA in sync always use lastSearchName to populate destinationFromTA
            //
            model.set('destinationFromTA', Typeahead.decodeHtmlCharacterEntities(data.regionNames.lastSearchName));
            model.set('destinationTLA', null);
            if (searchExperiments.getVariant("BEST_DEALS_OPTION") && data.type === "DEALS") {
                model.set('destination', Typeahead.decodeHtmlCharacterEntities(data.regionNames.lastSearchName));
            }
        }
        model.set('selectedTASuggestionPosition',parseInt(data.index)+1);

        if(data.regionMetadata) {
            if (data.regionMetadata.redirect && corewizard.masterconfig.trivagoRedirectionEnabled) {
                model.set('redirectionURL', data.regionMetadata.redirect);
                if (dctk) {
                    var linkID = 'LTC.NHP.ItemSelected';
                    dctk.trackAction(linkID, item, {prop16:linkID,eVar28:linkID,eVar18:'Homepage'});
                }
            }
        }

        typeaheadUpdateModel(data, model, hasChild);

        if (ab3291status.value === 1) {
            if (!model.get('noDate')) {
                corewizard.helpers.openCalendarField('startDate');
            }
        }

        if (searchExperiments.getVariant("BEST_DEALS_OPTION") && data.sort) {
            model.set('sort', data.sort);
        }

        if (
            searchExperiments.getSearchExperimentVariant('11582') !== '0' &&
            data.category === "USERHISTORY"
        ) {
            var  currTimestamp = new Date();

            var timeData = data.timestamp ? new Number(data.timestamp) : '-';

            if(!isNaN(timeData)) {
                var age = currTimestamp - new Date(timeData);
                model.set('userHistoryItemAge',age);
            }
        }

        if (searchExperiments.getVariant("CURRENT_LOCATION") &&  data.type === 'GEOLOCATION') {
            // repaint the form with all the new model fields set
            corewizard.core.reloadTab();

          if (uitk) {
            // signal "User your current location" option was selected
            uitk.publish('typeahead.currentLocationSelected');
          }
        }

        //vmohapatra : If selected suggestion does not have lat long information, set it to null in model
        // http://jira/jira/browse/ECOMSVC-2010
        if(!data.coordinates) {
            model.set('latLong', null);
        }
    }

    //Cars LOB pickup callback for the typeahead
    function typeaheadCarPickUpCallback(item) {
        require(['gc/dataModels', 'gc/loc'], function(dataModels, loc) {
            'use strict';
            var model = dataModels.state,
                data = undefined,
                alwaysEnableCarDropoff = loc.masterconfig.switches.enableCarOffairportOnewaySearch;

        data = TypeaheadUtils.getDataFromItem(item);

        var currentLob = getLob(dataModels.model.get('tab'), dataModels.model.get('packages'));

        if (! data) { return; }

            //Set the source info for each Typeahead selection. Default is null / undefined
            model.set('destinationSourceInfo', data.essId);
            model.set('regionId', null);
            model.set('latLong', null);

            //Set the relation info if present
            model.set('destinationRelInfo', getRelationInfo(data));

            if(data.hierarchyInfo) {
                model.set('tla', data.hierarchyInfo.airport ? data.hierarchyInfo.airport.airportCode : data.hierarchyInfo.airport);
            }

            if (data.type === "AIRPORT") {
                model.set('carSearchType', 1);
            }
            else {
                model.set('carSearchType', 2);
            }

            if(data.regionNames) {
                model.set('carPickupValueFromTA', Typeahead.decodeHtmlCharacterEntities(data.regionNames.fullName));
                model.set('destinationFromTA', Typeahead.decodeHtmlCharacterEntities(data.regionNames.fullName));
            }

            if(data.subtype && _.contains(['RENTALLOCATION', 'POSTALCODE'], data.subtype)) {
                model.set('originRegionId', '0');
            }
            else {
                model.set('originRegionId', getGaiaId(data, true));
            }

            if(data.coordinates){
                model.set('originLatitude', data.coordinates.lat);
                model.set('originLongitude', data.coordinates['long']);
            }

            model.set('selectedTASuggestionPosition',parseInt(data.index)+1);

            model.set('destSuggestionTypeId', getSuggestionTypeId(data));

            if(data.type=='ADDRESS')
            {
                model.set('TASearchType', data.subtype ? data.subtype : data.type);
                model.set('TADestSearchType', data.subtype ? data.subtype : data.type);

                if(_.contains(['car', 'hotelAttachedWithCar'], currentLob) && data.subtype=="CARRENTALADDRESS") {
                    model.set('TASearchType', 'RENTALLOCATION');
                    model.set('TADestSearchType', 'RENTALLOCATION');
                }
            }
            else
            {
                model.set('TASearchType', data.type);
                model.set('TADestSearchType', data.type);
            }

            setTimeout(function() {
                if(!alwaysEnableCarDropoff) {
                    dataModels.state.trigger('reloadWizard');
                }
            }, 100);

            //vmohapatra : If selected suggestion does not have lat long information, set it to null in model
            // http://jira/jira/browse/ECOMSVC-2010
            if(!data.coordinates) {
                model.set('latLong', null);
            }

            //uitk.utils.focusElement($('#car-pickup-label'));

        });
    }

    //Cars LOB dropoff callback for the typeahead
    function typeaheadCarDropOffCallback(item) {
        'use strict';
        var model = dataModels.state;
        var data = undefined;

        var currentLob = getLob(dataModels.model.get('tab'), dataModels.model.get('packages'));

        data = TypeaheadUtils.getDataFromItem(item);
        if (! data) { return; }

        //Set the source info for each Typeahead selection. Default is null / undefined
        model.set('originSourceInfo', data.essId);

        //Set the relation info if present
        model.set('originRelInfo', getRelationInfo(data));

        //vmohapatra : gaiaId/hotelId is going to be deprecated from ESS response.
        //model.set('destinationRegionId', data.gaiaId);
        if(data.subtype && _.contains(['RENTALLOCATION', 'POSTALCODE'], data.subtype)) {
            model.set('destinationRegionId', '0');
        }
        else {
            model.set('destinationRegionId', getGaiaId(data, true));
        }

        if(data.coordinates){
            model.set('destinationLatitude', data.coordinates.lat);
            model.set('destinationLongitude', data.coordinates['long']);
        }

        if(data.regionNames) {
            model.set('carDropoffValueFromTA', Typeahead.decodeHtmlCharacterEntities(data.regionNames.fullName));
        }
        model.set('selectedTASuggestionPosition',parseInt(data.index)+1);

        model.set('origSuggestionTypeId', getSuggestionTypeId(data));

        if(data.type=='ADDRESS')
        {
            model.set('TASearchType', data.subtype ? data.subtype : data.type);
            model.set('TAOrigSearchType', data.subtype ? data.subtype : data.type);

            if(_.contains(['car', 'hotelAttachedWithCar'], currentLob) && data.subtype=="CARRENTALADDRESS") {
                model.set('TASearchType', 'RENTALLOCATION');
                model.set('TAOrigSearchType', 'RENTALLOCATION');
            }
        }
        else
        {
            model.set('TASearchType', data.type);
            model.set('TAOrigSearchType', data.type);
        }

        //vmohapatra : If selected suggestion does not have lat long information, set it to null in model
        // http://jira/jira/browse/ECOMSVC-2010
        if(!data.coordinates) {
            model.set('latLong', null);
        }

    }

    //flight LOB origin callback for the typeahead
    function typeaheadFlightOriginCallback(item, hasChild) {
        'use strict';
        var model = dataModels.state, data=undefined;
        model.set('OMOriginTA', true);

        data = TypeaheadUtils.getDataFromItem(item);
        if (! data) { return; }

        //Set the source info for each Typeahead selection. Default is null / undefined
        model.set('originSourceInfo', data.essId);

        if(data.hierarchyInfo) {
            model.set('originTLA', data.hierarchyInfo.airport ? data.hierarchyInfo.airport.airportCode : data.hierarchyInfo.airport);
        }

        //Set the relation info if present
        model.set('originRelInfo', getRelationInfo(data));

        if(data.regionNames) {
            model.set('originFromTA', Typeahead.decodeHtmlCharacterEntities(data.regionNames.lastSearchName));
        }

        //POS with static Typeahead will not have hierarchyInfo in Flight LOB
        if(data.hierarchyInfo) {
            if (data.hierarchyInfo.relation && data.hierarchyInfo.relation[0]==="nearby") {
                model.set('TASearchType', "NEARBY"+data.type);
                model.set('TAOrigSearchType', "NEARBY"+data.type);
            }
            else {
                model.set('TASearchType', data.type);
                model.set('TAOrigSearchType', data.type);
            }
        }
        else {
            model.set('TASearchType', data.type);
            model.set('TAOrigSearchType', data.type);
        }

        model.set('selectedTASuggestionPosition',parseInt(data.index)+1);

        model.set('origSuggestionTypeId', getSuggestionTypeId(data));

        typeaheadUpdateModel(data, model, hasChild);

        if (ab3291status.value === 1) {
            dataModels.shiftFocus(corewizard.helpers.getWizardFieldByType('destination'));
        }

        //vmohapatra : If selected suggestion does not have lat long information, set it to null in model
        // http://jira/jira/browse/ECOMSVC-2010
        if(!data.coordinates) {
            model.set('latLong', null);
        }

    }

    //flight LOB destination callback for typeahead
    function typeaheadFlightDestinationCallback(item, hasChild) {
        'use strict';
        var model = dataModels.state, data = undefined;
        data = TypeaheadUtils.getDataFromItem(item);
        if (! data) { return; }

        if (ab3291status.value === 1) {
            dataModels.shiftFocus(corewizard.helpers.getWizardFieldByType('destination'));
        }

        model.set('OMDestinationTA', true);

        //Set the source info for each Typeahead selection. Default is null / undefined
        model.set('destinationSourceInfo', data.essId);

        //Set the relation info if present
        model.set('destinationRelInfo', getRelationInfo(data));

        //need to compare string for omniture logic.
        if(data.regionNames) {
            model.set('OMDestinationTACompare', data.regionNames.lastSearchName);
        }
        if (data.type == 'AIRPORT') {
            model.set('regionId', getGaiaId(data, true));

            if(data.hierarchyInfo) {
                model.set('destinationTLA', data.hierarchyInfo.airport ? data.hierarchyInfo.airport.airportCode : data.hierarchyInfo.airport);
            }
            if(data.regionNames) {
                var dest = Typeahead.decodeHtmlCharacterEntities(data.regionNames.lastSearchName);
                model.set('destinationFromTA', dest);
                model.set('destination', dest);
            }
        }
        else if(_.contains(['TRENDINGSEARCH'], data.type)) {
            //fullName should be used for custom data types
            if (data.regionNames) {
                model.set('destinationFromTA', Typeahead.decodeHtmlCharacterEntities(data.regionNames.fullName));
            }
            if (data.hierarchyInfo) {
                model.set('destinationTLA', data.hierarchyInfo.airport ? data.hierarchyInfo.airport.airportCode : data.hierarchyInfo.airport);
            }
        }
        else
        {
            if(data.regionNames) {
                model.set('destinationFromTA', Typeahead.decodeHtmlCharacterEntities(data.regionNames.lastSearchName));
            }
            if(data.hierarchyInfo) {
                model.set('destinationTLA', data.hierarchyInfo.airport ? data.hierarchyInfo.airport.airportCode : data.hierarchyInfo.airport);
            }
        }

        //POS with static Typeahead will not have hierarchyInfo in Flight LOB
        if(data.hierarchyInfo) {
            if (data.hierarchyInfo.relation && data.hierarchyInfo.relation[0]==="nearby") {
                model.set('TASearchType', "NEARBY"+data.type);
                model.set('TADestSearchType', "NEARBY"+data.type);
            }
            else {
                model.set('TASearchType', data.type);
                model.set('TADestSearchType', data.type);
            }
            if (data.hierarchyInfo.airport && data.hierarchyInfo.airport.multicity) {
                model.set('regionId', data.hierarchyInfo.airport.multicity);
                getMulticityRegionName(data.hierarchyInfo.airport.multicity);
            }
        }
        else {
            model.set('TASearchType', data.type);
            model.set('TADestSearchType', data.type);
        }

        model.set('destSuggestionTypeId', getSuggestionTypeId(data));

        model.set('selectedTASuggestionPosition',parseInt(data.index)+1);

        if (ab3291status.value === 1) {
            dataModels.shiftFocus(corewizard.helpers.getWizardFieldByType('departing'));
        }

        //Set values pertaining to Geo-hierarchy experiment in the model
        typeaheadUpdateModel(data, model, hasChild);

        //vmohapatra : If selected suggestion does not have lat long information, set it to null in model
        // http://jira/jira/browse/ECOMSVC-2010
        if(!data.coordinates) {
            model.set('latLong', null);
        }

    }

    //
    function getMulticityRegionName(multicityRegionId) {
        require(['gc/typeaheadConfig'], function(taConfig) {
            var locale = taConfig.typeahead.def.locale || 'en_US';
            $.ajax({
                dataType: 'jsonp',
                url: 'https://suggestch.expedia.com/api/v4/list/region/?gaiaid='+multicityRegionId+'&locale='+locale,
                success: function (data) {
                    require(['gc/dataModels'], function(model) {
                        if (data && data.sr && data.sr[0] && data.sr[0].regionNames && data.sr[0].regionNames.lastSearchName) {
                            model.state.set('regionName', data.sr[0].regionNames.lastSearchName);
                        }
                    });
                },
                error: function (d, text, errThrown) {
                    console.log("error", text, "-----", errThrown);
                }
            });
        });
    }

    //package LOB origin callback
    function typeaheadPackageOriginCallback(item) {
        'use strict';
        var model = dataModels.state, data=undefined;
        var essv4exp = (searchExperiments.getVariant("CONSUME_ESS_V4_FOR_PACKAGES") !== 0);
        model.set('OMOriginTA', true);
        data = TypeaheadUtils.getDataFromItem(item);
        if (! data) { return; }

        //Set the source info for each Typeahead selection. Default is null / undefined
        model.set('originSourceInfo', data.essId);

        //Set the relation info if present
        model.set('originRelInfo', getRelationInfo(data));

        model.set('originTLA', getAirportCode(data, essv4exp));
        model.set('originFromTA', Typeahead.decodeHtmlCharacterEntities(getLastSearchName(data, essv4exp)));
        model.set('TASearchType', getDataType(data, essv4exp));
        model.set('TAOrigSearchType', getDataType(data, essv4exp));
        model.set('origSuggestionTypeId', getSuggestionTypeId(data));
        model.set('selectedTASuggestionPosition', parseInt(getIndex(data, essv4exp)) + 1);

        //vmohapatra : If selected suggestion does not have lat long information, set it to null in model
        // http://jira/jira/browse/ECOMSVC-2010
        if(!data.coordinates) {
            model.set('latLong', null);
        }

    }

    //package LOB destination callback
    function typeaheadPackageDestinationCallback(item) {
        'use strict';
        var model = dataModels.state, data = undefined;
        var essv4exp = (searchExperiments.getVariant("CONSUME_ESS_V4_FOR_PACKAGES") !== 0);
        data = TypeaheadUtils.getDataFromItem(item);
        if (! data) { return; }
        model.set('TASearchType', getDataType(data, essv4exp));
        model.set('TADestSearchType', getDataType(data, essv4exp));
        model.set('OMDestinationTA', true);

        //Set the source info for each Typeahead selection. Default is null / undefined
        model.set('destinationSourceInfo', data.essId);

        //Set the relation info if present
        model.set('destinationRelInfo', getRelationInfo(data));

        model.set('regionId', getGaiaId(data, essv4exp));
        model.set('destinationTLA', getAirportCode(data, essv4exp));
        model.set('destinationFromTA',
            Typeahead.decodeHtmlCharacterEntities(getDestinationFromTAForPackageDestination(data, essv4exp)));

        if (ab3291status.value === 1) {
            corewizard.helpers.openCalendarField('departing');
        }
        model.set('destSuggestionTypeId', getSuggestionTypeId(data));
        model.set('selectedTASuggestionPosition',parseInt(getIndex(data, essv4exp))+1);

        //vmohapatra : If selected suggestion does not have lat long information, set it to null in model
        // http://jira/jira/browse/ECOMSVC-2010
        if(!data.coordinates) {
            model.set('latLong', null);
        }

    }

    //activity LOB callback
    function typeaheadActivityCallback(item) {
        'use strict';
        var essv4exp = (searchExperiments.getVariant("CONSUME_ESS_V4_FOR_ACTIVITIES") !== 0);
        var model = dataModels.state, data = undefined;
        data = TypeaheadUtils.getDataFromItem(item);
        if (! data) { return; }

        //Set the source info for each Typeahead selection. Default is null / undefined
        model.set('destinationSourceInfo', data.essId);

        //Set the relation info if present
        model.set('destinationRelInfo', getRelationInfo(data));

        model.set('TASearchType', getDataType(data, essv4exp));
        model.set('TADestSearchType', getDataType(data, essv4exp));
        model.set('destinationTLA', getAirportCode(data, essv4exp));
        model.set('destinationFromTA', Typeahead.decodeHtmlCharacterEntities(getFullName(data, essv4exp)));
        model.set('selectedTASuggestionPosition', parseInt(getIndex(data, essv4exp)) + 1);
        model.set('destSuggestionTypeId', getSuggestionTypeId(data));

        //vmohapatra : If selected suggestion does not have lat long information, set it to null in model
        // http://jira/jira/browse/ECOMSVC-2010
        if(!data.coordinates) {
            model.set('latLong', null);
        }

    }

    //Open search LOB callback
    function typeaheadOpenSearchCallback(item) {
        'use strict';
        var model = dataModels.state, data = undefined;
        data = TypeaheadUtils.getDataFromItem(item);
        if (! data) { return; }

        //Set the source info for each Typeahead selection. Default is null / undefined
        model.set('destinationSourceInfo', data.essId);

        //Set the relation info if present
        model.set('destinationRelInfo', getRelationInfo(data));

        model.set('selectedTASuggestionPosition',parseInt(data.index)+1);
        model.set('TASearchType', data.lob);
        model.set('openSearchQueryData', data);

    }

    //Flight LOB multidestination callback for secondary fields
    function typeaheadMultiFlightDestinationCallback (item, hasChild) {
        'use strict';
        var model = dataModels.state, data = undefined, multiFlightInput;
        if (typeof item.attr === 'function') {
            data = JSON.parse(item.attr('data-data'));
            multiFlightInput = item.attr('data-multiFlightInputId');
        }
        else {
            data = item;
            multiFlightInput = item;
        }

        //Default capturing of multi flight origin and destination information

        //Multi Flight field texts
        var multiFlightDestinations = model.get('multiFlightDestination') || {};
        var multiFlightOrigins = model.get('multiFlightOrigin') || {};
        //Multi Flight sourceIds
        var multiFlightDestSuggTypeIds = model.get('multiFlightDestSuggTypeId') || {};
        var multiFlightOrigSuggTypeIds = model.get('multiFlightOrigSuggTypeId') || {};
        //Multi Flight source info
        var multiFlightDestSrcInfo = model.get('multiFlightDestSrc') || {};
        var multiFlightOrigSrcInfo = model.get('multiFlightOrigSrc') || {};
        //Multi Flight Suggestion Type
        var multiFlightDestSuggTypes = model.get('multiFlightDestSuggType') || {};
        var multiFlightOrigSuggTypes = model.get('multiFlightOrigSuggType') || {};
        //Multi Flight relation info
        var multiFlightDestRelInfo = model.get('multiFlightDestRel') || {};
        var multiFlightOrigRelInfo = model.get('multiFlightOrigRel') || {};

        if(
            _.contains(['flight-2-destination', 'flight-3-destination', 'flight-4-destination', 'flight-5-destination'], multiFlightInput)
        )
        {
            //Destination fields
            multiFlightDestinations = multiFlightHelper(data, 'destination', multiFlightInput, multiFlightDestinations, 'input');
            multiFlightDestSuggTypeIds = multiFlightHelper(data, 'destination', multiFlightInput, multiFlightDestSuggTypeIds, 'suggestionId');
            multiFlightDestSrcInfo = multiFlightHelper(data, 'destination', multiFlightInput, multiFlightDestSrcInfo, 'sourceInfo');
            multiFlightDestSuggTypes = multiFlightHelper(data, 'destination', multiFlightInput, multiFlightDestSuggTypes, 'suggestionType');
            multiFlightDestRelInfo = multiFlightHelper(data, 'destination', multiFlightInput, multiFlightDestRelInfo, 'relationInfo');
        }
        else if(
            _.contains(['flight-2-origin', 'flight-3-origin', 'flight-4-origin', 'flight-5-origin'], multiFlightInput)
        )
        {
            //Origin fields
            multiFlightOrigins = multiFlightHelper(data, 'origin', multiFlightInput, multiFlightOrigins, 'input');
            multiFlightOrigSuggTypeIds = multiFlightHelper(data, 'origin', multiFlightInput, multiFlightOrigSuggTypeIds, 'suggestionId');
            multiFlightOrigSrcInfo = multiFlightHelper(data, 'origin', multiFlightInput, multiFlightOrigSrcInfo, 'sourceInfo');
            multiFlightOrigSuggTypes = multiFlightHelper(data, 'origin', multiFlightInput, multiFlightOrigSuggTypes, 'suggestionType');
            multiFlightOrigRelInfo = multiFlightHelper(data, 'origin', multiFlightInput, multiFlightOrigRelInfo, 'relationInfo');
        }

        //Set Multi Flight field texts
        model.set('multiFlightDestination',multiFlightDestinations);
        model.set('multiFlightOrigin',multiFlightOrigins);
        //Set Multi Flight sourceIds
        model.set('multiFlightDestSuggTypeId',multiFlightDestSuggTypeIds);
        model.set('multiFlightOrigSuggTypeId',multiFlightOrigSuggTypeIds);
        // Set Multi Flight source info
        model.set('multiFlightDestSrc',multiFlightDestSrcInfo);
        model.set('multiFlightOrigSrc',multiFlightOrigSrcInfo);
        //Multi Flight Suggestion Type
        model.set('multiFlightDestSuggType',multiFlightDestSuggTypes);
        model.set('multiFlightOrigSuggType',multiFlightOrigSuggTypes);
        //Multi Flight Suggestion Relation
        model.set('multiFlightDestRel',multiFlightDestRelInfo);
        model.set('multiFlightOrigRel',multiFlightOrigRelInfo);

        model.set('selectedTASuggestionPosition',parseInt(data.index)+1);
        model.set('TASearchType', data.type);
        typeaheadUpdateModel(data, model, hasChild);

        //vmohapatra : If selected suggestion does not have lat long information, set it to null in model
        // http://jira/jira/browse/ECOMSVC-2010
        if(!data.coordinates) {
            model.set('latLong', null);
        }

    }

    function multiFlightHelper(data, type, multiFlightInput, multiFlightObject, typeOfLogging) {
        var regex = new RegExp("flight-([2345])-" + type);
        var matchResults = regex.exec(multiFlightInput);
        var index;
        if (! matchResults) {
            return;
        }
        index = matchResults[1] - 2; // For example, index === 0 for multiFlightInput === flight-2-<type>
        if(typeOfLogging == 'input') { multiFlightObject[index]= data.regionNames ? data.regionNames.fullName : '-'; }
        else if(typeOfLogging == 'suggestionId') { multiFlightObject[index]= data.essId ? (data.essId.sourceId ? data.essId.sourceId : '-') : '-'; }
        else if(typeOfLogging == 'sourceInfo') { multiFlightObject[index]= data.essId ? data.essId : {}; }
        else if(typeOfLogging == 'suggestionType') { multiFlightObject[index]= data.type ? data.type : data.t; }
        else if(typeOfLogging == 'reset') { multiFlightObject[index]= data; }
        else if(typeOfLogging == 'relationInfo') { multiFlightObject[index]= getRelationInfo(data);}

        return multiFlightObject;
    }

    //Rails LOB origin callback
    function typeaheadRailOriginCallback(item, hasChild) {
        'use strict';
        var model = dataModels.state, data={};

        if (typeof item.attr === 'function') {
            data = JSON.parse(item.attr('data-data'));
        }
        else {
            data = item;
        }

        if(data.hierarchyInfo) {
            model.set('originTLA', data.hierarchyInfo.rails.stationCode);
        }
        if(data.regionNames) {
            var dest = Typeahead.decodeHtmlCharacterEntities(data.regionNames.lastSearchName);
            model.set('originFromTA', dest);
        }

        var essv4exp = true;
        typeaheadUpdateModel(data, model, hasChild);
        model.set('originSourceInfo', data.essId);
        model.set('TAOrigSearchType', data.type);
        model.set('TASearchType', data.type);
        model.set('originRelInfo',getRelationInfo(data));
        model.set('origSuggestionTypeId', getSuggestionTypeId(data));
        model.set('selectedTASuggestionPosition', parseInt(getIndex(data, essv4exp)) + 1);
    }

    //Rails LOB destination callback
    function typeaheadRailDestinationCallback(item, hasChild) {
        'use strict';
        var model = dataModels.state, data={};

        if (typeof item.attr === 'function') {
            data = JSON.parse(item.attr('data-data'));
        }
        else {
            data = item;
        }

        if(data.hierarchyInfo) {
            model.set('destinationTLA', data.hierarchyInfo.rails.stationCode);
        }
        if(data.regionNames) {
            var dest = Typeahead.decodeHtmlCharacterEntities(data.regionNames.lastSearchName);
            model.set('destinationFromTA', dest);
        }

        //FOr Rails LOB we will always be making ESS v4 API call
        var essv4exp = true;
        typeaheadUpdateModel(data, model, hasChild);
        model.set('destinationSourceInfo', data.essId);
        model.set('TADestSearchType', data.type);
        model.set('TASearchType', data.type);
        model.set('destinationRelInfo',getRelationInfo(data));
        model.set('destSuggestionTypeId', getSuggestionTypeId(data));
        model.set('selectedTASuggestionPosition', parseInt(getIndex(data, essv4exp)) + 1);
    }

    //uTA callback
    function typeaheadSuggestionSelectedCallback(taState, domElementId) {

        'use strict';

        function publishGeolocationBeginMeasurement(tracker) {
          if (uitk) {
            uitk.publish(TypeaheadMeasurementTopics.GeolocationBegin,
                new TypeaheadGeolocationBeginMeasurement(Date.now(), tracker));
          }
        }

        function publishGeolocationEndSuccessMeasurement(tracker, position) {
            if (uitk) {
                uitk.publish(TypeaheadMeasurementTopics.GeolocationEndSuccess,
                new TypeaheadUtils.TypeaheadGeolocationEndSuccessMeasurement(
                    Date.now(), tracker, position, domElementId, dataModels.model.get('tab'),//@vmohapatra TODO :getLobType
                    TypeaheadUtils.getTAExperimentTreatmentAssignments(corewizard)));
            }
        }

        function publishGeolocationEndErrorMeasurement(tracker, positionError) {
          if (uitk) {
                uitk.publish(TypeaheadMeasurementTopics.GeolocationEndError,
                new TypeaheadUtils.TypeaheadGeolocationEndErrorMeasurement(
                    Date.now(), tracker, positionError, domElementId, dataModels.model.get('tab'),//@vmohapatra TODO :getLobType
                    TypeaheadUtils.getTAExperimentTreatmentAssignments(corewizard)));
            }
        }

        var suggestion = taState.getSelectedSuggestion();

        var model = dataModels.state;
        var deferredGeolocation;
        var geolocationMetricsTracker;
        var promiseForGeolocationLiteral = "promiseForGeolocation";
        var currentLob = getLob(dataModels.model.get('tab'), dataModels.model.get('packages'));

        //Set the source info for each Typeahead selection. Default is null / undefined
        model.set('destinationSourceInfo', suggestion.getEssId().get());

        //Set the relation info if present
        model.set('destinationRelInfo', suggestion.getRelationInfo().get());


        if (searchExperiments.getVariant("CURRENT_LOCATION")) {

            if (suggestion.getType().get() === 'GEOLOCATION') {
                if (_.isObject(navigator.geolocation)) {
                    // Use the jQuery Deferred() mechanism to create a
                    // Promise object to store as a wizard state property.
                    deferredGeolocation = $.Deferred();
                    TypeaheadGeolocationMeasurementsLogger.getInstance();

                    geolocationMetricsTracker = TypeaheadUtils.generateTracker();
                    publishGeolocationBeginMeasurement(geolocationMetricsTracker);
                    // Ask HTML5 API for current location. This API can take quite a while so we
                    // 'store' off a Promise object that represents the eventual results of the call as a property
                    // on in the wizard state store.
                    // NOTE
                    // This call triggers a browser dialog the initial time the call is made and the user is asked if they
                    // want to allow expedia.com to access their geolocation. There's no way to know when that is however.
                    // But when it does happen, the browser window deactivates and loses keyboard focus. After the dialog
                    // is closed, the browser reactivates the window. This reactivation triggers a focus event. If the user
                    // selected
                    navigator.geolocation.getCurrentPosition(
                        function(position) {
                            publishGeolocationEndSuccessMeasurement(geolocationMetricsTracker, position);
                            deferredGeolocation.resolve(position);
                        },
                        function(positionError) {
                            publishGeolocationEndErrorMeasurement(geolocationMetricsTracker, positionError);
                            deferredGeolocation.reject(positionError);
                        },
                        {
                            enableHighAccuracy: true,
                            timeout: 5000,
                            maximumAge: 0
                        });

                    // store the Promise object on the wizard state object
                    model.set(promiseForGeolocationLiteral, deferredGeolocation.promise());
                }
                else {
                    // Browser does not support geolocation. Do nothing.
                }
            }
        }

        if (suggestion.getCategory().isPresent() && suggestion.getCategory().get() === "USERHISTORY") {
            setCoreWizardFields(
                RecentHistoryOptionsInjector.extractCoreWizardStateFromHistoryForHotel(
                suggestion.getEssId().get(), suggestion.getRegionNames().get()),
                getLob(dataModels.model.get('tab'), dataModels.model.get('packages'))
            );
        }
        else {
            if('HOTEL' == suggestion.getType().get()) {
                model.set('hotelId', suggestion.getHotelId().get());
                model.set('destSuggestionTypeId', suggestion.getTypeId().get());
                model.set('city', suggestion.getCity().get());
                model.set('destinationTLA', suggestion.getTla().get());
                model.set('multiCityRegion', suggestion.getMultiCity().get());
            }
            else{
                model.set('hotelId', null);
                model.set('destSuggestionTypeId', suggestion.getTypeId().get());
            }
        }

        if (suggestion.getSubType().isPresent()) {
            if (suggestion.getType().get()==='ADDRESS' || suggestion.getType().get()==='POI') {
                model.set('TASearchType', suggestion.getSubType().get());
                model.set('TADestSearchType', suggestion.getSubType().get());
                model.set('excludeGaiaId','true');
            } // this is especially for BUC HLR, in Omniture logging, we need to log its subType, but in HSRP, we need to both send its GAIAID and lat-long
            else if (suggestion.getType().get()==='MULTIREGION') {
                model.set('TASearchType', suggestion.getSubType().get());
                model.set('TADestSearchType', suggestion.getSubType().get());
            } // for Type 4 NBHs (ESS experiment 11374 CWTA_AirportIconForNBHDs)
              // https://eiwork.mingle.thoughtworks.com/projects/ewe_discovery_services/cards/3292
            else if (suggestion.getType().get()==='NEIGHBORHOOD' && suggestion.getSubType().get()==='AIRNBH') {
                model.set('TASearchType', 'AIRNBH');
                model.set('TADestSearchType', 'AIRNBH');
            }
        }
        else if(currentLob === 'hotel' && suggestion.getType().get()=='ADDRESS')
        {
            model.set('TASearchType', suggestion.getSubType().isPresent() ?
                suggestion.getSubType().get() : suggestion.getType().get());
            model.set('TADestSearchType', suggestion.getSubType().isPresent() ?
                suggestion.getSubType().get() : suggestion.getType().get());
        }
        else if(searchExperiments.getSearchExperimentVariant('11582') !== '0' && suggestion.getCategory().get()=='USERHISTORY')
        {
            model.set('TASearchType', 'USERHISTORY');
            model.set('TADestSearchType', 'USERHISTORY');
        }
        else
        {
            model.set('TASearchType', suggestion.getType().get());
            model.set('TADestSearchType', suggestion.getType().get());
        }

        model.set('OMHotelTA', true);
        if(model.get('hotelId') != undefined) {
            model.set('regionId', undefined);
        }
        else {
            model.set('regionId', suggestion.getRegionId().get());
        }

        //For Themes since they don't have coordinate information, don't set it in the model
        if(suggestion.getLatLong().isPresent())
        {
            //vmohapatra: HSRP requires latLong param to be sent in lat,long format. Domain can handle both comma and space
            model.set('latLong', suggestion.getLatLong().get());
        }
        if(suggestion.getRegionNames().isPresent()) {
            //model.set('destinationFromTA', data.regionNames.fullName);
            //vmohapatra : Since lastSearchName is used as searchText :
            //in order to keep destination and destinationFromTA in sync always use lastSearchName to populate destinationFromTA
            //
            //model.set('destinationFromTA', Typeahead.decodeHtmlCharacterEntities(data.regionNames.lastSearchName));
            model.set('destinationTLA', null);
            if (searchExperiments.getVariant("BEST_DEALS_OPTION") && data.type === "DEALS") {
                model.set('destination',
                    Typeahead.decodeHtmlCharacterEntities(suggestion.getRegionNames().get().lastSearchName));
            }
        }
        model.set('selectedTASuggestionPosition', suggestion.getPosition().get());

        if(suggestion.getRegionMetadata().isPresent()) {
            if (suggestion.getRegionMetadata().get().redirect && corewizard.masterconfig.trivagoRedirectionEnabled) {
                model.set('redirectionURL', suggestion.getRegionMetadata().get().redirect);
                if (dctk) {
                    var linkID = 'LTC.NHP.ItemSelected';
                    dctk.trackAction(linkID, item, {prop16:linkID,eVar28:linkID,eVar18:'Homepage'});
                }
            }
        }

        model.set('suggestionType', suggestion.getSuggestionHierarchyType().get());
        model.set('hasChild', suggestion.getHasChild().get());

        if (ab3291status.value === 1) {
            if (!model.get('noDate')) {
                corewizard.helpers.openCalendarField('startDate');
            }
        }

        if (searchExperiments.getVariant("BEST_DEALS_OPTION") && suggestion.getSort().isPresent()) {
            model.set('sort', suggestion.getSort().get());
        }

        if(
            searchExperiments.getSearchExperimentVariant('11582') !== '0' &&
            suggestion.getCategory().get() === "USERHISTORY"
        ) {
            var  currTimestamp = new Date();
            var timeData = suggestion.getTimestamp().isPresent()? new Number(suggestion.getTimestamp().get()) : '-';
            if(!isNaN(timeData)) {
                var age = currTimestamp - new Date(timeData);
                model.set('userHistoryItemAge',age);
            }
        }

        if (searchExperiments.getVariant("CURRENT_LOCATION") &&  suggestion.getType().get() === 'GEOLOCATION') {
            // repaint the form with all the new model fields set
            corewizard.core.reloadTab();

            // signal "User your current location" option was selected
            uitk.publish('typeahead.currentLocationSelected');
        }

        //vmohapatra : If selected suggestion does not have lat long information, set it to null in model
        // http://jira/jira/browse/ECOMSVC-2010
        if(!suggestion.getLatLong().isPresent()) {
            model.set('latLong', null);
        }
    }

    function typeaheadInputEditedCallback(newValue) {
        var model = dataModels.state;

        model.set('regionName', null);
        model.set('destinationTLA', null);
        model.set('hotelId', null);
        model.set('multiCityRegion', null);
        model.set('regionId', null);
        model.set('latLong', null);
        model.set('OMDestinationTA', false);
        model.set('TASearchType', null);
        model.set('destination', newValue);
    }

    return {
        typeaheadItemClickCallback: typeaheadItemClickCallback,
        typeaheadCarPickUpCallback: typeaheadCarPickUpCallback,
        typeaheadCarDropOffCallback: typeaheadCarDropOffCallback,
        typeaheadFlightOriginCallback: typeaheadFlightOriginCallback,
        typeaheadFlightDestinationCallback: typeaheadFlightDestinationCallback,
        typeaheadPackageOriginCallback: typeaheadPackageOriginCallback,
        typeaheadPackageDestinationCallback: typeaheadPackageDestinationCallback,
        typeaheadActivityCallback: typeaheadActivityCallback,
        typeaheadOpenSearchCallback: typeaheadOpenSearchCallback,
        typeaheadMultiFlightDestinationCallback: typeaheadMultiFlightDestinationCallback,
        multiFlightHelper: multiFlightHelper,
        typeaheadRailOriginCallback: typeaheadRailOriginCallback,
        typeaheadRailDestinationCallback: typeaheadRailDestinationCallback,

        //callbacks for uTA
        typeaheadSuggestionSelectedCallback: typeaheadSuggestionSelectedCallback,
        typeaheadInputEditedCallback: typeaheadInputEditedCallback
    }
});

/*global $, _, Modernizr, ab3291status, uitk */

;var corewizard = corewizard || {};

require(['gc/dataModels'], function(dataModels) {
    'use strict';

    $.extend(corewizard, {
        helpers : {
            unCheckNoDates : function() {
                var target = $('[data-wizard-type="noDate"]');
                if ($(target) && $(target).is(':checked')) {
                  $(target).prop('checked', false);
                }
            },
            isHotelsOnly : function() {
                var model = dataModels.state;
                return model.get('tab') == 'hotel' &&
                    !(model.get('packages.flight') || model.get('packages.car'));
            },
            elementIsHotelDepartingField : function(el) {
                return el.attr('data-wizard-action').indexOf('"startDate"') > -1 && this.shouldOpenCalendar('endDate');
            },
            shouldOpenCalendar : function(fieldType) {
                return this.isHotelsOnly() && this.isCalendarFieldValueDefault(fieldType);
            },
            isCalendarFieldValueDefault : function(fieldType) {
                var value = dataModels.model.get(fieldType);
                return typeof value === 'undefined' || value === null || value === '';
            },
            getWizardFieldByType : function(type) {
                var actionFields = $('[data-wizard-action]:visible');
                return _.find(actionFields, function(item) {
                    var field = $(item);
                    if (field.attr('data-wizard-action').indexOf('"' + type + '"') > -1) {
                        return true;
                    }
                });
            },

            openCalendarField : function(fieldType) {
                var hasTouch = Modernizr.touch,
                    hasWin8Touch = Modernizr.win8touch;
                if (hasTouch || hasWin8Touch) {
                    shiftFocus(this.getWizardFieldByType(fieldType), 100);
                } else {
                    shiftFocus(this.getWizardFieldByType(fieldType));
                }
            }

        }
    });
});

//uncheck "I don't know my dates" checkbox if a user types something into a date field or chooses a date from the calendar picker



var corewizard = corewizard || {};
corewizard.searchTracking = corewizard.searchTracking || {};

require([
  'gc/importedState',
  'gc/searchExperiments',
  'gc/conf',
  'env',
  'gc/getLob'
], function (
  importedState,
  searchExperiments,
  conf,
  env,
  getLob
) {
    //Default function to track valid search submit
    corewizard.searchTracking.trackValidSearch = function (model) {

        /*TnL Experiment #3397 [rWeb] migrate GC to uTA TA in S/F of responsive web - HOTELS LOB */
        if(searchExperiments.getVariant('uTA_HOTELS') !== 0 ) {

            trackValidSearchUsingUTA(model);
        }

        else {
            var isMultiOrOneWay = model.get('flighttype') === 'multi' || model.get('flighttype') === 'oneway';
            var organicPackageIsOpen = $('[data-tid="hotel-added-flight"]').is(':visible');

            // Is this LOB opensearch ; track events with different ids using opensearch specific functions
            if(getLob(model.get('tab'), model.get('packages')) == 'opensearch'){
                trackEvent(getDetailedTrackingDataForOpenSearch(model, true), getOpenSearchEvtStr(model));
            }
            else {
                var detailedTrackingData = getDetailedTrackingData(model, true);
                var evtStr = getEvtStr(model);
                if (!isMultiOrOneWay && !organicPackageIsOpen) {
                    trackEvent(detailedTrackingData.trackingData, evtStr, detailedTrackingData.staticExperimentData);
                }

                //This is to add instrumentation for one way or multi destination flights
                if(isMultiOrOneWay){
                    trackEvent(detailedTrackingData.trackingData, evtStr, detailedTrackingData.staticExperimentData);
                }
            }
        }
    };

    //Default function to track invalid search submit
    corewizard.searchTracking.trackInvalidSearch = function (model) {
        trackEvent(getDetailedTrackingData(model, false));
    };

    //Default function to send dctk track event function for core wizard
    //Optional param : svcExperimentData
    function trackEvent(trackingData, eventStr, svcExperimentData) {
        var staticExperimentData = {
            exposedExperiments: svcExperimentData
        };
        try {
            if(staticExperimentData.exposedExperiments && staticExperimentData.exposedExperiments != null) {
                dctk.addExperiments(staticExperimentData.exposedExperiments);
            }
            dctk.trackEvent('o', 'wizard-submit', trackingData, eventStr);
        } catch (e) {}
    }

    //TODO: Create a helper in uTA to get the trackingData
    function trackValidSearchUsingUTA(model) {

        require("universalTypeahead", function(uTA) {

            if(importedState.hasImportData()) {
                var previousData = {
                    destination : model.get('destination')
                };
            }

            var trackingData = uTA.getTrackingData(getBasicReport(model),
                getLob(model.get('tab'), model.get('packages')), previousData)

            var staticExperimentData = model.get('activeESSTests') ? model.get('activeESSTests') : null;

            trackEvent(trackingData, trackingData.eventString, staticExperimentData);
        }, function(error){});
    }

//****************************************************************************************
//***********************************Default Submit Logging*******************************
//****************************************************************************************

    //Function to capture basic referrer data in the format "LaunchView.SrchWzd.Tab.LOB.Locale.SiteId"
    function getBasicTrackingData(model) {
        var basicInfo = getBasicReport(model);
        return {
            prop16: basicInfo,
            eVar28: basicInfo
        };
    }

    //Function used to capture detailed search data ie. Typeahead related
    function getDetailedTrackingData(model, valid) {
        var detailedInfo = getDetailedReport(model, valid);
        var trackingData = {
            prop16: detailedInfo,
            eVar28: detailedInfo
        };

        var staticExperimentData = model.get('activeESSTests') ? model.get('activeESSTests') : null;

        if (valid) {
            //Record the timestamp at which a valid search was determined
            var currTimestamp = new Date();
            //Set the user typed text    in prop74
            trackingData.prop74 = '"' + ( model.get('userTypedQuery') || '' ) + '"' ;

            //vmohapatra : Preserve sourceName:sourceID|suggestionType|destination for multiflights
            if(getLob(model.get('tab'), model.get('packages'))=='flight' && model.get('flighttype') === 'multi')
            {
                //Enable default logging for origin and destination flights in Multi flight type
                //Add multiFlightDestinations to eVar48
                var multiFlightDestinations = model.get('multiDest').destination || model.get('multiFlightDestination');
                //Add multiFlightOrigins to prop73
                var multiFlightOrigins = model.get('multiDest').origin || model.get('multiFlightOrigin');

                var multiFlightDestSuggIds = model.get('multiFlightDestSuggTypeId');
                var multiFlightOrigSuggIds = model.get('multiFlightOrigSuggTypeId');

                var multiDestFieldInfo = model.get('multiFlightDestSrc');
                var multiOrigFieldInfo = model.get('multiFlightOrigSrc');

                var multiDestFieldType = model.get('multiFlightDestSuggType');
                var multiOrigFieldType = model.get('multiFlightOrigSuggType');

                //TODO vmohapatra: Consuming relation info for multi destination fields (Which variable to store in Omniture)
                var multiDestFieldRel = model.get('multiFlightDestRel');
                var multiOrigFieldRel = model.get('multiFlightOrigRel');

                var destCount = 0, 
                    destStr = [], 
                    origCount = 0, 
                    origStr = [], 
                    destIDStr = ['-','-','-','-'], 
                    origIDStr = ['-','-','-','-'],
                    destSrcStr = ['-:-', '-:-', '-:-', '-:-'],
                    origSrcStr = ['-:-', '-:-', '-:-', '-:-'],
                    destTypeStr = ['-','-','-','-'],
                    origTypeStr = ['-','-','-','-'],
                    multiDestTrackStr = '',
                    multiOrigTrackStr = '',
                    dest1Str = '',//First destination in multi flights sub LOB
                    orig1Str = '';//First origin in multi flights sub LOB

                for(key in multiFlightDestinations)
                {
                    destStr[destCount] = multiFlightDestinations[key];
                    destCount++;
                }

                for(key in multiFlightOrigins)
                {
                    origStr[origCount] = multiFlightOrigins[key];
                    origCount++;
                }

                for(key in multiFlightDestSuggIds)
                {
                    destIDStr[key] = multiFlightDestSuggIds[key];
                }

                for(key in multiFlightOrigSuggIds)
                {
                    origIDStr[key] = multiFlightOrigSuggIds[key];
                }

                for(key in multiDestFieldInfo)
                {
                    destSrcStr[key] = formatSourceInfo (multiDestFieldInfo[key]);
                }

                for(key in multiOrigFieldInfo)
                {
                    origSrcStr[key] = formatSourceInfo (multiOrigFieldInfo[key]);
                }

                for(key in multiDestFieldType)
                {
                    destTypeStr[key] = multiDestFieldType[key] ? multiDestFieldType[key] : '-';
                }

                for(key in multiOrigFieldType)
                {
                    origTypeStr[key] = multiOrigFieldType[key] ? multiOrigFieldType[key] : '-';
                }

                //Create the multi destination tracking str
                for(destCount = 0; destCount <= 3; destCount++ ) {
                    if(multiDestTrackStr == '') {
                        multiDestTrackStr = destSrcStr[destCount]+'|'+destTypeStr[destCount];
                    }
                    else {
                        multiDestTrackStr += '#'+destSrcStr[destCount]+'|'+destTypeStr[destCount];
                    }
                }

                //Create the multi origin tracking str
                for(origCount = 0; origCount <= 3; origCount++ ) {
                    if(multiOrigTrackStr == '') {
                        multiOrigTrackStr = origSrcStr[origCount]+'|'+origTypeStr[origCount];
                    }
                    else {
                        multiOrigTrackStr += '#'+origSrcStr[origCount]+'|'+origTypeStr[origCount];
                    }
                }

                dest1Str = _.compact([

                    //Set the sourceName:sourceId for destination field info variable
                    formatSourceInfo (model.get('destinationSourceInfo')),

                    //Set the suggestion type for destination field info variable
                    model.get('TADestSearchType') ?
                            model.get('TADestSearchType')
                            : '-'

                ]).join('|');

                orig1Str = _.compact([

                    //Set the sourceName:sourceId for origin field info variable
                    formatSourceInfo (model.get('originSourceInfo')),

                    //Set the suggestion type for origin field info variable
                    model.get('TAOrigSearchType') ?
                            model.get('TAOrigSearchType')
                            : '-'

                ]).join('|');

                multiDestTrackStr = _.compact([
                    dest1Str,
                    multiDestTrackStr
                ]).join('#');

                multiOrigTrackStr = _.compact([
                    orig1Str,
                    multiOrigTrackStr
                ]).join('#');

                //Track the sourceName:sourceId|suggestionType info delimited by '#' for multi destination flights
                trackingData.eVar48 = multiDestTrackStr;
                trackingData.prop73 = multiOrigTrackStr;

                //Special case :Track the multi origin and destination field strings in prop74
                trackingData.prop74 += '.'+ _.compact([
                                                model.get('originFromTA') || model.get('origin'),
                                                origStr.join('#')
                                            ]).join('#') + '.'
                                        + _.compact([
                                                model.get('destinationFromTA') || model.get('destination'),
                                                destStr.join('#')
                                            ]).join('#');

            }
            else
            {
                var lineOfBiz = getLob(model.get('tab'), model.get('packages'));
                var destFieldInfo = '';
                var origFieldInfo = '';

                destFieldInfo = _.compact([

                    //Set the sourceName:sourceId for destination field info variable
                    formatSourceInfo (model.get('destinationSourceInfo')),

                    //Set the suggestion type for destination field info variable
                    model.get('TADestSearchType') ?
                            model.get('TADestSearchType')
                            : '-',

                    //Set the relation info
                    'R#'+ (model.get('destinationRelInfo') ? model.get('destinationRelInfo') : '-'),

                    //Set the destination field text value in the info variable
                    lineOfBiz=='car'?
                            model.get('carPickupValueFromTA') || model.get('pickup') || 'TANoneSelected'
                            : model.get('destinationFromTA') || model.get('destination') || 'TANoneSelected'

                ]).join('|');

                origFieldInfo = _.compact([

                    //Set the sourceName:sourceId for origin field info variable
                    formatSourceInfo (model.get('originSourceInfo')),

                    //Set the suggestion type for origin field info variable
                    model.get('TAOrigSearchType') ?
                            model.get('TAOrigSearchType')
                            : '-',

                    //Set the relation info
                    'R#'+ (model.get('originRelInfo') ? model.get('originRelInfo') : '-'),

                    //Set the destination field text value in the info variable
                    lineOfBiz=='car'?
                            (
                                model.get('selectedTASuggestionPosition') && model.get('carReturn') ?
                                    model.get('carDropoffValueFromTA')
                                    : model.get('carReturn')
                            ) || 'TANoneSelected'
                            : lineOfBiz=='hotel' || lineOfBiz=='activity' || lineOfBiz=='hotelCar' ?
                                    'OriginNotApplicable' :
                                    model.get('originFromTA') || model.get('origin') || 'TANoneSelected'
                ]).join('|');

                trackingData.eVar48 = destFieldInfo;
                trackingData.prop73 = origFieldInfo;

                //Add the search by user timestamp of the selected typeahead item to prop74,if user history experiments are on
                //if age data is available from Scratchpad response
                //irrespective of whether User history suggestions shown
                if(
                    ( searchExperiments.getSearchExperimentVariant('11582') !== '0')
                ) {
                    var metaData = model.get('taMetadata');
                    var timeData;

                    //userHistoryOldestTimestamp is included in metadata 
                    //if we have info from recent history injector getOldestTimeStampInfo()
                    //It exposes the age of the entire user history retrieved from Scratchpad
                    //For "Hotel" and "Flight" LOB

                    if(lineOfBiz == 'hotel') {
                        timeData = metaData ?
                                        (metaData.userHistoryOldestTimestamp ? metaData.userHistoryOldestTimestamp['hotel'] : '-')
                                        : '-';
                    }
                    else if(lineOfBiz == 'flight') {
                        timeData = metaData ?
                                        (metaData.userHistoryOldestTimestamp ?
                                            (metaData.userHistoryOldestTimestamp['flight'] ? metaData.userHistoryOldestTimestamp['flight'][model.get('flighttype')] : '-')
                                            : '-'
                                        )
                                        : '-';
                    }

                    //Add to prop74 only if the timeData is a number
                    if(!isNaN(timeData)) {
                        var durationData = getDuration(currTimestamp - new Date(timeData));
                        //Add the age of the user history for the LOB
                        trackingData.prop74 += '.'+durationData;
                    }

                }

                //Add the cruise filters (CRUISE|CDES|CLIN|DPOR|DMON|CLEN) to evar47
                var cruiseFiltersEvar47 = model.get("cruiseFiltersEvar47");
                if(cruiseFiltersEvar47) trackingData.eVar47 = cruiseFiltersEvar47;

            }
        }
        return {'trackingData' : trackingData, 'staticExperimentData' : staticExperimentData };
    }

    //Function to generate Typeahead related event string
    function getEvtStr(model) {
        if (getTAShow(model) !== 'TANoShow') {
            var selectedItemPosition = model.get('selectedTASuggestionPosition');
            var userTypedQuery = model.get('userTypedQuery');
            var eventStr = "event45";

            if(userTypedQuery && userTypedQuery.toString() != 'NaN') {
                eventStr = 'event46=' + userTypedQuery.length + ',' + eventStr;
            }
            else {
                eventStr = 'event46=0,' + eventStr;
            }

            if (selectedItemPosition && selectedItemPosition.toString() != 'NaN') {
                eventStr = 'event44=' + selectedItemPosition + ',' + eventStr;
            }
            return eventStr;
        }
    }

    //Util function to get basic submit data for search wizard
    function getBasicReport(model) {
        var parts = [
            getLaunchView(),
            'SrchWzd',
            getTab(model),
            getShortLob(model),
            env.locale,
            env.siteId
        ];
        return _.compact(parts).join('.');
    }

    //Util function to get detailed submit data for search wizard
    //Adds typeahead related data only for valid search submission
    function getDetailedReport(model, valid) {
        return [
            getBasicReport(model),
            valid ? getTADetails(model) : 'Form-Invalid'
        ].join('.');
    }

    //Util function to get launch view
    function getLaunchView() {
        var LOBMap = {
            hotel: 'HTL',
            flight: 'FLT',
            'package': 'PKG',
            car: 'CAR',
            activity: 'LX',
            cruise: 'CRU'
        };
        var omnitureSubmitCode = conf.wizardconfig && conf.wizardconfig.omnitureSubmitCode;
        return omnitureSubmitCode && LOBMap[omnitureSubmitCode] ?
            LOBMap[conf.wizardconfig.omnitureSubmitCode] :
            'Home';
    }

    //Util function to get wizard tab
    function getTab(model) {
        var tabMap = {
            flight: 'Flights',
            hotel: 'Hotel',
            'package': 'Package',
            car: 'Car',
            cruise: 'Cruise',
            activity: 'Activity',
            buses: 'Bus',
            rail: 'Rail'
        };
        return tabMap[model.get('tab')];
    }

    //Util function to get LOB in search wizard
    function getShortLob(model) {
        var lobMap = {
            flight: 'F',
            flightHotel: 'FH',
            flightCar: 'FC',
            flightHotelCar: 'FHC',
            hotel: 'H',
            hotelCar: 'HC',
            car: 'C',
            cruise: null,
            activity: 'LX',
            buses: 'RedBus',
            rail: 'RL'
        };

        var flightTypeMap = {
                roundtrip: 'RT',
                oneway: 'OW',
                multi: 'MD'
        };

        var lineOfBiz = getLob(model.get('tab'), model.get('packages'));
        return lineOfBiz == 'flight' ?
                _.compact([ lobMap[lineOfBiz], flightTypeMap[model.get('flighttype')] ]).join('.') :
                lobMap[lineOfBiz] ;

    }

    //Function to get Typeahead related details eg: Typeahead trigger and instrumentation
    function getTADetails(model) {
        var TAShow = getTAShow(model);
        var customInstrumentation = getInstrumentationValue(model);
        var instrumentationValue = TAShow !== 'TANoShow' ?
            customInstrumentation :
            importedState.hasImportData() ?
                'TAPrevSearch' :
                '';

        if(instrumentationValue == 'TAPrevSearch')
        {
            instrumentationValue += customInstrumentation ? '.'+customInstrumentation : '';
        }

        var parts = [
            TAShow,
            instrumentationValue
        ];
        return _.compact(parts).join('.');
    }

    //Util function to capture the Typeahead triggers
    function getTAShow(model) {
        var renderedTA = !!corewizard.OMTypeAheadRendered;

        if (!renderedTA)
        {
            return 'TANoShow';
        }
        else
        {
        //TAShow.TAFocus : If Typeahead is shown and a particular TASearchType is selected from the suggestions
        //TODO : TAShow.TAPrevSearch : If Typeahead is shown, but the user submitted previously populated search text without selection
        //TAShow.TASelection : If Typeahead is shown and user selects from the shown suggestions
        //TAShow.TANoSelection : If Typeahead is shown and user submits a manual search query not equal to previously populated search text
        //TODO : Include check for whether matches with importedStateData

            var trigger = 'TAShow';

            if(
                _.contains(['TRENDINGSEARCH'], model.get('TASearchType'))
                && model.get('selectedTASuggestionPosition')
            )
            {
                //TAShow.TAFocus : If Typeahead is shown and a particular TASearchType is selected from the suggestions
                trigger += '.TAFocus';
            }
            else if(model.get('selectedTASuggestionPosition'))
            {
                if (model.get('userTypedQuery') === '') {
                    trigger += '.TAFocus';
                }
                else {
                    //If a typeahead item was selected, we would have selected item position
                    //TAShow.TASelection : If Typeahead is shown and user selects from the shown suggestions
                    trigger += '.TASelection';
                }
            }
            else
            {
                //TAShow.TANoSelection : If Typeahead is shown and user submits a manual search query not equal to previously populated search text
                trigger += '.TANoSelection';
            }

            return trigger;
        }

    }

    //Util function to get custom instrumentation for Typeahead
    function getInstrumentationValue(model) {
        var metaData = model.get('taMetadata');

        return _.compact([

            //Vijayalaxmi Mohapatra (vmohapatra) : Abbreviate the tag names as per below
            //ST = Selected Suggestion Type
            //L = Level of selection
            //ESS = Number of suggestions sent by ESS, This is always present as ESS is the primary service provider for TA
            //UH = Number of suggestions from user history
            //UHA = Selected user history item's age

            //Hierarchy info or Level of selection from the suggestions shown for LOBs other than hotel or flight
            _.contains(['flight', 'hotel'], getLob(model.get('tab'), model.get('packages'))) ?
                instrumentHierarchicalDisplay(model) :
                'L#' + (model.get('selectedTASuggestionPosition') ? model.get('selectedTASuggestionPosition') : '-'),

            //Search Type
            //'ST#' + (model.get('TASearchType') ? model.get('TASearchType') : '-'),

            //ESS Suggestions shown
            'ESS#' + (model.get('essItemsTotal') ? model.get('essItemsTotal') : '0'),

            //User history suggestions shown if user history experiments are on
            (searchExperiments.getSearchExperimentVariant('11582') !== '0') ?
            'UH#' + (model.get('userHistoryItemsTotal') ? model.get('userHistoryItemsTotal') : '0') :
            '',

            //Capture selected User History Item Age if the experiment is ON
            (searchExperiments.getSearchExperimentVariant('11582') !== '0') ?
            'UHA#' + (model.get('userHistoryItemAge') ? (getDuration(model.get('userHistoryItemAge')) ? getDuration(model.get('userHistoryItemAge')) : '-') : '-') :
            '',

            //Trending Search suggestions shown if experiment is ON
            (searchExperiments.getSearchExperimentVariant('10614') !== '0') ?
            'RX#'+(metaData ? (metaData.recommenderOptionsRendered ? metaData.recommenderOptionsRendered : '0') : '0') :
            ''
        ]).join('.');
    }

    //Util function to capture hierarchy related data
    function instrumentHierarchicalDisplay(model) {
        //Send the new instrumentation only for hotel LOB
        //C0 indicates item is parent
        //C1 indicates item is child
        //P0 indicates item has no child
        //P1 indicates item has child
        //L indicates level of item selected
        var hierarchyCode = '';
        if (model.get('suggestionType') === 'child')
        {
            // a child cannot have children
            hierarchyCode = 'P0C1';
        }
        else if (model.get('suggestionType') === 'parent' && model.get('hasChild'))
        {
            hierarchyCode = 'P1C0';
        }
        else
        {
            //Default hierarchy code : has no Children, is a parent
            hierarchyCode = 'P0C0';
        }

        var positionInfo = model.get('selectedTASuggestionPosition') ? model.get('selectedTASuggestionPosition') : '-';
        return hierarchyCode + 'L' + positionInfo;
    }

    //Utility function to convert milliseconds into readable format of days:hours:minutes:seconds:milliseconds
    function getDuration(ms) {
        //return undefined if a non-number or a null param is passed
        if(ms && isNaN(ms)) { return; }

        var days = Math.floor(ms / (24*60*60*1000)); //86,400,000ms
        var daysms=ms % (24*60*60*1000);

        var hours = Math.floor((daysms)/(60*60*1000));//3,600,000ms
        var hoursms=ms % (60*60*1000);

        var minutes = Math.floor((hoursms)/(60*1000));//6,000ms
        var minutesms=ms % (60*1000);

        var sec = Math.floor((minutesms)/(1000));//1,000ms
        var secms = ms % 1000;

        var millis = Math.floor((secms)/(1));

        return days+"d:"+hours+"h:"+minutes+"m:"+sec+"s:"+millis+"ms";
    }

    //Utility function to set the string with info sourceName:SourceID
    function formatSourceInfo(obj) {
        var returnStr = obj ?
                            (
                                ( obj.sourceName ? obj.sourceName : '-') 
                                + ':'
                                + ( obj.sourceName==="GPA" ?
                                    (
                                        '-'
                                    )
                                    : obj.sourceId ? obj.sourceId : '-')
                            )
                            : '-:-' ;
        return returnStr;
    }
//****************************************************************************************
//***********************************Default Submit Logging*******************************
//****************************************************************************************

});

var corewizard = corewizard || {};
corewizard.searchTracking = corewizard.searchTracking || {};

require([
         'gc/importedState',
         'gc/searchExperiments',
         'gc/conf',
         'env',
         'gc/getLob',
         'gc/abTest'
       ], function (
         importedState,
         searchExperiments,
         conf,
         env,
         getLob,
         abTest
       ) {
    //Default function to track valid search submit
    corewizard.searchTracking.trackValidOpenSearch = function (model) {
     var trackingData = getDetailedTrackingDataForOpenSearch(model, true);
     var eventStr = getOpenSearchEvtStr(model);
     if ((typeof dctk != "undefined") && (typeof dctk.trackEvent == "function")) {
        dctk.trackEvent('o', 'wizard-submit', trackingData, eventStr);
     }
    }
    //Function to generate Open search Typeahead related event string
    // Use event145 : user typed query ,
    // event146 : query length ,
    // event 144 : selected item position
    function getOpenSearchEvtStr(model) {
        if (!!corewizard.OMTypeAheadRendered) {    // was typeahead rendered
            var selectedItemPosition = model.get('selectedTASuggestionPosition');
            var userTypedQuery = model.get('userTypedQuery');
            var eventStr = "event145";

            if (userTypedQuery && userTypedQuery.toString() != 'NaN') {
                eventStr = 'event146=' + userTypedQuery.length + ',' + eventStr;
            } else {
                eventStr = 'event146=0,' + eventStr;
            }

            if (selectedItemPosition && selectedItemPosition.toString() != 'NaN') {
                eventStr = 'event144=' + selectedItemPosition + ',' + eventStr;
            }

            return eventStr;
        }
    }

    //Function used to capture detailed open search typeahead data
    function getDetailedTrackingDataForOpenSearch(model, valid) {

        var parts = [
                    'Home',
                    'SrchWzd',
                    "OpenSearch",
                    "OS",
                    corewizard.masterconfig.locale,
                    site_id
                    ];

        var basicReport = _.compact(parts).join('.');
        var detailedReport = getOpenSearchTADetails(model);

        var detailedInfo = basicReport +'.' + detailedReport ;

        var trackingData = {
            prop16: detailedInfo,
            eVar28: detailedInfo
        };

        //set LOB of entry selected in eVar48
        trackingData.eVar48 = model.get('TASearchType');
        //Set the user typed text    in prop74
        trackingData.prop74 = '"' + ( model.get('userTypedQuery') || '' ) + '"' ;

        return trackingData;
    }

    //Function to get Open search Typeahead related details
    function getOpenSearchTADetails(model) {
        var TAShow = getOpenSearchTAShow(model);
        var instrumentationValue = getOpenSearchInstrumentationValue(model) ;

        var parts = [
            TAShow,
            instrumentationValue
        ];
        return _.compact(parts).join('.');
    }

    //Function to capture if Open Search Typeadhead was shown
    function getOpenSearchTAShow(model) {
        var renderedTA = !!corewizard.OMTypeAheadRendered;
        var typeaheadService = (abTest.get(10406).value == "2") ? 'Gemma' : 'TA' ;

        if (!renderedTA)
        {
            return typeaheadService+'NoShow';
        }
        else
        {
        //TAShow.TAFocus : If Typeahead is shown and a particular TASearchType is selected from the suggestions
        //TAShow.TASelection : If Typeahead is shown and user selects from the shown suggestions
        //TAShow.TANoSelection : If Typeahead is shown and user submits a manual search query not equal to previously populated search text
            var trigger = typeaheadService+'Show';

            if(model.get('selectedTASuggestionPosition'))
            {
                //If a typeahead item was selected, we would have selected item position
                //TAShow.TASelection : If Typeahead is shown and user selects from the shown suggestions
                trigger += '.'+typeaheadService+'Selection';
            }
            else
            {
                //TAShow.TANoSelection : If Typeahead is shown and user submits a manual search query not equal to previously populated search text
                trigger += '.'+typeaheadService+'NoSelection';
            }
            return trigger;
        }
    }

    //Util function to get custom instrumentation for Open Search Typeahead
    function getOpenSearchInstrumentationValue(model) {

        var data = model.get('openSearchQueryData') || {} ;
        return _.compact([

            //ST = SearchType, region type of the entry selected
            'ST#' + (data.regionType)? data.regionType : '-',

            //QL = User typed query length
            'QL#' +    (model.get('userTypedQuery') ? model.get('userTypedQuery').length : '0'),

            //SS = Number of suggestions sent by SS - suggest service
            'SS#' + (model.get('essItemsTotal') ? model.get('essItemsTotal') : '0'),

            //LOB = Line of business of the entry selected as sent back by suggest service
            //For Gemma always gemma , for ESS if something was choosen by user that LOB otherwise -

            'LOB#' + (model.get('TASearchType') ? model.get('TASearchType') : '-')

        ]).join('.');
    }
});

/*
In core.js, corewizard.core.submit calls Submit.submit from this file. Handles form submit logic.
deps: corewizard, corewizard.validator, SubmitTracking, jQuery, uitk, dctk
*/

function setDefaultForRoomOneAdults() {
  'use strict';

  require(['gc/dataModels', 'gc/getLob'], function(dataModels, getLob) {
    var model = dataModels.model;
    var state = dataModels.state;
    // applies the desired default (2 for searches involving hotels, 1 for others) to the wizardModel unless the value has already been set by the user
    if (!model.get('rooms[0].adults') || model.get('rooms[0].adults') < 0) {
      if (model.get('tab') === 'hotel' ||
        model.get('packages.hotel') ||
        model.get('tab') === 'threePP') {
        state.set('rooms[0].adults', 2);
      } else {
        state.set('rooms[0].adults', 1);
      }
    }
  });
}

define('gc/Submit', [
  'gc/importedState',
  'gc/search',
  'gc/dataModels',
  'gc/localStorage',
  'gc/validate',
  'gc/getLob',
  'gc/TypeaheadSelectionToSubmissionLogger'
], function(
  importedState,
  search,
  dataModels,
  localStorage,
  validate,
  getLob,
  TypeaheadSelectionToSubmissionLogger
) {
  var Submit = {};
  var _uitk;

  Submit.setUitk = function(uitk) {
    _uitk = uitk;
  }

  Submit.submit = function(model) {
    // TODO: this should be in the model
    setDefaultForRoomOneAdults();
    var validationResults = validate(dataModels.model.get('config.validation'), dataModels.model.toJSON());
    dataModels.state.set('validation', validationResults);
    if (validationResults.isValid) {

      localStorage.saveLocalStorage(localStorage.localStorageKey, localStorage.filterModel(model.toJSON()));
      var viewModel = dataModels.viewModel.toJSON();
      localStorage.saveLocalStorage('_spark', viewModel);
      Submit.validSubmit(model);
    } else {
      Submit.invalidRetry(model);
    }
  };

  Submit.validSubmit = function(model) {
    importedState.setBackButtonData(model); // saving back button
    if(getLob(model.get('tab'), model.get('packages')) == 'openSearch'){
     corewizard.searchTracking.trackValidOpenSearch(model);
    } else {
    corewizard.searchTracking.trackValidSearch(model);
    }
    if (_uitk) {
      _uitk.publish("corewizard.validSubmit", getLob(model.get('tab'), model.get('packages')));
    }
    if (TypeaheadSelectionToSubmissionLogger.isValidSelection()) {
      _uitk.publish("SuggestionSubmitted",
          TypeaheadSelectionToSubmissionLogger.newSubmission(Date.now()));
    }
    Submit.goToSearchUrl(model);
  };

  Submit.goToSearchUrl = function(model) {
    var url = Submit.getSearchUrl(model.toJSON());
    url.indexOf('/Trivago-Redirection') > -1||url.indexOf('12go.asia') > -1? window.open(url, '_blank') : window.location = url;
  };

  Submit.getSearchUrl = function(model, lob, searchUrlGenerator) {
    lob = lob || getLob(model.tab, model.packages);
    if (Submit.trivagoRedirectionUrl && Submit.trivagoRedirectionUrl.shouldRedirect(model, lob)) {
      return Submit.trivagoRedirectionUrl(model);
    }
    else if (model.isMobileDevice && !model.isMultiDest && !model.isHashlessURLneeded) {
      return search.eapAspSearchUrl(model, lob);
    } else {
        var generator = searchUrlGenerator || dataModels.config.get('searchUrlGenerator');
        if(typeof generator === 'function') {
          return generator(model, lob, dataModels.state);
        }
        else {
          return search[generator](model, lob, dataModels.state);
        }
    }
  };

  Submit.invalidRetry = function(model) {
    // render errors
    dataModels.state.trigger('reloadWizard');

    //Fix for WCAG-2027
    //set focus
    $('div[data-wizard-action=search-wrapper]').find('.alert-container')
      .attr('tabindex', -1)
      .focus();
      uitk.utils.focusElement($('.alert-title'));

    // omniture track failure
    corewizard.searchTracking.trackInvalidSearch(model);
  };

  return Submit;
});

define('gc/wizardActionBinder', ['jquery','gc/errorLogging'], function($, errorLogging) {
  var _uitk;
  var oldValue = "OLD_VALUE";
  
  return {
    bindActions: function (wrapperEl, state, uitk) {
      _uitk = uitk;
      var key = '[data-wizard-action]';
      var defaultHandler = _.partial(handleStateChangeEvent, state);
      var accessibilityHandler = _.partial(handlePlaceholderEvent, state, uitk);
      var focusHandler = _.partial(handleFocusChangeEvent, state);
      var LabelAnimationHandler = _.partial(handleLabelChangeEvent, state);
      var listenerList = [
        { eventType: 'blur',          selector: 'input[type=tel]' + key,     handler: defaultHandler },
        { eventType: 'blur',          selector: 'input[type=number]' + key,     handler: defaultHandler },
        { eventType: 'change',        selector: 'input[type=number]' + key,     handler: defaultHandler },
        { eventType: 'blur',          selector: 'input[type=text]' + key,     handler: defaultHandler },
        { eventType: 'focus',          selector: 'input[type=text]' + key,     handler: LabelAnimationHandler },
        { eventType: 'blur',          selector: 'input[type=text]' + key,     handler: LabelAnimationHandler },
        { eventType: 'keyup',          selector: 'input[type=text]' + key,     handler: LabelAnimationHandler },
        { eventType: 'input',          selector: 'input[data-js-theme=typeahead]' + key,     handler: accessibilityHandler },
        { eventType: 'focus',         selector: 'input[type=text]:not(.dropdown_textbox):not(#car-dropoff)' + key,     handler: defaultHandler },
        { eventType: 'change',         selector: 'input[data-js-theme=typeahead]:not(.dropdown_textbox)' + key,     handler: defaultHandler },
        { eventType: 'focus',         selector: 'input[type=radio]' + key,     handler: focusHandler },
        { eventType: 'blur',         selector: 'input[type=radio]' + key,     handler: focusHandler },
        { eventType: 'change',        selector: 'select' + key,               handler: defaultHandler },
        { eventType: 'change',        selector: 'input[type=checkbox]' + key, handler: defaultHandler },
        { eventType: 'keydown',       selector: 'input[type=radio]' + key,    handler: accessibilityHandler },
        { eventType: 'keyup',         selector: 'input[type=text][id=car-dropoff]' + key,    handler: defaultHandler },
        { eventType: _uitk.clickEvent, selector: 'input[type=radio]' + key,    handler: defaultHandler },
        { eventType: _uitk.clickEvent, selector: 'a' + key,                    handler: defaultHandler },
        { eventType: _uitk.clickEvent, selector: 'a[data-tab=package]',        handler: _.partial(packageDealsClick, state) }
      ];

      _.each(listenerList, function (listener) {
        wrapperEl.on(listener.eventType, listener.selector, listener.handler);
      }, this);
    } ,
    bindOpenSearchSubmitAction : function (wrapperEI, state) {
      //Open Search can not select first input from typeahead and should
      //pass on only entered text to validation
      if (state.get('tab') == "openSearch") {
            wrapperEI.find('input').each(function(index, element) {
            applyStateChangeToField(state,$(element));
          });
       }
    }
  };

  function handlePlaceholderEvent(state, evt, uitkevt){
    try {
      var $target = $(evt.currentTarget);
      var groups = [];
      var thisGroup;
      if(uitkevt){
        $target = $(uitkevt.currentTarget);
      }

      if(!($('#wizard-container').hasClass('ab11873_1'))){
        // Fix the accessibility bug for WCAG-789
        if($target.data('wizard-action').hasOwnProperty('carReturn')){
          var $value = $target.val();
          if (oldValue === "OLD_VALUE" || oldValue !== $value) {
            oldValue = $value;
            var $placeholder = $target.attr('placeholder') || 'Same as Pick-up';
            if($value === ""){
              $target.prop('title', $placeholder);
            // Fix the accessibility bug for WCAG-987
              $target.attr('placeholder', $placeholder);
            }else {
              $target.prop('title', "");
            // Fix the accessibility bug for WCAG-987
              $target.attr('placeholder', "");
            }
          }
        }
      }

      // Fix for the accessbility bug WCAG-1032 and WCAG-1035
      if(evt.type === 'keydown'){
        // Disable the default behavior of the up and down arrow key
        evt.preventDefault();
        var $radioButtonGroup = $target.parent().parent().find("input[type='radio']");
        // group the radio button inputs field by name
        $radioButtonGroup.each(function (i,elem) {
          thisGroup = groups[elem.name] = (groups[elem.name] || []);
          thisGroup.push(elem);
        });

        setTimeout(function (){
          var el = evt.currentTarget;
          // Getting the radio buttons group matches the name of the current active radio button
          var thisGroup = groups[el.name] = (groups[el.name] || []),
              indexOfTarget = thisGroup.indexOf(el),
              active,
              $firstInput,
              $lastTab;

          if (evt.keyCode === 40 && indexOfTarget < (thisGroup.length - 1)) {
            //Setting the next radio button to be the active element after pressing downarrow key.
            active = thisGroup[indexOfTarget + 1];
            //Changing the state of the radio buttons to be the active one
            applyStateChangeToField(state, $(active));
            //Setting the focus on the active radio button
            document.getElementById(active.id).focus();

          }else if (evt.keyCode === 38 && indexOfTarget > 0) {
            //Setting the former radio button to be the active element after pressing uparrow key.
            active = thisGroup[indexOfTarget - 1];
            //Changing the state of the radio buttons to be the active one
            applyStateChangeToField(state, $(active));
            //Setting the focus on the active radio button
            document.getElementById(active.id).focus();
          }
          if(evt.keyCode === 9){
            if(!evt.shiftKey){
              if(evt.currentTarget.name == 'lap-or-seat'){
                if(evt.currentTarget.id.indexOf('flight') > -1){
                  $('#advanced-options').focus();
                }else{
                  $('#search-button').focus();
                }
              }else{
                //Pressing the tab key, the focus go to the next element
                $firstInput = $('.forms').find('input[type="text"]').first();
                $firstInput.focus().select();
              }
            }else {
              //Pressing the tab + Shift, moving the focus back the former element
              if(evt.currentTarget.name == 'lap-or-seat'){
                if(evt.currentTarget.id.indexOf('flight') > -1){
                  $('#flight-children-help').focus();
                }else{
                  $('#package-children-help').focus();
                }
              }else{
                $lastTab = $('.tabs').find('li').last();
                uitk.utils.focusElement($lastTab);
              }
            }
          }
        });
      }
    } catch (e) {
      errorLogging.logError(e, 'wizard', 'gc/wizardActionBinder', 'handlePlaceholderEvent');
    }
  }

  function packageDealsClick(state) {
    try {
      var packages = state.get('packages');
      var atLeastOnePackage = packages && (packages.flight || packages.hotel || packages.car || packages.train);
      var packageTabIsAlreadySelected = state.get('tab') === 'package';
      var isPackage = packageTabIsAlreadySelected || atLeastOnePackage;

      var update = {
        tab: 'package',
        packages: isPackage ? packages : {flight: true, hotel: true, car: false, train: false}
      };

      state.set(update);
    } catch (e) {
      errorLogging.logError(e, 'wizard', 'gc/wizardActionBinder', 'packageDealsClick');
    }
  }

  function handleStateChangeEvent(state, evt) {
    try {
      var $target = $(evt.currentTarget);

      // fix the accessibility bug WCAG-943
      if(window.navigator.userAgent.toLowerCase().indexOf('firefox') > -1  && evt.type != "keyup" ) {
        $target.select();
      }

      if ($target.attr('role') === 'button') evt.preventDefault();
      if (evt.type === 'change') {
        state.set('activeElement', $target.attr('id'));
        evt.stopPropagation(); //this stops an error being thrown in IE8
      }
      applyStateChangeToField(state, $target);
      state.trigger('change:UI:' + $target.attr('data-tracking'), state);
    } catch (e) {
      errorLogging.logError(e, 'wizard', 'gc/wizardActionBinder', 'handleStateChangeEvent');
    }
  }

  function handleLabelChangeEvent(state, evt){
    try{
      var $target = $(evt.currentTarget);

      if($('#wizard-container').hasClass('ab11873_1')){
        var $target = $(evt.target);
        var $label = $target.prev(".label");
        var onClass = "on";
        if(evt.type = 'keyup'){
          inlineLabelAnimation($target, $label);
        }
        if(evt.type = 'focus'){
          inlineLabelAnimation($target, $label);
          $label.addClass(onClass);
        }

        if(evt.type = 'blur'){
          $label.removeClass(onClass);
          inlineLabelAnimation($target, $label);
        }
      }

    }catch(e){
      errorLogging.logError(e, 'wizard', 'gc/wizardActionBinder', 'handleLabelChangeEvent');
    }
  }

  function inlineLabelAnimation(target, label){
    var showClass = "show";
    if(target.val() !== ""){
      label.addClass(showClass);
    } else {
      label.removeClass(showClass);
    }
  }

  function applyStateChangeToField(state, $field) {
    var values = getWizardActionValues($field);
    var properties = $field.attr('data-wizard-action');

    _.each(values, function(value, i) {
      var re = new RegExp('\\$value' + (i + 1), 'g');
      properties = properties.replace(re, value);
    });

    var attr = JSON.parse(properties);
    var dataTab = $field.attr('data-tab');
    var launchView = state.get('launchView');
    var hasFlight = attr.hasOwnProperty('packages.flight');
    var currentUserAgent = window.navigator.userAgent.toLowerCase();
    if((launchView === "home" || launchView === "/") && dataTab === 'flight'){
       attr.showFlightOptions = false;
    }
    if((launchView === "home" || launchView === "/") && dataTab === 'package'){
       attr.showFlightOptions = true;
    }
    state.set(attr);
    setFocusToElement(attr, $field);

    // Fix accessibility bug for WCAG-1875
    if(currentUserAgent.indexOf('firefox') > -1 && currentUserAgent.indexOf('android') > -1 ) {

      if(hasFlight && $field[0].id == 'package-fc' ){
        document.getElementById('package-fc').focus();
      }

      if(hasFlight && $field[0].id == 'package-hc' ){
        document.getElementById('package-hc').focus();
      }

      if(hasFlight && $field[0].id == 'package-fh' ){
        document.getElementById('package-fh').focus();
      }

      if(hasFlight && $field[0].id == 'package-fhc' ){
        document.getElementById('package-fhc').focus();
      }
    }

  }

  function handleFocusChangeEvent(state, evt) {
    try {
      if(!($('#wizard-container').hasClass('ab11872_1'))){
        if(evt.type == 'focusin'){
          if(evt.currentTarget.name == 'package-lob' || evt.currentTarget.name == 'flight-type'){
            $('#'+evt.currentTarget.id).parent().addClass('radio-blueborder');
          }
        }else{
          $('#'+evt.currentTarget.id).parent().removeClass('radio-blueborder');
        }
      }
    } catch (e) {
      errorLogging.logError(e, 'wizard', 'gc/wizardActionBinder', 'handleFocusChangeEvent');
    }
  }

  function getWizardActionValues($field) {
    if ($field.attr('type') == 'checkbox') {
      return [$field.is(':checked').toString()];
    } else if ($field.attr('type') == 'text' && $field.attr("data-value")) {
      return [$field.attr("data-value")];
    }
    else if ($field.val()) {
        if($field.attr('data-show-day-cal') == 'true' && typeof _uitk.calendarObj.toStringFromDate !== "undefined" && typeof _uitk.calendarObj.getDateFromString !== "undefined") {
            var d = _uitk.calendarObj.getDateFromString($field.val());
            if (d == null) {
                return $field.val().split(':');
            }
            return [_uitk.calendarObj.toStringFromDate(d) ];
        }
        return $field.val().split(':');
    } else {
      return [''];
    }
  }

  function setFocusToElement(attr, $field){
    // Fix accessibility bug for WCAG-1795
    if(attr.hasOwnProperty('isPartialStay') && $field[0].localName != 'a'){
      document.getElementById('partialHotelBooking').focus();
    }
    // Fix accessibility bug for WCAG-2022
    if(attr.hasOwnProperty('showFlightOptions') && $field[0].id == 'advanced-options' ){
      document.getElementById('advanced-options').focus();
    }
  }

});

/**
 * This file is intended to be a module that encapsulates the generation of the URLs for the requests to Expedia Suggest
 * Service (ESS).
 */
"use strict";

/**
 * A generator of the URLs for requests to Expedia Suggest Service (ESS).
 * @class
 * @param {Array} essAbacusIds - an array of Abacus IDs for which the variant assignments should be passed to ESS.
 * @param {function} variantAssigner - a function that, for any given abacus ID, returns the variant assignment for
 *        it, or returns undefined if the session should be excluded from the experiment.
 * @param {function} pageIdGetter - a function that returns the page ID of the web page.
 */
define('gc/ExpediaSuggestServiceRequestGenerator', ['gc/searchExperiments', 'env', 'gc/TypeaheadUtils'], function(searchExperiments, env, TypeaheadUtils) {

function ExpediaSuggestServiceRequestGenerator(essAbacusIds, variantAssigner, pageIdGetter) {
    this.__essAbacusIds = essAbacusIds;
    this.__variantAssigner = variantAssigner;
    this.__pageIdGetter = pageIdGetter;
    this.siteId = this.__getSiteId();
    this.guid = this.__getGuid();
}

ExpediaSuggestServiceRequestGenerator.prototype.ESS_ABACUS_IDS = [];

ExpediaSuggestServiceRequestGenerator.prototype.clientIdByPageId = {
    "aws_Homepage": "AWSHomepage",
    "Homepage": "Homepage",
    "page.Flights": "FlightsLandingPage",
    "page.Hotels": "HotelsLandingPage",
    "page.Cars" : "CarsLandingPage",
    "page.Activities" : "LXLandingPage",
    "page.Packages": "PackageLandingPage"
};

ExpediaSuggestServiceRequestGenerator.prototype.clientIdByPath = {
    "/": "Homepage",
    "/gc/render/all": "Homepage",
    "/Flights": "FlightsLandingPage",
    "/Hotels": "HotelsLandingPage",
    "/Cars" : "CarsLandingPage",
    "/Activities" : "LXLandingPage",
    "/Vacation-Packages": "PackageLandingPage"
};

ExpediaSuggestServiceRequestGenerator.prototype.defaultPageIdGetter = function () {
    return TypeaheadUtils.getPageId();
};

ExpediaSuggestServiceRequestGenerator.prototype.getClientId = function () {
    //var pageId = typeof this.__pageIdGetter === "function" && this.__pageIdGetter(),
        //clientId = pageId && ExpediaSuggestServiceRequestGenerator.prototype.clientIdByPageId[pageId];
        var clientId = $("meta[name='ESSClientID']").attr('content');
        if ( clientId ) { return clientId; }
        if(!clientId) {
            var pathName = window.location.pathname;
            clientId = ExpediaSuggestServiceRequestGenerator.prototype.clientIdByPath[pathName];
        }
    return clientId ? clientId : "Unknown";
};

ExpediaSuggestServiceRequestGenerator.prototype.__getVariantAssignment = function (abacusId) {
    if(typeof this.__variantAssigner !== 'function') { return; }
    var variant = this.__variantAssigner(abacusId);
    return variant === undefined ? undefined : "".concat(abacusId, ".", variant);
};

/**
 * Generates the Abacus parameter of ESS request URL.
 * @returns {string}
 */
ExpediaSuggestServiceRequestGenerator.prototype.generateAbacusParameter = function () {
    var self = this,
        abFieldValue = [];
    function getVariantAssignment (abacusId) {
        if(typeof self.__getVariantAssignment === 'function') {
            return self.__getVariantAssignment(abacusId);
        }
        else {
            return undefined;
        }
    }

    $(this.__essAbacusIds).each(function(index, abId){
        var variantAssignment = getVariantAssignment(abId);
        if(variantAssignment) { abFieldValue.push(variantAssignment); }
    });

    var varAssignment9241 = getVariantAssignment('9241');
    if(varAssignment9241){
        if(searchExperiments) {
            var variant9241 = searchExperiments.getSearchExperimentVariant('9241');
            switch(variant9241) {
                case "0"  : abFieldValue.push(getVariantAssignment('8071')); break;
                case "1"  : abFieldValue.push('8071.2'); break;
                default : abFieldValue.push(getVariantAssignment('8071'));
            }
        }
    }
    else {
        var varAssignment8071 = getVariantAssignment('8071');
        if(varAssignment8071) {
            abFieldValue.push(varAssignment8071);
        }
    }

    return abFieldValue.length > 0 ? abFieldValue.join("|") : "";
};

ExpediaSuggestServiceRequestGenerator.prototype.__getSiteId = function () {
    /*
     window.site_id is hardcoded to 1 in handlebars-amd-bootstrap.js. Using the 'env' module instead
     */
    /* window.site_id is defined on home page (both Expweb and cloud versions), and on launch pages. It is undefined on
     hotel search results page. Once we decide on a client-side error logging mechanism, we should log errors properly.
     */
    return env.siteId ? env.siteId : '';
};

ExpediaSuggestServiceRequestGenerator.prototype.__getGuid = function () {
    var mc1Cookie = TypeaheadUtils.getCookie("MC1"),
        pair = mc1Cookie && mc1Cookie.split("=");
    return $.isArray(pair) && pair.length === 2 ? pair[1] : "";
};

ExpediaSuggestServiceRequestGenerator.prototype.defaultVariantAssigner = function() {
    if(searchExperiments){
        return searchExperiments.getSearchExperimentVariantIfParticipating;
    }
    return undefined;
};

ExpediaSuggestServiceRequestGenerator.defaultGenerator = new ExpediaSuggestServiceRequestGenerator(
  ExpediaSuggestServiceRequestGenerator.prototype.ESS_ABACUS_IDS,
  ExpediaSuggestServiceRequestGenerator.prototype.defaultVariantAssigner ? ExpediaSuggestServiceRequestGenerator.prototype.defaultVariantAssigner() : undefined,
  ExpediaSuggestServiceRequestGenerator.prototype.defaultPageIdGetter);

return ExpediaSuggestServiceRequestGenerator;

});
/* global,
 TypeaheadUtils,
 uitk
 */
define('gc/TypeaheadSelectionToSubmissionLogger', [
    'gc/TypeaheadUtils'
], function (
    TypeaheadUtils
) {
    var instance = null;

    function TypeaheadSelectionToSubmissionLogger() {
        if(instance !== null){
            throw new Error("Cannot instantiate more than one TypeaheadSelectionToSubmissionLogger, " +
                "use TypeaheadSelectionToSubmissionLogger.getInstance()");
        }

        this.initialize();
    }

    TypeaheadSelectionToSubmissionLogger.prototype = {
        initialize: function () {
            "use strict";
            require('uitk', function(uitk) {
              uitk.subscribe("SuggestionSelected", this, TypeaheadSelectionToSubmissionLogger.prototype.logSuggestionsSelected);
              uitk.subscribe("SuggestionSubmitted", this, TypeaheadSelectionToSubmissionLogger.prototype.logSuggestionSubmitted);
            });
        },

        TypeaheadSuggestionSelectedMeasurement: function (timestamp, documentElementId, lineOfBusiness, treatmentAssignments) {
            "use strict";
            this.timestamp = timestamp;
            this.documentElementId = documentElementId;
            this.lineOfBusiness = lineOfBusiness;
            this.treatmentAssignments = treatmentAssignments;
        },

        TypeaheadSuggestionSubmittedMeasurement: function (timestamp) {
            "use strict";
            this.timestamp = timestamp;
        },

        createTypeaheadSelectionToSubmissionLogEntry: function (beginMeasurement, endMeasurement) {
            return _.extend(
                TypeaheadUtils.createTypeaheadMetricsLogEntryCore(
                    beginMeasurement.documentElementId,
                    beginMeasurement.lineOfBusiness,
                    beginMeasurement.treatmentAssignments,
                    endMeasurement.timestamp),
                {
                    latency: endMeasurement.timestamp - beginMeasurement.timestamp,
                    type: "selectionToSubmission"
                });
        },

        logSuggestionsSelected: function (topic, measurement) {
            this.measurement = measurement;
        },

        logSuggestionSubmitted: function (topic, measurement) {
            TypeaheadUtils.sendToCollector([
                TypeaheadSelectionToSubmissionLogger.prototype.createTypeaheadSelectionToSubmissionLogEntry(this.measurement, measurement)
            ]);
        },

        clearSelection: function () {
            this.measurement = undefined;
        },

        isValidSelection: function () {
            return this.measurement != undefined;
        },

        newSelection: function (timestamp, documentElementId, lineOfBusiness, treatmentAssignments) {
            "use strict";
            return new TypeaheadSelectionToSubmissionLogger.prototype.TypeaheadSuggestionSelectedMeasurement(
                timestamp, documentElementId, lineOfBusiness, treatmentAssignments);
        },

        newSubmission: function (timestamp) {
            "use strict";
            return new TypeaheadSelectionToSubmissionLogger.prototype.TypeaheadSuggestionSubmittedMeasurement(timestamp);
        }
    };

    TypeaheadSelectionToSubmissionLogger.getInstance = function(){
        // summary:
        //      Gets an instance of the singleton. It is better to use
        if(instance === null){
            instance = new TypeaheadSelectionToSubmissionLogger();
        }
        return instance;
    };

    return TypeaheadSelectionToSubmissionLogger.getInstance();
});

/* global $, _, corewizard */

var searchExperimentsGlobal;
require(['gc/abTest', 'gc/dataModels', 'gc/searchExperiments'], function(abTest, dataModels, searchExperiments) {
    searchExperimentsGlobal = searchExperiments;
});

function BestDealsOptionInjector(typeahead) {
    "use strict";
    var variant = searchExperimentsGlobal.getVariant("BEST_DEALS_OPTION");
    this.displayName = ["", typeahead.opts.bestDealsText, typeahead.opts.cheapHotelsText][variant] || "";
    this.lastSearchNamePostfix = [
                "",
                " - " + typeahead.opts.bestDealsText.toLowerCase(),
                " - " + typeahead.opts.cheapHotelsText.toLowerCase()
            ][variant] || "";
    this.sort = [undefined, "deals", "price"][variant] || undefined;
}

BestDealsOptionInjector.prototype = {};

BestDealsOptionInjector.prototype.__isChild = function (result) {
    "use strict";
    return result &&
        result.hierarchyInfo &&
        result.hierarchyInfo.relation &&
        _.contains(result.hierarchyInfo.relation, "child");
};

BestDealsOptionInjector.prototype.shouldInject = function (results) {
    "use strict";
    return _.isObject(results)
        && results.length >= 2
        && this.__isChild(results[1]);
};

BestDealsOptionInjector.prototype.deleteLeastImportantOption = function (results) {
    "use strict";
    var childrenCount;
    if (results.length < 10) {
        return;
    }
    childrenCount = this.countChildren(results);
    if (childrenCount >= 6) {
        results.splice(childrenCount, 1);
    } else {
        results.splice(results.length - 1, 1);
    }
};

BestDealsOptionInjector.prototype.countChildren = function (results) {
    "use strict";
    return _.filter(results, BestDealsOptionInjector.prototype.__isChild).length;
};

BestDealsOptionInjector.prototype.makeNewOption = function (baseOption) {
    "use strict";
    var newOption = {};
    $.extend(true, newOption, baseOption);
    newOption.regionNames = newOption.regionNames || {};
    newOption.regionNames.lastSearchName =
        $($.parseHTML(baseOption.regionNames.displayName)).text() + this.lastSearchNamePostfix;
    newOption.regionNames.displayName = this.displayName;
    newOption.hierarchyInfo = newOption.hierarchyInfo || {};
    newOption.hierarchyInfo.isChild = "true";
    newOption.hierarchyInfo.relation = newOption.hierarchyInfo.relation || [];
    newOption.hierarchyInfo.relation.push("child");
    newOption.type = "DEALS";
    newOption.sort = this.sort;
    return newOption;
};

BestDealsOptionInjector.prototype.inject = function (results) {
    "use strict";
    var newOption,
        i,
        optionsCount;
    if (!this.shouldInject(results)) {
        return;
    }
    this.deleteLeastImportantOption(results);
    newOption = this.makeNewOption(results[0]);
    results.splice(1, 0, newOption);
    optionsCount = results.length;
    for (i = 0; i < optionsCount; ++i) {
        results[i].index = i.toString(10);
    }
};

define('gc/InjectorUtils', [], function() {
    "use strict";

    function InjectorUtils() {

    }
    // here the intention is to cache both the index value for each item in the combined array as
    // well as preserve the original incoming array index in the essIndex property.
    function renumberOptions(results) {
        var optionsCount = results.length;
        var result;
        var i;
        for (i = 0; i < optionsCount; ++i) {
            result = results[i];
            if (_.isObject(result)) {
                if (!_.isUndefined(result.index) && _.isUndefined(result.essIndex)) {
                    // if the incoming item already had a .index property, then it's part of the
                    // original list. Store it off in the essIndex property
                    result.essIndex = result.index;
                }

                // now store(or update) the actual index
                result.index = i.toString(10);
            }
        }
    }

    InjectorUtils.injectSuggestions = function(preexistingSuggestions, additionalSuggestions, maxTotalOptions) {
        Array.prototype.splice.apply(preexistingSuggestions, [0, 0].concat(additionalSuggestions));
        preexistingSuggestions.splice(maxTotalOptions, Number.MAX_VALUE);
        renumberOptions(preexistingSuggestions);
    }

    return InjectorUtils;

});

/* global _, console, corewizard, uitk */

define('gc/RecentHistoryOptionsInjector', [
    'gc/searchExperiments',
    'gc/ExpediaSuggestServiceRequestGenerator',
    'jquery',
    'env',
    'uitk',
    'gc/pageModel',
    'gc/InjectorUtils'
], function(
    searchExperiments,
    ExpediaSuggestServiceRequestGenerator,
    $,
    env,
    uitk,
    pageModel,
    InjectorUtils
) {
    "use strict";

    // match omniture string for logging
    var recentHistoryType = "RECENTHISTORY";

    // simple console logger for
    // debug traces
    function logError(error) {
        console && console.error && console.error(error);
    }

    function verify(value, verifier, errorMessage) {
        if (!verifier(value)) {
            throw new Error(errorMessage);
        }
        return value;
    }

    function RecentHistoryOptionsInjector() {
        this.injectedOptionsCount = 0;
        this.startRequestForPrefetch();
    }


    function callbackFromPrefetch(json)
    {
        RecentHistoryOptionsInjector.prototype.resultsFromPrefetch = json.sr ? json.sr : (json.r ? json.r : []);
    }

    RecentHistoryOptionsInjector.prototype.resultsFromPrefetch = [];

    RecentHistoryOptionsInjector.prototype.startRequestForPrefetch = function () {
        var requestGenerator = ExpediaSuggestServiceRequestGenerator.defaultGenerator;
        var V4URL;
        if(!env.essEndpoint) {
            // TODO: when we get client side logging, log info to server
            console.error("Missing environment config value for essEndpoint so defaulting to production endpoint.");
            V4URL = "//suggest.expedia.com/api/";
        } else {
            V4URL = env.essEndpoint;
        }
        var url = [V4URL, 'v4', '/typeahead/', encodeURIComponent('')].join('');
        var param = {
            format: 'jsonp',
            client: requestGenerator.getClientId(),
            siteid: requestGenerator.siteId,
            guid: requestGenerator.guid,
            expuserid: pageModel.user.expUserId || -1
        };

        $.ajax({
            dataType: 'jsonp',
            url: url,
            data: param,
            timeout: 1000,
            tryCount: 0,
            retryLimit: 1,
            success: callbackFromPrefetch,
            error: function(jqXHR, textStatus, errorThrown) {
                if (textStatus === "timeout") {
                    if (++this.tryCount <= this.retryLimit) {
                        logError("Timeout when calling scratchpad server the first time. Trying to make the second call");
                        $.ajax(this);
                    }
                    else {
                        logError("Timeout when calling scratchpad server the second time. Aborted the connection");
                    }
                }
                else {
                    logError("Error when calling scratchpad server");
                }
            }
        });
    };

    //
    // NOTE:
    // extractCoreWizardStateFromHistoryForHotel and extractCoreWizardStateFromHistoryForFlight
    // are helper functions to map a history to a JS object that contains
    // the view model properties used by the corewizard to populate the
    // UI elements. The way this works is that each DOM element in the corewizard
    // has a 'data-wizard-action' attribute that looks something like this
    //
    //     data-wizard-action="{"endDate" : "$value1"}"
    //
    // The "endData" is the property key and the "#value1" is what gets put
    // into the UI when it renders. So, each of the keys in the wizardProps
    // object matches one of the keys the wizard uses to populate the data
    // in the UI.
    //

    function extractCoreWizardStateFromHistoryForHotel(essId, regionNames) {

        // These are the properties that map to the 'data-wizard-action' property
        // in the core wizard DOM for the element being populated.
        var wizardProps = {
            destination: regionNames.lastSearchName,
            destinationFromTA: regionNames.lastSearchName,
            regionId: essId.sourceId
        };

        return wizardProps;
    }

    RecentHistoryOptionsInjector.extractCoreWizardStateFromHistoryForHotel = extractCoreWizardStateFromHistoryForHotel;

    RecentHistoryOptionsInjector.prototype.inject = function(results, options) {
        var defaultValues = {
            srchText: '',
            elementId: '',
            lineOfBusiness: '',
            flightType: '',
            maxTotalOptions: 0
        };

        // set reasonable default options
        options = _.defaults(options || {}, defaultValues);

        var maxTotalOptions = options.maxTotalOptions;

        try {
            // save our taMetadata
            this.injectedOptionsCount = RecentHistoryOptionsInjector.prototype.resultsFromPrefetch.length;
            InjectorUtils.injectSuggestions(results, RecentHistoryOptionsInjector.prototype.resultsFromPrefetch, maxTotalOptions);
        } catch (error) {
            logError(error);
        }
    };

    RecentHistoryOptionsInjector.prototype.countInjectedOptions = function() {
        return this.injectedOptionsCount;
    };

    verify(uitk, _.isObject, "must have uitk to use this module");
    verify(uitk.utils, _.isObject, "must have uitk.utils to use this module");

    return RecentHistoryOptionsInjector;
});
(function () {

require(['underscore', 'env', 'gc/TypeaheadUtils', 'gc/TypeaheadMetricsLogger'], function(_, env, TypeaheadUtils, TypeaheadMetricsLogger) {
    'use strict';

    // ******************************************** IMPORTANT *******************************************************
    // vmohapatra : Trending Search module is not yet ready to be implemented.

    // Recommender service related documentation
    // Hotel search
    // https://confluence/display/POS/Recommender+Data+Model+-+Top+DestinationsByOrigin-+Region+to+Region+-+Multicity+to+MultiCity
    // http://wwwexpediacom.trunk.sb.karmalab.net/Region-Recommender-Ajax?action=getProductRecommendations&scenario=deals&rule=top-destinations-point-of-origin&id=Seattle&itemType=2&maxCount=10&startDate=&endDate=&reqRetIType=2&code=4&travellersInfo=2&feature=-1
    // Flight search
    // https://confluence/display/POS/Recommender+Data+Model+-+Top+DestinationsByOrigin+-+Region+to+Region+-+TLA+to+TLA
    // http://wwwexpediacom.trunk.sb.karmalab.net/Region-Recommender-Ajax?action=getProductRecommendations&scenario=deals&rule=top-destinations-point-of-origin&id=SEA&itemType=1&maxCount=10&startDate=&endDate=&reqRetIType=1&code=4&travellersInfo=2&feature=-1

    if (_.isUndefined(TypeaheadUtils) ||
        _.isUndefined(TypeaheadUtils.currentLocationInfo)) {
        throw new Error("Must have TypeaheadUtils and TypeaheadUtils.currentLocationInfo defined before using this module");
    }

    var hotelItemType = 2;
    var hotelRecItemType = 2;
    var flightItemType = 1;
    var flightRecItemType = 1;
    var flightDestinationRegex = /flight-.*destination/;
    var logger = new TypeaheadMetricsLogger("trendingSearchesDataProvider");

    // local promise "caches",
    // used as part of a singleton
    // pattern for the fetchFlightData()
    // and fetchHotelData() APIs
    var hotelsPromise;
    var hotelRegionModels = [];
    var flightsPromise;
    var flightsRegionModels = [];
    var isoCountries = {
        'AF': 'Afghanistan',
        'AX': 'Aland Islands',
        'AL': 'Albania',
        'DZ': 'Algeria',
        'AS': 'American Samoa',
        'AD': 'Andorra',
        'AO': 'Angola',
        'AI': 'Anguilla',
        'AQ': 'Antarctica',
        'AG': 'Antigua And Barbuda',
        'AR': 'Argentina',
        'AM': 'Armenia',
        'AW': 'Aruba',
        'AU': 'Australia',
        'AT': 'Austria',
        'AZ': 'Azerbaijan',
        'BS': 'Bahamas',
        'BH': 'Bahrain',
        'BD': 'Bangladesh',
        'BB': 'Barbados',
        'BY': 'Belarus',
        'BE': 'Belgium',
        'BZ': 'Belize',
        'BJ': 'Benin',
        'BM': 'Bermuda',
        'BT': 'Bhutan',
        'BO': 'Bolivia',
        'BA': 'Bosnia And Herzegovina',
        'BW': 'Botswana',
        'BV': 'Bouvet Island',
        'BR': 'Brazil',
        'IO': 'British Indian Ocean Territory',
        'BN': 'Brunei Darussalam',
        'BG': 'Bulgaria',
        'BF': 'Burkina Faso',
        'BI': 'Burundi',
        'KH': 'Cambodia',
        'CM': 'Cameroon',
        'CA': 'Canada',
        'CV': 'Cape Verde',
        'KY': 'Cayman Islands',
        'CF': 'Central African Republic',
        'TD': 'Chad',
        'CL': 'Chile',
        'CN': 'China',
        'CX': 'Christmas Island',
        'CC': 'Cocos (Keeling) Islands',
        'CO': 'Colombia',
        'KM': 'Comoros',
        'CG': 'Congo',
        'CD': 'Congo, Democratic Republic',
        'CK': 'Cook Islands',
        'CR': 'Costa Rica',
        'CI': 'Cote D\'Ivoire',
        'HR': 'Croatia',
        'CU': 'Cuba',
        'CY': 'Cyprus',
        'CZ': 'Czech Republic',
        'DK': 'Denmark',
        'DJ': 'Djibouti',
        'DM': 'Dominica',
        'DO': 'Dominican Republic',
        'EC': 'Ecuador',
        'EG': 'Egypt',
        'SV': 'El Salvador',
        'GQ': 'Equatorial Guinea',
        'ER': 'Eritrea',
        'EE': 'Estonia',
        'ET': 'Ethiopia',
        'FK': 'Falkland Islands (Malvinas)',
        'FO': 'Faroe Islands',
        'FJ': 'Fiji',
        'FI': 'Finland',
        'FR': 'France',
        'GF': 'French Guiana',
        'PF': 'French Polynesia',
        'TF': 'French Southern Territories',
        'GA': 'Gabon',
        'GM': 'Gambia',
        'GE': 'Georgia',
        'DE': 'Germany',
        'GH': 'Ghana',
        'GI': 'Gibraltar',
        'GR': 'Greece',
        'GL': 'Greenland',
        'GD': 'Grenada',
        'GP': 'Guadeloupe',
        'GU': 'Guam',
        'GT': 'Guatemala',
        'GG': 'Guernsey',
        'GN': 'Guinea',
        'GW': 'Guinea-Bissau',
        'GY': 'Guyana',
        'HT': 'Haiti',
        'HM': 'Heard Island & Mcdonald Islands',
        'VA': 'Holy See (Vatican City State)',
        'HN': 'Honduras',
        'HK': 'Hong Kong',
        'HU': 'Hungary',
        'IS': 'Iceland',
        'IN': 'India',
        'ID': 'Indonesia',
        'IR': 'Iran, Islamic Republic Of',
        'IQ': 'Iraq',
        'IE': 'Ireland',
        'IM': 'Isle Of Man',
        'IL': 'Israel',
        'IT': 'Italy',
        'JM': 'Jamaica',
        'JP': 'Japan',
        'JE': 'Jersey',
        'JO': 'Jordan',
        'KZ': 'Kazakhstan',
        'KE': 'Kenya',
        'KI': 'Kiribati',
        'KR': 'Korea',
        'KW': 'Kuwait',
        'KG': 'Kyrgyzstan',
        'LA': 'Lao People\'s Democratic Republic',
        'LV': 'Latvia',
        'LB': 'Lebanon',
        'LS': 'Lesotho',
        'LR': 'Liberia',
        'LY': 'Libyan Arab Jamahiriya',
        'LI': 'Liechtenstein',
        'LT': 'Lithuania',
        'LU': 'Luxembourg',
        'MO': 'Macao',
        'MK': 'Macedonia',
        'MG': 'Madagascar',
        'MW': 'Malawi',
        'MY': 'Malaysia',
        'MV': 'Maldives',
        'ML': 'Mali',
        'MT': 'Malta',
        'MH': 'Marshall Islands',
        'MQ': 'Martinique',
        'MR': 'Mauritania',
        'MU': 'Mauritius',
        'YT': 'Mayotte',
        'MX': 'Mexico',
        'FM': 'Micronesia, Federated States Of',
        'MD': 'Moldova',
        'MC': 'Monaco',
        'MN': 'Mongolia',
        'ME': 'Montenegro',
        'MS': 'Montserrat',
        'MA': 'Morocco',
        'MZ': 'Mozambique',
        'MM': 'Myanmar',
        'NA': 'Namibia',
        'NR': 'Nauru',
        'NP': 'Nepal',
        'NL': 'Netherlands',
        'AN': 'Netherlands Antilles',
        'NC': 'New Caledonia',
        'NZ': 'New Zealand',
        'NI': 'Nicaragua',
        'NE': 'Niger',
        'NG': 'Nigeria',
        'NU': 'Niue',
        'NF': 'Norfolk Island',
        'MP': 'Northern Mariana Islands',
        'NO': 'Norway',
        'OM': 'Oman',
        'PK': 'Pakistan',
        'PW': 'Palau',
        'PS': 'Palestinian Territory, Occupied',
        'PA': 'Panama',
        'PG': 'Papua New Guinea',
        'PY': 'Paraguay',
        'PE': 'Peru',
        'PH': 'Philippines',
        'PN': 'Pitcairn',
        'PL': 'Poland',
        'PT': 'Portugal',
        'PR': 'Puerto Rico',
        'QA': 'Qatar',
        'RE': 'Reunion',
        'RO': 'Romania',
        'RU': 'Russian Federation',
        'RW': 'Rwanda',
        'BL': 'Saint Barthelemy',
        'SH': 'Saint Helena',
        'KN': 'Saint Kitts And Nevis',
        'LC': 'Saint Lucia',
        'MF': 'Saint Martin',
        'PM': 'Saint Pierre And Miquelon',
        'VC': 'Saint Vincent And Grenadines',
        'WS': 'Samoa',
        'SM': 'San Marino',
        'ST': 'Sao Tome And Principe',
        'SA': 'Saudi Arabia',
        'SN': 'Senegal',
        'RS': 'Serbia',
        'SC': 'Seychelles',
        'SL': 'Sierra Leone',
        'SG': 'Singapore',
        'SK': 'Slovakia',
        'SI': 'Slovenia',
        'SB': 'Solomon Islands',
        'SO': 'Somalia',
        'ZA': 'South Africa',
        'GS': 'South Georgia And Sandwich Isl.',
        'ES': 'Spain',
        'LK': 'Sri Lanka',
        'SD': 'Sudan',
        'SR': 'Suriname',
        'SJ': 'Svalbard And Jan Mayen',
        'SZ': 'Swaziland',
        'SE': 'Sweden',
        'CH': 'Switzerland',
        'SY': 'Syrian Arab Republic',
        'TW': 'Taiwan',
        'TJ': 'Tajikistan',
        'TZ': 'Tanzania',
        'TH': 'Thailand',
        'TL': 'Timor-Leste',
        'TG': 'Togo',
        'TK': 'Tokelau',
        'TO': 'Tonga',
        'TT': 'Trinidad And Tobago',
        'TN': 'Tunisia',
        'TR': 'Turkey',
        'TM': 'Turkmenistan',
        'TC': 'Turks And Caicos Islands',
        'TV': 'Tuvalu',
        'UG': 'Uganda',
        'UA': 'Ukraine',
        'AE': 'United Arab Emirates',
        'GB': 'United Kingdom',
        'US': 'United States',
        'UM': 'United States Outlying Islands',
        'UY': 'Uruguay',
        'UZ': 'Uzbekistan',
        'VU': 'Vanuatu',
        'VE': 'Venezuela',
        'VN': 'Viet Nam',
        'VG': 'Virgin Islands, British',
        'VI': 'Virgin Islands, U.S.',
        'WF': 'Wallis And Futuna',
        'EH': 'Western Sahara',
        'YE': 'Yemen',
        'ZM': 'Zambia',
        'ZW': 'Zimbabwe'
    };

    var recommenderOptions = {
        trendingSearchesDataProvider: {

            // returns a list of hotel searches trending near the callers nearest major airport.
            // Returns a Promise() object.
            fetchHotelData: fetchHotelData,

            // returns a list of hotel searches trending near the callers current city.
            // Returns a Promise() object.
            fetchFlightData: fetchFlightData,

            // required for unit testing
            fetchData: fetchData
        }
    };

    function recommenderUrl(id, itemType, reqRetIType) {
        var url = "/Region-Recommender-Ajax?action=getProductRecommendations&scenario=ESS&rule=top-destinations-point-of-origin&id=" + id +
            "&itemType=" + itemType +
            "&maxCount=10&reqRetIType=" + reqRetIType +
            "&code=4&travellersInfo=2&feature=-1";
        return url;

    }

    function wasIpSniffSuccessful() {
        return (
            TypeaheadUtils.currentLocationInfo.currentCityName 
            && (TypeaheadUtils.currentLocationInfo.currentCityName !== "noCityName" || TypeaheadUtils.currentLocationInfo.currentCityName !== "nodata")
        );
    }

    function getCountryName(countryCode) {
        if (Object.prototype.hasOwnProperty.call(isoCountries, countryCode)) {
            return isoCountries[countryCode];
        } else {
            return countryCode;
        }
    }

    function getId() {
        var locInfo = TypeaheadUtils.currentLocationInfo;
        var siteId = env.siteId;
        var city = '';
        var state = '';
        var country = '';
        var id = '';

        if (wasIpSniffSuccessful()) {
            city = locInfo.currentCityName != 'noCityName' ? locInfo.currentCityName : city;
            state = locInfo.currentStateName != 'noStateName' ? locInfo.currentStateName : state;
            country = locInfo.currentCountryName != 'noCountryName' ? getCountryName(locInfo.currentCountryName.toUpperCase()): country;
            logIpSniffSuccess(locInfo);
            // Drop region_code for all non-US locations
            id = locInfo.currentCountryName.toUpperCase() != 'US'
                ? _.compact([city,country]).join(",")
                : _.compact([city,state,country]).join(",");
        } else {
            // then default the settings based on the siteId
            id = getDefaultId(siteId);
        }

        return id;
    }

    function getDefaultId(siteId){
        var defaultId = null;

        switch(siteId){
            case 3:
                defaultId = 'London, England';
                break;
            case 4:
                defaultId = 'Toronto, Canada';
                break;
            case 6:
                defaultId = 'Berlin, Germany';
                break;
            case 16:
                defaultId = 'Seoul, Korea';
                break;
            case 25:
                defaultId = 'Sydney, Australia';
                break;
            case 27:
                defaultId = 'Mumbai, India';
                break;
            case 29:
                defaultId = 'Auckland, New Zealand';
                break;
            default:
                break;
        }

        return defaultId;
    }

    function fetchData(url) {
        var ajaxOptions = {
            dataType: "json",
            url: url,
            timeout: 4000
        };
        return $.ajax(ajaxOptions).promise();
    }

    /**
     * Helper to call for cases where we don't have an id string to send to the recommender API
     * @returns {JQueryPromise<T>}
     */
    function getSiteIdFailurePromise() {
        var d = $.Deferred();
        d.reject("Failed to get a default id for the Region-Recommender-Ajax call for siteid: " + env.siteId);
        return d.promise();
    }

    function fetchHotelData() {
        if(_.isUndefined(hotelsPromise)){
            var recommenderUrlId = getId();
            if(recommenderUrlId){
                // only make the call when we actually have a location id to send
                hotelsPromise =  fetchData(recommenderUrl(recommenderUrlId, hotelItemType, hotelRecItemType));
            } else {
                // This API still needs to return a promise so we return a "failure" promise
                hotelsPromise = getSiteIdFailurePromise();
            }
        }

        return hotelsPromise;
    }

    function fetchFlightData() {
        if(_.isUndefined(flightsPromise)){
            var recommenderUrlId = getId();
            if(recommenderUrlId){
                // only make the call when we actually have a location id to send
                flightsPromise =  fetchData(recommenderUrl(recommenderUrlId, flightItemType, flightRecItemType));
            } else {
                // This API still needs to return a promise so we return a "failure" promise
                flightsPromise = getSiteIdFailurePromise();
            }
        }

        return flightsPromise;
    }

    function getRegionModels(lineOfBusiness, elementId) {
        switch(lineOfBusiness) {
            case "hotel":
                model = hotelRegionModels;break;
            case "flight":
                if (_.isNull(flightDestinationRegex.exec(elementId))) {
                    model = [];
                } else {
                    model = flightsRegionModels;
                }
                break;
            default:
                model = [];
        }
        return model;
    }

    /**
     * Logger for logging recommender success info for a line of business
     * @param count - the number items returned on successful recommender call
     * @param lob - which line of business
     */
    function logRegionRecommenderResultsCount(count, lob) {

        var logPropName = {
                "hotel": "numHotels",
                "flight": "numFlights"
            }[lob];
        var recommenderCountData = {
                type: "RegionRecommenderSuccess",
                guid: logger.guid,
                pointOfSale: window.location.hostname
            };

        // Only logs for hotel or flight recommender data.
        if(logPropName){
            recommenderCountData[logPropName] = count;
            TypeaheadUtils.sendToCollector([recommenderCountData]);
        }
    }

    function logRegionRecommenderFailure(errorText, errorCode) {
        TypeaheadUtils.sendToCollector([{
            type: "RegionRecommenderFailure",
            errorText: errorText,
            errorCode: errorCode,
            guid: logger.guid,
            pointOfSale: window.location.hostname
        }]);
    }

    function logIpSniffSuccess(currentLocationInfo) {
        TypeaheadUtils.sendToCollector([{
            type: "IpSniffDataSuccess",
            city: currentLocationInfo.currentCityName,
            state: currentLocationInfo.currentStateName,
            country: currentLocationInfo.currentCountryName,
            guid: logger.guid,
            pointOfSale: window.location.hostname
        }]);
    }

    function logIpSniffFailure() {
        TypeaheadUtils.sendToCollector([{
            type: "IpSniffDataFailure",
            guid: logger.guid,
            pointOfSale: window.location.hostname
        }]);
    }

    // add the trendingSearchesDataProvider to the TypeaheadUtils namespace
    _.extend(recommenderOptions.trendingSearchesDataProvider, {getRegionModels : getRegionModels});
    // add the trendingSearchesDataProvider to the TypeaheadUtils namespace
    _.extend(TypeaheadUtils, recommenderOptions.trendingSearchesDataProvider);

    // prefetch the regionModels arrays and stash them
    // on the trendingSearchesDataProvider object.
    fetchHotelData()
        .done(function(hotelsData){
            if(hotelsData.errorCode){
                logRegionRecommenderFailure(hotelsData.errorDesc, hotelsData.errorCode);
            } else {
                hotelRegionModels = hotelsData.regionModels;
                logRegionRecommenderResultsCount(hotelRegionModels.length, 'hotel');
            }
        })
        .fail(function(response, status, statusDescription) {
            if(response.errorCode){
                logRegionRecommenderFailure(response.errorCode);
            } else {
                logRegionRecommenderFailure(statusDescription);
            }
        });

    fetchFlightData()
        .done(function(flightsData){
            if(flightsData.errorCode){
                logRegionRecommenderFailure(flightsData.errorDesc, flightsData.errorCode);
            } else {
                flightsRegionModels = flightsData.regionModels;
                logRegionRecommenderResultsCount(flightsRegionModels.length, 'flight');
            }
        })
        .fail(function(response, status, statusDescription) {
            if(response.errorCode){
                logRegionRecommenderFailure(response.errorCode);
            } else {
                logRegionRecommenderFailure(statusDescription);
            }
        });

    (function logIpSniff() {
        if (wasIpSniffSuccessful()) {
            logIpSniffSuccess(TypeaheadUtils.currentLocationInfo);
        } else {
            logIpSniffFailure();
        }
    })();

});

})();
/* global _, console, corewizard */

(function() {
    "use strict";

    // match omniture string for logging
    var trendingSearchesNearYouType = "TRENDINGSEARCH";
    var corewizard = corewizard || undefined;
    var displayGroup = (
            _.isObject(corewizard) &&
            _.isObject(corewizard.masterconfig) &&
            _.isObject(corewizard.masterconfig.taCategories) &&
            _.isString(corewizard.masterconfig.taCategories.trending) &&
            corewizard.masterconfig.taCategories.trending
        ) || "Trending searches near you";

    function logError(error){
        console && console.error && console.error(error);
    }

    function TrendingSearchesNearYouInjector() {
    }

    function getDisplayGroupName(corewizard) {
        return (_.isObject(corewizard) &&
                _.isObject(corewizard.masterconfig) &&
                _.isObject(corewizard.masterconfig.taCategories) &&
                _.isString(corewizard.masterconfig.taCategories.trending) &&
                corewizard.masterconfig.taCategories.trending
            ) ||
            "Trending searches near you";
    }

    function makeTrendingSearchesNearOption(regionModel, displayKey) {
        if (_.isUndefined(displayGroup)) {
            displayGroup = getDisplayGroupName(corewizard);
        }
        return {
            regionNames: {
                displayName: regionModel[displayKey],
                lastSearchName: regionModel.longName,
                fullName: regionModel.longName
            },
            hierarchyInfo: {
                airport: {
                    airportCode: _.isEmpty(regionModel.TLA) ? "" : regionModel.TLA
                }
            },
            gaiaId: regionModel.id,
            type: trendingSearchesNearYouType,
            displayGroup: displayGroup
        };
    }

    function createTrendingSearchesNearOptions(regionModels, displayKey) {
        return _.reduce(
            regionModels,
            function (memo, regionModel) {
                memo.push(makeTrendingSearchesNearOption(regionModel, displayKey));
                return memo;
            },
            []);
    }

    TrendingSearchesNearYouInjector.prototype.inject = function (results, regionModels, options) {
        try {
            options = _.defaults(options || {}, {
                maxTotalOptions: 0
            });
            var maxTotalOptions = options.maxTotalOptions;
            var displayKey = options.displayKey;
            var trendingSearchesSuggestions = createTrendingSearchesNearOptions(regionModels, displayKey);
            //This is to determine number of trending suggestions based on # results sent from service/s
            var desiredNumberOfTrendingSearchesSuggestions = 0;
            //var desiredNumberOfTrendingSearchesSuggestions = Math.max(1, maxTotalOptions - results.length);
            if(results.length > 0) {
                desiredNumberOfTrendingSearchesSuggestions = 0;
            }
            else {
                desiredNumberOfTrendingSearchesSuggestions = maxTotalOptions;
            }
            trendingSearchesSuggestions.splice(desiredNumberOfTrendingSearchesSuggestions, Number.MAX_VALUE);
            TypeaheadUtils.injectSuggestions(results, trendingSearchesSuggestions, maxTotalOptions);
        } catch (error) {
            logError(error);
        }
    };

    window.TypeaheadUtils = window.TypeaheadUtils || {};
    window.TypeaheadUtils.TrendingSearchesNearYouInjector = TrendingSearchesNearYouInjector;
})();

define('gc/typeaheadConfig', ['gc/loc', 'gc/typeaheadCallbacks', 'env'], function(loc, TACallbacks, env) {
    return {
        typeahead: {
            def: {
                minchar: 3,
                maxresults: 10,
                version: 'v1',
                locale: env.locale ? env.locale : 'en_US',
                mask: 95,
                client: 'HOMEPAGE',
                lob: 'FLIGHTS',
                dest: false,
                closetext: loc.typeAhead.closetext,
                continuetext: loc.typeAhead.continuetext,
                tooltip: true,
                forceicon: false,
                template: 'default',
                cheapHotelsText: loc.typeAhead.cheapHotelsText,
                cheapHotelsInText: loc.typeAhead.cheapHotelsInText,
                bestDealsText: loc.typeAhead.bestDealsText,
                bestDealsInText: loc.typeAhead.bestDealsInText
            },
            flight_origin: {
                forceicon: 'flights',
                selectioncallback:TACallbacks.typeaheadFlightOriginCallback
            },
            flight_dest: {
                forceicon: 'flights',
                dest: true,
                selectioncallback:TACallbacks.typeaheadFlightDestinationCallback
            },
            // multi-dest flight fields
            flight_multi: {
                forceicon: 'flights',
                selectioncallback:TACallbacks.typeaheadMultiFlightDestinationCallback
            },
            hotel: {
                lob: 'HOTELS',
                dest: true,
                selectioncallback:TACallbacks.typeaheadItemClickCallback,
                inputEditCallback:TACallbacks.typeaheadInputEditedCallback,
                utaSelectionCallback:TACallbacks.typeaheadSuggestionSelectedCallback,
                mask:1759,
                version: 'v1'
            },
            package_origin: {
                forceicon: 'flights',
                lob: 'PACKAGES',
                selectioncallback: TACallbacks.typeaheadPackageOriginCallback
            },
            package_dest: {
                dest: true,
                lob: 'PACKAGES',
                selectioncallback: TACallbacks.typeaheadPackageDestinationCallback
            },
            package_FC_origin : {
                forceicon: 'flights',
                lob: 'PACKAGES',
                selectioncallback: TACallbacks.typeaheadPackageOriginCallback
            },
            package_FC_dest : {
                forceicon: 'flights',
                lob: 'PACKAGES',
                dest: false,
                selectioncallback: TACallbacks.typeaheadPackageDestinationCallback
            },
            package_hotel_car: {
                lob: 'HOTELS',
                selectioncallback: TACallbacks.typeaheadItemClickCallback
            },
            car_origin: {
                lob: 'CARS',
                selectioncallback: TACallbacks.typeaheadCarPickUpCallback,
                mask:31,
                version: 'v3',
                template: 'category'
            },
            car_dest: {
                lob: 'CARS',
                selectioncallback: TACallbacks.typeaheadCarDropOffCallback,
                forceicon: loc.masterconfig.switches.enableCarOffairportOnewaySearch ? false : 'flights',
                dest: true,
                mask: loc.masterconfig.switches.enableCarOffairportOnewaySearch ? 31 : 1,
                version: 'v3',
                template: 'category'
            },
            activity: {
                lob: 'ACTIVITIES',
                dest: true,
                mask:14,
                selectioncallback: TACallbacks.typeaheadActivityCallback
            },
            openSearch: {
            	lob: 'OPENSEARCH',
                selectioncallback: TACallbacks.typeaheadOpenSearchCallback,
                template: 'open-search-ta'
            },
            rail_origin: {
                lob: 'RAILS',
                minchar: 1,
                forceicon: 'train',
                selectioncallback:TACallbacks.typeaheadRailOriginCallback,
                mask:512,
                version: 'v4'
            },
            rail_dest: {
                lob: 'RAILS',
                minchar: 1,
                forceicon: 'train',
                dest: true,
                selectioncallback:TACallbacks.typeaheadRailDestinationCallback,
                mask:512,
                version: 'v4'
            }
        }
    };
});
//
// typeahead/core.js - a wrapper for the
//
// Documentation: http://confluence/display/POS/Typeahead+Javascript
// API documentation: http://confluence/display/POS/Expedia+Suggest+%28Type+Ahead%29+API+Family
//

define('gc/typeaheadWizard', [
    'gc/loc',
    'gc/config',
    'gc/dataModels',
    'gc/searchExperiments',
    'gc/ExpediaSuggestServiceRequestGenerator',
    'gc/TypeaheadMetricsLogger',
    'gc/TypeaheadSelectionToSubmissionLogger',
    'handlebars.runtime',
    'jquery',
    'gc/abTest',
    'gc/getLob',
    'gc/typeaheadCallbacks',
    'env',
    'gc/TypeaheadUtils',
    'gc/TypeaheadMeasurementTopics',
    'gc/TypeaheadScannabilityMeasurementsLogger',
    'gc/TypeaheadAddressAutocompleteHelper',
    'gc/carHelpers',
    'gc/pageModel',
    'gc/RecentHistoryOptionsInjector'
], function (
    loc,
    configObj,
    dataModels,
    searchExperiments,
    ExpediaSuggestServiceRequestGenerator,
    TypeaheadMetricsLogger,
    TypeaheadSelectionToSubmissionLogger,
    Handlebars,
    $,
    abTest,
    getLob,
    typeaheadCallbacks,
    env,
    TypeaheadUtils,
    TypeaheadMeasurementTopics,
    TypeaheadScannabilityMeasurementsLogger,
    TypeaheadAddressAutocompleteHelper,
    carHelpers,
    pageModel,
    RecentHistoryOptionsInjector
) {
    "use strict";
    // local copy of UITK passed into init so we don't have to set UITK as a dependacy.
    var _uitk;
    // some string constants
    var tooltipPlugin = 'uitk_tooltip',
        hammerManager,
        $window = $(window),
        windowWidth,
        dropDownWidth,
        triggerWidth,
        isCentered,
        autoPos,
        bodyMinWidth = parseFloat($('body').css('min-width')),
        nonResponsivePage = bodyMinWidth > 950 || Modernizr.mediaqueries === 'false' || Modernizr.mediaqueries === false,
        acDefaults = {
            gutter: 6,
            borderOffset: -2
        },
        control = '[data-control=autocomplete]',

    /** Classes **/
        autoCompleteClass = 'autocomplete',
        triggerClass = 'autocomplete-trigger-input',
        dropdownClass = 'autocomplete-dropdown',
        openClass = 'autocomplete-open',
        arrowClass = 'autocomplete-arrow',
        centerClass = 'pin-center',
        leftClass = 'pin-left',
        rightClass = 'pin-right',
        hlClass = 'highlight',


        promiseForGeolocationLiteral = "promiseForGeolocation",
        currentLocationLineItemText = "Use your current location",
        currentLocationInputFieldText = "Your current location";

    //Util function to determine if recent history experiments are on
    function isRecentHistoryExperiment(){
        return searchExperiments.getVariant("RECENT_HISTORY_HOTEL");
    }

    //Util function to determine if trending search experiment is on
    function isTrendingSearchesNearYouExperiment(){
        return (searchExperiments.getVariant("CWTA_JP_Recommendation") !== 0);
    }

    //Util function to determine if geolocation experiment is on
    function isCurrentLocationExperiment() {
        return (searchExperiments.getVariant("CURRENT_LOCATION") !== 0);
    }

    //Util function to determine if anchor input experiment is on
    function isAnchorInputOnFocusExperiment() {
        var onValidLob = _.contains(['flight', 'hotel'], getCurrentLob());
        return onValidLob &&
            (Modernizr.touch || isPastMobileBreakpoint()) &&
            (searchExperiments.getVariant("CWTA_AnchorTAOnTop") !== 0);
    }

    //Util function to check if the device is past the mobile breakpoint
    function isPastMobileBreakpoint() {
        if (uitk && uitk.mediaquery && uitk.mediaquery.getMediaQueries()) {
            return uitk.mediaquery.getMediaQueries().mobile.matches;
        }
        /* back-up value */
        return $('#wizard-theme-wrapper').hasClass('theme-pills');
    }

    //Util function to detrmine if selected item is geo location item
    function itemIsGeolocation($item) {
        var isGeolocation = false;
        var rawData;
        var parsedData;
        if ($item) {
            rawData = $item.attr('data-data');
            if (rawData) {
                try {
                    parsedData = JSON.parse(rawData);
                    isGeolocation = (parsedData && parsedData.type === "GEOLOCATION");
                }
                catch (e) {
                    // Do nothing.
                }
            }
        }
        return isGeolocation;
    }

    function userPickedCurrentLocation(){
        var promiseForGeolocation = corewizard.core.model.get('promiseForGeolocation');
        return _.isObject(promiseForGeolocation) && _.isFunction(promiseForGeolocation.state);
    }

    //Util function to show the typeahead popup with proper instance associated
    function showTaPopup($taContainer, taInstance){
        if($taContainer && $taContainer.is(':hidden')){
            // bind mouse handlers to this instance of the Typeahead input control
            $taContainer
                .on('mousedown', $.proxy(taInstance.clickOn, taInstance))
                .on('mouseup', $.proxy(taInstance.clickOff, taInstance))
                .on('click', $.proxy(taInstance.click, taInstance))
                .on('mouseenter', 'a', $.proxy(taInstance.mouseEnter, taInstance));

            if(Modernizr.touch){
                require('hammer', function(Hammer){
                    if(!hammerManager){
                        hammerManager = new Hammer.Manager($taContainer[0], {recognizers: []});
                    }

                    hammerManager.add(new Hammer.Tap());
                    hammerManager.on('tap', $.proxy(taInstance.hammerTapHandler, taInstance));
                });
            }

            // show the popup div
            $taContainer.closest('.' + autoCompleteClass).addClass(openClass);
            $taContainer.show();
            TypeaheadScannabilityMeasurementsLogger.getInstance();
            uitk.publish(TypeaheadMeasurementTopics.SuggestionsDisplayed, new TypeaheadUtils.TypeaheadSuggestionsDisplayedMeasurement(Date.now()));

            /**  Position dropDown if autoPos is true and page is responsive */

            if (autoPos && !nonResponsivePage) {
                taInstance.setAutocompletePos(taInstance.$parent);
            } else if (isCentered) {
                /** Center dropDown if autoPos is false or fixed page layout */
                taInstance.centerDropDown(taInstance.$parent);
            }

        }
    }

    //Util function to hide the typeahead popup with proper instance associated
    function hideTaPopup($taContainer, taInstance){
        if($taContainer){
            // unbind mouse handlers for this instance of the Typeahead input control
            $taContainer
                .off('mousedown', $.proxy(taInstance.clickOn, taInstance))
                .off('mouseup', $.proxy(taInstance.clickOff, taInstance))
                .off('click', $.proxy(taInstance.click, taInstance))
                .off('mouseenter', 'a', $.proxy(taInstance.mouseEnter, taInstance));

            if(Modernizr.touch){
                if(hammerManager) {
                    hammerManager.destroy();
                    hammerManager = null;
                }
            }

            // hide the popup div
            $taContainer.hide();
        }
    }

    function getClientsideExperiments() {
        function getAssignmentString(abacusId) {
            var experimentInfo = abTest.get(abacusId);
            var assignment = experimentInfo ? experimentInfo.value : undefined;
            return assignment ? String(abacusId) + "." +  assignment : undefined;
        }
        return _.compact(_.map(_.keys(searchExperiments.experimentDetails), getAssignmentString))
            .join("|");
    }

    function getCurrentLob() {
        return getLob(dataModels.model.get('tab'), dataModels.model.get('packages'));
    }

    //Util function to set TA related state attributes at starting of a request in TA
    function resetStateAtStart(taTriggerElemId) {

        var wizardState = dataModels.state;
        var currentLob = getCurrentLob();

        //If multi destination flights, reset the properties with the interacted TA instance
        if(currentLob=='flight' && wizardState.get('flighttype') === 'multi') {

            //TODO @vmohapatra : Preserve relation info for multi destination flights
            if(taTriggerElemId=='flight-destination') {
                wizardState.set('destinationFromTA',null);
                wizardState.set('destinationTLA',null);
                wizardState.set('TADestSearchType', null);
                wizardState.set('destSuggestionTypeId', null);
                wizardState.set('destinationSourceInfo', null);
                wizardState.set('destinationRelInfo', null);
            }
            else if(taTriggerElemId=='flight-origin') {
                wizardState.set('originFromTA',null);
                wizardState.set('originTLA',null);
                wizardState.set('TAOrigSearchType', null);
                wizardState.set('origSuggestionTypeId', null);
                wizardState.set('originSourceInfo', null);
                wizardState.set('originRelInfo', null);
            }

            if(
                _.contains(['flight-2-destination', 'flight-3-destination', 'flight-4-destination', 'flight-5-destination'], taTriggerElemId)
            ) {
                var multiFlightDestinations = wizardState.get('multiFlightDestination') || {};
                var multiFlightDestSuggTypeIds = wizardState.get('multiFlightDestSuggTypeId') || {};
                var multiFlightDestSrcInfo = wizardState.get('multiFlightDestSrc') || {};
                var multiFlightDestSuggTypes = wizardState.get('multiFlightDestSuggType') || {};
                var multiFlightDestRelInfo = wizardState.get('multiFlightDestRel') || {};
                wizardState.set('multiFlightDestination', typeaheadCallbacks.multiFlightHelper('', 'destination', taTriggerElemId, multiFlightDestinations, 'reset'));
                wizardState.set('multiFlightDestSuggTypeId', typeaheadCallbacks.multiFlightHelper(null, 'destination', taTriggerElemId, multiFlightDestSuggTypeIds, 'reset'));
                wizardState.set('multiFlightDestSrc', typeaheadCallbacks.multiFlightHelper(null, 'destination', taTriggerElemId, multiFlightDestSrcInfo, 'reset'));
                wizardState.set('multiFlightDestSuggType', typeaheadCallbacks.multiFlightHelper(null, 'destination', taTriggerElemId, multiFlightDestSuggTypes, 'reset'));
                wizardState.set('multiFlightDestRel', typeaheadCallbacks.multiFlightHelper(null, 'destination', taTriggerElemId, multiFlightDestRelInfo, 'reset'));
            }
            else if(
                _.contains(['flight-2-origin', 'flight-3-origin', 'flight-4-origin', 'flight-5-origin'], taTriggerElemId)
            ){
                var multiFlightOrigins = wizardState.get('multiFlightOrigin') || {};
                var multiFlightOrigSuggTypeIds = wizardState.get('multiFlightOrigSuggTypeId') || {};
                var multiFlightOrigSrcInfo = wizardState.get('multiFlightOrigSrc') || {};
                var multiFlightOrigSuggTypes = wizardState.get('multiFlightOrigSuggType') || {};
                var multiFlightOrigRelInfo = wizardState.get('multiFlightOrigRel') || {};
                wizardState.set('multiFlightOrigin',typeaheadCallbacks.multiFlightHelper('', 'origin', taTriggerElemId, multiFlightOrigins, 'reset'));
                wizardState.set('multiFlightOrigSuggTypeId',typeaheadCallbacks.multiFlightHelper(null, 'origin', taTriggerElemId, multiFlightOrigSuggTypeIds, 'reset'));
                wizardState.set('multiFlightOrigSrc',typeaheadCallbacks.multiFlightHelper(null, 'origin', taTriggerElemId, multiFlightOrigSrcInfo, 'reset'));
                wizardState.set('multiFlightOrigSuggType',typeaheadCallbacks.multiFlightHelper(null, 'origin', taTriggerElemId, multiFlightOrigSuggTypes, 'reset'));
                wizardState.set('multiFlightOrigRel',typeaheadCallbacks.multiFlightHelper(null, 'origin', taTriggerElemId, multiFlightOrigRelInfo, 'reset'));
            }

        }
        else if(
            (_.contains(['flight', 'hotel', 'flightHotel', 'flightHotelCar', 'flightCar', 'hotelCar', 'car', 'activity', 'rail'],getCurrentLob()))
            || carHelpers.isHotelAttachedWithCar(dataModels.model)
        ){

            //For LOBs with multiple TA trigger fields,
            //reset the state attributes associated with only
            //that field on interaction
            //Else reset per field for rest of LOBs ie hotel, hotelCar, activity
            // vmohapatra : String.indexOf works in IE8 : https://msdn.microsoft.com/en-us/library/53xtt423(v=vs.94).aspx
            if(taTriggerElemId.indexOf("destination") != -1 || taTriggerElemId.indexOf("pickup") != -1) {
                //Reset only destination fields
                wizardState.set('destinationFromTA', null);
                wizardState.set('destinationTLA', null);
                wizardState.set('TADestSearchType', null);
                wizardState.set('destSuggestionTypeId',null);
                wizardState.set('destinationSourceInfo', null);
                wizardState.set('destinationRelInfo', null);
                wizardState.set('destinationRegionId', null);
                wizardState.set('destinationLatitude', null);
                wizardState.set('destinationLongitude', null);
            }
            else if(taTriggerElemId.indexOf("origin") != -1 || taTriggerElemId.indexOf("dropoff") != -1) {
                //Reset only origin state fields
                wizardState.set('originFromTA', null);
                wizardState.set('originTLA', null);
                wizardState.set('TAOrigSearchType', null);
                wizardState.set('origSuggestionTypeId',null);
                wizardState.set('originSourceInfo', null);
                wizardState.set('originRelInfo', null);
                wizardState.set('originRegionId', null);
                wizardState.set('originLatitude', null);
                wizardState.set('originLongitude', null);
            }
        }
    }

    function shouldTryShowingSuggestionsOnFocus() {
        return isRecentHistoryExperiment() ||
            isTrendingSearchesNearYouExperiment() ||
            isCurrentLocationExperiment();
    }

    function expMultiVariantRenderStyles() {
        //Modifying the destination text in ess v4 for hotel LOB only
        // control and variant 4 use existing font size and icon color
        var expVariant = searchExperiments.getSearchExperimentVariant('10967');
        if(expVariant === "1") {
            //boldSearchDest for primary and grey icon
            //NOTE: for bolding we do not need to do anything explicit as the
            //displayName has the <b></b> tags in it for the entire serach destination
            $(".typeahead div .icon").css('color','#808080');
        }
        else if(expVariant === "2") {
            //fontsize smaller for secondary and boldSearchDest for primary
            //NOTE: for bolding we do not need to do anything explicit as the
            //displayName has the <b></b> tags in it for the entire serach destination
            $(".typeahead div .essNode1").css('font-size','1.15385em');//15px computed size
            $(".typeahead div .essNode2").css('font-size','1em');//13px computed size
        }
        else if(expVariant === "3") {
            //fontsize for secondary and grey icon
            //In this variant the any boldened text in display will come from ES based on query typed matched
            $(".typeahead div .essNode1").css('font-size','1.15385em');//15px computed size
            $(".typeahead div .essNode2").css('font-size','1em');//13px computed size
            $(".typeahead div .icon").css('color','#808080');
        }
    }

    //
    // Typeahead Constructor
    //
    window.Typeahead = function (element, config) {
      // True if and only if a suggestions for this input element has been selected and it has not been inputted since
        // the most recent selection.
        this.selectedSuggestionIsInEffect = false;

        // Accessibility
        this.firstItemFlag = true;

        // Get the config value per key (LOB or TAB value)
        this.opts = config.getAll(element.data('ta-key')).typeahead;

        this.template = Handlebars.partials['default/typeahead/' + this.opts.template];

        // State:
        this.searchType = null;
        this.cache = {};
        this.requestsOut = {};
        this.ignoreNext = false; // ???
        this.isClickOn = false;
        this.bodyClick = false;
        this.metricsLogger = null;
        this.selectionToSubmissionLogger = null;
        this.renderFromFocus = false;

        // Typeahead dialog and its listeners:
        bindDropDownListToTA(this, element);

        if (! config.tooltip) {
            if (!uitk.isTouchDevice) {
                this.$ta
                    .on('mousedown', $.proxy(this.clickOn, this))
                    .on('mouseup', $.proxy(this.clickOff, this))
                    .on('click', $.proxy(this.click, this))
                    .on('mouseenter', 'a', $.proxy(this.mouseEnter, this));
            } else {
                this.$ta.on('click', function (e) {
                    e.preventDefault()
                });
            }
        }

    };

    //
    // Prototype: defined with an IIFE
    //
    Typeahead.prototype = function () {
        // private helper methods can be defined between the opening brace and the return statement.
        function getIcon(resultType, category, forceIcon) {
            if (forceIcon && resultType !== "RECENTHISTORY") {
                if(searchExperiments.getSearchExperimentVariant('9241') !== "0") {
                    return '';
                }
                else {
                    return forceIcon;
                }
            }
            else {
                return category ? category.icon : 'location';
            }
        }

        function highlightOption(typeahead, $anchor) {
            var primaryText;
            var secondaryText;
            var announcement;
            $anchor.addClass('highlight');
            typeahead.$element.attr('aria-activedescendant', $anchor.attr("id"));
            $anchor.attr('aria-selected', 'true');

            //vmohapatra : We want to read state, country for Hotel but only want to use hotel name for search
            //data-announcement is populate only for hotel
            primaryText = $anchor.attr('data-announcement') ?
                              $anchor.attr('data-announcement')
                              : ($anchor.attr('data-value')? $anchor.attr('data-value') : ($anchor.children(".option-text-primary")[0] ? $anchor.children(".option-text-primary")[0].text() : '') );

            secondaryText = $anchor.children(".option-text-secondary");
            if (! _.isEmpty(secondaryText)) {
                secondaryText = $(secondaryText[0]).text();
            }
            announcement = _.compact([primaryText, secondaryText]).join(" ");
            if (! _.isEmpty(announcement)) {
                //conditionally doing liveAnnounce as it is causing NVDA to read extraneous data-value on Firefox
                if(!(window.navigator.userAgent.toLowerCase().indexOf('firefox') > -1)) {
                    uitk.utils.liveAnnounce(announcement, 'polite');
                }
            }

            if(searchExperiments.getVariant("CWTA_PrePopulateInput") !== 0) {
                updateWithDisplayName(JSON.parse($anchor.attr("data-data")), typeahead.$element);
            }
        }

        function updateWithDisplayName(dataData, $element) {
            var dValue =
                (dataData.d)
                    ?dataData.d
                    :dataData.regionNames.displayName;
            $element.val($("<span>" + dValue + "</span>").text());
        }

        function anchorInputOnFocus(target) {
            var page = $('body'),
                stopScrollEvents = 'wheel touchmove';

            if (!(target && $(target).hasClass(triggerClass))){
                return;
            }

            var anchor = $('#anchor-' + $(target).attr('id'));
            if (!anchor) {
                return;
            }

            var zoom = document.documentElement.clientWidth / window.innerWidth;
            if (zoom > 1) {
                // known web issue: inconsistent offsets while zoomed
                return;
            }

            // label has line-height == 1.4 which adds font-size * 0.2 padding to top and bottom
            // font-size is 12px so we need extra 10.6px to reach 13px
            var destination = anchor.offset().top - 10.6;
            var currentOffset = page.scrollTop();

            // if it's close enough, don't bother scrolling
            if (Math.abs(currentOffset - destination) < 6.5) {
                return;
            }

            // stop animation if user tries to move page manually
            page.on(stopScrollEvents, function () {
                page.off(stopScrollEvents);
                page.stop();
            });

            page.animate({
                scrollTop: destination
            }, 300);

        }

        function doInjectRecentOptions(results, recentHistoryOptionsInjector, recentHistoryOptions, taMetadata,
                                       wizardState)
        {
            recentHistoryOptionsInjector.inject(results, recentHistoryOptions);
            taMetadata.userHistoryItemsTotal =
                recentHistoryOptionsInjector ? recentHistoryOptionsInjector.countInjectedOptions() : 0;
            wizardState.set('userHistoryItemsTotal',taMetadata.userHistoryItemsTotal);
        }

        function doInjectRecommenderOptions(typeahead, results, trendingSearchesNearYouInjector,
                                            trendingSearchesNearYouOptions, taMetadata, wizardState)
        {
            trendingSearchesNearYouInjector.inject(
                results,
                TypeaheadUtils.trendingSearchesDataProvider.getRegionModels(
                    typeahead.getLob(), typeahead.$element.attr("id")),
                trendingSearchesNearYouOptions);
            // since we never mix "Trending searches near you" entries with ess entries
            // at this point, the number of items in the results list is the count of
            // recommender options we're showing to the user
            taMetadata.recommenderOptionsRendered = results.length;
            wizardState.set('recommenderOptionsRendered', taMetadata.recommenderOptionsRendered);
        }

        function injectUseYourCurrentLocationOptionIfApplicable(results, maxResults) {
            var useYourCurrentLocationOption;
            if(isCurrentLocationExperiment()) {
                useYourCurrentLocationOption = {
                    regionNames: {
                        displayName: currentLocationLineItemText,
                        lastSearchName: '',
                        fullName: currentLocationInputFieldText
                    },
                    type: 'GEOLOCATION',
                    displayGroup: ".CURRENT_LOCATION"
                };
                TypeaheadUtils.injectSuggestions(results, [useYourCurrentLocationOption], maxResults);
            }
        }

        // "statically" track which element received focus last. This is
        // the id of the latest interactive typeahead element that the the user was
        // interacting with. This piece of state is shared by all instances of
        // Typeahead which share this common prototype.
        var lastFocusedElementId;

        // return the prototype definition object and assign to Typeahead.prototype
        return {
            constructor: Typeahead,
            shouldBeOpen: false,
            startRequest: function () {
                var text = this.$element.val();
                var wizardState = dataModels.state;

                this.template = Handlebars.partials['default/typeahead/default'];

                if(_.contains(['openSearch'], getCurrentLob())) {
                    this.template = Handlebars.partials['default/typeahead/open-search-ta'];
                }

                if(_.contains(['car', 'hotelAttachedWithCar'], getCurrentLob()) || carHelpers.isHotelAttachedWithCar(dataModels.model)) {
                    this.template = Handlebars.partials['default/typeahead/default'];
                }

                if (searchExperiments.getVariant("BEST_DEALS_OPTION") !== 0) {
                    wizardState.set('sort', null);
                }
                //Set the user typed text which triggers the typeahead request in corewizard state for latest instance
                wizardState.set('userTypedQuery', text);

                var taTriggerElemId = this.$element.attr('id');
                //Every time typeahead request starts set the triggering element ID in state
                wizardState.set('taTriggerElemId', taTriggerElemId);

                //Reset the field specific states at the start of the request
                resetStateAtStart(taTriggerElemId);

                //clear the selection states for TypeaheadSelectionToSubmissionLogger at the start of the request
                TypeaheadSelectionToSubmissionLogger.clearSelection();

                //vmohapatra: Everytime TA request is sent reset the following attributes
                //which are tied to latest interaction only
                wizardState.set('selectedTASuggestionPosition', null);
                wizardState.set('TASearchType', null);
                wizardState.set('suggestionType', null);//holds 'child' info
                wizardState.set('essItemsTotal', 0);
                wizardState.set('taMetadata',null);
                wizardState.set('activeESSTests',null);

                //Reset the typeahead related flags
                corewizard.OMTypeAheadRendered = false;
                //Info pertaining to latest interaction
                wizardState.set('taMetadata',null);
                //reset the attributes which are expected to be populated only via Typeahead
                wizardState.set('hotelId', null);
                wizardState.set('multiCityRegion', null);
                wizardState.set('regionId', null);
                wizardState.set('latLong', null);

                //Reset user history specific state variables if the experiment is on
                if(isRecentHistoryExperiment()) {
                    wizardState.set('userHistoryItemsTotal',0);
                    wizardState.set('userHistoryItemAge',null);
                }

                //Reset Trending Suggestions specific state variables if the experiment is on
                if(isTrendingSearchesNearYouExperiment()) {
                    wizardState.set('recommenderOptionsRendered', 0);
                }

                //Reset Geo Location suggestion specific state variables if the experiment is on
                if(isCurrentLocationExperiment()) {
                    wizardState.set('currentLocationShown', 0);
                    wizardState.set('currentLocationDetails', null);
                }

                //if Experiment 6739 is on && is across all lobs
                if (searchExperiments.getSearchExperimentVariant('6739') !== "0" || searchExperiments.getSearchExperimentVariant('9110') !== "0") {
                    if ( searchExperiments.getSearchExperimentVariant('6739') == "1" ||
                         (env.siteId && _.contains([18, 62, 75], env.siteId) && searchExperiments.getSearchExperimentVariant('9110') == "1")
                    ) {
                        this.opts.minchar = 1;
                    }
                    else if (searchExperiments.getSearchExperimentVariant('6739') == "2" ||
                         (env.siteId && _.contains([18, 62, 75], env.siteId) && searchExperiments.getSearchExperimentVariant('9110') == "2")) {
                        this.opts.minchar = 2;
                    }
                }

                if (shouldTryShowingSuggestionsOnFocus()) {
                    this.opts.minchar = 0;
                }

                // car max results experiment
                if (_.contains(['car', 'hotelAttachedWithCar'], getCurrentLob()) || carHelpers.isHotelAttachedWithCar(dataModels.model)) {
                    var variant = searchExperiments.getVariant("CWTA_MaxSuggestionsCars");
                    if (1 <= variant && variant <= 3) {
                        this.opts.maxresults = 5 + variant;
                    }
                }

                if (this.renderFromFocus) {
                    if (isRecentHistoryExperiment()) {
                        wizardState.set('userTypedQuery', '');
                        this.render($.trim(this.$element.val()), [])
                    }
                }
                //vmohapatra : compare of the text length is greater or equal to the min char trigger
                else {
                    if (text.length >= this.opts.minchar) {
                        if ((!this.cache[text] && !this.requestsOut[text]) || text.length === 0) {
                            this.request(text);
                        }
                        else if (this.cache[text]) {
                            this.render(text, this.cache[text], /*serviceResults not from Google Autocomplete*/false);
                        }
                    }
                }

                if(text.length > 0){
                    //show
                    this.$element.parent().parent().children(".icon-close").removeClass("visuallyhidden");
                }
                else if(text.length == 0){
                    //hide
                    this.$element.parent().parent().children(".icon-close").addClass("visuallyhidden");
                }
            },

            request: function (text) {
                this.requestsOut[text] = true;
                Typeahead.request(text, this, this.opts, this.callback);
            },

            callback: function (essTAJsonResponse) {
                var wizardState = dataModels.state;
                var currentLob = getCurrentLob();
                var q = '',  // default search query string
                    results = []; // default empty results array

                //Set the active AB tests running in service typeahead request in corewizard state
                var activeESSTests = essTAJsonResponse && essTAJsonResponse.activeABTests ? essTAJsonResponse.activeABTests : null;
                wizardState.set('activeESSTests', activeESSTests);

                this.getMetricsLogger().timestamp(
                    this.getMetricsLogger().TimestampCategories.ESS_RESPONSE, essTAJsonResponse ? essTAJsonResponse.q : null);

                if(essTAJsonResponse && essTAJsonResponse.rc == "ADDRESS_AUTOCOMPLETE") {
                    TypeaheadAddressAutocompleteHelper.autocompleteAddress(essTAJsonResponse, this, lastFocusedElementId);
                }
                else{
                    if (currentLob === 'openSearch') {
                        results = essTAJsonResponse.opensearchresult ? essTAJsonResponse.opensearchresult : essTAJsonResponse.r;
                    }
                    else {
                        if(essTAJsonResponse){
                            results = essTAJsonResponse.sr ? essTAJsonResponse.sr : (essTAJsonResponse.r ? essTAJsonResponse.r : []);
                        }
                        if (searchExperiments.getVariant("BEST_DEALS_OPTION") !== 0) {
                            this.getBestDealsOptionInjector().inject(results);
                        }
                    }

                    if(this.shouldRender(essTAJsonResponse, results, lastFocusedElementId)){

                        if(essTAJsonResponse && _.isString(essTAJsonResponse.q)) {
                            q = essTAJsonResponse.q;
                        }

                        this.requestsOut[q] = false;

                        // the user is still interacting with the same typeahead element now that was
                        // active when this HTTP request that went out to fetch ESS search results
                        // so we can go ahead and render those results now. This avoids rendering stale
                        // data in a control that is no longer the active typeahead control.
                        if(results.length > 0){
                            this.cache[q] = results;
                            this.render(q, this.cache[q], /*serviceResults not from Google Autocomplete*/false);
                        }
                        else {
                            this.render(q, results, /*serviceResults not from Google Autocomplete*/false);
                        }
                    }
                    else {
                        this.cache[q] = [];
                        this.close();
                    }
                }
            },
            //shouldRender() also being used in TypeaheadAddressAutocompleteUtil.js
            shouldRender: function (essJsonResponse, essResults, lastFocused) {

                    var q='';
                    if(essJsonResponse && _.isString(essJsonResponse.q)) {
                        q = essJsonResponse.q;
                    }
                    this.requestsOut[q] = false;
                    if (essResults && this.shouldBeOpen) {
                        if (lastFocused === this.$element.attr('id')) {
                        // the user is still interacting with the same typeahead element now that was
                        // active when this HTTP request that went out to fetch ESS search results
                        // so we can go ahead and render those results now. This avoids rendering stale
                        // data in a control that is no longer the active typeahead control.
                            return true
                        }
                    }
                    return false;
            },

            // given input parameters of search text (prefix any word) and a reference to
            // external search results, either from a fresh ESS Ajax request or a previously cached
            // array, render the results into the typeahead tooltip window.
            // NOTE: the incoming results array is a reference to data that exists elsewhere
            // and is expected to only contain external service search results or a cached version thereof
            render: function (srchText, serviceResults, isGoogleAddressAutocompleteCall) {
            //isGoogleAddressAutocompleteCall -- boolean
            //       true: Skip all injector and category logic in render, only render serviceResults which should only contains Google Autocomplete predictions.
            //             Additional logging in suggestionEngagement for Google Autocomplete call.
            //       false: render ESS result with all injector and category logic.

                var wizardState = dataModels.state;
                var essv4exp = _.reduce(
                        [
                            "9432", // consuming ESS v4 for activities LOB
                            "9433"  // consuming ESS v4 for packages LOB
                        ],
                        function (memo, abacusId) {
                            //memo is the previous value (implements if else if logic) false is initial value for memo
                            return memo || (searchExperiments.getSearchExperimentVariant(abacusId) !== "0")
                        },
                        false
                    ),
                    bestDealsOptionVariant = searchExperiments.getVariant("BEST_DEALS_OPTION"),
                    currentLob = getCurrentLob(),
                    recentHistoryOptionsInjector,
                    trendingSearchesNearYouInjector = this.getTrendingSearchesNearYouInjector(),
                    // default our search term and results array to empty
                    text = '',
                    // pull the existing text out of the input field one time
                    $inputFieldText = $.trim(this.$element.val()),
                    results = [],
                    recentHistoryOptions = {
                        srchText: '',
                        elementId: '',
                        lineOfBusiness: '',
                        flightType: '',
                        maxTotalOptions: 0
                    },
                    trendingSearchesNearYouOptions = {
                        maxTotalOptions: 0
                    },
                    content,
                    that,
                    resultsLengthAnnouncement = ' results displayed for your search. Use the arrow keys to browse them.',
                    taMetadata = {};

                if (this.renderFromFocus) {
                    recentHistoryOptionsInjector = Typeahead.recentHistoryOptionsInjector;
                }

                var taTriggerElemId = this.$element.attr('id');

                if (_.isArray(serviceResults)) {
                    // Fix for ECOMSVC-1532
                    // Create a deep clone of the incoming ESS search results
                    // thus treating the incoming results as an immutable array.
                    // This incoming array may in fact be a reference to this.cache[srchText]
                    // Further down we actually alter and extend the items in the results array
                    // in order to send the data on to the Handlebars template. We don't want
                    // this alteration to leak back into the cache.
                    results = JSON.parse(JSON.stringify(serviceResults));
                    //Get the number of suggestions returned by ESS
                    taMetadata.essItemsTotal = results.length;
                    wizardState.set('essItemsTotal', taMetadata.essItemsTotal);
                }

                if(_.isString(srchText)){
                    // default to passed in search term
                    text = $.trim(srchText);
                } else {
                    // or search on the existing text (which might be an empty string)
                    text = $inputFieldText;
                }

                //Set up for User History experiment if the experiment is ON and user is bucketed in
                if(!isGoogleAddressAutocompleteCall)
                {
                    if(recentHistoryOptionsInjector){
                        // If we are in the recent histories experiment, then we have the recentHistoryOptionsInjector
                        // Setup to make the inject() call
                        recentHistoryOptions.elementId = this.$element.attr('id');
                        recentHistoryOptions.lineOfBusiness = getCurrentLob();
                        recentHistoryOptions.flightType = dataModels.model.get('flighttype');
                        recentHistoryOptions.maxTotalOptions = this.opts.maxresults;

                        // there's a requirement to handle render differently when it is initiated from a
                        // focus event. In that case, don't use existing search text for the recent
                        // history list, we get the full list without filtering.
                        // https://eiwork.mingle.thoughtworks.com/projects/ewe_discovery_services/cards/1986
                        recentHistoryOptions.srchText = this.renderFromFocus ? '' : text;
                        this.renderFromFocus = false; // turn off this flag
                    }

                    //Set up for Trending Search experiment is ON and user is bucketed in
                    if (trendingSearchesNearYouInjector) {
                        trendingSearchesNearYouOptions.maxTotalOptions = this.opts.maxresults;
                        var trendingVariant = searchExperiments.getVariant('TRENDING_SEARCHES_NEAR_YOU');

                        switch(trendingVariant) {
                            case 1: trendingSearchesNearYouOptions.displayKey = "city" ; break;
                            case 2: trendingSearchesNearYouOptions.displayKey = "longName" ; break;
                            default: trendingSearchesNearYouOptions.displayKey = "longName" ;
                        }
                    }
                }

                var isOpenSearch = (currentLob === 'openSearch');
                var isGemmaActive = (abTest.get(10406).value == "2");
                //Global rollout of ESS v4 for hotel, flight, opensearch LOB
                if ((_.contains(['flight', 'hotel', 'car', 'openSearch', 'hotelAttachedWithCar'], currentLob)) || carHelpers.isHotelAttachedWithCar(dataModels.model)) {
                    essv4exp = true;
                }

                if(isGoogleAddressAutocompleteCall){
                    essv4exp = true;
                }
                var model = {};

                //vmohapatra: Include the logic to indicate origin / destination fields for Flight LOB
                if (currentLob == 'flight') {
                    var contextID = this.$element.context.id;
                    //Add the context for both Origin and destination fields
                    model.multiFlightInputId = contextID;
                }

                // does this have ESS results, and has the typeahead changed?
                if (results.length > 0 && $inputFieldText == text) {

                    corewizard.OMTypeAheadRendered = true;
                    var typeAheadContainer = $('.theme-typeahead');
                    this.$element.removeAttr('aria-describedby');

                    $(typeAheadContainer).removeAttr('role', 'tooltip');
                    $(typeAheadContainer).attr('role', 'presentation');

                    //Inject user history suggestions in the results if the experiment is ON
                    if(isGoogleAddressAutocompleteCall === false)
                    {
                        if (recentHistoryOptionsInjector) {
                            doInjectRecentOptions(results, recentHistoryOptionsInjector, recentHistoryOptions, taMetadata,
                                wizardState);
                        }

                        //If there has been no user input wipe out suggestions from ESS from results
                        if (!this.beenInputed()) {
                            //vmohapatra : Assumption is Scratchpad and Trending Search experiments would never be on at the same time
                            //Inject trending search suggestions in the results if the experiment is ON
                            if (trendingSearchesNearYouInjector) {
                                results = [];
                                //Resetting essItemsTotal to 0 as we would not display them in this case
                                taMetadata.essItemsTotal = 0;
                                wizardState.set('essItemsTotal', 0);
                                doInjectRecommenderOptions(this, results, trendingSearchesNearYouInjector,
                                    trendingSearchesNearYouOptions, taMetadata, wizardState);

                                // since we never mix "Trending searches near you" entries with ess entries
                                // at this point, the number of items in the results list is the count of
                                // recommender options we're showing to the user
                                taMetadata.recommenderOptionsRendered = results.length;
                                wizardState.set('recommenderOptionsRendered', taMetadata.recommenderOptionsRendered);

                            }
                            injectUseYourCurrentLocationOptionIfApplicable(results, this.opts.maxresults);
                        }
                        else {
                            if (trendingSearchesNearYouInjector) {
                                //Since there has been user input no recommender suggestions were shown
                                taMetadata.recommenderOptionsRendered = 0;
                                wizardState.set('recommenderOptionsRendered', 0);
                            }
                        }

                        // Sort the results:
                        results.sort(function (a, b) {
                            var sortedResult = essv4exp ? (a.index - b.index) : (a.i - b.i);
                            return sortedResult;
                        });

                        var opts = this.opts;

                        if (bestDealsOptionVariant && !Typeahead.CATEGORIES.DEALS.name) {
                            Typeahead.CATEGORIES.DEALS.name =
                                ['', this.opts.bestDealsText, this.opts.cheapHotelsText][bestDealsOptionVariant];
                        }
                        var categoriesPresent = {};
                        $.each(results, function (i, result) {
                            var category = essv4exp ?
                                ((isOpenSearch && !isGemmaActive) ?
                                    ((result.regionType == 'HOTEL') ? result.regionType : result.lob) : result.type) : result.rt;
                            if (typeof categoriesPresent[category] === 'undefined') {
                                categoriesPresent[category] = true;
                            }
                        });

                        // Create a mapping from category to results:
                        var resultsByCategory = {};
                        if (this.opts.lob == 'HOTELS') {
                            if (categoriesPresent['CITY']) resultsByCategory[Typeahead.CATEGORIES.CITY.name] = [];
                            if (categoriesPresent['ATTRACTION']) resultsByCategory[Typeahead.CATEGORIES.ATTRACTION.name] = [];
                            if (categoriesPresent['AIRPORT']) resultsByCategory[Typeahead.CATEGORIES.AIRPORT.name] = [];
                            if (categoriesPresent['HOTEL']) resultsByCategory[Typeahead.CATEGORIES.HOTEL.name] = [];
                            if (categoriesPresent['TRAINSTATION']) resultsByCategory[Typeahead.CATEGORIES.TRAINSTATION.name] = [];
                            if (categoriesPresent['METROSTATION']) resultsByCategory[Typeahead.CATEGORIES.METROSTATION.name] = [];
                            if (categoriesPresent['MULTICITY']) resultsByCategory[Typeahead.CATEGORIES.MULTICITY.name] = [];
                            if (categoriesPresent['NEIGHBORHOOD']) resultsByCategory[Typeahead.CATEGORIES.NEIGHBORHOOD.name] = [];
                            if (categoriesPresent['METROCODE']) resultsByCategory[Typeahead.CATEGORIES.METROCODE.name] = [];
                            if (categoriesPresent['POI']) resultsByCategory[Typeahead.CATEGORIES.POI.name] = [];
                        }
                        else if (this.opts.lob == 'CARS' || carHelpers.isHotelAttachedWithCar(dataModels.model)) {
                            if (categoriesPresent['AIRPORT']) resultsByCategory[Typeahead.CATEGORIES.AIRPORT.name] = [];
                            if (categoriesPresent['CITY']) resultsByCategory[Typeahead.CATEGORIES.CITY.name] = [];
                            if (categoriesPresent['ATTRACTION']) resultsByCategory[Typeahead.CATEGORIES.ATTRACTION.name] = [];
                        }
                        else if (this.opts.lob == 'OPENSEARCH') {
                            if (categoriesPresent['HOTEL_NAME']) resultsByCategory[Typeahead.CATEGORIES.HOTEL_NAME.name] = [];
                            if (categoriesPresent['HOTELS']) resultsByCategory[Typeahead.CATEGORIES.HOTELS.name] = [];
                            if (categoriesPresent['FLIGHTS']) resultsByCategory[Typeahead.CATEGORIES.FLIGHTS.name] = [];
                            if (categoriesPresent['PACKAGES']) resultsByCategory[Typeahead.CATEGORIES.PACKAGES.name] = [];
                            if (categoriesPresent['CARS']) resultsByCategory[Typeahead.CATEGORIES.CARS.name] = [];
                            if (categoriesPresent['ACTIVITIES']) resultsByCategory[Typeahead.CATEGORIES.ACTIVITIES.name] = [];
                            if (categoriesPresent['CRUISES']) resultsByCategory[Typeahead.CATEGORIES.CRUISES.name] = [];
                        }
                    }
                    else{
                        wizardState.set('essItemsTotal', 0);
                        taMetadata.essItemsTotal = 0;
                    }

                    var isOriginField = (this.$element.context.id).indexOf('origin') !== -1;
                    if (essv4exp) {
                        $.each(results, function (i, result) {
                            //Allen Kim: Not sure why but BE POS is returning multiregion types which don't appear to be
                            //a recognized type. Just going to skip on multiregion type since we are still using v1 TA which
                            //is deprecated now.
                            if (searchExperiments.getSearchExperimentVariant('8664') === "0" && result.type == "MULTIREGION") {
                                //Return only if MULTIREGION are not exposed
                                return;
                            }

                            var category = undefined;

                            if(isGoogleAddressAutocompleteCall === false)
                            {
                                // Added to accomodate plane icon for Type 4 neighbourhoods: ESS experiment 11374 CWTA_AirportIconForNBHDs
                                // https://eiwork.mingle.thoughtworks.com/projects/ewe_discovery_services/cards/3292
                                if (result.type == "NEIGHBORHOOD" && result.subtype == "AIRNBH") {
                                    category = Typeahead.CATEGORIES['AIRPORT'];
                                }
                                else if (result.type == "ADDRESS") {
                                    var subtype = result.subtype;
                                    switch (subtype) {
                                        case 'RENTALLOCATION' :
                                            subtype = 'RENTAL';
                                            break;
                                        case 'CARRENTALADDRESS' :
                                            subtype = 'RENTAL';
                                            break;
                                        case 'POSTALCODE' :
                                            subtype = 'POSTCODE';
                                            break;
                                        default :
                                            subtype = result.subtype;
                                    }

                                    category = result.subtype ? Typeahead.CATEGORIES[subtype] : Typeahead.CATEGORIES[result.type];
                                }
                                else if (isOpenSearch) {
                                    if(isGemmaActive){
                                        category = 'GEMMA' ;
                                    }
                                    else {
                                        category = result.regionType == 'HOTEL' ?
                                            Typeahead.CATEGORIES['HOTEL_NAME'] :
                                            Typeahead.CATEGORIES[result.lob];
                                    }
                                }
                                else {
                                    category = Typeahead.CATEGORIES[result.type];
                                }

                                var categoryName = category ? category.name : 'Other'; // TODO : does this case exist? can we move the string to config?

                                if (typeof resultsByCategory[categoryName] === 'undefined') {
                                    resultsByCategory[categoryName] = [];
                                }
                                result.categoryName = categoryName;
                                resultsByCategory[categoryName].push(result);

                                if (searchExperiments.getVariant("CWTA_RemoveFlightIcon") === 0) {
                                    result.icon = getIcon(result.type, category, opts.forceicon);
                                }
                                else if (searchExperiments.getVariant("CWTA_RemoveFlightIcon") === 1) {
                                    if (!(currentLob === 'flight' || isOriginField)) {
                                        result.icon = getIcon(result.type, category, opts.forceicon);
                                    }
                                }

                            }
                            else
                            {
                                result.categoryName = Typeahead.CATEGORIES.ADDRESS.name;
                                result.icon = Typeahead.CATEGORIES.ADDRESS.icon;
                            }

                            if (typeof result.regionNames.lastSearchName != "undefined") {
                                //vmohapatra : If result type is hotel we want the fullname to be populated in the search box
                                if(result.type === "HOTEL") {
                                    result.regionNames.announceName = Typeahead.encodeHtmlCharacterReferences(result.regionNames.lastSearchName);
                                    result.regionNames.lastSearchName = Typeahead.encodeHtmlCharacterReferences(result.regionNames.fullName);
                                }
                                else {
                                    result.regionNames.lastSearchName = Typeahead.encodeHtmlCharacterReferences(result.regionNames.lastSearchName);
                                }
                            }
                            else {
                                result.regionNames.lastSearchName = Typeahead.encodeHtmlCharacterReferences(result.regionNames.fullName);
                            }

                            //Add typeahead metadata to each item
                            result.taMetadata = taMetadata;
                            //Set the metadata in the wizard state
                            wizardState.set('taMetadata',taMetadata);

                            result.data =  JSON.stringify(result);
                        });

                    }
                    else {
                        $.each(results, function (i, result) {
                            //Allen Kim: Not sure why but BE POS is returning multiregion types which don't appear to be
                            //a recognized type. Just going to skip on multiregion type since we are still using v1 TA which
                            //is deprecated now.

                            if (result.t === "MULTIREGION") return;

                            var category = undefined;

                            if ((_.contains(['car', 'hotelAttachedWithCar'], currentLob) || carHelpers.isHotelAttachedWithCar(dataModels.model) ) && result.rt === "ADDRESS") {
                                category = Typeahead.CATEGORIES['RENTAL'];
                            }
                            else {
                                category = Typeahead.CATEGORIES[result.rt];
                            }

                            var categoryName = category ? category.name : 'Other'; // TODO : does this case exist? can we move the string to config?

                            if (typeof resultsByCategory[categoryName] === 'undefined') {
                                resultsByCategory[categoryName] = [];
                            }
                            result.categoryName = categoryName;
                            resultsByCategory[categoryName].push(result);

                            if (searchExperiments.getVariant("CWTA_RemoveFlightIcon") === 0) {
                                result.icon = getIcon(result.type, category, opts.forceicon);
                            }
                            else if (searchExperiments.getVariant("CWTA_RemoveFlightIcon") === 1) {
                                if (!(currentLob === 'flight' || isOriginField)) {
                                    result.icon = getIcon(result.type, category, opts.forceicon);
                                }
                            }

                            if (typeof result.l != "undefined")
                                result.l = Typeahead.encodeHtmlCharacterReferences(result.l);
                            else
                                result.l = Typeahead.encodeHtmlCharacterReferences(result.f);

                            //Add typeahead metadata to each item
                            result.taMetadata = taMetadata;
                            //Set the metadata in the wizard state
                            wizardState.set('taMetadata',taMetadata);

                            result.data = JSON.stringify(result);
                        });
                    }

                    // Create an object to pass to the template:
                    //Add necessary variables to pass to existing model as needed for Geo-Hierarchy experiment
                    //eg : experiment variation

                    model.isGoogleAddressAutocompleteCall = isGoogleAddressAutocompleteCall;
                    model.continueText = this.opts.continuetext;
                    model.closeText = this.opts.closetext;
                    model.results = results;
                    model.resultsByCategory = resultsByCategory;
                    model.ariaOwns = this.ariaOwns;
                    model.isV4 = essv4exp;

                    model.resultsByDisplayGroup = _.groupBy(results, function(result){
                        return result.displayGroup ? result.displayGroup : "";
                    });

                    if (!_.isEmpty(model.results)) {
                        this.getMetricsLogger().suggestionEngagement.suggestionShown = true;
                        this.getMetricsLogger().suggestionEngagement.isAddrAutocomplete = isGoogleAddressAutocompleteCall;
                    }

                    content = this.template(model);
                    this.$ta.html(content);

                    this.$label.addClass('focused');
                    /* //@vmohapatra : TODO refactor code related to accessibility in TA
                    if (this.opts.tooltip) {

                        if (window.navigator.msPointerEnabled && !window.PointerEvent) {
                            // bind 'this' for use in the uitk.clickEvent and focusin callback
                            that = this;

                            // Using feature detection we can diff between IE 11 and IE 10.
                            // Pointer events were added in IE10 (window.PointerEvent).
                            // The syntax changed in IE 11 (vendor prefix was removed).
                            // If pointer events are supported - and - the new syntax is supported, we know it is IE 11.
                            // If pointer events supported and the new syntax is not supported -- then we know it is IE 10.

                            $('body').on(uitk.clickEvent + ' focusin.' + tooltipPlugin, function (e) {
                                if (e.type === 'focusin' && !uitk.utils.isFocusableElement($(e.target))) {
                                    return;
                                }
                                //don't close if clicked on $ta
                                if (e.target === that.$element[0]) {
                                    return;
                                }

                                that.close();
                            });
                        }

                        //If it is a touch device (ipad) Do not announce number of results displayed
                        if (!$('html').hasClass('appleios')) {
                            uitk.utils.liveAnnounce(results.length + resultsLengthAnnouncement, 'polite');
                        }
                    }
                    else {
                        var height = parseInt(this.$element.css('height'), 10);

                        var offset = this.$element.offset();
                        this.$ta.css({
                            top: offset.top + height + 'px',
                            left: offset.left + 'px'
                        });
                    }
                    */
                    if(results.length > 0){
                        // only show popup when we have something
                        // to actually render
                        showTaPopup(this.$ta, this);

                        //Followup up of 9971 style the typeahead suggestion per the multi variant factors
                        expMultiVariantRenderStyles();

                        //If experiment 9241 is ON
                        if(searchExperiments.getSearchExperimentVariant('9241') !== "0") {
                           $(".typeahead div .icon").css('padding-right','0em');
                           $(".typeahead .child-suggestion").css('padding-left','0em');
                           $(".typeahead .child-suggestion .icon").css('padding-right','0.65em');
                           $(".typeahead .child-suggestion .icon").css('padding-left','0.96923077em');
                        }

                        //vmohapatra: Enabling Announcement of results displayed
                        //If it is a touch device (ipad) Do not announce number of results displayed
                        if (!$('html').hasClass('appleios')) {	
                            setTimeout(function () {
                                uitk.utils.liveAnnounce(results.length + resultsLengthAnnouncement, 'polite');
                                setTimeout(function () {
                                    uitk.utils.liveAnnounce('', 'polite');
                                    }, 200); //Reset the last spoken text
                                }, 800); // Delay to give enough time for the voice over to finish saying the current word
                        }
                    }
                }
                else if (results.length == 0) {
                    // even though there's an empty results array to inject into,
                    // we still want to match any recent histories no matter what the
                    // state of the input text is, empty or otherwise...

                    //Inject user history suggestions in the results if the experiment is ON
                    if (recentHistoryOptionsInjector) {
                        doInjectRecentOptions(results, recentHistoryOptionsInjector, recentHistoryOptions, taMetadata,
                            wizardState);

                        // Get the number of userHistory suggestions injected
                        taMetadata.userHistoryItemsTotal = recentHistoryOptionsInjector ? recentHistoryOptionsInjector.countInjectedOptions() : 0;

                        wizardState.set('userHistoryItemsTotal', taMetadata.userHistoryItemsTotal);
                    }

                    //Inject trending search suggestions in the results if the experiment is ON
                    if (trendingSearchesNearYouInjector) {
                        doInjectRecommenderOptions(this, results, trendingSearchesNearYouInjector,
                            trendingSearchesNearYouOptions, taMetadata, wizardState);

                        // since we never mix "Trending searches near you" entries with ess entries
                        // at this point, the number of items in the results list is the count of
                        // recommender options we're showing to the user
                        taMetadata.recommenderOptionsRendered = results.length;
                        wizardState.set('recommenderOptionsRendered', taMetadata.recommenderOptionsRendered);

                    }
                    injectUseYourCurrentLocationOptionIfApplicable(results, this.opts.maxresults);
                    if (results.length > 0) {
                        model.results = results;
                    }

                    //Set the number of ESS items retrieved ie 0
                    wizardState.set('essItemsTotal', taMetadata.essItemsTotal);
                    wizardState.set('taMetadata',taMetadata);

                    //vmohapatra NOTE: never pass a string object to isEmptyObject() as gives wrong result in IE8
                    // in order to render, we need a list that will be rendered so we check the results array.
                    // The extra check makes it so we never see an empty typeahead popup dialog
                    if ($.isEmptyObject(model) == false && model.results && model.results.length > 0) {
                        this.getMetricsLogger().suggestionEngagement.suggestionShown = true;
                        //Add indication if its ESS V4 response
                        model.isV4 = essv4exp;
                        model.closeText = this.opts.closetext;

                        _.each(results, function (result) {

                            $.extend(result, {
                                taMetadata: taMetadata,
                                icon: getIcon(result.type, Typeahead.CATEGORIES[result.type], this.opts.forceIcon)
                            });

                            if (result.category == "USERHISTORY") {
                                var category = Typeahead.CATEGORIES['RECENTHISTORY'];
                                result.icon = getIcon(result.type, category, this.opts.forceicon);
                            }

                            // now, update the data-data string for the template with the updated result as JSON
                            result.data =  JSON.stringify(result);
                        }, this);

                        model.resultsByDisplayGroup = _.groupBy(results, function(result){
                            return result.displayGroup ? result.displayGroup : "";
                        });

                        // now we're ready to render the template
                        content = this.template(model);

                        this.$ta.html(content);

                        this.$label.addClass('focused');
                        /* //@vmohapatra : TODO refactor code related to accessibility in TA
                        if (this.opts.tooltip) {

                            if (window.navigator.msPointerEnabled && !window.PointerEvent) {
                                // bind 'this' for use in the uitk.clickEvent and focusin callback
                                that = this;

                                // Using feature detection we can diff between IE 11 and IE 10.
                                // Pointer events were added in IE10 (window.PointerEvent).
                                // The syntax changed in IE 11 (vendor prefix was removed).
                                // If pointer events are supported - and - the new syntax is supported, we know it is IE 11.
                                // If pointer events supported and the new syntax is not supported -- then we know it is IE 10.

                                $('body').on(uitk.clickEvent + ' focusin.' + tooltipPlugin, function (e) {
                                    if (e.type === 'focusin' && !uitk.utils.isFocusableElement($(e.target))) {
                                        return;
                                    }
                                    //don't close if clicked on $ta
                                    if (e.target === that.$element[0]) {
                                        return;
                                    }

                                    that.close();
                                });
                            }
                        }
                        else {
                            var height = parseInt(this.$element.css('height'), 10);

                            var offset = this.$element.offset();
                            this.$ta.css({
                                top: offset.top + height + 'px',
                                left: offset.left + 'px'
                            });
                        }
                        */
                    }

                    if(results.length > 0){
                        corewizard.OMTypeAheadRendered = true;
                        // only show popup when we actually have something
                        // to render in the popup list
                        showTaPopup(this.$ta, this);

                        //vmohapatra : Enable announcement for suggestions displayed
                        //If it is a touch device (ipad) Do not announce number of results displayed
                        if (!$('html').hasClass('appleios')) {
                            if (results && results.length) {
                                uitk.utils.liveAnnounce(results.length + resultsLengthAnnouncement, 'polite');
                            }
                        }
                    }
                }
                else {
                    this.close();
                }

                this.getMetricsLogger().timestamp(this.getMetricsLogger().TimestampCategories.RENDER, text);
            },

            close: function () {
                this.$label.removeClass('focused');

                this.$ta.closest('.' + autoCompleteClass).removeClass(openClass);
                hideTaPopup(this.$ta, this);
                this.$ta.html('');

                if (this.bodyClick) {
                    this.$ta.unbind('mousedown', $.proxy(this.cancelEvent, this));
                    $(document.body).unbind('mousedown', $.proxy(this.close, this));
                    this.bodyClick = false;
                }

                this.removeActiveDescendant();
                // for any code that needs to know when
                // the typeahead window has been closed
                uitk.publish('typeaheadTooltip.closed', lastFocusedElementId);
            },

            closeAllTA: function(){
                //Removes the focused class from the label, the open class from the wrapper, clears the dropdown and hides it
                var $ac = $('.' + autoCompleteClass);
                $ac.find('label.' + arrowClass).removeClass('focused');
                $ac.removeClass(openClass).find('.' + dropdownClass).html('').hide();

                this.removeActiveDescendant();
            },

            /** Accessibility
             * Added to remove the aria-activedescendant attribute when closing the dropdown. This was previously
             * taken care automatically by Tooltips. The attribute should be removed once the dropdown is closed for
             * any reason including selection, blur, etc. **/
            removeActiveDescendant: function(){
                var needToRemove = $('input[aria-activedescendant]');

                if(needToRemove.length > 0){
                    needToRemove.removeAttr('aria-activedescendant');
                }
            },

            prev: function () {
                var links = this.$ta.find('a'),
                    current = this.$ta.find('.highlight').removeClass('highlight'),
                    i = links.index(current),
                    prev = links[i - 1],
                    $prev = $(prev);

                $(current).attr('aria-selected', 'false');

                if(searchExperiments.getVariant("CWTA_PrePopulateInput") !== 0){
                    if (!this.$ta.find('.highlight').length) {
                        this.restoreUserInput();
                    }
                }

                if (prev) {
                    highlightOption(this, $prev);
                }
                else {
                    // 'reset' by removing attributes
                    this.$element.removeAttr('aria-activedescendant');
                    $('[aria-selected="true"]').attr('aria-selected', 'false');
                    // Accessibility: when user navigates back to input, read the value (Toby)
                    uitk.utils.liveAnnounce(this.$element.val(), 'polite');
                }
            },

            next: function () {
                var links = this.$ta.find('a'),
                    current = this.$ta.find('.highlight').removeClass('highlight'),
                    i = links.index(current),
                    next = links[i + 1],
                    $next = $(next),
                    item,
                    accyText = '';

                $(current).attr('aria-selected', 'false');

                if(searchExperiments.getVariant("CWTA_PrePopulateInput") !== 0){
                    if(i === -1){
                        this.saveUserInput();
                    }
                }

                // Accessibility: announce 'close' button as selection moves to it.
                // (this is not the same as announcing it has been selected.)
                // (Aria roles and labels didn't work on Safari/VO)
                if ($(links[i + 1]).hasClass('close')) {
                    uitk.utils.liveAnnounce('close', 'assertive');
                }

                // There is a 'bug' in screen readers other than Safari/VoiceOver where
                // they will not read the first option the second (and following) time they access it,
                // especially after navigating back to the input.
                // It has to do with the way screen readers view ULs (Stack).
                // This work around will explicitly call out the value after first access.
                if (!$('html').hasClass('safari')) {
                    if (this.firstItemFlag === true) {
                        this.firstItemFlag = false;
                    } else {
                        if (typeof links[i] === 'undefined') {
                            // only over ride for the first item, not the rest
                            item = $('.active-tooltip').find('a')[0];
                            accyText = $(item).attr('data-value');
                            uitk.utils.liveAnnounce(accyText, 'polite');
                        }
                    }
                }

                if (next) {
                    highlightOption(this, $next);
                }
                else {
                    // Accessibility: navigated to input, read the value (Toby)
                    uitk.utils.liveAnnounce(this.$element.val(), 'polite');
                }

                if(searchExperiments.getVariant("CWTA_PrePopulateInput") !== 0) {
                    if (!this.$ta.find('.highlight').length) {
                        this.restoreUserInput();
                    }
                }
            },

            removeHighlights: function () {
                this.$ta.find('.highlight').removeClass('highlight');
            },

            //This is for the CWTA_PrePopulateInput
            saveUserInput: function () {
                this.userInput = this.$element.val();
            },

            //This is for the CWTA_PrePopulateInput
            restoreUserInput: function () {
                this.$element.val(this.userInput);
            },

            // Choose the currently selected item:
            selectHighlighted: function (e) {

                // Clean out the the saved Promise on any selection and only reset it
                // if the last item selected is type 'GEOLOCATION' and
                // corewizard.searchExperiments.getVariant("CURRENT_LOCATION") is true.
                // The getVariant("CURRENT_LOCATION") call will only be true based on LOB
                // However, this property is set on the corewizard.core.state object. That means
                // for example, that the user can be on the Hotels tab where the experiment runs
                // and switch to any other tab and the getVariant("CURRENT_LOCATION") will be
                // false. But, the value will have been set while on the Hotels tab. The existence
                // of the property as an object signals behavior so you always want to clear the property
                // no matter if the experiment is on or not whenever typeahead is used.
                // See: constraints properties in .../trunk/content/static_content/jsconfig/default/corewizard/hotel.js
                // and other jsconfig files.
                dataModels.state.set(promiseForGeolocationLiteral, null);

                var closeFlag = this.$ta.find('.highlight').hasClass('close'),
                    $item = this.$ta.find('.highlight'),
                    essItemData;

                if(searchExperiments.getVariant("CWTA_PrePopulateInput") !== 0) {
                    if (closeFlag) {
                        this.restoreUserInput();
                    }
                }

                if (! closeFlag) {
                    this.selectedSuggestionIsInEffect = true;
                    essItemData = TypeaheadUtils.getDataFromItem($item);
                    if(essItemData)
                    {
                        this.selectedSuggestionEssId = essItemData.essId;
                    }
                }
                // User has selected one of the items in the list
                // Setting this flag here since code that follows
                // has the side effect of setting focus and the handler
                // for focus is precisely where this flag is used
                Typeahead.taItemChosen = true;


                var $nextItem = $item.parent().next(),
                    index,
                    itemTextFull = $item.text(),
                    itemText, closeText, $html = $('html');

                index = this.$ta.find('a').index($item);
                if (index >= 0) {
                    this.getMetricsLogger().logSelection(this.$ta.find('a').index($item), this.$element.val());
                }

                // this trims whitespace off ends of the string
                itemText = itemTextFull.replace(/(^\s+|\s+$)/g, '');

                //NOTE : The following condition might be true for non-touch devices as well.
                //To be on the safe side set the item and other data again.
                //used for touch devices as they don't have hover and therefore don't highlight
                if (e && $item.length === 0) {
                    $item = $(e.target).closest('.results-item').find('a');
                    $nextItem = $item.parent().next();
                }
                if (Typeahead.isHierarchyEnabled(this.opts)) {
                    this.updateTextField($item, $nextItem);
                }
                else {
                    this.updateTextField($item);
                }

                $item.removeClass('highlight');

                // Accessibility
                // Announces that a selection has been made and the value selected,
                // or that the user closed the menu with the close button.
                // NOTE: once the sentences have been localized, we can simplify this logic below.
                if (closeFlag === true) {
                    // the close button was selected, so
                    // get the potentially localized 'close' text
                    closeText = $item.text().replace(/(^\s+|\s+$)/g, '');
                    if (this.$element.attr('locale') === 'en_US' || $html.attr('data-language') === 'en_US') {
                        // it is US English, read the complete sentence
                        uitk.utils.liveAnnounce('Close button is selected and the menu has closed', 'assertive');
                    } else {
                        // just read the localized 'close' text (until the full sentence is localized)
                        uitk.utils.liveAnnounce(closeText, 'assertive');
                    }
                } else {
                    // NOTE: NVDA and JAWs read the selection, VO does not.
                    if ($html.hasClass('safari')) {
                        if (this.$element.attr('locale') === 'en_US' || $html.attr('data-language') === 'en_US') {
                            // it is US English, read the complete sentence
                            uitk.utils.liveAnnounce('You selected ' + itemText + ' and the menu has closed', 'assertive');
                        } else {
                            // just read the localized 'item' text (until the full sentence is localized)
                            uitk.utils.liveAnnounce(itemText, 'assertive');
                        }
                    }
                    uitk.publish(TypeaheadMeasurementTopics.SuggestionSelected,
                        new TypeaheadUtils.TypeaheadSuggestionSelectedMeasurement(
                            Date.now(), this.$element.attr("id"), dataModels.model.get('tab'),
                            TypeaheadUtils.getExperimentTreatmentAssignments(corewizard)));

                    uitk.publish("SuggestionSelected",
                        TypeaheadSelectionToSubmissionLogger.newSelection(
                            Date.now(), this.$element.attr("id"), dataModels.model.get('tab'),
                            TypeaheadUtils.getExperimentTreatmentAssignments(
                                dataModels.model.get("activeESSTests"),
                                getClientsideExperiments())
                            ));
                }

                // Publish select element event on typeahead select
                var data = {element: $item};
                uitk.publish('typeahead.resultSelected', data);

                if(isAnchorInputOnFocusExperiment()){
                    // When on a touch device like a phone, the popup can be
                    // quite long. This is here to animate the highlighted input
                    // into view after an item has been selected and a value added to the
                    // the associated input field. The setTimeout() call is to ensure
                    // this happens after this function has completed.
                    var self = this; // not using bind() for compatibility with old IE8
                    setTimeout(anchorInputOnFocus(self.$element), 0);
                }
            },

            updateTextField: function ($item, $nextItem) {

                var itemId = this.$element.attr("id"),
                    value,
                    locationExperimentEnabled = isCurrentLocationExperiment(),
                    isGeolocationItem = itemIsGeolocation($item),
                    wizardState = dataModels.state;

                if ($item) {
                    value = $item.attr('data-value');
                    if (value || locationExperimentEnabled) {

                        if(locationExperimentEnabled && isGeolocationItem) {
                            // fired by typeaheadItemClickCallback() function
                            uitk.subscribe('typeahead.currentLocationSelected', function (evt, data) {
                                // give the UI a bit of time to fully paint before setting focus to the input
                                setTimeout(function(){
                                    $("#" + itemId).select();
                                }, 200);
                            });
                        }

                        if (!locationExperimentEnabled ||  // experiment is not running
                            !isGeolocationItem){  // this item is not "User your current location
                            value = Typeahead.decodeHtmlCharacterEntities(value);
                            //Set the user typed text which is present in input field before updating the field
                            wizardState.set('userTypedQuery', this.$element.val());

                            this.$element.val(value);
                            //This is to trigger updating of destination or origin model values in wizard state
                            this.$element.change();
                        }

                        //There is no selectioncallback for activities LOB, hence typeOfSearch always shows as undefined
                        if (this.opts.selectioncallback) {

                            var childData;
                            //If hierarchical display is off nextItem would be undefined.
                            if ($nextItem != undefined) {
                                //childData should be populated only if nextItem is available
                                childData = $nextItem.closest('.results-item').find('a').attr('data-data');
                            }

                            var hasChildFlag = -1;
                            if (childData != undefined) {
                                //Assumption : Currently relation node has only one value at a time
                                //Looking for value "child" in ESS response
                                hasChildFlag = childData.search(/"child"/i);
                            }

                            var hasChild = false;
                            if (childData != undefined && hasChildFlag != -1) {
                                hasChild = true;
                            }

                            if (typeof this.opts.selectioncallback == 'function') {
                                this.opts.selectioncallback($item, hasChild, this);
                            } else if (typeof this.opts.selectioncallback == 'string') {
                                window[this.opts.selectioncallback]($item, hasChild, this);
                            }
                        }
                    }
                    this.close();
                    this.$element.parent().parent().children(".icon-close").addClass("visuallyhidden");

                    if(! Modernizr.touch && searchExperiments.getVariant("CWTA_PrePopulateInput") !== 0){
                        this.$element.select();
                    }
                    else {
                        this.$element.select();
                    }
                }
            },

            focus: function (evt) {
                if(evt && evt.currentTarget) {
                    // keeping track of the id of the element that got the focus
                    // so we pass it on to the 'typeaheadTooltip.closed' subscribers
                    lastFocusedElementId = evt.currentTarget.getAttribute("id");

                    if (isAnchorInputOnFocusExperiment()) {
                        anchorInputOnFocus(evt.currentTarget);
                    }
                }

                if(Typeahead.taItemChosen){
                    // if this is the focus call right after the user has picked an item
                    // from the list, we don't want to fire off another render sequence
                    // so we just get out now and flip the flag back.
                    Typeahead.taItemChosen = false;
                    return;
                }

                this.getMetricsLogger().timestamp(this.getMetricsLogger().TimestampCategories.FOCUS, this.$element.val());
                this.getMetricsLogger().logFocus();
                if (!evt) {
                    evt = window.event;
                }

                //Zero typehead trigger display and no character in focused input field
                // is a valid case for the recent history experiments
                if (shouldTryShowingSuggestionsOnFocus()) {

                    var elemValue = $.trim(this.$element.val());
                    var inputElemPlaceholderFlag;

                    //For browsers that support placeholder text
                    // in HTML input controls. Best practice is to use Modernizr
                    if (Modernizr.input.placeholder) {
                        inputElemPlaceholderFlag = elemValue;
                    }
                    else {
                        //For IE8 which does not support placeholder
                        if (elemValue == $.trim(this.$element.attr("placeholder"))) {
                            this.$element.val("");
                            inputElemPlaceholderFlag = "";
                        }
                        else {
                            this.$element.val(elemValue);
                            inputElemPlaceholderFlag = elemValue;
                            $(this.$element).removeClass("placeholderspolyfill");
                        }
                    }

                    if (isCurrentLocationExperiment() && userPickedCurrentLocation()){
                        // then don't trigger ESS fetch again.
                        return;
                    }

                    //If the input element has no previous value, show trending now options on focus
                    if (inputElemPlaceholderFlag == '' || shouldTryShowingSuggestionsOnFocus()) {
                        this.shouldBeOpen = true;
                        this.renderFromFocus = true;
                        this.startRequest();
                    }
                }
            },

            keyDown: function (evt) {
                var keyCode;

                if (!evt) evt = window.event;

                keyCode = evt.keyCode;

                switch (keyCode) {
                    case 27: // Escape
                        this.close();
                        evt.stopPropagation();
                        break;

                    case 13: // Enter
                        if (this.$ta.is(":visible")) {
                          if(getCurrentLob() === 'openSearch') {
                            if (this.$ta.find('.highlight').length) {
                              evt.preventDefault();
                              this.selectHighlighted(evt);
                            }
                          }
                          else {
                            // if there is no highlighted element select the first
                            if (!this.$ta.find('.highlight').length) {
                              this.$ta.find('a:first').addClass('highlight');
                            }
                            evt.preventDefault();
                            this.selectHighlighted(evt);
                          }
                        }
                        break;

                    case 32: // space
                        if (this.$ta.find('.highlight').hasClass('close')) {
                            evt.stopPropagation();
                            evt.preventDefault();
                        }
                        break;

                    case 39: // Right
                        if (this.$ta.find('.highlight').length) {
                            this.ignoreNext = true;
                            this.selectHighlighted(evt);
                        }
                        break;
                    case 38: // Up
                    case 40: // Down
                        evt.stopPropagation();
                        evt.preventDefault();
                        break;
                }
            },

            keyPress: function (evt) {
                if (!evt) {
                    evt = window.event;
                }
                if (evt.keyCode == 13 /* Enter/Return */) {
                    this.close();
                }
            },

            keyUp: function (evt) {
                // prevents a key up after an item has been selected by the key board
                if (this.ignoreNext) {
                    this.ignoreNext = false;
                    return;
                }

                if (!evt) evt = window.event;
                switch (evt.keyCode) {
                    case 27: // Escape
                        if(searchExperiments.getVariant("CWTA_PrePopulateInput") !== 0) {
                            this.restoreUserInput();
                        }
                        break;

                    case 37: // Left
                        this.removeHighlights();
                        break;

                    case 38: // Up
                        this.prev();
                        break;

                    case 40: // Down
                        this.next();
                        break;

                    case 9: // TAB
                    case 16: // Shift
                    case 17: // Ctrl
                    case 18: // Alt
                        // when you TAB into a control, like an input field, that control gets the keyup
                        // it doesn't get the key down. When the input control gets a focus event, it will
                        // render if it needs to. No need to let TAB fall through and trigger render again.
                        break;
                    case 13: // Enter/Return
                        this.shouldBeOpen = false;
                        break;

                    case 32: // space
                        if (this.$ta.find('.highlight').hasClass('close')) {
                            evt.stopPropagation();
                            evt.preventDefault();
                            this.selectHighlighted(evt);
                        }
                        break;
                    default:
                        // Clean out any saved Promise when the user starts typing.
                        // The existence of the property as an object signals behavior and only exists when the user
                        // has picked "Use you current location" so you always want to clear the property
                        // no matter if the experiment is on or not whenever typeahead is used or the user starts
                        // typing in the input box.
                        dataModels.state.set(promiseForGeolocationLiteral, null);

                        this.shouldBeOpen = true;
                        this.getMetricsLogger().timestamp(
                            this.getMetricsLogger().TimestampCategories.KEY_UP, this.$element.val());

                        if (isAnchorInputOnFocusExperiment()) {
                            anchorInputOnFocus(evt.currentTarget);
                        }
                        this.startRequest();
                        break;
                }
            },

            blur: function (event) {
                function emitSuggestionEngagementMetricIfApplicable(typeahead, clientId, userTypedQuery, lobType) {
                    function isInteractionWithInputElementCompleted(event) {
                        var typeaheadResultsDomElement = $(".typeahead")[0];
                        // A blur caused by focusing on a typeahead suggestion doesn't indicate the completion of
                        // interaction with the input element.
                        return event.type === "blur" &&
                            ! (typeaheadResultsDomElement && $.contains(typeaheadResultsDomElement, event.relatedTarget));
                    }
                    if (isInteractionWithInputElementCompleted(event)) {
                        typeahead.getMetricsLogger().emitSuggestionEngagementMetric(
                            typeahead.selectedSuggestionIsInEffect,
                            userTypedQuery,
                            typeahead.$element.val(),
                            TypeaheadUtils.getExperimentTreatmentAssignments(corewizard), typeahead.selectedSuggestionEssId);
                    }
                }
                setTimeout(emitSuggestionEngagementMetricIfApplicable, 0,
                    this, TypeaheadUtils.getPageId(), dataModels.model.get("userTypedQuery"),
                     dataModels.model.get('tab'));
                this.getMetricsLogger().emitMetrics();

                // IE10 Win8 fix
                if (window.navigator.msPointerEnabled && !window.PointerEvent) {
                    return;
                }

                // need a delay so we can cancel if the ta is being clicked on
                if (!this.isClickOn) {
                    this.close();
                } else {
                    this.$ta.bind('mousedown', $.proxy(this.cancelEvent, this));
                    $(document.body).bind('mousedown', $.proxy(this.close, this));
                    this.bodyClick = true;
                }
                // Binding the 'x' hiding function to this so it can delay a little and stay *just* long enough for the click to register.
                // Otherwise, the loss of focus on the input element when you click on the 'x' causes it disappear and not register the click.
                var boundHide = (function() {this.$element.parent().parent().children(".icon-close").addClass("visuallyhidden");}).bind(this);
                window.setTimeout(boundHide, 150);

            },

            hammerTapHandler: function(hammerEvent){
                // The Hammer.js library emits "tap" events for touch devices
                // and sends a Hammer event object to the handler.
                // See: http://hammerjs.github.io/api/#event-object
                var srcEvent = _.isObject(hammerEvent) && hammerEvent.srcEvent;
                if(_.isObject(srcEvent)){
                    this.click(srcEvent);
                }
            },

            clickOn: function () {
                this.isClickOn = true;
            },

            clickOff: function () {
                this.isClickOn = false;
            },

            click: function (e) {
                e.stopPropagation();
                e.preventDefault();
                this.selectHighlighted(e);
            },

            onClick: function(){
                if(searchExperiments.getVariant("CWTA_PrePopulateInput") !== 0 ) {
                    var sel;
                    if (! Modernizr.touch) {
                       // when user clicks into the input field, select any existing text
                       // This makes mouse click focus and keyboard TAB focus
                       // behave in the same way providing a consistent user experience no
                       // matter how the control is focused
                       this.$element.select();
                    }
                    else {
                       sel = window.getSelection();
                       if (! _.isEmpty(sel + "")) {
                           sel.removeAllRanges();
                       }
                    }
                }
                else {
                    // when user clicks into the input field, select any existing text
                    // This makes mouse click focus and keyboard TAB focus
                    // behave in the same way providing a consistent user experience no
                    // matter how the control is focused
                    this.$element.select();

                    if (isAnchorInputOnFocusExperiment()) {
                        anchorInputOnFocus(this.$element[0]);
                    }
                }
            },

            mouseEnter: function (e) {
                this.removeHighlights();
                $(e.currentTarget).addClass('highlight');
            },

            cancelEvent: function (evt) {
                evt.cancelBubble = true;
                if (evt.stopPropagation) evt.stopPropagation();
                if (evt.preventDefault) evt.preventDefault();
                evt.cancel = true;
                evt.returnValue = false;
            },

            // TODO - is this method necessary?
            remove: function () {
                this.$element.autocomplete = 'on';
                this.$element.closest('form').attr('autocomplete', 'on');

                this.$element
                    .off('focus', $.proxy(this.focus, this))
                    .off('keydown', $.proxy(this.keyDown, this))
                    .off('keyup', $.proxy(this.keyUp, this))
                    .off('keypress', $.proxy(this.keyPress, this))
                    .off('blur', $.proxy(this.blur, this));
                this.$ta
                    .off('mousedown', $.proxy(this.mouseDown, this))
                    .off('mouseup', $.proxy(this.mouseUp, this))
                    .off('click', $.proxy(this.click, this))
                    .off('mouseenter', 'a', $.proxy(this.mouseEnter, this))
                    .remove();
            },

            getMetricsLogger: function () {
                if (!this.metricsLogger) {
                    this.metricsLogger = new TypeaheadMetricsLogger(this.$element.attr("id"), this.opts.locale);
                }
                return this.metricsLogger;
            },

            getBestDealsOptionInjector: function () {
                if (!this.bestDealsOptionInjector &&
                    (searchExperiments.getVariant("BEST_DEALS_OPTION") !== 0) &&
                    _.isFunction(BestDealsOptionInjector)) {
                    this.bestDealsOptionInjector = new BestDealsOptionInjector(this);
                }
                return this.bestDealsOptionInjector;
            },

            getTrendingSearchesNearYouInjector: function () {
                if (!this.trendingSearchesNearYouInjector &&
                    isTrendingSearchesNearYouExperiment() &&
                    _.isFunction(TypeaheadUtils.TrendingSearchesNearYouInjector)) {
                    this.trendingSearchesNearYouInjector = new TypeaheadUtils.TrendingSearchesNearYouInjector();
                }
                return this.trendingSearchesNearYouInjector;
            },

            getAddressAutocompleteService: function () {
                if (!window.Typeahead.addressAutocompleteService) {
                    if(_.isObject(google) && _.isObject(google.maps) && _.isObject(google.maps.places) && _.isFunction(google.maps.places.AutocompleteService))
                    {
                        window.Typeahead.addressAutocompleteService = new google.maps.places.AutocompleteService();
                    }
                }
                return window.Typeahead.addressAutocompleteService;
            },

            bindJQueryObject: function(input) {
                if (input.is(this.$element)) {
                    return;
                }

                // The <input>
                this.$element = input;
                bindDropDownListToTA(this, this.$element);

                // The <input>'s parent (wrapping div)
                this.$parent = this.$element.closest('.' + autoCompleteClass);

                // beenInputed() returns true if and only if an input event (https://goo.gl/IHeZsl) whose target is the element
                // associated with this object has been fired since the instantiation of this object.
                this.beenInputed = (function($element){
                    var beenInputed = false;
                    var eventName = "input";
                    function handler() {
                        beenInputed = true;
                        $element.off(eventName, handler);
                    }
                    $element.on(eventName, handler);
                    return function() {
                        return beenInputed;
                    }
                })(this.$element);

                // The <input>'s <label>
                this.$label = this.$element.closest('label');

                autoPos = this.$parent.data('autoPos');
                //Defaults positioning of the autocomplete dropdown to the left. If another class is set, it will stay as is
                this.setPinClass(this.$parent);

                this.$element.on("input", $.proxy(function(){ this.selectedSuggestionIsInEffect = false; }, this));

                // Accessibility
                // The ID for the DIV that is to receive the dynamic content
                // passed in via data attribute in INPUT markup.
                // For backwards compatibility, we use a preset ID so that tooltip
                // can append content correctly, even if accessibility doesnt work it won't
                // break pages.
                this.ariaOwns = this.$element.attr('aria-owns') || 'backwards';

                // Set up the input and listeners:
                this.$element.autocomplete = 'off';

                // For gecko-based browsers, we turn autocomplete off on the <form>,
                // not the <input>
                this.$element.closest('form').attr('autocomplete', 'off');

                this.$element
                    .on('click', $.proxy(this.onClick, this))
                    .on('focus', $.proxy(this.focus, this))
                    .on('keydown', $.proxy(this.keyDown, this))
                    .on('keyup', $.proxy(this.keyUp, this))
                    .on('keypress', $.proxy(this.keyPress, this))
                    .on('blur', $.proxy(this.blur, this));

                // Allen Kim: If you blur before the TA ajax call returns, it won't close so I'm using a blockRender
                // flag here. It gets set to false again on focus. https://jira/jira/browse/MAIN-101040
                //.on('blur', $.proxy(function() { this.blockRender = true; }, this));
                //Allen Kim: mobile isn't handling blur events well - https://jira/jira/browse/MAIN-129737, https://jira/jira/browse/MAIN-129750
                //  .on('blur', $.proxy(this.blur, this));
                $('body').on('click focus', $.proxy(function (evt) {
                    if (evt.target !== this.$element[0]) this.blur(evt);
                }, this));

                /*
                if (this.opts.tooltip) {
                    this.$element[tooltipPlugin]({
                        content: this.$ta,
                        template: '<div class="uitk-tooltip" role="presentation"><div class="tooltip-inner" role="presentation"></div><span class="tooltip-arrow-border"></span><span class="tooltip-arrow"></span></div>',
                        width: 600
                    });
                }
                */
            },

            getWindowWidth: function() {
                return $window.width();
            },
            centerDropDown: function($target) {
                var trigger = $target.find('.' + triggerClass),
                    dropDown = $target.find('.' + dropdownClass),
                    shiftC,
                    borderOffset = acDefaults.borderOffset;
                dropDownWidth = dropDown.outerWidth();
                triggerWidth = trigger.outerWidth();
                shiftC = (triggerWidth - dropDownWidth) / 2;
                dropDown.css('right', shiftC - (borderOffset / 2) + 'px');
            },
            setAutocompletePos: function($target) {
                var that = this,
                    dropDown = $target.find('.' + dropdownClass),
                    trigger = $target.find('.' + triggerClass),
                    isPinLeft = $target.hasClass(leftClass),
                    isPinRight = $target.hasClass(rightClass),
                    gutter = acDefaults.gutter,
                    borderOffset = acDefaults.borderOffset,
                    dropDownOffset,
                    dropDownOffsetL,
                    dropDownOffsetR,
                    widthDelta,
                    shiftLeft;
                windowWidth = that.getWindowWidth();
                dropDownWidth = dropDown.outerWidth();
                triggerWidth = trigger.outerWidth();
                isCentered = $target.hasClass(centerClass);
                /** Init dropDown position */
                if (isPinLeft) {
                    dropDown.css({'right':'auto', 'left':borderOffset + 'px'});
                } else if (isPinRight) {
                    dropDown.css('right', borderOffset + 'px');
                } else if (isCentered) {
                    that.centerDropDown($target);
                }
                /** Maintain dropDown position on resize */
                dropDownOffset = dropDown.offset();
                dropDownOffsetL = dropDownOffset.left;
                dropDownOffsetR = windowWidth - (dropDownOffsetL + dropDownWidth);

                if(dropDownWidth >= windowWidth*0.9)
                {
                    dropDown.css('max-width', windowWidth*0.9 + 'px');
                    dropDownWidth = dropDown.outerWidth();
                }
                else if(windowWidth*0.9 < 600)
                {
                    dropDown.css('max-width', windowWidth*0.9 + 'px');
                    dropDownWidth = dropDown.outerWidth();
                }

                widthDelta = dropDownWidth - (windowWidth - trigger.offset().left);
                shiftLeft = widthDelta * -1;

                if(dropDownOffsetR < gutter){
                    if(dropDownOffsetL > 0.1 * windowWidth)
                    {
                        if(widthDelta > 0)
                        {
                            dropDown.css('left', shiftLeft + 'px');
                        }
                    }
                }
            },
            handleResize: function($target) {
                var that = this,
                    autoPos = $target.data('autoPos');
                windowWidth = that.getWindowWidth();
                /** Sets a minWidth to fix issues in IE */
                if (!bodyMinWidth) {
                    bodyMinWidth = 255;
                }
                if (!autoPos) { return; }
                /** Set position if autoPos is true and window is wider than 255 */
                if (windowWidth > bodyMinWidth) {
                    that.setAutocompletePos($target);
                }
            },
            setPinClass: function($parent){
                if (!$parent.hasClass(leftClass) && !$parent.hasClass(rightClass) && !$parent.hasClass(centerClass)) {
                    $parent.addClass(leftClass);
                }
            }

        };

    }();

    // State variable that tracks when a user chooses an item
    // from the typeahead popup UI. When the user chooses an option from within the
    // typeahead list we set this to true. When the typeahead popup finally closes
    // the pubsub event 'typeahead.resultSelected' gets fired and then focus is restored
    // to the Typeahead control. At that time, use use this flag to know that for this
    // particular focus event fires, we know not to run out and render the typeahead popup again.
    // At that time the flag is toggled back to false.
    Typeahead.taItemChosen = false;

    //
    // Constants:
    //
    Typeahead.AIRPORT = 1;
    Typeahead.CITY = 2;
    Typeahead.MULTICITY = 4;
    Typeahead.NEIGHBORHOOD = 8;
    Typeahead.POI = 16;
    Typeahead.ADDRESS = 32;
    Typeahead.RENTAL = 32;
    Typeahead.METROCODE = 64;
    Typeahead.HOTEL = 128;
    Typeahead.TRAINSTATION = 512;
    Typeahead.METROSTATION = 1024;
    Typeahead.MULTIREGION = 256;
    // Set a default typeahead suggesturl
    Typeahead.SUGGESTURL_DEFAULT = "//suggest.expedia.com/hint/es/";
    Typeahead.SUGGESTURL = Typeahead.SUGGESTURL_DEFAULT;
    //gemma url for experiemnt 10406
    Typeahead.GEMMAURL= "https://gemma.expedia.com/gemma/rest/suggest";
    Typeahead.GEMMACLIENTID = "b73f2e66-c96a-4382-845b-30fa2d5ab102";
    Typeahead.GEMMACOUNT = "10";
    Typeahead.REGIONTYPE = {
        'ALL': 31,
        'AIRPORT': 1,
        'CITIES': 2
    };

    Typeahead.CATEGORIES = {
        'CITY': {
            'id': 0,
            name: loc.typeAhead.region,
            icon: 'location'
        },
        'ATTRACTION': {
            'id': 1,
            name: loc.typeAhead.attractions,
            icon: 'location'
        },
        'AIRPORT': {
            'id': 2,
            name: loc.typeAhead.airports,
            icon: 'flights'
        },
        'HOTEL': {
            'id': 3,
            name: loc.typeAhead.hotels,
            icon: 'hotels'
        },
        'ADDRESS': {
            'id': 4,
            name: loc.typeAhead.address,
            icon: 'location'
        },
        'TRAINSTATION': {
            'id': 5,
            name: loc.typeAhead.trains,
            icon: 'train'
        },
        'METROSTATION': {
            'id': 6,
            name: loc.typeAhead.metros,
            icon: 'train'
        },
        'MULTICITY': {
            'id': 7,
            name: loc.typeAhead.region,
            icon: 'location'
        },
        'NEIGHBORHOOD': {
            'id': 8,
            name: loc.typeAhead.region,
            icon: 'location'
        },
        'METROCODE': {
            'id': 9,
            name: loc.typeAhead.airports,
            icon: 'flights'
        },
        'POI': {
            'id': 11,
            name: loc.typeAhead.attractions,
            icon: 'location'
        },
        'RENTAL': {
            'id': 12,
            name: loc.typeAhead.rentals,
            icon: 'location'
        },
        'DEALS': {
            'id': 13,
            name: loc.typeAhead.deals,
            icon: 'location'
        },
        'POSTCODE': {
            'id': 14,
            name: loc.typeAhead.postcode,
            icon: 'location'
        },
        'HOTELS': {
            'id': 15,
            name: loc.typeAhead.hotels,
            icon: 'hotels'
        },
        'FLIGHTS': {
            'id': 16,
            name: loc.typeAhead.flights,
            icon: 'flights'
        },
        'PACKAGES': {
            'id': 17,
            name: loc.typeAhead.packages,
            icon: 'packages'
        },
        'CARS': {
            'id': 18,
            name: loc.typeAhead.cars,
            icon: 'cars'
        },
        'ACTIVITIES': {
            'id': 19,
            name: loc.typeAhead.activities,
            icon: 'activities'
        },
        'CRUISES': {
            'id': 20,
            name: loc.typeAhead.cruises,
            icon: 'cruises'
        },
        'HOTEL_NAME': {
            'id': 21,
            name: undefined, // Name is not required for display purposes
            icon: 'hotels'
        },
        'RECENTHISTORY': {
            'id': 22,
            name: loc.typeAhead.recent,
            icon: 'notime'
        },
        'ALL': {
            'id': 23,
            name: undefined,
            icon: 'location'
        },
        'TRENDINGSEARCH' : {
            'id': 24,
            name: loc.typeAhead.trending,
            icon: 'location'
        }
    };

    Typeahead.defaultOptions = {
        // "Options" - to be moved into this.opts, which is a merge from Typeahead.default
        // The options are overwriten with html attributes and need to be all lower case
        minchar: 3,
        maxitems: 10,
        version: 'v2',
        locale: 'en_US',
        abtest: '',
        mask: (Typeahead.AIRPORT | Typeahead.CITY | Typeahead.MULTICITY | Typeahead.NEIGHBORHOOD | Typeahead.POI),
        lob: 'FLIGHTS',
        dest: false,
        closetext: 'Close',
        continuetext: 'Continue typing to refine search',
        selectioncallback: null, // called when an item is selected with mouse or keyboard, with one argument that is the selected <a>.
        tooltip: true,
        forceicon: false
    };

    Typeahead.isHierarchyEnabled = function (opts) {
        return _.contains(["FLIGHTS", "HOTELS", "RAILS"], opts.lob);
    }

    Typeahead.enableSuggestionHierarchy = function (opts) {
        if (Typeahead.isHierarchyEnabled(opts)) {
            Typeahead.URLPARAMS = {
                regiontype: opts.mask,
                locale: opts.locale,
                features: 'ta_hierarchy', // Instructs ESS to include suggestion hierarchy.
                ab: opts.abtest,
                lob: opts.lob,
                format: 'jsonp',
                dest: opts.dest,
                maxresults: opts.maxresults,
                client: opts.client
            };
            if (opts.lob === 'FLIGHTS') {
                opts.version = 'v4';
            }
            if (searchExperiments.getSearchExperimentVariant('8075') !== "0") {
                Typeahead.URLPARAMS.features = Typeahead.URLPARAMS.features + '|nearby_airport';
            }

        }
    };

    Typeahead.request = function (text, instance, opts, callback) {
        var requestGenerator = ExpediaSuggestServiceRequestGenerator.defaultGenerator,
            essAbacusParameter = requestGenerator.generateAbacusParameter(),
            requestDevice,
            requestBrowser,
            deviceCharacteristics;
        Typeahead.SUGGESTURL = Typeahead.SUGGESTURL_DEFAULT;
        Typeahead.V4URL = Typeahead.V4URL || "//suggest.expedia.com/api/";
        Typeahead.URLPARAMS = undefined; //Stores the URL params for v4 call
        var currentLob = getCurrentLob();

        //retrieve device and browser type from window.utag_data....deviceCharacteristics
        if(window.utag_data && window.utag_data.context && window.utag_data.context.clientInfo && window.utag_data.context.clientInfo.deviceCharacteristics)
        {
            deviceCharacteristics = window.utag_data.context.clientInfo.deviceCharacteristics;
            if(deviceCharacteristics.mobile && !deviceCharacteristics.tablet)
            {
                requestDevice = 'mobile';
            }
            else if(deviceCharacteristics.tablet)
            {
                requestDevice = 'tablet';
            }
            else
            {
                requestDevice = 'desktop'
            }

            if(deviceCharacteristics.mobileBrowser)
            {
                requestBrowser = deviceCharacteristics.mobileBrowser
            }
        }

        if(!env.essEndpoint) {
            // TODO: when we get client side logging, log info to server
            console.error("Missing environment config value for essEndpoint so defaulting to production endpoint.");
            Typeahead.V4URL = "//suggest.expedia.com/api/";
        } else {
            Typeahead.V4URL = env.essEndpoint;
        }

        Typeahead.URLPARAMS = undefined; //Stores the URL params for v4 call

        // only check hierarchy for sub-lob 'flight' and 'hotel'
        if ( _.contains(["flight", "hotel", "rail"], currentLob)) {
            Typeahead.enableSuggestionHierarchy(opts);
        }

        if (abTest.get(6696).value == "1") {
            Typeahead.SUGGESTURL = "//suggest.integration.bgb.karmalab.net:52408/hint/es/";
        }

        //Global rollout of optimized categories for Cars except for BEX ASIA POS
        if (env.siteId && _.contains([14, 15, 16, 17, 18, 27, 28, 61, 62, 68, 71, 75], env.siteId) && (_.contains(['car'], getCurrentLob()) || carHelpers.isHotelAttachedWithCar(dataModels.model))) {
            //BEX Asia POS
            //Default show airport
            //opts.mask = 1;
            opts.mask = Typeahead.AIRPORT;
        }
        else if (env.siteId && !_.contains([14, 15, 16, 17, 18, 27, 28, 61, 62, 68, 71, 75], env.siteId) && (_.contains(['car'], getCurrentLob()) || carHelpers.isHotelAttachedWithCar(dataModels.model))) {
            //Non-BEX Asia POS
            //This substitutes POIs with train stations and metro stations
            if (_.contains(['car', 'hotelAttachedWithCar'], currentLob) || carHelpers.isHotelAttachedWithCar(dataModels.model)) {
                //opts.mask = 1583;
                opts.mask = (Typeahead.AIRPORT | Typeahead.CITY | Typeahead.MULTICITY | Typeahead.NEIGHBORHOOD | Typeahead.TRAINSTATION | Typeahead.METROSTATION | Typeahead.RENTAL);
            }
            else {
                //opts.mask = 1551;
                opts.mask = (Typeahead.AIRPORT | Typeahead.CITY | Typeahead.MULTICITY | Typeahead.NEIGHBORHOOD | Typeahead.TRAINSTATION | Typeahead.METROSTATION);
            }
        }

        var url;
        var isESSTypeaheadEnabled = true;

        if (getCurrentLob() === 'hotel') {
            opts.version = 'v4';
             var featuresType = 'ta_hierarchy';

            var regionTypeNum = 1759;
            if (featuresType && featuresType !== '') {
                featuresType = featuresType + '|contextual_ta';
            }
            else {
                featuresType = 'contextual_ta';
            }

            if (searchExperiments.getSearchExperimentVariant('8664') !== "0") {
                regionTypeNum = regionTypeNum + 256;
            }

            Typeahead.URLPARAMS = {
                regiontype: regionTypeNum,
                locale: opts.locale,
                lob: opts.lob,
                format: 'jsonp',
                ab: opts.abtest,
                features: featuresType,
                maxresults: opts.maxresults,
                client: opts.client
            };
        }

        if (_.contains(['car', 'hotelAttachedWithCar'], currentLob) || carHelpers.isHotelAttachedWithCar(dataModels.model)) {
            opts.version = 'v4';

            Typeahead.URLPARAMS = {
                regiontype: opts.mask,
                locale: opts.locale,
                lob: opts.lob,
                format: 'jsonp',
                ab: opts.abtest,
                maxresults: opts.maxresults,
                client: opts.client,
                sortcriteria: 'popularity',
                features: 'carsclickpopularity'
            };
        }

        if (searchExperiments.getVariant("CONSUME_ESS_V4_FOR_ACTIVITIES") !== 0) {
            opts.version = "v4";
            Typeahead.URLPARAMS = {
                regiontype: opts.mask,
                dest: true,
                locale: opts.locale,
                lob: opts.lob,
                format: 'jsonp',
                ab: opts.abtest,
                maxresults: opts.maxresults,
                client: opts.client
            };
        }

        if (searchExperiments.getVariant("CONSUME_ESS_V4_FOR_PACKAGES") !== 0) {
            opts.version = "v4";
            Typeahead.URLPARAMS = {
                regiontype: opts.mask,
                dest: opts.dest,
                locale: opts.locale,
                lob: opts.lob,
                format: 'jsonp',
                ab: opts.abtest,
                maxresults: opts.maxresults,
                client: opts.client
            };
            if (Typeahead.isHierarchyEnabled(opts)) {
                Typeahead.URLPARAMS.features = "ta_hierarchy";
            }
        }
        if (opts.version == 'v4') {
            url = [Typeahead.V4URL, opts.version, '/typeahead/', encodeURIComponent(text), '?callback=?'].join('');
        }
        else {
            url = [
                Typeahead.SUGGESTURL,
                opts.version,
                '/ac/',
                env.locale,
                '/',
                encodeURIComponent(text),
                '?callback=?'
            ].join('');
        }

        // Experiment 10406 : Support different types of typeahead within OpenSearch
        if (getCurrentLob() === 'openSearch' && abTest.get(10406).value) {
            if (abTest.get(10406).value == "3") {
                opts.mask = (Typeahead.HOTEL | Typeahead.CITY | Typeahead.MULTICITY | Typeahead.NEIGHBORHOOD | Typeahead.POI);
                opts.version = 'v4';
                Typeahead.URLPARAMS = {
                    regiontype: opts.mask,
                    locale: opts.locale,
                    lob: opts.lob,
                    format: 'jsonp',
                    ab: opts.abtest,
                    features: featuresType,
                    maxresults: opts.maxresults,
                    rid: opts.regionid,
                    client: opts.client
                };
                url = [Typeahead.V4URL, opts.version, '/opensearch/', encodeURIComponent(text), '?callback=?'].join('');
            }
            else if(abTest.get(10406).value == "2") {
                isESSTypeaheadEnabled = false;
            }
        }

        var cb;

        if (!callback) {
            cb = $.noop;
        }
        else {
            cb = $.proxy(callback, instance);
        }

        //If the zero char typeahead trigger is on and there is no text
        if (isTrendingSearchesNearYouExperiment() || isCurrentLocationExperiment() &&  $.trim(text) == '') {
            setTimeout(cb, 1);
        }
        else {
            //If there is atleast one char in text
            if (Typeahead.URLPARAMS != undefined) {

                //rental location and carsclickpopularity in Cars LOB
                if (_.contains(['car', 'hotelAttachedWithCar'], currentLob) || carHelpers.isHotelAttachedWithCar(dataModels.model)) {
                    if (Typeahead.URLPARAMS.features && Typeahead.URLPARAMS.features !== '') {
                        Typeahead.URLPARAMS.features = Typeahead.URLPARAMS.features + '|cars_rental';
                    }
                    else {
                        Typeahead.URLPARAMS.features = 'cars_rental';
                    }
                }

                //show hotels in Cars LOB
                if(searchExperiments.getVariant("CWTA_HotelNameInCars") !== 0) {
                    Typeahead.URLPARAMS.regiontype = Typeahead.URLPARAMS.regiontype | Typeahead.HOTEL;
                }

                //post code in Hotel LOB
                if (getCurrentLob() === 'hotel') {
                    if (Typeahead.URLPARAMS.features && Typeahead.URLPARAMS.features !== '') {
                        Typeahead.URLPARAMS.features = Typeahead.URLPARAMS.features + '|postal_code';
                    }
                    else {
                        Typeahead.URLPARAMS.features = 'postal_code';
                    }
                    //Add bitmask for Typeahead.ADDRESS to hotel only
                    Typeahead.URLPARAMS.regiontype = Typeahead.URLPARAMS.regiontype + 32;
                }

                //Follow up of 9971 modifying the destination text in ess v4 for hotel LOB only
                var exp10967Variant = searchExperiments.getSearchExperimentVariant('10967');
                if (exp10967Variant !== "0") {
                    var feature10967Str = '';
                    if(exp10967Variant === "1" || exp10967Variant === "4") {
                        //boldSearchDest
                        feature10967Str = 'boldSearchDest';
                    }
                    else if(exp10967Variant === "2" || exp10967Variant === "3") {
                        //fontsize and boldSearchDest
                        feature10967Str = 'fontsize|boldSearchDest';
                    }

                    if (Typeahead.URLPARAMS.features && Typeahead.URLPARAMS.features !== '') {
                        Typeahead.URLPARAMS.features = Typeahead.URLPARAMS.features + '|'+feature10967Str;
                    }
                    else {
                        Typeahead.URLPARAMS.features = feature10967Str;
                    }
                }

                if (essAbacusParameter) {
                    Typeahead.URLPARAMS.ab = essAbacusParameter;
                }

                Typeahead.URLPARAMS.client = requestGenerator.getClientId();
                Typeahead.URLPARAMS.siteid = requestGenerator.siteId;
                Typeahead.URLPARAMS.guid = requestGenerator.guid;

                if(requestDevice && requestBrowser) {
                    _.extend(Typeahead.URLPARAMS, {device : requestDevice, browser : requestBrowser});
                }

                if (isESSTypeaheadEnabled) {
                    $.getJSON(
                        url,
                        Typeahead.URLPARAMS,
                        cb
                    );
                }
                else{
                    callGemma(cb , text);
                }
                if (instance) {
                    instance.metricsLogger.timestamp(instance.metricsLogger.TimestampCategories.ESS_REQUEST, text);
                }
            }
            else {
                var param = {
                    type: opts.mask,
                    ab: essAbacusParameter,
                    lob: opts.lob,
                    format: 'json',
                    dest: opts.dest,
                    maxresults: opts.maxresults,
                    rid: opts.regionid,
                    client: requestGenerator.getClientId(),
                    siteid: requestGenerator.siteId,
                    guid: requestGenerator.guid
                };

                if (_.contains(['car', 'hotelAttachedWithCar'], currentLob) || carHelpers.isHotelAttachedWithCar(dataModels.model)) {
                    param.features = 'cars_rental';
                }

                if(requestDevice && requestBrowser) {
                    _.extend(param, {device : requestDevice, browser : requestBrowser});
                }

                if (isESSTypeaheadEnabled) {
                    $.getJSON(
                        url,
                        param,
                        cb
                    );
                }
                else {
                    callGemma(cb , text);
                }
                if (instance) {
                    instance.metricsLogger.timestamp(instance.metricsLogger.TimestampCategories.ESS_REQUEST, text);
                }
            }
        }
    };

    function initTA($el, config) {
        var elementId = $el.attr("id");
        var typeahead = Typeahead.instanceByElementId[elementId];
        if (! typeahead) {
            typeahead = new Typeahead($el, config);
            Typeahead.instanceByElementId[elementId] = typeahead;
        }
        typeahead.bindJQueryObject($el);
        return Typeahead.instanceByElementId;
    }

    function bindDropDownListToTA(el, $element) {
        el.$ta = $element.closest('.' + arrowClass).siblings('.' + dropdownClass);
    }

    Typeahead.instanceByElementId = {};

    // this is literally the only Typeahead property accessed outside the scope of this file
    Typeahead.init = function (taConfig, uitk) {
        _uitk = uitk;
        var config = new configObj(taConfig);

        if (abTest.get(11582).value == "1") {
            Typeahead.recentHistoryOptionsInjector = new RecentHistoryOptionsInjector();
        }

        function appendTypeaheadContentToBodyElement() {
            // Accessibility
            // Insert DIV into DOM to receive the dynamic content.
            var acceptingID = 'uitk_ta_content',
                acceptingDiv = '<div id="' + acceptingID + '" role="presentation"></div>',
                alreadyExists = $('#' + acceptingID).length;

            //Append to body if typeahead tooltip does not exists
            if (alreadyExists === 0) {
                $('body').append(acceptingDiv);
            }
        }
        //appendTypeaheadContentToBodyElement();
        Typeahead.request('zzzzz', null, config.getAll('def').typeahead, function () {});
        $('body').on('focus.typeahead', '[data-provide="typeahead"]', function (e) {
            try {
                e.preventDefault();
                Typeahead.instanceByElementId = initTA($(this), config, Typeahead.instanceByElementId);
            } catch (e) {
                if (_.isObject(console) && _.isFunction(console.log)) {
                    console.warn("Failed to (re-)initialize typeahead", e);
                }
            }
        });

        /** EVENT LISTENERS: WINDOW */
        $window.on('resize', function(){
            var $target = $(control + '.'+ openClass);
            if (!nonResponsivePage && $target.length > 0) {
                Typeahead.prototype.handleResize($target);
            }
        });
    };

    // Types of cities yet to be integrated to GAIA. See the following Mingle card for detials:
    // /https://eiwork.mingle.thoughtworks.com/projects/ewe_discovery_services/cards/1518
    // revmoed "BCOMCITY", "TRIPADVISORCITY" since these are promoted by GAIA. Keeping this variable for other non-GAIA cities in the future.
    Typeahead.unintegratedCityTypes = [];

    Typeahead.encodeHtmlCharacterReferences = function(source) {
        if (typeof source !== "string") {
            return source;
        }
        var escapeMap = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;',
            '/': '&#x2F;',
            '`': '&#x60;',
            '=': '&#x3D;'
        };
        return String(source).replace(/[&<>"'`=\/]/g, function fromEscapeMap (s) {
            return escapeMap[s];
        });
    };

    // Converts a string that may contain HTML character entities into the corresponding string containing the
    // characters that are referred. For example, "C&#244;te d&#39;Ivoire" is converted to "Côte d'Ivoire".
    Typeahead.decodeHtmlCharacterEntities = function(encoded) {
        var textArea;
        if (typeof encoded !== "string") {
            return encoded;
        }
        textArea = document.createElement('textarea');
        textArea.innerHTML = encoded;
        return textArea.value;
    };

    /**
     * This function calls Gemma service to get response for prefix
     *
     * @param {Function} callback
     * @param {String} text
     */
    function callGemma(callback , text){
        $.ajax({
            url: Typeahead.GEMMAURL,
            dataType: 'xml',
            data: {clientid : Typeahead.GEMMACLIENTID ,
                count: Typeahead.GEMMACOUNT,
                prefix: text},
            success: function ajaxSuccess(response) {
                var json = formatGemmaResultsToJSON(response , text);
                callback(json);
            }
          });
    }
    /**
     * This function formats Gemma service results for easier parsing
     *
     * @param {Object} gemmaResponse
     * @param {String} prefix
     * @returns {Object} formatted gemma response
     */
    function formatGemmaResultsToJSON(gemmaResponse , prefix) {
        var suggestions = $(gemmaResponse).find('Suggestion')
            .map(function() {
                return this.innerHTML;
            })
            .get();

        var parseSuggestions = [];
        var index = 1;
        suggestions.forEach(function (suggestion)
        {
          var result = {
                "gemma" : "valid",
                "lob" : "GEMMA",
                "index" : index,
                "regionNames" : {
                    "fullName" : suggestion
                }
            };
          index++;
          parseSuggestions.push(result);
        });
        var jsonResponse = { "q" : prefix , "r" : parseSuggestions};
        return jsonResponse;
    }

    $(document).on('click.uitk_autocomplete focusin.uitk_autocomplete', function(e) {
        if (e.type === 'focusin' && !uitk.utils.isFocusableElement($(e.target))) {
            return;
        }

        var $target = $(e.target).closest('[data-control="autocomplete"]');

        if ($target.length <= 0) {
            $target = $(e.target);
        }

        // if clicked item isn't related to autocomplete, close the complete
        if (($target.length === 1 && !$target.hasClass(openClass)) || $target.data('control') !== 'autocomplete' && !$target.hasClass(openClass) && $target.closest('.' + openClass).length === 0) {
            Typeahead.prototype.closeAllTA();
        }
    });

    return Typeahead;

});
